import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';
import * as React from 'react';
import React__default, { createContext, createRef, useContext, useRef, useEffect, useState, useLayoutEffect, useCallback, useMemo, forwardRef } from 'react';
import './assets/src/modules/MediaPlayer/styles.css.ts.vanilla-000acf4d.css';
import clsx from 'clsx';
import { unstable_batchedUpdates, createPortal } from 'react-dom';
import { Button } from '@aicon-dev/caas-ui';
import './assets/src/modules/MediaPlayer/components/Controls/modules/Date/DatePicker/Calendar/styles.css.ts.vanilla-fb80115b.css';
import './assets/src/modules/MediaPlayer/components/Controls/modules/Date/DatePicker/MobileTimePicker/styles.css.ts.vanilla-1cc9f8aa.css';
import './assets/src/modules/MediaPlayer/components/Controls/modules/Date/DatePicker/styles.css.ts.vanilla-1e21568f.css';
import './assets/src/modules/MediaPlayer/components/Controls/modules/Date/DatePicker/TimePicker/styles.css.ts.vanilla-6151f329.css';
import './assets/src/modules/MediaPlayer/components/Controls/modules/Settings/styles.css.ts.vanilla-311ec128.css';
import './assets/src/modules/MediaPlayer/components/Controls/styles.css.ts.vanilla-49380976.css';
import './assets/src/modules/MediaPlayer/components/Controls/modules/Zoom/styles.css.ts.vanilla-42b0b630.css';
import './assets/src/modules/MediaPlayer/components/Timeline/styles.css.ts.vanilla-669c7cca.css';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return {
          value: void 0,
          done: !0
        };
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable || "" === iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$3(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$3(obj, key, value) {
  key = _toPropertyKey$3(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive$3(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey$3(arg) {
  var key = _toPrimitive$3(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var _assign$1 = function __assign() {
  _assign$1 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign$1.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var MediaPlayerConfigContext = createContext({
  locale: 'en-US'
});
/**
 * 미디어 플레이어에 대한 기본 설정값을 추가하여 전역에 위치시키거나 플레이어를 감싸주세요.
 * @param props
 * @returns
 */
var MediaPlayerProvider = function MediaPlayerProvider(props) {
  var children = props.children,
    context = __rest(props, ["children"]);
  return jsx(MediaPlayerConfigContext.Provider, {
    value: context,
    children: children
  });
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === "object" && argStr === "[object Date]")
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (
    typeof argument === "number" ||
    argStr === "[object Number]" ||
    typeof argument === "string" ||
    argStr === "[object String]"
  ) {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}

/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */
function addMonths(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  const dayOfMonth = _date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  const endOfDesiredMonth = constructFrom(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}

/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add$1(date, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = duration;

  // Add years and months
  const _date = toDate(date);
  const dateWithMonths =
    months || years ? addMonths(_date, months + years * 12) : _date;

  // Add weeks and days
  const dateWithDays =
    days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths;

  // Add days, hours, minutes and seconds
  const minutesToAdd = minutes + hours * 60;
  const secondsToAdd = seconds + minutesToAdd * 60;
  const msToAdd = secondsToAdd * 1000;
  const finalDate = constructFrom(date, dateWithDays.getTime() + msToAdd);

  return finalDate;
}

/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday(date) {
  return toDate(date).getDay() === 0;
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(date, amount) {
  const timestamp = +toDate(date);
  return constructFrom(date, timestamp + amount);
}

/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */

/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = 604800000;

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = 86400000;

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
const millisecondsInMinute = 60000;

let defaultOptions = {};

function getDefaultOptions() {
  return defaultOptions;
}

/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = getDefaultOptions();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);

  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);

  const timestampLeft =
    +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight =
    +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(date, amount) {
  return addMilliseconds(date, amount * millisecondsInMinute);
}

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds(date, amount) {
  return addMilliseconds(date, amount * 1000);
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(date, amount) {
  const days = amount * 7;
  return addDays(date, days);
}

/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo(dateToCompare, dates) {
  const date = toDate(dateToCompare);

  if (isNaN(Number(date))) return NaN;

  const timeToCompare = date.getTime();

  let result;
  let minDistance;
  dates.forEach(function (dirtyDate, index) {
    const currentDate = toDate(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = NaN;
      minDistance = NaN;
      return;
    }

    const distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < minDistance) {
      result = index;
      minDistance = distance;
    }
  });

  return result;
}

/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo(dateToCompare, dates) {
  const date = toDate(dateToCompare);

  if (isNaN(Number(date))) return constructFrom(dateToCompare, NaN);

  const timeToCompare = date.getTime();

  let result;
  let minDistance;
  dates.forEach((dirtyDate) => {
    const currentDate = toDate(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = constructFrom(dateToCompare, NaN);
      minDistance = NaN;
      return;
    }

    const distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < minDistance) {
      result = currentDate;
      minDistance = distance;
    }
  });

  return result;
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dateLeft, dateRight) {
  const dateLeftStartOfDay = startOfDay(dateLeft);
  const dateRightStartOfDay = startOfDay(dateRight);

  return +dateLeftStartOfDay === +dateRightStartOfDay;
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate$1(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid$1(date) {
  if (!isDate$1(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}

function getRoundingMethod(method) {
  return (number) => {
    const round = method ? Math[method] : Math.trunc;
    const result = round(number);
    // Prevent negative zero
    return result === 0 ? 0 : result;
  };
}

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  return +toDate(dateLeft) - +toDate(dateRight);
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(date) {
  const _date = toDate(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

/**
 * The {@link differenceInSeconds} function options.
 */

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds(dateLeft, dateRight, options) {
  const diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

/**
 * The {@link eachDayOfInterval} function options.
 */

/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDayOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return reversed ? dates.reverse() : dates;
}

/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute(date) {
  const _date = toDate(date);
  _date.setSeconds(0, 0);
  return _date;
}

/**
 * The {@link eachWeekOfInterval} function options.
 */

/**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */
function eachWeekOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);

  let reversed = +startDate > +endDate;
  const startDateWeek = reversed
    ? startOfWeek(endDate, options)
    : startOfWeek(startDate, options);
  const endDateWeek = reversed
    ? startOfWeek(startDate, options)
    : startOfWeek(endDate, options);

  // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
  startDateWeek.setHours(15);
  endDateWeek.setHours(15);

  const endTime = +endDateWeek.getTime();
  let currentDate = startDateWeek;

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    currentDate.setHours(0);
    dates.push(toDate(currentDate));
    currentDate = addWeeks(currentDate, step);
    currentDate.setHours(15);
  }

  return reversed ? dates.reverse() : dates;
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(date) {
  const _date = toDate(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * The {@link endOfWeek} function options.
 */

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(date, options) {
  const defaultOptions = getDefaultOptions();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];

/* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

const localize = {
  ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex$2(parsePatterns, (pattern) => pattern.test(matchedString))
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        findKey$1(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey$1(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex$2(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = toDate(date);
  const year = _date.getFullYear();

  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);

  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(date, options) {
  const _date = toDate(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },

  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  },
};

const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = getWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = getISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = getWeek(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return addLeadingZeros(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = getISOWeek(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return addLeadingZeros(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = getDayOfYear(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  },
};

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
};

const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format$1(date, formatStr, options) {
  const defaultOptions = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions.locale ?? enUS;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = toDate(date);

  if (!isValid$1(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString(substring) };
      }

      if (formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (!options?.useAdditionalWeekYearTokens &&
          isProtectedWeekYearToken(token)) ||
        (!options?.useAdditionalDayOfYearTokens &&
          isProtectedDayOfYearToken(token))
      ) {
        warnOrThrowProtectedError(token, formatStr, String(date));
      }

      const formatter = formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */

/**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */

/**
 * The locale options.
 */

/**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */

/**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */

/**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */

/**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */

function intlFormat(date, formatOrLocale, localeOptions) {
  let formatOptions;

  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }

  return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format(
    toDate(date),
  );
}

function isFormatOptions(opts) {
  return opts !== undefined && !("locale" in opts);
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return +_date < +_dateToCompare;
}

/**
 * The {@link setDay} function options.
 */

/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay(date, day, options) {
  const defaultOptions = getDefaultOptions();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date);
  const currentDay = _date.getDay();

  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;

  const delta = 7 - weekStartsOn;
  const diff =
    day < 0 || day > 6
      ? day - ((currentDay + delta) % 7)
      : ((dayIndex + delta) % 7) - ((currentDay + delta) % 7);
  return addDays(_date, diff);
}

/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */
function isSameMinute(dateLeft, dateRight) {
  const dateLeftStartOfMinute = startOfMinute(dateLeft);
  const dateRightStartOfMinute = startOfMinute(dateRight);

  return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return (
    _dateLeft.getFullYear() === _dateRight.getFullYear() &&
    _dateLeft.getMonth() === _dateRight.getMonth()
  );
}

/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday(date) {
  return isSameDay(date, Date.now());
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(date, amount) {
  return addDays(date, -amount);
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(date, amount) {
  return addMonths(date, -amount);
}

/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */
function sub(date, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = duration;

  // Subtract years and months
  const dateWithoutMonths = subMonths(date, months + years * 12);

  // Subtract weeks and days
  const dateWithoutDays = subDays(dateWithoutMonths, days + weeks * 7);

  // Subtract hours, minutes and seconds
  const minutestoSub = minutes + hours * 60;
  const secondstoSub = seconds + minutestoSub * 60;
  const mstoSub = secondstoSub * 1000;
  const finalDate = constructFrom(date, dateWithoutDays.getTime() - mstoSub);

  return finalDate;
}

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes(date, amount) {
  return addMinutes(date, -amount);
}

var createFetch = function createFetch(context, url, init) {
  return fetch("".concat(context.baseUrl, "/").concat(url), _assign$1(_assign$1({}, init), {
    headers: _assign$1({
      Authorization: "apikey ".concat(context.apiKey)
    }, init.headers)
  }));
};

var getPlayerResolution = function getPlayerResolution(context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var res, _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, createFetch(context, "player/resolution", {
            method: 'GET'
          })];
        case 1:
          res = _b.sent();
          if (!!res.ok) return [3 /*break*/, 3];
          _a = Error.bind;
          return [4 /*yield*/, res.json()];
        case 2:
          throw new (_a.apply(Error, [void 0, _b.sent()]))();
        case 3:
          return [4 /*yield*/, res.json()];
        case 4:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};

/**
 * Media Player Logger
 *
 * Debug mode can be enabled in three ways:
 * 1. Development environment (NODE_ENV === 'development')
 * 2. Build-time flag (MEDIA_PLAYER_DEBUG === 'true')
 * 3. Runtime flag (window.__MEDIA_PLAYER_DEBUG__ = true)
 */
var isDev$2 = process.env.NODE_ENV === 'development';
/**
 * Check if debug mode is enabled
 */
var isDebugEnabled = function isDebugEnabled() {
  return isDev$2 || process.env.MEDIA_PLAYER_DEBUG === 'true' || typeof window !== 'undefined' && window.__MEDIA_PLAYER_DEBUG__ === true;
};
/**
 * Media Player Logger
 *
 * Provides centralized logging with debug mode support.
 * All methods except `error` are only active when debug mode is enabled.
 * Error logs are always output to preserve critical error information.
 */
var logger$1 = {
  /**
   * Log general debug information (only in debug mode)
   */
  log: function log() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (isDebugEnabled()) {
      console.log.apply(console, __spreadArray(['[MediaPlayer]'], args, false));
    }
  },
  /**
   * Log detailed debug information (only in debug mode)
   */
  debug: function debug() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (isDebugEnabled()) {
      console.debug.apply(console, __spreadArray(['[MediaPlayer]'], args, false));
    }
  },
  /**
   * Log informational messages (only in debug mode)
   */
  info: function info() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (isDebugEnabled()) {
      console.info.apply(console, __spreadArray(['[MediaPlayer]'], args, false));
    }
  },
  /**
   * Log warning messages (only in debug mode)
   */
  warn: function warn() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (isDebugEnabled()) {
      console.warn.apply(console, __spreadArray(['[MediaPlayer]'], args, false));
    }
  },
  /**
   * Log error messages (always active)
   *
   * Error logs are always output, even in production.
   * If an Error object is present in arguments, it's moved to the end
   * to preserve stack trace information.
   */
  error: function error() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var errorIndex = args.findIndex(function (arg) {
      return arg instanceof Error;
    });
    if (errorIndex !== -1) {
      // Move Error object to the end to preserve stack trace
      var error = args[errorIndex];
      var otherArgs = args.filter(function (_, i) {
        return i !== errorIndex;
      });
      console.error.apply(console, __spreadArray(__spreadArray(['[MediaPlayer]'], otherArgs, false), [error], false));
    } else {
      console.error.apply(console, __spreadArray(['[MediaPlayer]'], args, false));
    }
  }
};
/**
 * Enable debug mode at runtime
 *
 * Usage:
 * ```typescript
 * import { enableDebugMode } from '@aicon-dev/caas-media-player';
 * enableDebugMode();
 * ```
 *
 * Or in browser console:
 * ```javascript
 * window.__MEDIA_PLAYER_DEBUG__ = true;
 * location.reload();
 * ```
 */
var enableDebugMode = function enableDebugMode() {
  if (typeof window !== 'undefined') {
    window.__MEDIA_PLAYER_DEBUG__ = true;
  }
};
/**
 * Disable debug mode at runtime
 */
var disableDebugMode = function disableDebugMode() {
  if (typeof window !== 'undefined') {
    window.__MEDIA_PLAYER_DEBUG__ = false;
  }
};

var playMediaSafely = function playMediaSafely(media, reason) {
  if (!media) return;
  var playPromise = media.play();
  if (!playPromise || typeof playPromise.catch !== 'function') {
    return;
  }
  playPromise.catch(function (error) {
    var errorName = error instanceof Error ? error.name : '';
    var errorMessage = error instanceof Error ? error.message : String(error);
    var isExpectedInterruption = errorName === 'AbortError' || errorName === 'NotAllowedError' || errorMessage.includes('interrupted by a call to pause');
    if (isExpectedInterruption) {
      logger$1.debug("".concat(reason, ": play interrupted"), error);
      return;
    }
    logger$1.error("".concat(reason, ": play failed"), error);
  });
};

var DEFAULT_LIVE_SYNC_OFFSET = 60;
var MEDIA_MOBILE_MAX_WIDTH = 768;

/**
 * 현재시간
 */
var now$2 = sub(new Date(), {
  seconds: DEFAULT_LIVE_SYNC_OFFSET
});
/**
 * MediaPlayer 내부에서 사용하는 Internal Context입니다.
 */
var MediaPlayerContext = createContext({
  baseUrl: '',
  apiKey: '',
  locale: 'en-US',
  resolutions: [],
  currentResolution: 1080,
  setCurrentResolution: function setCurrentResolution() {},
  userSetResolution: false,
  setUserSetResolution: function setUserSetResolution() {},
  containerRef: createRef(),
  videoRef: createRef(),
  timelineScrollRef: createRef(),
  isPlaying: false,
  isLoading: false,
  isFullscreen: false,
  setIsFullscreen: function setIsFullscreen() {},
  isPausedByPlayer: false,
  setIsPausedByPlayer: function setIsPausedByPlayer() {},
  timelineData: [],
  fetchTimeline: function fetchTimeline() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/];
      });
    });
  },

  now: now$2.getTime(),
  initTs: now$2.getTime(),
  setInitTs: function setInitTs() {},
  currentTs: now$2.getTime(),
  setCurrentTs: function setCurrentTs() {},
  startTs: sub(now$2, {
    hours: 0.5
  }).getTime(),
  setStartTs: function setStartTs() {},
  endTs: add$1(now$2, {
    hours: 0.5
  }).getTime(),
  progressBarWidth: 0,
  setProgressBarWidth: function setProgressBarWidth() {},
  forceInitHls: function forceInitHls() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/];
      });
    });
  },

  showZoomControl: true,
  playbackRate: 1,
  setPlaybackRate: function setPlaybackRate() {},
  zoomLevel: 0,
  setZoomLevel: function setZoomLevel() {},
  overlayForceDisplay: false,
  setOverlayForceDisplay: function setOverlayForceDisplay() {},
  controlMouseOvered: false,
  setControlMouseOvered: function setControlMouseOvered() {}
});
var useMediaPlayerContext = function useMediaPlayerContext() {
  return useContext(MediaPlayerContext);
};

/**
 * HLS가 자체적으로 실행하는 재요청이 3번 이상
 * 실패할 경우 재생시점을 현재시간으로 초기화하여 최신화합니다.
 */
var useAutoRetry = function useAutoRetry(props) {
  var videoRef = props.videoRef,
    onRetry = props.onRetry;
  var retryInterval = useRef();
  var retryCount = useRef(0);
  var onRetryRef = useRef(onRetry);
  useEffect(function () {
    onRetryRef.current = onRetry;
  }, [onRetry]);
  useEffect(function () {
    return function () {
      clearRetry();
    };
  }, []);
  var clearRetry = function clearRetry() {
    logger$1.debug('자동 재시도를 중단합니다.');
    clearInterval(retryInterval.current);
    retryInterval.current = undefined;
    retryCount.current = 0;
  };
  var onLoading = function onLoading() {
    if (retryInterval.current) {
      return;
    }
    logger$1.info('비디오가 로딩 상태입니다. 10초 후 라이브일 경우 자동 재시도를 실행합니다.');
    retryInterval.current = setInterval(function () {
      var _a, _b, _c, _d;
      logger$1.debug('재시도 횟수:', retryCount.current);
      if (retryCount.current >= 5) {
        logger$1.warn('재시도 횟수가 5회를 초과하여 인터벌을 제거합니다.');
        (_a = onRetryRef.current) === null || _a === void 0 ? void 0 : _a.call(onRetryRef, {
          attempt: retryCount.current,
          exhausted: true
        });
        clearRetry();
        return;
      }
      if (((_c = (_b = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _b === void 0 ? void 0 : _b.readyState) !== null && _c !== void 0 ? _c : 0) >= 3) {
        logger$1.debug('비디오가 로드되어 인터벌을 제거합니다.');
        clearRetry();
        return;
      }
      retryCount.current += 1;
      (_d = onRetryRef.current) === null || _d === void 0 ? void 0 : _d.call(onRetryRef, {
        attempt: retryCount.current,
        exhausted: false
      });
    }, 10000);
  };
  return {
    onLoading: onLoading,
    clearRetry: clearRetry
  };
};

var useFormat = function useFormat() {
  var locale = useMediaPlayerContext().locale;
  var _intlFormat = function _intlFormat(date, formatOptions) {
    return intlFormat(date, formatOptions, {
      locale: locale
    });
  };
  return {
    intlFormat: _intlFormat
  };
};

var _CmcdHeaderMap;function getDefaultExportFromCjs(x){return x&&x.__esModule&&Object.prototype.hasOwnProperty.call(x,'default')?x['default']:x;}var urlToolkit={exports:{}};(function(module,exports){// see https://tools.ietf.org/html/rfc1808
(function(root){var URL_REGEX=/^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;var FIRST_SEGMENT_REGEX=/^(?=([^\/?#]*))\1([^]*)$/;var SLASH_DOT_REGEX=/(?:\/|^)\.(?=\/)/g;var SLASH_DOT_DOT_REGEX=/(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;var URLToolkit={// If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
// E.g
// With opts.alwaysNormalize = false (default, spec compliant)
// http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
// With opts.alwaysNormalize = true (not spec compliant)
// http://a.com/b/cd + /e/f/../g => http://a.com/e/g
buildAbsoluteURL:function buildAbsoluteURL(baseURL,relativeURL,opts){opts=opts||{};// remove any remaining space and CRLF
baseURL=baseURL.trim();relativeURL=relativeURL.trim();if(!relativeURL){// 2a) If the embedded URL is entirely empty, it inherits the
// entire base URL (i.e., is set equal to the base URL)
// and we are done.
if(!opts.alwaysNormalize){return baseURL;}var basePartsForNormalise=URLToolkit.parseURL(baseURL);if(!basePartsForNormalise){throw new Error('Error trying to parse base URL.');}basePartsForNormalise.path=URLToolkit.normalizePath(basePartsForNormalise.path);return URLToolkit.buildURLFromParts(basePartsForNormalise);}var relativeParts=URLToolkit.parseURL(relativeURL);if(!relativeParts){throw new Error('Error trying to parse relative URL.');}if(relativeParts.scheme){// 2b) If the embedded URL starts with a scheme name, it is
// interpreted as an absolute URL and we are done.
if(!opts.alwaysNormalize){return relativeURL;}relativeParts.path=URLToolkit.normalizePath(relativeParts.path);return URLToolkit.buildURLFromParts(relativeParts);}var baseParts=URLToolkit.parseURL(baseURL);if(!baseParts){throw new Error('Error trying to parse base URL.');}if(!baseParts.netLoc&&baseParts.path&&baseParts.path[0]!=='/'){// If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
// This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
var pathParts=FIRST_SEGMENT_REGEX.exec(baseParts.path);baseParts.netLoc=pathParts[1];baseParts.path=pathParts[2];}if(baseParts.netLoc&&!baseParts.path){baseParts.path='/';}var builtParts={// 2c) Otherwise, the embedded URL inherits the scheme of
// the base URL.
scheme:baseParts.scheme,netLoc:relativeParts.netLoc,path:null,params:relativeParts.params,query:relativeParts.query,fragment:relativeParts.fragment};if(!relativeParts.netLoc){// 3) If the embedded URL's <net_loc> is non-empty, we skip to
// Step 7.  Otherwise, the embedded URL inherits the <net_loc>
// (if any) of the base URL.
builtParts.netLoc=baseParts.netLoc;// 4) If the embedded URL path is preceded by a slash "/", the
// path is not relative and we skip to Step 7.
if(relativeParts.path[0]!=='/'){if(!relativeParts.path){// 5) If the embedded URL path is empty (and not preceded by a
// slash), then the embedded URL inherits the base URL path
builtParts.path=baseParts.path;// 5a) if the embedded URL's <params> is non-empty, we skip to
// step 7; otherwise, it inherits the <params> of the base
// URL (if any) and
if(!relativeParts.params){builtParts.params=baseParts.params;// 5b) if the embedded URL's <query> is non-empty, we skip to
// step 7; otherwise, it inherits the <query> of the base
// URL (if any) and we skip to step 7.
if(!relativeParts.query){builtParts.query=baseParts.query;}}}else {// 6) The last segment of the base URL's path (anything
// following the rightmost slash "/", or the entire path if no
// slash is present) is removed and the embedded URL's path is
// appended in its place.
var baseURLPath=baseParts.path;var newPath=baseURLPath.substring(0,baseURLPath.lastIndexOf('/')+1)+relativeParts.path;builtParts.path=URLToolkit.normalizePath(newPath);}}}if(builtParts.path===null){builtParts.path=opts.alwaysNormalize?URLToolkit.normalizePath(relativeParts.path):relativeParts.path;}return URLToolkit.buildURLFromParts(builtParts);},parseURL:function parseURL(url){var parts=URL_REGEX.exec(url);if(!parts){return null;}return {scheme:parts[1]||'',netLoc:parts[2]||'',path:parts[3]||'',params:parts[4]||'',query:parts[5]||'',fragment:parts[6]||''};},normalizePath:function normalizePath(path){// The following operations are
// then applied, in order, to the new path:
// 6a) All occurrences of "./", where "." is a complete path
// segment, are removed.
// 6b) If the path ends with "." as a complete path segment,
// that "." is removed.
path=path.split('').reverse().join('').replace(SLASH_DOT_REGEX,'');// 6c) All occurrences of "<segment>/../", where <segment> is a
// complete path segment not equal to "..", are removed.
// Removal of these path segments is performed iteratively,
// removing the leftmost matching pattern on each iteration,
// until no matching pattern remains.
// 6d) If the path ends with "<segment>/..", where <segment> is a
// complete path segment not equal to "..", that
// "<segment>/.." is removed.
while(path.length!==(path=path.replace(SLASH_DOT_DOT_REGEX,'')).length){}return path.split('').reverse().join('');},buildURLFromParts:function buildURLFromParts(parts){return parts.scheme+parts.netLoc+parts.path+parts.params+parts.query+parts.fragment;}};module.exports=URLToolkit;})();})(urlToolkit);var urlToolkitExports=urlToolkit.exports;function ownKeys$2(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);r&&(o=o.filter(function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable;})),t.push.apply(t,o);}return t;}function _objectSpread2$2(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?ownKeys$2(Object(t),!0).forEach(function(r){_defineProperty$2(e,r,t[r]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):ownKeys$2(Object(t)).forEach(function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r));});}return e;}function _toPrimitive$2(t,r){if("object"!=_typeof(t)||!t)return t;var e=t[Symbol.toPrimitive];if(void 0!==e){var i=e.call(t,r||"default");if("object"!=_typeof(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string"===r?String:Number)(t);}function _toPropertyKey$2(t){var i=_toPrimitive$2(t,"string");return "symbol"==_typeof(i)?i:String(i);}function _defineProperty$2(obj,key,value){key=_toPropertyKey$2(key);if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key]=value;}return obj;}function _extends(){_extends=Object.assign?Object.assign.bind():function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}// https://caniuse.com/mdn-javascript_builtins_number_isfinite
var isFiniteNumber=Number.isFinite||function(value){return typeof value==='number'&&isFinite(value);};// https://caniuse.com/mdn-javascript_builtins_number_issafeinteger
var isSafeInteger$1=Number.isSafeInteger||function(value){return typeof value==='number'&&Math.abs(value)<=MAX_SAFE_INTEGER$6;};var MAX_SAFE_INTEGER$6=Number.MAX_SAFE_INTEGER||9007199254740991;var Events=/*#__PURE__*/function(Events){Events["MEDIA_ATTACHING"]="hlsMediaAttaching";Events["MEDIA_ATTACHED"]="hlsMediaAttached";Events["MEDIA_DETACHING"]="hlsMediaDetaching";Events["MEDIA_DETACHED"]="hlsMediaDetached";Events["BUFFER_RESET"]="hlsBufferReset";Events["BUFFER_CODECS"]="hlsBufferCodecs";Events["BUFFER_CREATED"]="hlsBufferCreated";Events["BUFFER_APPENDING"]="hlsBufferAppending";Events["BUFFER_APPENDED"]="hlsBufferAppended";Events["BUFFER_EOS"]="hlsBufferEos";Events["BUFFER_FLUSHING"]="hlsBufferFlushing";Events["BUFFER_FLUSHED"]="hlsBufferFlushed";Events["MANIFEST_LOADING"]="hlsManifestLoading";Events["MANIFEST_LOADED"]="hlsManifestLoaded";Events["MANIFEST_PARSED"]="hlsManifestParsed";Events["LEVEL_SWITCHING"]="hlsLevelSwitching";Events["LEVEL_SWITCHED"]="hlsLevelSwitched";Events["LEVEL_LOADING"]="hlsLevelLoading";Events["LEVEL_LOADED"]="hlsLevelLoaded";Events["LEVEL_UPDATED"]="hlsLevelUpdated";Events["LEVEL_PTS_UPDATED"]="hlsLevelPtsUpdated";Events["LEVELS_UPDATED"]="hlsLevelsUpdated";Events["AUDIO_TRACKS_UPDATED"]="hlsAudioTracksUpdated";Events["AUDIO_TRACK_SWITCHING"]="hlsAudioTrackSwitching";Events["AUDIO_TRACK_SWITCHED"]="hlsAudioTrackSwitched";Events["AUDIO_TRACK_LOADING"]="hlsAudioTrackLoading";Events["AUDIO_TRACK_LOADED"]="hlsAudioTrackLoaded";Events["SUBTITLE_TRACKS_UPDATED"]="hlsSubtitleTracksUpdated";Events["SUBTITLE_TRACKS_CLEARED"]="hlsSubtitleTracksCleared";Events["SUBTITLE_TRACK_SWITCH"]="hlsSubtitleTrackSwitch";Events["SUBTITLE_TRACK_LOADING"]="hlsSubtitleTrackLoading";Events["SUBTITLE_TRACK_LOADED"]="hlsSubtitleTrackLoaded";Events["SUBTITLE_FRAG_PROCESSED"]="hlsSubtitleFragProcessed";Events["CUES_PARSED"]="hlsCuesParsed";Events["NON_NATIVE_TEXT_TRACKS_FOUND"]="hlsNonNativeTextTracksFound";Events["INIT_PTS_FOUND"]="hlsInitPtsFound";Events["FRAG_LOADING"]="hlsFragLoading";Events["FRAG_LOAD_EMERGENCY_ABORTED"]="hlsFragLoadEmergencyAborted";Events["FRAG_LOADED"]="hlsFragLoaded";Events["FRAG_DECRYPTED"]="hlsFragDecrypted";Events["FRAG_PARSING_INIT_SEGMENT"]="hlsFragParsingInitSegment";Events["FRAG_PARSING_USERDATA"]="hlsFragParsingUserdata";Events["FRAG_PARSING_METADATA"]="hlsFragParsingMetadata";Events["FRAG_PARSED"]="hlsFragParsed";Events["FRAG_BUFFERED"]="hlsFragBuffered";Events["FRAG_CHANGED"]="hlsFragChanged";Events["FPS_DROP"]="hlsFpsDrop";Events["FPS_DROP_LEVEL_CAPPING"]="hlsFpsDropLevelCapping";Events["MAX_AUTO_LEVEL_UPDATED"]="hlsMaxAutoLevelUpdated";Events["ERROR"]="hlsError";Events["DESTROYING"]="hlsDestroying";Events["KEY_LOADING"]="hlsKeyLoading";Events["KEY_LOADED"]="hlsKeyLoaded";Events["LIVE_BACK_BUFFER_REACHED"]="hlsLiveBackBufferReached";Events["BACK_BUFFER_REACHED"]="hlsBackBufferReached";Events["STEERING_MANIFEST_LOADED"]="hlsSteeringManifestLoaded";return Events;}({});/**
 * Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
 */var ErrorTypes=/*#__PURE__*/function(ErrorTypes){ErrorTypes["NETWORK_ERROR"]="networkError";ErrorTypes["MEDIA_ERROR"]="mediaError";ErrorTypes["KEY_SYSTEM_ERROR"]="keySystemError";ErrorTypes["MUX_ERROR"]="muxError";ErrorTypes["OTHER_ERROR"]="otherError";return ErrorTypes;}({});var ErrorDetails=/*#__PURE__*/function(ErrorDetails){ErrorDetails["KEY_SYSTEM_NO_KEYS"]="keySystemNoKeys";ErrorDetails["KEY_SYSTEM_NO_ACCESS"]="keySystemNoAccess";ErrorDetails["KEY_SYSTEM_NO_SESSION"]="keySystemNoSession";ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"]="keySystemNoConfiguredLicense";ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"]="keySystemLicenseRequestFailed";ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"]="keySystemServerCertificateRequestFailed";ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"]="keySystemServerCertificateUpdateFailed";ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"]="keySystemSessionUpdateFailed";ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"]="keySystemStatusOutputRestricted";ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"]="keySystemStatusInternalError";ErrorDetails["MANIFEST_LOAD_ERROR"]="manifestLoadError";ErrorDetails["MANIFEST_LOAD_TIMEOUT"]="manifestLoadTimeOut";ErrorDetails["MANIFEST_PARSING_ERROR"]="manifestParsingError";ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"]="manifestIncompatibleCodecsError";ErrorDetails["LEVEL_EMPTY_ERROR"]="levelEmptyError";ErrorDetails["LEVEL_LOAD_ERROR"]="levelLoadError";ErrorDetails["LEVEL_LOAD_TIMEOUT"]="levelLoadTimeOut";ErrorDetails["LEVEL_PARSING_ERROR"]="levelParsingError";ErrorDetails["LEVEL_SWITCH_ERROR"]="levelSwitchError";ErrorDetails["AUDIO_TRACK_LOAD_ERROR"]="audioTrackLoadError";ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"]="audioTrackLoadTimeOut";ErrorDetails["SUBTITLE_LOAD_ERROR"]="subtitleTrackLoadError";ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"]="subtitleTrackLoadTimeOut";ErrorDetails["FRAG_LOAD_ERROR"]="fragLoadError";ErrorDetails["FRAG_LOAD_TIMEOUT"]="fragLoadTimeOut";ErrorDetails["FRAG_DECRYPT_ERROR"]="fragDecryptError";ErrorDetails["FRAG_PARSING_ERROR"]="fragParsingError";ErrorDetails["FRAG_GAP"]="fragGap";ErrorDetails["REMUX_ALLOC_ERROR"]="remuxAllocError";ErrorDetails["KEY_LOAD_ERROR"]="keyLoadError";ErrorDetails["KEY_LOAD_TIMEOUT"]="keyLoadTimeOut";ErrorDetails["BUFFER_ADD_CODEC_ERROR"]="bufferAddCodecError";ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"]="bufferIncompatibleCodecsError";ErrorDetails["BUFFER_APPEND_ERROR"]="bufferAppendError";ErrorDetails["BUFFER_APPENDING_ERROR"]="bufferAppendingError";ErrorDetails["BUFFER_STALLED_ERROR"]="bufferStalledError";ErrorDetails["BUFFER_FULL_ERROR"]="bufferFullError";ErrorDetails["BUFFER_SEEK_OVER_HOLE"]="bufferSeekOverHole";ErrorDetails["BUFFER_NUDGE_ON_STALL"]="bufferNudgeOnStall";ErrorDetails["INTERNAL_EXCEPTION"]="internalException";ErrorDetails["INTERNAL_ABORTED"]="aborted";ErrorDetails["UNKNOWN"]="unknown";return ErrorDetails;}({});var noop$3=function noop(){};var fakeLogger={trace:noop$3,debug:noop$3,log:noop$3,warn:noop$3,info:noop$3,error:noop$3};var exportedLogger=fakeLogger;// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }
function consolePrintFn(type){var func=self.console[type];if(func){return func.bind(self.console,"[".concat(type,"] >"));}return noop$3;}function exportLoggerFunctions(debugConfig){for(var _len=arguments.length,functions=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){functions[_key-1]=arguments[_key];}functions.forEach(function(type){exportedLogger[type]=debugConfig[type]?debugConfig[type].bind(debugConfig):consolePrintFn(type);});}function enableLogs(debugConfig,id){// check that console is available
if((typeof console==="undefined"?"undefined":_typeof(console))==='object'&&debugConfig===true||_typeof(debugConfig)==='object'){exportLoggerFunctions(debugConfig,// Remove out from list here to hard-disable a log-level
// 'trace',
'debug','log','info','warn','error');// Some browsers don't allow to use bind on console object anyway
// fallback to default if needed
try{exportedLogger.log("Debug logs enabled for \"".concat(id,"\" in hls.js version ","1.5.18"));}catch(e){exportedLogger=fakeLogger;}}else {exportedLogger=fakeLogger;}}var logger=exportedLogger;var DECIMAL_RESOLUTION_REGEX=/^(\d+)x(\d+)$/;var ATTR_LIST_REGEX=/(.+?)=(".*?"|.*?)(?:,|$)/g;// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
var AttrList=/*#__PURE__*/function(){function AttrList(attrs){_classCallCheck(this,AttrList);if(typeof attrs==='string'){attrs=AttrList.parseAttrList(attrs);}_extends(this,attrs);}_createClass(AttrList,[{key:"clientAttrs",get:function get(){return Object.keys(this).filter(function(attr){return attr.substring(0,2)==='X-';});}},{key:"decimalInteger",value:function decimalInteger(attrName){var intValue=parseInt(this[attrName],10);if(intValue>Number.MAX_SAFE_INTEGER){return Infinity;}return intValue;}},{key:"hexadecimalInteger",value:function hexadecimalInteger(attrName){if(this[attrName]){var stringValue=(this[attrName]||'0x').slice(2);stringValue=(stringValue.length&1?'0':'')+stringValue;var value=new Uint8Array(stringValue.length/2);for(var i=0;i<stringValue.length/2;i++){value[i]=parseInt(stringValue.slice(i*2,i*2+2),16);}return value;}else {return null;}}},{key:"hexadecimalIntegerAsNumber",value:function hexadecimalIntegerAsNumber(attrName){var intValue=parseInt(this[attrName],16);if(intValue>Number.MAX_SAFE_INTEGER){return Infinity;}return intValue;}},{key:"decimalFloatingPoint",value:function decimalFloatingPoint(attrName){return parseFloat(this[attrName]);}},{key:"optionalFloat",value:function optionalFloat(attrName,defaultValue){var value=this[attrName];return value?parseFloat(value):defaultValue;}},{key:"enumeratedString",value:function enumeratedString(attrName){return this[attrName];}},{key:"bool",value:function bool(attrName){return this[attrName]==='YES';}},{key:"decimalResolution",value:function decimalResolution(attrName){var res=DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);if(res===null){return undefined;}return {width:parseInt(res[1],10),height:parseInt(res[2],10)};}}],[{key:"parseAttrList",value:function parseAttrList(input){var match;var attrs={};var quote='"';ATTR_LIST_REGEX.lastIndex=0;while((match=ATTR_LIST_REGEX.exec(input))!==null){var value=match[2];if(value.indexOf(quote)===0&&value.lastIndexOf(quote)===value.length-1){value=value.slice(1,-1);}var name=match[1].trim();attrs[name]=value;}return attrs;}}]);return AttrList;}();// Avoid exporting const enum so that these values can be inlined
function isDateRangeCueAttribute(attrName){return attrName!=="ID"&&attrName!=="CLASS"&&attrName!=="START-DATE"&&attrName!=="DURATION"&&attrName!=="END-DATE"&&attrName!=="END-ON-NEXT";}function isSCTE35Attribute(attrName){return attrName==="SCTE35-OUT"||attrName==="SCTE35-IN";}var DateRange=/*#__PURE__*/function(){function DateRange(dateRangeAttr,dateRangeWithSameId){_classCallCheck(this,DateRange);this.attr=void 0;this._startDate=void 0;this._endDate=void 0;this._badValueForSameId=void 0;if(dateRangeWithSameId){var previousAttr=dateRangeWithSameId.attr;for(var key in previousAttr){if(Object.prototype.hasOwnProperty.call(dateRangeAttr,key)&&dateRangeAttr[key]!==previousAttr[key]){logger.warn("DATERANGE tag attribute: \"".concat(key,"\" does not match for tags with ID: \"").concat(dateRangeAttr.ID,"\""));this._badValueForSameId=key;break;}}// Merge DateRange tags with the same ID
dateRangeAttr=_extends(new AttrList({}),previousAttr,dateRangeAttr);}this.attr=dateRangeAttr;this._startDate=new Date(dateRangeAttr["START-DATE"]);if("END-DATE"in this.attr){var endDate=new Date(this.attr["END-DATE"]);if(isFiniteNumber(endDate.getTime())){this._endDate=endDate;}}}_createClass(DateRange,[{key:"id",get:function get(){return this.attr.ID;}},{key:"class",get:function get(){return this.attr.CLASS;}},{key:"startDate",get:function get(){return this._startDate;}},{key:"endDate",get:function get(){if(this._endDate){return this._endDate;}var duration=this.duration;if(duration!==null){return new Date(this._startDate.getTime()+duration*1000);}return null;}},{key:"duration",get:function get(){if("DURATION"in this.attr){var duration=this.attr.decimalFloatingPoint("DURATION");if(isFiniteNumber(duration)){return duration;}}else if(this._endDate){return (this._endDate.getTime()-this._startDate.getTime())/1000;}return null;}},{key:"plannedDuration",get:function get(){if("PLANNED-DURATION"in this.attr){return this.attr.decimalFloatingPoint("PLANNED-DURATION");}return null;}},{key:"endOnNext",get:function get(){return this.attr.bool("END-ON-NEXT");}},{key:"isValid",get:function get(){return !!this.id&&!this._badValueForSameId&&isFiniteNumber(this.startDate.getTime())&&(this.duration===null||this.duration>=0)&&(!this.endOnNext||!!this["class"]);}}]);return DateRange;}();var LoadStats=/*#__PURE__*/_createClass(function LoadStats(){_classCallCheck(this,LoadStats);this.aborted=false;this.loaded=0;this.retry=0;this.total=0;this.chunkCount=0;this.bwEstimate=0;this.loading={start:0,first:0,end:0};this.parsing={start:0,end:0};this.buffering={start:0,first:0,end:0};});var ElementaryStreamTypes={AUDIO:"audio",VIDEO:"video",AUDIOVIDEO:"audiovideo"};var BaseSegment=/*#__PURE__*/function(){function BaseSegment(baseurl){var _this$elementaryStrea;_classCallCheck(this,BaseSegment);this._byteRange=null;this._url=null;// baseurl is the URL to the playlist
this.baseurl=void 0;// relurl is the portion of the URL that comes from inside the playlist.
this.relurl=void 0;// Holds the types of data this fragment supports
this.elementaryStreams=(_this$elementaryStrea={},_defineProperty$3(_this$elementaryStrea,ElementaryStreamTypes.AUDIO,null),_defineProperty$3(_this$elementaryStrea,ElementaryStreamTypes.VIDEO,null),_defineProperty$3(_this$elementaryStrea,ElementaryStreamTypes.AUDIOVIDEO,null),_this$elementaryStrea);this.baseurl=baseurl;}// setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
_createClass(BaseSegment,[{key:"setByteRange",value:function setByteRange(value,previous){var params=value.split('@',2);var start;if(params.length===1){start=(previous==null?void 0:previous.byteRangeEndOffset)||0;}else {start=parseInt(params[1]);}this._byteRange=[start,parseInt(params[0])+start];}},{key:"byteRange",get:function get(){if(!this._byteRange){return [];}return this._byteRange;}},{key:"byteRangeStartOffset",get:function get(){return this.byteRange[0];}},{key:"byteRangeEndOffset",get:function get(){return this.byteRange[1];}},{key:"url",get:function get(){if(!this._url&&this.baseurl&&this.relurl){this._url=urlToolkitExports.buildAbsoluteURL(this.baseurl,this.relurl,{alwaysNormalize:true});}return this._url||'';},set:function set(value){this._url=value;}}]);return BaseSegment;}();/**
 * Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
 */var Fragment=/*#__PURE__*/function(_BaseSegment){_inherits(Fragment,_BaseSegment);var _super=_createSuper(Fragment);function Fragment(type,baseurl){var _this2;_classCallCheck(this,Fragment);_this2=_super.call(this,baseurl);_this2._decryptdata=null;_this2.rawProgramDateTime=null;_this2.programDateTime=null;_this2.tagList=[];// EXTINF has to be present for a m3u8 to be considered valid
_this2.duration=0;// sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
_this2.sn=0;// levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
// core difference from the private field _decryptdata is the lack of the initialized IV
// _decryptdata will set the IV for this segment based on the segment number in the fragment
_this2.levelkeys=void 0;// A string representing the fragment type
_this2.type=void 0;// A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
_this2.loader=null;// A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
_this2.keyLoader=null;// The level/track index to which the fragment belongs
_this2.level=-1;// The continuity counter of the fragment
_this2.cc=0;// The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
_this2.startPTS=void 0;// The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
_this2.endPTS=void 0;// The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
_this2.startDTS=void 0;// The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
_this2.endDTS=void 0;// The start time of the fragment, as listed in the manifest. Updated after transmux complete.
_this2.start=0;// Set by `updateFragPTSDTS` in level-helper
_this2.deltaPTS=void 0;// The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
_this2.maxStartPTS=void 0;// The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
_this2.minEndPTS=void 0;// Load/parse timing information
_this2.stats=new LoadStats();// Init Segment bytes (unset for media segments)
_this2.data=void 0;// A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
_this2.bitrateTest=false;// #EXTINF  segment title
_this2.title=null;// The Media Initialization Section for this segment
_this2.initSegment=null;// Fragment is the last fragment in the media playlist
_this2.endList=void 0;// Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
_this2.gap=void 0;// Deprecated
_this2.urlId=0;_this2.type=type;return _this2;}_createClass(Fragment,[{key:"decryptdata",get:function get(){var levelkeys=this.levelkeys;if(!levelkeys&&!this._decryptdata){return null;}if(!this._decryptdata&&this.levelkeys&&!this.levelkeys.NONE){var key=this.levelkeys.identity;if(key){this._decryptdata=key.getDecryptData(this.sn);}else {var keyFormats=Object.keys(this.levelkeys);if(keyFormats.length===1){return this._decryptdata=this.levelkeys[keyFormats[0]].getDecryptData(this.sn);}}}return this._decryptdata;}},{key:"end",get:function get(){return this.start+this.duration;}},{key:"endProgramDateTime",get:function get(){if(this.programDateTime===null){return null;}if(!isFiniteNumber(this.programDateTime)){return null;}var duration=!isFiniteNumber(this.duration)?0:this.duration;return this.programDateTime+duration*1000;}},{key:"encrypted",get:function get(){var _this$_decryptdata;// At the m3u8-parser level we need to add support for manifest signalled keyformats
// when we want the fragment to start reporting that it is encrypted.
// Currently, keyFormat will only be set for identity keys
if((_this$_decryptdata=this._decryptdata)!=null&&_this$_decryptdata.encrypted){return true;}else if(this.levelkeys){var keyFormats=Object.keys(this.levelkeys);var len=keyFormats.length;if(len>1||len===1&&this.levelkeys[keyFormats[0]].encrypted){return true;}}return false;}},{key:"setKeyFormat",value:function setKeyFormat(keyFormat){if(this.levelkeys){var key=this.levelkeys[keyFormat];if(key&&!this._decryptdata){this._decryptdata=key.getDecryptData(this.sn);}}}},{key:"abortRequests",value:function abortRequests(){var _this$loader,_this$keyLoader;(_this$loader=this.loader)==null?void 0:_this$loader.abort();(_this$keyLoader=this.keyLoader)==null?void 0:_this$keyLoader.abort();}},{key:"setElementaryStreamInfo",value:function setElementaryStreamInfo(type,startPTS,endPTS,startDTS,endDTS){var partial=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;var elementaryStreams=this.elementaryStreams;var info=elementaryStreams[type];if(!info){elementaryStreams[type]={startPTS:startPTS,endPTS:endPTS,startDTS:startDTS,endDTS:endDTS,partial:partial};return;}info.startPTS=Math.min(info.startPTS,startPTS);info.endPTS=Math.max(info.endPTS,endPTS);info.startDTS=Math.min(info.startDTS,startDTS);info.endDTS=Math.max(info.endDTS,endDTS);}},{key:"clearElementaryStreamInfo",value:function clearElementaryStreamInfo(){var elementaryStreams=this.elementaryStreams;elementaryStreams[ElementaryStreamTypes.AUDIO]=null;elementaryStreams[ElementaryStreamTypes.VIDEO]=null;elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO]=null;}}]);return Fragment;}(BaseSegment);/**
 * Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
 */var Part=/*#__PURE__*/function(_BaseSegment2){_inherits(Part,_BaseSegment2);var _super2=_createSuper(Part);function Part(partAttrs,frag,baseurl,index,previous){var _this3;_classCallCheck(this,Part);_this3=_super2.call(this,baseurl);_this3.fragOffset=0;_this3.duration=0;_this3.gap=false;_this3.independent=false;_this3.relurl=void 0;_this3.fragment=void 0;_this3.index=void 0;_this3.stats=new LoadStats();_this3.duration=partAttrs.decimalFloatingPoint('DURATION');_this3.gap=partAttrs.bool('GAP');_this3.independent=partAttrs.bool('INDEPENDENT');_this3.relurl=partAttrs.enumeratedString('URI');_this3.fragment=frag;_this3.index=index;var byteRange=partAttrs.enumeratedString('BYTERANGE');if(byteRange){_this3.setByteRange(byteRange,previous);}if(previous){_this3.fragOffset=previous.fragOffset+previous.duration;}return _this3;}_createClass(Part,[{key:"start",get:function get(){return this.fragment.start+this.fragOffset;}},{key:"end",get:function get(){return this.start+this.duration;}},{key:"loaded",get:function get(){var elementaryStreams=this.elementaryStreams;return !!(elementaryStreams.audio||elementaryStreams.video||elementaryStreams.audiovideo);}}]);return Part;}(BaseSegment);var DEFAULT_TARGET_DURATION=10;/**
 * Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
 */var LevelDetails=/*#__PURE__*/function(){function LevelDetails(baseUrl){_classCallCheck(this,LevelDetails);this.PTSKnown=false;this.alignedSliding=false;this.averagetargetduration=void 0;this.endCC=0;this.endSN=0;this.fragments=void 0;this.fragmentHint=void 0;this.partList=null;this.dateRanges=void 0;this.live=true;this.ageHeader=0;this.advancedDateTime=void 0;this.updated=true;this.advanced=true;this.availabilityDelay=void 0;// Manifest reload synchronization
this.misses=0;this.startCC=0;this.startSN=0;this.startTimeOffset=null;this.targetduration=0;this.totalduration=0;this.type=null;this.url=void 0;this.m3u8='';this.version=null;this.canBlockReload=false;this.canSkipUntil=0;this.canSkipDateRanges=false;this.skippedSegments=0;this.recentlyRemovedDateranges=void 0;this.partHoldBack=0;this.holdBack=0;this.partTarget=0;this.preloadHint=void 0;this.renditionReports=void 0;this.tuneInGoal=0;this.deltaUpdateFailed=void 0;this.driftStartTime=0;this.driftEndTime=0;this.driftStart=0;this.driftEnd=0;this.encryptedFragments=void 0;this.playlistParsingError=null;this.variableList=null;this.hasVariableRefs=false;this.fragments=[];this.encryptedFragments=[];this.dateRanges={};this.url=baseUrl;}_createClass(LevelDetails,[{key:"reloaded",value:function reloaded(previous){if(!previous){this.advanced=true;this.updated=true;return;}var partSnDiff=this.lastPartSn-previous.lastPartSn;var partIndexDiff=this.lastPartIndex-previous.lastPartIndex;this.updated=this.endSN!==previous.endSN||!!partIndexDiff||!!partSnDiff||!this.live;this.advanced=this.endSN>previous.endSN||partSnDiff>0||partSnDiff===0&&partIndexDiff>0;if(this.updated||this.advanced){this.misses=Math.floor(previous.misses*0.6);}else {this.misses=previous.misses+1;}this.availabilityDelay=previous.availabilityDelay;}},{key:"hasProgramDateTime",get:function get(){if(this.fragments.length){return isFiniteNumber(this.fragments[this.fragments.length-1].programDateTime);}return false;}},{key:"levelTargetDuration",get:function get(){return this.averagetargetduration||this.targetduration||DEFAULT_TARGET_DURATION;}},{key:"drift",get:function get(){var runTime=this.driftEndTime-this.driftStartTime;if(runTime>0){var runDuration=this.driftEnd-this.driftStart;return runDuration*1000/runTime;}return 1;}},{key:"edge",get:function get(){return this.partEnd||this.fragmentEnd;}},{key:"partEnd",get:function get(){var _this$partList;if((_this$partList=this.partList)!=null&&_this$partList.length){return this.partList[this.partList.length-1].end;}return this.fragmentEnd;}},{key:"fragmentEnd",get:function get(){var _this$fragments;if((_this$fragments=this.fragments)!=null&&_this$fragments.length){return this.fragments[this.fragments.length-1].end;}return 0;}},{key:"age",get:function get(){if(this.advancedDateTime){return Math.max(Date.now()-this.advancedDateTime,0)/1000;}return 0;}},{key:"lastPartIndex",get:function get(){var _this$partList2;if((_this$partList2=this.partList)!=null&&_this$partList2.length){return this.partList[this.partList.length-1].index;}return -1;}},{key:"lastPartSn",get:function get(){var _this$partList3;if((_this$partList3=this.partList)!=null&&_this$partList3.length){return this.partList[this.partList.length-1].fragment.sn;}return this.endSN;}}]);return LevelDetails;}();function base64Decode(base64encodedStr){return Uint8Array.from(atob(base64encodedStr),function(c){return c.charCodeAt(0);});}function getKeyIdBytes(str){var keyIdbytes=strToUtf8array(str).subarray(0,16);var paddedkeyIdbytes=new Uint8Array(16);paddedkeyIdbytes.set(keyIdbytes,16-keyIdbytes.length);return paddedkeyIdbytes;}function changeEndianness(keyId){var swap=function swap(array,from,to){var cur=array[from];array[from]=array[to];array[to]=cur;};swap(keyId,0,3);swap(keyId,1,2);swap(keyId,4,5);swap(keyId,6,7);}function convertDataUriToArrayBytes(uri){// data:[<media type][;attribute=value][;base64],<data>
var colonsplit=uri.split(':');var keydata=null;if(colonsplit[0]==='data'&&colonsplit.length===2){var semicolonsplit=colonsplit[1].split(';');var commasplit=semicolonsplit[semicolonsplit.length-1].split(',');if(commasplit.length===2){var isbase64=commasplit[0]==='base64';var data=commasplit[1];if(isbase64){semicolonsplit.splice(-1,1);// remove from processing
keydata=base64Decode(data);}else {keydata=getKeyIdBytes(data);}}}return keydata;}function strToUtf8array(str){return Uint8Array.from(unescape(encodeURIComponent(str)),function(c){return c.charCodeAt(0);});}/** returns `undefined` is `self` is missing, e.g. in node */var optionalSelf=typeof self!=='undefined'?self:undefined;/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */var KeySystems={CLEARKEY:"org.w3.clearkey",FAIRPLAY:"com.apple.fps",PLAYREADY:"com.microsoft.playready",WIDEVINE:"com.widevine.alpha"};// Playlist #EXT-X-KEY KEYFORMAT values
var KeySystemFormats={CLEARKEY:"org.w3.clearkey",FAIRPLAY:"com.apple.streamingkeydelivery",PLAYREADY:"com.microsoft.playready",WIDEVINE:"urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"};function keySystemFormatToKeySystemDomain(format){switch(format){case KeySystemFormats.FAIRPLAY:return KeySystems.FAIRPLAY;case KeySystemFormats.PLAYREADY:return KeySystems.PLAYREADY;case KeySystemFormats.WIDEVINE:return KeySystems.WIDEVINE;case KeySystemFormats.CLEARKEY:return KeySystems.CLEARKEY;}}// System IDs for which we can extract a key ID from "encrypted" event PSSH
var KeySystemIds={CENC:"1077efecc0b24d02ace33c1e52e2fb4b",CLEARKEY:"e2719d58a985b3c9781ab030af78d30e",FAIRPLAY:"94ce86fb07ff4f43adb893d2fa968ca2",PLAYREADY:"9a04f07998404286ab92e65be0885f95",WIDEVINE:"edef8ba979d64acea3c827dcd51d21ed"};function keySystemIdToKeySystemDomain(systemId){if(systemId===KeySystemIds.WIDEVINE){return KeySystems.WIDEVINE;}else if(systemId===KeySystemIds.PLAYREADY){return KeySystems.PLAYREADY;}else if(systemId===KeySystemIds.CENC||systemId===KeySystemIds.CLEARKEY){return KeySystems.CLEARKEY;}}function keySystemDomainToKeySystemFormat(keySystem){switch(keySystem){case KeySystems.FAIRPLAY:return KeySystemFormats.FAIRPLAY;case KeySystems.PLAYREADY:return KeySystemFormats.PLAYREADY;case KeySystems.WIDEVINE:return KeySystemFormats.WIDEVINE;case KeySystems.CLEARKEY:return KeySystemFormats.CLEARKEY;}}function getKeySystemsForConfig(config){var drmSystems=config.drmSystems,widevineLicenseUrl=config.widevineLicenseUrl;var keySystemsToAttempt=drmSystems?[KeySystems.FAIRPLAY,KeySystems.WIDEVINE,KeySystems.PLAYREADY,KeySystems.CLEARKEY].filter(function(keySystem){return !!drmSystems[keySystem];}):[];if(!keySystemsToAttempt[KeySystems.WIDEVINE]&&widevineLicenseUrl){keySystemsToAttempt.push(KeySystems.WIDEVINE);}return keySystemsToAttempt;}var _requestMediaKeySystemAccess=function(_optionalSelf$navigat){if(optionalSelf!=null&&(_optionalSelf$navigat=optionalSelf.navigator)!=null&&_optionalSelf$navigat.requestMediaKeySystemAccess){return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);}else {return null;}}();/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 */function getSupportedMediaKeySystemConfigurations(keySystem,audioCodecs,videoCodecs,drmSystemOptions){var initDataTypes;switch(keySystem){case KeySystems.FAIRPLAY:initDataTypes=['cenc','sinf'];break;case KeySystems.WIDEVINE:case KeySystems.PLAYREADY:initDataTypes=['cenc'];break;case KeySystems.CLEARKEY:initDataTypes=['cenc','keyids'];break;default:throw new Error("Unknown key-system: ".concat(keySystem));}return createMediaKeySystemConfigurations(initDataTypes,audioCodecs,videoCodecs,drmSystemOptions);}function createMediaKeySystemConfigurations(initDataTypes,audioCodecs,videoCodecs,drmSystemOptions){var baseConfig={initDataTypes:initDataTypes,persistentState:drmSystemOptions.persistentState||'optional',distinctiveIdentifier:drmSystemOptions.distinctiveIdentifier||'optional',sessionTypes:drmSystemOptions.sessionTypes||[drmSystemOptions.sessionType||'temporary'],audioCapabilities:audioCodecs.map(function(codec){return {contentType:"audio/mp4; codecs=\"".concat(codec,"\""),robustness:drmSystemOptions.audioRobustness||'',encryptionScheme:drmSystemOptions.audioEncryptionScheme||null};}),videoCapabilities:videoCodecs.map(function(codec){return {contentType:"video/mp4; codecs=\"".concat(codec,"\""),robustness:drmSystemOptions.videoRobustness||'',encryptionScheme:drmSystemOptions.videoEncryptionScheme||null};})};return [baseConfig];}function sliceUint8(array,start,end){// @ts-expect-error This polyfills IE11 usage of Uint8Array slice.
// It always exists in the TypeScript definition so fails, but it fails at runtime on IE11.
return Uint8Array.prototype.slice?array.slice(start,end):new Uint8Array(Array.prototype.slice.call(array,start,end));}// breaking up those two types in order to clarify what is happening in the decoding path.
/**
 * Returns true if an ID3 header can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */var isHeader$2=function isHeader$2(data,offset){/*
   * http://id3.org/id3v2.3.0
   * [0]     = 'I'
   * [1]     = 'D'
   * [2]     = '3'
   * [3,4]   = {Version}
   * [5]     = {Flags}
   * [6-9]   = {ID3 Size}
   *
   * An ID3v2 tag can be detected with the following pattern:
   *  $49 44 33 yy yy xx zz zz zz zz
   * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
   */if(offset+10<=data.length){// look for 'ID3' identifier
if(data[offset]===0x49&&data[offset+1]===0x44&&data[offset+2]===0x33){// check version is within range
if(data[offset+3]<0xff&&data[offset+4]<0xff){// check size is within range
if(data[offset+6]<0x80&&data[offset+7]<0x80&&data[offset+8]<0x80&&data[offset+9]<0x80){return true;}}}}return false;};/**
 * Returns true if an ID3 footer can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */var isFooter=function isFooter(data,offset){/*
   * The footer is a copy of the header, but with a different identifier
   */if(offset+10<=data.length){// look for '3DI' identifier
if(data[offset]===0x33&&data[offset+1]===0x44&&data[offset+2]===0x49){// check version is within range
if(data[offset+3]<0xff&&data[offset+4]<0xff){// check size is within range
if(data[offset+6]<0x80&&data[offset+7]<0x80&&data[offset+8]<0x80&&data[offset+9]<0x80){return true;}}}}return false;};/**
 * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 * @returns the block of data containing any ID3 tags found
 * or *undefined* if no header is found at the starting offset
 */var getID3Data=function getID3Data(data,offset){var front=offset;var length=0;while(isHeader$2(data,offset)){// ID3 header is 10 bytes
length+=10;var size=readSize(data,offset+6);length+=size;if(isFooter(data,offset+10)){// ID3 footer is 10 bytes
length+=10;}offset+=length;}if(length>0){return data.subarray(front,front+length);}return undefined;};var readSize=function readSize(data,offset){var size=0;size=(data[offset]&0x7f)<<21;size|=(data[offset+1]&0x7f)<<14;size|=(data[offset+2]&0x7f)<<7;size|=data[offset+3]&0x7f;return size;};var canParse$2=function canParse$2(data,offset){return isHeader$2(data,offset)&&readSize(data,offset+6)+10<=data.length-offset;};/**
 * Searches for the Elementary Stream timestamp found in the ID3 data chunk
 * @param data - Block of data containing one or more ID3 tags
 */var getTimeStamp=function getTimeStamp(data){var frames=getID3Frames(data);for(var i=0;i<frames.length;i++){var frame=frames[i];if(isTimeStampFrame(frame)){return readTimeStamp(frame);}}return undefined;};/**
 * Returns true if the ID3 frame is an Elementary Stream timestamp frame
 */var isTimeStampFrame=function isTimeStampFrame(frame){return frame&&frame.key==='PRIV'&&frame.info==='com.apple.streaming.transportStreamTimestamp';};var getFrameData=function getFrameData(data){/*
  Frame ID       $xx xx xx xx (four characters)
  Size           $xx xx xx xx
  Flags          $xx xx
  */var type=String.fromCharCode(data[0],data[1],data[2],data[3]);var size=readSize(data,4);// skip frame id, size, and flags
var offset=10;return {type:type,size:size,data:data.subarray(offset,offset+size)};};/**
 * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
 * @param id3Data - The ID3 data containing one or more ID3 tags
 */var getID3Frames=function getID3Frames(id3Data){var offset=0;var frames=[];while(isHeader$2(id3Data,offset)){var size=readSize(id3Data,offset+6);// skip past ID3 header
offset+=10;var end=offset+size;// loop through frames in the ID3 tag
while(offset+8<end){var frameData=getFrameData(id3Data.subarray(offset));var frame=decodeFrame(frameData);if(frame){frames.push(frame);}// skip frame header and frame data
offset+=frameData.size+10;}if(isFooter(id3Data,offset)){offset+=10;}}return frames;};var decodeFrame=function decodeFrame(frame){if(frame.type==='PRIV'){return decodePrivFrame(frame);}else if(frame.type[0]==='W'){return decodeURLFrame(frame);}return decodeTextFrame(frame);};var decodePrivFrame=function decodePrivFrame(frame){/*
  Format: <text string>\0<binary data>
  */if(frame.size<2){return undefined;}var owner=utf8ArrayToStr(frame.data,true);var privateData=new Uint8Array(frame.data.subarray(owner.length+1));return {key:frame.type,info:owner,data:privateData.buffer};};var decodeTextFrame=function decodeTextFrame(frame){if(frame.size<2){return undefined;}if(frame.type==='TXXX'){/*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{Value}
    */var index=1;var description=utf8ArrayToStr(frame.data.subarray(index),true);index+=description.length+1;var value=utf8ArrayToStr(frame.data.subarray(index));return {key:frame.type,info:description,data:value};}/*
  Format:
  [0]   = {Text Encoding}
  [1-?] = {Value}
  */var text=utf8ArrayToStr(frame.data.subarray(1));return {key:frame.type,data:text};};var decodeURLFrame=function decodeURLFrame(frame){if(frame.type==='WXXX'){/*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{URL}
    */if(frame.size<2){return undefined;}var index=1;var description=utf8ArrayToStr(frame.data.subarray(index),true);index+=description.length+1;var value=utf8ArrayToStr(frame.data.subarray(index));return {key:frame.type,info:description,data:value};}/*
  Format:
  [0-?] = {URL}
  */var url=utf8ArrayToStr(frame.data);return {key:frame.type,data:url};};var readTimeStamp=function readTimeStamp(timeStampFrame){if(timeStampFrame.data.byteLength===8){var data=new Uint8Array(timeStampFrame.data);// timestamp is 33 bit expressed as a big-endian eight-octet number,
// with the upper 31 bits set to zero.
var pts33Bit=data[3]&0x1;var timestamp=(data[4]<<23)+(data[5]<<15)+(data[6]<<7)+data[7];timestamp/=45;if(pts33Bit){timestamp+=47721858.84;}// 2^32 / 90
return Math.round(timestamp);}return undefined;};// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */var utf8ArrayToStr=function utf8ArrayToStr(array){var exitOnNull=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var decoder=getTextDecoder();if(decoder){var decoded=decoder.decode(array);if(exitOnNull){// grab up to the first null
var idx=decoded.indexOf('\0');return idx!==-1?decoded.substring(0,idx):decoded;}// remove any null characters
return decoded.replace(/\0/g,'');}var len=array.length;var c;var char2;var char3;var out='';var i=0;while(i<len){c=array[i++];if(c===0x00&&exitOnNull){return out;}else if(c===0x00||c===0x03){// If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
continue;}switch(c>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:// 0xxxxxxx
out+=String.fromCharCode(c);break;case 12:case 13:// 110x xxxx   10xx xxxx
char2=array[i++];out+=String.fromCharCode((c&0x1f)<<6|char2&0x3f);break;case 14:// 1110 xxxx  10xx xxxx  10xx xxxx
char2=array[i++];char3=array[i++];out+=String.fromCharCode((c&0x0f)<<12|(char2&0x3f)<<6|(char3&0x3f)<<0);break;}}return out;};var decoder;function getTextDecoder(){// On Play Station 4, TextDecoder is defined but partially implemented.
// Manual decoding option is preferable
if(navigator.userAgent.includes('PlayStation 4')){return;}if(!decoder&&typeof self.TextDecoder!=='undefined'){decoder=new self.TextDecoder('utf-8');}return decoder;}/**
 *  hex dump helper class
 */var Hex={hexDump:function hexDump(array){var str='';for(var i=0;i<array.length;i++){var h=array[i].toString(16);if(h.length<2){h='0'+h;}str+=h;}return str;}};var UINT32_MAX$1=Math.pow(2,32)-1;var push=[].push;// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
var RemuxerTrackIdConfig={video:1,audio:2,id3:3,text:4};function bin2str(data){return String.fromCharCode.apply(null,data);}function readUint16(buffer,offset){var val=buffer[offset]<<8|buffer[offset+1];return val<0?65536+val:val;}function readUint32(buffer,offset){var val=readSint32(buffer,offset);return val<0?4294967296+val:val;}function readUint64(buffer,offset){var result=readUint32(buffer,offset);result*=Math.pow(2,32);result+=readUint32(buffer,offset+4);return result;}function readSint32(buffer,offset){return buffer[offset]<<24|buffer[offset+1]<<16|buffer[offset+2]<<8|buffer[offset+3];}function writeUint32(buffer,offset,value){buffer[offset]=value>>24;buffer[offset+1]=value>>16&0xff;buffer[offset+2]=value>>8&0xff;buffer[offset+3]=value&0xff;}// Find "moof" box
function hasMoofData(data){var end=data.byteLength;for(var i=0;i<end;){var size=readUint32(data,i);if(size>8&&data[i+4]===0x6d&&data[i+5]===0x6f&&data[i+6]===0x6f&&data[i+7]===0x66){return true;}i=size>1?i+size:end;}return false;}// Find the data for a box specified by its path
function findBox(data,path){var results=[];if(!path.length){// short-circuit the search for empty paths
return results;}var end=data.byteLength;for(var i=0;i<end;){var size=readUint32(data,i);var type=bin2str(data.subarray(i+4,i+8));var endbox=size>1?i+size:end;if(type===path[0]){if(path.length===1){// this is the end of the path and we've found the box we were
// looking for
results.push(data.subarray(i+8,endbox));}else {// recursively search for the next box along the path
var subresults=findBox(data.subarray(i+8,endbox),path.slice(1));if(subresults.length){push.apply(results,subresults);}}}i=endbox;}// we've finished searching all of data
return results;}function parseSegmentIndex(sidx){var references=[];var version=sidx[0];// set initial offset, we skip the reference ID (not needed)
var index=8;var timescale=readUint32(sidx,index);index+=4;var earliestPresentationTime=0;var firstOffset=0;if(version===0){earliestPresentationTime=readUint32(sidx,index);firstOffset=readUint32(sidx,index+4);index+=8;}else {earliestPresentationTime=readUint64(sidx,index);firstOffset=readUint64(sidx,index+8);index+=16;}// skip reserved
index+=2;var startByte=sidx.length+firstOffset;var referencesCount=readUint16(sidx,index);index+=2;for(var i=0;i<referencesCount;i++){var referenceIndex=index;var referenceInfo=readUint32(sidx,referenceIndex);referenceIndex+=4;var referenceSize=referenceInfo&0x7fffffff;var referenceType=(referenceInfo&0x80000000)>>>31;if(referenceType===1){logger.warn('SIDX has hierarchical references (not supported)');return null;}var subsegmentDuration=readUint32(sidx,referenceIndex);referenceIndex+=4;references.push({referenceSize:referenceSize,subsegmentDuration:subsegmentDuration,// unscaled
info:{duration:subsegmentDuration/timescale,start:startByte,end:startByte+referenceSize-1}});startByte+=referenceSize;// Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
// for |sapDelta|.
referenceIndex+=4;// skip to next ref
index=referenceIndex;}return {earliestPresentationTime:earliestPresentationTime,timescale:timescale,version:version,referencesCount:referencesCount,references:references};}/**
 * Parses an MP4 initialization segment and extracts stream type and
 * timescale values for any declared tracks. Timescale values indicate the
 * number of clock ticks per second to assume for time-based values
 * elsewhere in the MP4.
 *
 * To determine the start time of an MP4, you need two pieces of
 * information: the timescale unit and the earliest base media decode
 * time. Multiple timescales can be specified within an MP4 but the
 * base media decode time is always expressed in the timescale from
 * the media header box for the track:
 * ```
 * moov > trak > mdia > mdhd.timescale
 * moov > trak > mdia > hdlr
 * ```
 * @param initSegment the bytes of the init segment
 * @returns a hash of track type to timescale values or null if
 * the init segment is malformed.
 */function parseInitSegment(initSegment){var result=[];var traks=findBox(initSegment,['moov','trak']);for(var i=0;i<traks.length;i++){var trak=traks[i];var tkhd=findBox(trak,['tkhd'])[0];if(tkhd){var version=tkhd[0];var trackId=readUint32(tkhd,version===0?12:20);var mdhd=findBox(trak,['mdia','mdhd'])[0];if(mdhd){version=mdhd[0];var timescale=readUint32(mdhd,version===0?12:20);var hdlr=findBox(trak,['mdia','hdlr'])[0];if(hdlr){var hdlrType=bin2str(hdlr.subarray(8,12));var type={soun:ElementaryStreamTypes.AUDIO,vide:ElementaryStreamTypes.VIDEO}[hdlrType];if(type){// Parse codec details
var stsd=findBox(trak,['mdia','minf','stbl','stsd'])[0];var stsdData=parseStsd(stsd);result[trackId]={timescale:timescale,type:type};result[type]=_objectSpread2$2({timescale:timescale,id:trackId},stsdData);}}}}}var trex=findBox(initSegment,['moov','mvex','trex']);trex.forEach(function(trex){var trackId=readUint32(trex,4);var track=result[trackId];if(track){track["default"]={duration:readUint32(trex,12),flags:readUint32(trex,20)};}});return result;}function parseStsd(stsd){var sampleEntries=stsd.subarray(8);var sampleEntriesEnd=sampleEntries.subarray(8+78);var fourCC=bin2str(sampleEntries.subarray(4,8));var codec=fourCC;var encrypted=fourCC==='enca'||fourCC==='encv';if(encrypted){var encBox=findBox(sampleEntries,[fourCC])[0];var encBoxChildren=encBox.subarray(fourCC==='enca'?28:78);var sinfs=findBox(encBoxChildren,['sinf']);sinfs.forEach(function(sinf){var schm=findBox(sinf,['schm'])[0];if(schm){var scheme=bin2str(schm.subarray(4,8));if(scheme==='cbcs'||scheme==='cenc'){var frma=findBox(sinf,['frma'])[0];if(frma){// for encrypted content codec fourCC will be in frma
codec=bin2str(frma);}}}});}switch(codec){case'avc1':case'avc2':case'avc3':case'avc4':{// extract profile + compatibility + level out of avcC box
var avcCBox=findBox(sampleEntriesEnd,['avcC'])[0];codec+='.'+toHex(avcCBox[1])+toHex(avcCBox[2])+toHex(avcCBox[3]);break;}case'mp4a':{var codecBox=findBox(sampleEntries,[fourCC])[0];var esdsBox=findBox(codecBox.subarray(28),['esds'])[0];if(esdsBox&&esdsBox.length>12){var i=4;// ES Descriptor tag
if(esdsBox[i++]!==0x03){break;}i=skipBERInteger(esdsBox,i);i+=2;// skip es_id;
var flags=esdsBox[i++];if(flags&0x80){i+=2;// skip dependency es_id
}if(flags&0x40){i+=esdsBox[i++];// skip URL
}// Decoder config descriptor
if(esdsBox[i++]!==0x04){break;}i=skipBERInteger(esdsBox,i);var objectType=esdsBox[i++];if(objectType===0x40){codec+='.'+toHex(objectType);}else {break;}i+=12;// Decoder specific info
if(esdsBox[i++]!==0x05){break;}i=skipBERInteger(esdsBox,i);var firstByte=esdsBox[i++];var audioObjectType=(firstByte&0xf8)>>3;if(audioObjectType===31){audioObjectType+=1+((firstByte&0x7)<<3)+((esdsBox[i]&0xe0)>>5);}codec+='.'+audioObjectType;}break;}case'hvc1':case'hev1':{var hvcCBox=findBox(sampleEntriesEnd,['hvcC'])[0];var profileByte=hvcCBox[1];var profileSpace=['','A','B','C'][profileByte>>6];var generalProfileIdc=profileByte&0x1f;var profileCompat=readUint32(hvcCBox,2);var tierFlag=(profileByte&0x20)>>5?'H':'L';var levelIDC=hvcCBox[12];var constraintIndicator=hvcCBox.subarray(6,12);codec+='.'+profileSpace+generalProfileIdc;codec+='.'+profileCompat.toString(16).toUpperCase();codec+='.'+tierFlag+levelIDC;var constraintString='';for(var _i2=constraintIndicator.length;_i2--;){var _byte=constraintIndicator[_i2];if(_byte||constraintString){var encodedByte=_byte.toString(16).toUpperCase();constraintString='.'+encodedByte+constraintString;}}codec+=constraintString;break;}case'dvh1':case'dvhe':{var dvcCBox=findBox(sampleEntriesEnd,['dvcC'])[0];var profile=dvcCBox[2]>>1&0x7f;var level=dvcCBox[2]<<5&0x20|dvcCBox[3]>>3&0x1f;codec+='.'+addLeadingZero(profile)+'.'+addLeadingZero(level);break;}case'vp09':{var vpcCBox=findBox(sampleEntriesEnd,['vpcC'])[0];var _profile=vpcCBox[4];var _level=vpcCBox[5];var bitDepth=vpcCBox[6]>>4&0x0f;codec+='.'+addLeadingZero(_profile)+'.'+addLeadingZero(_level)+'.'+addLeadingZero(bitDepth);break;}case'av01':{var av1CBox=findBox(sampleEntriesEnd,['av1C'])[0];var _profile2=av1CBox[1]>>>5;var _level2=av1CBox[1]&0x1f;var _tierFlag=av1CBox[2]>>>7?'H':'M';var highBitDepth=(av1CBox[2]&0x40)>>6;var twelveBit=(av1CBox[2]&0x20)>>5;var _bitDepth=_profile2===2&&highBitDepth?twelveBit?12:10:highBitDepth?10:8;var monochrome=(av1CBox[2]&0x10)>>4;var chromaSubsamplingX=(av1CBox[2]&0x08)>>3;var chromaSubsamplingY=(av1CBox[2]&0x04)>>2;var chromaSamplePosition=av1CBox[2]&0x03;// TODO: parse color_description_present_flag
// default it to BT.709/limited range for now
// more info https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
var colorPrimaries=1;var transferCharacteristics=1;var matrixCoefficients=1;var videoFullRangeFlag=0;codec+='.'+_profile2+'.'+addLeadingZero(_level2)+_tierFlag+'.'+addLeadingZero(_bitDepth)+'.'+monochrome+'.'+chromaSubsamplingX+chromaSubsamplingY+chromaSamplePosition+'.'+addLeadingZero(colorPrimaries)+'.'+addLeadingZero(transferCharacteristics)+'.'+addLeadingZero(matrixCoefficients)+'.'+videoFullRangeFlag;break;}}return {codec:codec,encrypted:encrypted};}function skipBERInteger(bytes,i){var limit=i+5;while(bytes[i++]&0x80&&i<limit){}return i;}function toHex(x){return ('0'+x.toString(16).toUpperCase()).slice(-2);}function addLeadingZero(num){return (num<10?'0':'')+num;}function patchEncyptionData(initSegment,decryptdata){if(!initSegment||!decryptdata){return initSegment;}var keyId=decryptdata.keyId;if(keyId&&decryptdata.isCommonEncryption){var traks=findBox(initSegment,['moov','trak']);traks.forEach(function(trak){var stsd=findBox(trak,['mdia','minf','stbl','stsd'])[0];// skip the sample entry count
var sampleEntries=stsd.subarray(8);var encBoxes=findBox(sampleEntries,['enca']);var isAudio=encBoxes.length>0;if(!isAudio){encBoxes=findBox(sampleEntries,['encv']);}encBoxes.forEach(function(enc){var encBoxChildren=isAudio?enc.subarray(28):enc.subarray(78);var sinfBoxes=findBox(encBoxChildren,['sinf']);sinfBoxes.forEach(function(sinf){var tenc=parseSinf(sinf);if(tenc){// Look for default key id (keyID offset is always 8 within the tenc box):
var tencKeyId=tenc.subarray(8,24);if(!tencKeyId.some(function(b){return b!==0;})){logger.log("[eme] Patching keyId in 'enc".concat(isAudio?'a':'v',">sinf>>tenc' box: ").concat(Hex.hexDump(tencKeyId)," -> ").concat(Hex.hexDump(keyId)));tenc.set(keyId,8);}}});});});}return initSegment;}function parseSinf(sinf){var schm=findBox(sinf,['schm'])[0];if(schm){var scheme=bin2str(schm.subarray(4,8));if(scheme==='cbcs'||scheme==='cenc'){return findBox(sinf,['schi','tenc'])[0];}}return null;}/**
 * Determine the base media decode start time, in seconds, for an MP4
 * fragment. If multiple fragments are specified, the earliest time is
 * returned.
 *
 * The base media decode time can be parsed from track fragment
 * metadata:
 * ```
 * moof > traf > tfdt.baseMediaDecodeTime
 * ```
 * It requires the timescale value from the mdhd to interpret.
 *
 * @param initData - a hash of track type to timescale values
 * @param fmp4 - the bytes of the mp4 fragment
 * @returns the earliest base media decode start time for the
 * fragment, in seconds
 */function getStartDTS(initData,fmp4){// we need info from two children of each track fragment box
return findBox(fmp4,['moof','traf']).reduce(function(result,traf){var tfdt=findBox(traf,['tfdt'])[0];var version=tfdt[0];var start=findBox(traf,['tfhd']).reduce(function(result,tfhd){// get the track id from the tfhd
var id=readUint32(tfhd,4);var track=initData[id];if(track){var baseTime=readUint32(tfdt,4);if(version===1){// If value is too large, assume signed 64-bit. Negative track fragment decode times are invalid, but they exist in the wild.
// This prevents large values from being used for initPTS, which can cause playlist sync issues.
// https://github.com/video-dev/hls.js/issues/5303
if(baseTime===UINT32_MAX$1){logger.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time");return result;}baseTime*=UINT32_MAX$1+1;baseTime+=readUint32(tfdt,8);}// assume a 90kHz clock if no timescale was specified
var scale=track.timescale||90e3;// convert base time to seconds
var startTime=baseTime/scale;if(isFiniteNumber(startTime)&&(result===null||startTime<result)){return startTime;}}return result;},null);if(start!==null&&isFiniteNumber(start)&&(result===null||start<result)){return start;}return result;},null);}/*
  For Reference:
  aligned(8) class TrackFragmentHeaderBox
           extends FullBox(‘tfhd’, 0, tf_flags){
     unsigned int(32)  track_ID;
     // all the following are optional fields
     unsigned int(64)  base_data_offset;
     unsigned int(32)  sample_description_index;
     unsigned int(32)  default_sample_duration;
     unsigned int(32)  default_sample_size;
     unsigned int(32)  default_sample_flags
  }
 */function getDuration(data,initData){var rawDuration=0;var videoDuration=0;var audioDuration=0;var trafs=findBox(data,['moof','traf']);for(var i=0;i<trafs.length;i++){var traf=trafs[i];// There is only one tfhd & trun per traf
// This is true for CMAF style content, and we should perhaps check the ftyp
// and only look for a single trun then, but for ISOBMFF we should check
// for multiple track runs.
var tfhd=findBox(traf,['tfhd'])[0];// get the track id from the tfhd
var id=readUint32(tfhd,4);var track=initData[id];if(!track){continue;}var trackDefault=track["default"];var tfhdFlags=readUint32(tfhd,0)|(trackDefault==null?void 0:trackDefault.flags);var sampleDuration=trackDefault==null?void 0:trackDefault.duration;if(tfhdFlags&0x000008){// 0x000008 indicates the presence of the default_sample_duration field
if(tfhdFlags&0x000002){// 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
// If present, the default_sample_duration exists at byte offset 12
sampleDuration=readUint32(tfhd,12);}else {// Otherwise, the duration is at byte offset 8
sampleDuration=readUint32(tfhd,8);}}// assume a 90kHz clock if no timescale was specified
var timescale=track.timescale||90e3;var truns=findBox(traf,['trun']);for(var j=0;j<truns.length;j++){rawDuration=computeRawDurationFromSamples(truns[j]);if(!rawDuration&&sampleDuration){var sampleCount=readUint32(truns[j],4);rawDuration=sampleDuration*sampleCount;}if(track.type===ElementaryStreamTypes.VIDEO){videoDuration+=rawDuration/timescale;}else if(track.type===ElementaryStreamTypes.AUDIO){audioDuration+=rawDuration/timescale;}}}if(videoDuration===0&&audioDuration===0){// If duration samples are not available in the traf use sidx subsegment_duration
var sidxMinStart=Infinity;var sidxMaxEnd=0;var sidxDuration=0;var sidxs=findBox(data,['sidx']);for(var _i3=0;_i3<sidxs.length;_i3++){var sidx=parseSegmentIndex(sidxs[_i3]);if(sidx!=null&&sidx.references){sidxMinStart=Math.min(sidxMinStart,sidx.earliestPresentationTime/sidx.timescale);var subSegmentDuration=sidx.references.reduce(function(dur,ref){return dur+ref.info.duration||0;},0);sidxMaxEnd=Math.max(sidxMaxEnd,subSegmentDuration+sidx.earliestPresentationTime/sidx.timescale);sidxDuration=sidxMaxEnd-sidxMinStart;}}if(sidxDuration&&isFiniteNumber(sidxDuration)){return sidxDuration;}}if(videoDuration){return videoDuration;}return audioDuration;}/*
  For Reference:
  aligned(8) class TrackRunBox
           extends FullBox(‘trun’, version, tr_flags) {
     unsigned int(32)  sample_count;
     // the following are optional fields
     signed int(32) data_offset;
     unsigned int(32)  first_sample_flags;
     // all fields in the following array are optional
     {
        unsigned int(32)  sample_duration;
        unsigned int(32)  sample_size;
        unsigned int(32)  sample_flags
        if (version == 0)
           { unsigned int(32)
        else
           { signed int(32)
     }[ sample_count ]
  }
 */function computeRawDurationFromSamples(trun){var flags=readUint32(trun,0);// Flags are at offset 0, non-optional sample_count is at offset 4. Therefore we start 8 bytes in.
// Each field is an int32, which is 4 bytes
var offset=8;// data-offset-present flag
if(flags&0x000001){offset+=4;}// first-sample-flags-present flag
if(flags&0x000004){offset+=4;}var duration=0;var sampleCount=readUint32(trun,4);for(var i=0;i<sampleCount;i++){// sample-duration-present flag
if(flags&0x000100){var sampleDuration=readUint32(trun,offset);duration+=sampleDuration;offset+=4;}// sample-size-present flag
if(flags&0x000200){offset+=4;}// sample-flags-present flag
if(flags&0x000400){offset+=4;}// sample-composition-time-offsets-present flag
if(flags&0x000800){offset+=4;}}return duration;}function offsetStartDTS(initData,fmp4,timeOffset){findBox(fmp4,['moof','traf']).forEach(function(traf){findBox(traf,['tfhd']).forEach(function(tfhd){// get the track id from the tfhd
var id=readUint32(tfhd,4);var track=initData[id];if(!track){return;}// assume a 90kHz clock if no timescale was specified
var timescale=track.timescale||90e3;// get the base media decode time from the tfdt
findBox(traf,['tfdt']).forEach(function(tfdt){var version=tfdt[0];var offset=timeOffset*timescale;if(offset){var baseMediaDecodeTime=readUint32(tfdt,4);if(version===0){baseMediaDecodeTime-=offset;baseMediaDecodeTime=Math.max(baseMediaDecodeTime,0);writeUint32(tfdt,4,baseMediaDecodeTime);}else {baseMediaDecodeTime*=Math.pow(2,32);baseMediaDecodeTime+=readUint32(tfdt,8);baseMediaDecodeTime-=offset;baseMediaDecodeTime=Math.max(baseMediaDecodeTime,0);var upper=Math.floor(baseMediaDecodeTime/(UINT32_MAX$1+1));var lower=Math.floor(baseMediaDecodeTime%(UINT32_MAX$1+1));writeUint32(tfdt,4,upper);writeUint32(tfdt,8,lower);}}});});});}// TODO: Check if the last moof+mdat pair is part of the valid range
function segmentValidRange(data){var segmentedRange={valid:null,remainder:null};var moofs=findBox(data,['moof']);if(moofs.length<2){segmentedRange.remainder=data;return segmentedRange;}var last=moofs[moofs.length-1];// Offset by 8 bytes; findBox offsets the start by as much
segmentedRange.valid=sliceUint8(data,0,last.byteOffset-8);segmentedRange.remainder=sliceUint8(data,last.byteOffset-8);return segmentedRange;}function appendUint8Array(data1,data2){var temp=new Uint8Array(data1.length+data2.length);temp.set(data1);temp.set(data2,data1.length);return temp;}function parseSamples(timeOffset,track){var seiSamples=[];var videoData=track.samples;var timescale=track.timescale;var trackId=track.id;var isHEVCFlavor=false;var moofs=findBox(videoData,['moof']);moofs.map(function(moof){var moofOffset=moof.byteOffset-8;var trafs=findBox(moof,['traf']);trafs.map(function(traf){// get the base media decode time from the tfdt
var baseTime=findBox(traf,['tfdt']).map(function(tfdt){var version=tfdt[0];var result=readUint32(tfdt,4);if(version===1){result*=Math.pow(2,32);result+=readUint32(tfdt,8);}return result/timescale;})[0];if(baseTime!==undefined){timeOffset=baseTime;}return findBox(traf,['tfhd']).map(function(tfhd){var id=readUint32(tfhd,4);var tfhdFlags=readUint32(tfhd,0)&0xffffff;var baseDataOffsetPresent=(tfhdFlags&0x000001)!==0;var sampleDescriptionIndexPresent=(tfhdFlags&0x000002)!==0;var defaultSampleDurationPresent=(tfhdFlags&0x000008)!==0;var defaultSampleDuration=0;var defaultSampleSizePresent=(tfhdFlags&0x000010)!==0;var defaultSampleSize=0;var defaultSampleFlagsPresent=(tfhdFlags&0x000020)!==0;var tfhdOffset=8;if(id===trackId){if(baseDataOffsetPresent){tfhdOffset+=8;}if(sampleDescriptionIndexPresent){tfhdOffset+=4;}if(defaultSampleDurationPresent){defaultSampleDuration=readUint32(tfhd,tfhdOffset);tfhdOffset+=4;}if(defaultSampleSizePresent){defaultSampleSize=readUint32(tfhd,tfhdOffset);tfhdOffset+=4;}if(defaultSampleFlagsPresent){tfhdOffset+=4;}if(track.type==='video'){isHEVCFlavor=isHEVC(track.codec);}findBox(traf,['trun']).map(function(trun){var version=trun[0];var flags=readUint32(trun,0)&0xffffff;var dataOffsetPresent=(flags&0x000001)!==0;var dataOffset=0;var firstSampleFlagsPresent=(flags&0x000004)!==0;var sampleDurationPresent=(flags&0x000100)!==0;var sampleDuration=0;var sampleSizePresent=(flags&0x000200)!==0;var sampleSize=0;var sampleFlagsPresent=(flags&0x000400)!==0;var sampleCompositionOffsetsPresent=(flags&0x000800)!==0;var compositionOffset=0;var sampleCount=readUint32(trun,4);var trunOffset=8;// past version, flags, and sample count
if(dataOffsetPresent){dataOffset=readUint32(trun,trunOffset);trunOffset+=4;}if(firstSampleFlagsPresent){trunOffset+=4;}var sampleOffset=dataOffset+moofOffset;for(var ix=0;ix<sampleCount;ix++){if(sampleDurationPresent){sampleDuration=readUint32(trun,trunOffset);trunOffset+=4;}else {sampleDuration=defaultSampleDuration;}if(sampleSizePresent){sampleSize=readUint32(trun,trunOffset);trunOffset+=4;}else {sampleSize=defaultSampleSize;}if(sampleFlagsPresent){trunOffset+=4;}if(sampleCompositionOffsetsPresent){if(version===0){compositionOffset=readUint32(trun,trunOffset);}else {compositionOffset=readSint32(trun,trunOffset);}trunOffset+=4;}if(track.type===ElementaryStreamTypes.VIDEO){var naluTotalSize=0;while(naluTotalSize<sampleSize){var naluSize=readUint32(videoData,sampleOffset);sampleOffset+=4;if(isSEIMessage(isHEVCFlavor,videoData[sampleOffset])){var data=videoData.subarray(sampleOffset,sampleOffset+naluSize);parseSEIMessageFromNALu(data,isHEVCFlavor?2:1,timeOffset+compositionOffset/timescale,seiSamples);}sampleOffset+=naluSize;naluTotalSize+=naluSize+4;}}timeOffset+=sampleDuration/timescale;}});}});});});return seiSamples;}function isHEVC(codec){if(!codec){return false;}var delimit=codec.indexOf('.');var baseCodec=delimit<0?codec:codec.substring(0,delimit);return baseCodec==='hvc1'||baseCodec==='hev1'||// Dolby Vision
baseCodec==='dvh1'||baseCodec==='dvhe';}function isSEIMessage(isHEVCFlavor,naluHeader){if(isHEVCFlavor){var naluType=naluHeader>>1&0x3f;return naluType===39||naluType===40;}else {var _naluType=naluHeader&0x1f;return _naluType===6;}}function parseSEIMessageFromNALu(unescapedData,headerSize,pts,samples){var data=discardEPB(unescapedData);var seiPtr=0;// skip nal header
seiPtr+=headerSize;var payloadType=0;var payloadSize=0;var b=0;while(seiPtr<data.length){payloadType=0;do{if(seiPtr>=data.length){break;}b=data[seiPtr++];payloadType+=b;}while(b===0xff);// Parse payload size.
payloadSize=0;do{if(seiPtr>=data.length){break;}b=data[seiPtr++];payloadSize+=b;}while(b===0xff);var leftOver=data.length-seiPtr;// Create a variable to process the payload
var payPtr=seiPtr;// Increment the seiPtr to the end of the payload
if(payloadSize<leftOver){seiPtr+=payloadSize;}else if(payloadSize>leftOver){// Some type of corruption has happened?
logger.error("Malformed SEI payload. ".concat(payloadSize," is too small, only ").concat(leftOver," bytes left to parse."));// We might be able to parse some data, but let's be safe and ignore it.
break;}if(payloadType===4){var countryCode=data[payPtr++];if(countryCode===181){var providerCode=readUint16(data,payPtr);payPtr+=2;if(providerCode===49){var userStructure=readUint32(data,payPtr);payPtr+=4;if(userStructure===0x47413934){var userDataType=data[payPtr++];// Raw CEA-608 bytes wrapped in CEA-708 packet
if(userDataType===3){var firstByte=data[payPtr++];var totalCCs=0x1f&firstByte;var enabled=0x40&firstByte;var totalBytes=enabled?2+totalCCs*3:0;var byteArray=new Uint8Array(totalBytes);if(enabled){byteArray[0]=firstByte;for(var i=1;i<totalBytes;i++){byteArray[i]=data[payPtr++];}}samples.push({type:userDataType,payloadType:payloadType,pts:pts,bytes:byteArray});}}}}}else if(payloadType===5){if(payloadSize>16){var uuidStrArray=[];for(var _i4=0;_i4<16;_i4++){var _b=data[payPtr++].toString(16);uuidStrArray.push(_b.length==1?'0'+_b:_b);if(_i4===3||_i4===5||_i4===7||_i4===9){uuidStrArray.push('-');}}var length=payloadSize-16;var userDataBytes=new Uint8Array(length);for(var _i5=0;_i5<length;_i5++){userDataBytes[_i5]=data[payPtr++];}samples.push({payloadType:payloadType,pts:pts,uuid:uuidStrArray.join(''),userData:utf8ArrayToStr(userDataBytes),userDataBytes:userDataBytes});}}}}/**
 * remove Emulation Prevention bytes from a RBSP
 */function discardEPB(data){var length=data.byteLength;var EPBPositions=[];var i=1;// Find all `Emulation Prevention Bytes`
while(i<length-2){if(data[i]===0&&data[i+1]===0&&data[i+2]===0x03){EPBPositions.push(i+2);i+=2;}else {i++;}}// If no Emulation Prevention Bytes were found just return the original
// array
if(EPBPositions.length===0){return data;}// Create a new array to hold the NAL unit data
var newLength=length-EPBPositions.length;var newData=new Uint8Array(newLength);var sourceIndex=0;for(i=0;i<newLength;sourceIndex++,i++){if(sourceIndex===EPBPositions[0]){// Skip this byte
sourceIndex++;// Remove this position index
EPBPositions.shift();}newData[i]=data[sourceIndex];}return newData;}function parseEmsg(data){var version=data[0];var schemeIdUri='';var value='';var timeScale=0;var presentationTimeDelta=0;var presentationTime=0;var eventDuration=0;var id=0;var offset=0;if(version===0){while(bin2str(data.subarray(offset,offset+1))!=='\0'){schemeIdUri+=bin2str(data.subarray(offset,offset+1));offset+=1;}schemeIdUri+=bin2str(data.subarray(offset,offset+1));offset+=1;while(bin2str(data.subarray(offset,offset+1))!=='\0'){value+=bin2str(data.subarray(offset,offset+1));offset+=1;}value+=bin2str(data.subarray(offset,offset+1));offset+=1;timeScale=readUint32(data,12);presentationTimeDelta=readUint32(data,16);eventDuration=readUint32(data,20);id=readUint32(data,24);offset=28;}else if(version===1){offset+=4;timeScale=readUint32(data,offset);offset+=4;var leftPresentationTime=readUint32(data,offset);offset+=4;var rightPresentationTime=readUint32(data,offset);offset+=4;presentationTime=Math.pow(2,32)*leftPresentationTime+rightPresentationTime;if(!isSafeInteger$1(presentationTime)){presentationTime=Number.MAX_SAFE_INTEGER;logger.warn('Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box');}eventDuration=readUint32(data,offset);offset+=4;id=readUint32(data,offset);offset+=4;while(bin2str(data.subarray(offset,offset+1))!=='\0'){schemeIdUri+=bin2str(data.subarray(offset,offset+1));offset+=1;}schemeIdUri+=bin2str(data.subarray(offset,offset+1));offset+=1;while(bin2str(data.subarray(offset,offset+1))!=='\0'){value+=bin2str(data.subarray(offset,offset+1));offset+=1;}value+=bin2str(data.subarray(offset,offset+1));offset+=1;}var payload=data.subarray(offset,data.byteLength);return {schemeIdUri:schemeIdUri,value:value,timeScale:timeScale,presentationTime:presentationTime,presentationTimeDelta:presentationTimeDelta,eventDuration:eventDuration,id:id,payload:payload};}function mp4Box(type){for(var _len2=arguments.length,payload=new Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){payload[_key2-1]=arguments[_key2];}var len=payload.length;var size=8;var i=len;while(i--){size+=payload[i].byteLength;}var result=new Uint8Array(size);result[0]=size>>24&0xff;result[1]=size>>16&0xff;result[2]=size>>8&0xff;result[3]=size&0xff;result.set(type,4);for(i=0,size=8;i<len;i++){result.set(payload[i],size);size+=payload[i].byteLength;}return result;}function mp4pssh(systemId,keyids,data){if(systemId.byteLength!==16){throw new RangeError('Invalid system id');}var version;var kids;if(keyids){version=1;kids=new Uint8Array(keyids.length*16);for(var ix=0;ix<keyids.length;ix++){var k=keyids[ix];// uint8array
if(k.byteLength!==16){throw new RangeError('Invalid key');}kids.set(k,ix*16);}}else {version=0;kids=new Uint8Array();}var kidCount;if(version>0){kidCount=new Uint8Array(4);if(keyids.length>0){new DataView(kidCount.buffer).setUint32(0,keyids.length,false);}}else {kidCount=new Uint8Array();}var dataSize=new Uint8Array(4);if(data&&data.byteLength>0){new DataView(dataSize.buffer).setUint32(0,data.byteLength,false);}return mp4Box([112,115,115,104],new Uint8Array([version,0x00,0x00,0x00// Flags
]),systemId,// 16 bytes
kidCount,kids,dataSize,data||new Uint8Array());}function parseMultiPssh(initData){var results=[];if(initData instanceof ArrayBuffer){var length=initData.byteLength;var offset=0;while(offset+32<length){var view=new DataView(initData,offset);var pssh=parsePssh(view);results.push(pssh);offset+=pssh.size;}}return results;}function parsePssh(view){var size=view.getUint32(0);var offset=view.byteOffset;var length=view.byteLength;if(length<size){return {offset:offset,size:length};}var type=view.getUint32(4);if(type!==0x70737368){return {offset:offset,size:size};}var version=view.getUint32(8)>>>24;if(version!==0&&version!==1){return {offset:offset,size:size};}var buffer=view.buffer;var systemId=Hex.hexDump(new Uint8Array(buffer,offset+12,16));var dataSizeOrKidCount=view.getUint32(28);var kids=null;var data=null;if(version===0){if(size-32<dataSizeOrKidCount||dataSizeOrKidCount<22){return {offset:offset,size:size};}data=new Uint8Array(buffer,offset+32,dataSizeOrKidCount);}else if(version===1){if(!dataSizeOrKidCount||length<offset+32+dataSizeOrKidCount*16+16){return {offset:offset,size:size};}kids=[];for(var i=0;i<dataSizeOrKidCount;i++){kids.push(new Uint8Array(buffer,offset+32+i*16,16));}}return {version:version,systemId:systemId,kids:kids,data:data,offset:offset,size:size};}var keyUriToKeyIdMap={};var LevelKey=/*#__PURE__*/function(){function LevelKey(method,uri,format){var formatversions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[1];var iv=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;_classCallCheck(this,LevelKey);this.uri=void 0;this.method=void 0;this.keyFormat=void 0;this.keyFormatVersions=void 0;this.encrypted=void 0;this.isCommonEncryption=void 0;this.iv=null;this.key=null;this.keyId=null;this.pssh=null;this.method=method;this.uri=uri;this.keyFormat=format;this.keyFormatVersions=formatversions;this.iv=iv;this.encrypted=method?method!=='NONE':false;this.isCommonEncryption=this.encrypted&&method!=='AES-128';}_createClass(LevelKey,[{key:"isSupported",value:function isSupported(){// If it's Segment encryption or No encryption, just select that key system
if(this.method){if(this.method==='AES-128'||this.method==='NONE'){return true;}if(this.keyFormat==='identity'){// Maintain support for clear SAMPLE-AES with MPEG-3 TS
return this.method==='SAMPLE-AES';}else {switch(this.keyFormat){case KeySystemFormats.FAIRPLAY:case KeySystemFormats.WIDEVINE:case KeySystemFormats.PLAYREADY:case KeySystemFormats.CLEARKEY:return ['ISO-23001-7','SAMPLE-AES','SAMPLE-AES-CENC','SAMPLE-AES-CTR'].indexOf(this.method)!==-1;}}}return false;}},{key:"getDecryptData",value:function getDecryptData(sn){if(!this.encrypted||!this.uri){return null;}if(this.method==='AES-128'&&this.uri&&!this.iv){if(typeof sn!=='number'){// We are fetching decryption data for a initialization segment
// If the segment was encrypted with AES-128
// It must have an IV defined. We cannot substitute the Segment Number in.
if(this.method==='AES-128'&&!this.iv){logger.warn("missing IV for initialization segment with method=\"".concat(this.method,"\" - compliance issue"));}// Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
sn=0;}var iv=createInitializationVector(sn);var decryptdata=new LevelKey(this.method,this.uri,'identity',this.keyFormatVersions,iv);return decryptdata;}// Initialize keyId if possible
var keyBytes=convertDataUriToArrayBytes(this.uri);if(keyBytes){switch(this.keyFormat){case KeySystemFormats.WIDEVINE:this.pssh=keyBytes;// In case of widevine keyID is embedded in PSSH box. Read Key ID.
if(keyBytes.length>=22){this.keyId=keyBytes.subarray(keyBytes.length-22,keyBytes.length-6);}break;case KeySystemFormats.PLAYREADY:{var PlayReadyKeySystemUUID=new Uint8Array([0x9a,0x04,0xf0,0x79,0x98,0x40,0x42,0x86,0xab,0x92,0xe6,0x5b,0xe0,0x88,0x5f,0x95]);this.pssh=mp4pssh(PlayReadyKeySystemUUID,null,keyBytes);var keyBytesUtf16=new Uint16Array(keyBytes.buffer,keyBytes.byteOffset,keyBytes.byteLength/2);var keyByteStr=String.fromCharCode.apply(null,Array.from(keyBytesUtf16));// Parse Playready WRMHeader XML
var xmlKeyBytes=keyByteStr.substring(keyByteStr.indexOf('<'),keyByteStr.length);var parser=new DOMParser();var xmlDoc=parser.parseFromString(xmlKeyBytes,'text/xml');var keyData=xmlDoc.getElementsByTagName('KID')[0];if(keyData){var keyId=keyData.childNodes[0]?keyData.childNodes[0].nodeValue:keyData.getAttribute('VALUE');if(keyId){var keyIdArray=base64Decode(keyId).subarray(0,16);// KID value in PRO is a base64-encoded little endian GUID interpretation of UUID
// KID value in ‘tenc’ is a big endian UUID GUID interpretation of UUID
changeEndianness(keyIdArray);this.keyId=keyIdArray;}}break;}default:{var keydata=keyBytes.subarray(0,16);if(keydata.length!==16){var padded=new Uint8Array(16);padded.set(keydata,16-keydata.length);keydata=padded;}this.keyId=keydata;break;}}}// Default behavior: assign a new keyId for each uri
if(!this.keyId||this.keyId.byteLength!==16){var _keyId=keyUriToKeyIdMap[this.uri];if(!_keyId){var val=Object.keys(keyUriToKeyIdMap).length%Number.MAX_SAFE_INTEGER;_keyId=new Uint8Array(16);var dv=new DataView(_keyId.buffer,12,4);// Just set the last 4 bytes
dv.setUint32(0,val);keyUriToKeyIdMap[this.uri]=_keyId;}this.keyId=_keyId;}return this;}}],[{key:"clearKeyUriToKeyIdMap",value:function clearKeyUriToKeyIdMap(){keyUriToKeyIdMap={};}}]);return LevelKey;}();function createInitializationVector(segmentNumber){var uint8View=new Uint8Array(16);for(var i=12;i<16;i++){uint8View[i]=segmentNumber>>8*(15-i)&0xff;}return uint8View;}var VARIABLE_REPLACEMENT_REGEX=/\{\$([a-zA-Z0-9-_]+)\}/g;function hasVariableReferences(str){return VARIABLE_REPLACEMENT_REGEX.test(str);}function substituteVariablesInAttributes(parsed,attr,attributeNames){if(parsed.variableList!==null||parsed.hasVariableRefs){for(var i=attributeNames.length;i--;){var name=attributeNames[i];var value=attr[name];if(value){attr[name]=substituteVariables(parsed,value);}}}}function substituteVariables(parsed,value){if(parsed.variableList!==null||parsed.hasVariableRefs){var variableList=parsed.variableList;return value.replace(VARIABLE_REPLACEMENT_REGEX,function(variableReference){var variableName=variableReference.substring(2,variableReference.length-1);var variableValue=variableList==null?void 0:variableList[variableName];if(variableValue===undefined){parsed.playlistParsingError||(parsed.playlistParsingError=new Error("Missing preceding EXT-X-DEFINE tag for Variable Reference: \"".concat(variableName,"\"")));return variableReference;}return variableValue;});}return value;}function addVariableDefinition(parsed,attr,parentUrl){var variableList=parsed.variableList;if(!variableList){parsed.variableList=variableList={};}var NAME;var VALUE;if('QUERYPARAM'in attr){NAME=attr.QUERYPARAM;try{var searchParams=new self.URL(parentUrl).searchParams;if(searchParams.has(NAME)){VALUE=searchParams.get(NAME);}else {throw new Error("\"".concat(NAME,"\" does not match any query parameter in URI: \"").concat(parentUrl,"\""));}}catch(error){parsed.playlistParsingError||(parsed.playlistParsingError=new Error("EXT-X-DEFINE QUERYPARAM: ".concat(error.message)));}}else {NAME=attr.NAME;VALUE=attr.VALUE;}if(NAME in variableList){parsed.playlistParsingError||(parsed.playlistParsingError=new Error("EXT-X-DEFINE duplicate Variable Name declarations: \"".concat(NAME,"\"")));}else {variableList[NAME]=VALUE||'';}}function importVariableDefinition(parsed,attr,sourceVariableList){var IMPORT=attr.IMPORT;if(sourceVariableList&&IMPORT in sourceVariableList){var variableList=parsed.variableList;if(!variableList){parsed.variableList=variableList={};}variableList[IMPORT]=sourceVariableList[IMPORT];}else {parsed.playlistParsingError||(parsed.playlistParsingError=new Error("EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: \"".concat(IMPORT,"\"")));}}/**
 * MediaSource helper
 */function _getMediaSource(){var preferManagedMediaSource=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;if(typeof self==='undefined')return undefined;var mms=(preferManagedMediaSource||!self.MediaSource)&&self.ManagedMediaSource;return mms||self.MediaSource||self.WebKitMediaSource;}function isManagedMediaSource(source){return typeof self!=='undefined'&&source===self.ManagedMediaSource;}// from http://mp4ra.org/codecs.html
// values indicate codec selection preference (lower is higher priority)
var sampleEntryCodesISO={audio:{a3ds:1,'ac-3':0.95,'ac-4':1,alac:0.9,alaw:1,dra1:1,'dts+':1,'dts-':1,dtsc:1,dtse:1,dtsh:1,'ec-3':0.9,enca:1,fLaC:0.9,// MP4-RA listed codec entry for FLAC
flac:0.9,// legacy browser codec name for FLAC
FLAC:0.9,// some manifests may list "FLAC" with Apple's tools
g719:1,g726:1,m4ae:1,mha1:1,mha2:1,mhm1:1,mhm2:1,mlpa:1,mp4a:1,'raw ':1,Opus:1,opus:1,// browsers expect this to be lowercase despite MP4RA says 'Opus'
samr:1,sawb:1,sawp:1,sevc:1,sqcp:1,ssmv:1,twos:1,ulaw:1},video:{avc1:1,avc2:1,avc3:1,avc4:1,avcp:1,av01:0.8,drac:1,dva1:1,dvav:1,dvh1:0.7,dvhe:0.7,encv:1,hev1:0.75,hvc1:0.75,mjp2:1,mp4v:1,mvc1:1,mvc2:1,mvc3:1,mvc4:1,resv:1,rv60:1,s263:1,svc1:1,svc2:1,'vc-1':1,vp08:1,vp09:0.9},text:{stpp:1,wvtt:1}};function isCodecType(codec,type){var typeCodes=sampleEntryCodesISO[type];return !!typeCodes&&!!typeCodes[codec.slice(0,4)];}function areCodecsMediaSourceSupported(codecs,type){var preferManagedMediaSource=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return !codecs.split(',').some(function(codec){return !isCodecMediaSourceSupported(codec,type,preferManagedMediaSource);});}function isCodecMediaSourceSupported(codec,type){var preferManagedMediaSource=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var _MediaSource$isTypeSu;var MediaSource=_getMediaSource(preferManagedMediaSource);return (_MediaSource$isTypeSu=MediaSource==null?void 0:MediaSource.isTypeSupported(mimeTypeForCodec(codec,type)))!=null?_MediaSource$isTypeSu:false;}function mimeTypeForCodec(codec,type){return "".concat(type,"/mp4;codecs=\"").concat(codec,"\"");}function videoCodecPreferenceValue(videoCodec){if(videoCodec){var fourCC=videoCodec.substring(0,4);return sampleEntryCodesISO.video[fourCC];}return 2;}function codecsSetSelectionPreferenceValue(codecSet){return codecSet.split(',').reduce(function(num,fourCC){var preferenceValue=sampleEntryCodesISO.video[fourCC];if(preferenceValue){return (preferenceValue*2+num)/(num?3:2);}return (sampleEntryCodesISO.audio[fourCC]+num)/(num?2:1);},0);}var CODEC_COMPATIBLE_NAMES={};function getCodecCompatibleNameLower(lowerCaseCodec){var preferManagedMediaSource=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(CODEC_COMPATIBLE_NAMES[lowerCaseCodec]){return CODEC_COMPATIBLE_NAMES[lowerCaseCodec];}// Idealy fLaC and Opus would be first (spec-compliant) but
// some browsers will report that fLaC is supported then fail.
// see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
var codecsToCheck={flac:['flac','fLaC','FLAC'],opus:['opus','Opus']}[lowerCaseCodec];for(var i=0;i<codecsToCheck.length;i++){if(isCodecMediaSourceSupported(codecsToCheck[i],'audio',preferManagedMediaSource)){CODEC_COMPATIBLE_NAMES[lowerCaseCodec]=codecsToCheck[i];return codecsToCheck[i];}}return lowerCaseCodec;}var AUDIO_CODEC_REGEXP=/flac|opus/i;function getCodecCompatibleName(codec){var preferManagedMediaSource=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return codec.replace(AUDIO_CODEC_REGEXP,function(m){return getCodecCompatibleNameLower(m.toLowerCase(),preferManagedMediaSource);});}function pickMostCompleteCodecName(parsedCodec,levelCodec){// Parsing of mp4a codecs strings in mp4-tools from media is incomplete as of d8c6c7a
// so use level codec is parsed codec is unavailable or incomplete
if(parsedCodec&&parsedCodec!=='mp4a'){return parsedCodec;}return levelCodec?levelCodec.split(',')[0]:levelCodec;}function convertAVC1ToAVCOTI(codec){// Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
// Examples: avc1.66.30 to avc1.42001e and avc1.77.30,avc1.66.30 to avc1.4d001e,avc1.42001e.
var codecs=codec.split(',');for(var i=0;i<codecs.length;i++){var avcdata=codecs[i].split('.');if(avcdata.length>2){var result=avcdata.shift()+'.';result+=parseInt(avcdata.shift()).toString(16);result+=('000'+parseInt(avcdata.shift()).toString(16)).slice(-4);codecs[i]=result;}}return codecs.join(',');}var MASTER_PLAYLIST_REGEX=/#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;var MASTER_PLAYLIST_MEDIA_REGEX=/#EXT-X-MEDIA:(.*)/g;var IS_MEDIA_PLAYLIST=/^#EXT(?:INF|-X-TARGETDURATION):/m;// Handle empty Media Playlist (first EXTINF not signaled, but TARGETDURATION present)
var LEVEL_PLAYLIST_REGEX_FAST=new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,// duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
/(?!#) *(\S[^\r\n]*)/.source,// segment URI, group 3 => the URI (note newline is not eaten)
/#EXT-X-BYTERANGE:*(.+)/.source,// next segment's byterange, group 4 => range spec (x@y)
/#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,// next segment's program date/time group 5 => the datetime spec
/#.*/.source// All other non-segment oriented tags will match with all groups empty
].join('|'),'g');var LEVEL_PLAYLIST_REGEX_SLOW=new RegExp([/#(EXTM3U)/.source,/#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source,/#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source,/#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source,/(#)([^:]*):(.*)/.source,/(#)(.*)(?:.*)\r?\n?/.source].join('|'));var M3U8Parser=/*#__PURE__*/function(){function M3U8Parser(){_classCallCheck(this,M3U8Parser);}_createClass(M3U8Parser,null,[{key:"findGroup",value:function findGroup(groups,mediaGroupId){for(var i=0;i<groups.length;i++){var group=groups[i];if(group.id===mediaGroupId){return group;}}}},{key:"resolve",value:function resolve(url,baseUrl){return urlToolkitExports.buildAbsoluteURL(baseUrl,url,{alwaysNormalize:true});}},{key:"isMediaPlaylist",value:function isMediaPlaylist(str){return IS_MEDIA_PLAYLIST.test(str);}},{key:"parseMasterPlaylist",value:function parseMasterPlaylist(string,baseurl){var hasVariableRefs=hasVariableReferences(string);var parsed={contentSteering:null,levels:[],playlistParsingError:null,sessionData:null,sessionKeys:null,startTimeOffset:null,variableList:null,hasVariableRefs:hasVariableRefs};var levelsWithKnownCodecs=[];MASTER_PLAYLIST_REGEX.lastIndex=0;var result;while((result=MASTER_PLAYLIST_REGEX.exec(string))!=null){if(result[1]){var _level$unknownCodecs;// '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
var attrs=new AttrList(result[1]);{substituteVariablesInAttributes(parsed,attrs,['CODECS','SUPPLEMENTAL-CODECS','ALLOWED-CPC','PATHWAY-ID','STABLE-VARIANT-ID','AUDIO','VIDEO','SUBTITLES','CLOSED-CAPTIONS','NAME']);}var uri=substituteVariables(parsed,result[2]);var level={attrs:attrs,bitrate:attrs.decimalInteger('BANDWIDTH')||attrs.decimalInteger('AVERAGE-BANDWIDTH'),name:attrs.NAME,url:M3U8Parser.resolve(uri,baseurl)};var resolution=attrs.decimalResolution('RESOLUTION');if(resolution){level.width=resolution.width;level.height=resolution.height;}setCodecs(attrs.CODECS,level);if(!((_level$unknownCodecs=level.unknownCodecs)!=null&&_level$unknownCodecs.length)){levelsWithKnownCodecs.push(level);}parsed.levels.push(level);}else if(result[3]){var tag=result[3];var attributes=result[4];switch(tag){case'SESSION-DATA':{// #EXT-X-SESSION-DATA
var sessionAttrs=new AttrList(attributes);{substituteVariablesInAttributes(parsed,sessionAttrs,['DATA-ID','LANGUAGE','VALUE','URI']);}var dataId=sessionAttrs['DATA-ID'];if(dataId){if(parsed.sessionData===null){parsed.sessionData={};}parsed.sessionData[dataId]=sessionAttrs;}break;}case'SESSION-KEY':{// #EXT-X-SESSION-KEY
var sessionKey=parseKey(attributes,baseurl,parsed);if(sessionKey.encrypted&&sessionKey.isSupported()){if(parsed.sessionKeys===null){parsed.sessionKeys=[];}parsed.sessionKeys.push(sessionKey);}else {logger.warn("[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: \"".concat(attributes,"\""));}break;}case'DEFINE':{// #EXT-X-DEFINE
{var variableAttributes=new AttrList(attributes);substituteVariablesInAttributes(parsed,variableAttributes,['NAME','VALUE','QUERYPARAM']);addVariableDefinition(parsed,variableAttributes,baseurl);}break;}case'CONTENT-STEERING':{// #EXT-X-CONTENT-STEERING
var contentSteeringAttributes=new AttrList(attributes);{substituteVariablesInAttributes(parsed,contentSteeringAttributes,['SERVER-URI','PATHWAY-ID']);}parsed.contentSteering={uri:M3U8Parser.resolve(contentSteeringAttributes['SERVER-URI'],baseurl),pathwayId:contentSteeringAttributes['PATHWAY-ID']||'.'};break;}case'START':{// #EXT-X-START
parsed.startTimeOffset=parseStartTimeOffset(attributes);break;}}}}// Filter out levels with unknown codecs if it does not remove all levels
var stripUnknownCodecLevels=levelsWithKnownCodecs.length>0&&levelsWithKnownCodecs.length<parsed.levels.length;parsed.levels=stripUnknownCodecLevels?levelsWithKnownCodecs:parsed.levels;if(parsed.levels.length===0){parsed.playlistParsingError=new Error('no levels found in manifest');}return parsed;}},{key:"parseMasterPlaylistMedia",value:function parseMasterPlaylistMedia(string,baseurl,parsed){var result;var results={};var levels=parsed.levels;var groupsByType={AUDIO:levels.map(function(level){return {id:level.attrs.AUDIO,audioCodec:level.audioCodec};}),SUBTITLES:levels.map(function(level){return {id:level.attrs.SUBTITLES,textCodec:level.textCodec};}),'CLOSED-CAPTIONS':[]};var id=0;MASTER_PLAYLIST_MEDIA_REGEX.lastIndex=0;while((result=MASTER_PLAYLIST_MEDIA_REGEX.exec(string))!==null){var attrs=new AttrList(result[1]);var type=attrs.TYPE;if(type){var groups=groupsByType[type];var medias=results[type]||[];results[type]=medias;{substituteVariablesInAttributes(parsed,attrs,['URI','GROUP-ID','LANGUAGE','ASSOC-LANGUAGE','STABLE-RENDITION-ID','NAME','INSTREAM-ID','CHARACTERISTICS','CHANNELS']);}var lang=attrs.LANGUAGE;var assocLang=attrs['ASSOC-LANGUAGE'];var channels=attrs.CHANNELS;var characteristics=attrs.CHARACTERISTICS;var instreamId=attrs['INSTREAM-ID'];var media={attrs:attrs,bitrate:0,id:id++,groupId:attrs['GROUP-ID']||'',name:attrs.NAME||lang||'',type:type,"default":attrs.bool('DEFAULT'),autoselect:attrs.bool('AUTOSELECT'),forced:attrs.bool('FORCED'),lang:lang,url:attrs.URI?M3U8Parser.resolve(attrs.URI,baseurl):''};if(assocLang){media.assocLang=assocLang;}if(channels){media.channels=channels;}if(characteristics){media.characteristics=characteristics;}if(instreamId){media.instreamId=instreamId;}if(groups!=null&&groups.length){// If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
// If we don't find the track signalled, lets use the first audio groups codec we have
// Acting as a best guess
var groupCodec=M3U8Parser.findGroup(groups,media.groupId)||groups[0];assignCodec(media,groupCodec,'audioCodec');assignCodec(media,groupCodec,'textCodec');}medias.push(media);}}return results;}},{key:"parseLevelPlaylist",value:function parseLevelPlaylist(string,baseurl,id,type,levelUrlId,multivariantVariableList){var level=new LevelDetails(baseurl);var fragments=level.fragments;// The most recent init segment seen (applies to all subsequent segments)
var currentInitSegment=null;var currentSN=0;var currentPart=0;var totalduration=0;var discontinuityCounter=0;var prevFrag=null;var frag=new Fragment(type,baseurl);var result;var i;var levelkeys;var firstPdtIndex=-1;var createNextFrag=false;var nextByteRange=null;LEVEL_PLAYLIST_REGEX_FAST.lastIndex=0;level.m3u8=string;level.hasVariableRefs=hasVariableReferences(string);while((result=LEVEL_PLAYLIST_REGEX_FAST.exec(string))!==null){if(createNextFrag){createNextFrag=false;frag=new Fragment(type,baseurl);// setup the next fragment for part loading
frag.start=totalduration;frag.sn=currentSN;frag.cc=discontinuityCounter;frag.level=id;if(currentInitSegment){frag.initSegment=currentInitSegment;frag.rawProgramDateTime=currentInitSegment.rawProgramDateTime;currentInitSegment.rawProgramDateTime=null;if(nextByteRange){frag.setByteRange(nextByteRange);nextByteRange=null;}}}var duration=result[1];if(duration){// INF
frag.duration=parseFloat(duration);// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
var title=(' '+result[2]).slice(1);frag.title=title||null;frag.tagList.push(title?['INF',duration,title]:['INF',duration]);}else if(result[3]){// url
if(isFiniteNumber(frag.duration)){frag.start=totalduration;if(levelkeys){setFragLevelKeys(frag,levelkeys,level);}frag.sn=currentSN;frag.level=id;frag.cc=discontinuityCounter;fragments.push(frag);// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
var uri=(' '+result[3]).slice(1);frag.relurl=substituteVariables(level,uri);assignProgramDateTime(frag,prevFrag);prevFrag=frag;totalduration+=frag.duration;currentSN++;currentPart=0;createNextFrag=true;}}else if(result[4]){// X-BYTERANGE
var data=(' '+result[4]).slice(1);if(prevFrag){frag.setByteRange(data,prevFrag);}else {frag.setByteRange(data);}}else if(result[5]){// PROGRAM-DATE-TIME
// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
frag.rawProgramDateTime=(' '+result[5]).slice(1);frag.tagList.push(['PROGRAM-DATE-TIME',frag.rawProgramDateTime]);if(firstPdtIndex===-1){firstPdtIndex=fragments.length;}}else {result=result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);if(!result){logger.warn('No matches on slow regex match for level playlist!');continue;}for(i=1;i<result.length;i++){if(typeof result[i]!=='undefined'){break;}}// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
var tag=(' '+result[i]).slice(1);var value1=(' '+result[i+1]).slice(1);var value2=result[i+2]?(' '+result[i+2]).slice(1):'';switch(tag){case'PLAYLIST-TYPE':level.type=value1.toUpperCase();break;case'MEDIA-SEQUENCE':currentSN=level.startSN=parseInt(value1);break;case'SKIP':{var skipAttrs=new AttrList(value1);{substituteVariablesInAttributes(level,skipAttrs,['RECENTLY-REMOVED-DATERANGES']);}var skippedSegments=skipAttrs.decimalInteger('SKIPPED-SEGMENTS');if(isFiniteNumber(skippedSegments)){level.skippedSegments=skippedSegments;// This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
for(var _i=skippedSegments;_i--;){fragments.unshift(null);}currentSN+=skippedSegments;}var recentlyRemovedDateranges=skipAttrs.enumeratedString('RECENTLY-REMOVED-DATERANGES');if(recentlyRemovedDateranges){level.recentlyRemovedDateranges=recentlyRemovedDateranges.split('\t');}break;}case'TARGETDURATION':level.targetduration=Math.max(parseInt(value1),1);break;case'VERSION':level.version=parseInt(value1);break;case'INDEPENDENT-SEGMENTS':case'EXTM3U':break;case'ENDLIST':level.live=false;break;case'#':if(value1||value2){frag.tagList.push(value2?[value1,value2]:[value1]);}break;case'DISCONTINUITY':discontinuityCounter++;frag.tagList.push(['DIS']);break;case'GAP':frag.gap=true;frag.tagList.push([tag]);break;case'BITRATE':frag.tagList.push([tag,value1]);break;case'DATERANGE':{var dateRangeAttr=new AttrList(value1);{substituteVariablesInAttributes(level,dateRangeAttr,['ID','CLASS','START-DATE','END-DATE','SCTE35-CMD','SCTE35-OUT','SCTE35-IN']);substituteVariablesInAttributes(level,dateRangeAttr,dateRangeAttr.clientAttrs);}var dateRange=new DateRange(dateRangeAttr,level.dateRanges[dateRangeAttr.ID]);if(dateRange.isValid||level.skippedSegments){level.dateRanges[dateRange.id]=dateRange;}else {logger.warn("Ignoring invalid DATERANGE tag: \"".concat(value1,"\""));}// Add to fragment tag list for backwards compatibility (< v1.2.0)
frag.tagList.push(['EXT-X-DATERANGE',value1]);break;}case'DEFINE':{{var variableAttributes=new AttrList(value1);substituteVariablesInAttributes(level,variableAttributes,['NAME','VALUE','IMPORT','QUERYPARAM']);if('IMPORT'in variableAttributes){importVariableDefinition(level,variableAttributes,multivariantVariableList);}else {addVariableDefinition(level,variableAttributes,baseurl);}}break;}case'DISCONTINUITY-SEQUENCE':discontinuityCounter=parseInt(value1);break;case'KEY':{var levelKey=parseKey(value1,baseurl,level);if(levelKey.isSupported()){if(levelKey.method==='NONE'){levelkeys=undefined;break;}if(!levelkeys){levelkeys={};}if(levelkeys[levelKey.keyFormat]){levelkeys=_extends({},levelkeys);}levelkeys[levelKey.keyFormat]=levelKey;}else {logger.warn("[Keys] Ignoring invalid EXT-X-KEY tag: \"".concat(value1,"\""));}break;}case'START':level.startTimeOffset=parseStartTimeOffset(value1);break;case'MAP':{var mapAttrs=new AttrList(value1);{substituteVariablesInAttributes(level,mapAttrs,['BYTERANGE','URI']);}if(frag.duration){// Initial segment tag is after segment duration tag.
//   #EXTINF: 6.0
//   #EXT-X-MAP:URI="init.mp4
var init=new Fragment(type,baseurl);setInitSegment(init,mapAttrs,id,levelkeys);currentInitSegment=init;frag.initSegment=currentInitSegment;if(currentInitSegment.rawProgramDateTime&&!frag.rawProgramDateTime){frag.rawProgramDateTime=currentInitSegment.rawProgramDateTime;}}else {// Initial segment tag is before segment duration tag
// Handle case where EXT-X-MAP is declared after EXT-X-BYTERANGE
var end=frag.byteRangeEndOffset;if(end){var start=frag.byteRangeStartOffset;nextByteRange="".concat(end-start,"@").concat(start);}else {nextByteRange=null;}setInitSegment(frag,mapAttrs,id,levelkeys);currentInitSegment=frag;createNextFrag=true;}break;}case'SERVER-CONTROL':{var serverControlAttrs=new AttrList(value1);level.canBlockReload=serverControlAttrs.bool('CAN-BLOCK-RELOAD');level.canSkipUntil=serverControlAttrs.optionalFloat('CAN-SKIP-UNTIL',0);level.canSkipDateRanges=level.canSkipUntil>0&&serverControlAttrs.bool('CAN-SKIP-DATERANGES');level.partHoldBack=serverControlAttrs.optionalFloat('PART-HOLD-BACK',0);level.holdBack=serverControlAttrs.optionalFloat('HOLD-BACK',0);break;}case'PART-INF':{var partInfAttrs=new AttrList(value1);level.partTarget=partInfAttrs.decimalFloatingPoint('PART-TARGET');break;}case'PART':{var partList=level.partList;if(!partList){partList=level.partList=[];}var previousFragmentPart=currentPart>0?partList[partList.length-1]:undefined;var index=currentPart++;var partAttrs=new AttrList(value1);{substituteVariablesInAttributes(level,partAttrs,['BYTERANGE','URI']);}var part=new Part(partAttrs,frag,baseurl,index,previousFragmentPart);partList.push(part);frag.duration+=part.duration;break;}case'PRELOAD-HINT':{var preloadHintAttrs=new AttrList(value1);{substituteVariablesInAttributes(level,preloadHintAttrs,['URI']);}level.preloadHint=preloadHintAttrs;break;}case'RENDITION-REPORT':{var renditionReportAttrs=new AttrList(value1);{substituteVariablesInAttributes(level,renditionReportAttrs,['URI']);}level.renditionReports=level.renditionReports||[];level.renditionReports.push(renditionReportAttrs);break;}default:logger.warn("line parsed but not handled: ".concat(result));break;}}}if(prevFrag&&!prevFrag.relurl){fragments.pop();totalduration-=prevFrag.duration;if(level.partList){level.fragmentHint=prevFrag;}}else if(level.partList){assignProgramDateTime(frag,prevFrag);frag.cc=discontinuityCounter;level.fragmentHint=frag;if(levelkeys){setFragLevelKeys(frag,levelkeys,level);}}var fragmentLength=fragments.length;var firstFragment=fragments[0];var lastFragment=fragments[fragmentLength-1];totalduration+=level.skippedSegments*level.targetduration;if(totalduration>0&&fragmentLength&&lastFragment){level.averagetargetduration=totalduration/fragmentLength;var lastSn=lastFragment.sn;level.endSN=lastSn!=='initSegment'?lastSn:0;if(!level.live){lastFragment.endList=true;}if(firstFragment){level.startCC=firstFragment.cc;}}else {level.endSN=0;level.startCC=0;}if(level.fragmentHint){totalduration+=level.fragmentHint.duration;}level.totalduration=totalduration;level.endCC=discontinuityCounter;/**
     * Backfill any missing PDT values
     * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
     * one or more Media Segment URIs, the client SHOULD extrapolate
     * backward from that tag (using EXTINF durations and/or media
     * timestamps) to associate dates with those segments."
     * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
     * computed.
     */if(firstPdtIndex>0){backfillProgramDateTimes(fragments,firstPdtIndex);}return level;}}]);return M3U8Parser;}();function parseKey(keyTagAttributes,baseurl,parsed){var _keyAttrs$METHOD,_keyAttrs$KEYFORMAT;// https://tools.ietf.org/html/rfc8216#section-4.3.2.4
var keyAttrs=new AttrList(keyTagAttributes);{substituteVariablesInAttributes(parsed,keyAttrs,['KEYFORMAT','KEYFORMATVERSIONS','URI','IV','URI']);}var decryptmethod=(_keyAttrs$METHOD=keyAttrs.METHOD)!=null?_keyAttrs$METHOD:'';var decrypturi=keyAttrs.URI;var decryptiv=keyAttrs.hexadecimalInteger('IV');var decryptkeyformatversions=keyAttrs.KEYFORMATVERSIONS;// From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
var decryptkeyformat=(_keyAttrs$KEYFORMAT=keyAttrs.KEYFORMAT)!=null?_keyAttrs$KEYFORMAT:'identity';if(decrypturi&&keyAttrs.IV&&!decryptiv){logger.error("Invalid IV: ".concat(keyAttrs.IV));}// If decrypturi is a URI with a scheme, then baseurl will be ignored
// No uri is allowed when METHOD is NONE
var resolvedUri=decrypturi?M3U8Parser.resolve(decrypturi,baseurl):'';var keyFormatVersions=(decryptkeyformatversions?decryptkeyformatversions:'1').split('/').map(Number).filter(Number.isFinite);return new LevelKey(decryptmethod,resolvedUri,decryptkeyformat,keyFormatVersions,decryptiv);}function parseStartTimeOffset(startAttributes){var startAttrs=new AttrList(startAttributes);var startTimeOffset=startAttrs.decimalFloatingPoint('TIME-OFFSET');if(isFiniteNumber(startTimeOffset)){return startTimeOffset;}return null;}function setCodecs(codecsAttributeValue,level){var codecs=(codecsAttributeValue||'').split(/[ ,]+/).filter(function(c){return c;});['video','audio','text'].forEach(function(type){var filtered=codecs.filter(function(codec){return isCodecType(codec,type);});if(filtered.length){// Comma separated list of all codecs for type
level["".concat(type,"Codec")]=filtered.join(',');// Remove known codecs so that only unknownCodecs are left after iterating through each type
codecs=codecs.filter(function(codec){return filtered.indexOf(codec)===-1;});}});level.unknownCodecs=codecs;}function assignCodec(media,groupItem,codecProperty){var codecValue=groupItem[codecProperty];if(codecValue){media[codecProperty]=codecValue;}}function backfillProgramDateTimes(fragments,firstPdtIndex){var fragPrev=fragments[firstPdtIndex];for(var i=firstPdtIndex;i--;){var frag=fragments[i];// Exit on delta-playlist skipped segments
if(!frag){return;}frag.programDateTime=fragPrev.programDateTime-frag.duration*1000;fragPrev=frag;}}function assignProgramDateTime(frag,prevFrag){if(frag.rawProgramDateTime){frag.programDateTime=Date.parse(frag.rawProgramDateTime);}else if(prevFrag!=null&&prevFrag.programDateTime){frag.programDateTime=prevFrag.endProgramDateTime;}if(!isFiniteNumber(frag.programDateTime)){frag.programDateTime=null;frag.rawProgramDateTime=null;}}function setInitSegment(frag,mapAttrs,id,levelkeys){frag.relurl=mapAttrs.URI;if(mapAttrs.BYTERANGE){frag.setByteRange(mapAttrs.BYTERANGE);}frag.level=id;frag.sn='initSegment';if(levelkeys){frag.levelkeys=levelkeys;}frag.initSegment=null;}function setFragLevelKeys(frag,levelkeys,level){frag.levelkeys=levelkeys;var encryptedFragments=level.encryptedFragments;if((!encryptedFragments.length||encryptedFragments[encryptedFragments.length-1].levelkeys!==levelkeys)&&Object.keys(levelkeys).some(function(format){return levelkeys[format].isCommonEncryption;})){encryptedFragments.push(frag);}}var PlaylistContextType={MANIFEST:"manifest",LEVEL:"level",AUDIO_TRACK:"audioTrack",SUBTITLE_TRACK:"subtitleTrack"};var PlaylistLevelType={MAIN:"main",AUDIO:"audio",SUBTITLE:"subtitle"};function mapContextToLevelType(context){var type=context.type;switch(type){case PlaylistContextType.AUDIO_TRACK:return PlaylistLevelType.AUDIO;case PlaylistContextType.SUBTITLE_TRACK:return PlaylistLevelType.SUBTITLE;default:return PlaylistLevelType.MAIN;}}function getResponseUrl(response,context){var url=response.url;// responseURL not supported on some browsers (it is used to detect URL redirection)
// data-uri mode also not supported (but no need to detect redirection)
if(url===undefined||url.indexOf('data:')===0){// fallback to initial URL
url=context.url;}return url;}var PlaylistLoader=/*#__PURE__*/function(){function PlaylistLoader(hls){_classCallCheck(this,PlaylistLoader);this.hls=void 0;this.loaders=Object.create(null);this.variableList=null;this.hls=hls;this.registerListeners();}_createClass(PlaylistLoader,[{key:"startLoad",value:function startLoad(startPosition){}},{key:"stopLoad",value:function stopLoad(){this.destroyInternalLoaders();}},{key:"registerListeners",value:function registerListeners(){var hls=this.hls;hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.LEVEL_LOADING,this.onLevelLoading,this);hls.on(Events.AUDIO_TRACK_LOADING,this.onAudioTrackLoading,this);hls.on(Events.SUBTITLE_TRACK_LOADING,this.onSubtitleTrackLoading,this);}},{key:"unregisterListeners",value:function unregisterListeners(){var hls=this.hls;hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.LEVEL_LOADING,this.onLevelLoading,this);hls.off(Events.AUDIO_TRACK_LOADING,this.onAudioTrackLoading,this);hls.off(Events.SUBTITLE_TRACK_LOADING,this.onSubtitleTrackLoading,this);}/**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */},{key:"createInternalLoader",value:function createInternalLoader(context){var config=this.hls.config;var PLoader=config.pLoader;var Loader=config.loader;var InternalLoader=PLoader||Loader;var loader=new InternalLoader(config);this.loaders[context.type]=loader;return loader;}},{key:"getInternalLoader",value:function getInternalLoader(context){return this.loaders[context.type];}},{key:"resetInternalLoader",value:function resetInternalLoader(contextType){if(this.loaders[contextType]){delete this.loaders[contextType];}}/**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */},{key:"destroyInternalLoaders",value:function destroyInternalLoaders(){for(var contextType in this.loaders){var loader=this.loaders[contextType];if(loader){loader.destroy();}this.resetInternalLoader(contextType);}}},{key:"destroy",value:function destroy(){this.variableList=null;this.unregisterListeners();this.destroyInternalLoaders();}},{key:"onManifestLoading",value:function onManifestLoading(event,data){var url=data.url;this.variableList=null;this.load({id:null,level:0,responseType:'text',type:PlaylistContextType.MANIFEST,url:url,deliveryDirectives:null});}},{key:"onLevelLoading",value:function onLevelLoading(event,data){var id=data.id,level=data.level,pathwayId=data.pathwayId,url=data.url,deliveryDirectives=data.deliveryDirectives;this.load({id:id,level:level,pathwayId:pathwayId,responseType:'text',type:PlaylistContextType.LEVEL,url:url,deliveryDirectives:deliveryDirectives});}},{key:"onAudioTrackLoading",value:function onAudioTrackLoading(event,data){var id=data.id,groupId=data.groupId,url=data.url,deliveryDirectives=data.deliveryDirectives;this.load({id:id,groupId:groupId,level:null,responseType:'text',type:PlaylistContextType.AUDIO_TRACK,url:url,deliveryDirectives:deliveryDirectives});}},{key:"onSubtitleTrackLoading",value:function onSubtitleTrackLoading(event,data){var id=data.id,groupId=data.groupId,url=data.url,deliveryDirectives=data.deliveryDirectives;this.load({id:id,groupId:groupId,level:null,responseType:'text',type:PlaylistContextType.SUBTITLE_TRACK,url:url,deliveryDirectives:deliveryDirectives});}},{key:"load",value:function load(context){var _this4=this;var _context$deliveryDire;var config=this.hls.config;// logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);
// Check if a loader for this context already exists
var loader=this.getInternalLoader(context);if(loader){var loaderContext=loader.context;if(loaderContext&&loaderContext.url===context.url&&loaderContext.level===context.level){// same URL can't overlap
logger.trace('[playlist-loader]: playlist request ongoing');return;}logger.log("[playlist-loader]: aborting previous loader for type: ".concat(context.type));loader.abort();}// apply different configs for retries depending on
// context (manifest, level, audio/subs playlist)
var loadPolicy;if(context.type===PlaylistContextType.MANIFEST){loadPolicy=config.manifestLoadPolicy["default"];}else {loadPolicy=_extends({},config.playlistLoadPolicy["default"],{timeoutRetry:null,errorRetry:null});}loader=this.createInternalLoader(context);// Override level/track timeout for LL-HLS requests
// (the default of 10000ms is counter productive to blocking playlist reload requests)
if(isFiniteNumber((_context$deliveryDire=context.deliveryDirectives)==null?void 0:_context$deliveryDire.part)){var levelDetails;if(context.type===PlaylistContextType.LEVEL&&context.level!==null){levelDetails=this.hls.levels[context.level].details;}else if(context.type===PlaylistContextType.AUDIO_TRACK&&context.id!==null){levelDetails=this.hls.audioTracks[context.id].details;}else if(context.type===PlaylistContextType.SUBTITLE_TRACK&&context.id!==null){levelDetails=this.hls.subtitleTracks[context.id].details;}if(levelDetails){var partTarget=levelDetails.partTarget;var targetDuration=levelDetails.targetduration;if(partTarget&&targetDuration){var maxLowLatencyPlaylistRefresh=Math.max(partTarget*3,targetDuration*0.8)*1000;loadPolicy=_extends({},loadPolicy,{maxTimeToFirstByteMs:Math.min(maxLowLatencyPlaylistRefresh,loadPolicy.maxTimeToFirstByteMs),maxLoadTimeMs:Math.min(maxLowLatencyPlaylistRefresh,loadPolicy.maxTimeToFirstByteMs)});}}}var legacyRetryCompatibility=loadPolicy.errorRetry||loadPolicy.timeoutRetry||{};var loaderConfig={loadPolicy:loadPolicy,timeout:loadPolicy.maxLoadTimeMs,maxRetry:legacyRetryCompatibility.maxNumRetry||0,retryDelay:legacyRetryCompatibility.retryDelayMs||0,maxRetryDelay:legacyRetryCompatibility.maxRetryDelayMs||0};var loaderCallbacks={onSuccess:function onSuccess(response,stats,context,networkDetails){var loader=_this4.getInternalLoader(context);_this4.resetInternalLoader(context.type);var string=response.data;// Validate if it is an M3U8 at all
if(string.indexOf('#EXTM3U')!==0){_this4.handleManifestParsingError(response,context,new Error('no EXTM3U delimiter'),networkDetails||null,stats);return;}stats.parsing.start=performance.now();if(M3U8Parser.isMediaPlaylist(string)){_this4.handleTrackOrLevelPlaylist(response,stats,context,networkDetails||null,loader);}else {_this4.handleMasterPlaylist(response,stats,context,networkDetails);}},onError:function onError(response,context,networkDetails,stats){_this4.handleNetworkError(context,networkDetails,false,response,stats);},onTimeout:function onTimeout(stats,context,networkDetails){_this4.handleNetworkError(context,networkDetails,true,undefined,stats);}};// logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);
loader.load(context,loaderConfig,loaderCallbacks);}},{key:"handleMasterPlaylist",value:function handleMasterPlaylist(response,stats,context,networkDetails){var hls=this.hls;var string=response.data;var url=getResponseUrl(response,context);var parsedResult=M3U8Parser.parseMasterPlaylist(string,url);if(parsedResult.playlistParsingError){this.handleManifestParsingError(response,context,parsedResult.playlistParsingError,networkDetails,stats);return;}var contentSteering=parsedResult.contentSteering,levels=parsedResult.levels,sessionData=parsedResult.sessionData,sessionKeys=parsedResult.sessionKeys,startTimeOffset=parsedResult.startTimeOffset,variableList=parsedResult.variableList;this.variableList=variableList;var _M3U8Parser$parseMast=M3U8Parser.parseMasterPlaylistMedia(string,url,parsedResult),_M3U8Parser$parseMast2=_M3U8Parser$parseMast.AUDIO,audioTracks=_M3U8Parser$parseMast2===void 0?[]:_M3U8Parser$parseMast2,subtitles=_M3U8Parser$parseMast.SUBTITLES,captions=_M3U8Parser$parseMast['CLOSED-CAPTIONS'];if(audioTracks.length){// check if we have found an audio track embedded in main playlist (audio track without URI attribute)
var embeddedAudioFound=audioTracks.some(function(audioTrack){return !audioTrack.url;});// if no embedded audio track defined, but audio codec signaled in quality level,
// we need to signal this main audio track this could happen with playlists with
// alt audio rendition in which quality levels (main)
// contains both audio+video. but with mixed audio track not signaled
if(!embeddedAudioFound&&levels[0].audioCodec&&!levels[0].attrs.AUDIO){logger.log('[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one');audioTracks.unshift({type:'main',name:'main',groupId:'main',"default":false,autoselect:false,forced:false,id:-1,attrs:new AttrList({}),bitrate:0,url:''});}}hls.trigger(Events.MANIFEST_LOADED,{levels:levels,audioTracks:audioTracks,subtitles:subtitles,captions:captions,contentSteering:contentSteering,url:url,stats:stats,networkDetails:networkDetails,sessionData:sessionData,sessionKeys:sessionKeys,startTimeOffset:startTimeOffset,variableList:variableList});}},{key:"handleTrackOrLevelPlaylist",value:function handleTrackOrLevelPlaylist(response,stats,context,networkDetails,loader){var hls=this.hls;var id=context.id,level=context.level,type=context.type;var url=getResponseUrl(response,context);var levelUrlId=0;var levelId=isFiniteNumber(level)?level:isFiniteNumber(id)?id:0;var levelType=mapContextToLevelType(context);var levelDetails=M3U8Parser.parseLevelPlaylist(response.data,url,levelId,levelType,levelUrlId,this.variableList);// We have done our first request (Manifest-type) and receive
// not a master playlist but a chunk-list (track/level)
// We fire the manifest-loaded event anyway with the parsed level-details
// by creating a single-level structure for it.
if(type===PlaylistContextType.MANIFEST){var singleLevel={attrs:new AttrList({}),bitrate:0,details:levelDetails,name:'',url:url};hls.trigger(Events.MANIFEST_LOADED,{levels:[singleLevel],audioTracks:[],url:url,stats:stats,networkDetails:networkDetails,sessionData:null,sessionKeys:null,contentSteering:null,startTimeOffset:null,variableList:null});}// save parsing time
stats.parsing.end=performance.now();// extend the context with the new levelDetails property
context.levelDetails=levelDetails;this.handlePlaylistLoaded(levelDetails,response,stats,context,networkDetails,loader);}},{key:"handleManifestParsingError",value:function handleManifestParsingError(response,context,error,networkDetails,stats){this.hls.trigger(Events.ERROR,{type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.MANIFEST_PARSING_ERROR,fatal:context.type===PlaylistContextType.MANIFEST,url:response.url,err:error,error:error,reason:error.message,response:response,context:context,networkDetails:networkDetails,stats:stats});}},{key:"handleNetworkError",value:function handleNetworkError(context,networkDetails){var timeout=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var response=arguments.length>3?arguments[3]:undefined;var stats=arguments.length>4?arguments[4]:undefined;var message="A network ".concat(timeout?'timeout':'error'+(response?' (status '+response.code+')':'')," occurred while loading ").concat(context.type);if(context.type===PlaylistContextType.LEVEL){message+=": ".concat(context.level," id: ").concat(context.id);}else if(context.type===PlaylistContextType.AUDIO_TRACK||context.type===PlaylistContextType.SUBTITLE_TRACK){message+=" id: ".concat(context.id," group-id: \"").concat(context.groupId,"\"");}var error=new Error(message);logger.warn("[playlist-loader]: ".concat(message));var details=ErrorDetails.UNKNOWN;var fatal=false;var loader=this.getInternalLoader(context);switch(context.type){case PlaylistContextType.MANIFEST:details=timeout?ErrorDetails.MANIFEST_LOAD_TIMEOUT:ErrorDetails.MANIFEST_LOAD_ERROR;fatal=true;break;case PlaylistContextType.LEVEL:details=timeout?ErrorDetails.LEVEL_LOAD_TIMEOUT:ErrorDetails.LEVEL_LOAD_ERROR;fatal=false;break;case PlaylistContextType.AUDIO_TRACK:details=timeout?ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:ErrorDetails.AUDIO_TRACK_LOAD_ERROR;fatal=false;break;case PlaylistContextType.SUBTITLE_TRACK:details=timeout?ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:ErrorDetails.SUBTITLE_LOAD_ERROR;fatal=false;break;}if(loader){this.resetInternalLoader(context.type);}var errorData={type:ErrorTypes.NETWORK_ERROR,details:details,fatal:fatal,url:context.url,loader:loader,context:context,error:error,networkDetails:networkDetails,stats:stats};if(response){var url=(networkDetails==null?void 0:networkDetails.url)||context.url;errorData.response=_objectSpread2$2({url:url,data:undefined},response);}this.hls.trigger(Events.ERROR,errorData);}},{key:"handlePlaylistLoaded",value:function handlePlaylistLoaded(levelDetails,response,stats,context,networkDetails,loader){var hls=this.hls;var type=context.type,level=context.level,id=context.id,groupId=context.groupId,deliveryDirectives=context.deliveryDirectives;var url=getResponseUrl(response,context);var parent=mapContextToLevelType(context);var levelIndex=typeof context.level==='number'&&parent===PlaylistLevelType.MAIN?level:undefined;if(!levelDetails.fragments.length){var _error=new Error('No Segments found in Playlist');hls.trigger(Events.ERROR,{type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.LEVEL_EMPTY_ERROR,fatal:false,url:url,error:_error,reason:_error.message,response:response,context:context,level:levelIndex,parent:parent,networkDetails:networkDetails,stats:stats});return;}if(!levelDetails.targetduration){levelDetails.playlistParsingError=new Error('Missing Target Duration');}var error=levelDetails.playlistParsingError;if(error){hls.trigger(Events.ERROR,{type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.LEVEL_PARSING_ERROR,fatal:false,url:url,error:error,reason:error.message,response:response,context:context,level:levelIndex,parent:parent,networkDetails:networkDetails,stats:stats});return;}if(levelDetails.live&&loader){if(loader.getCacheAge){levelDetails.ageHeader=loader.getCacheAge()||0;}if(!loader.getCacheAge||isNaN(levelDetails.ageHeader)){levelDetails.ageHeader=0;}}switch(type){case PlaylistContextType.MANIFEST:case PlaylistContextType.LEVEL:hls.trigger(Events.LEVEL_LOADED,{details:levelDetails,level:levelIndex||0,id:id||0,stats:stats,networkDetails:networkDetails,deliveryDirectives:deliveryDirectives});break;case PlaylistContextType.AUDIO_TRACK:hls.trigger(Events.AUDIO_TRACK_LOADED,{details:levelDetails,id:id||0,groupId:groupId||'',stats:stats,networkDetails:networkDetails,deliveryDirectives:deliveryDirectives});break;case PlaylistContextType.SUBTITLE_TRACK:hls.trigger(Events.SUBTITLE_TRACK_LOADED,{details:levelDetails,id:id||0,groupId:groupId||'',stats:stats,networkDetails:networkDetails,deliveryDirectives:deliveryDirectives});break;}}}]);return PlaylistLoader;}();function sendAddTrackEvent(track,videoEl){var event;try{event=new Event('addtrack');}catch(err){// for IE11
event=document.createEvent('Event');event.initEvent('addtrack',false,false);}event.track=track;videoEl.dispatchEvent(event);}function addCueToTrack(track,cue){// Sometimes there are cue overlaps on segmented vtts so the same
// cue can appear more than once in different vtt files.
// This avoid showing duplicated cues with same timecode and text.
var mode=track.mode;if(mode==='disabled'){track.mode='hidden';}if(track.cues&&!track.cues.getCueById(cue.id)){try{track.addCue(cue);if(!track.cues.getCueById(cue.id)){throw new Error("addCue is failed for: ".concat(cue));}}catch(err){logger.debug("[texttrack-utils]: ".concat(err));try{var textTrackCue=new self.TextTrackCue(cue.startTime,cue.endTime,cue.text);textTrackCue.id=cue.id;track.addCue(textTrackCue);}catch(err2){logger.debug("[texttrack-utils]: Legacy TextTrackCue fallback failed: ".concat(err2));}}}if(mode==='disabled'){track.mode=mode;}}function clearCurrentCues(track){// When track.mode is disabled, track.cues will be null.
// To guarantee the removal of cues, we need to temporarily
// change the mode to hidden
var mode=track.mode;if(mode==='disabled'){track.mode='hidden';}if(track.cues){for(var i=track.cues.length;i--;){track.removeCue(track.cues[i]);}}if(mode==='disabled'){track.mode=mode;}}function removeCuesInRange(track,start,end,predicate){var mode=track.mode;if(mode==='disabled'){track.mode='hidden';}if(track.cues&&track.cues.length>0){var cues=getCuesInRange(track.cues,start,end);for(var i=0;i<cues.length;i++){if(!predicate||predicate(cues[i])){track.removeCue(cues[i]);}}}if(mode==='disabled'){track.mode=mode;}}// Find first cue starting after given time.
// Modified version of binary search O(log(n)).
function getFirstCueIndexAfterTime(cues,time){// If first cue starts after time, start there
if(time<cues[0].startTime){return 0;}// If the last cue ends before time there is no overlap
var len=cues.length-1;if(time>cues[len].endTime){return -1;}var left=0;var right=len;while(left<=right){var mid=Math.floor((right+left)/2);if(time<cues[mid].startTime){right=mid-1;}else if(time>cues[mid].startTime&&left<len){left=mid+1;}else {// If it's not lower or higher, it must be equal.
return mid;}}// At this point, left and right have swapped.
// No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
return cues[left].startTime-time<time-cues[right].startTime?left:right;}function getCuesInRange(cues,start,end){var cuesFound=[];var firstCueInRange=getFirstCueIndexAfterTime(cues,start);if(firstCueInRange>-1){for(var i=firstCueInRange,len=cues.length;i<len;i++){var cue=cues[i];if(cue.startTime>=start&&cue.endTime<=end){cuesFound.push(cue);}else if(cue.startTime>end){return cuesFound;}}}return cuesFound;}function filterSubtitleTracks(textTrackList){var tracks=[];for(var i=0;i<textTrackList.length;i++){var track=textTrackList[i];// Edge adds a track without a label; we don't want to use it
if((track.kind==='subtitles'||track.kind==='captions')&&track.label){tracks.push(textTrackList[i]);}}return tracks;}var MetadataSchema={audioId3:"org.id3",dateRange:"com.apple.quicktime.HLS",emsg:"https://aomedia.org/emsg/ID3"};var MIN_CUE_DURATION=0.25;function getCueClass(){if(typeof self==='undefined')return undefined;return self.VTTCue||self.TextTrackCue;}function createCueWithDataFields(Cue,startTime,endTime,data,type){var cue=new Cue(startTime,endTime,'');try{cue.value=data;if(type){cue.type=type;}}catch(e){cue=new Cue(startTime,endTime,JSON.stringify(type?_objectSpread2$2({type:type},data):data));}return cue;}// VTTCue latest draft allows an infinite duration, fallback
// to MAX_VALUE if necessary
var MAX_CUE_ENDTIME=function(){var Cue=getCueClass();try{Cue&&new Cue(0,Number.POSITIVE_INFINITY,'');}catch(e){return Number.MAX_VALUE;}return Number.POSITIVE_INFINITY;}();function dateRangeDateToTimelineSeconds(date,offset){return date.getTime()/1000-offset;}function hexToArrayBuffer(str){return Uint8Array.from(str.replace(/^0x/,'').replace(/([\da-fA-F]{2}) ?/g,'0x$1 ').replace(/ +$/,'').split(' ')).buffer;}var ID3TrackController=/*#__PURE__*/function(){function ID3TrackController(hls){_classCallCheck(this,ID3TrackController);this.hls=void 0;this.id3Track=null;this.media=null;this.dateRangeCuesAppended={};this.hls=hls;this._registerListeners();}_createClass(ID3TrackController,[{key:"destroy",value:function destroy(){this._unregisterListeners();this.id3Track=null;this.media=null;this.dateRangeCuesAppended={};// @ts-ignore
this.hls=null;}},{key:"_registerListeners",value:function _registerListeners(){var hls=this.hls;hls.on(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.on(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.FRAG_PARSING_METADATA,this.onFragParsingMetadata,this);hls.on(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);hls.on(Events.LEVEL_UPDATED,this.onLevelUpdated,this);}},{key:"_unregisterListeners",value:function _unregisterListeners(){var hls=this.hls;hls.off(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.off(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.FRAG_PARSING_METADATA,this.onFragParsingMetadata,this);hls.off(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);hls.off(Events.LEVEL_UPDATED,this.onLevelUpdated,this);}// Add ID3 metatadata text track.
},{key:"onMediaAttached",value:function onMediaAttached(event,data){this.media=data.media;}},{key:"onMediaDetaching",value:function onMediaDetaching(){if(!this.id3Track){return;}clearCurrentCues(this.id3Track);this.id3Track=null;this.media=null;this.dateRangeCuesAppended={};}},{key:"onManifestLoading",value:function onManifestLoading(){this.dateRangeCuesAppended={};}},{key:"createTrack",value:function createTrack(media){var track=this.getID3Track(media.textTracks);track.mode='hidden';return track;}},{key:"getID3Track",value:function getID3Track(textTracks){if(!this.media){return;}for(var i=0;i<textTracks.length;i++){var textTrack=textTracks[i];if(textTrack.kind==='metadata'&&textTrack.label==='id3'){// send 'addtrack' when reusing the textTrack for metadata,
// same as what we do for captions
sendAddTrackEvent(textTrack,this.media);return textTrack;}}return this.media.addTextTrack('metadata','id3');}},{key:"onFragParsingMetadata",value:function onFragParsingMetadata(event,data){if(!this.media){return;}var _this$hls$config=this.hls.config,enableEmsgMetadataCues=_this$hls$config.enableEmsgMetadataCues,enableID3MetadataCues=_this$hls$config.enableID3MetadataCues;if(!enableEmsgMetadataCues&&!enableID3MetadataCues){return;}var samples=data.samples;// create track dynamically
if(!this.id3Track){this.id3Track=this.createTrack(this.media);}var Cue=getCueClass();if(!Cue){return;}for(var i=0;i<samples.length;i++){var type=samples[i].type;if(type===MetadataSchema.emsg&&!enableEmsgMetadataCues||!enableID3MetadataCues){continue;}var frames=getID3Frames(samples[i].data);if(frames){var startTime=samples[i].pts;var endTime=startTime+samples[i].duration;if(endTime>MAX_CUE_ENDTIME){endTime=MAX_CUE_ENDTIME;}var timeDiff=endTime-startTime;if(timeDiff<=0){endTime=startTime+MIN_CUE_DURATION;}for(var j=0;j<frames.length;j++){var frame=frames[j];// Safari doesn't put the timestamp frame in the TextTrack
if(!isTimeStampFrame(frame)){// add a bounds to any unbounded cues
this.updateId3CueEnds(startTime,type);var cue=createCueWithDataFields(Cue,startTime,endTime,frame,type);if(cue){this.id3Track.addCue(cue);}}}}}}},{key:"updateId3CueEnds",value:function updateId3CueEnds(startTime,type){var _this$id3Track;var cues=(_this$id3Track=this.id3Track)==null?void 0:_this$id3Track.cues;if(cues){for(var i=cues.length;i--;){var cue=cues[i];if(cue.type===type&&cue.startTime<startTime&&cue.endTime===MAX_CUE_ENDTIME){cue.endTime=startTime;}}}}},{key:"onBufferFlushing",value:function onBufferFlushing(event,_ref){var startOffset=_ref.startOffset,endOffset=_ref.endOffset,type=_ref.type;var id3Track=this.id3Track,hls=this.hls;if(!hls){return;}var _hls$config=hls.config,enableEmsgMetadataCues=_hls$config.enableEmsgMetadataCues,enableID3MetadataCues=_hls$config.enableID3MetadataCues;if(id3Track&&(enableEmsgMetadataCues||enableID3MetadataCues)){var predicate;if(type==='audio'){predicate=function predicate(cue){return cue.type===MetadataSchema.audioId3&&enableID3MetadataCues;};}else if(type==='video'){predicate=function predicate(cue){return cue.type===MetadataSchema.emsg&&enableEmsgMetadataCues;};}else {predicate=function predicate(cue){return cue.type===MetadataSchema.audioId3&&enableID3MetadataCues||cue.type===MetadataSchema.emsg&&enableEmsgMetadataCues;};}removeCuesInRange(id3Track,startOffset,endOffset,predicate);}}},{key:"onLevelUpdated",value:function onLevelUpdated(event,_ref2){var _this5=this;var details=_ref2.details;if(!this.media||!details.hasProgramDateTime||!this.hls.config.enableDateRangeMetadataCues){return;}var dateRangeCuesAppended=this.dateRangeCuesAppended,id3Track=this.id3Track;var dateRanges=details.dateRanges;var ids=Object.keys(dateRanges);// Remove cues from track not found in details.dateRanges
if(id3Track){var idsToRemove=Object.keys(dateRangeCuesAppended).filter(function(id){return !ids.includes(id);});var _loop=function _loop(){var id=idsToRemove[i];Object.keys(dateRangeCuesAppended[id].cues).forEach(function(key){id3Track.removeCue(dateRangeCuesAppended[id].cues[key]);});delete dateRangeCuesAppended[id];};for(var i=idsToRemove.length;i--;){_loop();}}// Exit if the playlist does not have Date Ranges or does not have Program Date Time
var lastFragment=details.fragments[details.fragments.length-1];if(ids.length===0||!isFiniteNumber(lastFragment==null?void 0:lastFragment.programDateTime)){return;}if(!this.id3Track){this.id3Track=this.createTrack(this.media);}var dateTimeOffset=lastFragment.programDateTime/1000-lastFragment.start;var Cue=getCueClass();var _loop2=function _loop2(){var id=ids[_i6];var dateRange=dateRanges[id];var startTime=dateRangeDateToTimelineSeconds(dateRange.startDate,dateTimeOffset);// Process DateRanges to determine end-time (known DURATION, END-DATE, or END-ON-NEXT)
var appendedDateRangeCues=dateRangeCuesAppended[id];var cues=(appendedDateRangeCues==null?void 0:appendedDateRangeCues.cues)||{};var durationKnown=(appendedDateRangeCues==null?void 0:appendedDateRangeCues.durationKnown)||false;var endTime=MAX_CUE_ENDTIME;var endDate=dateRange.endDate;if(endDate){endTime=dateRangeDateToTimelineSeconds(endDate,dateTimeOffset);durationKnown=true;}else if(dateRange.endOnNext&&!durationKnown){var nextDateRangeWithSameClass=ids.reduce(function(candidateDateRange,id){if(id!==dateRange.id){var otherDateRange=dateRanges[id];if(otherDateRange["class"]===dateRange["class"]&&otherDateRange.startDate>dateRange.startDate&&(!candidateDateRange||dateRange.startDate<candidateDateRange.startDate)){return otherDateRange;}}return candidateDateRange;},null);if(nextDateRangeWithSameClass){endTime=dateRangeDateToTimelineSeconds(nextDateRangeWithSameClass.startDate,dateTimeOffset);durationKnown=true;}}// Create TextTrack Cues for each MetadataGroup Item (select DateRange attribute)
// This is to emulate Safari HLS playback handling of DateRange tags
var attributes=Object.keys(dateRange.attr);for(var j=0;j<attributes.length;j++){var key=attributes[j];if(!isDateRangeCueAttribute(key)){continue;}var cue=cues[key];if(cue){if(durationKnown&&!appendedDateRangeCues.durationKnown){cue.endTime=endTime;}}else if(Cue){var data=dateRange.attr[key];if(isSCTE35Attribute(key)){data=hexToArrayBuffer(data);}var _cue=createCueWithDataFields(Cue,startTime,endTime,{key:key,data:data},MetadataSchema.dateRange);if(_cue){_cue.id=id;_this5.id3Track.addCue(_cue);cues[key]=_cue;}}}// Keep track of processed DateRanges by ID for updating cues with new DateRange tag attributes
dateRangeCuesAppended[id]={cues:cues,dateRange:dateRange,durationKnown:durationKnown};};for(var _i6=0;_i6<ids.length;_i6++){_loop2();}}}]);return ID3TrackController;}();var LatencyController=/*#__PURE__*/function(){function LatencyController(hls){var _this6=this;_classCallCheck(this,LatencyController);this.hls=void 0;this.config=void 0;this.media=null;this.levelDetails=null;this.currentTime=0;this.stallCount=0;this._latency=null;this.timeupdateHandler=function(){return _this6.timeupdate();};this.hls=hls;this.config=hls.config;this.registerListeners();}_createClass(LatencyController,[{key:"latency",get:function get(){return this._latency||0;}},{key:"maxLatency",get:function get(){var config=this.config,levelDetails=this.levelDetails;if(config.liveMaxLatencyDuration!==undefined){return config.liveMaxLatencyDuration;}return levelDetails?config.liveMaxLatencyDurationCount*levelDetails.targetduration:0;}},{key:"targetLatency",get:function get(){var levelDetails=this.levelDetails;if(levelDetails===null){return null;}var holdBack=levelDetails.holdBack,partHoldBack=levelDetails.partHoldBack,targetduration=levelDetails.targetduration;var _this$config=this.config,liveSyncDuration=_this$config.liveSyncDuration,liveSyncDurationCount=_this$config.liveSyncDurationCount,lowLatencyMode=_this$config.lowLatencyMode;var userConfig=this.hls.userConfig;var targetLatency=lowLatencyMode?partHoldBack||holdBack:holdBack;if(userConfig.liveSyncDuration||userConfig.liveSyncDurationCount||targetLatency===0){targetLatency=liveSyncDuration!==undefined?liveSyncDuration:liveSyncDurationCount*targetduration;}var maxLiveSyncOnStallIncrease=targetduration;var liveSyncOnStallIncrease=1.0;return targetLatency+Math.min(this.stallCount*liveSyncOnStallIncrease,maxLiveSyncOnStallIncrease);}},{key:"liveSyncPosition",get:function get(){var liveEdge=this.estimateLiveEdge();var targetLatency=this.targetLatency;var levelDetails=this.levelDetails;if(liveEdge===null||targetLatency===null||levelDetails===null){return null;}var edge=levelDetails.edge;var syncPosition=liveEdge-targetLatency-this.edgeStalled;var min=edge-levelDetails.totalduration;var max=edge-(this.config.lowLatencyMode&&levelDetails.partTarget||levelDetails.targetduration);return Math.min(Math.max(min,syncPosition),max);}},{key:"drift",get:function get(){var levelDetails=this.levelDetails;if(levelDetails===null){return 1;}return levelDetails.drift;}},{key:"edgeStalled",get:function get(){var levelDetails=this.levelDetails;if(levelDetails===null){return 0;}var maxLevelUpdateAge=(this.config.lowLatencyMode&&levelDetails.partTarget||levelDetails.targetduration)*3;return Math.max(levelDetails.age-maxLevelUpdateAge,0);}},{key:"forwardBufferLength",get:function get(){var media=this.media,levelDetails=this.levelDetails;if(!media||!levelDetails){return 0;}var bufferedRanges=media.buffered.length;return (bufferedRanges?media.buffered.end(bufferedRanges-1):levelDetails.edge)-this.currentTime;}},{key:"destroy",value:function destroy(){this.unregisterListeners();this.onMediaDetaching();this.levelDetails=null;// @ts-ignore
this.hls=this.timeupdateHandler=null;}},{key:"registerListeners",value:function registerListeners(){this.hls.on(Events.MEDIA_ATTACHED,this.onMediaAttached,this);this.hls.on(Events.MEDIA_DETACHING,this.onMediaDetaching,this);this.hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);this.hls.on(Events.LEVEL_UPDATED,this.onLevelUpdated,this);this.hls.on(Events.ERROR,this.onError,this);}},{key:"unregisterListeners",value:function unregisterListeners(){this.hls.off(Events.MEDIA_ATTACHED,this.onMediaAttached,this);this.hls.off(Events.MEDIA_DETACHING,this.onMediaDetaching,this);this.hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);this.hls.off(Events.LEVEL_UPDATED,this.onLevelUpdated,this);this.hls.off(Events.ERROR,this.onError,this);}},{key:"onMediaAttached",value:function onMediaAttached(event,data){this.media=data.media;this.media.addEventListener('timeupdate',this.timeupdateHandler);}},{key:"onMediaDetaching",value:function onMediaDetaching(){if(this.media){this.media.removeEventListener('timeupdate',this.timeupdateHandler);this.media=null;}}},{key:"onManifestLoading",value:function onManifestLoading(){this.levelDetails=null;this._latency=null;this.stallCount=0;}},{key:"onLevelUpdated",value:function onLevelUpdated(event,_ref3){var details=_ref3.details;this.levelDetails=details;if(details.advanced){this.timeupdate();}if(!details.live&&this.media){this.media.removeEventListener('timeupdate',this.timeupdateHandler);}}},{key:"onError",value:function onError(event,data){var _this$levelDetails;if(data.details!==ErrorDetails.BUFFER_STALLED_ERROR){return;}this.stallCount++;if((_this$levelDetails=this.levelDetails)!=null&&_this$levelDetails.live){logger.warn('[playback-rate-controller]: Stall detected, adjusting target latency');}}},{key:"timeupdate",value:function timeupdate(){var media=this.media,levelDetails=this.levelDetails;if(!media||!levelDetails){return;}this.currentTime=media.currentTime;var latency=this.computeLatency();if(latency===null){return;}this._latency=latency;// Adapt playbackRate to meet target latency in low-latency mode
var _this$config2=this.config,lowLatencyMode=_this$config2.lowLatencyMode,maxLiveSyncPlaybackRate=_this$config2.maxLiveSyncPlaybackRate;if(!lowLatencyMode||maxLiveSyncPlaybackRate===1||!levelDetails.live){return;}var targetLatency=this.targetLatency;if(targetLatency===null){return;}var distanceFromTarget=latency-targetLatency;// Only adjust playbackRate when within one target duration of targetLatency
// and more than one second from under-buffering.
// Playback further than one target duration from target can be considered DVR playback.
var liveMinLatencyDuration=Math.min(this.maxLatency,targetLatency+levelDetails.targetduration);var inLiveRange=distanceFromTarget<liveMinLatencyDuration;if(inLiveRange&&distanceFromTarget>0.05&&this.forwardBufferLength>1){var max=Math.min(2,Math.max(1.0,maxLiveSyncPlaybackRate));var rate=Math.round(2/(1+Math.exp(-0.75*distanceFromTarget-this.edgeStalled))*20)/20;media.playbackRate=Math.min(max,Math.max(1,rate));}else if(media.playbackRate!==1&&media.playbackRate!==0){media.playbackRate=1;}}},{key:"estimateLiveEdge",value:function estimateLiveEdge(){var levelDetails=this.levelDetails;if(levelDetails===null){return null;}return levelDetails.edge+levelDetails.age;}},{key:"computeLatency",value:function computeLatency(){var liveEdge=this.estimateLiveEdge();if(liveEdge===null){return null;}return liveEdge-this.currentTime;}}]);return LatencyController;}();var HdcpLevels=['NONE','TYPE-0','TYPE-1',null];function isHdcpLevel(value){return HdcpLevels.indexOf(value)>-1;}var VideoRangeValues=['SDR','PQ','HLG'];function isVideoRange(value){return !!value&&VideoRangeValues.indexOf(value)>-1;}var HlsSkip={No:"",Yes:"YES",v2:"v2"};function getSkipValue(details){var canSkipUntil=details.canSkipUntil,canSkipDateRanges=details.canSkipDateRanges,age=details.age;// A Client SHOULD NOT request a Playlist Delta Update unless it already
// has a version of the Playlist that is no older than one-half of the Skip Boundary.
// @see: https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis#section-6.3.7
var playlistRecentEnough=age<canSkipUntil/2;if(canSkipUntil&&playlistRecentEnough){if(canSkipDateRanges){return HlsSkip.v2;}return HlsSkip.Yes;}return HlsSkip.No;}var HlsUrlParameters=/*#__PURE__*/function(){function HlsUrlParameters(msn,part,skip){_classCallCheck(this,HlsUrlParameters);this.msn=void 0;this.part=void 0;this.skip=void 0;this.msn=msn;this.part=part;this.skip=skip;}_createClass(HlsUrlParameters,[{key:"addDirectives",value:function addDirectives(uri){var url=new self.URL(uri);if(this.msn!==undefined){url.searchParams.set('_HLS_msn',this.msn.toString());}if(this.part!==undefined){url.searchParams.set('_HLS_part',this.part.toString());}if(this.skip){url.searchParams.set('_HLS_skip',this.skip);}return url.href;}}]);return HlsUrlParameters;}();var Level=/*#__PURE__*/function(){function Level(data){_classCallCheck(this,Level);this._attrs=void 0;this.audioCodec=void 0;this.bitrate=void 0;this.codecSet=void 0;this.url=void 0;this.frameRate=void 0;this.height=void 0;this.id=void 0;this.name=void 0;this.videoCodec=void 0;this.width=void 0;this.details=void 0;this.fragmentError=0;this.loadError=0;this.loaded=void 0;this.realBitrate=0;this.supportedPromise=void 0;this.supportedResult=void 0;this._avgBitrate=0;this._audioGroups=void 0;this._subtitleGroups=void 0;// Deprecated (retained for backwards compatibility)
this._urlId=0;this.url=[data.url];this._attrs=[data.attrs];this.bitrate=data.bitrate;if(data.details){this.details=data.details;}this.id=data.id||0;this.name=data.name;this.width=data.width||0;this.height=data.height||0;this.frameRate=data.attrs.optionalFloat('FRAME-RATE',0);this._avgBitrate=data.attrs.decimalInteger('AVERAGE-BANDWIDTH');this.audioCodec=data.audioCodec;this.videoCodec=data.videoCodec;this.codecSet=[data.videoCodec,data.audioCodec].filter(function(c){return !!c;}).map(function(s){return s.substring(0,4);}).join(',');this.addGroupId('audio',data.attrs.AUDIO);this.addGroupId('text',data.attrs.SUBTITLES);}_createClass(Level,[{key:"maxBitrate",get:function get(){return Math.max(this.realBitrate,this.bitrate);}},{key:"averageBitrate",get:function get(){return this._avgBitrate||this.realBitrate||this.bitrate;}},{key:"attrs",get:function get(){return this._attrs[0];}},{key:"codecs",get:function get(){return this.attrs.CODECS||'';}},{key:"pathwayId",get:function get(){return this.attrs['PATHWAY-ID']||'.';}},{key:"videoRange",get:function get(){return this.attrs['VIDEO-RANGE']||'SDR';}},{key:"score",get:function get(){return this.attrs.optionalFloat('SCORE',0);}},{key:"uri",get:function get(){return this.url[0]||'';}},{key:"hasAudioGroup",value:function hasAudioGroup(groupId){return hasGroup(this._audioGroups,groupId);}},{key:"hasSubtitleGroup",value:function hasSubtitleGroup(groupId){return hasGroup(this._subtitleGroups,groupId);}},{key:"audioGroups",get:function get(){return this._audioGroups;}},{key:"subtitleGroups",get:function get(){return this._subtitleGroups;}},{key:"addGroupId",value:function addGroupId(type,groupId){if(!groupId){return;}if(type==='audio'){var audioGroups=this._audioGroups;if(!audioGroups){audioGroups=this._audioGroups=[];}if(audioGroups.indexOf(groupId)===-1){audioGroups.push(groupId);}}else if(type==='text'){var subtitleGroups=this._subtitleGroups;if(!subtitleGroups){subtitleGroups=this._subtitleGroups=[];}if(subtitleGroups.indexOf(groupId)===-1){subtitleGroups.push(groupId);}}}// Deprecated methods (retained for backwards compatibility)
},{key:"urlId",get:function get(){return 0;},set:function set(value){}},{key:"audioGroupIds",get:function get(){return this.audioGroups?[this.audioGroupId]:undefined;}},{key:"textGroupIds",get:function get(){return this.subtitleGroups?[this.textGroupId]:undefined;}},{key:"audioGroupId",get:function get(){var _this$audioGroups;return (_this$audioGroups=this.audioGroups)==null?void 0:_this$audioGroups[0];}},{key:"textGroupId",get:function get(){var _this$subtitleGroups;return (_this$subtitleGroups=this.subtitleGroups)==null?void 0:_this$subtitleGroups[0];}},{key:"addFallback",value:function addFallback(){}}]);return Level;}();function hasGroup(groups,groupId){if(!groupId||!groups){return false;}return groups.indexOf(groupId)!==-1;}function updateFromToPTS(fragFrom,fragTo){var fragToPTS=fragTo.startPTS;// if we know startPTS[toIdx]
if(isFiniteNumber(fragToPTS)){// update fragment duration.
// it helps to fix drifts between playlist reported duration and fragment real duration
var duration=0;var frag;if(fragTo.sn>fragFrom.sn){duration=fragToPTS-fragFrom.start;frag=fragFrom;}else {duration=fragFrom.start-fragToPTS;frag=fragTo;}if(frag.duration!==duration){frag.duration=duration;}// we dont know startPTS[toIdx]
}else if(fragTo.sn>fragFrom.sn){var contiguous=fragFrom.cc===fragTo.cc;// TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
if(contiguous&&fragFrom.minEndPTS){fragTo.start=fragFrom.start+(fragFrom.minEndPTS-fragFrom.start);}else {fragTo.start=fragFrom.start+fragFrom.duration;}}else {fragTo.start=Math.max(fragFrom.start-fragTo.duration,0);}}function updateFragPTSDTS(details,frag,startPTS,endPTS,startDTS,endDTS){var parsedMediaDuration=endPTS-startPTS;if(parsedMediaDuration<=0){logger.warn('Fragment should have a positive duration',frag);endPTS=startPTS+frag.duration;endDTS=startDTS+frag.duration;}var maxStartPTS=startPTS;var minEndPTS=endPTS;var fragStartPts=frag.startPTS;var fragEndPts=frag.endPTS;if(isFiniteNumber(fragStartPts)){// delta PTS between audio and video
var deltaPTS=Math.abs(fragStartPts-startPTS);if(!isFiniteNumber(frag.deltaPTS)){frag.deltaPTS=deltaPTS;}else {frag.deltaPTS=Math.max(deltaPTS,frag.deltaPTS);}maxStartPTS=Math.max(startPTS,fragStartPts);startPTS=Math.min(startPTS,fragStartPts);startDTS=Math.min(startDTS,frag.startDTS);minEndPTS=Math.min(endPTS,fragEndPts);endPTS=Math.max(endPTS,fragEndPts);endDTS=Math.max(endDTS,frag.endDTS);}var drift=startPTS-frag.start;if(frag.start!==0){frag.start=startPTS;}frag.duration=endPTS-frag.start;frag.startPTS=startPTS;frag.maxStartPTS=maxStartPTS;frag.startDTS=startDTS;frag.endPTS=endPTS;frag.minEndPTS=minEndPTS;frag.endDTS=endDTS;var sn=frag.sn;// 'initSegment'
// exit if sn out of range
if(!details||sn<details.startSN||sn>details.endSN){return 0;}var i;var fragIdx=sn-details.startSN;var fragments=details.fragments;// update frag reference in fragments array
// rationale is that fragments array might not contain this frag object.
// this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
// if we don't update frag, we won't be able to propagate PTS info on the playlist
// resulting in invalid sliding computation
fragments[fragIdx]=frag;// adjust fragment PTS/duration from seqnum-1 to frag 0
for(i=fragIdx;i>0;i--){updateFromToPTS(fragments[i],fragments[i-1]);}// adjust fragment PTS/duration from seqnum to last frag
for(i=fragIdx;i<fragments.length-1;i++){updateFromToPTS(fragments[i],fragments[i+1]);}if(details.fragmentHint){updateFromToPTS(fragments[fragments.length-1],details.fragmentHint);}details.PTSKnown=details.alignedSliding=true;return drift;}function mergeDetails(oldDetails,newDetails){// Track the last initSegment processed. Initialize it to the last one on the timeline.
var currentInitSegment=null;var oldFragments=oldDetails.fragments;for(var i=oldFragments.length-1;i>=0;i--){var oldInit=oldFragments[i].initSegment;if(oldInit){currentInitSegment=oldInit;break;}}if(oldDetails.fragmentHint){// prevent PTS and duration from being adjusted on the next hint
delete oldDetails.fragmentHint.endPTS;}// check if old/new playlists have fragments in common
// loop through overlapping SN and update startPTS , cc, and duration if any found
var ccOffset=0;var PTSFrag;mapFragmentIntersection(oldDetails,newDetails,function(oldFrag,newFrag){if(oldFrag.relurl){// Do not compare CC if the old fragment has no url. This is a level.fragmentHint used by LL-HLS parts.
// It maybe be off by 1 if it was created before any parts or discontinuity tags were appended to the end
// of the playlist.
ccOffset=oldFrag.cc-newFrag.cc;}if(isFiniteNumber(oldFrag.startPTS)&&isFiniteNumber(oldFrag.endPTS)){newFrag.start=newFrag.startPTS=oldFrag.startPTS;newFrag.startDTS=oldFrag.startDTS;newFrag.maxStartPTS=oldFrag.maxStartPTS;newFrag.endPTS=oldFrag.endPTS;newFrag.endDTS=oldFrag.endDTS;newFrag.minEndPTS=oldFrag.minEndPTS;newFrag.duration=oldFrag.endPTS-oldFrag.startPTS;if(newFrag.duration){PTSFrag=newFrag;}// PTS is known when any segment has startPTS and endPTS
newDetails.PTSKnown=newDetails.alignedSliding=true;}newFrag.elementaryStreams=oldFrag.elementaryStreams;newFrag.loader=oldFrag.loader;newFrag.stats=oldFrag.stats;if(oldFrag.initSegment){newFrag.initSegment=oldFrag.initSegment;currentInitSegment=oldFrag.initSegment;}});if(currentInitSegment){var fragmentsToCheck=newDetails.fragmentHint?newDetails.fragments.concat(newDetails.fragmentHint):newDetails.fragments;fragmentsToCheck.forEach(function(frag){var _currentInitSegment;if(frag&&(!frag.initSegment||frag.initSegment.relurl===((_currentInitSegment=currentInitSegment)==null?void 0:_currentInitSegment.relurl))){frag.initSegment=currentInitSegment;}});}if(newDetails.skippedSegments){newDetails.deltaUpdateFailed=newDetails.fragments.some(function(frag){return !frag;});if(newDetails.deltaUpdateFailed){logger.warn('[level-helper] Previous playlist missing segments skipped in delta playlist');for(var _i7=newDetails.skippedSegments;_i7--;){newDetails.fragments.shift();}newDetails.startSN=newDetails.fragments[0].sn;newDetails.startCC=newDetails.fragments[0].cc;}else if(newDetails.canSkipDateRanges){newDetails.dateRanges=mergeDateRanges(oldDetails.dateRanges,newDetails.dateRanges,newDetails.recentlyRemovedDateranges);}}var newFragments=newDetails.fragments;if(ccOffset){logger.warn('discontinuity sliding from playlist, take drift into account');for(var _i8=0;_i8<newFragments.length;_i8++){newFragments[_i8].cc+=ccOffset;}}if(newDetails.skippedSegments){newDetails.startCC=newDetails.fragments[0].cc;}// Merge parts
mapPartIntersection(oldDetails.partList,newDetails.partList,function(oldPart,newPart){newPart.elementaryStreams=oldPart.elementaryStreams;newPart.stats=oldPart.stats;});// if at least one fragment contains PTS info, recompute PTS information for all fragments
if(PTSFrag){updateFragPTSDTS(newDetails,PTSFrag,PTSFrag.startPTS,PTSFrag.endPTS,PTSFrag.startDTS,PTSFrag.endDTS);}else {// ensure that delta is within oldFragments range
// also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
// in that case we also need to adjust start offset of all fragments
adjustSliding(oldDetails,newDetails);}if(newFragments.length){newDetails.totalduration=newDetails.edge-newFragments[0].start;}newDetails.driftStartTime=oldDetails.driftStartTime;newDetails.driftStart=oldDetails.driftStart;var advancedDateTime=newDetails.advancedDateTime;if(newDetails.advanced&&advancedDateTime){var edge=newDetails.edge;if(!newDetails.driftStart){newDetails.driftStartTime=advancedDateTime;newDetails.driftStart=edge;}newDetails.driftEndTime=advancedDateTime;newDetails.driftEnd=edge;}else {newDetails.driftEndTime=oldDetails.driftEndTime;newDetails.driftEnd=oldDetails.driftEnd;newDetails.advancedDateTime=oldDetails.advancedDateTime;}}function mergeDateRanges(oldDateRanges,deltaDateRanges,recentlyRemovedDateranges){var dateRanges=_extends({},oldDateRanges);if(recentlyRemovedDateranges){recentlyRemovedDateranges.forEach(function(id){delete dateRanges[id];});}Object.keys(deltaDateRanges).forEach(function(id){var dateRange=new DateRange(deltaDateRanges[id].attr,dateRanges[id]);if(dateRange.isValid){dateRanges[id]=dateRange;}else {logger.warn("Ignoring invalid Playlist Delta Update DATERANGE tag: \"".concat(JSON.stringify(deltaDateRanges[id].attr),"\""));}});return dateRanges;}function mapPartIntersection(oldParts,newParts,intersectionFn){if(oldParts&&newParts){var delta=0;for(var i=0,len=oldParts.length;i<=len;i++){var oldPart=oldParts[i];var newPart=newParts[i+delta];if(oldPart&&newPart&&oldPart.index===newPart.index&&oldPart.fragment.sn===newPart.fragment.sn){intersectionFn(oldPart,newPart);}else {delta--;}}}}function mapFragmentIntersection(oldDetails,newDetails,intersectionFn){var skippedSegments=newDetails.skippedSegments;var start=Math.max(oldDetails.startSN,newDetails.startSN)-newDetails.startSN;var end=(oldDetails.fragmentHint?1:0)+(skippedSegments?newDetails.endSN:Math.min(oldDetails.endSN,newDetails.endSN))-newDetails.startSN;var delta=newDetails.startSN-oldDetails.startSN;var newFrags=newDetails.fragmentHint?newDetails.fragments.concat(newDetails.fragmentHint):newDetails.fragments;var oldFrags=oldDetails.fragmentHint?oldDetails.fragments.concat(oldDetails.fragmentHint):oldDetails.fragments;for(var i=start;i<=end;i++){var oldFrag=oldFrags[delta+i];var newFrag=newFrags[i];if(skippedSegments&&!newFrag&&i<skippedSegments){// Fill in skipped segments in delta playlist
newFrag=newDetails.fragments[i]=oldFrag;}if(oldFrag&&newFrag){intersectionFn(oldFrag,newFrag);}}}function adjustSliding(oldDetails,newDetails){var delta=newDetails.startSN+newDetails.skippedSegments-oldDetails.startSN;var oldFragments=oldDetails.fragments;if(delta<0||delta>=oldFragments.length){return;}addSliding(newDetails,oldFragments[delta].start);}function addSliding(details,start){if(start){var fragments=details.fragments;for(var i=details.skippedSegments;i<fragments.length;i++){fragments[i].start+=start;}if(details.fragmentHint){details.fragmentHint.start+=start;}}}function computeReloadInterval(newDetails){var distanceToLiveEdgeMs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Infinity;var reloadInterval=1000*newDetails.targetduration;if(newDetails.updated){// Use last segment duration when shorter than target duration and near live edge
var fragments=newDetails.fragments;var liveEdgeMaxTargetDurations=4;if(fragments.length&&reloadInterval*liveEdgeMaxTargetDurations>distanceToLiveEdgeMs){var lastSegmentDuration=fragments[fragments.length-1].duration*1000;if(lastSegmentDuration<reloadInterval){reloadInterval=lastSegmentDuration;}}}else {// estimate = 'miss half average';
// follow HLS Spec, If the client reloads a Playlist file and finds that it has not
// changed then it MUST wait for a period of one-half the target
// duration before retrying.
reloadInterval/=2;}return Math.round(reloadInterval);}function getFragmentWithSN(level,sn,fragCurrent){if(!(level!=null&&level.details)){return null;}var levelDetails=level.details;var fragment=levelDetails.fragments[sn-levelDetails.startSN];if(fragment){return fragment;}fragment=levelDetails.fragmentHint;if(fragment&&fragment.sn===sn){return fragment;}if(sn<levelDetails.startSN&&fragCurrent&&fragCurrent.sn===sn){return fragCurrent;}return null;}function getPartWith(level,sn,partIndex){var _level$details;if(!(level!=null&&level.details)){return null;}return findPart((_level$details=level.details)==null?void 0:_level$details.partList,sn,partIndex);}function findPart(partList,sn,partIndex){if(partList){for(var i=partList.length;i--;){var part=partList[i];if(part.index===partIndex&&part.fragment.sn===sn){return part;}}}return null;}function reassignFragmentLevelIndexes(levels){levels.forEach(function(level,index){var details=level.details;if(details!=null&&details.fragments){details.fragments.forEach(function(fragment){fragment.level=index;});}});}function isTimeoutError(error){switch(error.details){case ErrorDetails.FRAG_LOAD_TIMEOUT:case ErrorDetails.KEY_LOAD_TIMEOUT:case ErrorDetails.LEVEL_LOAD_TIMEOUT:case ErrorDetails.MANIFEST_LOAD_TIMEOUT:return true;}return false;}function getRetryConfig(loadPolicy,error){var isTimeout=isTimeoutError(error);return loadPolicy["default"]["".concat(isTimeout?'timeout':'error',"Retry")];}function getRetryDelay(retryConfig,retryCount){// exponential backoff capped to max retry delay
var backoffFactor=retryConfig.backoff==='linear'?1:Math.pow(2,retryCount);return Math.min(backoffFactor*retryConfig.retryDelayMs,retryConfig.maxRetryDelayMs);}function getLoaderConfigWithoutReties(loderConfig){return _objectSpread2$2(_objectSpread2$2({},loderConfig),{errorRetry:null,timeoutRetry:null});}function shouldRetry(retryConfig,retryCount,isTimeout,loaderResponse){if(!retryConfig){return false;}var httpStatus=loaderResponse==null?void 0:loaderResponse.code;var retry=retryCount<retryConfig.maxNumRetry&&(retryForHttpStatus(httpStatus)||!!isTimeout);return retryConfig.shouldRetry?retryConfig.shouldRetry(retryConfig,retryCount,isTimeout,loaderResponse,retry):retry;}function retryForHttpStatus(httpStatus){// Do not retry on status 4xx, status 0 (CORS error), or undefined (decrypt/gap/parse error)
return httpStatus===0&&navigator.onLine===false||!!httpStatus&&(httpStatus<400||httpStatus>499);}var BinarySearch={/**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */search:function search(list,comparisonFn){var minIndex=0;var maxIndex=list.length-1;var currentIndex=null;var currentElement=null;while(minIndex<=maxIndex){currentIndex=(minIndex+maxIndex)/2|0;currentElement=list[currentIndex];var comparisonResult=comparisonFn(currentElement);if(comparisonResult>0){minIndex=currentIndex+1;}else if(comparisonResult<0){maxIndex=currentIndex-1;}else {return currentElement;}}return null;}};/**
 * Returns first fragment whose endPdt value exceeds the given PDT, or null.
 * @param fragments - The array of candidate fragments
 * @param PDTValue - The PDT value which must be exceeded
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 */function findFragmentByPDT(fragments,PDTValue,maxFragLookUpTolerance){if(PDTValue===null||!Array.isArray(fragments)||!fragments.length||!isFiniteNumber(PDTValue)){return null;}// if less than start
var startPDT=fragments[0].programDateTime;if(PDTValue<(startPDT||0)){return null;}var endPDT=fragments[fragments.length-1].endProgramDateTime;if(PDTValue>=(endPDT||0)){return null;}maxFragLookUpTolerance=maxFragLookUpTolerance||0;for(var seg=0;seg<fragments.length;++seg){var frag=fragments[seg];if(pdtWithinToleranceTest(PDTValue,maxFragLookUpTolerance,frag)){return frag;}}return null;}/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param fragPrevious - The last frag successfully appended
 * @param fragments - The array of candidate fragments
 * @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns a matching fragment or null
 */function findFragmentByPTS(fragPrevious,fragments){var bufferEnd=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var maxFragLookUpTolerance=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var nextFragLookupTolerance=arguments.length>4&&arguments[4]!==undefined?arguments[4]:0.005;var fragNext=null;if(fragPrevious){fragNext=fragments[fragPrevious.sn-fragments[0].sn+1]||null;// check for buffer-end rounding error
var bufferEdgeError=fragPrevious.endDTS-bufferEnd;if(bufferEdgeError>0&&bufferEdgeError<0.0000015){bufferEnd+=0.0000015;}}else if(bufferEnd===0&&fragments[0].start===0){fragNext=fragments[0];}// Prefer the next fragment if it's within tolerance
if(fragNext&&((!fragPrevious||fragPrevious.level===fragNext.level)&&fragmentWithinToleranceTest(bufferEnd,maxFragLookUpTolerance,fragNext)===0||fragmentWithinFastStartSwitch(fragNext,fragPrevious,Math.min(nextFragLookupTolerance,maxFragLookUpTolerance)))){return fragNext;}// We might be seeking past the tolerance so find the best match
var foundFragment=BinarySearch.search(fragments,fragmentWithinToleranceTest.bind(null,bufferEnd,maxFragLookUpTolerance));if(foundFragment&&(foundFragment!==fragPrevious||!fragNext)){return foundFragment;}// If no match was found return the next fragment after fragPrevious, or null
return fragNext;}function fragmentWithinFastStartSwitch(fragNext,fragPrevious,nextFragLookupTolerance){if(fragPrevious&&fragPrevious.start===0&&fragPrevious.level<fragNext.level&&(fragPrevious.endPTS||0)>0){var firstDuration=fragPrevious.tagList.reduce(function(duration,tag){if(tag[0]==='INF'){duration+=parseFloat(tag[1]);}return duration;},nextFragLookupTolerance);return fragNext.start<=firstDuration;}return false;}/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param candidate - The fragment to test
 * @param bufferEnd - The end of the current buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns 0 if it matches, 1 if too low, -1 if too high
 */function fragmentWithinToleranceTest(){var bufferEnd=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var maxFragLookUpTolerance=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var candidate=arguments.length>2?arguments[2]:undefined;// eagerly accept an accurate match (no tolerance)
if(candidate.start<=bufferEnd&&candidate.start+candidate.duration>bufferEnd){return 0;}// offset should be within fragment boundary - config.maxFragLookUpTolerance
// this is to cope with situations like
// bufferEnd = 9.991
// frag[Ø] : [0,10]
// frag[1] : [10,20]
// bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
//              frag start               frag start+duration
//                  |-----------------------------|
//              <--->                         <--->
//  ...--------><-----------------------------><---------....
// previous frag         matching fragment         next frag
//  return -1             return 0                 return 1
// logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
// Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
var candidateLookupTolerance=Math.min(maxFragLookUpTolerance,candidate.duration+(candidate.deltaPTS?candidate.deltaPTS:0));if(candidate.start+candidate.duration-candidateLookupTolerance<=bufferEnd){return 1;}else if(candidate.start-candidateLookupTolerance>bufferEnd&&candidate.start){// if maxFragLookUpTolerance will have negative value then don't return -1 for first element
return -1;}return 0;}/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param candidate - The fragment to test
 * @param pdtBufferEnd - The Unix time representing the end of the current buffered range
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns true if contiguous, false otherwise
 */function pdtWithinToleranceTest(pdtBufferEnd,maxFragLookUpTolerance,candidate){var candidateLookupTolerance=Math.min(maxFragLookUpTolerance,candidate.duration+(candidate.deltaPTS?candidate.deltaPTS:0))*1000;// endProgramDateTime can be null, default to zero
var endProgramDateTime=candidate.endProgramDateTime||0;return endProgramDateTime-candidateLookupTolerance>pdtBufferEnd;}function findFragWithCC(fragments,cc){return BinarySearch.search(fragments,function(candidate){if(candidate.cc<cc){return 1;}else if(candidate.cc>cc){return -1;}else {return 0;}});}var NetworkErrorAction={DoNothing:0,SendEndCallback:1,SendAlternateToPenaltyBox:2,RemoveAlternatePermanently:3,InsertDiscontinuity:4,RetryRequest:5};var ErrorActionFlags={None:0,MoveAllAlternatesMatchingHost:1,MoveAllAlternatesMatchingHDCP:2,SwitchToSDR:4};// Reserved for future use
var ErrorController=/*#__PURE__*/function(){function ErrorController(hls){_classCallCheck(this,ErrorController);this.hls=void 0;this.playlistError=0;this.penalizedRenditions={};this.log=void 0;this.warn=void 0;this.error=void 0;this.hls=hls;this.log=logger.log.bind(logger,"[info]:");this.warn=logger.warn.bind(logger,"[warning]:");this.error=logger.error.bind(logger,"[error]:");this.registerListeners();}_createClass(ErrorController,[{key:"registerListeners",value:function registerListeners(){var hls=this.hls;hls.on(Events.ERROR,this.onError,this);hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.LEVEL_UPDATED,this.onLevelUpdated,this);}},{key:"unregisterListeners",value:function unregisterListeners(){var hls=this.hls;if(!hls){return;}hls.off(Events.ERROR,this.onError,this);hls.off(Events.ERROR,this.onErrorOut,this);hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.LEVEL_UPDATED,this.onLevelUpdated,this);}},{key:"destroy",value:function destroy(){this.unregisterListeners();// @ts-ignore
this.hls=null;this.penalizedRenditions={};}},{key:"startLoad",value:function startLoad(startPosition){}},{key:"stopLoad",value:function stopLoad(){this.playlistError=0;}},{key:"getVariantLevelIndex",value:function getVariantLevelIndex(frag){return (frag==null?void 0:frag.type)===PlaylistLevelType.MAIN?frag.level:this.hls.loadLevel;}},{key:"onManifestLoading",value:function onManifestLoading(){this.playlistError=0;this.penalizedRenditions={};}},{key:"onLevelUpdated",value:function onLevelUpdated(){this.playlistError=0;}},{key:"onError",value:function onError(event,data){var _data$frag,_data$level;if(data.fatal){return;}var hls=this.hls;var context=data.context;switch(data.details){case ErrorDetails.FRAG_LOAD_ERROR:case ErrorDetails.FRAG_LOAD_TIMEOUT:case ErrorDetails.KEY_LOAD_ERROR:case ErrorDetails.KEY_LOAD_TIMEOUT:data.errorAction=this.getFragRetryOrSwitchAction(data);return;case ErrorDetails.FRAG_PARSING_ERROR:// ignore empty segment errors marked as gap
if((_data$frag=data.frag)!=null&&_data$frag.gap){data.errorAction={action:NetworkErrorAction.DoNothing,flags:ErrorActionFlags.None};return;}// falls through
case ErrorDetails.FRAG_GAP:case ErrorDetails.FRAG_DECRYPT_ERROR:{// Switch level if possible, otherwise allow retry count to reach max error retries
data.errorAction=this.getFragRetryOrSwitchAction(data);data.errorAction.action=NetworkErrorAction.SendAlternateToPenaltyBox;return;}case ErrorDetails.LEVEL_EMPTY_ERROR:case ErrorDetails.LEVEL_PARSING_ERROR:{var _data$context,_data$context$levelDe;// Only retry when empty and live
var levelIndex=data.parent===PlaylistLevelType.MAIN?data.level:hls.loadLevel;if(data.details===ErrorDetails.LEVEL_EMPTY_ERROR&&!!((_data$context=data.context)!=null&&(_data$context$levelDe=_data$context.levelDetails)!=null&&_data$context$levelDe.live)){data.errorAction=this.getPlaylistRetryOrSwitchAction(data,levelIndex);}else {// Escalate to fatal if not retrying or switching
data.levelRetry=false;data.errorAction=this.getLevelSwitchAction(data,levelIndex);}}return;case ErrorDetails.LEVEL_LOAD_ERROR:case ErrorDetails.LEVEL_LOAD_TIMEOUT:if(typeof(context==null?void 0:context.level)==='number'){data.errorAction=this.getPlaylistRetryOrSwitchAction(data,context.level);}return;case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:case ErrorDetails.SUBTITLE_LOAD_ERROR:case ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:if(context){var level=hls.levels[hls.loadLevel];if(level&&(context.type===PlaylistContextType.AUDIO_TRACK&&level.hasAudioGroup(context.groupId)||context.type===PlaylistContextType.SUBTITLE_TRACK&&level.hasSubtitleGroup(context.groupId))){// Perform Pathway switch or Redundant failover if possible for fastest recovery
// otherwise allow playlist retry count to reach max error retries
data.errorAction=this.getPlaylistRetryOrSwitchAction(data,hls.loadLevel);data.errorAction.action=NetworkErrorAction.SendAlternateToPenaltyBox;data.errorAction.flags=ErrorActionFlags.MoveAllAlternatesMatchingHost;return;}}return;case ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:{var _level3=hls.levels[hls.loadLevel];var restrictedHdcpLevel=_level3==null?void 0:_level3.attrs['HDCP-LEVEL'];if(restrictedHdcpLevel){data.errorAction={action:NetworkErrorAction.SendAlternateToPenaltyBox,flags:ErrorActionFlags.MoveAllAlternatesMatchingHDCP,hdcpLevel:restrictedHdcpLevel};}else {this.keySystemError(data);}}return;case ErrorDetails.BUFFER_ADD_CODEC_ERROR:case ErrorDetails.REMUX_ALLOC_ERROR:case ErrorDetails.BUFFER_APPEND_ERROR:data.errorAction=this.getLevelSwitchAction(data,(_data$level=data.level)!=null?_data$level:hls.loadLevel);return;case ErrorDetails.INTERNAL_EXCEPTION:case ErrorDetails.BUFFER_APPENDING_ERROR:case ErrorDetails.BUFFER_FULL_ERROR:case ErrorDetails.LEVEL_SWITCH_ERROR:case ErrorDetails.BUFFER_STALLED_ERROR:case ErrorDetails.BUFFER_SEEK_OVER_HOLE:case ErrorDetails.BUFFER_NUDGE_ON_STALL:data.errorAction={action:NetworkErrorAction.DoNothing,flags:ErrorActionFlags.None};return;}if(data.type===ErrorTypes.KEY_SYSTEM_ERROR){this.keySystemError(data);}}},{key:"keySystemError",value:function keySystemError(data){var levelIndex=this.getVariantLevelIndex(data.frag);// Do not retry level. Escalate to fatal if switching levels fails.
data.levelRetry=false;data.errorAction=this.getLevelSwitchAction(data,levelIndex);}},{key:"getPlaylistRetryOrSwitchAction",value:function getPlaylistRetryOrSwitchAction(data,levelIndex){var hls=this.hls;var retryConfig=getRetryConfig(hls.config.playlistLoadPolicy,data);var retryCount=this.playlistError++;var retry=shouldRetry(retryConfig,retryCount,isTimeoutError(data),data.response);if(retry){return {action:NetworkErrorAction.RetryRequest,flags:ErrorActionFlags.None,retryConfig:retryConfig,retryCount:retryCount};}var errorAction=this.getLevelSwitchAction(data,levelIndex);if(retryConfig){errorAction.retryConfig=retryConfig;errorAction.retryCount=retryCount;}return errorAction;}},{key:"getFragRetryOrSwitchAction",value:function getFragRetryOrSwitchAction(data){var hls=this.hls;// Share fragment error count accross media options (main, audio, subs)
// This allows for level based rendition switching when media option assets fail
var variantLevelIndex=this.getVariantLevelIndex(data.frag);var level=hls.levels[variantLevelIndex];var _hls$config2=hls.config,fragLoadPolicy=_hls$config2.fragLoadPolicy,keyLoadPolicy=_hls$config2.keyLoadPolicy;var retryConfig=getRetryConfig(data.details.startsWith('key')?keyLoadPolicy:fragLoadPolicy,data);var fragmentErrors=hls.levels.reduce(function(acc,level){return acc+level.fragmentError;},0);// Switch levels when out of retried or level index out of bounds
if(level){if(data.details!==ErrorDetails.FRAG_GAP){level.fragmentError++;}var retry=shouldRetry(retryConfig,fragmentErrors,isTimeoutError(data),data.response);if(retry){return {action:NetworkErrorAction.RetryRequest,flags:ErrorActionFlags.None,retryConfig:retryConfig,retryCount:fragmentErrors};}}// Reach max retry count, or Missing level reference
// Switch to valid index
var errorAction=this.getLevelSwitchAction(data,variantLevelIndex);// Add retry details to allow skipping of FRAG_PARSING_ERROR
if(retryConfig){errorAction.retryConfig=retryConfig;errorAction.retryCount=fragmentErrors;}return errorAction;}},{key:"getLevelSwitchAction",value:function getLevelSwitchAction(data,levelIndex){var hls=this.hls;if(levelIndex===null||levelIndex===undefined){levelIndex=hls.loadLevel;}var level=this.hls.levels[levelIndex];if(level){var _data$frag2,_data$context2;var errorDetails=data.details;level.loadError++;if(errorDetails===ErrorDetails.BUFFER_APPEND_ERROR){level.fragmentError++;}// Search for next level to retry
var nextLevel=-1;var levels=hls.levels,loadLevel=hls.loadLevel,minAutoLevel=hls.minAutoLevel,maxAutoLevel=hls.maxAutoLevel;if(!hls.autoLevelEnabled){hls.loadLevel=-1;}var fragErrorType=(_data$frag2=data.frag)==null?void 0:_data$frag2.type;// Find alternate audio codec if available on audio codec error
var isAudioCodecError=fragErrorType===PlaylistLevelType.AUDIO&&errorDetails===ErrorDetails.FRAG_PARSING_ERROR||data.sourceBufferName==='audio'&&(errorDetails===ErrorDetails.BUFFER_ADD_CODEC_ERROR||errorDetails===ErrorDetails.BUFFER_APPEND_ERROR);var findAudioCodecAlternate=isAudioCodecError&&levels.some(function(_ref4){var audioCodec=_ref4.audioCodec;return level.audioCodec!==audioCodec;});// Find alternate video codec if available on video codec error
var isVideoCodecError=data.sourceBufferName==='video'&&(errorDetails===ErrorDetails.BUFFER_ADD_CODEC_ERROR||errorDetails===ErrorDetails.BUFFER_APPEND_ERROR);var findVideoCodecAlternate=isVideoCodecError&&levels.some(function(_ref5){var codecSet=_ref5.codecSet,audioCodec=_ref5.audioCodec;return level.codecSet!==codecSet&&level.audioCodec===audioCodec;});var _ref6=(_data$context2=data.context)!=null?_data$context2:{},playlistErrorType=_ref6.type,playlistErrorGroupId=_ref6.groupId;var _loop3=function _loop3(){var candidate=(i+loadLevel)%levels.length;if(candidate!==loadLevel&&candidate>=minAutoLevel&&candidate<=maxAutoLevel&&levels[candidate].loadError===0){var levelCandidate=levels[candidate];// Skip level switch if GAP tag is found in next level at same position
if(errorDetails===ErrorDetails.FRAG_GAP&&fragErrorType===PlaylistLevelType.MAIN&&data.frag){var levelDetails=levels[candidate].details;if(levelDetails){var fragCandidate=findFragmentByPTS(data.frag,levelDetails.fragments,data.frag.start);if(fragCandidate!=null&&fragCandidate.gap){return 0;// continue
}}}else if(playlistErrorType===PlaylistContextType.AUDIO_TRACK&&levelCandidate.hasAudioGroup(playlistErrorGroupId)||playlistErrorType===PlaylistContextType.SUBTITLE_TRACK&&levelCandidate.hasSubtitleGroup(playlistErrorGroupId)){// For audio/subs playlist errors find another group ID or fallthrough to redundant fail-over
return 0;// continue
}else if(fragErrorType===PlaylistLevelType.AUDIO&&(_level$audioGroups=level.audioGroups)!=null&&_level$audioGroups.some(function(groupId){return levelCandidate.hasAudioGroup(groupId);})||fragErrorType===PlaylistLevelType.SUBTITLE&&(_level$subtitleGroups=level.subtitleGroups)!=null&&_level$subtitleGroups.some(function(groupId){return levelCandidate.hasSubtitleGroup(groupId);})||findAudioCodecAlternate&&level.audioCodec===levelCandidate.audioCodec||!findAudioCodecAlternate&&level.audioCodec!==levelCandidate.audioCodec||findVideoCodecAlternate&&level.codecSet===levelCandidate.codecSet){// For video/audio/subs frag errors find another group ID or fallthrough to redundant fail-over
return 0;// continue
}nextLevel=candidate;return 1;// break
}},_level$audioGroups,_level$subtitleGroups,_ret;for(var i=levels.length;i--;){_ret=_loop3();if(_ret===0)continue;if(_ret===1)break;}if(nextLevel>-1&&hls.loadLevel!==nextLevel){data.levelRetry=true;this.playlistError=0;return {action:NetworkErrorAction.SendAlternateToPenaltyBox,flags:ErrorActionFlags.None,nextAutoLevel:nextLevel};}}// No levels to switch / Manual level selection / Level not found
// Resolve with Pathway switch, Redundant fail-over, or stay on lowest Level
return {action:NetworkErrorAction.SendAlternateToPenaltyBox,flags:ErrorActionFlags.MoveAllAlternatesMatchingHost};}},{key:"onErrorOut",value:function onErrorOut(event,data){var _data$errorAction;switch((_data$errorAction=data.errorAction)==null?void 0:_data$errorAction.action){case NetworkErrorAction.DoNothing:break;case NetworkErrorAction.SendAlternateToPenaltyBox:this.sendAlternateToPenaltyBox(data);if(!data.errorAction.resolved&&data.details!==ErrorDetails.FRAG_GAP){data.fatal=true;}else if(/MediaSource readyState: ended/.test(data.error.message)){this.warn("MediaSource ended after \"".concat(data.sourceBufferName,"\" sourceBuffer append error. Attempting to recover from media error."));this.hls.recoverMediaError();}break;}if(data.fatal){this.hls.stopLoad();return;}}},{key:"sendAlternateToPenaltyBox",value:function sendAlternateToPenaltyBox(data){var hls=this.hls;var errorAction=data.errorAction;if(!errorAction){return;}var flags=errorAction.flags,hdcpLevel=errorAction.hdcpLevel,nextAutoLevel=errorAction.nextAutoLevel;switch(flags){case ErrorActionFlags.None:this.switchLevel(data,nextAutoLevel);break;case ErrorActionFlags.MoveAllAlternatesMatchingHDCP:if(hdcpLevel){hls.maxHdcpLevel=HdcpLevels[HdcpLevels.indexOf(hdcpLevel)-1];errorAction.resolved=true;}this.warn("Restricting playback to HDCP-LEVEL of \"".concat(hls.maxHdcpLevel,"\" or lower"));break;}// If not resolved by previous actions try to switch to next level
if(!errorAction.resolved){this.switchLevel(data,nextAutoLevel);}}},{key:"switchLevel",value:function switchLevel(data,levelIndex){if(levelIndex!==undefined&&data.errorAction){this.warn("switching to level ".concat(levelIndex," after ").concat(data.details));this.hls.nextAutoLevel=levelIndex;data.errorAction.resolved=true;// Stream controller is responsible for this but won't switch on false start
this.hls.nextLoadLevel=this.hls.nextAutoLevel;}}}]);return ErrorController;}();var BasePlaylistController=/*#__PURE__*/function(){function BasePlaylistController(hls,logPrefix){_classCallCheck(this,BasePlaylistController);this.hls=void 0;this.timer=-1;this.requestScheduled=-1;this.canLoad=false;this.log=void 0;this.warn=void 0;this.log=logger.log.bind(logger,"".concat(logPrefix,":"));this.warn=logger.warn.bind(logger,"".concat(logPrefix,":"));this.hls=hls;}_createClass(BasePlaylistController,[{key:"destroy",value:function destroy(){this.clearTimer();// @ts-ignore
this.hls=this.log=this.warn=null;}},{key:"clearTimer",value:function clearTimer(){if(this.timer!==-1){self.clearTimeout(this.timer);this.timer=-1;}}},{key:"startLoad",value:function startLoad(){this.canLoad=true;this.requestScheduled=-1;this.loadPlaylist();}},{key:"stopLoad",value:function stopLoad(){this.canLoad=false;this.clearTimer();}},{key:"switchParams",value:function switchParams(playlistUri,previous,current){var renditionReports=previous==null?void 0:previous.renditionReports;if(renditionReports){var foundIndex=-1;for(var i=0;i<renditionReports.length;i++){var attr=renditionReports[i];var uri=void 0;try{uri=new self.URL(attr.URI,previous.url).href;}catch(error){logger.warn("Could not construct new URL for Rendition Report: ".concat(error));uri=attr.URI||'';}// Use exact match. Otherwise, the last partial match, if any, will be used
// (Playlist URI includes a query string that the Rendition Report does not)
if(uri===playlistUri){foundIndex=i;break;}else if(uri===playlistUri.substring(0,uri.length)){foundIndex=i;}}if(foundIndex!==-1){var _attr=renditionReports[foundIndex];var msn=parseInt(_attr['LAST-MSN'])||(previous==null?void 0:previous.lastPartSn);var part=parseInt(_attr['LAST-PART'])||(previous==null?void 0:previous.lastPartIndex);if(this.hls.config.lowLatencyMode){var currentGoal=Math.min(previous.age-previous.partTarget,previous.targetduration);if(part>=0&&currentGoal>previous.partTarget){part+=1;}}var skip=current&&getSkipValue(current);return new HlsUrlParameters(msn,part>=0?part:undefined,skip);}}}},{key:"loadPlaylist",value:function loadPlaylist(hlsUrlParameters){if(this.requestScheduled===-1){this.requestScheduled=self.performance.now();}// Loading is handled by the subclasses
}},{key:"shouldLoadPlaylist",value:function shouldLoadPlaylist(playlist){return this.canLoad&&!!playlist&&!!playlist.url&&(!playlist.details||playlist.details.live);}},{key:"shouldReloadPlaylist",value:function shouldReloadPlaylist(playlist){return this.timer===-1&&this.requestScheduled===-1&&this.shouldLoadPlaylist(playlist);}},{key:"playlistLoaded",value:function playlistLoaded(index,data,previousDetails){var _this7=this;var details=data.details,stats=data.stats;// Set last updated date-time
var now=self.performance.now();var elapsed=stats.loading.first?Math.max(0,now-stats.loading.first):0;details.advancedDateTime=Date.now()-elapsed;// if current playlist is a live playlist, arm a timer to reload it
if(details.live||previousDetails!=null&&previousDetails.live){details.reloaded(previousDetails);if(previousDetails){this.log("live playlist ".concat(index," ").concat(details.advanced?'REFRESHED '+details.lastPartSn+'-'+details.lastPartIndex:details.updated?'UPDATED':'MISSED'));}// Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
if(previousDetails&&details.fragments.length>0){mergeDetails(previousDetails,details);}if(!this.canLoad||!details.live){return;}var deliveryDirectives;var msn=undefined;var part=undefined;if(details.canBlockReload&&details.endSN&&details.advanced){// Load level with LL-HLS delivery directives
var lowLatencyMode=this.hls.config.lowLatencyMode;var lastPartSn=details.lastPartSn;var endSn=details.endSN;var lastPartIndex=details.lastPartIndex;var hasParts=lastPartIndex!==-1;var lastPart=lastPartSn===endSn;// When low latency mode is disabled, we'll skip part requests once the last part index is found
var nextSnStartIndex=lowLatencyMode?0:lastPartIndex;if(hasParts){msn=lastPart?endSn+1:lastPartSn;part=lastPart?nextSnStartIndex:lastPartIndex+1;}else {msn=endSn+1;}// Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
// Update directives to obtain the Playlist that has the estimated additional duration of media
var lastAdvanced=details.age;var cdnAge=lastAdvanced+details.ageHeader;var currentGoal=Math.min(cdnAge-details.partTarget,details.targetduration*1.5);if(currentGoal>0){if(previousDetails&&currentGoal>previousDetails.tuneInGoal){// If we attempted to get the next or latest playlist update, but currentGoal increased,
// then we either can't catchup, or the "age" header cannot be trusted.
this.warn("CDN Tune-in goal increased from: ".concat(previousDetails.tuneInGoal," to: ").concat(currentGoal," with playlist age: ").concat(details.age));currentGoal=0;}else {var segments=Math.floor(currentGoal/details.targetduration);msn+=segments;if(part!==undefined){var parts=Math.round(currentGoal%details.targetduration/details.partTarget);part+=parts;}this.log("CDN Tune-in age: ".concat(details.ageHeader,"s last advanced ").concat(lastAdvanced.toFixed(2),"s goal: ").concat(currentGoal," skip sn ").concat(segments," to part ").concat(part));}details.tuneInGoal=currentGoal;}deliveryDirectives=this.getDeliveryDirectives(details,data.deliveryDirectives,msn,part);if(lowLatencyMode||!lastPart){this.loadPlaylist(deliveryDirectives);return;}}else if(details.canBlockReload||details.canSkipUntil){deliveryDirectives=this.getDeliveryDirectives(details,data.deliveryDirectives,msn,part);}var bufferInfo=this.hls.mainForwardBufferInfo;var position=bufferInfo?bufferInfo.end-bufferInfo.len:0;var distanceToLiveEdgeMs=(details.edge-position)*1000;var reloadInterval=computeReloadInterval(details,distanceToLiveEdgeMs);if(details.updated&&now>this.requestScheduled+reloadInterval){this.requestScheduled=stats.loading.start;}if(msn!==undefined&&details.canBlockReload){this.requestScheduled=stats.loading.first+reloadInterval-(details.partTarget*1000||1000);}else if(this.requestScheduled===-1||this.requestScheduled+reloadInterval<now){this.requestScheduled=now;}else if(this.requestScheduled-now<=0){this.requestScheduled+=reloadInterval;}var estimatedTimeUntilUpdate=this.requestScheduled-now;estimatedTimeUntilUpdate=Math.max(0,estimatedTimeUntilUpdate);this.log("reload live playlist ".concat(index," in ").concat(Math.round(estimatedTimeUntilUpdate)," ms"));// this.log(
//   `live reload ${details.updated ? 'REFRESHED' : 'MISSED'}
// reload in ${estimatedTimeUntilUpdate / 1000}
// round trip ${(stats.loading.end - stats.loading.start) / 1000}
// diff ${
//   (reloadInterval -
//     (estimatedTimeUntilUpdate +
//       stats.loading.end -
//       stats.loading.start)) /
//   1000
// }
// reload interval ${reloadInterval / 1000}
// target duration ${details.targetduration}
// distance to edge ${distanceToLiveEdgeMs / 1000}`
// );
this.timer=self.setTimeout(function(){return _this7.loadPlaylist(deliveryDirectives);},estimatedTimeUntilUpdate);}else {this.clearTimer();}}},{key:"getDeliveryDirectives",value:function getDeliveryDirectives(details,previousDeliveryDirectives,msn,part){var skip=getSkipValue(details);if(previousDeliveryDirectives!=null&&previousDeliveryDirectives.skip&&details.deltaUpdateFailed){msn=previousDeliveryDirectives.msn;part=previousDeliveryDirectives.part;skip=HlsSkip.No;}return new HlsUrlParameters(msn,part,skip);}},{key:"checkRetry",value:function checkRetry(errorEvent){var _this8=this;var errorDetails=errorEvent.details;var isTimeout=isTimeoutError(errorEvent);var errorAction=errorEvent.errorAction;var _ref7=errorAction||{},action=_ref7.action,_ref7$retryCount=_ref7.retryCount,retryCount=_ref7$retryCount===void 0?0:_ref7$retryCount,retryConfig=_ref7.retryConfig;var retry=!!errorAction&&!!retryConfig&&(action===NetworkErrorAction.RetryRequest||!errorAction.resolved&&action===NetworkErrorAction.SendAlternateToPenaltyBox);if(retry){var _errorEvent$context;this.requestScheduled=-1;if(retryCount>=retryConfig.maxNumRetry){return false;}if(isTimeout&&(_errorEvent$context=errorEvent.context)!=null&&_errorEvent$context.deliveryDirectives){// The LL-HLS request already timed out so retry immediately
this.warn("Retrying playlist loading ".concat(retryCount+1,"/").concat(retryConfig.maxNumRetry," after \"").concat(errorDetails,"\" without delivery-directives"));this.loadPlaylist();}else {var delay=getRetryDelay(retryConfig,retryCount);// Schedule level/track reload
this.timer=self.setTimeout(function(){return _this8.loadPlaylist();},delay);this.warn("Retrying playlist loading ".concat(retryCount+1,"/").concat(retryConfig.maxNumRetry," after \"").concat(errorDetails,"\" in ").concat(delay,"ms"));}// `levelRetry = true` used to inform other controllers that a retry is happening
errorEvent.levelRetry=true;errorAction.resolved=true;}return retry;}}]);return BasePlaylistController;}();/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */var EWMA=/*#__PURE__*/function(){//  About half of the estimated value will be from the last |halfLife| samples by weight.
function EWMA(halfLife){var estimate=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var weight=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;_classCallCheck(this,EWMA);this.halfLife=void 0;this.alpha_=void 0;this.estimate_=void 0;this.totalWeight_=void 0;this.halfLife=halfLife;// Larger values of alpha expire historical data more slowly.
this.alpha_=halfLife?Math.exp(Math.log(0.5)/halfLife):0;this.estimate_=estimate;this.totalWeight_=weight;}_createClass(EWMA,[{key:"sample",value:function sample(weight,value){var adjAlpha=Math.pow(this.alpha_,weight);this.estimate_=value*(1-adjAlpha)+adjAlpha*this.estimate_;this.totalWeight_+=weight;}},{key:"getTotalWeight",value:function getTotalWeight(){return this.totalWeight_;}},{key:"getEstimate",value:function getEstimate(){if(this.alpha_){var zeroFactor=1-Math.pow(this.alpha_,this.totalWeight_);if(zeroFactor){return this.estimate_/zeroFactor;}}return this.estimate_;}}]);return EWMA;}();/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */var EwmaBandWidthEstimator=/*#__PURE__*/function(){function EwmaBandWidthEstimator(slow,fast,defaultEstimate){var defaultTTFB=arguments.length>3&&arguments[3]!==undefined?arguments[3]:100;_classCallCheck(this,EwmaBandWidthEstimator);this.defaultEstimate_=void 0;this.minWeight_=void 0;this.minDelayMs_=void 0;this.slow_=void 0;this.fast_=void 0;this.defaultTTFB_=void 0;this.ttfb_=void 0;this.defaultEstimate_=defaultEstimate;this.minWeight_=0.001;this.minDelayMs_=50;this.slow_=new EWMA(slow);this.fast_=new EWMA(fast);this.defaultTTFB_=defaultTTFB;this.ttfb_=new EWMA(slow);}_createClass(EwmaBandWidthEstimator,[{key:"update",value:function update(slow,fast){var slow_=this.slow_,fast_=this.fast_,ttfb_=this.ttfb_;if(slow_.halfLife!==slow){this.slow_=new EWMA(slow,slow_.getEstimate(),slow_.getTotalWeight());}if(fast_.halfLife!==fast){this.fast_=new EWMA(fast,fast_.getEstimate(),fast_.getTotalWeight());}if(ttfb_.halfLife!==slow){this.ttfb_=new EWMA(slow,ttfb_.getEstimate(),ttfb_.getTotalWeight());}}},{key:"sample",value:function sample(durationMs,numBytes){durationMs=Math.max(durationMs,this.minDelayMs_);var numBits=8*numBytes;// weight is duration in seconds
var durationS=durationMs/1000;// value is bandwidth in bits/s
var bandwidthInBps=numBits/durationS;this.fast_.sample(durationS,bandwidthInBps);this.slow_.sample(durationS,bandwidthInBps);}},{key:"sampleTTFB",value:function sampleTTFB(ttfb){// weight is frequency curve applied to TTFB in seconds
// (longer times have less weight with expected input under 1 second)
var seconds=ttfb/1000;var weight=Math.sqrt(2)*Math.exp(-Math.pow(seconds,2)/2);this.ttfb_.sample(weight,Math.max(ttfb,5));}},{key:"canEstimate",value:function canEstimate(){return this.fast_.getTotalWeight()>=this.minWeight_;}},{key:"getEstimate",value:function getEstimate(){if(this.canEstimate()){// console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
// console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
// Take the minimum of these two estimates.  This should have the effect of
// adapting down quickly, but up more slowly.
return Math.min(this.fast_.getEstimate(),this.slow_.getEstimate());}else {return this.defaultEstimate_;}}},{key:"getEstimateTTFB",value:function getEstimateTTFB(){if(this.ttfb_.getTotalWeight()>=this.minWeight_){return this.ttfb_.getEstimate();}else {return this.defaultTTFB_;}}},{key:"destroy",value:function destroy(){}}]);return EwmaBandWidthEstimator;}();var SUPPORTED_INFO_DEFAULT={supported:true,configurations:[],decodingInfoResults:[{supported:true,powerEfficient:true,smooth:true}]};var SUPPORTED_INFO_CACHE={};function requiresMediaCapabilitiesDecodingInfo(level,audioTracksByGroup,currentVideoRange,currentFrameRate,currentBw,audioPreference){// Only test support when configuration is exceeds minimum options
var audioGroups=level.audioCodec?level.audioGroups:null;var audioCodecPreference=audioPreference==null?void 0:audioPreference.audioCodec;var channelsPreference=audioPreference==null?void 0:audioPreference.channels;var maxChannels=channelsPreference?parseInt(channelsPreference):audioCodecPreference?Infinity:2;var audioChannels=null;if(audioGroups!=null&&audioGroups.length){try{if(audioGroups.length===1&&audioGroups[0]){audioChannels=audioTracksByGroup.groups[audioGroups[0]].channels;}else {audioChannels=audioGroups.reduce(function(acc,groupId){if(groupId){var audioTrackGroup=audioTracksByGroup.groups[groupId];if(!audioTrackGroup){throw new Error("Audio track group ".concat(groupId," not found"));}// Sum all channel key values
Object.keys(audioTrackGroup.channels).forEach(function(key){acc[key]=(acc[key]||0)+audioTrackGroup.channels[key];});}return acc;},{2:0});}}catch(error){return true;}}return level.videoCodec!==undefined&&(level.width>1920&&level.height>1088||level.height>1920&&level.width>1088||level.frameRate>Math.max(currentFrameRate,30)||level.videoRange!=='SDR'&&level.videoRange!==currentVideoRange||level.bitrate>Math.max(currentBw,8e6))||!!audioChannels&&isFiniteNumber(maxChannels)&&Object.keys(audioChannels).some(function(channels){return parseInt(channels)>maxChannels;});}function getMediaDecodingInfoPromise(level,audioTracksByGroup,mediaCapabilities){var videoCodecs=level.videoCodec;var audioCodecs=level.audioCodec;if(!videoCodecs||!audioCodecs||!mediaCapabilities){return Promise.resolve(SUPPORTED_INFO_DEFAULT);}var baseVideoConfiguration={width:level.width,height:level.height,bitrate:Math.ceil(Math.max(level.bitrate*0.9,level.averageBitrate)),// Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
framerate:level.frameRate||30};var videoRange=level.videoRange;if(videoRange!=='SDR'){baseVideoConfiguration.transferFunction=videoRange.toLowerCase();}var configurations=videoCodecs.split(',').map(function(videoCodec){return {type:'media-source',video:_objectSpread2$2(_objectSpread2$2({},baseVideoConfiguration),{},{contentType:mimeTypeForCodec(videoCodec,'video')})};});if(audioCodecs&&level.audioGroups){level.audioGroups.forEach(function(audioGroupId){var _audioTracksByGroup$g;if(!audioGroupId){return;}(_audioTracksByGroup$g=audioTracksByGroup.groups[audioGroupId])==null?void 0:_audioTracksByGroup$g.tracks.forEach(function(audioTrack){if(audioTrack.groupId===audioGroupId){var channels=audioTrack.channels||'';var channelsNumber=parseFloat(channels);if(isFiniteNumber(channelsNumber)&&channelsNumber>2){configurations.push.apply(configurations,audioCodecs.split(',').map(function(audioCodec){return {type:'media-source',audio:{contentType:mimeTypeForCodec(audioCodec,'audio'),channels:''+channelsNumber// spatialRendering:
//   audioCodec === 'ec-3' && channels.indexOf('JOC'),
}};}));}}});});}return Promise.all(configurations.map(function(configuration){// Cache MediaCapabilities promises
var decodingInfoKey=getMediaDecodingInfoKey(configuration);return SUPPORTED_INFO_CACHE[decodingInfoKey]||(SUPPORTED_INFO_CACHE[decodingInfoKey]=mediaCapabilities.decodingInfo(configuration));})).then(function(decodingInfoResults){return {supported:!decodingInfoResults.some(function(info){return !info.supported;}),configurations:configurations,decodingInfoResults:decodingInfoResults};})["catch"](function(error){return {supported:false,configurations:configurations,decodingInfoResults:[],error:error};});}function getMediaDecodingInfoKey(config){var audio=config.audio,video=config.video;var mediaConfig=video||audio;if(mediaConfig){var codec=mediaConfig.contentType.split('"')[1];if(video){return "r".concat(video.height,"x").concat(video.width,"f").concat(Math.ceil(video.framerate)).concat(video.transferFunction||'sd',"_").concat(codec,"_").concat(Math.ceil(video.bitrate/1e5));}if(audio){return "c".concat(audio.channels).concat(audio.spatialRendering?'s':'n',"_").concat(codec);}}return '';}/**
 * @returns Whether we can detect and validate HDR capability within the window context
 */function isHdrSupported(){if(typeof matchMedia==='function'){var mediaQueryList=matchMedia('(dynamic-range: high)');var badQuery=matchMedia('bad query');if(mediaQueryList.media!==badQuery.media){return mediaQueryList.matches===true;}}return false;}/**
 * Sanitizes inputs to return the active video selection options for HDR/SDR.
 * When both inputs are null:
 *
 *    `{ preferHDR: false, allowedVideoRanges: [] }`
 *
 * When `currentVideoRange` non-null, maintain the active range:
 *
 *    `{ preferHDR: currentVideoRange !== 'SDR', allowedVideoRanges: [currentVideoRange] }`
 *
 * When VideoSelectionOption non-null:
 *
 *  - Allow all video ranges if `allowedVideoRanges` unspecified.
 *  - If `preferHDR` is non-null use the value to filter `allowedVideoRanges`.
 *  - Else check window for HDR support and set `preferHDR` to the result.
 *
 * @param currentVideoRange
 * @param videoPreference
 */function getVideoSelectionOptions(currentVideoRange,videoPreference){var preferHDR=false;var allowedVideoRanges=[];if(currentVideoRange){preferHDR=currentVideoRange!=='SDR';allowedVideoRanges=[currentVideoRange];}if(videoPreference){allowedVideoRanges=videoPreference.allowedVideoRanges||VideoRangeValues.slice(0);preferHDR=videoPreference.preferHDR!==undefined?videoPreference.preferHDR:isHdrSupported();if(preferHDR){allowedVideoRanges=allowedVideoRanges.filter(function(range){return range!=='SDR';});}else {allowedVideoRanges=['SDR'];}}return {preferHDR:preferHDR,allowedVideoRanges:allowedVideoRanges};}function getStartCodecTier(codecTiers,currentVideoRange,currentBw,audioPreference,videoPreference){var codecSets=Object.keys(codecTiers);var channelsPreference=audioPreference==null?void 0:audioPreference.channels;var audioCodecPreference=audioPreference==null?void 0:audioPreference.audioCodec;var preferStereo=channelsPreference&&parseInt(channelsPreference)===2;// Use first level set to determine stereo, and minimum resolution and framerate
var hasStereo=true;var hasCurrentVideoRange=false;var minHeight=Infinity;var minFramerate=Infinity;var minBitrate=Infinity;var selectedScore=0;var videoRanges=[];var _getVideoSelectionOpt=getVideoSelectionOptions(currentVideoRange,videoPreference),preferHDR=_getVideoSelectionOpt.preferHDR,allowedVideoRanges=_getVideoSelectionOpt.allowedVideoRanges;var _loop4=function _loop4(){var tier=codecTiers[codecSets[i]];hasStereo=tier.channels[2]>0;minHeight=Math.min(minHeight,tier.minHeight);minFramerate=Math.min(minFramerate,tier.minFramerate);minBitrate=Math.min(minBitrate,tier.minBitrate);var matchingVideoRanges=allowedVideoRanges.filter(function(range){return tier.videoRanges[range]>0;});if(matchingVideoRanges.length>0){hasCurrentVideoRange=true;videoRanges=matchingVideoRanges;}};for(var i=codecSets.length;i--;){_loop4();}minHeight=isFiniteNumber(minHeight)?minHeight:0;minFramerate=isFiniteNumber(minFramerate)?minFramerate:0;var maxHeight=Math.max(1080,minHeight);var maxFramerate=Math.max(30,minFramerate);minBitrate=isFiniteNumber(minBitrate)?minBitrate:currentBw;currentBw=Math.max(minBitrate,currentBw);// If there are no variants with matching preference, set currentVideoRange to undefined
if(!hasCurrentVideoRange){currentVideoRange=undefined;videoRanges=[];}var codecSet=codecSets.reduce(function(selected,candidate){// Remove candiates which do not meet bitrate, default audio, stereo or channels preference, 1080p or lower, 30fps or lower, or SDR/HDR selection if present
var candidateTier=codecTiers[candidate];if(candidate===selected){return selected;}if(candidateTier.minBitrate>currentBw){logStartCodecCandidateIgnored(candidate,"min bitrate of ".concat(candidateTier.minBitrate," > current estimate of ").concat(currentBw));return selected;}if(!candidateTier.hasDefaultAudio){logStartCodecCandidateIgnored(candidate,"no renditions with default or auto-select sound found");return selected;}if(audioCodecPreference&&candidate.indexOf(audioCodecPreference.substring(0,4))%5!==0){logStartCodecCandidateIgnored(candidate,"audio codec preference \"".concat(audioCodecPreference,"\" not found"));return selected;}if(channelsPreference&&!preferStereo){if(!candidateTier.channels[channelsPreference]){logStartCodecCandidateIgnored(candidate,"no renditions with ".concat(channelsPreference," channel sound found (channels options: ").concat(Object.keys(candidateTier.channels),")"));return selected;}}else if((!audioCodecPreference||preferStereo)&&hasStereo&&candidateTier.channels['2']===0){logStartCodecCandidateIgnored(candidate,"no renditions with stereo sound found");return selected;}if(candidateTier.minHeight>maxHeight){logStartCodecCandidateIgnored(candidate,"min resolution of ".concat(candidateTier.minHeight," > maximum of ").concat(maxHeight));return selected;}if(candidateTier.minFramerate>maxFramerate){logStartCodecCandidateIgnored(candidate,"min framerate of ".concat(candidateTier.minFramerate," > maximum of ").concat(maxFramerate));return selected;}if(!videoRanges.some(function(range){return candidateTier.videoRanges[range]>0;})){logStartCodecCandidateIgnored(candidate,"no variants with VIDEO-RANGE of ".concat(JSON.stringify(videoRanges)," found"));return selected;}if(candidateTier.maxScore<selectedScore){logStartCodecCandidateIgnored(candidate,"max score of ".concat(candidateTier.maxScore," < selected max of ").concat(selectedScore));return selected;}// Remove candiates with less preferred codecs or more errors
if(selected&&(codecsSetSelectionPreferenceValue(candidate)>=codecsSetSelectionPreferenceValue(selected)||candidateTier.fragmentError>codecTiers[selected].fragmentError)){return selected;}selectedScore=candidateTier.maxScore;return candidate;},undefined);return {codecSet:codecSet,videoRanges:videoRanges,preferHDR:preferHDR,minFramerate:minFramerate,minBitrate:minBitrate};}function logStartCodecCandidateIgnored(codeSet,reason){logger.log("[abr] start candidates with \"".concat(codeSet,"\" ignored because ").concat(reason));}function getAudioTracksByGroup(allAudioTracks){return allAudioTracks.reduce(function(audioTracksByGroup,track){var trackGroup=audioTracksByGroup.groups[track.groupId];if(!trackGroup){trackGroup=audioTracksByGroup.groups[track.groupId]={tracks:[],channels:{2:0},hasDefault:false,hasAutoSelect:false};}trackGroup.tracks.push(track);var channelsKey=track.channels||'2';trackGroup.channels[channelsKey]=(trackGroup.channels[channelsKey]||0)+1;trackGroup.hasDefault=trackGroup.hasDefault||track["default"];trackGroup.hasAutoSelect=trackGroup.hasAutoSelect||track.autoselect;if(trackGroup.hasDefault){audioTracksByGroup.hasDefaultAudio=true;}if(trackGroup.hasAutoSelect){audioTracksByGroup.hasAutoSelectAudio=true;}return audioTracksByGroup;},{hasDefaultAudio:false,hasAutoSelectAudio:false,groups:{}});}function getCodecTiers(levels,audioTracksByGroup,minAutoLevel,maxAutoLevel){return levels.slice(minAutoLevel,maxAutoLevel+1).reduce(function(tiers,level){if(!level.codecSet){return tiers;}var audioGroups=level.audioGroups;var tier=tiers[level.codecSet];if(!tier){tiers[level.codecSet]=tier={minBitrate:Infinity,minHeight:Infinity,minFramerate:Infinity,maxScore:0,videoRanges:{SDR:0},channels:{'2':0},hasDefaultAudio:!audioGroups,fragmentError:0};}tier.minBitrate=Math.min(tier.minBitrate,level.bitrate);var lesserWidthOrHeight=Math.min(level.height,level.width);tier.minHeight=Math.min(tier.minHeight,lesserWidthOrHeight);tier.minFramerate=Math.min(tier.minFramerate,level.frameRate);tier.maxScore=Math.max(tier.maxScore,level.score);tier.fragmentError+=level.fragmentError;tier.videoRanges[level.videoRange]=(tier.videoRanges[level.videoRange]||0)+1;if(audioGroups){audioGroups.forEach(function(audioGroupId){if(!audioGroupId){return;}var audioGroup=audioTracksByGroup.groups[audioGroupId];if(!audioGroup){return;}// Default audio is any group with DEFAULT=YES, or if missing then any group with AUTOSELECT=YES, or all variants
tier.hasDefaultAudio=tier.hasDefaultAudio||audioTracksByGroup.hasDefaultAudio?audioGroup.hasDefault:audioGroup.hasAutoSelect||!audioTracksByGroup.hasDefaultAudio&&!audioTracksByGroup.hasAutoSelectAudio;Object.keys(audioGroup.channels).forEach(function(channels){tier.channels[channels]=(tier.channels[channels]||0)+audioGroup.channels[channels];});});}return tiers;},{});}function findMatchingOption(option,tracks,matchPredicate){if('attrs'in option){var index=tracks.indexOf(option);if(index!==-1){return index;}}for(var i=0;i<tracks.length;i++){var track=tracks[i];if(matchesOption(option,track,matchPredicate)){return i;}}return -1;}function matchesOption(option,track,matchPredicate){var groupId=option.groupId,name=option.name,lang=option.lang,assocLang=option.assocLang,characteristics=option.characteristics,isDefault=option["default"];var forced=option.forced;return (groupId===undefined||track.groupId===groupId)&&(name===undefined||track.name===name)&&(lang===undefined||track.lang===lang)&&(lang===undefined||track.assocLang===assocLang)&&(isDefault===undefined||track["default"]===isDefault)&&(forced===undefined||track.forced===forced)&&(characteristics===undefined||characteristicsMatch(characteristics,track.characteristics))&&(matchPredicate===undefined||matchPredicate(option,track));}function characteristicsMatch(characteristicsA){var characteristicsB=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var arrA=characteristicsA.split(',');var arrB=characteristicsB.split(',');// Expects each item to be unique:
return arrA.length===arrB.length&&!arrA.some(function(el){return arrB.indexOf(el)===-1;});}function audioMatchPredicate(option,track){var audioCodec=option.audioCodec,channels=option.channels;return (audioCodec===undefined||(track.audioCodec||'').substring(0,4)===audioCodec.substring(0,4))&&(channels===undefined||channels===(track.channels||'2'));}function findClosestLevelWithAudioGroup(option,levels,allAudioTracks,searchIndex,matchPredicate){var currentLevel=levels[searchIndex];// Are there variants with same URI as current level?
// If so, find a match that does not require any level URI change
var variants=levels.reduce(function(variantMap,level,index){var uri=level.uri;var renditions=variantMap[uri]||(variantMap[uri]=[]);renditions.push(index);return variantMap;},{});var renditions=variants[currentLevel.uri];if(renditions.length>1){searchIndex=Math.max.apply(Math,renditions);}// Find best match
var currentVideoRange=currentLevel.videoRange;var currentFrameRate=currentLevel.frameRate;var currentVideoCodec=currentLevel.codecSet.substring(0,4);var matchingVideo=searchDownAndUpList(levels,searchIndex,function(level){if(level.videoRange!==currentVideoRange||level.frameRate!==currentFrameRate||level.codecSet.substring(0,4)!==currentVideoCodec){return false;}var audioGroups=level.audioGroups;var tracks=allAudioTracks.filter(function(track){return !audioGroups||audioGroups.indexOf(track.groupId)!==-1;});return findMatchingOption(option,tracks,matchPredicate)>-1;});if(matchingVideo>-1){return matchingVideo;}return searchDownAndUpList(levels,searchIndex,function(level){var audioGroups=level.audioGroups;var tracks=allAudioTracks.filter(function(track){return !audioGroups||audioGroups.indexOf(track.groupId)!==-1;});return findMatchingOption(option,tracks,matchPredicate)>-1;});}function searchDownAndUpList(arr,searchIndex,predicate){for(var i=searchIndex;i>-1;i--){if(predicate(arr[i])){return i;}}for(var _i9=searchIndex+1;_i9<arr.length;_i9++){if(predicate(arr[_i9])){return _i9;}}return -1;}var AbrController=/*#__PURE__*/function(){function AbrController(_hls){var _this9=this;_classCallCheck(this,AbrController);this.hls=void 0;this.lastLevelLoadSec=0;this.lastLoadedFragLevel=-1;this.firstSelection=-1;this._nextAutoLevel=-1;this.nextAutoLevelKey='';this.audioTracksByGroup=null;this.codecTiers=null;this.timer=-1;this.fragCurrent=null;this.partCurrent=null;this.bitrateTestDelay=0;this.bwEstimator=void 0;/*
        This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
        quickly enough to prevent underbuffering
      */this._abandonRulesCheck=function(){var frag=_this9.fragCurrent,part=_this9.partCurrent,hls=_this9.hls;var autoLevelEnabled=hls.autoLevelEnabled,media=hls.media;if(!frag||!media){return;}var now=performance.now();var stats=part?part.stats:frag.stats;var duration=part?part.duration:frag.duration;var timeLoading=now-stats.loading.start;var minAutoLevel=hls.minAutoLevel;// If frag loading is aborted, complete, or from lowest level, stop timer and return
if(stats.aborted||stats.loaded&&stats.loaded===stats.total||frag.level<=minAutoLevel){_this9.clearTimer();// reset forced auto level value so that next level will be selected
_this9._nextAutoLevel=-1;return;}// This check only runs if we're in ABR mode and actually playing
if(!autoLevelEnabled||media.paused||!media.playbackRate||!media.readyState){return;}var bufferInfo=hls.mainForwardBufferInfo;if(bufferInfo===null){return;}var ttfbEstimate=_this9.bwEstimator.getEstimateTTFB();var playbackRate=Math.abs(media.playbackRate);// To maintain stable adaptive playback, only begin monitoring frag loading after half or more of its playback duration has passed
if(timeLoading<=Math.max(ttfbEstimate,1000*(duration/(playbackRate*2)))){return;}// bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
var bufferStarvationDelay=bufferInfo.len/playbackRate;var ttfb=stats.loading.first?stats.loading.first-stats.loading.start:-1;var loadedFirstByte=stats.loaded&&ttfb>-1;var bwEstimate=_this9.getBwEstimate();var levels=hls.levels;var level=levels[frag.level];var expectedLen=stats.total||Math.max(stats.loaded,Math.round(duration*level.averageBitrate/8));var timeStreaming=loadedFirstByte?timeLoading-ttfb:timeLoading;if(timeStreaming<1&&loadedFirstByte){timeStreaming=Math.min(timeLoading,stats.loaded*8/bwEstimate);}var loadRate=loadedFirstByte?stats.loaded*1000/timeStreaming:0;// fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
var fragLoadedDelay=loadRate?(expectedLen-stats.loaded)/loadRate:expectedLen*8/bwEstimate+ttfbEstimate/1000;// Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
if(fragLoadedDelay<=bufferStarvationDelay){return;}var bwe=loadRate?loadRate*8:bwEstimate;var fragLevelNextLoadedDelay=Number.POSITIVE_INFINITY;var nextLoadLevel;// Iterate through lower level and try to find the largest one that avoids rebuffering
for(nextLoadLevel=frag.level-1;nextLoadLevel>minAutoLevel;nextLoadLevel--){// compute time to load next fragment at lower level
// 8 = bits per byte (bps/Bps)
var levelNextBitrate=levels[nextLoadLevel].maxBitrate;fragLevelNextLoadedDelay=_this9.getTimeToLoadFrag(ttfbEstimate/1000,bwe,duration*levelNextBitrate,!levels[nextLoadLevel].details);if(fragLevelNextLoadedDelay<bufferStarvationDelay){break;}}// Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
// to load the current one
if(fragLevelNextLoadedDelay>=fragLoadedDelay){return;}// if estimated load time of new segment is completely unreasonable, ignore and do not emergency switch down
if(fragLevelNextLoadedDelay>duration*10){return;}hls.nextLoadLevel=hls.nextAutoLevel=nextLoadLevel;if(loadedFirstByte){// If there has been loading progress, sample bandwidth using loading time offset by minimum TTFB time
_this9.bwEstimator.sample(timeLoading-Math.min(ttfbEstimate,ttfb),stats.loaded);}else {// If there has been no loading progress, sample TTFB
_this9.bwEstimator.sampleTTFB(timeLoading);}var nextLoadLevelBitrate=levels[nextLoadLevel].maxBitrate;if(_this9.getBwEstimate()*_this9.hls.config.abrBandWidthUpFactor>nextLoadLevelBitrate){_this9.resetEstimator(nextLoadLevelBitrate);}_this9.clearTimer();logger.warn("[abr] Fragment ".concat(frag.sn).concat(part?' part '+part.index:''," of level ").concat(frag.level," is loading too slowly;\n      Time to underbuffer: ").concat(bufferStarvationDelay.toFixed(3)," s\n      Estimated load time for current fragment: ").concat(fragLoadedDelay.toFixed(3)," s\n      Estimated load time for down switch fragment: ").concat(fragLevelNextLoadedDelay.toFixed(3)," s\n      TTFB estimate: ").concat(ttfb|0," ms\n      Current BW estimate: ").concat(isFiniteNumber(bwEstimate)?bwEstimate|0:'Unknown'," bps\n      New BW estimate: ").concat(_this9.getBwEstimate()|0," bps\n      Switching to level ").concat(nextLoadLevel," @ ").concat(nextLoadLevelBitrate|0," bps"));hls.trigger(Events.FRAG_LOAD_EMERGENCY_ABORTED,{frag:frag,part:part,stats:stats});};this.hls=_hls;this.bwEstimator=this.initEstimator();this.registerListeners();}_createClass(AbrController,[{key:"resetEstimator",value:function resetEstimator(abrEwmaDefaultEstimate){if(abrEwmaDefaultEstimate){logger.log("setting initial bwe to ".concat(abrEwmaDefaultEstimate));this.hls.config.abrEwmaDefaultEstimate=abrEwmaDefaultEstimate;}this.firstSelection=-1;this.bwEstimator=this.initEstimator();}},{key:"initEstimator",value:function initEstimator(){var config=this.hls.config;return new EwmaBandWidthEstimator(config.abrEwmaSlowVoD,config.abrEwmaFastVoD,config.abrEwmaDefaultEstimate);}},{key:"registerListeners",value:function registerListeners(){var hls=this.hls;hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.FRAG_LOADING,this.onFragLoading,this);hls.on(Events.FRAG_LOADED,this.onFragLoaded,this);hls.on(Events.FRAG_BUFFERED,this.onFragBuffered,this);hls.on(Events.LEVEL_SWITCHING,this.onLevelSwitching,this);hls.on(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.on(Events.LEVELS_UPDATED,this.onLevelsUpdated,this);hls.on(Events.MAX_AUTO_LEVEL_UPDATED,this.onMaxAutoLevelUpdated,this);hls.on(Events.ERROR,this.onError,this);}},{key:"unregisterListeners",value:function unregisterListeners(){var hls=this.hls;if(!hls){return;}hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.FRAG_LOADING,this.onFragLoading,this);hls.off(Events.FRAG_LOADED,this.onFragLoaded,this);hls.off(Events.FRAG_BUFFERED,this.onFragBuffered,this);hls.off(Events.LEVEL_SWITCHING,this.onLevelSwitching,this);hls.off(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.off(Events.LEVELS_UPDATED,this.onLevelsUpdated,this);hls.off(Events.MAX_AUTO_LEVEL_UPDATED,this.onMaxAutoLevelUpdated,this);hls.off(Events.ERROR,this.onError,this);}},{key:"destroy",value:function destroy(){this.unregisterListeners();this.clearTimer();// @ts-ignore
this.hls=this._abandonRulesCheck=null;this.fragCurrent=this.partCurrent=null;}},{key:"onManifestLoading",value:function onManifestLoading(event,data){this.lastLoadedFragLevel=-1;this.firstSelection=-1;this.lastLevelLoadSec=0;this.fragCurrent=this.partCurrent=null;this.onLevelsUpdated();this.clearTimer();}},{key:"onLevelsUpdated",value:function onLevelsUpdated(){if(this.lastLoadedFragLevel>-1&&this.fragCurrent){this.lastLoadedFragLevel=this.fragCurrent.level;}this._nextAutoLevel=-1;this.onMaxAutoLevelUpdated();this.codecTiers=null;this.audioTracksByGroup=null;}},{key:"onMaxAutoLevelUpdated",value:function onMaxAutoLevelUpdated(){this.firstSelection=-1;this.nextAutoLevelKey='';}},{key:"onFragLoading",value:function onFragLoading(event,data){var frag=data.frag;if(this.ignoreFragment(frag)){return;}if(!frag.bitrateTest){var _data$part;this.fragCurrent=frag;this.partCurrent=(_data$part=data.part)!=null?_data$part:null;}this.clearTimer();this.timer=self.setInterval(this._abandonRulesCheck,100);}},{key:"onLevelSwitching",value:function onLevelSwitching(event,data){this.clearTimer();}},{key:"onError",value:function onError(event,data){if(data.fatal){return;}switch(data.details){case ErrorDetails.BUFFER_ADD_CODEC_ERROR:case ErrorDetails.BUFFER_APPEND_ERROR:// Reset last loaded level so that a new selection can be made after calling recoverMediaError
this.lastLoadedFragLevel=-1;this.firstSelection=-1;break;case ErrorDetails.FRAG_LOAD_TIMEOUT:{var frag=data.frag;var fragCurrent=this.fragCurrent,part=this.partCurrent;if(frag&&fragCurrent&&frag.sn===fragCurrent.sn&&frag.level===fragCurrent.level){var _now=performance.now();var stats=part?part.stats:frag.stats;var timeLoading=_now-stats.loading.start;var ttfb=stats.loading.first?stats.loading.first-stats.loading.start:-1;var loadedFirstByte=stats.loaded&&ttfb>-1;if(loadedFirstByte){var ttfbEstimate=this.bwEstimator.getEstimateTTFB();this.bwEstimator.sample(timeLoading-Math.min(ttfbEstimate,ttfb),stats.loaded);}else {this.bwEstimator.sampleTTFB(timeLoading);}}break;}}}},{key:"getTimeToLoadFrag",value:function getTimeToLoadFrag(timeToFirstByteSec,bandwidth,fragSizeBits,isSwitch){var fragLoadSec=timeToFirstByteSec+fragSizeBits/bandwidth;var playlistLoadSec=isSwitch?this.lastLevelLoadSec:0;return fragLoadSec+playlistLoadSec;}},{key:"onLevelLoaded",value:function onLevelLoaded(event,data){var config=this.hls.config;var loading=data.stats.loading;var timeLoadingMs=loading.end-loading.start;if(isFiniteNumber(timeLoadingMs)){this.lastLevelLoadSec=timeLoadingMs/1000;}if(data.details.live){this.bwEstimator.update(config.abrEwmaSlowLive,config.abrEwmaFastLive);}else {this.bwEstimator.update(config.abrEwmaSlowVoD,config.abrEwmaFastVoD);}}},{key:"onFragLoaded",value:function onFragLoaded(event,_ref8){var frag=_ref8.frag,part=_ref8.part;var stats=part?part.stats:frag.stats;if(frag.type===PlaylistLevelType.MAIN){this.bwEstimator.sampleTTFB(stats.loading.first-stats.loading.start);}if(this.ignoreFragment(frag)){return;}// stop monitoring bw once frag loaded
this.clearTimer();// reset forced auto level value so that next level will be selected
if(frag.level===this._nextAutoLevel){this._nextAutoLevel=-1;}this.firstSelection=-1;// compute level average bitrate
if(this.hls.config.abrMaxWithRealBitrate){var duration=part?part.duration:frag.duration;var level=this.hls.levels[frag.level];var loadedBytes=(level.loaded?level.loaded.bytes:0)+stats.loaded;var loadedDuration=(level.loaded?level.loaded.duration:0)+duration;level.loaded={bytes:loadedBytes,duration:loadedDuration};level.realBitrate=Math.round(8*loadedBytes/loadedDuration);}if(frag.bitrateTest){var fragBufferedData={stats:stats,frag:frag,part:part,id:frag.type};this.onFragBuffered(Events.FRAG_BUFFERED,fragBufferedData);frag.bitrateTest=false;}else {// store level id after successful fragment load for playback
this.lastLoadedFragLevel=frag.level;}}},{key:"onFragBuffered",value:function onFragBuffered(event,data){var frag=data.frag,part=data.part;var stats=part!=null&&part.stats.loaded?part.stats:frag.stats;if(stats.aborted){return;}if(this.ignoreFragment(frag)){return;}// Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
// rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
// is used. If we used buffering in that case, our BW estimate sample will be very large.
var processingMs=stats.parsing.end-stats.loading.start-Math.min(stats.loading.first-stats.loading.start,this.bwEstimator.getEstimateTTFB());this.bwEstimator.sample(processingMs,stats.loaded);stats.bwEstimate=this.getBwEstimate();if(frag.bitrateTest){this.bitrateTestDelay=processingMs/1000;}else {this.bitrateTestDelay=0;}}},{key:"ignoreFragment",value:function ignoreFragment(frag){// Only count non-alt-audio frags which were actually buffered in our BW calculations
return frag.type!==PlaylistLevelType.MAIN||frag.sn==='initSegment';}},{key:"clearTimer",value:function clearTimer(){if(this.timer>-1){self.clearInterval(this.timer);this.timer=-1;}}},{key:"firstAutoLevel",get:function get(){var _this$hls2=this.hls,maxAutoLevel=_this$hls2.maxAutoLevel,minAutoLevel=_this$hls2.minAutoLevel;var bwEstimate=this.getBwEstimate();var maxStartDelay=this.hls.config.maxStarvationDelay;var abrAutoLevel=this.findBestLevel(bwEstimate,minAutoLevel,maxAutoLevel,0,maxStartDelay,1,1);if(abrAutoLevel>-1){return abrAutoLevel;}var firstLevel=this.hls.firstLevel;var clamped=Math.min(Math.max(firstLevel,minAutoLevel),maxAutoLevel);logger.warn("[abr] Could not find best starting auto level. Defaulting to first in playlist ".concat(firstLevel," clamped to ").concat(clamped));return clamped;}},{key:"forcedAutoLevel",get:function get(){if(this.nextAutoLevelKey){return -1;}return this._nextAutoLevel;}// return next auto level
},{key:"nextAutoLevel",get:function get(){var forcedAutoLevel=this.forcedAutoLevel;var bwEstimator=this.bwEstimator;var useEstimate=bwEstimator.canEstimate();var loadedFirstFrag=this.lastLoadedFragLevel>-1;// in case next auto level has been forced, and bw not available or not reliable, return forced value
if(forcedAutoLevel!==-1&&(!useEstimate||!loadedFirstFrag||this.nextAutoLevelKey===this.getAutoLevelKey())){return forcedAutoLevel;}// compute next level using ABR logic
var nextABRAutoLevel=useEstimate&&loadedFirstFrag?this.getNextABRAutoLevel():this.firstAutoLevel;// use forced auto level while it hasn't errored more than ABR selection
if(forcedAutoLevel!==-1){var levels=this.hls.levels;if(levels.length>Math.max(forcedAutoLevel,nextABRAutoLevel)&&levels[forcedAutoLevel].loadError<=levels[nextABRAutoLevel].loadError){return forcedAutoLevel;}}// save result until state has changed
this._nextAutoLevel=nextABRAutoLevel;this.nextAutoLevelKey=this.getAutoLevelKey();return nextABRAutoLevel;},set:function set(nextLevel){var _this$hls3=this.hls,maxAutoLevel=_this$hls3.maxAutoLevel,minAutoLevel=_this$hls3.minAutoLevel;var value=Math.min(Math.max(nextLevel,minAutoLevel),maxAutoLevel);if(this._nextAutoLevel!==value){this.nextAutoLevelKey='';this._nextAutoLevel=value;}}},{key:"getAutoLevelKey",value:function getAutoLevelKey(){return "".concat(this.getBwEstimate(),"_").concat(this.getStarvationDelay().toFixed(2));}},{key:"getNextABRAutoLevel",value:function getNextABRAutoLevel(){var fragCurrent=this.fragCurrent,partCurrent=this.partCurrent,hls=this.hls;var maxAutoLevel=hls.maxAutoLevel,config=hls.config,minAutoLevel=hls.minAutoLevel;var currentFragDuration=partCurrent?partCurrent.duration:fragCurrent?fragCurrent.duration:0;var avgbw=this.getBwEstimate();// bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
var bufferStarvationDelay=this.getStarvationDelay();var bwFactor=config.abrBandWidthFactor;var bwUpFactor=config.abrBandWidthUpFactor;// First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
if(bufferStarvationDelay){var _bestLevel=this.findBestLevel(avgbw,minAutoLevel,maxAutoLevel,bufferStarvationDelay,0,bwFactor,bwUpFactor);if(_bestLevel>=0){return _bestLevel;}}// not possible to get rid of rebuffering... try to find level that will guarantee less than maxStarvationDelay of rebuffering
var maxStarvationDelay=currentFragDuration?Math.min(currentFragDuration,config.maxStarvationDelay):config.maxStarvationDelay;if(!bufferStarvationDelay){// in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
var bitrateTestDelay=this.bitrateTestDelay;if(bitrateTestDelay){// if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
// max video loading delay used in  automatic start level selection :
// in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
// the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
// cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
var maxLoadingDelay=currentFragDuration?Math.min(currentFragDuration,config.maxLoadingDelay):config.maxLoadingDelay;maxStarvationDelay=maxLoadingDelay-bitrateTestDelay;logger.info("[abr] bitrate test took ".concat(Math.round(1000*bitrateTestDelay),"ms, set first fragment max fetchDuration to ").concat(Math.round(1000*maxStarvationDelay)," ms"));// don't use conservative factor on bitrate test
bwFactor=bwUpFactor=1;}}var bestLevel=this.findBestLevel(avgbw,minAutoLevel,maxAutoLevel,bufferStarvationDelay,maxStarvationDelay,bwFactor,bwUpFactor);logger.info("[abr] ".concat(bufferStarvationDelay?'rebuffering expected':'buffer is empty',", optimal quality level ").concat(bestLevel));if(bestLevel>-1){return bestLevel;}// If no matching level found, see if min auto level would be a better option
var minLevel=hls.levels[minAutoLevel];var autoLevel=hls.levels[hls.loadLevel];if((minLevel==null?void 0:minLevel.bitrate)<(autoLevel==null?void 0:autoLevel.bitrate)){return minAutoLevel;}// or if bitrate is not lower, continue to use loadLevel
return hls.loadLevel;}},{key:"getStarvationDelay",value:function getStarvationDelay(){var hls=this.hls;var media=hls.media;if(!media){return Infinity;}// playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
// if we're playing back at the normal rate.
var playbackRate=media&&media.playbackRate!==0?Math.abs(media.playbackRate):1.0;var bufferInfo=hls.mainForwardBufferInfo;return (bufferInfo?bufferInfo.len:0)/playbackRate;}},{key:"getBwEstimate",value:function getBwEstimate(){return this.bwEstimator.canEstimate()?this.bwEstimator.getEstimate():this.hls.config.abrEwmaDefaultEstimate;}},{key:"findBestLevel",value:function findBestLevel(currentBw,minAutoLevel,maxAutoLevel,bufferStarvationDelay,maxStarvationDelay,bwFactor,bwUpFactor){var _this10=this;var _level$details;var maxFetchDuration=bufferStarvationDelay+maxStarvationDelay;var lastLoadedFragLevel=this.lastLoadedFragLevel;var selectionBaseLevel=lastLoadedFragLevel===-1?this.hls.firstLevel:lastLoadedFragLevel;var fragCurrent=this.fragCurrent,partCurrent=this.partCurrent;var _this$hls4=this.hls,levels=_this$hls4.levels,allAudioTracks=_this$hls4.allAudioTracks,loadLevel=_this$hls4.loadLevel,config=_this$hls4.config;if(levels.length===1){return 0;}var level=levels[selectionBaseLevel];var live=!!(level!=null&&(_level$details=level.details)!=null&&_level$details.live);var firstSelection=loadLevel===-1||lastLoadedFragLevel===-1;var currentCodecSet;var currentVideoRange='SDR';var currentFrameRate=(level==null?void 0:level.frameRate)||0;var audioPreference=config.audioPreference,videoPreference=config.videoPreference;var audioTracksByGroup=this.audioTracksByGroup||(this.audioTracksByGroup=getAudioTracksByGroup(allAudioTracks));if(firstSelection){if(this.firstSelection!==-1){return this.firstSelection;}var codecTiers=this.codecTiers||(this.codecTiers=getCodecTiers(levels,audioTracksByGroup,minAutoLevel,maxAutoLevel));var startTier=getStartCodecTier(codecTiers,currentVideoRange,currentBw,audioPreference,videoPreference);var codecSet=startTier.codecSet,videoRanges=startTier.videoRanges,minFramerate=startTier.minFramerate,minBitrate=startTier.minBitrate,preferHDR=startTier.preferHDR;currentCodecSet=codecSet;currentVideoRange=preferHDR?videoRanges[videoRanges.length-1]:videoRanges[0];currentFrameRate=minFramerate;currentBw=Math.max(currentBw,minBitrate);logger.log("[abr] picked start tier ".concat(JSON.stringify(startTier)));}else {currentCodecSet=level==null?void 0:level.codecSet;currentVideoRange=level==null?void 0:level.videoRange;}var currentFragDuration=partCurrent?partCurrent.duration:fragCurrent?fragCurrent.duration:0;var ttfbEstimateSec=this.bwEstimator.getEstimateTTFB()/1000;var levelsSkipped=[];var _loop5=function _loop5(){var levelInfo=levels[i];var upSwitch=i>selectionBaseLevel;if(!levelInfo){return 0;// continue
}if(config.useMediaCapabilities&&!levelInfo.supportedResult&&!levelInfo.supportedPromise){var mediaCapabilities=navigator.mediaCapabilities;if(typeof(mediaCapabilities==null?void 0:mediaCapabilities.decodingInfo)==='function'&&requiresMediaCapabilitiesDecodingInfo(levelInfo,audioTracksByGroup,currentVideoRange,currentFrameRate,currentBw,audioPreference)){levelInfo.supportedPromise=getMediaDecodingInfoPromise(levelInfo,audioTracksByGroup,mediaCapabilities);levelInfo.supportedPromise.then(function(decodingInfo){if(!_this10.hls){return;}levelInfo.supportedResult=decodingInfo;var levels=_this10.hls.levels;var index=levels.indexOf(levelInfo);if(decodingInfo.error){logger.warn("[abr] MediaCapabilities decodingInfo error: \"".concat(decodingInfo.error,"\" for level ").concat(index," ").concat(JSON.stringify(decodingInfo)));}else if(!decodingInfo.supported){logger.warn("[abr] Unsupported MediaCapabilities decodingInfo result for level ".concat(index," ").concat(JSON.stringify(decodingInfo)));if(index>-1&&levels.length>1){logger.log("[abr] Removing unsupported level ".concat(index));_this10.hls.removeLevel(index);}}});}else {levelInfo.supportedResult=SUPPORTED_INFO_DEFAULT;}}// skip candidates which change codec-family or video-range,
// and which decrease or increase frame-rate for up and down-switch respectfully
if(currentCodecSet&&levelInfo.codecSet!==currentCodecSet||currentVideoRange&&levelInfo.videoRange!==currentVideoRange||upSwitch&&currentFrameRate>levelInfo.frameRate||!upSwitch&&currentFrameRate>0&&currentFrameRate<levelInfo.frameRate||levelInfo.supportedResult&&!((_levelInfo$supportedR=levelInfo.supportedResult.decodingInfoResults)!=null&&_levelInfo$supportedR[0].smooth)){levelsSkipped.push(i);return 0;// continue
}var levelDetails=levelInfo.details;var avgDuration=(partCurrent?levelDetails==null?void 0:levelDetails.partTarget:levelDetails==null?void 0:levelDetails.averagetargetduration)||currentFragDuration;var adjustedbw;// follow algorithm captured from stagefright :
// https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
// Pick the highest bandwidth stream below or equal to estimated bandwidth.
// consider only 80% of the available bandwidth, but if we are switching up,
// be even more conservative (70%) to avoid overestimating and immediately
// switching back.
if(!upSwitch){adjustedbw=bwFactor*currentBw;}else {adjustedbw=bwUpFactor*currentBw;}// Use average bitrate when starvation delay (buffer length) is gt or eq two segment durations and rebuffering is not expected (maxStarvationDelay > 0)
var bitrate=currentFragDuration&&bufferStarvationDelay>=currentFragDuration*2&&maxStarvationDelay===0?levels[i].averageBitrate:levels[i].maxBitrate;var fetchDuration=_this10.getTimeToLoadFrag(ttfbEstimateSec,adjustedbw,bitrate*avgDuration,levelDetails===undefined);var canSwitchWithinTolerance=// if adjusted bw is greater than level bitrate AND
adjustedbw>=bitrate&&(// no level change, or new level has no error history
i===lastLoadedFragLevel||levelInfo.loadError===0&&levelInfo.fragmentError===0)&&(// fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
// we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
// special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
fetchDuration<=ttfbEstimateSec||!isFiniteNumber(fetchDuration)||live&&!_this10.bitrateTestDelay||fetchDuration<maxFetchDuration);if(canSwitchWithinTolerance){var forcedAutoLevel=_this10.forcedAutoLevel;if(i!==loadLevel&&(forcedAutoLevel===-1||forcedAutoLevel!==loadLevel)){if(levelsSkipped.length){logger.trace("[abr] Skipped level(s) ".concat(levelsSkipped.join(',')," of ").concat(maxAutoLevel," max with CODECS and VIDEO-RANGE:\"").concat(levels[levelsSkipped[0]].codecs,"\" ").concat(levels[levelsSkipped[0]].videoRange,"; not compatible with \"").concat(level.codecs,"\" ").concat(currentVideoRange));}logger.info("[abr] switch candidate:".concat(selectionBaseLevel,"->").concat(i," adjustedbw(").concat(Math.round(adjustedbw),")-bitrate=").concat(Math.round(adjustedbw-bitrate)," ttfb:").concat(ttfbEstimateSec.toFixed(1)," avgDuration:").concat(avgDuration.toFixed(1)," maxFetchDuration:").concat(maxFetchDuration.toFixed(1)," fetchDuration:").concat(fetchDuration.toFixed(1)," firstSelection:").concat(firstSelection," codecSet:").concat(currentCodecSet," videoRange:").concat(currentVideoRange," hls.loadLevel:").concat(loadLevel));}if(firstSelection){_this10.firstSelection=i;}// as we are looping from highest to lowest, this will return the best achievable quality level
return {v:i};}},_levelInfo$supportedR,_ret2;for(var i=maxAutoLevel;i>=minAutoLevel;i--){_ret2=_loop5();if(_ret2===0)continue;if(_ret2)return _ret2.v;}// not enough time budget even with quality level 0 ... rebuffering might happen
return -1;}}]);return AbrController;}();/**
 * @ignore
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */var TaskLoop=/*#__PURE__*/function(){function TaskLoop(){_classCallCheck(this,TaskLoop);this._boundTick=void 0;this._tickTimer=null;this._tickInterval=null;this._tickCallCount=0;this._boundTick=this.tick.bind(this);}_createClass(TaskLoop,[{key:"destroy",value:function destroy(){this.onHandlerDestroying();this.onHandlerDestroyed();}},{key:"onHandlerDestroying",value:function onHandlerDestroying(){// clear all timers before unregistering from event bus
this.clearNextTick();this.clearInterval();}},{key:"onHandlerDestroyed",value:function onHandlerDestroyed(){}},{key:"hasInterval",value:function hasInterval(){return !!this._tickInterval;}},{key:"hasNextTick",value:function hasNextTick(){return !!this._tickTimer;}/**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */},{key:"setInterval",value:function setInterval(millis){if(!this._tickInterval){this._tickCallCount=0;this._tickInterval=self.setInterval(this._boundTick,millis);return true;}return false;}/**
   * @returns True when interval was cleared, false when none was set (no effect)
   */},{key:"clearInterval",value:function clearInterval(){if(this._tickInterval){self.clearInterval(this._tickInterval);this._tickInterval=null;return true;}return false;}/**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */},{key:"clearNextTick",value:function clearNextTick(){if(this._tickTimer){self.clearTimeout(this._tickTimer);this._tickTimer=null;return true;}return false;}/**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */},{key:"tick",value:function tick(){this._tickCallCount++;if(this._tickCallCount===1){this.doTick();// re-entrant call to tick from previous doTick call stack
// -> schedule a call on the next main loop iteration to process this task processing request
if(this._tickCallCount>1){// make sure only one timer exists at any time at max
this.tickImmediate();}this._tickCallCount=0;}}},{key:"tickImmediate",value:function tickImmediate(){this.clearNextTick();this._tickTimer=self.setTimeout(this._boundTick,0);}/**
   * For subclass to implement task logic
   * @abstract
   */},{key:"doTick",value:function doTick(){}}]);return TaskLoop;}();var FragmentState={NOT_LOADED:"NOT_LOADED",APPENDING:"APPENDING",PARTIAL:"PARTIAL",OK:"OK"};var FragmentTracker=/*#__PURE__*/function(){function FragmentTracker(hls){_classCallCheck(this,FragmentTracker);this.activePartLists=Object.create(null);this.endListFragments=Object.create(null);this.fragments=Object.create(null);this.timeRanges=Object.create(null);this.bufferPadding=0.2;this.hls=void 0;this.hasGaps=false;this.hls=hls;this._registerListeners();}_createClass(FragmentTracker,[{key:"_registerListeners",value:function _registerListeners(){var hls=this.hls;hls.on(Events.BUFFER_APPENDED,this.onBufferAppended,this);hls.on(Events.FRAG_BUFFERED,this.onFragBuffered,this);hls.on(Events.FRAG_LOADED,this.onFragLoaded,this);}},{key:"_unregisterListeners",value:function _unregisterListeners(){var hls=this.hls;hls.off(Events.BUFFER_APPENDED,this.onBufferAppended,this);hls.off(Events.FRAG_BUFFERED,this.onFragBuffered,this);hls.off(Events.FRAG_LOADED,this.onFragLoaded,this);}},{key:"destroy",value:function destroy(){this._unregisterListeners();// @ts-ignore
this.fragments=// @ts-ignore
this.activePartLists=// @ts-ignore
this.endListFragments=this.timeRanges=null;}/**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */},{key:"getAppendedFrag",value:function getAppendedFrag(position,levelType){var activeParts=this.activePartLists[levelType];if(activeParts){for(var i=activeParts.length;i--;){var activePart=activeParts[i];if(!activePart){break;}var appendedPTS=activePart.end;if(activePart.start<=position&&appendedPTS!==null&&position<=appendedPTS){return activePart;}}}return this.getBufferedFrag(position,levelType);}/**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */},{key:"getBufferedFrag",value:function getBufferedFrag(position,levelType){var fragments=this.fragments;var keys=Object.keys(fragments);for(var i=keys.length;i--;){var fragmentEntity=fragments[keys[i]];if((fragmentEntity==null?void 0:fragmentEntity.body.type)===levelType&&fragmentEntity.buffered){var frag=fragmentEntity.body;if(frag.start<=position&&position<=frag.end){return frag;}}}return null;}/**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */},{key:"detectEvictedFragments",value:function detectEvictedFragments(elementaryStream,timeRange,playlistType,appendedPart){var _this11=this;if(this.timeRanges){this.timeRanges[elementaryStream]=timeRange;}// Check if any flagged fragments have been unloaded
// excluding anything newer than appendedPartSn
var appendedPartSn=(appendedPart==null?void 0:appendedPart.fragment.sn)||-1;Object.keys(this.fragments).forEach(function(key){var fragmentEntity=_this11.fragments[key];if(!fragmentEntity){return;}if(appendedPartSn>=fragmentEntity.body.sn){return;}if(!fragmentEntity.buffered&&!fragmentEntity.loaded){if(fragmentEntity.body.type===playlistType){_this11.removeFragment(fragmentEntity.body);}return;}var esData=fragmentEntity.range[elementaryStream];if(!esData){return;}esData.time.some(function(time){var isNotBuffered=!_this11.isTimeBuffered(time.startPTS,time.endPTS,timeRange);if(isNotBuffered){// Unregister partial fragment as it needs to load again to be reused
_this11.removeFragment(fragmentEntity.body);}return isNotBuffered;});});}/**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */},{key:"detectPartialFragments",value:function detectPartialFragments(data){var _this12=this;var timeRanges=this.timeRanges;var frag=data.frag,part=data.part;if(!timeRanges||frag.sn==='initSegment'){return;}var fragKey=getFragmentKey(frag);var fragmentEntity=this.fragments[fragKey];if(!fragmentEntity||fragmentEntity.buffered&&frag.gap){return;}var isFragHint=!frag.relurl;Object.keys(timeRanges).forEach(function(elementaryStream){var streamInfo=frag.elementaryStreams[elementaryStream];if(!streamInfo){return;}var timeRange=timeRanges[elementaryStream];var partial=isFragHint||streamInfo.partial===true;fragmentEntity.range[elementaryStream]=_this12.getBufferedTimes(frag,part,partial,timeRange);});fragmentEntity.loaded=null;if(Object.keys(fragmentEntity.range).length){fragmentEntity.buffered=true;var endList=fragmentEntity.body.endList=frag.endList||fragmentEntity.body.endList;if(endList){this.endListFragments[fragmentEntity.body.type]=fragmentEntity;}if(!isPartial(fragmentEntity)){// Remove older fragment parts from lookup after frag is tracked as buffered
this.removeParts(frag.sn-1,frag.type);}}else {// remove fragment if nothing was appended
this.removeFragment(fragmentEntity.body);}}},{key:"removeParts",value:function removeParts(snToKeep,levelType){var activeParts=this.activePartLists[levelType];if(!activeParts){return;}this.activePartLists[levelType]=activeParts.filter(function(part){return part.fragment.sn>=snToKeep;});}},{key:"fragBuffered",value:function fragBuffered(frag,force){var fragKey=getFragmentKey(frag);var fragmentEntity=this.fragments[fragKey];if(!fragmentEntity&&force){fragmentEntity=this.fragments[fragKey]={body:frag,appendedPTS:null,loaded:null,buffered:false,range:Object.create(null)};if(frag.gap){this.hasGaps=true;}}if(fragmentEntity){fragmentEntity.loaded=null;fragmentEntity.buffered=true;}}},{key:"getBufferedTimes",value:function getBufferedTimes(fragment,part,partial,timeRange){var buffered={time:[],partial:partial};var startPTS=fragment.start;var endPTS=fragment.end;var minEndPTS=fragment.minEndPTS||endPTS;var maxStartPTS=fragment.maxStartPTS||startPTS;for(var i=0;i<timeRange.length;i++){var startTime=timeRange.start(i)-this.bufferPadding;var endTime=timeRange.end(i)+this.bufferPadding;if(maxStartPTS>=startTime&&minEndPTS<=endTime){// Fragment is entirely contained in buffer
// No need to check the other timeRange times since it's completely playable
buffered.time.push({startPTS:Math.max(startPTS,timeRange.start(i)),endPTS:Math.min(endPTS,timeRange.end(i))});break;}else if(startPTS<endTime&&endPTS>startTime){var start=Math.max(startPTS,timeRange.start(i));var end=Math.min(endPTS,timeRange.end(i));if(end>start){buffered.partial=true;// Check for intersection with buffer
// Get playable sections of the fragment
buffered.time.push({startPTS:start,endPTS:end});}}else if(endPTS<=startTime){// No need to check the rest of the timeRange as it is in order
break;}}return buffered;}/**
   * Gets the partial fragment for a certain time
   */},{key:"getPartialFragment",value:function getPartialFragment(time){var bestFragment=null;var timePadding;var startTime;var endTime;var bestOverlap=0;var bufferPadding=this.bufferPadding,fragments=this.fragments;Object.keys(fragments).forEach(function(key){var fragmentEntity=fragments[key];if(!fragmentEntity){return;}if(isPartial(fragmentEntity)){startTime=fragmentEntity.body.start-bufferPadding;endTime=fragmentEntity.body.end+bufferPadding;if(time>=startTime&&time<=endTime){// Use the fragment that has the most padding from start and end time
timePadding=Math.min(time-startTime,endTime-time);if(bestOverlap<=timePadding){bestFragment=fragmentEntity.body;bestOverlap=timePadding;}}}});return bestFragment;}},{key:"isEndListAppended",value:function isEndListAppended(type){var lastFragmentEntity=this.endListFragments[type];return lastFragmentEntity!==undefined&&(lastFragmentEntity.buffered||isPartial(lastFragmentEntity));}},{key:"getState",value:function getState(fragment){var fragKey=getFragmentKey(fragment);var fragmentEntity=this.fragments[fragKey];if(fragmentEntity){if(!fragmentEntity.buffered){return FragmentState.APPENDING;}else if(isPartial(fragmentEntity)){return FragmentState.PARTIAL;}else {return FragmentState.OK;}}return FragmentState.NOT_LOADED;}},{key:"isTimeBuffered",value:function isTimeBuffered(startPTS,endPTS,timeRange){var startTime;var endTime;for(var i=0;i<timeRange.length;i++){startTime=timeRange.start(i)-this.bufferPadding;endTime=timeRange.end(i)+this.bufferPadding;if(startPTS>=startTime&&endPTS<=endTime){return true;}if(endPTS<=startTime){// No need to check the rest of the timeRange as it is in order
return false;}}return false;}},{key:"onFragLoaded",value:function onFragLoaded(event,data){var frag=data.frag,part=data.part;// don't track initsegment (for which sn is not a number)
// don't track frags used for bitrateTest, they're irrelevant.
if(frag.sn==='initSegment'||frag.bitrateTest){return;}// Fragment entity `loaded` FragLoadedData is null when loading parts
var loaded=part?null:data;var fragKey=getFragmentKey(frag);this.fragments[fragKey]={body:frag,appendedPTS:null,loaded:loaded,buffered:false,range:Object.create(null)};}},{key:"onBufferAppended",value:function onBufferAppended(event,data){var _this13=this;var frag=data.frag,part=data.part,timeRanges=data.timeRanges;if(frag.sn==='initSegment'){return;}var playlistType=frag.type;if(part){var activeParts=this.activePartLists[playlistType];if(!activeParts){this.activePartLists[playlistType]=activeParts=[];}activeParts.push(part);}// Store the latest timeRanges loaded in the buffer
this.timeRanges=timeRanges;Object.keys(timeRanges).forEach(function(elementaryStream){var timeRange=timeRanges[elementaryStream];_this13.detectEvictedFragments(elementaryStream,timeRange,playlistType,part);});}},{key:"onFragBuffered",value:function onFragBuffered(event,data){this.detectPartialFragments(data);}},{key:"hasFragment",value:function hasFragment(fragment){var fragKey=getFragmentKey(fragment);return !!this.fragments[fragKey];}},{key:"hasParts",value:function hasParts(type){var _this$activePartLists;return !!((_this$activePartLists=this.activePartLists[type])!=null&&_this$activePartLists.length);}},{key:"removeFragmentsInRange",value:function removeFragmentsInRange(start,end,playlistType,withGapOnly,unbufferedOnly){var _this14=this;if(withGapOnly&&!this.hasGaps){return;}Object.keys(this.fragments).forEach(function(key){var fragmentEntity=_this14.fragments[key];if(!fragmentEntity){return;}var frag=fragmentEntity.body;if(frag.type!==playlistType||withGapOnly&&!frag.gap){return;}if(frag.start<end&&frag.end>start&&(fragmentEntity.buffered||unbufferedOnly)){_this14.removeFragment(frag);}});}},{key:"removeFragment",value:function removeFragment(fragment){var fragKey=getFragmentKey(fragment);fragment.stats.loaded=0;fragment.clearElementaryStreamInfo();var activeParts=this.activePartLists[fragment.type];if(activeParts){var snToRemove=fragment.sn;this.activePartLists[fragment.type]=activeParts.filter(function(part){return part.fragment.sn!==snToRemove;});}delete this.fragments[fragKey];if(fragment.endList){delete this.endListFragments[fragment.type];}}},{key:"removeAllFragments",value:function removeAllFragments(){this.fragments=Object.create(null);this.endListFragments=Object.create(null);this.activePartLists=Object.create(null);this.hasGaps=false;}}]);return FragmentTracker;}();function isPartial(fragmentEntity){var _fragmentEntity$range,_fragmentEntity$range2,_fragmentEntity$range3;return fragmentEntity.buffered&&(fragmentEntity.body.gap||((_fragmentEntity$range=fragmentEntity.range.video)==null?void 0:_fragmentEntity$range.partial)||((_fragmentEntity$range2=fragmentEntity.range.audio)==null?void 0:_fragmentEntity$range2.partial)||((_fragmentEntity$range3=fragmentEntity.range.audiovideo)==null?void 0:_fragmentEntity$range3.partial));}function getFragmentKey(fragment){return "".concat(fragment.type,"_").concat(fragment.level,"_").concat(fragment.sn);}/**
 * Provides methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
 */var noopBuffered={length:0,start:function start(){return 0;},end:function end(){return 0;}};var BufferHelper=/*#__PURE__*/function(){function BufferHelper(){_classCallCheck(this,BufferHelper);}_createClass(BufferHelper,null,[{key:"isBuffered",value:/**
   * Return true if `media`'s buffered include `position`
   */function isBuffered(media,position){try{if(media){var buffered=BufferHelper.getBuffered(media);for(var i=0;i<buffered.length;i++){if(position>=buffered.start(i)&&position<=buffered.end(i)){return true;}}}}catch(error){// this is to catch
// InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
// This SourceBuffer has been removed from the parent media source
}return false;}},{key:"bufferInfo",value:function bufferInfo(media,pos,maxHoleDuration){try{if(media){var vbuffered=BufferHelper.getBuffered(media);var buffered=[];var i;for(i=0;i<vbuffered.length;i++){buffered.push({start:vbuffered.start(i),end:vbuffered.end(i)});}return this.bufferedInfo(buffered,pos,maxHoleDuration);}}catch(error){// this is to catch
// InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
// This SourceBuffer has been removed from the parent media source
}return {len:0,start:pos,end:pos,nextStart:undefined};}},{key:"bufferedInfo",value:function bufferedInfo(buffered,pos,maxHoleDuration){pos=Math.max(0,pos);// sort on buffer.start/smaller end (IE does not always return sorted buffered range)
buffered.sort(function(a,b){var diff=a.start-b.start;if(diff){return diff;}else {return b.end-a.end;}});var buffered2=[];if(maxHoleDuration){// there might be some small holes between buffer time range
// consider that holes smaller than maxHoleDuration are irrelevant and build another
// buffer time range representations that discards those holes
for(var i=0;i<buffered.length;i++){var buf2len=buffered2.length;if(buf2len){var buf2end=buffered2[buf2len-1].end;// if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
if(buffered[i].start-buf2end<maxHoleDuration){// merge overlapping time ranges
// update lastRange.end only if smaller than item.end
// e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
// whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
if(buffered[i].end>buf2end){buffered2[buf2len-1].end=buffered[i].end;}}else {// big hole
buffered2.push(buffered[i]);}}else {// first value
buffered2.push(buffered[i]);}}}else {buffered2=buffered;}var bufferLen=0;// bufferStartNext can possibly be undefined based on the conditional logic below
var bufferStartNext;// bufferStart and bufferEnd are buffer boundaries around current video position
var bufferStart=pos;var bufferEnd=pos;for(var _i10=0;_i10<buffered2.length;_i10++){var start=buffered2[_i10].start;var end=buffered2[_i10].end;// logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
if(pos+maxHoleDuration>=start&&pos<end){// play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
bufferStart=start;bufferEnd=end;bufferLen=bufferEnd-pos;}else if(pos+maxHoleDuration<start){bufferStartNext=start;break;}}return {len:bufferLen,start:bufferStart||0,end:bufferEnd||0,nextStart:bufferStartNext};}/**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */},{key:"getBuffered",value:function getBuffered(media){try{return media.buffered;}catch(e){logger.log('failed to get media.buffered',e);return noopBuffered;}}}]);return BufferHelper;}();var ChunkMetadata=/*#__PURE__*/_createClass(function ChunkMetadata(level,sn,id){var size=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var part=arguments.length>4&&arguments[4]!==undefined?arguments[4]:-1;var partial=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;_classCallCheck(this,ChunkMetadata);this.level=void 0;this.sn=void 0;this.part=void 0;this.id=void 0;this.size=void 0;this.partial=void 0;this.transmuxing=getNewPerformanceTiming();this.buffering={audio:getNewPerformanceTiming(),video:getNewPerformanceTiming(),audiovideo:getNewPerformanceTiming()};this.level=level;this.sn=sn;this.id=id;this.size=size;this.part=part;this.partial=partial;});function getNewPerformanceTiming(){return {start:0,executeStart:0,executeEnd:0,end:0};}function findFirstFragWithCC(fragments,cc){for(var i=0,len=fragments.length;i<len;i++){var _fragments$i;if(((_fragments$i=fragments[i])==null?void 0:_fragments$i.cc)===cc){return fragments[i];}}return null;}function shouldAlignOnDiscontinuities(lastFrag,switchDetails,details){if(switchDetails){if(details.endCC>details.startCC||lastFrag&&lastFrag.cc<details.startCC){return true;}}return false;}// Find the first frag in the previous level which matches the CC of the first frag of the new level
function findDiscontinuousReferenceFrag(prevDetails,curDetails){var prevFrags=prevDetails.fragments;var curFrags=curDetails.fragments;if(!curFrags.length||!prevFrags.length){logger.log('No fragments to align');return;}var prevStartFrag=findFirstFragWithCC(prevFrags,curFrags[0].cc);if(!prevStartFrag||prevStartFrag&&!prevStartFrag.startPTS){logger.log('No frag in previous level to align on');return;}return prevStartFrag;}function adjustFragmentStart(frag,sliding){if(frag){var start=frag.start+sliding;frag.start=frag.startPTS=start;frag.endPTS=start+frag.duration;}}function adjustSlidingStart(sliding,details){// Update segments
var fragments=details.fragments;for(var i=0,len=fragments.length;i<len;i++){adjustFragmentStart(fragments[i],sliding);}// Update LL-HLS parts at the end of the playlist
if(details.fragmentHint){adjustFragmentStart(details.fragmentHint,sliding);}details.alignedSliding=true;}/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastFrag
 * @param lastLevel
 * @param details
 */function alignStream(lastFrag,switchDetails,details){if(!switchDetails){return;}alignDiscontinuities(lastFrag,details,switchDetails);if(!details.alignedSliding&&switchDetails){// If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
// Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
// discontinuity sequence.
alignMediaPlaylistByPDT(details,switchDetails);}if(!details.alignedSliding&&switchDetails&&!details.skippedSegments){// Try to align on sn so that we pick a better start fragment.
// Do not perform this on playlists with delta updates as this is only to align levels on switch
// and adjustSliding only adjusts fragments after skippedSegments.
adjustSliding(switchDetails,details);}}/**
 * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
 * discontinuity sequence.
 * @param lastFrag - The last Fragment which shares the same discontinuity sequence
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */function alignDiscontinuities(lastFrag,details,switchDetails){if(shouldAlignOnDiscontinuities(lastFrag,switchDetails,details)){var referenceFrag=findDiscontinuousReferenceFrag(switchDetails,details);if(referenceFrag&&isFiniteNumber(referenceFrag.start)){logger.log("Adjusting PTS using last level due to CC increase within current level ".concat(details.url));adjustSlidingStart(referenceFrag.start,details);}}}/**
 * Ensures appropriate time-alignment between renditions based on PDT.
 * This function assumes the timelines represented in `refDetails` are accurate, including the PDTs
 * for the last discontinuity sequence number shared by both playlists when present,
 * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
 * times/timelines of `details` accordingly.
 * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
 * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
 * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
 * be consistent across playlists, per the HLS spec.
 * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
 * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
 */function alignMediaPlaylistByPDT(details,refDetails){if(!details.hasProgramDateTime||!refDetails.hasProgramDateTime){return;}var fragments=details.fragments;var refFragments=refDetails.fragments;if(!fragments.length||!refFragments.length){return;}// Calculate a delta to apply to all fragments according to the delta in PDT times and start times
// of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
// If a fragment of the same discontinuity was not found use the middle fragment of both.
var refFrag;var frag;var targetCC=Math.min(refDetails.endCC,details.endCC);if(refDetails.startCC<targetCC&&details.startCC<targetCC){refFrag=findFirstFragWithCC(refFragments,targetCC);frag=findFirstFragWithCC(fragments,targetCC);}if(!refFrag||!frag){refFrag=refFragments[Math.floor(refFragments.length/2)];frag=findFirstFragWithCC(fragments,refFrag.cc)||fragments[Math.floor(fragments.length/2)];}var refPDT=refFrag.programDateTime;var targetPDT=frag.programDateTime;if(!refPDT||!targetPDT){return;}var delta=(targetPDT-refPDT)/1000-(frag.start-refFrag.start);adjustSlidingStart(delta,details);}var MIN_CHUNK_SIZE=Math.pow(2,17);// 128kb
var FragmentLoader=/*#__PURE__*/function(){function FragmentLoader(config){_classCallCheck(this,FragmentLoader);this.config=void 0;this.loader=null;this.partLoadTimeout=-1;this.config=config;}_createClass(FragmentLoader,[{key:"destroy",value:function destroy(){if(this.loader){this.loader.destroy();this.loader=null;}}},{key:"abort",value:function abort(){if(this.loader){// Abort the loader for current fragment. Only one may load at any given time
this.loader.abort();}}},{key:"load",value:function load(frag,_onProgress){var _this15=this;var url=frag.url;if(!url){return Promise.reject(new LoadError({type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.FRAG_LOAD_ERROR,fatal:false,frag:frag,error:new Error("Fragment does not have a ".concat(url?'part list':'url')),networkDetails:null}));}this.abort();var config=this.config;var FragmentILoader=config.fLoader;var DefaultILoader=config.loader;return new Promise(function(resolve,reject){if(_this15.loader){_this15.loader.destroy();}if(frag.gap){if(frag.tagList.some(function(tags){return tags[0]==='GAP';})){reject(createGapLoadError(frag));return;}else {// Reset temporary treatment as GAP tag
frag.gap=false;}}var loader=_this15.loader=frag.loader=FragmentILoader?new FragmentILoader(config):new DefaultILoader(config);var loaderContext=createLoaderContext(frag);var loadPolicy=getLoaderConfigWithoutReties(config.fragLoadPolicy["default"]);var loaderConfig={loadPolicy:loadPolicy,timeout:loadPolicy.maxLoadTimeMs,maxRetry:0,retryDelay:0,maxRetryDelay:0,highWaterMark:frag.sn==='initSegment'?Infinity:MIN_CHUNK_SIZE};// Assign frag stats to the loader's stats reference
frag.stats=loader.stats;loader.load(loaderContext,loaderConfig,{onSuccess:function onSuccess(response,stats,context,networkDetails){_this15.resetLoader(frag,loader);var payload=response.data;if(context.resetIV&&frag.decryptdata){frag.decryptdata.iv=new Uint8Array(payload.slice(0,16));payload=payload.slice(16);}resolve({frag:frag,part:null,payload:payload,networkDetails:networkDetails});},onError:function onError(response,context,networkDetails,stats){_this15.resetLoader(frag,loader);reject(new LoadError({type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.FRAG_LOAD_ERROR,fatal:false,frag:frag,response:_objectSpread2$2({url:url,data:undefined},response),error:new Error("HTTP Error ".concat(response.code," ").concat(response.text)),networkDetails:networkDetails,stats:stats}));},onAbort:function onAbort(stats,context,networkDetails){_this15.resetLoader(frag,loader);reject(new LoadError({type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.INTERNAL_ABORTED,fatal:false,frag:frag,error:new Error('Aborted'),networkDetails:networkDetails,stats:stats}));},onTimeout:function onTimeout(stats,context,networkDetails){_this15.resetLoader(frag,loader);reject(new LoadError({type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.FRAG_LOAD_TIMEOUT,fatal:false,frag:frag,error:new Error("Timeout after ".concat(loaderConfig.timeout,"ms")),networkDetails:networkDetails,stats:stats}));},onProgress:function onProgress(stats,context,data,networkDetails){if(_onProgress){_onProgress({frag:frag,part:null,payload:data,networkDetails:networkDetails});}}});});}},{key:"loadPart",value:function loadPart(frag,part,onProgress){var _this16=this;this.abort();var config=this.config;var FragmentILoader=config.fLoader;var DefaultILoader=config.loader;return new Promise(function(resolve,reject){if(_this16.loader){_this16.loader.destroy();}if(frag.gap||part.gap){reject(createGapLoadError(frag,part));return;}var loader=_this16.loader=frag.loader=FragmentILoader?new FragmentILoader(config):new DefaultILoader(config);var loaderContext=createLoaderContext(frag,part);// Should we define another load policy for parts?
var loadPolicy=getLoaderConfigWithoutReties(config.fragLoadPolicy["default"]);var loaderConfig={loadPolicy:loadPolicy,timeout:loadPolicy.maxLoadTimeMs,maxRetry:0,retryDelay:0,maxRetryDelay:0,highWaterMark:MIN_CHUNK_SIZE};// Assign part stats to the loader's stats reference
part.stats=loader.stats;loader.load(loaderContext,loaderConfig,{onSuccess:function onSuccess(response,stats,context,networkDetails){_this16.resetLoader(frag,loader);_this16.updateStatsFromPart(frag,part);var partLoadedData={frag:frag,part:part,payload:response.data,networkDetails:networkDetails};onProgress(partLoadedData);resolve(partLoadedData);},onError:function onError(response,context,networkDetails,stats){_this16.resetLoader(frag,loader);reject(new LoadError({type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.FRAG_LOAD_ERROR,fatal:false,frag:frag,part:part,response:_objectSpread2$2({url:loaderContext.url,data:undefined},response),error:new Error("HTTP Error ".concat(response.code," ").concat(response.text)),networkDetails:networkDetails,stats:stats}));},onAbort:function onAbort(stats,context,networkDetails){frag.stats.aborted=part.stats.aborted;_this16.resetLoader(frag,loader);reject(new LoadError({type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.INTERNAL_ABORTED,fatal:false,frag:frag,part:part,error:new Error('Aborted'),networkDetails:networkDetails,stats:stats}));},onTimeout:function onTimeout(stats,context,networkDetails){_this16.resetLoader(frag,loader);reject(new LoadError({type:ErrorTypes.NETWORK_ERROR,details:ErrorDetails.FRAG_LOAD_TIMEOUT,fatal:false,frag:frag,part:part,error:new Error("Timeout after ".concat(loaderConfig.timeout,"ms")),networkDetails:networkDetails,stats:stats}));}});});}},{key:"updateStatsFromPart",value:function updateStatsFromPart(frag,part){var fragStats=frag.stats;var partStats=part.stats;var partTotal=partStats.total;fragStats.loaded+=partStats.loaded;if(partTotal){var estTotalParts=Math.round(frag.duration/part.duration);var estLoadedParts=Math.min(Math.round(fragStats.loaded/partTotal),estTotalParts);var estRemainingParts=estTotalParts-estLoadedParts;var estRemainingBytes=estRemainingParts*Math.round(fragStats.loaded/estLoadedParts);fragStats.total=fragStats.loaded+estRemainingBytes;}else {fragStats.total=Math.max(fragStats.loaded,fragStats.total);}var fragLoading=fragStats.loading;var partLoading=partStats.loading;if(fragLoading.start){// add to fragment loader latency
fragLoading.first+=partLoading.first-partLoading.start;}else {fragLoading.start=partLoading.start;fragLoading.first=partLoading.first;}fragLoading.end=partLoading.end;}},{key:"resetLoader",value:function resetLoader(frag,loader){frag.loader=null;if(this.loader===loader){self.clearTimeout(this.partLoadTimeout);this.loader=null;}loader.destroy();}}]);return FragmentLoader;}();function createLoaderContext(frag){var part=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var segment=part||frag;var loaderContext={frag:frag,part:part,responseType:'arraybuffer',url:segment.url,headers:{},rangeStart:0,rangeEnd:0};var start=segment.byteRangeStartOffset;var end=segment.byteRangeEndOffset;if(isFiniteNumber(start)&&isFiniteNumber(end)){var _frag$decryptdata;var byteRangeStart=start;var byteRangeEnd=end;if(frag.sn==='initSegment'&&((_frag$decryptdata=frag.decryptdata)==null?void 0:_frag$decryptdata.method)==='AES-128'){// MAP segment encrypted with method 'AES-128', when served with HTTP Range,
// has the unencrypted size specified in the range.
// Ref: https://tools.ietf.org/html/draft-pantos-hls-rfc8216bis-08#section-6.3.6
var fragmentLen=end-start;if(fragmentLen%16){byteRangeEnd=end+(16-fragmentLen%16);}if(start!==0){loaderContext.resetIV=true;byteRangeStart=start-16;}}loaderContext.rangeStart=byteRangeStart;loaderContext.rangeEnd=byteRangeEnd;}return loaderContext;}function createGapLoadError(frag,part){var error=new Error("GAP ".concat(frag.gap?'tag':'attribute'," found"));var errorData={type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.FRAG_GAP,fatal:false,frag:frag,error:error,networkDetails:null};if(part){errorData.part=part;}(part?part:frag).stats.aborted=true;return new LoadError(errorData);}var LoadError=/*#__PURE__*/function(_Error){_inherits(LoadError,_Error);var _super3=_createSuper(LoadError);function LoadError(data){var _this17;_classCallCheck(this,LoadError);_this17=_super3.call(this,data.error.message);_this17.data=void 0;_this17.data=data;return _this17;}return _createClass(LoadError);}(/*#__PURE__*/_wrapNativeSuper(Error));var AESCrypto=/*#__PURE__*/function(){function AESCrypto(subtle,iv){_classCallCheck(this,AESCrypto);this.subtle=void 0;this.aesIV=void 0;this.subtle=subtle;this.aesIV=iv;}_createClass(AESCrypto,[{key:"decrypt",value:function decrypt(data,key){return this.subtle.decrypt({name:'AES-CBC',iv:this.aesIV},key,data);}}]);return AESCrypto;}();var FastAESKey=/*#__PURE__*/function(){function FastAESKey(subtle,key){_classCallCheck(this,FastAESKey);this.subtle=void 0;this.key=void 0;this.subtle=subtle;this.key=key;}_createClass(FastAESKey,[{key:"expandKey",value:function expandKey(){return this.subtle.importKey('raw',this.key,{name:'AES-CBC'},false,['encrypt','decrypt']);}}]);return FastAESKey;}();// PKCS7
function removePadding(array){var outputBytes=array.byteLength;var paddingBytes=outputBytes&&new DataView(array.buffer).getUint8(outputBytes-1);if(paddingBytes){return sliceUint8(array,0,outputBytes-paddingBytes);}return array;}var AESDecryptor=/*#__PURE__*/function(){function AESDecryptor(){_classCallCheck(this,AESDecryptor);this.rcon=[0x0,0x1,0x2,0x4,0x8,0x10,0x20,0x40,0x80,0x1b,0x36];this.subMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)];this.invSubMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)];this.sBox=new Uint32Array(256);this.invSBox=new Uint32Array(256);this.key=new Uint32Array(0);this.ksRows=0;this.keySize=0;this.keySchedule=void 0;this.invKeySchedule=void 0;this.initTable();}// Using view.getUint32() also swaps the byte order.
_createClass(AESDecryptor,[{key:"uint8ArrayToUint32Array_",value:function uint8ArrayToUint32Array_(arrayBuffer){var view=new DataView(arrayBuffer);var newArray=new Uint32Array(4);for(var i=0;i<4;i++){newArray[i]=view.getUint32(i*4);}return newArray;}},{key:"initTable",value:function initTable(){var sBox=this.sBox;var invSBox=this.invSBox;var subMix=this.subMix;var subMix0=subMix[0];var subMix1=subMix[1];var subMix2=subMix[2];var subMix3=subMix[3];var invSubMix=this.invSubMix;var invSubMix0=invSubMix[0];var invSubMix1=invSubMix[1];var invSubMix2=invSubMix[2];var invSubMix3=invSubMix[3];var d=new Uint32Array(256);var x=0;var xi=0;var i=0;for(i=0;i<256;i++){if(i<128){d[i]=i<<1;}else {d[i]=i<<1^0x11b;}}for(i=0;i<256;i++){var sx=xi^xi<<1^xi<<2^xi<<3^xi<<4;sx=sx>>>8^sx&0xff^0x63;sBox[x]=sx;invSBox[sx]=x;// Compute multiplication
var x2=d[x];var x4=d[x2];var x8=d[x4];// Compute sub/invSub bytes, mix columns tables
var t=d[sx]*0x101^sx*0x1010100;subMix0[x]=t<<24|t>>>8;subMix1[x]=t<<16|t>>>16;subMix2[x]=t<<8|t>>>24;subMix3[x]=t;// Compute inv sub bytes, inv mix columns tables
t=x8*0x1010101^x4*0x10001^x2*0x101^x*0x1010100;invSubMix0[sx]=t<<24|t>>>8;invSubMix1[sx]=t<<16|t>>>16;invSubMix2[sx]=t<<8|t>>>24;invSubMix3[sx]=t;// Compute next counter
if(!x){x=xi=1;}else {x=x2^d[d[d[x8^x2]]];xi^=d[d[xi]];}}}},{key:"expandKey",value:function expandKey(keyBuffer){// convert keyBuffer to Uint32Array
var key=this.uint8ArrayToUint32Array_(keyBuffer);var sameKey=true;var offset=0;while(offset<key.length&&sameKey){sameKey=key[offset]===this.key[offset];offset++;}if(sameKey){return;}this.key=key;var keySize=this.keySize=key.length;if(keySize!==4&&keySize!==6&&keySize!==8){throw new Error('Invalid aes key size='+keySize);}var ksRows=this.ksRows=(keySize+6+1)*4;var ksRow;var invKsRow;var keySchedule=this.keySchedule=new Uint32Array(ksRows);var invKeySchedule=this.invKeySchedule=new Uint32Array(ksRows);var sbox=this.sBox;var rcon=this.rcon;var invSubMix=this.invSubMix;var invSubMix0=invSubMix[0];var invSubMix1=invSubMix[1];var invSubMix2=invSubMix[2];var invSubMix3=invSubMix[3];var prev;var t;for(ksRow=0;ksRow<ksRows;ksRow++){if(ksRow<keySize){prev=keySchedule[ksRow]=key[ksRow];continue;}t=prev;if(ksRow%keySize===0){// Rot word
t=t<<8|t>>>24;// Sub word
t=sbox[t>>>24]<<24|sbox[t>>>16&0xff]<<16|sbox[t>>>8&0xff]<<8|sbox[t&0xff];// Mix Rcon
t^=rcon[ksRow/keySize|0]<<24;}else if(keySize>6&&ksRow%keySize===4){// Sub word
t=sbox[t>>>24]<<24|sbox[t>>>16&0xff]<<16|sbox[t>>>8&0xff]<<8|sbox[t&0xff];}keySchedule[ksRow]=prev=(keySchedule[ksRow-keySize]^t)>>>0;}for(invKsRow=0;invKsRow<ksRows;invKsRow++){ksRow=ksRows-invKsRow;if(invKsRow&3){t=keySchedule[ksRow];}else {t=keySchedule[ksRow-4];}if(invKsRow<4||ksRow<=4){invKeySchedule[invKsRow]=t;}else {invKeySchedule[invKsRow]=invSubMix0[sbox[t>>>24]]^invSubMix1[sbox[t>>>16&0xff]]^invSubMix2[sbox[t>>>8&0xff]]^invSubMix3[sbox[t&0xff]];}invKeySchedule[invKsRow]=invKeySchedule[invKsRow]>>>0;}}// Adding this as a method greatly improves performance.
},{key:"networkToHostOrderSwap",value:function networkToHostOrderSwap(word){return word<<24|(word&0xff00)<<8|(word&0xff0000)>>8|word>>>24;}},{key:"decrypt",value:function decrypt(inputArrayBuffer,offset,aesIV){var nRounds=this.keySize+6;var invKeySchedule=this.invKeySchedule;var invSBOX=this.invSBox;var invSubMix=this.invSubMix;var invSubMix0=invSubMix[0];var invSubMix1=invSubMix[1];var invSubMix2=invSubMix[2];var invSubMix3=invSubMix[3];var initVector=this.uint8ArrayToUint32Array_(aesIV);var initVector0=initVector[0];var initVector1=initVector[1];var initVector2=initVector[2];var initVector3=initVector[3];var inputInt32=new Int32Array(inputArrayBuffer);var outputInt32=new Int32Array(inputInt32.length);var t0,t1,t2,t3;var s0,s1,s2,s3;var inputWords0,inputWords1,inputWords2,inputWords3;var ksRow,i;var swapWord=this.networkToHostOrderSwap;while(offset<inputInt32.length){inputWords0=swapWord(inputInt32[offset]);inputWords1=swapWord(inputInt32[offset+1]);inputWords2=swapWord(inputInt32[offset+2]);inputWords3=swapWord(inputInt32[offset+3]);s0=inputWords0^invKeySchedule[0];s1=inputWords3^invKeySchedule[1];s2=inputWords2^invKeySchedule[2];s3=inputWords1^invKeySchedule[3];ksRow=4;// Iterate through the rounds of decryption
for(i=1;i<nRounds;i++){t0=invSubMix0[s0>>>24]^invSubMix1[s1>>16&0xff]^invSubMix2[s2>>8&0xff]^invSubMix3[s3&0xff]^invKeySchedule[ksRow];t1=invSubMix0[s1>>>24]^invSubMix1[s2>>16&0xff]^invSubMix2[s3>>8&0xff]^invSubMix3[s0&0xff]^invKeySchedule[ksRow+1];t2=invSubMix0[s2>>>24]^invSubMix1[s3>>16&0xff]^invSubMix2[s0>>8&0xff]^invSubMix3[s1&0xff]^invKeySchedule[ksRow+2];t3=invSubMix0[s3>>>24]^invSubMix1[s0>>16&0xff]^invSubMix2[s1>>8&0xff]^invSubMix3[s2&0xff]^invKeySchedule[ksRow+3];// Update state
s0=t0;s1=t1;s2=t2;s3=t3;ksRow=ksRow+4;}// Shift rows, sub bytes, add round key
t0=invSBOX[s0>>>24]<<24^invSBOX[s1>>16&0xff]<<16^invSBOX[s2>>8&0xff]<<8^invSBOX[s3&0xff]^invKeySchedule[ksRow];t1=invSBOX[s1>>>24]<<24^invSBOX[s2>>16&0xff]<<16^invSBOX[s3>>8&0xff]<<8^invSBOX[s0&0xff]^invKeySchedule[ksRow+1];t2=invSBOX[s2>>>24]<<24^invSBOX[s3>>16&0xff]<<16^invSBOX[s0>>8&0xff]<<8^invSBOX[s1&0xff]^invKeySchedule[ksRow+2];t3=invSBOX[s3>>>24]<<24^invSBOX[s0>>16&0xff]<<16^invSBOX[s1>>8&0xff]<<8^invSBOX[s2&0xff]^invKeySchedule[ksRow+3];// Write
outputInt32[offset]=swapWord(t0^initVector0);outputInt32[offset+1]=swapWord(t3^initVector1);outputInt32[offset+2]=swapWord(t2^initVector2);outputInt32[offset+3]=swapWord(t1^initVector3);// reset initVector to last 4 unsigned int
initVector0=inputWords0;initVector1=inputWords1;initVector2=inputWords2;initVector3=inputWords3;offset=offset+4;}return outputInt32.buffer;}}]);return AESDecryptor;}();var CHUNK_SIZE=16;// 16 bytes, 128 bits
var Decrypter=/*#__PURE__*/function(){function Decrypter(config){var _ref9=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},_ref9$removePKCS7Padd=_ref9.removePKCS7Padding,removePKCS7Padding=_ref9$removePKCS7Padd===void 0?true:_ref9$removePKCS7Padd;_classCallCheck(this,Decrypter);this.logEnabled=true;this.removePKCS7Padding=void 0;this.subtle=null;this.softwareDecrypter=null;this.key=null;this.fastAesKey=null;this.remainderData=null;this.currentIV=null;this.currentResult=null;this.useSoftware=void 0;this.useSoftware=config.enableSoftwareAES;this.removePKCS7Padding=removePKCS7Padding;// built in decryptor expects PKCS7 padding
if(removePKCS7Padding){try{var browserCrypto=self.crypto;if(browserCrypto){this.subtle=browserCrypto.subtle||browserCrypto.webkitSubtle;}}catch(e){/* no-op */}}this.useSoftware=!this.subtle;}_createClass(Decrypter,[{key:"destroy",value:function destroy(){this.subtle=null;this.softwareDecrypter=null;this.key=null;this.fastAesKey=null;this.remainderData=null;this.currentIV=null;this.currentResult=null;}},{key:"isSync",value:function isSync(){return this.useSoftware;}},{key:"flush",value:function flush(){var currentResult=this.currentResult,remainderData=this.remainderData;if(!currentResult||remainderData){this.reset();return null;}var data=new Uint8Array(currentResult);this.reset();if(this.removePKCS7Padding){return removePadding(data);}return data;}},{key:"reset",value:function reset(){this.currentResult=null;this.currentIV=null;this.remainderData=null;if(this.softwareDecrypter){this.softwareDecrypter=null;}}},{key:"decrypt",value:function decrypt(data,key,iv){var _this18=this;if(this.useSoftware){return new Promise(function(resolve,reject){_this18.softwareDecrypt(new Uint8Array(data),key,iv);var decryptResult=_this18.flush();if(decryptResult){resolve(decryptResult.buffer);}else {reject(new Error('[softwareDecrypt] Failed to decrypt data'));}});}return this.webCryptoDecrypt(new Uint8Array(data),key,iv);}// Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
// data is handled in the flush() call
},{key:"softwareDecrypt",value:function softwareDecrypt(data,key,iv){var currentIV=this.currentIV,currentResult=this.currentResult,remainderData=this.remainderData;this.logOnce('JS AES decrypt');// The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
// This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
// the end on flush(), but by that time we have already received all bytes for the segment.
// Progressive decryption does not work with WebCrypto
if(remainderData){data=appendUint8Array(remainderData,data);this.remainderData=null;}// Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
var currentChunk=this.getValidChunk(data);if(!currentChunk.length){return null;}if(currentIV){iv=currentIV;}var softwareDecrypter=this.softwareDecrypter;if(!softwareDecrypter){softwareDecrypter=this.softwareDecrypter=new AESDecryptor();}softwareDecrypter.expandKey(key);var result=currentResult;this.currentResult=softwareDecrypter.decrypt(currentChunk.buffer,0,iv);this.currentIV=sliceUint8(currentChunk,-16).buffer;if(!result){return null;}return result;}},{key:"webCryptoDecrypt",value:function webCryptoDecrypt(data,key,iv){var _this19=this;if(this.key!==key||!this.fastAesKey){if(!this.subtle){return Promise.resolve(this.onWebCryptoError(data,key,iv));}this.key=key;this.fastAesKey=new FastAESKey(this.subtle,key);}return this.fastAesKey.expandKey().then(function(aesKey){// decrypt using web crypto
if(!_this19.subtle){return Promise.reject(new Error('web crypto not initialized'));}_this19.logOnce('WebCrypto AES decrypt');var crypto=new AESCrypto(_this19.subtle,new Uint8Array(iv));return crypto.decrypt(data.buffer,aesKey);})["catch"](function(err){logger.warn("[decrypter]: WebCrypto Error, disable WebCrypto API, ".concat(err.name,": ").concat(err.message));return _this19.onWebCryptoError(data,key,iv);});}},{key:"onWebCryptoError",value:function onWebCryptoError(data,key,iv){this.useSoftware=true;this.logEnabled=true;this.softwareDecrypt(data,key,iv);var decryptResult=this.flush();if(decryptResult){return decryptResult.buffer;}throw new Error('WebCrypto and softwareDecrypt: failed to decrypt data');}},{key:"getValidChunk",value:function getValidChunk(data){var currentChunk=data;var splitPoint=data.length-data.length%CHUNK_SIZE;if(splitPoint!==data.length){currentChunk=sliceUint8(data,0,splitPoint);this.remainderData=sliceUint8(data,splitPoint);}return currentChunk;}},{key:"logOnce",value:function logOnce(msg){if(!this.logEnabled){return;}logger.log("[decrypter]: ".concat(msg));this.logEnabled=false;}}]);return Decrypter;}();/**
 *  TimeRanges to string helper
 */var TimeRanges={toString:function toString(r){var log='';var len=r.length;for(var i=0;i<len;i++){log+="[".concat(r.start(i).toFixed(3),"-").concat(r.end(i).toFixed(3),"]");}return log;}};var State={STOPPED:'STOPPED',IDLE:'IDLE',KEY_LOADING:'KEY_LOADING',FRAG_LOADING:'FRAG_LOADING',FRAG_LOADING_WAITING_RETRY:'FRAG_LOADING_WAITING_RETRY',WAITING_TRACK:'WAITING_TRACK',PARSING:'PARSING',PARSED:'PARSED',ENDED:'ENDED',ERROR:'ERROR',WAITING_INIT_PTS:'WAITING_INIT_PTS',WAITING_LEVEL:'WAITING_LEVEL'};var BaseStreamController=/*#__PURE__*/function(_TaskLoop){_inherits(BaseStreamController,_TaskLoop);var _super4=_createSuper(BaseStreamController);function BaseStreamController(hls,fragmentTracker,keyLoader,logPrefix,playlistType){var _this20;_classCallCheck(this,BaseStreamController);_this20=_super4.call(this);_this20.hls=void 0;_this20.fragPrevious=null;_this20.fragCurrent=null;_this20.fragmentTracker=void 0;_this20.transmuxer=null;_this20._state=State.STOPPED;_this20.playlistType=void 0;_this20.media=null;_this20.mediaBuffer=null;_this20.config=void 0;_this20.bitrateTest=false;_this20.lastCurrentTime=0;_this20.nextLoadPosition=0;_this20.startPosition=0;_this20.startTimeOffset=null;_this20.loadedmetadata=false;_this20.retryDate=0;_this20.levels=null;_this20.fragmentLoader=void 0;_this20.keyLoader=void 0;_this20.levelLastLoaded=null;_this20.startFragRequested=false;_this20.decrypter=void 0;_this20.initPTS=[];_this20.buffering=true;_this20.onvseeking=null;_this20.onvended=null;_this20.logPrefix='';_this20.log=void 0;_this20.warn=void 0;_this20.playlistType=playlistType;_this20.logPrefix=logPrefix;_this20.log=logger.log.bind(logger,"".concat(logPrefix,":"));_this20.warn=logger.warn.bind(logger,"".concat(logPrefix,":"));_this20.hls=hls;_this20.fragmentLoader=new FragmentLoader(hls.config);_this20.keyLoader=keyLoader;_this20.fragmentTracker=fragmentTracker;_this20.config=hls.config;_this20.decrypter=new Decrypter(hls.config);hls.on(Events.MANIFEST_LOADED,_this20.onManifestLoaded,_assertThisInitialized(_this20));return _this20;}_createClass(BaseStreamController,[{key:"doTick",value:function doTick(){this.onTickEnd();}},{key:"onTickEnd",value:function onTickEnd(){}// eslint-disable-next-line @typescript-eslint/no-unused-vars
},{key:"startLoad",value:function startLoad(startPosition){}},{key:"stopLoad",value:function stopLoad(){this.fragmentLoader.abort();this.keyLoader.abort(this.playlistType);var frag=this.fragCurrent;if(frag!=null&&frag.loader){frag.abortRequests();this.fragmentTracker.removeFragment(frag);}this.resetTransmuxer();this.fragCurrent=null;this.fragPrevious=null;this.clearInterval();this.clearNextTick();this.state=State.STOPPED;}},{key:"pauseBuffering",value:function pauseBuffering(){this.buffering=false;}},{key:"resumeBuffering",value:function resumeBuffering(){this.buffering=true;}},{key:"_streamEnded",value:function _streamEnded(bufferInfo,levelDetails){// If playlist is live, there is another buffered range after the current range, nothing buffered, media is detached,
// of nothing loading/loaded return false
if(levelDetails.live||bufferInfo.nextStart||!bufferInfo.end||!this.media){return false;}var partList=levelDetails.partList;// Since the last part isn't guaranteed to correspond to the last playlist segment for Low-Latency HLS,
// check instead if the last part is buffered.
if(partList!=null&&partList.length){var lastPart=partList[partList.length-1];// Checking the midpoint of the part for potential margin of error and related issues.
// NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
// and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
// part mismatches for independent audio and video playlists/segments.
var lastPartBuffered=BufferHelper.isBuffered(this.media,lastPart.start+lastPart.duration/2);return lastPartBuffered;}var playlistType=levelDetails.fragments[levelDetails.fragments.length-1].type;return this.fragmentTracker.isEndListAppended(playlistType);}},{key:"getLevelDetails",value:function getLevelDetails(){if(this.levels&&this.levelLastLoaded!==null){var _this$levelLastLoaded;return (_this$levelLastLoaded=this.levelLastLoaded)==null?void 0:_this$levelLastLoaded.details;}}},{key:"onMediaAttached",value:function onMediaAttached(event,data){var media=this.media=this.mediaBuffer=data.media;this.onvseeking=this.onMediaSeeking.bind(this);this.onvended=this.onMediaEnded.bind(this);media.addEventListener('seeking',this.onvseeking);media.addEventListener('ended',this.onvended);var config=this.config;if(this.levels&&config.autoStartLoad&&this.state===State.STOPPED){this.startLoad(config.startPosition);}}},{key:"onMediaDetaching",value:function onMediaDetaching(){var media=this.media;if(media!=null&&media.ended){this.log('MSE detaching and video ended, reset startPosition');this.startPosition=this.lastCurrentTime=0;}// remove video listeners
if(media&&this.onvseeking&&this.onvended){media.removeEventListener('seeking',this.onvseeking);media.removeEventListener('ended',this.onvended);this.onvseeking=this.onvended=null;}if(this.keyLoader){this.keyLoader.detach();}this.media=this.mediaBuffer=null;this.loadedmetadata=false;this.fragmentTracker.removeAllFragments();this.stopLoad();}},{key:"onMediaSeeking",value:function onMediaSeeking(){var config=this.config,fragCurrent=this.fragCurrent,media=this.media,mediaBuffer=this.mediaBuffer,state=this.state;var currentTime=media?media.currentTime:0;var bufferInfo=BufferHelper.bufferInfo(mediaBuffer?mediaBuffer:media,currentTime,config.maxBufferHole);this.log("media seeking to ".concat(isFiniteNumber(currentTime)?currentTime.toFixed(3):currentTime,", state: ").concat(state));if(this.state===State.ENDED){this.resetLoadingState();}else if(fragCurrent){// Seeking while frag load is in progress
var tolerance=config.maxFragLookUpTolerance;var fragStartOffset=fragCurrent.start-tolerance;var fragEndOffset=fragCurrent.start+fragCurrent.duration+tolerance;// if seeking out of buffered range or into new one
if(!bufferInfo.len||fragEndOffset<bufferInfo.start||fragStartOffset>bufferInfo.end){var pastFragment=currentTime>fragEndOffset;// if the seek position is outside the current fragment range
if(currentTime<fragStartOffset||pastFragment){if(pastFragment&&fragCurrent.loader){this.log('seeking outside of buffer while fragment load in progress, cancel fragment load');fragCurrent.abortRequests();this.resetLoadingState();}this.fragPrevious=null;}}}if(media){// Remove gap fragments
this.fragmentTracker.removeFragmentsInRange(currentTime,Infinity,this.playlistType,true);this.lastCurrentTime=currentTime;}// in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
if(!this.loadedmetadata&&!bufferInfo.len){this.nextLoadPosition=this.startPosition=currentTime;}// Async tick to speed up processing
this.tickImmediate();}},{key:"onMediaEnded",value:function onMediaEnded(){// reset startPosition and lastCurrentTime to restart playback @ stream beginning
this.startPosition=this.lastCurrentTime=0;}},{key:"onManifestLoaded",value:function onManifestLoaded(event,data){this.startTimeOffset=data.startTimeOffset;this.initPTS=[];}},{key:"onHandlerDestroying",value:function onHandlerDestroying(){this.hls.off(Events.MANIFEST_LOADED,this.onManifestLoaded,this);this.stopLoad();_get(_getPrototypeOf(BaseStreamController.prototype),"onHandlerDestroying",this).call(this);// @ts-ignore
this.hls=null;}},{key:"onHandlerDestroyed",value:function onHandlerDestroyed(){this.state=State.STOPPED;if(this.fragmentLoader){this.fragmentLoader.destroy();}if(this.keyLoader){this.keyLoader.destroy();}if(this.decrypter){this.decrypter.destroy();}this.hls=this.log=this.warn=this.decrypter=this.keyLoader=this.fragmentLoader=this.fragmentTracker=null;_get(_getPrototypeOf(BaseStreamController.prototype),"onHandlerDestroyed",this).call(this);}},{key:"loadFragment",value:function loadFragment(frag,level,targetBufferTime){this._loadFragForPlayback(frag,level,targetBufferTime);}},{key:"_loadFragForPlayback",value:function _loadFragForPlayback(frag,level,targetBufferTime){var _this21=this;var progressCallback=function progressCallback(data){if(_this21.fragContextChanged(frag)){_this21.warn("Fragment ".concat(frag.sn).concat(data.part?' p: '+data.part.index:''," of level ").concat(frag.level," was dropped during download."));_this21.fragmentTracker.removeFragment(frag);return;}frag.stats.chunkCount++;_this21._handleFragmentLoadProgress(data);};this._doFragLoad(frag,level,targetBufferTime,progressCallback).then(function(data){if(!data){// if we're here we probably needed to backtrack or are waiting for more parts
return;}var state=_this21.state;if(_this21.fragContextChanged(frag)){if(state===State.FRAG_LOADING||!_this21.fragCurrent&&state===State.PARSING){_this21.fragmentTracker.removeFragment(frag);_this21.state=State.IDLE;}return;}if('payload'in data){_this21.log("Loaded fragment ".concat(frag.sn," of level ").concat(frag.level));_this21.hls.trigger(Events.FRAG_LOADED,data);}// Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
_this21._handleFragmentLoadComplete(data);})["catch"](function(reason){if(_this21.state===State.STOPPED||_this21.state===State.ERROR){return;}_this21.warn("Frag error: ".concat((reason==null?void 0:reason.message)||reason));_this21.resetFragmentLoading(frag);});}},{key:"clearTrackerIfNeeded",value:function clearTrackerIfNeeded(frag){var _this$mediaBuffer;var fragmentTracker=this.fragmentTracker;var fragState=fragmentTracker.getState(frag);if(fragState===FragmentState.APPENDING){// Lower the max buffer length and try again
var playlistType=frag.type;var bufferedInfo=this.getFwdBufferInfo(this.mediaBuffer,playlistType);var minForwardBufferLength=Math.max(frag.duration,bufferedInfo?bufferedInfo.len:this.config.maxBufferLength);// If backtracking, always remove from the tracker without reducing max buffer length
var backtrackFragment=this.backtrackFragment;var backtracked=backtrackFragment?frag.sn-backtrackFragment.sn:0;if(backtracked===1||this.reduceMaxBufferLength(minForwardBufferLength,frag.duration)){fragmentTracker.removeFragment(frag);}}else if(((_this$mediaBuffer=this.mediaBuffer)==null?void 0:_this$mediaBuffer.buffered.length)===0){// Stop gap for bad tracker / buffer flush behavior
fragmentTracker.removeAllFragments();}else if(fragmentTracker.hasParts(frag.type)){// In low latency mode, remove fragments for which only some parts were buffered
fragmentTracker.detectPartialFragments({frag:frag,part:null,stats:frag.stats,id:frag.type});if(fragmentTracker.getState(frag)===FragmentState.PARTIAL){fragmentTracker.removeFragment(frag);}}}},{key:"checkLiveUpdate",value:function checkLiveUpdate(details){if(details.updated&&!details.live){// Live stream ended, update fragment tracker
var lastFragment=details.fragments[details.fragments.length-1];this.fragmentTracker.detectPartialFragments({frag:lastFragment,part:null,stats:lastFragment.stats,id:lastFragment.type});}if(!details.fragments[0]){details.deltaUpdateFailed=true;}}},{key:"flushMainBuffer",value:function flushMainBuffer(startOffset,endOffset){var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;if(!(startOffset-endOffset)){return;}// When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
// passing a null type flushes both buffers
var flushScope={startOffset:startOffset,endOffset:endOffset,type:type};this.hls.trigger(Events.BUFFER_FLUSHING,flushScope);}},{key:"_loadInitSegment",value:function _loadInitSegment(frag,level){var _this22=this;this._doFragLoad(frag,level).then(function(data){if(!data||_this22.fragContextChanged(frag)||!_this22.levels){throw new Error('init load aborted');}return data;}).then(function(data){var hls=_this22.hls;var payload=data.payload;var decryptData=frag.decryptdata;// check to see if the payload needs to be decrypted
if(payload&&payload.byteLength>0&&decryptData!=null&&decryptData.key&&decryptData.iv&&decryptData.method==='AES-128'){var startTime=self.performance.now();// decrypt init segment data
return _this22.decrypter.decrypt(new Uint8Array(payload),decryptData.key.buffer,decryptData.iv.buffer)["catch"](function(err){hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.FRAG_DECRYPT_ERROR,fatal:false,error:err,reason:err.message,frag:frag});throw err;}).then(function(decryptedData){var endTime=self.performance.now();hls.trigger(Events.FRAG_DECRYPTED,{frag:frag,payload:decryptedData,stats:{tstart:startTime,tdecrypt:endTime}});data.payload=decryptedData;return _this22.completeInitSegmentLoad(data);});}return _this22.completeInitSegmentLoad(data);})["catch"](function(reason){if(_this22.state===State.STOPPED||_this22.state===State.ERROR){return;}_this22.warn(reason);_this22.resetFragmentLoading(frag);});}},{key:"completeInitSegmentLoad",value:function completeInitSegmentLoad(data){var levels=this.levels;if(!levels){throw new Error('init load aborted, missing levels');}var stats=data.frag.stats;this.state=State.IDLE;data.frag.data=new Uint8Array(data.payload);stats.parsing.start=stats.buffering.start=self.performance.now();stats.parsing.end=stats.buffering.end=self.performance.now();this.tick();}},{key:"fragContextChanged",value:function fragContextChanged(frag){var fragCurrent=this.fragCurrent;return !frag||!fragCurrent||frag.sn!==fragCurrent.sn||frag.level!==fragCurrent.level;}},{key:"fragBufferedComplete",value:function fragBufferedComplete(frag,part){var _frag$startPTS,_frag$endPTS,_this$fragCurrent,_this$fragPrevious;var media=this.mediaBuffer?this.mediaBuffer:this.media;this.log("Buffered ".concat(frag.type," sn: ").concat(frag.sn).concat(part?' part: '+part.index:''," of ").concat(this.playlistType===PlaylistLevelType.MAIN?'level':'track'," ").concat(frag.level," (frag:[").concat(((_frag$startPTS=frag.startPTS)!=null?_frag$startPTS:NaN).toFixed(3),"-").concat(((_frag$endPTS=frag.endPTS)!=null?_frag$endPTS:NaN).toFixed(3),"] > buffer:").concat(media?TimeRanges.toString(BufferHelper.getBuffered(media)):'(detached)',")"));if(frag.sn!=='initSegment'){var _this$levels;if(frag.type!==PlaylistLevelType.SUBTITLE){var el=frag.elementaryStreams;if(!Object.keys(el).some(function(type){return !!el[type];})){// empty segment
this.state=State.IDLE;return;}}var level=(_this$levels=this.levels)==null?void 0:_this$levels[frag.level];if(level!=null&&level.fragmentError){this.log("Resetting level fragment error count of ".concat(level.fragmentError," on frag buffered"));level.fragmentError=0;}}this.state=State.IDLE;if(!media){return;}if(!this.loadedmetadata&&frag.type==PlaylistLevelType.MAIN&&media.buffered.length&&((_this$fragCurrent=this.fragCurrent)==null?void 0:_this$fragCurrent.sn)===((_this$fragPrevious=this.fragPrevious)==null?void 0:_this$fragPrevious.sn)){this.loadedmetadata=true;this.seekToStartPos();}this.tick();}},{key:"seekToStartPos",value:function seekToStartPos(){}},{key:"_handleFragmentLoadComplete",value:function _handleFragmentLoadComplete(fragLoadedEndData){var transmuxer=this.transmuxer;if(!transmuxer){return;}var frag=fragLoadedEndData.frag,part=fragLoadedEndData.part,partsLoaded=fragLoadedEndData.partsLoaded;// If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
var complete=!partsLoaded||partsLoaded.length===0||partsLoaded.some(function(fragLoaded){return !fragLoaded;});var chunkMeta=new ChunkMetadata(frag.level,frag.sn,frag.stats.chunkCount+1,0,part?part.index:-1,!complete);transmuxer.flush(chunkMeta);}// eslint-disable-next-line @typescript-eslint/no-unused-vars
},{key:"_handleFragmentLoadProgress",value:function _handleFragmentLoadProgress(frag){}},{key:"_doFragLoad",value:function _doFragLoad(frag,level){var _this23=this;var targetBufferTime=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var progressCallback=arguments.length>3?arguments[3]:undefined;var _frag$decryptdata;var details=level==null?void 0:level.details;if(!this.levels||!details){throw new Error("frag load aborted, missing level".concat(details?'':' detail',"s"));}var keyLoadingPromise=null;if(frag.encrypted&&!((_frag$decryptdata=frag.decryptdata)!=null&&_frag$decryptdata.key)){this.log("Loading key for ".concat(frag.sn," of [").concat(details.startSN,"-").concat(details.endSN,"], ").concat(this.logPrefix==='[stream-controller]'?'level':'track'," ").concat(frag.level));this.state=State.KEY_LOADING;this.fragCurrent=frag;keyLoadingPromise=this.keyLoader.load(frag).then(function(keyLoadedData){if(!_this23.fragContextChanged(keyLoadedData.frag)){_this23.hls.trigger(Events.KEY_LOADED,keyLoadedData);if(_this23.state===State.KEY_LOADING){_this23.state=State.IDLE;}return keyLoadedData;}});this.hls.trigger(Events.KEY_LOADING,{frag:frag});if(this.fragCurrent===null){keyLoadingPromise=Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING"));}}else if(!frag.encrypted&&details.encryptedFragments.length){this.keyLoader.loadClear(frag,details.encryptedFragments);}targetBufferTime=Math.max(frag.start,targetBufferTime||0);if(this.config.lowLatencyMode&&frag.sn!=='initSegment'){var partList=details.partList;if(partList&&progressCallback){if(targetBufferTime>frag.end&&details.fragmentHint){frag=details.fragmentHint;}var partIndex=this.getNextPart(partList,frag,targetBufferTime);if(partIndex>-1){var part=partList[partIndex];this.log("Loading part sn: ".concat(frag.sn," p: ").concat(part.index," cc: ").concat(frag.cc," of playlist [").concat(details.startSN,"-").concat(details.endSN,"] parts [0-").concat(partIndex,"-").concat(partList.length-1,"] ").concat(this.logPrefix==='[stream-controller]'?'level':'track',": ").concat(frag.level,", target: ").concat(parseFloat(targetBufferTime.toFixed(3))));this.nextLoadPosition=part.start+part.duration;this.state=State.FRAG_LOADING;var _result;if(keyLoadingPromise){_result=keyLoadingPromise.then(function(keyLoadedData){if(!keyLoadedData||_this23.fragContextChanged(keyLoadedData.frag)){return null;}return _this23.doFragPartsLoad(frag,part,level,progressCallback);})["catch"](function(error){return _this23.handleFragLoadError(error);});}else {_result=this.doFragPartsLoad(frag,part,level,progressCallback)["catch"](function(error){return _this23.handleFragLoadError(error);});}this.hls.trigger(Events.FRAG_LOADING,{frag:frag,part:part,targetBufferTime:targetBufferTime});if(this.fragCurrent===null){return Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts"));}return _result;}else if(!frag.url||this.loadedEndOfParts(partList,targetBufferTime)){// Fragment hint has no parts
return Promise.resolve(null);}}}this.log("Loading fragment ".concat(frag.sn," cc: ").concat(frag.cc," ").concat(details?'of ['+details.startSN+'-'+details.endSN+'] ':'').concat(this.logPrefix==='[stream-controller]'?'level':'track',": ").concat(frag.level,", target: ").concat(parseFloat(targetBufferTime.toFixed(3))));// Don't update nextLoadPosition for fragments which are not buffered
if(isFiniteNumber(frag.sn)&&!this.bitrateTest){this.nextLoadPosition=frag.start+frag.duration;}this.state=State.FRAG_LOADING;// Load key before streaming fragment data
var dataOnProgress=this.config.progressive;var result;if(dataOnProgress&&keyLoadingPromise){result=keyLoadingPromise.then(function(keyLoadedData){if(!keyLoadedData||_this23.fragContextChanged(keyLoadedData==null?void 0:keyLoadedData.frag)){return null;}return _this23.fragmentLoader.load(frag,progressCallback);})["catch"](function(error){return _this23.handleFragLoadError(error);});}else {// load unencrypted fragment data with progress event,
// or handle fragment result after key and fragment are finished loading
result=Promise.all([this.fragmentLoader.load(frag,dataOnProgress?progressCallback:undefined),keyLoadingPromise]).then(function(_ref10){var _ref11=_slicedToArray(_ref10,1),fragLoadedData=_ref11[0];if(!dataOnProgress&&fragLoadedData&&progressCallback){progressCallback(fragLoadedData);}return fragLoadedData;})["catch"](function(error){return _this23.handleFragLoadError(error);});}this.hls.trigger(Events.FRAG_LOADING,{frag:frag,targetBufferTime:targetBufferTime});if(this.fragCurrent===null){return Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING"));}return result;}},{key:"doFragPartsLoad",value:function doFragPartsLoad(frag,fromPart,level,progressCallback){var _this24=this;return new Promise(function(resolve,reject){var _level$details;var partsLoaded=[];var initialPartList=(_level$details=level.details)==null?void 0:_level$details.partList;var loadPart=function loadPart(part){_this24.fragmentLoader.loadPart(frag,part,progressCallback).then(function(partLoadedData){partsLoaded[part.index]=partLoadedData;var loadedPart=partLoadedData.part;_this24.hls.trigger(Events.FRAG_LOADED,partLoadedData);var nextPart=getPartWith(level,frag.sn,part.index+1)||findPart(initialPartList,frag.sn,part.index+1);if(nextPart){loadPart(nextPart);}else {return resolve({frag:frag,part:loadedPart,partsLoaded:partsLoaded});}})["catch"](reject);};loadPart(fromPart);});}},{key:"handleFragLoadError",value:function handleFragLoadError(error){if('data'in error){var data=error.data;if(error.data&&data.details===ErrorDetails.INTERNAL_ABORTED){this.handleFragLoadAborted(data.frag,data.part);}else {this.hls.trigger(Events.ERROR,data);}}else {this.hls.trigger(Events.ERROR,{type:ErrorTypes.OTHER_ERROR,details:ErrorDetails.INTERNAL_EXCEPTION,err:error,error:error,fatal:true});}return null;}},{key:"_handleTransmuxerFlush",value:function _handleTransmuxerFlush(chunkMeta){var context=this.getCurrentContext(chunkMeta);if(!context||this.state!==State.PARSING){if(!this.fragCurrent&&this.state!==State.STOPPED&&this.state!==State.ERROR){this.state=State.IDLE;}return;}var frag=context.frag,part=context.part,level=context.level;var now=self.performance.now();frag.stats.parsing.end=now;if(part){part.stats.parsing.end=now;}this.updateLevelTiming(frag,part,level,chunkMeta.partial);}},{key:"getCurrentContext",value:function getCurrentContext(chunkMeta){var levels=this.levels,fragCurrent=this.fragCurrent;var levelIndex=chunkMeta.level,sn=chunkMeta.sn,partIndex=chunkMeta.part;if(!(levels!=null&&levels[levelIndex])){this.warn("Levels object was unset while buffering fragment ".concat(sn," of level ").concat(levelIndex,". The current chunk will not be buffered."));return null;}var level=levels[levelIndex];var part=partIndex>-1?getPartWith(level,sn,partIndex):null;var frag=part?part.fragment:getFragmentWithSN(level,sn,fragCurrent);if(!frag){return null;}if(fragCurrent&&fragCurrent!==frag){frag.stats=fragCurrent.stats;}return {frag:frag,part:part,level:level};}},{key:"bufferFragmentData",value:function bufferFragmentData(data,frag,part,chunkMeta,noBacktracking){var _buffer;if(!data||this.state!==State.PARSING){return;}var data1=data.data1,data2=data.data2;var buffer=data1;if(data1&&data2){// Combine the moof + mdat so that we buffer with a single append
buffer=appendUint8Array(data1,data2);}if(!((_buffer=buffer)!=null&&_buffer.length)){return;}var segment={type:data.type,frag:frag,part:part,chunkMeta:chunkMeta,parent:frag.type,data:buffer};this.hls.trigger(Events.BUFFER_APPENDING,segment);if(data.dropped&&data.independent&&!part){if(noBacktracking){return;}// Clear buffer so that we reload previous segments sequentially if required
this.flushBufferGap(frag);}}},{key:"flushBufferGap",value:function flushBufferGap(frag){var media=this.media;if(!media){return;}// If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
if(!BufferHelper.isBuffered(media,media.currentTime)){this.flushMainBuffer(0,frag.start);return;}// Remove back-buffer without interrupting playback to allow back tracking
var currentTime=media.currentTime;var bufferInfo=BufferHelper.bufferInfo(media,currentTime,0);var fragDuration=frag.duration;var segmentFraction=Math.min(this.config.maxFragLookUpTolerance*2,fragDuration*0.25);var start=Math.max(Math.min(frag.start-segmentFraction,bufferInfo.end-segmentFraction),currentTime+segmentFraction);if(frag.start-start>segmentFraction){this.flushMainBuffer(start,frag.start);}}},{key:"getFwdBufferInfo",value:function getFwdBufferInfo(bufferable,type){var pos=this.getLoadPosition();if(!isFiniteNumber(pos)){return null;}return this.getFwdBufferInfoAtPos(bufferable,pos,type);}},{key:"getFwdBufferInfoAtPos",value:function getFwdBufferInfoAtPos(bufferable,pos,type){var maxBufferHole=this.config.maxBufferHole;var bufferInfo=BufferHelper.bufferInfo(bufferable,pos,maxBufferHole);// Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
if(bufferInfo.len===0&&bufferInfo.nextStart!==undefined){var bufferedFragAtPos=this.fragmentTracker.getBufferedFrag(pos,type);if(bufferedFragAtPos&&bufferInfo.nextStart<bufferedFragAtPos.end){return BufferHelper.bufferInfo(bufferable,pos,Math.max(bufferInfo.nextStart,maxBufferHole));}}return bufferInfo;}},{key:"getMaxBufferLength",value:function getMaxBufferLength(levelBitrate){var config=this.config;var maxBufLen;if(levelBitrate){maxBufLen=Math.max(8*config.maxBufferSize/levelBitrate,config.maxBufferLength);}else {maxBufLen=config.maxBufferLength;}return Math.min(maxBufLen,config.maxMaxBufferLength);}},{key:"reduceMaxBufferLength",value:function reduceMaxBufferLength(threshold,fragDuration){var config=this.config;var minLength=Math.max(Math.min(threshold-fragDuration,config.maxBufferLength),fragDuration);var reducedLength=Math.max(threshold-fragDuration*3,config.maxMaxBufferLength/2,minLength);if(reducedLength>=minLength){// reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
config.maxMaxBufferLength=reducedLength;this.warn("Reduce max buffer length to ".concat(reducedLength,"s"));return true;}return false;}},{key:"getAppendedFrag",value:function getAppendedFrag(position){var fragOrPart=this.fragmentTracker.getAppendedFrag(position,PlaylistLevelType.MAIN);if(fragOrPart&&'fragment'in fragOrPart){return fragOrPart.fragment;}return fragOrPart;}},{key:"getNextFragment",value:function getNextFragment(pos,levelDetails){var fragments=levelDetails.fragments;var fragLen=fragments.length;if(!fragLen){return null;}// find fragment index, contiguous with end of buffer position
var config=this.config;var start=fragments[0].start;var frag;if(levelDetails.live){var initialLiveManifestSize=config.initialLiveManifestSize;if(fragLen<initialLiveManifestSize){this.warn("Not enough fragments to start playback (have: ".concat(fragLen,", need: ").concat(initialLiveManifestSize,")"));return null;}// The real fragment start times for a live stream are only known after the PTS range for that level is known.
// In order to discover the range, we load the best matching fragment for that level and demux it.
// Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
// we get the fragment matching that start time
if(!levelDetails.PTSKnown&&!this.startFragRequested&&this.startPosition===-1||pos<start){frag=this.getInitialLiveFragment(levelDetails,fragments);this.startPosition=this.nextLoadPosition=frag?this.hls.liveSyncPosition||frag.start:pos;}}else if(pos<=start){// VoD playlist: if loadPosition before start of playlist, load first fragment
frag=fragments[0];}// If we haven't run into any special cases already, just load the fragment most closely matching the requested position
if(!frag){var end=config.lowLatencyMode?levelDetails.partEnd:levelDetails.fragmentEnd;frag=this.getFragmentAtPosition(pos,end,levelDetails);}return this.mapToInitFragWhenRequired(frag);}},{key:"isLoopLoading",value:function isLoopLoading(frag,targetBufferTime){var trackerState=this.fragmentTracker.getState(frag);return (trackerState===FragmentState.OK||trackerState===FragmentState.PARTIAL&&!!frag.gap)&&this.nextLoadPosition>targetBufferTime;}},{key:"getNextFragmentLoopLoading",value:function getNextFragmentLoopLoading(frag,levelDetails,bufferInfo,playlistType,maxBufLen){var gapStart=frag.gap;var nextFragment=this.getNextFragment(this.nextLoadPosition,levelDetails);if(nextFragment===null){return nextFragment;}frag=nextFragment;if(gapStart&&frag&&!frag.gap&&bufferInfo.nextStart){// Media buffered after GAP tags should not make the next buffer timerange exceed forward buffer length
var nextbufferInfo=this.getFwdBufferInfoAtPos(this.mediaBuffer?this.mediaBuffer:this.media,bufferInfo.nextStart,playlistType);if(nextbufferInfo!==null&&bufferInfo.len+nextbufferInfo.len>=maxBufLen){// Returning here might result in not finding an audio and video candiate to skip to
this.log("buffer full after gaps in \"".concat(playlistType,"\" playlist starting at sn: ").concat(frag.sn));return null;}}return frag;}},{key:"mapToInitFragWhenRequired",value:function mapToInitFragWhenRequired(frag){// If an initSegment is present, it must be buffered first
if(frag!=null&&frag.initSegment&&!(frag!=null&&frag.initSegment.data)&&!this.bitrateTest){return frag.initSegment;}return frag;}},{key:"getNextPart",value:function getNextPart(partList,frag,targetBufferTime){var nextPart=-1;var contiguous=false;var independentAttrOmitted=true;for(var i=0,len=partList.length;i<len;i++){var part=partList[i];independentAttrOmitted=independentAttrOmitted&&!part.independent;if(nextPart>-1&&targetBufferTime<part.start){break;}var loaded=part.loaded;if(loaded){nextPart=-1;}else if((contiguous||part.independent||independentAttrOmitted)&&part.fragment===frag){nextPart=i;}contiguous=loaded;}return nextPart;}},{key:"loadedEndOfParts",value:function loadedEndOfParts(partList,targetBufferTime){var lastPart=partList[partList.length-1];return lastPart&&targetBufferTime>lastPart.start&&lastPart.loaded;}/*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */},{key:"getInitialLiveFragment",value:function getInitialLiveFragment(levelDetails,fragments){var fragPrevious=this.fragPrevious;var frag=null;if(fragPrevious){if(levelDetails.hasProgramDateTime){// Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
this.log("Live playlist, switching playlist, load frag with same PDT: ".concat(fragPrevious.programDateTime));frag=findFragmentByPDT(fragments,fragPrevious.endProgramDateTime,this.config.maxFragLookUpTolerance);}if(!frag){// SN does not need to be accurate between renditions, but depending on the packaging it may be so.
var targetSN=fragPrevious.sn+1;if(targetSN>=levelDetails.startSN&&targetSN<=levelDetails.endSN){var fragNext=fragments[targetSN-levelDetails.startSN];// Ensure that we're staying within the continuity range, since PTS resets upon a new range
if(fragPrevious.cc===fragNext.cc){frag=fragNext;this.log("Live playlist, switching playlist, load frag with next SN: ".concat(frag.sn));}}// It's important to stay within the continuity range if available; otherwise the fragments in the playlist
// will have the wrong start times
if(!frag){frag=findFragWithCC(fragments,fragPrevious.cc);if(frag){this.log("Live playlist, switching playlist, load frag with same CC: ".concat(frag.sn));}}}}else {// Find a new start fragment when fragPrevious is null
var liveStart=this.hls.liveSyncPosition;if(liveStart!==null){frag=this.getFragmentAtPosition(liveStart,this.bitrateTest?levelDetails.fragmentEnd:levelDetails.edge,levelDetails);}}return frag;}/*
  This method finds the best matching fragment given the provided position.
   */},{key:"getFragmentAtPosition",value:function getFragmentAtPosition(bufferEnd,end,levelDetails){var config=this.config;var fragPrevious=this.fragPrevious;var fragments=levelDetails.fragments,endSN=levelDetails.endSN;var fragmentHint=levelDetails.fragmentHint;var maxFragLookUpTolerance=config.maxFragLookUpTolerance;var partList=levelDetails.partList;var loadingParts=!!(config.lowLatencyMode&&partList!=null&&partList.length&&fragmentHint);if(loadingParts&&fragmentHint&&!this.bitrateTest){// Include incomplete fragment with parts at end
fragments=fragments.concat(fragmentHint);endSN=fragmentHint.sn;}var frag;if(bufferEnd<end){var lookupTolerance=bufferEnd>end-maxFragLookUpTolerance?0:maxFragLookUpTolerance;// Remove the tolerance if it would put the bufferEnd past the actual end of stream
// Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
frag=findFragmentByPTS(fragPrevious,fragments,bufferEnd,lookupTolerance);}else {// reach end of playlist
frag=fragments[fragments.length-1];}if(frag){var curSNIdx=frag.sn-levelDetails.startSN;// Move fragPrevious forward to support forcing the next fragment to load
// when the buffer catches up to a previously buffered range.
var fragState=this.fragmentTracker.getState(frag);if(fragState===FragmentState.OK||fragState===FragmentState.PARTIAL&&frag.gap){fragPrevious=frag;}if(fragPrevious&&frag.sn===fragPrevious.sn&&(!loadingParts||partList[0].fragment.sn>frag.sn)){// Force the next fragment to load if the previous one was already selected. This can occasionally happen with
// non-uniform fragment durations
var sameLevel=fragPrevious&&frag.level===fragPrevious.level;if(sameLevel){var nextFrag=fragments[curSNIdx+1];if(frag.sn<endSN&&this.fragmentTracker.getState(nextFrag)!==FragmentState.OK){frag=nextFrag;}else {frag=null;}}}}return frag;}},{key:"synchronizeToLiveEdge",value:function synchronizeToLiveEdge(levelDetails){var config=this.config,media=this.media;if(!media){return;}var liveSyncPosition=this.hls.liveSyncPosition;var currentTime=media.currentTime;var start=levelDetails.fragments[0].start;var end=levelDetails.edge;var withinSlidingWindow=currentTime>=start-config.maxFragLookUpTolerance&&currentTime<=end;// Continue if we can seek forward to sync position or if current time is outside of sliding window
if(liveSyncPosition!==null&&media.duration>liveSyncPosition&&(currentTime<liveSyncPosition||!withinSlidingWindow)){// Continue if buffer is starving or if current time is behind max latency
var maxLatency=config.liveMaxLatencyDuration!==undefined?config.liveMaxLatencyDuration:config.liveMaxLatencyDurationCount*levelDetails.targetduration;if(!withinSlidingWindow&&media.readyState<4||currentTime<end-maxLatency){if(!this.loadedmetadata){this.nextLoadPosition=liveSyncPosition;}// Only seek if ready and there is not a significant forward buffer available for playback
if(media.readyState){this.warn("Playback: ".concat(currentTime.toFixed(3)," is located too far from the end of live sliding playlist: ").concat(end,", reset currentTime to : ").concat(liveSyncPosition.toFixed(3)));media.currentTime=liveSyncPosition;}}}}},{key:"alignPlaylists",value:function alignPlaylists(details,previousDetails,switchDetails){// FIXME: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
//  this could all go in level-helper mergeDetails()
var length=details.fragments.length;if(!length){this.warn("No fragments in live playlist");return 0;}var slidingStart=details.fragments[0].start;var firstLevelLoad=!previousDetails;var aligned=details.alignedSliding&&isFiniteNumber(slidingStart);if(firstLevelLoad||!aligned&&!slidingStart){var fragPrevious=this.fragPrevious;alignStream(fragPrevious,switchDetails,details);var alignedSlidingStart=details.fragments[0].start;this.log("Live playlist sliding: ".concat(alignedSlidingStart.toFixed(2)," start-sn: ").concat(previousDetails?previousDetails.startSN:'na',"->").concat(details.startSN," prev-sn: ").concat(fragPrevious?fragPrevious.sn:'na'," fragments: ").concat(length));return alignedSlidingStart;}return slidingStart;}},{key:"waitForCdnTuneIn",value:function waitForCdnTuneIn(details){// Wait for Low-Latency CDN Tune-in to get an updated playlist
var advancePartLimit=3;return details.live&&details.canBlockReload&&details.partTarget&&details.tuneInGoal>Math.max(details.partHoldBack,details.partTarget*advancePartLimit);}},{key:"setStartPosition",value:function setStartPosition(details,sliding){// compute start position if set to -1. use it straight away if value is defined
var startPosition=this.startPosition;if(startPosition<sliding){startPosition=-1;}if(startPosition===-1||this.lastCurrentTime===-1){// Use Playlist EXT-X-START:TIME-OFFSET when set
// Prioritize Multivariant Playlist offset so that main, audio, and subtitle stream-controller start times match
var offsetInMultivariantPlaylist=this.startTimeOffset!==null;var startTimeOffset=offsetInMultivariantPlaylist?this.startTimeOffset:details.startTimeOffset;if(startTimeOffset!==null&&isFiniteNumber(startTimeOffset)){startPosition=sliding+startTimeOffset;if(startTimeOffset<0){startPosition+=details.totalduration;}startPosition=Math.min(Math.max(sliding,startPosition),sliding+details.totalduration);this.log("Start time offset ".concat(startTimeOffset," found in ").concat(offsetInMultivariantPlaylist?'multivariant':'media'," playlist, adjust startPosition to ").concat(startPosition));this.startPosition=startPosition;}else if(details.live){// Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
// not been specified via the config or an as an argument to startLoad (#3736).
startPosition=this.hls.liveSyncPosition||sliding;}else {this.startPosition=startPosition=0;}this.lastCurrentTime=startPosition;}this.nextLoadPosition=startPosition;}},{key:"getLoadPosition",value:function getLoadPosition(){var media=this.media;// if we have not yet loaded any fragment, start loading from start position
var pos=0;if(this.loadedmetadata&&media){pos=media.currentTime;}else if(this.nextLoadPosition){pos=this.nextLoadPosition;}return pos;}},{key:"handleFragLoadAborted",value:function handleFragLoadAborted(frag,part){if(this.transmuxer&&frag.sn!=='initSegment'&&frag.stats.aborted){this.warn("Fragment ".concat(frag.sn).concat(part?' part '+part.index:''," of level ").concat(frag.level," was aborted"));this.resetFragmentLoading(frag);}}},{key:"resetFragmentLoading",value:function resetFragmentLoading(frag){if(!this.fragCurrent||!this.fragContextChanged(frag)&&this.state!==State.FRAG_LOADING_WAITING_RETRY){this.state=State.IDLE;}}},{key:"onFragmentOrKeyLoadError",value:function onFragmentOrKeyLoadError(filterType,data){if(data.chunkMeta&&!data.frag){var context=this.getCurrentContext(data.chunkMeta);if(context){data.frag=context.frag;}}var frag=data.frag;// Handle frag error related to caller's filterType
if(!frag||frag.type!==filterType||!this.levels){return;}if(this.fragContextChanged(frag)){var _this$fragCurrent2;this.warn("Frag load error must match current frag to retry ".concat(frag.url," > ").concat((_this$fragCurrent2=this.fragCurrent)==null?void 0:_this$fragCurrent2.url));return;}var gapTagEncountered=data.details===ErrorDetails.FRAG_GAP;if(gapTagEncountered){this.fragmentTracker.fragBuffered(frag,true);}// keep retrying until the limit will be reached
var errorAction=data.errorAction;var _ref12=errorAction||{},action=_ref12.action,_ref12$retryCount=_ref12.retryCount,retryCount=_ref12$retryCount===void 0?0:_ref12$retryCount,retryConfig=_ref12.retryConfig;if(errorAction&&action===NetworkErrorAction.RetryRequest&&retryConfig){this.resetStartWhenNotLoaded(this.levelLastLoaded);var delay=getRetryDelay(retryConfig,retryCount);this.warn("Fragment ".concat(frag.sn," of ").concat(filterType," ").concat(frag.level," errored with ").concat(data.details,", retrying loading ").concat(retryCount+1,"/").concat(retryConfig.maxNumRetry," in ").concat(delay,"ms"));errorAction.resolved=true;this.retryDate=self.performance.now()+delay;this.state=State.FRAG_LOADING_WAITING_RETRY;}else if(retryConfig&&errorAction){this.resetFragmentErrors(filterType);if(retryCount<retryConfig.maxNumRetry){// Network retry is skipped when level switch is preferred
if(!gapTagEncountered&&action!==NetworkErrorAction.RemoveAlternatePermanently){errorAction.resolved=true;}}else {logger.warn("".concat(data.details," reached or exceeded max retry (").concat(retryCount,")"));return;}}else if((errorAction==null?void 0:errorAction.action)===NetworkErrorAction.SendAlternateToPenaltyBox){this.state=State.WAITING_LEVEL;}else {this.state=State.ERROR;}// Perform next async tick sooner to speed up error action resolution
this.tickImmediate();}},{key:"reduceLengthAndFlushBuffer",value:function reduceLengthAndFlushBuffer(data){// if in appending state
if(this.state===State.PARSING||this.state===State.PARSED){var frag=data.frag;var playlistType=data.parent;var bufferedInfo=this.getFwdBufferInfo(this.mediaBuffer,playlistType);// 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
// reduce max buf len if current position is buffered
var buffered=bufferedInfo&&bufferedInfo.len>0.5;if(buffered){this.reduceMaxBufferLength(bufferedInfo.len,(frag==null?void 0:frag.duration)||10);}var flushBuffer=!buffered;if(flushBuffer){// current position is not buffered, but browser is still complaining about buffer full error
// this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
// in that case flush the whole audio buffer to recover
this.warn("Buffer full error while media.currentTime is not buffered, flush ".concat(playlistType," buffer"));}if(frag){this.fragmentTracker.removeFragment(frag);this.nextLoadPosition=frag.start;}this.resetLoadingState();return flushBuffer;}return false;}},{key:"resetFragmentErrors",value:function resetFragmentErrors(filterType){if(filterType===PlaylistLevelType.AUDIO){// Reset current fragment since audio track audio is essential and may not have a fail-over track
this.fragCurrent=null;}// Fragment errors that result in a level switch or redundant fail-over
// should reset the stream controller state to idle
if(!this.loadedmetadata){this.startFragRequested=false;}if(this.state!==State.STOPPED){this.state=State.IDLE;}}},{key:"afterBufferFlushed",value:function afterBufferFlushed(media,bufferType,playlistType){if(!media){return;}// After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
// (so that we will check against video.buffered ranges in case of alt audio track)
var bufferedTimeRanges=BufferHelper.getBuffered(media);this.fragmentTracker.detectEvictedFragments(bufferType,bufferedTimeRanges,playlistType);if(this.state===State.ENDED){this.resetLoadingState();}}},{key:"resetLoadingState",value:function resetLoadingState(){this.log('Reset loading state');this.fragCurrent=null;this.fragPrevious=null;this.state=State.IDLE;}},{key:"resetStartWhenNotLoaded",value:function resetStartWhenNotLoaded(level){// if loadedmetadata is not set, it means that first frag request failed
// in that case, reset startFragRequested flag
if(!this.loadedmetadata){this.startFragRequested=false;var details=level?level.details:null;if(details!=null&&details.live){// Update the start position and return to IDLE to recover live start
this.startPosition=-1;this.setStartPosition(details,0);this.resetLoadingState();}else {this.nextLoadPosition=this.startPosition;}}}},{key:"resetWhenMissingContext",value:function resetWhenMissingContext(chunkMeta){this.warn("The loading context changed while buffering fragment ".concat(chunkMeta.sn," of level ").concat(chunkMeta.level,". This chunk will not be buffered."));this.removeUnbufferedFrags();this.resetStartWhenNotLoaded(this.levelLastLoaded);this.resetLoadingState();}},{key:"removeUnbufferedFrags",value:function removeUnbufferedFrags(){var start=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;this.fragmentTracker.removeFragmentsInRange(start,Infinity,this.playlistType,false,true);}},{key:"updateLevelTiming",value:function updateLevelTiming(frag,part,level,partial){var _this25=this;var _this$transmuxer;var details=level.details;if(!details){this.warn('level.details undefined');return;}var parsed=Object.keys(frag.elementaryStreams).reduce(function(result,type){var info=frag.elementaryStreams[type];if(info){var parsedDuration=info.endPTS-info.startPTS;if(parsedDuration<=0){// Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
// The new transmuxer will be configured with a time offset matching the next fragment start,
// preventing the timeline from shifting.
_this25.warn("Could not parse fragment ".concat(frag.sn," ").concat(type," duration reliably (").concat(parsedDuration,")"));return result||false;}var drift=partial?0:updateFragPTSDTS(details,frag,info.startPTS,info.endPTS,info.startDTS,info.endDTS);_this25.hls.trigger(Events.LEVEL_PTS_UPDATED,{details:details,level:level,drift:drift,type:type,frag:frag,start:info.startPTS,end:info.endPTS});return true;}return result;},false);if(!parsed&&((_this$transmuxer=this.transmuxer)==null?void 0:_this$transmuxer.error)===null){var error=new Error("Found no media in fragment ".concat(frag.sn," of level ").concat(frag.level," resetting transmuxer to fallback to playlist timing"));if(level.fragmentError===0){// Mark and track the odd empty segment as a gap to avoid reloading
level.fragmentError++;frag.gap=true;this.fragmentTracker.removeFragment(frag);this.fragmentTracker.fragBuffered(frag,true);}this.warn(error.message);this.hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.FRAG_PARSING_ERROR,fatal:false,error:error,frag:frag,reason:"Found no media in msn ".concat(frag.sn," of level \"").concat(level.url,"\"")});if(!this.hls){return;}this.resetTransmuxer();// For this error fallthrough. Marking parsed will allow advancing to next fragment.
}this.state=State.PARSED;this.hls.trigger(Events.FRAG_PARSED,{frag:frag,part:part});}},{key:"resetTransmuxer",value:function resetTransmuxer(){if(this.transmuxer){this.transmuxer.destroy();this.transmuxer=null;}}},{key:"recoverWorkerError",value:function recoverWorkerError(data){if(data.event==='demuxerWorker'){this.fragmentTracker.removeAllFragments();this.resetTransmuxer();this.resetStartWhenNotLoaded(this.levelLastLoaded);this.resetLoadingState();}}},{key:"state",get:function get(){return this._state;},set:function set(nextState){var previousState=this._state;if(previousState!==nextState){this._state=nextState;this.log("".concat(previousState,"->").concat(nextState));}}}]);return BaseStreamController;}(TaskLoop);var ChunkCache=/*#__PURE__*/function(){function ChunkCache(){_classCallCheck(this,ChunkCache);this.chunks=[];this.dataLength=0;}_createClass(ChunkCache,[{key:"push",value:function push(chunk){this.chunks.push(chunk);this.dataLength+=chunk.length;}},{key:"flush",value:function flush(){var chunks=this.chunks,dataLength=this.dataLength;var result;if(!chunks.length){return new Uint8Array(0);}else if(chunks.length===1){result=chunks[0];}else {result=concatUint8Arrays(chunks,dataLength);}this.reset();return result;}},{key:"reset",value:function reset(){this.chunks.length=0;this.dataLength=0;}}]);return ChunkCache;}();function concatUint8Arrays(chunks,dataLength){var result=new Uint8Array(dataLength);var offset=0;for(var i=0;i<chunks.length;i++){var chunk=chunks[i];result.set(chunk,offset);offset+=chunk.length;}return result;}// ensure the worker ends up in the bundle
// If the worker should not be included this gets aliased to empty.js
function hasUMDWorker(){return typeof __HLS_WORKER_BUNDLE__==='function';}function injectWorker(){var blob=new self.Blob(["var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(".concat(__HLS_WORKER_BUNDLE__.toString(),")(true);")],{type:'text/javascript'});var objectURL=self.URL.createObjectURL(blob);var worker=new self.Worker(objectURL);return {worker:worker,objectURL:objectURL};}function loadWorker(path){var scriptURL=new self.URL(path,self.location.href).href;var worker=new self.Worker(scriptURL);return {worker:worker,scriptURL:scriptURL};}function dummyTrack(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var inputTimeScale=arguments.length>1&&arguments[1]!==undefined?arguments[1]:90000;return {type:type,id:-1,pid:-1,inputTimeScale:inputTimeScale,sequenceNumber:-1,samples:[],dropped:0};}var BaseAudioDemuxer=/*#__PURE__*/function(){function BaseAudioDemuxer(){_classCallCheck(this,BaseAudioDemuxer);this._audioTrack=void 0;this._id3Track=void 0;this.frameIndex=0;this.cachedData=null;this.basePTS=null;this.initPTS=null;this.lastPTS=null;}_createClass(BaseAudioDemuxer,[{key:"resetInitSegment",value:function resetInitSegment(initSegment,audioCodec,videoCodec,trackDuration){this._id3Track={type:'id3',id:3,pid:-1,inputTimeScale:90000,sequenceNumber:0,samples:[],dropped:0};}},{key:"resetTimeStamp",value:function resetTimeStamp(deaultTimestamp){this.initPTS=deaultTimestamp;this.resetContiguity();}},{key:"resetContiguity",value:function resetContiguity(){this.basePTS=null;this.lastPTS=null;this.frameIndex=0;}},{key:"canParse",value:function canParse(data,offset){return false;}},{key:"appendFrame",value:function appendFrame(track,data,offset){}// feed incoming data to the front of the parsing pipeline
},{key:"demux",value:function demux(data,timeOffset){if(this.cachedData){data=appendUint8Array(this.cachedData,data);this.cachedData=null;}var id3Data=getID3Data(data,0);var offset=id3Data?id3Data.length:0;var lastDataIndex;var track=this._audioTrack;var id3Track=this._id3Track;var timestamp=id3Data?getTimeStamp(id3Data):undefined;var length=data.length;if(this.basePTS===null||this.frameIndex===0&&isFiniteNumber(timestamp)){this.basePTS=initPTSFn(timestamp,timeOffset,this.initPTS);this.lastPTS=this.basePTS;}if(this.lastPTS===null){this.lastPTS=this.basePTS;}// more expressive than alternative: id3Data?.length
if(id3Data&&id3Data.length>0){id3Track.samples.push({pts:this.lastPTS,dts:this.lastPTS,data:id3Data,type:MetadataSchema.audioId3,duration:Number.POSITIVE_INFINITY});}while(offset<length){if(this.canParse(data,offset)){var frame=this.appendFrame(track,data,offset);if(frame){this.frameIndex++;this.lastPTS=frame.sample.pts;offset+=frame.length;lastDataIndex=offset;}else {offset=length;}}else if(canParse$2(data,offset)){// after a ID3.canParse, a call to ID3.getID3Data *should* always returns some data
id3Data=getID3Data(data,offset);id3Track.samples.push({pts:this.lastPTS,dts:this.lastPTS,data:id3Data,type:MetadataSchema.audioId3,duration:Number.POSITIVE_INFINITY});offset+=id3Data.length;lastDataIndex=offset;}else {offset++;}if(offset===length&&lastDataIndex!==length){var partialData=sliceUint8(data,lastDataIndex);if(this.cachedData){this.cachedData=appendUint8Array(this.cachedData,partialData);}else {this.cachedData=partialData;}}}return {audioTrack:track,videoTrack:dummyTrack(),id3Track:id3Track,textTrack:dummyTrack()};}},{key:"demuxSampleAes",value:function demuxSampleAes(data,keyData,timeOffset){return Promise.reject(new Error("[".concat(this,"] This demuxer does not support Sample-AES decryption")));}},{key:"flush",value:function flush(timeOffset){// Parse cache in case of remaining frames.
var cachedData=this.cachedData;if(cachedData){this.cachedData=null;this.demux(cachedData,0);}return {audioTrack:this._audioTrack,videoTrack:dummyTrack(),id3Track:this._id3Track,textTrack:dummyTrack()};}},{key:"destroy",value:function destroy(){}}]);return BaseAudioDemuxer;}();/**
 * Initialize PTS
 * <p>
 *    use timestamp unless it is undefined, NaN or Infinity
 * </p>
 */var initPTSFn=function initPTSFn(timestamp,timeOffset,initPTS){if(isFiniteNumber(timestamp)){return timestamp*90;}var init90kHz=initPTS?initPTS.baseTime*90000/initPTS.timescale:0;return timeOffset*90000+init90kHz;};/**
 * ADTS parser helper
 * @link https://wiki.multimedia.cx/index.php?title=ADTS
 */function getAudioConfig(observer,data,offset,audioCodec){var adtsObjectType;var adtsExtensionSamplingIndex;var adtsChannelConfig;var config;var userAgent=navigator.userAgent.toLowerCase();var manifestCodec=audioCodec;var adtsSamplingRates=[96000,88200,64000,48000,44100,32000,24000,22050,16000,12000,11025,8000,7350];// byte 2
adtsObjectType=((data[offset+2]&0xc0)>>>6)+1;var adtsSamplingIndex=(data[offset+2]&0x3c)>>>2;if(adtsSamplingIndex>adtsSamplingRates.length-1){var error=new Error("invalid ADTS sampling index:".concat(adtsSamplingIndex));observer.emit(Events.ERROR,Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.FRAG_PARSING_ERROR,fatal:true,error:error,reason:error.message});return;}adtsChannelConfig=(data[offset+2]&0x01)<<2;// byte 3
adtsChannelConfig|=(data[offset+3]&0xc0)>>>6;logger.log("manifest codec:".concat(audioCodec,", ADTS type:").concat(adtsObjectType,", samplingIndex:").concat(adtsSamplingIndex));// firefox: freq less than 24kHz = AAC SBR (HE-AAC)
if(/firefox/i.test(userAgent)){if(adtsSamplingIndex>=6){adtsObjectType=5;config=new Array(4);// HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
// there is a factor 2 between frame sample rate and output sample rate
// multiply frequency by 2 (see table below, equivalent to substract 3)
adtsExtensionSamplingIndex=adtsSamplingIndex-3;}else {adtsObjectType=2;config=new Array(2);adtsExtensionSamplingIndex=adtsSamplingIndex;}// Android : always use AAC
}else if(userAgent.indexOf('android')!==-1){adtsObjectType=2;config=new Array(2);adtsExtensionSamplingIndex=adtsSamplingIndex;}else {/*  for other browsers (Chrome/Vivaldi/Opera ...)
        always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
    */adtsObjectType=5;config=new Array(4);// if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
if(audioCodec&&(audioCodec.indexOf('mp4a.40.29')!==-1||audioCodec.indexOf('mp4a.40.5')!==-1)||!audioCodec&&adtsSamplingIndex>=6){// HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
// there is a factor 2 between frame sample rate and output sample rate
// multiply frequency by 2 (see table below, equivalent to substract 3)
adtsExtensionSamplingIndex=adtsSamplingIndex-3;}else {// if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
// Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
if(audioCodec&&audioCodec.indexOf('mp4a.40.2')!==-1&&(adtsSamplingIndex>=6&&adtsChannelConfig===1||/vivaldi/i.test(userAgent))||!audioCodec&&adtsChannelConfig===1){adtsObjectType=2;config=new Array(2);}adtsExtensionSamplingIndex=adtsSamplingIndex;}}/* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */ // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
config[0]=adtsObjectType<<3;// samplingFrequencyIndex
config[0]|=(adtsSamplingIndex&0x0e)>>1;config[1]|=(adtsSamplingIndex&0x01)<<7;// channelConfiguration
config[1]|=adtsChannelConfig<<3;if(adtsObjectType===5){// adtsExtensionSamplingIndex
config[1]|=(adtsExtensionSamplingIndex&0x0e)>>1;config[2]=(adtsExtensionSamplingIndex&0x01)<<7;// adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
//    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
config[2]|=2<<2;config[3]=0;}return {config:config,samplerate:adtsSamplingRates[adtsSamplingIndex],channelCount:adtsChannelConfig,codec:'mp4a.40.'+adtsObjectType,manifestCodec:manifestCodec};}function isHeaderPattern$1(data,offset){return data[offset]===0xff&&(data[offset+1]&0xf6)===0xf0;}function getHeaderLength(data,offset){return data[offset+1]&0x01?7:9;}function getFullFrameLength(data,offset){return (data[offset+3]&0x03)<<11|data[offset+4]<<3|(data[offset+5]&0xe0)>>>5;}function canGetFrameLength(data,offset){return offset+5<data.length;}function isHeader$1(data,offset){// Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
// Layer bits (position 14 and 15) in header should be always 0 for ADTS
// More info https://wiki.multimedia.cx/index.php?title=ADTS
return offset+1<data.length&&isHeaderPattern$1(data,offset);}function canParse$1(data,offset){return canGetFrameLength(data,offset)&&isHeaderPattern$1(data,offset)&&getFullFrameLength(data,offset)<=data.length-offset;}function probe$1(data,offset){// same as isHeader but we also check that ADTS frame follows last ADTS frame
// or end of data is reached
if(isHeader$1(data,offset)){// ADTS header Length
var headerLength=getHeaderLength(data,offset);if(offset+headerLength>=data.length){return false;}// ADTS frame Length
var frameLength=getFullFrameLength(data,offset);if(frameLength<=headerLength){return false;}var newOffset=offset+frameLength;return newOffset===data.length||isHeader$1(data,newOffset);}return false;}function initTrackConfig(track,observer,data,offset,audioCodec){if(!track.samplerate){var config=getAudioConfig(observer,data,offset,audioCodec);if(!config){return;}track.config=config.config;track.samplerate=config.samplerate;track.channelCount=config.channelCount;track.codec=config.codec;track.manifestCodec=config.manifestCodec;logger.log("parsed codec:".concat(track.codec,", rate:").concat(config.samplerate,", channels:").concat(config.channelCount));}}function getFrameDuration(samplerate){return 1024*90000/samplerate;}function parseFrameHeader(data,offset){// The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
var headerLength=getHeaderLength(data,offset);if(offset+headerLength<=data.length){// retrieve frame size
var frameLength=getFullFrameLength(data,offset)-headerLength;if(frameLength>0){// logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
return {headerLength:headerLength,frameLength:frameLength};}}}function appendFrame$2(track,data,offset,pts,frameIndex){var frameDuration=getFrameDuration(track.samplerate);var stamp=pts+frameIndex*frameDuration;var header=parseFrameHeader(data,offset);var unit;if(header){var frameLength=header.frameLength,headerLength=header.headerLength;var _length=headerLength+frameLength;var missing=Math.max(0,offset+_length-data.length);// logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
if(missing){unit=new Uint8Array(_length-headerLength);unit.set(data.subarray(offset+headerLength,data.length),0);}else {unit=data.subarray(offset+headerLength,offset+_length);}var _sample={unit:unit,pts:stamp};if(!missing){track.samples.push(_sample);}return {sample:_sample,length:_length,missing:missing};}// overflow incomplete header
var length=data.length-offset;unit=new Uint8Array(length);unit.set(data.subarray(offset,data.length),0);var sample={unit:unit,pts:stamp};return {sample:sample,length:length,missing:-1};}/**
 *  MPEG parser helper
 */var chromeVersion$1=null;var BitratesMap=[32,64,96,128,160,192,224,256,288,320,352,384,416,448,32,48,56,64,80,96,112,128,160,192,224,256,320,384,32,40,48,56,64,80,96,112,128,160,192,224,256,320,32,48,56,64,80,96,112,128,144,160,176,192,224,256,8,16,24,32,40,48,56,64,80,96,112,128,144,160];var SamplingRateMap=[44100,48000,32000,22050,24000,16000,11025,12000,8000];var SamplesCoefficients=[// MPEG 2.5
[0,// Reserved
72,// Layer3
144,// Layer2
12// Layer1
],// Reserved
[0,// Reserved
0,// Layer3
0,// Layer2
0// Layer1
],// MPEG 2
[0,// Reserved
72,// Layer3
144,// Layer2
12// Layer1
],// MPEG 1
[0,// Reserved
144,// Layer3
144,// Layer2
12// Layer1
]];var BytesInSlot=[0,// Reserved
1,// Layer3
1,// Layer2
4// Layer1
];function appendFrame$1(track,data,offset,pts,frameIndex){// Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
if(offset+24>data.length){return;}var header=parseHeader(data,offset);if(header&&offset+header.frameLength<=data.length){var frameDuration=header.samplesPerFrame*90000/header.sampleRate;var stamp=pts+frameIndex*frameDuration;var sample={unit:data.subarray(offset,offset+header.frameLength),pts:stamp,dts:stamp};track.config=[];track.channelCount=header.channelCount;track.samplerate=header.sampleRate;track.samples.push(sample);return {sample:sample,length:header.frameLength,missing:0};}}function parseHeader(data,offset){var mpegVersion=data[offset+1]>>3&3;var mpegLayer=data[offset+1]>>1&3;var bitRateIndex=data[offset+2]>>4&15;var sampleRateIndex=data[offset+2]>>2&3;if(mpegVersion!==1&&bitRateIndex!==0&&bitRateIndex!==15&&sampleRateIndex!==3){var paddingBit=data[offset+2]>>1&1;var channelMode=data[offset+3]>>6;var columnInBitrates=mpegVersion===3?3-mpegLayer:mpegLayer===3?3:4;var bitRate=BitratesMap[columnInBitrates*14+bitRateIndex-1]*1000;var columnInSampleRates=mpegVersion===3?0:mpegVersion===2?1:2;var sampleRate=SamplingRateMap[columnInSampleRates*3+sampleRateIndex];var channelCount=channelMode===3?1:2;// If bits of channel mode are `11` then it is a single channel (Mono)
var sampleCoefficient=SamplesCoefficients[mpegVersion][mpegLayer];var bytesInSlot=BytesInSlot[mpegLayer];var samplesPerFrame=sampleCoefficient*8*bytesInSlot;var frameLength=Math.floor(sampleCoefficient*bitRate/sampleRate+paddingBit)*bytesInSlot;if(chromeVersion$1===null){var userAgent=navigator.userAgent||'';var result=userAgent.match(/Chrome\/(\d+)/i);chromeVersion$1=result?parseInt(result[1]):0;}var needChromeFix=!!chromeVersion$1&&chromeVersion$1<=87;if(needChromeFix&&mpegLayer===2&&bitRate>=224000&&channelMode===0){// Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
data[offset+3]=data[offset+3]|0x80;}return {sampleRate:sampleRate,channelCount:channelCount,frameLength:frameLength,samplesPerFrame:samplesPerFrame};}}function isHeaderPattern(data,offset){return data[offset]===0xff&&(data[offset+1]&0xe0)===0xe0&&(data[offset+1]&0x06)!==0x00;}function isHeader(data,offset){// Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
// Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
// More info http://www.mp3-tech.org/programmer/frame_header.html
return offset+1<data.length&&isHeaderPattern(data,offset);}function _canParse(data,offset){var headerSize=4;return isHeaderPattern(data,offset)&&headerSize<=data.length-offset;}function _probe(data,offset){// same as isHeader but we also check that MPEG frame follows last MPEG frame
// or end of data is reached
if(offset+1<data.length&&isHeaderPattern(data,offset)){// MPEG header Length
var headerLength=4;// MPEG frame Length
var header=parseHeader(data,offset);var frameLength=headerLength;if(header!=null&&header.frameLength){frameLength=header.frameLength;}var newOffset=offset+frameLength;return newOffset===data.length||isHeader(data,newOffset);}return false;}/**
 * AAC demuxer
 */var AACDemuxer=/*#__PURE__*/function(_BaseAudioDemuxer){_inherits(AACDemuxer,_BaseAudioDemuxer);var _super5=_createSuper(AACDemuxer);function AACDemuxer(observer,config){var _this26;_classCallCheck(this,AACDemuxer);_this26=_super5.call(this);_this26.observer=void 0;_this26.config=void 0;_this26.observer=observer;_this26.config=config;return _this26;}_createClass(AACDemuxer,[{key:"resetInitSegment",value:function resetInitSegment(initSegment,audioCodec,videoCodec,trackDuration){_get(_getPrototypeOf(AACDemuxer.prototype),"resetInitSegment",this).call(this,initSegment,audioCodec,videoCodec,trackDuration);this._audioTrack={container:'audio/adts',type:'audio',id:2,pid:-1,sequenceNumber:0,segmentCodec:'aac',samples:[],manifestCodec:audioCodec,duration:trackDuration,inputTimeScale:90000,dropped:0};}// Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
},{key:"canParse",value:function canParse(data,offset){return canParse$1(data,offset);}},{key:"appendFrame",value:function appendFrame(track,data,offset){initTrackConfig(track,this.observer,data,offset,track.manifestCodec);var frame=appendFrame$2(track,data,offset,this.basePTS,this.frameIndex);if(frame&&frame.missing===0){return frame;}}}],[{key:"probe",value:function probe(data){if(!data){return false;}// Check for the ADTS sync word
// Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
// Layer bits (position 14 and 15) in header should be always 0 for ADTS
// More info https://wiki.multimedia.cx/index.php?title=ADTS
var id3Data=getID3Data(data,0);var offset=(id3Data==null?void 0:id3Data.length)||0;if(_probe(data,offset)){return false;}for(var length=data.length;offset<length;offset++){if(probe$1(data,offset)){logger.log('ADTS sync word found !');return true;}}return false;}}]);return AACDemuxer;}(BaseAudioDemuxer);var emsgSchemePattern=/\/emsg[-/]ID3/i;var MP4Demuxer=/*#__PURE__*/function(){function MP4Demuxer(observer,config){_classCallCheck(this,MP4Demuxer);this.remainderData=null;this.timeOffset=0;this.config=void 0;this.videoTrack=void 0;this.audioTrack=void 0;this.id3Track=void 0;this.txtTrack=void 0;this.config=config;}_createClass(MP4Demuxer,[{key:"resetTimeStamp",value:function resetTimeStamp(){}},{key:"resetInitSegment",value:function resetInitSegment(initSegment,audioCodec,videoCodec,trackDuration){var videoTrack=this.videoTrack=dummyTrack('video',1);var audioTrack=this.audioTrack=dummyTrack('audio',1);var captionTrack=this.txtTrack=dummyTrack('text',1);this.id3Track=dummyTrack('id3',1);this.timeOffset=0;if(!(initSegment!=null&&initSegment.byteLength)){return;}var initData=parseInitSegment(initSegment);if(initData.video){var _initData$video=initData.video,id=_initData$video.id,timescale=_initData$video.timescale,codec=_initData$video.codec;videoTrack.id=id;videoTrack.timescale=captionTrack.timescale=timescale;videoTrack.codec=codec;}if(initData.audio){var _initData$audio=initData.audio,_id2=_initData$audio.id,_timescale=_initData$audio.timescale,_codec=_initData$audio.codec;audioTrack.id=_id2;audioTrack.timescale=_timescale;audioTrack.codec=_codec;}captionTrack.id=RemuxerTrackIdConfig.text;videoTrack.sampleDuration=0;videoTrack.duration=audioTrack.duration=trackDuration;}},{key:"resetContiguity",value:function resetContiguity(){this.remainderData=null;}},{key:"demux",value:function demux(data,timeOffset){this.timeOffset=timeOffset;// Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
var videoSamples=data;var videoTrack=this.videoTrack;var textTrack=this.txtTrack;if(this.config.progressive){// Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
// This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
// that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
if(this.remainderData){videoSamples=appendUint8Array(this.remainderData,data);}var segmentedData=segmentValidRange(videoSamples);this.remainderData=segmentedData.remainder;videoTrack.samples=segmentedData.valid||new Uint8Array();}else {videoTrack.samples=videoSamples;}var id3Track=this.extractID3Track(videoTrack,timeOffset);textTrack.samples=parseSamples(timeOffset,videoTrack);return {videoTrack:videoTrack,audioTrack:this.audioTrack,id3Track:id3Track,textTrack:this.txtTrack};}},{key:"flush",value:function flush(){var timeOffset=this.timeOffset;var videoTrack=this.videoTrack;var textTrack=this.txtTrack;videoTrack.samples=this.remainderData||new Uint8Array();this.remainderData=null;var id3Track=this.extractID3Track(videoTrack,this.timeOffset);textTrack.samples=parseSamples(timeOffset,videoTrack);return {videoTrack:videoTrack,audioTrack:dummyTrack(),id3Track:id3Track,textTrack:dummyTrack()};}},{key:"extractID3Track",value:function extractID3Track(videoTrack,timeOffset){var id3Track=this.id3Track;if(videoTrack.samples.length){var emsgs=findBox(videoTrack.samples,['emsg']);if(emsgs){emsgs.forEach(function(data){var emsgInfo=parseEmsg(data);if(emsgSchemePattern.test(emsgInfo.schemeIdUri)){var pts=isFiniteNumber(emsgInfo.presentationTime)?emsgInfo.presentationTime/emsgInfo.timeScale:timeOffset+emsgInfo.presentationTimeDelta/emsgInfo.timeScale;var duration=emsgInfo.eventDuration===0xffffffff?Number.POSITIVE_INFINITY:emsgInfo.eventDuration/emsgInfo.timeScale;// Safari takes anything <= 0.001 seconds and maps it to Infinity
if(duration<=0.001){duration=Number.POSITIVE_INFINITY;}var payload=emsgInfo.payload;id3Track.samples.push({data:payload,len:payload.byteLength,dts:pts,pts:pts,type:MetadataSchema.emsg,duration:duration});}});}}return id3Track;}},{key:"demuxSampleAes",value:function demuxSampleAes(data,keyData,timeOffset){return Promise.reject(new Error('The MP4 demuxer does not support SAMPLE-AES decryption'));}},{key:"destroy",value:function destroy(){}}],[{key:"probe",value:function probe(data){return hasMoofData(data);}}]);return MP4Demuxer;}();var getAudioBSID=function getAudioBSID(data,offset){// check the bsid to confirm ac-3 | ec-3
var bsid=0;var numBits=5;offset+=numBits;var temp=new Uint32Array(1);// unsigned 32 bit for temporary storage
var mask=new Uint32Array(1);// unsigned 32 bit mask value
var _byte2=new Uint8Array(1);// unsigned 8 bit for temporary storage
while(numBits>0){_byte2[0]=data[offset];// read remaining bits, upto 8 bits at a time
var bits=Math.min(numBits,8);var shift=8-bits;mask[0]=0xff000000>>>24+shift<<shift;temp[0]=(_byte2[0]&mask[0])>>shift;bsid=!bsid?temp[0]:bsid<<bits|temp[0];offset+=1;numBits-=bits;}return bsid;};var AC3Demuxer=/*#__PURE__*/function(_BaseAudioDemuxer2){_inherits(AC3Demuxer,_BaseAudioDemuxer2);var _super6=_createSuper(AC3Demuxer);function AC3Demuxer(observer){var _this27;_classCallCheck(this,AC3Demuxer);_this27=_super6.call(this);_this27.observer=void 0;_this27.observer=observer;return _this27;}_createClass(AC3Demuxer,[{key:"resetInitSegment",value:function resetInitSegment(initSegment,audioCodec,videoCodec,trackDuration){_get(_getPrototypeOf(AC3Demuxer.prototype),"resetInitSegment",this).call(this,initSegment,audioCodec,videoCodec,trackDuration);this._audioTrack={container:'audio/ac-3',type:'audio',id:2,pid:-1,sequenceNumber:0,segmentCodec:'ac3',samples:[],manifestCodec:audioCodec,duration:trackDuration,inputTimeScale:90000,dropped:0};}},{key:"canParse",value:function canParse(data,offset){return offset+64<data.length;}},{key:"appendFrame",value:function appendFrame(track,data,offset){var frameLength=_appendFrame(track,data,offset,this.basePTS,this.frameIndex);if(frameLength!==-1){var sample=track.samples[track.samples.length-1];return {sample:sample,length:frameLength,missing:0};}}}],[{key:"probe",value:function probe(data){if(!data){return false;}var id3Data=getID3Data(data,0);if(!id3Data){return false;}// look for the ac-3 sync bytes
var offset=id3Data.length;if(data[offset]===0x0b&&data[offset+1]===0x77&&getTimeStamp(id3Data)!==undefined&&// check the bsid to confirm ac-3
getAudioBSID(data,offset)<16){return true;}return false;}}]);return AC3Demuxer;}(BaseAudioDemuxer);function _appendFrame(track,data,start,pts,frameIndex){if(start+8>data.length){return -1;// not enough bytes left
}if(data[start]!==0x0b||data[start+1]!==0x77){return -1;// invalid magic
}// get sample rate
var samplingRateCode=data[start+4]>>6;if(samplingRateCode>=3){return -1;// invalid sampling rate
}var samplingRateMap=[48000,44100,32000];var sampleRate=samplingRateMap[samplingRateCode];// get frame size
var frameSizeCode=data[start+4]&0x3f;var frameSizeMap=[64,69,96,64,70,96,80,87,120,80,88,120,96,104,144,96,105,144,112,121,168,112,122,168,128,139,192,128,140,192,160,174,240,160,175,240,192,208,288,192,209,288,224,243,336,224,244,336,256,278,384,256,279,384,320,348,480,320,349,480,384,417,576,384,418,576,448,487,672,448,488,672,512,557,768,512,558,768,640,696,960,640,697,960,768,835,1152,768,836,1152,896,975,1344,896,976,1344,1024,1114,1536,1024,1115,1536,1152,1253,1728,1152,1254,1728,1280,1393,1920,1280,1394,1920];var frameLength=frameSizeMap[frameSizeCode*3+samplingRateCode]*2;if(start+frameLength>data.length){return -1;}// get channel count
var channelMode=data[start+6]>>5;var skipCount=0;if(channelMode===2){skipCount+=2;}else {if(channelMode&1&&channelMode!==1){skipCount+=2;}if(channelMode&4){skipCount+=2;}}var lfeon=(data[start+6]<<8|data[start+7])>>12-skipCount&1;var channelsMap=[2,1,2,3,3,4,4,5];var channelCount=channelsMap[channelMode]+lfeon;// build dac3 box
var bsid=data[start+5]>>3;var bsmod=data[start+5]&7;var config=new Uint8Array([samplingRateCode<<6|bsid<<1|bsmod>>2,(bsmod&3)<<6|channelMode<<3|lfeon<<2|frameSizeCode>>4,frameSizeCode<<4&0xe0]);var frameDuration=1536/sampleRate*90000;var stamp=pts+frameIndex*frameDuration;var unit=data.subarray(start,start+frameLength);track.config=config;track.channelCount=channelCount;track.samplerate=sampleRate;track.samples.push({unit:unit,pts:stamp});return frameLength;}var BaseVideoParser=/*#__PURE__*/function(){function BaseVideoParser(){_classCallCheck(this,BaseVideoParser);this.VideoSample=null;}_createClass(BaseVideoParser,[{key:"createVideoSample",value:function createVideoSample(key,pts,dts,debug){return {key:key,frame:false,pts:pts,dts:dts,units:[],debug:debug,length:0};}},{key:"getLastNalUnit",value:function getLastNalUnit(samples){var _VideoSample;var VideoSample=this.VideoSample;var lastUnit;// try to fallback to previous sample if current one is empty
if(!VideoSample||VideoSample.units.length===0){VideoSample=samples[samples.length-1];}if((_VideoSample=VideoSample)!=null&&_VideoSample.units){var units=VideoSample.units;lastUnit=units[units.length-1];}return lastUnit;}},{key:"pushAccessUnit",value:function pushAccessUnit(VideoSample,videoTrack){if(VideoSample.units.length&&VideoSample.frame){// if sample does not have PTS/DTS, patch with last sample PTS/DTS
if(VideoSample.pts===undefined){var samples=videoTrack.samples;var nbSamples=samples.length;if(nbSamples){var lastSample=samples[nbSamples-1];VideoSample.pts=lastSample.pts;VideoSample.dts=lastSample.dts;}else {// dropping samples, no timestamp found
videoTrack.dropped++;return;}}videoTrack.samples.push(VideoSample);}if(VideoSample.debug.length){logger.log(VideoSample.pts+'/'+VideoSample.dts+':'+VideoSample.debug);}}}]);return BaseVideoParser;}();/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
 */var ExpGolomb=/*#__PURE__*/function(){function ExpGolomb(data){_classCallCheck(this,ExpGolomb);this.data=void 0;this.bytesAvailable=void 0;this.word=void 0;this.bitsAvailable=void 0;this.data=data;// the number of bytes left to examine in this.data
this.bytesAvailable=data.byteLength;// the current word being examined
this.word=0;// :uint
// the number of bits left to examine in the current word
this.bitsAvailable=0;// :uint
}// ():void
_createClass(ExpGolomb,[{key:"loadWord",value:function loadWord(){var data=this.data;var bytesAvailable=this.bytesAvailable;var position=data.byteLength-bytesAvailable;var workingBytes=new Uint8Array(4);var availableBytes=Math.min(4,bytesAvailable);if(availableBytes===0){throw new Error('no bytes available');}workingBytes.set(data.subarray(position,position+availableBytes));this.word=new DataView(workingBytes.buffer).getUint32(0);// track the amount of this.data that has been processed
this.bitsAvailable=availableBytes*8;this.bytesAvailable-=availableBytes;}// (count:int):void
},{key:"skipBits",value:function skipBits(count){var skipBytes;// :int
count=Math.min(count,this.bytesAvailable*8+this.bitsAvailable);if(this.bitsAvailable>count){this.word<<=count;this.bitsAvailable-=count;}else {count-=this.bitsAvailable;skipBytes=count>>3;count-=skipBytes<<3;this.bytesAvailable-=skipBytes;this.loadWord();this.word<<=count;this.bitsAvailable-=count;}}// (size:int):uint
},{key:"readBits",value:function readBits(size){var bits=Math.min(this.bitsAvailable,size);// :uint
var valu=this.word>>>32-bits;// :uint
if(size>32){logger.error('Cannot read more than 32 bits at a time');}this.bitsAvailable-=bits;if(this.bitsAvailable>0){this.word<<=bits;}else if(this.bytesAvailable>0){this.loadWord();}else {throw new Error('no bits available');}bits=size-bits;if(bits>0&&this.bitsAvailable){return valu<<bits|this.readBits(bits);}else {return valu;}}// ():uint
},{key:"skipLZ",value:function skipLZ(){var leadingZeroCount;// :uint
for(leadingZeroCount=0;leadingZeroCount<this.bitsAvailable;++leadingZeroCount){if((this.word&0x80000000>>>leadingZeroCount)!==0){// the first bit of working word is 1
this.word<<=leadingZeroCount;this.bitsAvailable-=leadingZeroCount;return leadingZeroCount;}}// we exhausted word and still have not found a 1
this.loadWord();return leadingZeroCount+this.skipLZ();}// ():void
},{key:"skipUEG",value:function skipUEG(){this.skipBits(1+this.skipLZ());}// ():void
},{key:"skipEG",value:function skipEG(){this.skipBits(1+this.skipLZ());}// ():uint
},{key:"readUEG",value:function readUEG(){var clz=this.skipLZ();// :uint
return this.readBits(clz+1)-1;}// ():int
},{key:"readEG",value:function readEG(){var valu=this.readUEG();// :int
if(0x01&valu){// the number is odd if the low order bit is set
return 1+valu>>>1;// add 1 to make it even, and divide by 2
}else {return -1*(valu>>>1);// divide by two then make it negative
}}// Some convenience functions
// :Boolean
},{key:"readBoolean",value:function readBoolean(){return this.readBits(1)===1;}// ():int
},{key:"readUByte",value:function readUByte(){return this.readBits(8);}// ():int
},{key:"readUShort",value:function readUShort(){return this.readBits(16);}// ():int
},{key:"readUInt",value:function readUInt(){return this.readBits(32);}/**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */},{key:"skipScalingList",value:function skipScalingList(count){var lastScale=8;var nextScale=8;var deltaScale;for(var j=0;j<count;j++){if(nextScale!==0){deltaScale=this.readEG();nextScale=(lastScale+deltaScale+256)%256;}lastScale=nextScale===0?lastScale:nextScale;}}/**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */},{key:"readSPS",value:function readSPS(){var frameCropLeftOffset=0;var frameCropRightOffset=0;var frameCropTopOffset=0;var frameCropBottomOffset=0;var numRefFramesInPicOrderCntCycle;var scalingListCount;var i;var readUByte=this.readUByte.bind(this);var readBits=this.readBits.bind(this);var readUEG=this.readUEG.bind(this);var readBoolean=this.readBoolean.bind(this);var skipBits=this.skipBits.bind(this);var skipEG=this.skipEG.bind(this);var skipUEG=this.skipUEG.bind(this);var skipScalingList=this.skipScalingList.bind(this);readUByte();var profileIdc=readUByte();// profile_idc
readBits(5);// profileCompat constraint_set[0-4]_flag, u(5)
skipBits(3);// reserved_zero_3bits u(3),
readUByte();// level_idc u(8)
skipUEG();// seq_parameter_set_id
// some profiles have more optional data we don't need
if(profileIdc===100||profileIdc===110||profileIdc===122||profileIdc===244||profileIdc===44||profileIdc===83||profileIdc===86||profileIdc===118||profileIdc===128){var chromaFormatIdc=readUEG();if(chromaFormatIdc===3){skipBits(1);}// separate_colour_plane_flag
skipUEG();// bit_depth_luma_minus8
skipUEG();// bit_depth_chroma_minus8
skipBits(1);// qpprime_y_zero_transform_bypass_flag
if(readBoolean()){// seq_scaling_matrix_present_flag
scalingListCount=chromaFormatIdc!==3?8:12;for(i=0;i<scalingListCount;i++){if(readBoolean()){// seq_scaling_list_present_flag[ i ]
if(i<6){skipScalingList(16);}else {skipScalingList(64);}}}}}skipUEG();// log2_max_frame_num_minus4
var picOrderCntType=readUEG();if(picOrderCntType===0){readUEG();// log2_max_pic_order_cnt_lsb_minus4
}else if(picOrderCntType===1){skipBits(1);// delta_pic_order_always_zero_flag
skipEG();// offset_for_non_ref_pic
skipEG();// offset_for_top_to_bottom_field
numRefFramesInPicOrderCntCycle=readUEG();for(i=0;i<numRefFramesInPicOrderCntCycle;i++){skipEG();}// offset_for_ref_frame[ i ]
}skipUEG();// max_num_ref_frames
skipBits(1);// gaps_in_frame_num_value_allowed_flag
var picWidthInMbsMinus1=readUEG();var picHeightInMapUnitsMinus1=readUEG();var frameMbsOnlyFlag=readBits(1);if(frameMbsOnlyFlag===0){skipBits(1);}// mb_adaptive_frame_field_flag
skipBits(1);// direct_8x8_inference_flag
if(readBoolean()){// frame_cropping_flag
frameCropLeftOffset=readUEG();frameCropRightOffset=readUEG();frameCropTopOffset=readUEG();frameCropBottomOffset=readUEG();}var pixelRatio=[1,1];if(readBoolean()){// vui_parameters_present_flag
if(readBoolean()){// aspect_ratio_info_present_flag
var aspectRatioIdc=readUByte();switch(aspectRatioIdc){case 1:pixelRatio=[1,1];break;case 2:pixelRatio=[12,11];break;case 3:pixelRatio=[10,11];break;case 4:pixelRatio=[16,11];break;case 5:pixelRatio=[40,33];break;case 6:pixelRatio=[24,11];break;case 7:pixelRatio=[20,11];break;case 8:pixelRatio=[32,11];break;case 9:pixelRatio=[80,33];break;case 10:pixelRatio=[18,11];break;case 11:pixelRatio=[15,11];break;case 12:pixelRatio=[64,33];break;case 13:pixelRatio=[160,99];break;case 14:pixelRatio=[4,3];break;case 15:pixelRatio=[3,2];break;case 16:pixelRatio=[2,1];break;case 255:{pixelRatio=[readUByte()<<8|readUByte(),readUByte()<<8|readUByte()];break;}}}}return {width:Math.ceil((picWidthInMbsMinus1+1)*16-frameCropLeftOffset*2-frameCropRightOffset*2),height:(2-frameMbsOnlyFlag)*(picHeightInMapUnitsMinus1+1)*16-(frameMbsOnlyFlag?2:4)*(frameCropTopOffset+frameCropBottomOffset),pixelRatio:pixelRatio};}},{key:"readSliceType",value:function readSliceType(){// skip NALu type
this.readUByte();// discard first_mb_in_slice
this.readUEG();// return slice_type
return this.readUEG();}}]);return ExpGolomb;}();var AvcVideoParser=/*#__PURE__*/function(_BaseVideoParser){_inherits(AvcVideoParser,_BaseVideoParser);var _super7=_createSuper(AvcVideoParser);function AvcVideoParser(){_classCallCheck(this,AvcVideoParser);return _super7.apply(this,arguments);}_createClass(AvcVideoParser,[{key:"parseAVCPES",value:function parseAVCPES(track,textTrack,pes,last,duration){var _this28=this;var units=this.parseAVCNALu(track,pes.data);var VideoSample=this.VideoSample;var push;var spsfound=false;// free pes.data to save up some memory
pes.data=null;// if new NAL units found and last sample still there, let's push ...
// this helps parsing streams with missing AUD (only do this if AUD never found)
if(VideoSample&&units.length&&!track.audFound){this.pushAccessUnit(VideoSample,track);VideoSample=this.VideoSample=this.createVideoSample(false,pes.pts,pes.dts,'');}units.forEach(function(unit){var _VideoSample2;switch(unit.type){// NDR
case 1:{var iskey=false;push=true;var data=unit.data;// only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
if(spsfound&&data.length>4){// retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
var sliceType=new ExpGolomb(data).readSliceType();// 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
// SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
// An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
// I slice: A slice that is not an SI slice that is decoded using intra prediction only.
// if (sliceType === 2 || sliceType === 7) {
if(sliceType===2||sliceType===4||sliceType===7||sliceType===9){iskey=true;}}if(iskey){var _VideoSample;// if we have non-keyframe data already, that cannot belong to the same frame as a keyframe, so force a push
if((_VideoSample=VideoSample)!=null&&_VideoSample.frame&&!VideoSample.key){_this28.pushAccessUnit(VideoSample,track);VideoSample=_this28.VideoSample=null;}}if(!VideoSample){VideoSample=_this28.VideoSample=_this28.createVideoSample(true,pes.pts,pes.dts,'');}VideoSample.frame=true;VideoSample.key=iskey;break;// IDR
}case 5:push=true;// handle PES not starting with AUD
// if we have frame data already, that cannot belong to the same frame, so force a push
if((_VideoSample2=VideoSample)!=null&&_VideoSample2.frame&&!VideoSample.key){_this28.pushAccessUnit(VideoSample,track);VideoSample=_this28.VideoSample=null;}if(!VideoSample){VideoSample=_this28.VideoSample=_this28.createVideoSample(true,pes.pts,pes.dts,'');}VideoSample.key=true;VideoSample.frame=true;break;// SEI
case 6:{push=true;parseSEIMessageFromNALu(unit.data,1,pes.pts,textTrack.samples);break;// SPS
}case 7:{var _track$pixelRatio,_track$pixelRatio2;push=true;spsfound=true;var sps=unit.data;var expGolombDecoder=new ExpGolomb(sps);var config=expGolombDecoder.readSPS();if(!track.sps||track.width!==config.width||track.height!==config.height||((_track$pixelRatio=track.pixelRatio)==null?void 0:_track$pixelRatio[0])!==config.pixelRatio[0]||((_track$pixelRatio2=track.pixelRatio)==null?void 0:_track$pixelRatio2[1])!==config.pixelRatio[1]){track.width=config.width;track.height=config.height;track.pixelRatio=config.pixelRatio;track.sps=[sps];track.duration=duration;var codecarray=sps.subarray(1,4);var codecstring='avc1.';for(var i=0;i<3;i++){var h=codecarray[i].toString(16);if(h.length<2){h='0'+h;}codecstring+=h;}track.codec=codecstring;}break;}// PPS
case 8:push=true;track.pps=[unit.data];break;// AUD
case 9:push=true;track.audFound=true;if(VideoSample){_this28.pushAccessUnit(VideoSample,track);}VideoSample=_this28.VideoSample=_this28.createVideoSample(false,pes.pts,pes.dts,'');break;// Filler Data
case 12:push=true;break;default:push=false;if(VideoSample){VideoSample.debug+='unknown NAL '+unit.type+' ';}break;}if(VideoSample&&push){var _units=VideoSample.units;_units.push(unit);}});// if last PES packet, push samples
if(last&&VideoSample){this.pushAccessUnit(VideoSample,track);this.VideoSample=null;}}},{key:"parseAVCNALu",value:function parseAVCNALu(track,array){var len=array.byteLength;var state=track.naluState||0;var lastState=state;var units=[];var i=0;var value;var overflow;var unitType;var lastUnitStart=-1;var lastUnitType=0;// logger.log('PES:' + Hex.hexDump(array));
if(state===-1){// special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
lastUnitStart=0;// NALu type is value read from offset 0
lastUnitType=array[0]&0x1f;state=0;i=1;}while(i<len){value=array[i++];// optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
if(!state){state=value?0:1;continue;}if(state===1){state=value?0:2;continue;}// here we have state either equal to 2 or 3
if(!value){state=3;}else if(value===1){overflow=i-state-1;if(lastUnitStart>=0){var unit={data:array.subarray(lastUnitStart,overflow),type:lastUnitType};// logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
units.push(unit);}else {// lastUnitStart is undefined => this is the first start code found in this PES packet
// first check if start code delimiter is overlapping between 2 PES packets,
// ie it started in last packet (lastState not zero)
// and ended at the beginning of this PES packet (i <= 4 - lastState)
var lastUnit=this.getLastNalUnit(track.samples);if(lastUnit){if(lastState&&i<=4-lastState){// start delimiter overlapping between PES packets
// strip start delimiter bytes from the end of last NAL unit
// check if lastUnit had a state different from zero
if(lastUnit.state){// strip last bytes
lastUnit.data=lastUnit.data.subarray(0,lastUnit.data.byteLength-lastState);}}// If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
if(overflow>0){// logger.log('first NALU found with overflow:' + overflow);
lastUnit.data=appendUint8Array(lastUnit.data,array.subarray(0,overflow));lastUnit.state=0;}}}// check if we can read unit type
if(i<len){unitType=array[i]&0x1f;// logger.log('find NALU @ offset:' + i + ',type:' + unitType);
lastUnitStart=i;lastUnitType=unitType;state=0;}else {// not enough byte to read unit type. let's read it on next PES parsing
state=-1;}}else {state=0;}}if(lastUnitStart>=0&&state>=0){var _unit={data:array.subarray(lastUnitStart,len),type:lastUnitType,state:state};units.push(_unit);// logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
}// no NALu found
if(units.length===0){// append pes.data to previous NAL unit
var _lastUnit=this.getLastNalUnit(track.samples);if(_lastUnit){_lastUnit.data=appendUint8Array(_lastUnit.data,array);}}track.naluState=state;return units;}}]);return AvcVideoParser;}(BaseVideoParser);/**
 * SAMPLE-AES decrypter
 */var SampleAesDecrypter=/*#__PURE__*/function(){function SampleAesDecrypter(observer,config,keyData){_classCallCheck(this,SampleAesDecrypter);this.keyData=void 0;this.decrypter=void 0;this.keyData=keyData;this.decrypter=new Decrypter(config,{removePKCS7Padding:false});}_createClass(SampleAesDecrypter,[{key:"decryptBuffer",value:function decryptBuffer(encryptedData){return this.decrypter.decrypt(encryptedData,this.keyData.key.buffer,this.keyData.iv.buffer);}// AAC - encrypt all full 16 bytes blocks starting from offset 16
},{key:"decryptAacSample",value:function decryptAacSample(samples,sampleIndex,callback){var _this29=this;var curUnit=samples[sampleIndex].unit;if(curUnit.length<=16){// No encrypted portion in this sample (first 16 bytes is not
// encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
return;}var encryptedData=curUnit.subarray(16,curUnit.length-curUnit.length%16);var encryptedBuffer=encryptedData.buffer.slice(encryptedData.byteOffset,encryptedData.byteOffset+encryptedData.length);this.decryptBuffer(encryptedBuffer).then(function(decryptedBuffer){var decryptedData=new Uint8Array(decryptedBuffer);curUnit.set(decryptedData,16);if(!_this29.decrypter.isSync()){_this29.decryptAacSamples(samples,sampleIndex+1,callback);}});}},{key:"decryptAacSamples",value:function decryptAacSamples(samples,sampleIndex,callback){for(;;sampleIndex++){if(sampleIndex>=samples.length){callback();return;}if(samples[sampleIndex].unit.length<32){continue;}this.decryptAacSample(samples,sampleIndex,callback);if(!this.decrypter.isSync()){return;}}}// AVC - encrypt one 16 bytes block out of ten, starting from offset 32
},{key:"getAvcEncryptedData",value:function getAvcEncryptedData(decodedData){var encryptedDataLen=Math.floor((decodedData.length-48)/160)*16+16;var encryptedData=new Int8Array(encryptedDataLen);var outputPos=0;for(var inputPos=32;inputPos<decodedData.length-16;inputPos+=160,outputPos+=16){encryptedData.set(decodedData.subarray(inputPos,inputPos+16),outputPos);}return encryptedData;}},{key:"getAvcDecryptedUnit",value:function getAvcDecryptedUnit(decodedData,decryptedData){var uint8DecryptedData=new Uint8Array(decryptedData);var inputPos=0;for(var outputPos=32;outputPos<decodedData.length-16;outputPos+=160,inputPos+=16){decodedData.set(uint8DecryptedData.subarray(inputPos,inputPos+16),outputPos);}return decodedData;}},{key:"decryptAvcSample",value:function decryptAvcSample(samples,sampleIndex,unitIndex,callback,curUnit){var _this30=this;var decodedData=discardEPB(curUnit.data);var encryptedData=this.getAvcEncryptedData(decodedData);this.decryptBuffer(encryptedData.buffer).then(function(decryptedBuffer){curUnit.data=_this30.getAvcDecryptedUnit(decodedData,decryptedBuffer);if(!_this30.decrypter.isSync()){_this30.decryptAvcSamples(samples,sampleIndex,unitIndex+1,callback);}});}},{key:"decryptAvcSamples",value:function decryptAvcSamples(samples,sampleIndex,unitIndex,callback){if(samples instanceof Uint8Array){throw new Error('Cannot decrypt samples of type Uint8Array');}for(;;sampleIndex++,unitIndex=0){if(sampleIndex>=samples.length){callback();return;}var curUnits=samples[sampleIndex].units;for(;;unitIndex++){if(unitIndex>=curUnits.length){break;}var curUnit=curUnits[unitIndex];if(curUnit.data.length<=48||curUnit.type!==1&&curUnit.type!==5){continue;}this.decryptAvcSample(samples,sampleIndex,unitIndex,callback,curUnit);if(!this.decrypter.isSync()){return;}}}}}]);return SampleAesDecrypter;}();var PACKET_LENGTH=188;var TSDemuxer=/*#__PURE__*/function(){function TSDemuxer(observer,config,typeSupported){_classCallCheck(this,TSDemuxer);this.observer=void 0;this.config=void 0;this.typeSupported=void 0;this.sampleAes=null;this.pmtParsed=false;this.audioCodec=void 0;this.videoCodec=void 0;this._duration=0;this._pmtId=-1;this._videoTrack=void 0;this._audioTrack=void 0;this._id3Track=void 0;this._txtTrack=void 0;this.aacOverFlow=null;this.remainderData=null;this.videoParser=void 0;this.observer=observer;this.config=config;this.typeSupported=typeSupported;this.videoParser=new AvcVideoParser();}_createClass(TSDemuxer,[{key:"resetInitSegment",value:/**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */function resetInitSegment(initSegment,audioCodec,videoCodec,trackDuration){this.pmtParsed=false;this._pmtId=-1;this._videoTrack=TSDemuxer.createTrack('video');this._audioTrack=TSDemuxer.createTrack('audio',trackDuration);this._id3Track=TSDemuxer.createTrack('id3');this._txtTrack=TSDemuxer.createTrack('text');this._audioTrack.segmentCodec='aac';// flush any partial content
this.aacOverFlow=null;this.remainderData=null;this.audioCodec=audioCodec;this.videoCodec=videoCodec;this._duration=trackDuration;}},{key:"resetTimeStamp",value:function resetTimeStamp(){}},{key:"resetContiguity",value:function resetContiguity(){var _audioTrack=this._audioTrack,_videoTrack=this._videoTrack,_id3Track=this._id3Track;if(_audioTrack){_audioTrack.pesData=null;}if(_videoTrack){_videoTrack.pesData=null;}if(_id3Track){_id3Track.pesData=null;}this.aacOverFlow=null;this.remainderData=null;}},{key:"demux",value:function demux(data,timeOffset){var isSampleAes=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var flush=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;if(!isSampleAes){this.sampleAes=null;}var pes;var videoTrack=this._videoTrack;var audioTrack=this._audioTrack;var id3Track=this._id3Track;var textTrack=this._txtTrack;var videoPid=videoTrack.pid;var videoData=videoTrack.pesData;var audioPid=audioTrack.pid;var id3Pid=id3Track.pid;var audioData=audioTrack.pesData;var id3Data=id3Track.pesData;var unknownPID=null;var pmtParsed=this.pmtParsed;var pmtId=this._pmtId;var len=data.length;if(this.remainderData){data=appendUint8Array(this.remainderData,data);len=data.length;this.remainderData=null;}if(len<PACKET_LENGTH&&!flush){this.remainderData=data;return {audioTrack:audioTrack,videoTrack:videoTrack,id3Track:id3Track,textTrack:textTrack};}var syncOffset=Math.max(0,TSDemuxer.syncOffset(data));len-=(len-syncOffset)%PACKET_LENGTH;if(len<data.byteLength&&!flush){this.remainderData=new Uint8Array(data.buffer,len,data.buffer.byteLength-len);}// loop through TS packets
var tsPacketErrors=0;for(var start=syncOffset;start<len;start+=PACKET_LENGTH){if(data[start]===0x47){var stt=!!(data[start+1]&0x40);var pid=parsePID(data,start);var atf=(data[start+3]&0x30)>>4;// if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
var offset=void 0;if(atf>1){offset=start+5+data[start+4];// continue if there is only adaptation field
if(offset===start+PACKET_LENGTH){continue;}}else {offset=start+4;}switch(pid){case videoPid:if(stt){if(videoData&&(pes=parsePES(videoData))){this.videoParser.parseAVCPES(videoTrack,textTrack,pes,false,this._duration);}videoData={data:[],size:0};}if(videoData){videoData.data.push(data.subarray(offset,start+PACKET_LENGTH));videoData.size+=start+PACKET_LENGTH-offset;}break;case audioPid:if(stt){if(audioData&&(pes=parsePES(audioData))){switch(audioTrack.segmentCodec){case'aac':this.parseAACPES(audioTrack,pes);break;case'mp3':this.parseMPEGPES(audioTrack,pes);break;case'ac3':{this.parseAC3PES(audioTrack,pes);}break;}}audioData={data:[],size:0};}if(audioData){audioData.data.push(data.subarray(offset,start+PACKET_LENGTH));audioData.size+=start+PACKET_LENGTH-offset;}break;case id3Pid:if(stt){if(id3Data&&(pes=parsePES(id3Data))){this.parseID3PES(id3Track,pes);}id3Data={data:[],size:0};}if(id3Data){id3Data.data.push(data.subarray(offset,start+PACKET_LENGTH));id3Data.size+=start+PACKET_LENGTH-offset;}break;case 0:if(stt){offset+=data[offset]+1;}pmtId=this._pmtId=parsePAT(data,offset);// logger.log('PMT PID:'  + this._pmtId);
break;case pmtId:{if(stt){offset+=data[offset]+1;}var parsedPIDs=parsePMT(data,offset,this.typeSupported,isSampleAes,this.observer);// only update track id if track PID found while parsing PMT
// this is to avoid resetting the PID to -1 in case
// track PID transiently disappears from the stream
// this could happen in case of transient missing audio samples for example
// NOTE this is only the PID of the track as found in TS,
// but we are not using this for MP4 track IDs.
videoPid=parsedPIDs.videoPid;if(videoPid>0){videoTrack.pid=videoPid;videoTrack.segmentCodec=parsedPIDs.segmentVideoCodec;}audioPid=parsedPIDs.audioPid;if(audioPid>0){audioTrack.pid=audioPid;audioTrack.segmentCodec=parsedPIDs.segmentAudioCodec;}id3Pid=parsedPIDs.id3Pid;if(id3Pid>0){id3Track.pid=id3Pid;}if(unknownPID!==null&&!pmtParsed){logger.warn("MPEG-TS PMT found at ".concat(start," after unknown PID '").concat(unknownPID,"'. Backtracking to sync byte @").concat(syncOffset," to parse all TS packets."));unknownPID=null;// we set it to -188, the += 188 in the for loop will reset start to 0
start=syncOffset-188;}pmtParsed=this.pmtParsed=true;break;}case 0x11:case 0x1fff:break;default:unknownPID=pid;break;}}else {tsPacketErrors++;}}if(tsPacketErrors>0){emitParsingError(this.observer,new Error("Found ".concat(tsPacketErrors," TS packet/s that do not start with 0x47")));}videoTrack.pesData=videoData;audioTrack.pesData=audioData;id3Track.pesData=id3Data;var demuxResult={audioTrack:audioTrack,videoTrack:videoTrack,id3Track:id3Track,textTrack:textTrack};if(flush){this.extractRemainingSamples(demuxResult);}return demuxResult;}},{key:"flush",value:function flush(){var remainderData=this.remainderData;this.remainderData=null;var result;if(remainderData){result=this.demux(remainderData,-1,false,true);}else {result={videoTrack:this._videoTrack,audioTrack:this._audioTrack,id3Track:this._id3Track,textTrack:this._txtTrack};}this.extractRemainingSamples(result);if(this.sampleAes){return this.decrypt(result,this.sampleAes);}return result;}},{key:"extractRemainingSamples",value:function extractRemainingSamples(demuxResult){var audioTrack=demuxResult.audioTrack,videoTrack=demuxResult.videoTrack,id3Track=demuxResult.id3Track,textTrack=demuxResult.textTrack;var videoData=videoTrack.pesData;var audioData=audioTrack.pesData;var id3Data=id3Track.pesData;// try to parse last PES packets
var pes;if(videoData&&(pes=parsePES(videoData))){this.videoParser.parseAVCPES(videoTrack,textTrack,pes,true,this._duration);videoTrack.pesData=null;}else {// either avcData null or PES truncated, keep it for next frag parsing
videoTrack.pesData=videoData;}if(audioData&&(pes=parsePES(audioData))){switch(audioTrack.segmentCodec){case'aac':this.parseAACPES(audioTrack,pes);break;case'mp3':this.parseMPEGPES(audioTrack,pes);break;case'ac3':{this.parseAC3PES(audioTrack,pes);}break;}audioTrack.pesData=null;}else {if(audioData!=null&&audioData.size){logger.log('last AAC PES packet truncated,might overlap between fragments');}// either audioData null or PES truncated, keep it for next frag parsing
audioTrack.pesData=audioData;}if(id3Data&&(pes=parsePES(id3Data))){this.parseID3PES(id3Track,pes);id3Track.pesData=null;}else {// either id3Data null or PES truncated, keep it for next frag parsing
id3Track.pesData=id3Data;}}},{key:"demuxSampleAes",value:function demuxSampleAes(data,keyData,timeOffset){var demuxResult=this.demux(data,timeOffset,true,!this.config.progressive);var sampleAes=this.sampleAes=new SampleAesDecrypter(this.observer,this.config,keyData);return this.decrypt(demuxResult,sampleAes);}},{key:"decrypt",value:function decrypt(demuxResult,sampleAes){return new Promise(function(resolve){var audioTrack=demuxResult.audioTrack,videoTrack=demuxResult.videoTrack;if(audioTrack.samples&&audioTrack.segmentCodec==='aac'){sampleAes.decryptAacSamples(audioTrack.samples,0,function(){if(videoTrack.samples){sampleAes.decryptAvcSamples(videoTrack.samples,0,0,function(){resolve(demuxResult);});}else {resolve(demuxResult);}});}else if(videoTrack.samples){sampleAes.decryptAvcSamples(videoTrack.samples,0,0,function(){resolve(demuxResult);});}});}},{key:"destroy",value:function destroy(){this._duration=0;}},{key:"parseAACPES",value:function parseAACPES(track,pes){var startOffset=0;var aacOverFlow=this.aacOverFlow;var data=pes.data;if(aacOverFlow){this.aacOverFlow=null;var frameMissingBytes=aacOverFlow.missing;var sampleLength=aacOverFlow.sample.unit.byteLength;// logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
if(frameMissingBytes===-1){data=appendUint8Array(aacOverFlow.sample.unit,data);}else {var frameOverflowBytes=sampleLength-frameMissingBytes;aacOverFlow.sample.unit.set(data.subarray(0,frameMissingBytes),frameOverflowBytes);track.samples.push(aacOverFlow.sample);startOffset=aacOverFlow.missing;}}// look for ADTS header (0xFFFx)
var offset;var len;for(offset=startOffset,len=data.length;offset<len-1;offset++){if(isHeader$1(data,offset)){break;}}// if ADTS header does not start straight from the beginning of the PES payload, raise an error
if(offset!==startOffset){var reason;var recoverable=offset<len-1;if(recoverable){reason="AAC PES did not start with ADTS header,offset:".concat(offset);}else {reason='No ADTS header found in AAC PES';}emitParsingError(this.observer,new Error(reason),recoverable);if(!recoverable){return;}}initTrackConfig(track,this.observer,data,offset,this.audioCodec);var pts;if(pes.pts!==undefined){pts=pes.pts;}else if(aacOverFlow){// if last AAC frame is overflowing, we should ensure timestamps are contiguous:
// first sample PTS should be equal to last sample PTS + frameDuration
var frameDuration=getFrameDuration(track.samplerate);pts=aacOverFlow.sample.pts+frameDuration;}else {logger.warn('[tsdemuxer]: AAC PES unknown PTS');return;}// scan for aac samples
var frameIndex=0;var frame;while(offset<len){frame=appendFrame$2(track,data,offset,pts,frameIndex);offset+=frame.length;if(!frame.missing){frameIndex++;for(;offset<len-1;offset++){if(isHeader$1(data,offset)){break;}}}else {this.aacOverFlow=frame;break;}}}},{key:"parseMPEGPES",value:function parseMPEGPES(track,pes){var data=pes.data;var length=data.length;var frameIndex=0;var offset=0;var pts=pes.pts;if(pts===undefined){logger.warn('[tsdemuxer]: MPEG PES unknown PTS');return;}while(offset<length){if(isHeader(data,offset)){var frame=appendFrame$1(track,data,offset,pts,frameIndex);if(frame){offset+=frame.length;frameIndex++;}else {// logger.log('Unable to parse Mpeg audio frame');
break;}}else {// nothing found, keep looking
offset++;}}}},{key:"parseAC3PES",value:function parseAC3PES(track,pes){{var data=pes.data;var pts=pes.pts;if(pts===undefined){logger.warn('[tsdemuxer]: AC3 PES unknown PTS');return;}var length=data.length;var frameIndex=0;var offset=0;var parsed;while(offset<length&&(parsed=_appendFrame(track,data,offset,pts,frameIndex++))>0){offset+=parsed;}}}},{key:"parseID3PES",value:function parseID3PES(id3Track,pes){if(pes.pts===undefined){logger.warn('[tsdemuxer]: ID3 PES unknown PTS');return;}var id3Sample=_extends({},pes,{type:this._videoTrack?MetadataSchema.emsg:MetadataSchema.audioId3,duration:Number.POSITIVE_INFINITY});id3Track.samples.push(id3Sample);}}],[{key:"probe",value:function probe(data){var syncOffset=TSDemuxer.syncOffset(data);if(syncOffset>0){logger.warn("MPEG2-TS detected but first sync word found @ offset ".concat(syncOffset));}return syncOffset!==-1;}},{key:"syncOffset",value:function syncOffset(data){var length=data.length;var scanwindow=Math.min(PACKET_LENGTH*5,length-PACKET_LENGTH)+1;var i=0;while(i<scanwindow){// a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
var foundPat=false;var packetStart=-1;var tsPackets=0;for(var j=i;j<length;j+=PACKET_LENGTH){if(data[j]===0x47&&(length-j===PACKET_LENGTH||data[j+PACKET_LENGTH]===0x47)){tsPackets++;if(packetStart===-1){packetStart=j;// First sync word found at offset, increase scan length (#5251)
if(packetStart!==0){scanwindow=Math.min(packetStart+PACKET_LENGTH*99,data.length-PACKET_LENGTH)+1;}}if(!foundPat){foundPat=parsePID(data,j)===0;}// Sync word found at 0 with 3 packets, or found at offset least 2 packets up to scanwindow (#5501)
if(foundPat&&tsPackets>1&&(packetStart===0&&tsPackets>2||j+PACKET_LENGTH>scanwindow)){return packetStart;}}else if(tsPackets){// Exit if sync word found, but does not contain contiguous packets
return -1;}else {break;}}i++;}return -1;}/**
   * Creates a track model internal to demuxer used to drive remuxing input
   */},{key:"createTrack",value:function createTrack(type,duration){return {container:type==='video'||type==='audio'?'video/mp2t':undefined,type:type,id:RemuxerTrackIdConfig[type],pid:-1,inputTimeScale:90000,sequenceNumber:0,samples:[],dropped:0,duration:type==='audio'?duration:undefined};}}]);return TSDemuxer;}();function parsePID(data,offset){// pid is a 13-bit field starting at the last bit of TS[1]
return ((data[offset+1]&0x1f)<<8)+data[offset+2];}function parsePAT(data,offset){// skip the PSI header and parse the first PMT entry
return (data[offset+10]&0x1f)<<8|data[offset+11];}function parsePMT(data,offset,typeSupported,isSampleAes,observer){var result={audioPid:-1,videoPid:-1,id3Pid:-1,segmentVideoCodec:'avc',segmentAudioCodec:'aac'};var sectionLength=(data[offset+1]&0x0f)<<8|data[offset+2];var tableEnd=offset+3+sectionLength-4;// to determine where the table is, we have to figure out how
// long the program info descriptors are
var programInfoLength=(data[offset+10]&0x0f)<<8|data[offset+11];// advance the offset to the first entry in the mapping table
offset+=12+programInfoLength;while(offset<tableEnd){var pid=parsePID(data,offset);var esInfoLength=(data[offset+3]&0x0f)<<8|data[offset+4];switch(data[offset]){case 0xcf:// SAMPLE-AES AAC
if(!isSampleAes){logEncryptedSamplesFoundInUnencryptedStream('ADTS AAC');break;}/* falls through */case 0x0f:// ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
// logger.log('AAC PID:'  + pid);
if(result.audioPid===-1){result.audioPid=pid;}break;// Packetized metadata (ID3)
case 0x15:// logger.log('ID3 PID:'  + pid);
if(result.id3Pid===-1){result.id3Pid=pid;}break;case 0xdb:// SAMPLE-AES AVC
if(!isSampleAes){logEncryptedSamplesFoundInUnencryptedStream('H.264');break;}/* falls through */case 0x1b:// ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
// logger.log('AVC PID:'  + pid);
if(result.videoPid===-1){result.videoPid=pid;result.segmentVideoCodec='avc';}break;// ISO/IEC 11172-3 (MPEG-1 audio)
// or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
case 0x03:case 0x04:// logger.log('MPEG PID:'  + pid);
if(!typeSupported.mpeg&&!typeSupported.mp3){logger.log('MPEG audio found, not supported in this browser');}else if(result.audioPid===-1){result.audioPid=pid;result.segmentAudioCodec='mp3';}break;case 0xc1:// SAMPLE-AES AC3
if(!isSampleAes){logEncryptedSamplesFoundInUnencryptedStream('AC-3');break;}/* falls through */case 0x81:{if(!typeSupported.ac3){logger.log('AC-3 audio found, not supported in this browser');}else if(result.audioPid===-1){result.audioPid=pid;result.segmentAudioCodec='ac3';}}break;case 0x06:// stream_type 6 can mean a lot of different things in case of DVB.
// We need to look at the descriptors. Right now, we're only interested
// in AC-3 audio, so we do the descriptor parsing only when we don't have
// an audio PID yet.
if(result.audioPid===-1&&esInfoLength>0){var parsePos=offset+5;var remaining=esInfoLength;while(remaining>2){var descriptorId=data[parsePos];switch(descriptorId){case 0x6a:// DVB Descriptor for AC-3
{if(typeSupported.ac3!==true){logger.log('AC-3 audio found, not supported in this browser for now');}else {result.audioPid=pid;result.segmentAudioCodec='ac3';}}break;}var descriptorLen=data[parsePos+1]+2;parsePos+=descriptorLen;remaining-=descriptorLen;}}break;case 0xc2:// SAMPLE-AES EC3
/* falls through */case 0x87:emitParsingError(observer,new Error('Unsupported EC-3 in M2TS found'));return result;case 0x24:emitParsingError(observer,new Error('Unsupported HEVC in M2TS found'));return result;}// move to the next table entry
// skip past the elementary stream descriptors, if present
offset+=esInfoLength+5;}return result;}function emitParsingError(observer,error,levelRetry){logger.warn("parsing error: ".concat(error.message));observer.emit(Events.ERROR,Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.FRAG_PARSING_ERROR,fatal:false,levelRetry:levelRetry,error:error,reason:error.message});}function logEncryptedSamplesFoundInUnencryptedStream(type){logger.log("".concat(type," with AES-128-CBC encryption found in unencrypted stream"));}function parsePES(stream){var i=0;var frag;var pesLen;var pesHdrLen;var pesPts;var pesDts;var data=stream.data;// safety check
if(!stream||stream.size===0){return null;}// we might need up to 19 bytes to read PES header
// if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
// usually only one merge is needed (and this is rare ...)
while(data[0].length<19&&data.length>1){data[0]=appendUint8Array(data[0],data[1]);data.splice(1,1);}// retrieve PTS/DTS from first fragment
frag=data[0];var pesPrefix=(frag[0]<<16)+(frag[1]<<8)+frag[2];if(pesPrefix===1){pesLen=(frag[4]<<8)+frag[5];// if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
// minus 6 : PES header size
if(pesLen&&pesLen>stream.size-6){return null;}var pesFlags=frag[7];if(pesFlags&0xc0){/* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
          as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
          as Bitwise operators treat their operands as a sequence of 32 bits */pesPts=(frag[9]&0x0e)*536870912+// 1 << 29
(frag[10]&0xff)*4194304+// 1 << 22
(frag[11]&0xfe)*16384+// 1 << 14
(frag[12]&0xff)*128+// 1 << 7
(frag[13]&0xfe)/2;if(pesFlags&0x40){pesDts=(frag[14]&0x0e)*536870912+// 1 << 29
(frag[15]&0xff)*4194304+// 1 << 22
(frag[16]&0xfe)*16384+// 1 << 14
(frag[17]&0xff)*128+// 1 << 7
(frag[18]&0xfe)/2;if(pesPts-pesDts>60*90000){logger.warn("".concat(Math.round((pesPts-pesDts)/90000),"s delta between PTS and DTS, align them"));pesPts=pesDts;}}else {pesDts=pesPts;}}pesHdrLen=frag[8];// 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
var payloadStartOffset=pesHdrLen+9;if(stream.size<=payloadStartOffset){return null;}stream.size-=payloadStartOffset;// reassemble PES packet
var pesData=new Uint8Array(stream.size);for(var j=0,dataLen=data.length;j<dataLen;j++){frag=data[j];var len=frag.byteLength;if(payloadStartOffset){if(payloadStartOffset>len){// trim full frag if PES header bigger than frag
payloadStartOffset-=len;continue;}else {// trim partial frag if PES header smaller than frag
frag=frag.subarray(payloadStartOffset);len-=payloadStartOffset;payloadStartOffset=0;}}pesData.set(frag,i);i+=len;}if(pesLen){// payload size : remove PES header + PES extension
pesLen-=pesHdrLen+3;}return {data:pesData,pts:pesPts,dts:pesDts,len:pesLen};}return null;}/**
 * MP3 demuxer
 */var MP3Demuxer=/*#__PURE__*/function(_BaseAudioDemuxer3){_inherits(MP3Demuxer,_BaseAudioDemuxer3);var _super8=_createSuper(MP3Demuxer);function MP3Demuxer(){_classCallCheck(this,MP3Demuxer);return _super8.apply(this,arguments);}_createClass(MP3Demuxer,[{key:"resetInitSegment",value:function resetInitSegment(initSegment,audioCodec,videoCodec,trackDuration){_get(_getPrototypeOf(MP3Demuxer.prototype),"resetInitSegment",this).call(this,initSegment,audioCodec,videoCodec,trackDuration);this._audioTrack={container:'audio/mpeg',type:'audio',id:2,pid:-1,sequenceNumber:0,segmentCodec:'mp3',samples:[],manifestCodec:audioCodec,duration:trackDuration,inputTimeScale:90000,dropped:0};}},{key:"canParse",value:function canParse(data,offset){return _canParse(data,offset);}},{key:"appendFrame",value:function appendFrame(track,data,offset){if(this.basePTS===null){return;}return appendFrame$1(track,data,offset,this.basePTS,this.frameIndex);}}],[{key:"probe",value:function probe(data){if(!data){return false;}// check if data contains ID3 timestamp and MPEG sync word
// Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
// Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
// More info http://www.mp3-tech.org/programmer/frame_header.html
var id3Data=getID3Data(data,0);var offset=(id3Data==null?void 0:id3Data.length)||0;// Check for ac-3|ec-3 sync bytes and return false if present
if(id3Data&&data[offset]===0x0b&&data[offset+1]===0x77&&getTimeStamp(id3Data)!==undefined&&// check the bsid to confirm ac-3 or ec-3 (not mp3)
getAudioBSID(data,offset)<=16){return false;}for(var length=data.length;offset<length;offset++){if(_probe(data,offset)){logger.log('MPEG Audio sync word found !');return true;}}return false;}}]);return MP3Demuxer;}(BaseAudioDemuxer);/**
 *  AAC helper
 */var AAC=/*#__PURE__*/function(){function AAC(){_classCallCheck(this,AAC);}_createClass(AAC,null,[{key:"getSilentFrame",value:function getSilentFrame(codec,channelCount){switch(codec){case'mp4a.40.2':if(channelCount===1){return new Uint8Array([0x00,0xc8,0x00,0x80,0x23,0x80]);}else if(channelCount===2){return new Uint8Array([0x21,0x00,0x49,0x90,0x02,0x19,0x00,0x23,0x80]);}else if(channelCount===3){return new Uint8Array([0x00,0xc8,0x00,0x80,0x20,0x84,0x01,0x26,0x40,0x08,0x64,0x00,0x8e]);}else if(channelCount===4){return new Uint8Array([0x00,0xc8,0x00,0x80,0x20,0x84,0x01,0x26,0x40,0x08,0x64,0x00,0x80,0x2c,0x80,0x08,0x02,0x38]);}else if(channelCount===5){return new Uint8Array([0x00,0xc8,0x00,0x80,0x20,0x84,0x01,0x26,0x40,0x08,0x64,0x00,0x82,0x30,0x04,0x99,0x00,0x21,0x90,0x02,0x38]);}else if(channelCount===6){return new Uint8Array([0x00,0xc8,0x00,0x80,0x20,0x84,0x01,0x26,0x40,0x08,0x64,0x00,0x82,0x30,0x04,0x99,0x00,0x21,0x90,0x02,0x00,0xb2,0x00,0x20,0x08,0xe0]);}break;// handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
default:if(channelCount===1){// ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
return new Uint8Array([0x1,0x40,0x22,0x80,0xa3,0x4e,0xe6,0x80,0xba,0x8,0x0,0x0,0x0,0x1c,0x6,0xf1,0xc1,0xa,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5e]);}else if(channelCount===2){// ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
return new Uint8Array([0x1,0x40,0x22,0x80,0xa3,0x5e,0xe6,0x80,0xba,0x8,0x0,0x0,0x0,0x0,0x95,0x0,0x6,0xf1,0xa1,0xa,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5e]);}else if(channelCount===3){// ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
return new Uint8Array([0x1,0x40,0x22,0x80,0xa3,0x5e,0xe6,0x80,0xba,0x8,0x0,0x0,0x0,0x0,0x95,0x0,0x6,0xf1,0xa1,0xa,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5a,0x5e]);}break;}return undefined;}}]);return AAC;}();/**
 * Generate MP4 Box
 */var UINT32_MAX=Math.pow(2,32)-1;var MP4=/*#__PURE__*/function(){function MP4(){_classCallCheck(this,MP4);}_createClass(MP4,null,[{key:"init",value:function init(){MP4.types={avc1:[],// codingname
avcC:[],btrt:[],dinf:[],dref:[],esds:[],ftyp:[],hdlr:[],mdat:[],mdhd:[],mdia:[],mfhd:[],minf:[],moof:[],moov:[],mp4a:[],'.mp3':[],dac3:[],'ac-3':[],mvex:[],mvhd:[],pasp:[],sdtp:[],stbl:[],stco:[],stsc:[],stsd:[],stsz:[],stts:[],tfdt:[],tfhd:[],traf:[],trak:[],trun:[],trex:[],tkhd:[],vmhd:[],smhd:[]};var i;for(i in MP4.types){if(MP4.types.hasOwnProperty(i)){MP4.types[i]=[i.charCodeAt(0),i.charCodeAt(1),i.charCodeAt(2),i.charCodeAt(3)];}}var videoHdlr=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,// pre_defined
0x76,0x69,0x64,0x65,// handler_type: 'vide'
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x56,0x69,0x64,0x65,0x6f,0x48,0x61,0x6e,0x64,0x6c,0x65,0x72,0x00// name: 'VideoHandler'
]);var audioHdlr=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,// pre_defined
0x73,0x6f,0x75,0x6e,// handler_type: 'soun'
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x53,0x6f,0x75,0x6e,0x64,0x48,0x61,0x6e,0x64,0x6c,0x65,0x72,0x00// name: 'SoundHandler'
]);MP4.HDLR_TYPES={video:videoHdlr,audio:audioHdlr};var dref=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x01,// entry_count
0x00,0x00,0x00,0x0c,// entry_size
0x75,0x72,0x6c,0x20,// 'url' type
0x00,// version 0
0x00,0x00,0x01// entry_flags
]);var stco=new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00// entry_count
]);MP4.STTS=MP4.STSC=MP4.STCO=stco;MP4.STSZ=new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,// sample_size
0x00,0x00,0x00,0x00// sample_count
]);MP4.VMHD=new Uint8Array([0x00,// version
0x00,0x00,0x01,// flags
0x00,0x00,// graphicsmode
0x00,0x00,0x00,0x00,0x00,0x00// opcolor
]);MP4.SMHD=new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
0x00,0x00,// balance
0x00,0x00// reserved
]);MP4.STSD=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x01]);// entry_count
var majorBrand=new Uint8Array([105,115,111,109]);// isom
var avc1Brand=new Uint8Array([97,118,99,49]);// avc1
var minorVersion=new Uint8Array([0,0,0,1]);MP4.FTYP=MP4.box(MP4.types.ftyp,majorBrand,minorVersion,majorBrand,avc1Brand);MP4.DINF=MP4.box(MP4.types.dinf,MP4.box(MP4.types.dref,dref));}},{key:"box",value:function box(type){var size=8;for(var _len3=arguments.length,payload=new Array(_len3>1?_len3-1:0),_key3=1;_key3<_len3;_key3++){payload[_key3-1]=arguments[_key3];}var i=payload.length;var len=i;// calculate the total size we need to allocate
while(i--){size+=payload[i].byteLength;}var result=new Uint8Array(size);result[0]=size>>24&0xff;result[1]=size>>16&0xff;result[2]=size>>8&0xff;result[3]=size&0xff;result.set(type,4);// copy the payload into the result
for(i=0,size=8;i<len;i++){// copy payload[i] array @ offset size
result.set(payload[i],size);size+=payload[i].byteLength;}return result;}},{key:"hdlr",value:function hdlr(type){return MP4.box(MP4.types.hdlr,MP4.HDLR_TYPES[type]);}},{key:"mdat",value:function mdat(data){return MP4.box(MP4.types.mdat,data);}},{key:"mdhd",value:function mdhd(timescale,duration){duration*=timescale;var upperWordDuration=Math.floor(duration/(UINT32_MAX+1));var lowerWordDuration=Math.floor(duration%(UINT32_MAX+1));return MP4.box(MP4.types.mdhd,new Uint8Array([0x01,// version 1
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,// creation_time
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x03,// modification_time
timescale>>24&0xff,timescale>>16&0xff,timescale>>8&0xff,timescale&0xff,// timescale
upperWordDuration>>24,upperWordDuration>>16&0xff,upperWordDuration>>8&0xff,upperWordDuration&0xff,lowerWordDuration>>24,lowerWordDuration>>16&0xff,lowerWordDuration>>8&0xff,lowerWordDuration&0xff,0x55,0xc4,// 'und' language (undetermined)
0x00,0x00]));}},{key:"mdia",value:function mdia(track){return MP4.box(MP4.types.mdia,MP4.mdhd(track.timescale,track.duration),MP4.hdlr(track.type),MP4.minf(track));}},{key:"mfhd",value:function mfhd(sequenceNumber){return MP4.box(MP4.types.mfhd,new Uint8Array([0x00,0x00,0x00,0x00,// flags
sequenceNumber>>24,sequenceNumber>>16&0xff,sequenceNumber>>8&0xff,sequenceNumber&0xff// sequence_number
]));}},{key:"minf",value:function minf(track){if(track.type==='audio'){return MP4.box(MP4.types.minf,MP4.box(MP4.types.smhd,MP4.SMHD),MP4.DINF,MP4.stbl(track));}else {return MP4.box(MP4.types.minf,MP4.box(MP4.types.vmhd,MP4.VMHD),MP4.DINF,MP4.stbl(track));}}},{key:"moof",value:function moof(sn,baseMediaDecodeTime,track){return MP4.box(MP4.types.moof,MP4.mfhd(sn),MP4.traf(track,baseMediaDecodeTime));}},{key:"moov",value:function moov(tracks){var i=tracks.length;var boxes=[];while(i--){boxes[i]=MP4.trak(tracks[i]);}return MP4.box.apply(null,[MP4.types.moov,MP4.mvhd(tracks[0].timescale,tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));}},{key:"mvex",value:function mvex(tracks){var i=tracks.length;var boxes=[];while(i--){boxes[i]=MP4.trex(tracks[i]);}return MP4.box.apply(null,[MP4.types.mvex].concat(boxes));}},{key:"mvhd",value:function mvhd(timescale,duration){duration*=timescale;var upperWordDuration=Math.floor(duration/(UINT32_MAX+1));var lowerWordDuration=Math.floor(duration%(UINT32_MAX+1));var bytes=new Uint8Array([0x01,// version 1
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,// creation_time
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x03,// modification_time
timescale>>24&0xff,timescale>>16&0xff,timescale>>8&0xff,timescale&0xff,// timescale
upperWordDuration>>24,upperWordDuration>>16&0xff,upperWordDuration>>8&0xff,upperWordDuration&0xff,lowerWordDuration>>24,lowerWordDuration>>16&0xff,lowerWordDuration>>8&0xff,lowerWordDuration&0xff,0x00,0x01,0x00,0x00,// 1.0 rate
0x01,0x00,// 1.0 volume
0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x00,0x00,0x00,// transformation: unity matrix
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// pre_defined
0xff,0xff,0xff,0xff// next_track_ID
]);return MP4.box(MP4.types.mvhd,bytes);}},{key:"sdtp",value:function sdtp(track){var samples=track.samples||[];var bytes=new Uint8Array(4+samples.length);var i;var flags;// leave the full box header (4 bytes) all zero
// write the sample table
for(i=0;i<samples.length;i++){flags=samples[i].flags;bytes[i+4]=flags.dependsOn<<4|flags.isDependedOn<<2|flags.hasRedundancy;}return MP4.box(MP4.types.sdtp,bytes);}},{key:"stbl",value:function stbl(track){return MP4.box(MP4.types.stbl,MP4.stsd(track),MP4.box(MP4.types.stts,MP4.STTS),MP4.box(MP4.types.stsc,MP4.STSC),MP4.box(MP4.types.stsz,MP4.STSZ),MP4.box(MP4.types.stco,MP4.STCO));}},{key:"avc1",value:function avc1(track){var sps=[];var pps=[];var i;var data;var len;// assemble the SPSs
for(i=0;i<track.sps.length;i++){data=track.sps[i];len=data.byteLength;sps.push(len>>>8&0xff);sps.push(len&0xff);// SPS
sps=sps.concat(Array.prototype.slice.call(data));}// assemble the PPSs
for(i=0;i<track.pps.length;i++){data=track.pps[i];len=data.byteLength;pps.push(len>>>8&0xff);pps.push(len&0xff);pps=pps.concat(Array.prototype.slice.call(data));}var avcc=MP4.box(MP4.types.avcC,new Uint8Array([0x01,// version
sps[3],// profile
sps[4],// profile compat
sps[5],// level
0xfc|3,// lengthSizeMinusOne, hard-coded to 4 bytes
0xe0|track.sps.length// 3bit reserved (111) + numOfSequenceParameterSets
].concat(sps).concat([track.pps.length// numOfPictureParameterSets
]).concat(pps)));// "PPS"
var width=track.width;var height=track.height;var hSpacing=track.pixelRatio[0];var vSpacing=track.pixelRatio[1];return MP4.box(MP4.types.avc1,new Uint8Array([0x00,0x00,0x00,// reserved
0x00,0x00,0x00,// reserved
0x00,0x01,// data_reference_index
0x00,0x00,// pre_defined
0x00,0x00,// reserved
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// pre_defined
width>>8&0xff,width&0xff,// width
height>>8&0xff,height&0xff,// height
0x00,0x48,0x00,0x00,// horizresolution
0x00,0x48,0x00,0x00,// vertresolution
0x00,0x00,0x00,0x00,// reserved
0x00,0x01,// frame_count
0x12,0x64,0x61,0x69,0x6c,// dailymotion/hls.js
0x79,0x6d,0x6f,0x74,0x69,0x6f,0x6e,0x2f,0x68,0x6c,0x73,0x2e,0x6a,0x73,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// compressorname
0x00,0x18,// depth = 24
0x11,0x11]),// pre_defined = -1
avcc,MP4.box(MP4.types.btrt,new Uint8Array([0x00,0x1c,0x9c,0x80,// bufferSizeDB
0x00,0x2d,0xc6,0xc0,// maxBitrate
0x00,0x2d,0xc6,0xc0])),// avgBitrate
MP4.box(MP4.types.pasp,new Uint8Array([hSpacing>>24,// hSpacing
hSpacing>>16&0xff,hSpacing>>8&0xff,hSpacing&0xff,vSpacing>>24,// vSpacing
vSpacing>>16&0xff,vSpacing>>8&0xff,vSpacing&0xff])));}},{key:"esds",value:function esds(track){var configlen=track.config.length;return new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x03,// descriptor_type
0x17+configlen,// length
0x00,0x01,// es_id
0x00,// stream_priority
0x04,// descriptor_type
0x0f+configlen,// length
0x40,// codec : mpeg4_audio
0x15,// stream_type
0x00,0x00,0x00,// buffer_size
0x00,0x00,0x00,0x00,// maxBitrate
0x00,0x00,0x00,0x00,// avgBitrate
0x05// descriptor_type
].concat([configlen]).concat(track.config).concat([0x06,0x01,0x02]));// GASpecificConfig)); // length + audio config descriptor
}},{key:"audioStsd",value:function audioStsd(track){var samplerate=track.samplerate;return new Uint8Array([0x00,0x00,0x00,// reserved
0x00,0x00,0x00,// reserved
0x00,0x01,// data_reference_index
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// reserved
0x00,track.channelCount,// channelcount
0x00,0x10,// sampleSize:16bits
0x00,0x00,0x00,0x00,// reserved2
samplerate>>8&0xff,samplerate&0xff,//
0x00,0x00]);}},{key:"mp4a",value:function mp4a(track){return MP4.box(MP4.types.mp4a,MP4.audioStsd(track),MP4.box(MP4.types.esds,MP4.esds(track)));}},{key:"mp3",value:function mp3(track){return MP4.box(MP4.types['.mp3'],MP4.audioStsd(track));}},{key:"ac3",value:function ac3(track){return MP4.box(MP4.types['ac-3'],MP4.audioStsd(track),MP4.box(MP4.types.dac3,track.config));}},{key:"stsd",value:function stsd(track){if(track.type==='audio'){if(track.segmentCodec==='mp3'&&track.codec==='mp3'){return MP4.box(MP4.types.stsd,MP4.STSD,MP4.mp3(track));}if(track.segmentCodec==='ac3'){return MP4.box(MP4.types.stsd,MP4.STSD,MP4.ac3(track));}return MP4.box(MP4.types.stsd,MP4.STSD,MP4.mp4a(track));}else {return MP4.box(MP4.types.stsd,MP4.STSD,MP4.avc1(track));}}},{key:"tkhd",value:function tkhd(track){var id=track.id;var duration=track.duration*track.timescale;var width=track.width;var height=track.height;var upperWordDuration=Math.floor(duration/(UINT32_MAX+1));var lowerWordDuration=Math.floor(duration%(UINT32_MAX+1));return MP4.box(MP4.types.tkhd,new Uint8Array([0x01,// version 1
0x00,0x00,0x07,// flags
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,// creation_time
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x03,// modification_time
id>>24&0xff,id>>16&0xff,id>>8&0xff,id&0xff,// track_ID
0x00,0x00,0x00,0x00,// reserved
upperWordDuration>>24,upperWordDuration>>16&0xff,upperWordDuration>>8&0xff,upperWordDuration&0xff,lowerWordDuration>>24,lowerWordDuration>>16&0xff,lowerWordDuration>>8&0xff,lowerWordDuration&0xff,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// reserved
0x00,0x00,// layer
0x00,0x00,// alternate_group
0x00,0x00,// non-audio track volume
0x00,0x00,// reserved
0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x00,0x00,0x00,// transformation: unity matrix
width>>8&0xff,width&0xff,0x00,0x00,// width
height>>8&0xff,height&0xff,0x00,0x00// height
]));}},{key:"traf",value:function traf(track,baseMediaDecodeTime){var sampleDependencyTable=MP4.sdtp(track);var id=track.id;var upperWordBaseMediaDecodeTime=Math.floor(baseMediaDecodeTime/(UINT32_MAX+1));var lowerWordBaseMediaDecodeTime=Math.floor(baseMediaDecodeTime%(UINT32_MAX+1));return MP4.box(MP4.types.traf,MP4.box(MP4.types.tfhd,new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
id>>24,id>>16&0xff,id>>8&0xff,id&0xff// track_ID
])),MP4.box(MP4.types.tfdt,new Uint8Array([0x01,// version 1
0x00,0x00,0x00,// flags
upperWordBaseMediaDecodeTime>>24,upperWordBaseMediaDecodeTime>>16&0xff,upperWordBaseMediaDecodeTime>>8&0xff,upperWordBaseMediaDecodeTime&0xff,lowerWordBaseMediaDecodeTime>>24,lowerWordBaseMediaDecodeTime>>16&0xff,lowerWordBaseMediaDecodeTime>>8&0xff,lowerWordBaseMediaDecodeTime&0xff])),MP4.trun(track,sampleDependencyTable.length+16+// tfhd
20+// tfdt
8+// traf header
16+// mfhd
8+// moof header
8),// mdat header
sampleDependencyTable);}/**
   * Generate a track box.
   * @param track a track definition
   */},{key:"trak",value:function trak(track){track.duration=track.duration||0xffffffff;return MP4.box(MP4.types.trak,MP4.tkhd(track),MP4.mdia(track));}},{key:"trex",value:function trex(track){var id=track.id;return MP4.box(MP4.types.trex,new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
id>>24,id>>16&0xff,id>>8&0xff,id&0xff,// track_ID
0x00,0x00,0x00,0x01,// default_sample_description_index
0x00,0x00,0x00,0x00,// default_sample_duration
0x00,0x00,0x00,0x00,// default_sample_size
0x00,0x01,0x00,0x01// default_sample_flags
]));}},{key:"trun",value:function trun(track,offset){var samples=track.samples||[];var len=samples.length;var arraylen=12+16*len;var array=new Uint8Array(arraylen);var i;var sample;var duration;var size;var flags;var cts;offset+=8+arraylen;array.set([track.type==='video'?0x01:0x00,// version 1 for video with signed-int sample_composition_time_offset
0x00,0x0f,0x01,// flags
len>>>24&0xff,len>>>16&0xff,len>>>8&0xff,len&0xff,// sample_count
offset>>>24&0xff,offset>>>16&0xff,offset>>>8&0xff,offset&0xff// data_offset
],0);for(i=0;i<len;i++){sample=samples[i];duration=sample.duration;size=sample.size;flags=sample.flags;cts=sample.cts;array.set([duration>>>24&0xff,duration>>>16&0xff,duration>>>8&0xff,duration&0xff,// sample_duration
size>>>24&0xff,size>>>16&0xff,size>>>8&0xff,size&0xff,// sample_size
flags.isLeading<<2|flags.dependsOn,flags.isDependedOn<<6|flags.hasRedundancy<<4|flags.paddingValue<<1|flags.isNonSync,flags.degradPrio&0xf0<<8,flags.degradPrio&0x0f,// sample_flags
cts>>>24&0xff,cts>>>16&0xff,cts>>>8&0xff,cts&0xff// sample_composition_time_offset
],12+16*i);}return MP4.box(MP4.types.trun,array);}},{key:"initSegment",value:function initSegment(tracks){if(!MP4.types){MP4.init();}var movie=MP4.moov(tracks);var result=appendUint8Array(MP4.FTYP,movie);return result;}}]);return MP4;}();MP4.types=void 0;MP4.HDLR_TYPES=void 0;MP4.STTS=void 0;MP4.STSC=void 0;MP4.STCO=void 0;MP4.STSZ=void 0;MP4.VMHD=void 0;MP4.SMHD=void 0;MP4.STSD=void 0;MP4.FTYP=void 0;MP4.DINF=void 0;var MPEG_TS_CLOCK_FREQ_HZ=90000;function toTimescaleFromBase(baseTime,destScale){var srcBase=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var round=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var result=baseTime*destScale*srcBase;// equivalent to `(value * scale) / (1 / base)`
return round?Math.round(result):result;}function toTimescaleFromScale(baseTime,destScale){var srcScale=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var round=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return toTimescaleFromBase(baseTime,destScale,1/srcScale,round);}function toMsFromMpegTsClock(baseTime){var round=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return toTimescaleFromBase(baseTime,1000,1/MPEG_TS_CLOCK_FREQ_HZ,round);}function toMpegTsClockFromTimescale(baseTime){var srcScale=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return toTimescaleFromBase(baseTime,MPEG_TS_CLOCK_FREQ_HZ,1/srcScale);}var MAX_SILENT_FRAME_DURATION=10*1000;// 10 seconds
var AAC_SAMPLES_PER_FRAME=1024;var MPEG_AUDIO_SAMPLE_PER_FRAME=1152;var AC3_SAMPLES_PER_FRAME=1536;var chromeVersion=null;var safariWebkitVersion=null;var MP4Remuxer=/*#__PURE__*/function(){function MP4Remuxer(observer,config,typeSupported){_classCallCheck(this,MP4Remuxer);this.observer=void 0;this.config=void 0;this.typeSupported=void 0;this.ISGenerated=false;this._initPTS=null;this._initDTS=null;this.nextAvcDts=null;this.nextAudioPts=null;this.videoSampleDuration=null;this.isAudioContiguous=false;this.isVideoContiguous=false;this.videoTrackConfig=void 0;this.observer=observer;this.config=config;this.typeSupported=typeSupported;this.ISGenerated=false;if(chromeVersion===null){var userAgent=navigator.userAgent||'';var result=userAgent.match(/Chrome\/(\d+)/i);chromeVersion=result?parseInt(result[1]):0;}if(safariWebkitVersion===null){var _result2=navigator.userAgent.match(/Safari\/(\d+)/i);safariWebkitVersion=_result2?parseInt(_result2[1]):0;}}_createClass(MP4Remuxer,[{key:"destroy",value:function destroy(){// @ts-ignore
this.config=this.videoTrackConfig=this._initPTS=this._initDTS=null;}},{key:"resetTimeStamp",value:function resetTimeStamp(defaultTimeStamp){logger.log('[mp4-remuxer]: initPTS & initDTS reset');this._initPTS=this._initDTS=defaultTimeStamp;}},{key:"resetNextTimestamp",value:function resetNextTimestamp(){logger.log('[mp4-remuxer]: reset next timestamp');this.isVideoContiguous=false;this.isAudioContiguous=false;}},{key:"resetInitSegment",value:function resetInitSegment(){logger.log('[mp4-remuxer]: ISGenerated flag reset');this.ISGenerated=false;this.videoTrackConfig=undefined;}},{key:"getVideoStartPts",value:function getVideoStartPts(videoSamples){// Get the minimum PTS value relative to the first sample's PTS, normalized for 33-bit wrapping
var rolloverDetected=false;var firstPts=videoSamples[0].pts;var startPTS=videoSamples.reduce(function(minPTS,sample){var pts=sample.pts;var delta=pts-minPTS;if(delta<-4294967296){// 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
rolloverDetected=true;pts=normalizePts(pts,firstPts);delta=pts-minPTS;}if(delta>0){return minPTS;}return pts;},firstPts);if(rolloverDetected){logger.debug('PTS rollover detected');}return startPTS;}},{key:"remux",value:function remux(audioTrack,videoTrack,id3Track,textTrack,timeOffset,accurateTimeOffset,flush,playlistType){var video;var audio;var initSegment;var text;var id3;var independent;var audioTimeOffset=timeOffset;var videoTimeOffset=timeOffset;// If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
// This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
// parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
// However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
// then we can remux one track without waiting for the other.
var hasAudio=audioTrack.pid>-1;var hasVideo=videoTrack.pid>-1;var length=videoTrack.samples.length;var enoughAudioSamples=audioTrack.samples.length>0;var enoughVideoSamples=flush&&length>0||length>1;var canRemuxAvc=(!hasAudio||enoughAudioSamples)&&(!hasVideo||enoughVideoSamples)||this.ISGenerated||flush;if(canRemuxAvc){if(this.ISGenerated){var _videoTrack$pixelRati,_config$pixelRatio,_videoTrack$pixelRati2,_config$pixelRatio2;var config=this.videoTrackConfig;if(config&&(videoTrack.width!==config.width||videoTrack.height!==config.height||((_videoTrack$pixelRati=videoTrack.pixelRatio)==null?void 0:_videoTrack$pixelRati[0])!==((_config$pixelRatio=config.pixelRatio)==null?void 0:_config$pixelRatio[0])||((_videoTrack$pixelRati2=videoTrack.pixelRatio)==null?void 0:_videoTrack$pixelRati2[1])!==((_config$pixelRatio2=config.pixelRatio)==null?void 0:_config$pixelRatio2[1]))){this.resetInitSegment();}}else {initSegment=this.generateIS(audioTrack,videoTrack,timeOffset,accurateTimeOffset);}var isVideoContiguous=this.isVideoContiguous;var firstKeyFrameIndex=-1;var firstKeyFramePTS;if(enoughVideoSamples){firstKeyFrameIndex=findKeyframeIndex(videoTrack.samples);if(!isVideoContiguous&&this.config.forceKeyFrameOnDiscontinuity){independent=true;if(firstKeyFrameIndex>0){logger.warn("[mp4-remuxer]: Dropped ".concat(firstKeyFrameIndex," out of ").concat(length," video samples due to a missing keyframe"));var startPTS=this.getVideoStartPts(videoTrack.samples);videoTrack.samples=videoTrack.samples.slice(firstKeyFrameIndex);videoTrack.dropped+=firstKeyFrameIndex;videoTimeOffset+=(videoTrack.samples[0].pts-startPTS)/videoTrack.inputTimeScale;firstKeyFramePTS=videoTimeOffset;}else if(firstKeyFrameIndex===-1){logger.warn("[mp4-remuxer]: No keyframe found out of ".concat(length," video samples"));independent=false;}}}if(this.ISGenerated){if(enoughAudioSamples&&enoughVideoSamples){// timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
// if first audio DTS is not aligned with first video DTS then we need to take that into account
// when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
// drift between audio and video streams
var _startPTS=this.getVideoStartPts(videoTrack.samples);var tsDelta=normalizePts(audioTrack.samples[0].pts,_startPTS)-_startPTS;var audiovideoTimestampDelta=tsDelta/videoTrack.inputTimeScale;audioTimeOffset+=Math.max(0,audiovideoTimestampDelta);videoTimeOffset+=Math.max(0,-audiovideoTimestampDelta);}// Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
if(enoughAudioSamples){// if initSegment was generated without audio samples, regenerate it again
if(!audioTrack.samplerate){logger.warn('[mp4-remuxer]: regenerate InitSegment as audio detected');initSegment=this.generateIS(audioTrack,videoTrack,timeOffset,accurateTimeOffset);}audio=this.remuxAudio(audioTrack,audioTimeOffset,this.isAudioContiguous,accurateTimeOffset,hasVideo||enoughVideoSamples||playlistType===PlaylistLevelType.AUDIO?videoTimeOffset:undefined);if(enoughVideoSamples){var audioTrackLength=audio?audio.endPTS-audio.startPTS:0;// if initSegment was generated without video samples, regenerate it again
if(!videoTrack.inputTimeScale){logger.warn('[mp4-remuxer]: regenerate InitSegment as video detected');initSegment=this.generateIS(audioTrack,videoTrack,timeOffset,accurateTimeOffset);}video=this.remuxVideo(videoTrack,videoTimeOffset,isVideoContiguous,audioTrackLength);}}else if(enoughVideoSamples){video=this.remuxVideo(videoTrack,videoTimeOffset,isVideoContiguous,0);}if(video){video.firstKeyFrame=firstKeyFrameIndex;video.independent=firstKeyFrameIndex!==-1;video.firstKeyFramePTS=firstKeyFramePTS;}}}// Allow ID3 and text to remux, even if more audio/video samples are required
if(this.ISGenerated&&this._initPTS&&this._initDTS){if(id3Track.samples.length){id3=flushTextTrackMetadataCueSamples(id3Track,timeOffset,this._initPTS,this._initDTS);}if(textTrack.samples.length){text=flushTextTrackUserdataCueSamples(textTrack,timeOffset,this._initPTS);}}return {audio:audio,video:video,initSegment:initSegment,independent:independent,text:text,id3:id3};}},{key:"generateIS",value:function generateIS(audioTrack,videoTrack,timeOffset,accurateTimeOffset){var audioSamples=audioTrack.samples;var videoSamples=videoTrack.samples;var typeSupported=this.typeSupported;var tracks={};var _initPTS=this._initPTS;var computePTSDTS=!_initPTS||accurateTimeOffset;var container='audio/mp4';var initPTS;var initDTS;var timescale;if(computePTSDTS){initPTS=initDTS=Infinity;}if(audioTrack.config&&audioSamples.length){// let's use audio sampling rate as MP4 time scale.
// rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
// using audio sampling rate here helps having an integer MP4 frame duration
// this avoids potential rounding issue and AV sync issue
audioTrack.timescale=audioTrack.samplerate;switch(audioTrack.segmentCodec){case'mp3':if(typeSupported.mpeg){// Chrome and Safari
container='audio/mpeg';audioTrack.codec='';}else if(typeSupported.mp3){// Firefox
audioTrack.codec='mp3';}break;case'ac3':audioTrack.codec='ac-3';break;}tracks.audio={id:'audio',container:container,codec:audioTrack.codec,initSegment:audioTrack.segmentCodec==='mp3'&&typeSupported.mpeg?new Uint8Array(0):MP4.initSegment([audioTrack]),metadata:{channelCount:audioTrack.channelCount}};if(computePTSDTS){timescale=audioTrack.inputTimeScale;if(!_initPTS||timescale!==_initPTS.timescale){// remember first PTS of this demuxing context. for audio, PTS = DTS
initPTS=initDTS=audioSamples[0].pts-Math.round(timescale*timeOffset);}else {computePTSDTS=false;}}}if(videoTrack.sps&&videoTrack.pps&&videoSamples.length){// let's use input time scale as MP4 video timescale
// we use input time scale straight away to avoid rounding issues on frame duration / cts computation
videoTrack.timescale=videoTrack.inputTimeScale;tracks.video={id:'main',container:'video/mp4',codec:videoTrack.codec,initSegment:MP4.initSegment([videoTrack]),metadata:{width:videoTrack.width,height:videoTrack.height}};if(computePTSDTS){timescale=videoTrack.inputTimeScale;if(!_initPTS||timescale!==_initPTS.timescale){var startPTS=this.getVideoStartPts(videoSamples);var startOffset=Math.round(timescale*timeOffset);initDTS=Math.min(initDTS,normalizePts(videoSamples[0].dts,startPTS)-startOffset);initPTS=Math.min(initPTS,startPTS-startOffset);}else {computePTSDTS=false;}}this.videoTrackConfig={width:videoTrack.width,height:videoTrack.height,pixelRatio:videoTrack.pixelRatio};}if(Object.keys(tracks).length){this.ISGenerated=true;if(computePTSDTS){this._initPTS={baseTime:initPTS,timescale:timescale};this._initDTS={baseTime:initDTS,timescale:timescale};}else {initPTS=timescale=undefined;}return {tracks:tracks,initPTS:initPTS,timescale:timescale};}}},{key:"remuxVideo",value:function remuxVideo(track,timeOffset,contiguous,audioTrackLength){var timeScale=track.inputTimeScale;var inputSamples=track.samples;var outputSamples=[];var nbSamples=inputSamples.length;var initPTS=this._initPTS;var nextAvcDts=this.nextAvcDts;var offset=8;var mp4SampleDuration=this.videoSampleDuration;var firstDTS;var lastDTS;var minPTS=Number.POSITIVE_INFINITY;var maxPTS=Number.NEGATIVE_INFINITY;var sortSamples=false;// if parsed fragment is contiguous with last one, let's use last DTS value as reference
if(!contiguous||nextAvcDts===null){var pts=timeOffset*timeScale;var cts=inputSamples[0].pts-normalizePts(inputSamples[0].dts,inputSamples[0].pts);if(chromeVersion&&nextAvcDts!==null&&Math.abs(pts-cts-nextAvcDts)<15000){// treat as contigous to adjust samples that would otherwise produce video buffer gaps in Chrome
contiguous=true;}else {// if not contiguous, let's use target timeOffset
nextAvcDts=pts-cts;}}// PTS is coded on 33bits, and can loop from -2^32 to 2^32
// PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
var initTime=initPTS.baseTime*timeScale/initPTS.timescale;for(var i=0;i<nbSamples;i++){var sample=inputSamples[i];sample.pts=normalizePts(sample.pts-initTime,nextAvcDts);sample.dts=normalizePts(sample.dts-initTime,nextAvcDts);if(sample.dts<inputSamples[i>0?i-1:i].dts){sortSamples=true;}}// sort video samples by DTS then PTS then demux id order
if(sortSamples){inputSamples.sort(function(a,b){var deltadts=a.dts-b.dts;var deltapts=a.pts-b.pts;return deltadts||deltapts;});}// Get first/last DTS
firstDTS=inputSamples[0].dts;lastDTS=inputSamples[inputSamples.length-1].dts;// Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
// set this constant duration as being the avg delta between consecutive DTS.
var inputDuration=lastDTS-firstDTS;var averageSampleDuration=inputDuration?Math.round(inputDuration/(nbSamples-1)):mp4SampleDuration||track.inputTimeScale/30;// if fragment are contiguous, detect hole/overlapping between fragments
if(contiguous){// check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
var delta=firstDTS-nextAvcDts;var foundHole=delta>averageSampleDuration;var foundOverlap=delta<-1;if(foundHole||foundOverlap){if(foundHole){logger.warn("AVC: ".concat(toMsFromMpegTsClock(delta,true)," ms (").concat(delta,"dts) hole between fragments detected at ").concat(timeOffset.toFixed(3)));}else {logger.warn("AVC: ".concat(toMsFromMpegTsClock(-delta,true)," ms (").concat(delta,"dts) overlapping between fragments detected at ").concat(timeOffset.toFixed(3)));}if(!foundOverlap||nextAvcDts>=inputSamples[0].pts||chromeVersion){firstDTS=nextAvcDts;var firstPTS=inputSamples[0].pts-delta;if(foundHole){inputSamples[0].dts=firstDTS;inputSamples[0].pts=firstPTS;}else {for(var _i11=0;_i11<inputSamples.length;_i11++){if(inputSamples[_i11].dts>firstPTS){break;}inputSamples[_i11].dts-=delta;inputSamples[_i11].pts-=delta;}}logger.log("Video: Initial PTS/DTS adjusted: ".concat(toMsFromMpegTsClock(firstPTS,true),"/").concat(toMsFromMpegTsClock(firstDTS,true),", delta: ").concat(toMsFromMpegTsClock(delta,true)," ms"));}}}firstDTS=Math.max(0,firstDTS);var nbNalu=0;var naluLen=0;var dtsStep=firstDTS;for(var _i12=0;_i12<nbSamples;_i12++){// compute total/avc sample length and nb of NAL units
var _sample2=inputSamples[_i12];var units=_sample2.units;var nbUnits=units.length;var sampleLen=0;for(var j=0;j<nbUnits;j++){sampleLen+=units[j].data.length;}naluLen+=sampleLen;nbNalu+=nbUnits;_sample2.length=sampleLen;// ensure sample monotonic DTS
if(_sample2.dts<dtsStep){_sample2.dts=dtsStep;dtsStep+=averageSampleDuration/4|0||1;}else {dtsStep=_sample2.dts;}minPTS=Math.min(_sample2.pts,minPTS);maxPTS=Math.max(_sample2.pts,maxPTS);}lastDTS=inputSamples[nbSamples-1].dts;/* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */var mdatSize=naluLen+4*nbNalu+8;var mdat;try{mdat=new Uint8Array(mdatSize);}catch(err){this.observer.emit(Events.ERROR,Events.ERROR,{type:ErrorTypes.MUX_ERROR,details:ErrorDetails.REMUX_ALLOC_ERROR,fatal:false,error:err,bytes:mdatSize,reason:"fail allocating video mdat ".concat(mdatSize)});return;}var view=new DataView(mdat.buffer);view.setUint32(0,mdatSize);mdat.set(MP4.types.mdat,4);var stretchedLastFrame=false;var minDtsDelta=Number.POSITIVE_INFINITY;var minPtsDelta=Number.POSITIVE_INFINITY;var maxDtsDelta=Number.NEGATIVE_INFINITY;var maxPtsDelta=Number.NEGATIVE_INFINITY;for(var _i13=0;_i13<nbSamples;_i13++){var VideoSample=inputSamples[_i13];var VideoSampleUnits=VideoSample.units;var mp4SampleLength=0;// convert NALU bitstream to MP4 format (prepend NALU with size field)
for(var _j=0,_nbUnits=VideoSampleUnits.length;_j<_nbUnits;_j++){var unit=VideoSampleUnits[_j];var unitData=unit.data;var unitDataLen=unit.data.byteLength;view.setUint32(offset,unitDataLen);offset+=4;mdat.set(unitData,offset);offset+=unitDataLen;mp4SampleLength+=4+unitDataLen;}// expected sample duration is the Decoding Timestamp diff of consecutive samples
var ptsDelta=void 0;if(_i13<nbSamples-1){mp4SampleDuration=inputSamples[_i13+1].dts-VideoSample.dts;ptsDelta=inputSamples[_i13+1].pts-VideoSample.pts;}else {var config=this.config;var lastFrameDuration=_i13>0?VideoSample.dts-inputSamples[_i13-1].dts:averageSampleDuration;ptsDelta=_i13>0?VideoSample.pts-inputSamples[_i13-1].pts:averageSampleDuration;if(config.stretchShortVideoTrack&&this.nextAudioPts!==null){// In some cases, a segment's audio track duration may exceed the video track duration.
// Since we've already remuxed audio, and we know how long the audio track is, we look to
// see if the delta to the next segment is longer than maxBufferHole.
// If so, playback would potentially get stuck, so we artificially inflate
// the duration of the last frame to minimize any potential gap between segments.
var gapTolerance=Math.floor(config.maxBufferHole*timeScale);var deltaToFrameEnd=(audioTrackLength?minPTS+audioTrackLength*timeScale:this.nextAudioPts)-VideoSample.pts;if(deltaToFrameEnd>gapTolerance){// We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
// frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
mp4SampleDuration=deltaToFrameEnd-lastFrameDuration;if(mp4SampleDuration<0){mp4SampleDuration=lastFrameDuration;}else {stretchedLastFrame=true;}logger.log("[mp4-remuxer]: It is approximately ".concat(deltaToFrameEnd/90," ms to the next segment; using duration ").concat(mp4SampleDuration/90," ms for the last video frame."));}else {mp4SampleDuration=lastFrameDuration;}}else {mp4SampleDuration=lastFrameDuration;}}var compositionTimeOffset=Math.round(VideoSample.pts-VideoSample.dts);minDtsDelta=Math.min(minDtsDelta,mp4SampleDuration);maxDtsDelta=Math.max(maxDtsDelta,mp4SampleDuration);minPtsDelta=Math.min(minPtsDelta,ptsDelta);maxPtsDelta=Math.max(maxPtsDelta,ptsDelta);outputSamples.push(new Mp4Sample(VideoSample.key,mp4SampleDuration,mp4SampleLength,compositionTimeOffset));}if(outputSamples.length){if(chromeVersion){if(chromeVersion<70){// Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
// https://code.google.com/p/chromium/issues/detail?id=229412
var flags=outputSamples[0].flags;flags.dependsOn=2;flags.isNonSync=0;}}else if(safariWebkitVersion){// Fix for "CNN special report, with CC" in test-streams (Safari browser only)
// Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
if(maxPtsDelta-minPtsDelta<maxDtsDelta-minDtsDelta&&averageSampleDuration/maxDtsDelta<0.025&&outputSamples[0].cts===0){logger.warn('Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.');var dts=firstDTS;for(var _i14=0,len=outputSamples.length;_i14<len;_i14++){var nextDts=dts+outputSamples[_i14].duration;var _pts=dts+outputSamples[_i14].cts;if(_i14<len-1){var nextPts=nextDts+outputSamples[_i14+1].cts;outputSamples[_i14].duration=nextPts-_pts;}else {outputSamples[_i14].duration=_i14?outputSamples[_i14-1].duration:averageSampleDuration;}outputSamples[_i14].cts=0;dts=nextDts;}}}}// next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
mp4SampleDuration=stretchedLastFrame||!mp4SampleDuration?averageSampleDuration:mp4SampleDuration;this.nextAvcDts=nextAvcDts=lastDTS+mp4SampleDuration;this.videoSampleDuration=mp4SampleDuration;this.isVideoContiguous=true;var moof=MP4.moof(track.sequenceNumber++,firstDTS,_extends({},track,{samples:outputSamples}));var type='video';var data={data1:moof,data2:mdat,startPTS:minPTS/timeScale,endPTS:(maxPTS+mp4SampleDuration)/timeScale,startDTS:firstDTS/timeScale,endDTS:nextAvcDts/timeScale,type:type,hasAudio:false,hasVideo:true,nb:outputSamples.length,dropped:track.dropped};track.samples=[];track.dropped=0;return data;}},{key:"getSamplesPerFrame",value:function getSamplesPerFrame(track){switch(track.segmentCodec){case'mp3':return MPEG_AUDIO_SAMPLE_PER_FRAME;case'ac3':return AC3_SAMPLES_PER_FRAME;default:return AAC_SAMPLES_PER_FRAME;}}},{key:"remuxAudio",value:function remuxAudio(track,timeOffset,contiguous,accurateTimeOffset,videoTimeOffset){var inputTimeScale=track.inputTimeScale;var mp4timeScale=track.samplerate?track.samplerate:inputTimeScale;var scaleFactor=inputTimeScale/mp4timeScale;var mp4SampleDuration=this.getSamplesPerFrame(track);var inputSampleDuration=mp4SampleDuration*scaleFactor;var initPTS=this._initPTS;var rawMPEG=track.segmentCodec==='mp3'&&this.typeSupported.mpeg;var outputSamples=[];var alignedWithVideo=videoTimeOffset!==undefined;var inputSamples=track.samples;var offset=rawMPEG?0:8;var nextAudioPts=this.nextAudioPts||-1;// window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);
// for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
// for sake of clarity:
// consecutive fragments are frags with
//  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
//  - less than 20 audio frames distance
// contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
// this helps ensuring audio continuity
// and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
var timeOffsetMpegTS=timeOffset*inputTimeScale;var initTime=initPTS.baseTime*inputTimeScale/initPTS.timescale;this.isAudioContiguous=contiguous=contiguous||inputSamples.length&&nextAudioPts>0&&(accurateTimeOffset&&Math.abs(timeOffsetMpegTS-nextAudioPts)<9000||Math.abs(normalizePts(inputSamples[0].pts-initTime,timeOffsetMpegTS)-nextAudioPts)<20*inputSampleDuration);// compute normalized PTS
inputSamples.forEach(function(sample){sample.pts=normalizePts(sample.pts-initTime,timeOffsetMpegTS);});if(!contiguous||nextAudioPts<0){// filter out sample with negative PTS that are not playable anyway
// if we don't remove these negative samples, they will shift all audio samples forward.
// leading to audio overlap between current / next fragment
inputSamples=inputSamples.filter(function(sample){return sample.pts>=0;});// in case all samples have negative PTS, and have been filtered out, return now
if(!inputSamples.length){return;}if(videoTimeOffset===0){// Set the start to 0 to match video so that start gaps larger than inputSampleDuration are filled with silence
nextAudioPts=0;}else if(accurateTimeOffset&&!alignedWithVideo){// When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
nextAudioPts=Math.max(0,timeOffsetMpegTS);}else {// if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
nextAudioPts=inputSamples[0].pts;}}// If the audio track is missing samples, the frames seem to get "left-shifted" within the
// resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
// In an effort to prevent this from happening, we inject frames here where there are gaps.
// When possible, we inject a silent frame; when that's not possible, we duplicate the last
// frame.
if(track.segmentCodec==='aac'){var maxAudioFramesDrift=this.config.maxAudioFramesDrift;for(var i=0,nextPts=nextAudioPts;i<inputSamples.length;i++){// First, let's see how far off this frame is from where we expect it to be
var sample=inputSamples[i];var pts=sample.pts;var delta=pts-nextPts;var duration=Math.abs(1000*delta/inputTimeScale);// When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
if(delta<=-maxAudioFramesDrift*inputSampleDuration&&alignedWithVideo){if(i===0){logger.warn("Audio frame @ ".concat((pts/inputTimeScale).toFixed(3),"s overlaps nextAudioPts by ").concat(Math.round(1000*delta/inputTimeScale)," ms."));this.nextAudioPts=nextAudioPts=nextPts=pts;}}// eslint-disable-line brace-style
// Insert missing frames if:
// 1: We're more than maxAudioFramesDrift frame away
// 2: Not more than MAX_SILENT_FRAME_DURATION away
// 3: currentTime (aka nextPtsNorm) is not 0
// 4: remuxing with video (videoTimeOffset !== undefined)
else if(delta>=maxAudioFramesDrift*inputSampleDuration&&duration<MAX_SILENT_FRAME_DURATION&&alignedWithVideo){var missing=Math.round(delta/inputSampleDuration);// Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
// later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
nextPts=pts-missing*inputSampleDuration;if(nextPts<0){missing--;nextPts+=inputSampleDuration;}if(i===0){this.nextAudioPts=nextAudioPts=nextPts;}logger.warn("[mp4-remuxer]: Injecting ".concat(missing," audio frame @ ").concat((nextPts/inputTimeScale).toFixed(3),"s due to ").concat(Math.round(1000*delta/inputTimeScale)," ms gap."));for(var j=0;j<missing;j++){var newStamp=Math.max(nextPts,0);var fillFrame=AAC.getSilentFrame(track.manifestCodec||track.codec,track.channelCount);if(!fillFrame){logger.log('[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.');fillFrame=sample.unit.subarray();}inputSamples.splice(i,0,{unit:fillFrame,pts:newStamp});nextPts+=inputSampleDuration;i++;}}sample.pts=nextPts;nextPts+=inputSampleDuration;}}var firstPTS=null;var lastPTS=null;var mdat;var mdatSize=0;var sampleLength=inputSamples.length;while(sampleLength--){mdatSize+=inputSamples[sampleLength].unit.byteLength;}for(var _j2=0,_nbSamples=inputSamples.length;_j2<_nbSamples;_j2++){var audioSample=inputSamples[_j2];var unit=audioSample.unit;var _pts2=audioSample.pts;if(lastPTS!==null){// If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
// the previous sample
var prevSample=outputSamples[_j2-1];prevSample.duration=Math.round((_pts2-lastPTS)/scaleFactor);}else {if(contiguous&&track.segmentCodec==='aac'){// set PTS/DTS to expected PTS/DTS
_pts2=nextAudioPts;}// remember first PTS of our audioSamples
firstPTS=_pts2;if(mdatSize>0){/* concatenate the audio data and construct the mdat in place
            (need 8 more bytes to fill length and mdat type) */mdatSize+=offset;try{mdat=new Uint8Array(mdatSize);}catch(err){this.observer.emit(Events.ERROR,Events.ERROR,{type:ErrorTypes.MUX_ERROR,details:ErrorDetails.REMUX_ALLOC_ERROR,fatal:false,error:err,bytes:mdatSize,reason:"fail allocating audio mdat ".concat(mdatSize)});return;}if(!rawMPEG){var view=new DataView(mdat.buffer);view.setUint32(0,mdatSize);mdat.set(MP4.types.mdat,4);}}else {// no audio samples
return;}}mdat.set(unit,offset);var unitLen=unit.byteLength;offset+=unitLen;// Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
// In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
// becomes the PTS diff with the previous sample
outputSamples.push(new Mp4Sample(true,mp4SampleDuration,unitLen,0));lastPTS=_pts2;}// We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
var nbSamples=outputSamples.length;if(!nbSamples){return;}// The next audio sample PTS should be equal to last sample PTS + duration
var lastSample=outputSamples[outputSamples.length-1];this.nextAudioPts=nextAudioPts=lastPTS+scaleFactor*lastSample.duration;// Set the track samples from inputSamples to outputSamples before remuxing
var moof=rawMPEG?new Uint8Array(0):MP4.moof(track.sequenceNumber++,firstPTS/scaleFactor,_extends({},track,{samples:outputSamples}));// Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
track.samples=[];var start=firstPTS/inputTimeScale;var end=nextAudioPts/inputTimeScale;var type='audio';var audioData={data1:moof,data2:mdat,startPTS:start,endPTS:end,startDTS:start,endDTS:end,type:type,hasAudio:true,hasVideo:false,nb:nbSamples};this.isAudioContiguous=true;return audioData;}},{key:"remuxEmptyAudio",value:function remuxEmptyAudio(track,timeOffset,contiguous,videoData){var inputTimeScale=track.inputTimeScale;var mp4timeScale=track.samplerate?track.samplerate:inputTimeScale;var scaleFactor=inputTimeScale/mp4timeScale;var nextAudioPts=this.nextAudioPts;// sync with video's timestamp
var initDTS=this._initDTS;var init90kHz=initDTS.baseTime*90000/initDTS.timescale;var startDTS=(nextAudioPts!==null?nextAudioPts:videoData.startDTS*inputTimeScale)+init90kHz;var endDTS=videoData.endDTS*inputTimeScale+init90kHz;// one sample's duration value
var frameDuration=scaleFactor*AAC_SAMPLES_PER_FRAME;// samples count of this segment's duration
var nbSamples=Math.ceil((endDTS-startDTS)/frameDuration);// silent frame
var silentFrame=AAC.getSilentFrame(track.manifestCodec||track.codec,track.channelCount);logger.warn('[mp4-remuxer]: remux empty Audio');// Can't remux if we can't generate a silent frame...
if(!silentFrame){logger.trace('[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec');return;}var samples=[];for(var i=0;i<nbSamples;i++){var stamp=startDTS+i*frameDuration;samples.push({unit:silentFrame,pts:stamp,dts:stamp});}track.samples=samples;return this.remuxAudio(track,timeOffset,contiguous,false);}}]);return MP4Remuxer;}();function normalizePts(value,reference){var offset;if(reference===null){return value;}if(reference<value){// - 2^33
offset=-8589934592;}else {// + 2^33
offset=8589934592;}/* PTS is 33bit (from 0 to 2^33 -1)
    if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
    PTS looping occured. fill the gap */while(Math.abs(value-reference)>4294967296){value+=offset;}return value;}function findKeyframeIndex(samples){for(var i=0;i<samples.length;i++){if(samples[i].key){return i;}}return -1;}function flushTextTrackMetadataCueSamples(track,timeOffset,initPTS,initDTS){var length=track.samples.length;if(!length){return;}var inputTimeScale=track.inputTimeScale;for(var index=0;index<length;index++){var sample=track.samples[index];// setting id3 pts, dts to relative time
// using this._initPTS and this._initDTS to calculate relative time
sample.pts=normalizePts(sample.pts-initPTS.baseTime*inputTimeScale/initPTS.timescale,timeOffset*inputTimeScale)/inputTimeScale;sample.dts=normalizePts(sample.dts-initDTS.baseTime*inputTimeScale/initDTS.timescale,timeOffset*inputTimeScale)/inputTimeScale;}var samples=track.samples;track.samples=[];return {samples:samples};}function flushTextTrackUserdataCueSamples(track,timeOffset,initPTS){var length=track.samples.length;if(!length){return;}var inputTimeScale=track.inputTimeScale;for(var index=0;index<length;index++){var sample=track.samples[index];// setting text pts, dts to relative time
// using this._initPTS and this._initDTS to calculate relative time
sample.pts=normalizePts(sample.pts-initPTS.baseTime*inputTimeScale/initPTS.timescale,timeOffset*inputTimeScale)/inputTimeScale;}track.samples.sort(function(a,b){return a.pts-b.pts;});var samples=track.samples;track.samples=[];return {samples:samples};}var Mp4Sample=/*#__PURE__*/_createClass(function Mp4Sample(isKeyframe,duration,size,cts){_classCallCheck(this,Mp4Sample);this.size=void 0;this.duration=void 0;this.cts=void 0;this.flags=void 0;this.duration=duration;this.size=size;this.cts=cts;this.flags={isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,dependsOn:isKeyframe?2:1,isNonSync:isKeyframe?0:1};});var PassThroughRemuxer=/*#__PURE__*/function(){function PassThroughRemuxer(){_classCallCheck(this,PassThroughRemuxer);this.emitInitSegment=false;this.audioCodec=void 0;this.videoCodec=void 0;this.initData=void 0;this.initPTS=null;this.initTracks=void 0;this.lastEndTime=null;}_createClass(PassThroughRemuxer,[{key:"destroy",value:function destroy(){}},{key:"resetTimeStamp",value:function resetTimeStamp(defaultInitPTS){this.initPTS=defaultInitPTS;this.lastEndTime=null;}},{key:"resetNextTimestamp",value:function resetNextTimestamp(){this.lastEndTime=null;}},{key:"resetInitSegment",value:function resetInitSegment(initSegment,audioCodec,videoCodec,decryptdata){this.audioCodec=audioCodec;this.videoCodec=videoCodec;this.generateInitSegment(patchEncyptionData(initSegment,decryptdata));this.emitInitSegment=true;}},{key:"generateInitSegment",value:function generateInitSegment(initSegment){var audioCodec=this.audioCodec,videoCodec=this.videoCodec;if(!(initSegment!=null&&initSegment.byteLength)){this.initTracks=undefined;this.initData=undefined;return;}var initData=this.initData=parseInitSegment(initSegment);// Get codec from initSegment or fallback to default
if(initData.audio){audioCodec=getParsedTrackCodec(initData.audio,ElementaryStreamTypes.AUDIO);}if(initData.video){videoCodec=getParsedTrackCodec(initData.video,ElementaryStreamTypes.VIDEO);}var tracks={};if(initData.audio&&initData.video){tracks.audiovideo={container:'video/mp4',codec:audioCodec+','+videoCodec,initSegment:initSegment,id:'main'};}else if(initData.audio){tracks.audio={container:'audio/mp4',codec:audioCodec,initSegment:initSegment,id:'audio'};}else if(initData.video){tracks.video={container:'video/mp4',codec:videoCodec,initSegment:initSegment,id:'main'};}else {logger.warn('[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.');}this.initTracks=tracks;}},{key:"remux",value:function remux(audioTrack,videoTrack,id3Track,textTrack,timeOffset,accurateTimeOffset){var _initData,_initData2;var initPTS=this.initPTS,lastEndTime=this.lastEndTime;var result={audio:undefined,video:undefined,text:textTrack,id3:id3Track,initSegment:undefined};// If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
// lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
// the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
if(!isFiniteNumber(lastEndTime)){lastEndTime=this.lastEndTime=timeOffset||0;}// The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
// audio or video (or both); adding it to video was an arbitrary choice.
var data=videoTrack.samples;if(!(data!=null&&data.length)){return result;}var initSegment={initPTS:undefined,timescale:1};var initData=this.initData;if(!((_initData=initData)!=null&&_initData.length)){this.generateInitSegment(data);initData=this.initData;}if(!((_initData2=initData)!=null&&_initData2.length)){// We can't remux if the initSegment could not be generated
logger.warn('[passthrough-remuxer.ts]: Failed to generate initSegment.');return result;}if(this.emitInitSegment){initSegment.tracks=this.initTracks;this.emitInitSegment=false;}var duration=getDuration(data,initData);var startDTS=getStartDTS(initData,data);var decodeTime=startDTS===null?timeOffset:startDTS;if(isInvalidInitPts(initPTS,decodeTime,timeOffset,duration)||initSegment.timescale!==initPTS.timescale&&accurateTimeOffset){initSegment.initPTS=decodeTime-timeOffset;if(initPTS&&initPTS.timescale===1){logger.warn("Adjusting initPTS by ".concat(initSegment.initPTS-initPTS.baseTime));}this.initPTS=initPTS={baseTime:initSegment.initPTS,timescale:1};}var startTime=audioTrack?decodeTime-initPTS.baseTime/initPTS.timescale:lastEndTime;var endTime=startTime+duration;offsetStartDTS(initData,data,initPTS.baseTime/initPTS.timescale);if(duration>0){this.lastEndTime=endTime;}else {logger.warn('Duration parsed from mp4 should be greater than zero');this.resetNextTimestamp();}var hasAudio=!!initData.audio;var hasVideo=!!initData.video;var type='';if(hasAudio){type+='audio';}if(hasVideo){type+='video';}var track={data1:data,startPTS:startTime,startDTS:startTime,endPTS:endTime,endDTS:endTime,type:type,hasAudio:hasAudio,hasVideo:hasVideo,nb:1,dropped:0};result.audio=track.type==='audio'?track:undefined;result.video=track.type!=='audio'?track:undefined;result.initSegment=initSegment;result.id3=flushTextTrackMetadataCueSamples(id3Track,timeOffset,initPTS,initPTS);if(textTrack.samples.length){result.text=flushTextTrackUserdataCueSamples(textTrack,timeOffset,initPTS);}return result;}}]);return PassThroughRemuxer;}();function isInvalidInitPts(initPTS,startDTS,timeOffset,duration){if(initPTS===null){return true;}// InitPTS is invalid when distance from program would be more than segment duration or a minimum of one second
var minDuration=Math.max(duration,1);var startTime=startDTS-initPTS.baseTime/initPTS.timescale;return Math.abs(startTime-timeOffset)>minDuration;}function getParsedTrackCodec(track,type){var parsedCodec=track==null?void 0:track.codec;if(parsedCodec&&parsedCodec.length>4){return parsedCodec;}if(type===ElementaryStreamTypes.AUDIO){if(parsedCodec==='ec-3'||parsedCodec==='ac-3'||parsedCodec==='alac'){return parsedCodec;}if(parsedCodec==='fLaC'||parsedCodec==='Opus'){// Opting not to get `preferManagedMediaSource` from player config for isSupported() check for simplicity
var preferManagedMediaSource=false;return getCodecCompatibleName(parsedCodec,preferManagedMediaSource);}var result='mp4a.40.5';logger.info("Parsed audio codec \"".concat(parsedCodec,"\" or audio object type not handled. Using \"").concat(result,"\""));return result;}// Provide defaults based on codec type
// This allows for some playback of some fmp4 playlists without CODECS defined in manifest
logger.warn("Unhandled video codec \"".concat(parsedCodec,"\""));if(parsedCodec==='hvc1'||parsedCodec==='hev1'){return 'hvc1.1.6.L120.90';}if(parsedCodec==='av01'){return 'av01.0.04M.08';}return 'avc1.42e01e';}var now$1;// performance.now() not available on WebWorker, at least on Safari Desktop
try{now$1=self.performance.now.bind(self.performance);}catch(err){logger.debug('Unable to use Performance API on this environment');now$1=optionalSelf==null?void 0:optionalSelf.Date.now;}var muxConfig=[{demux:MP4Demuxer,remux:PassThroughRemuxer},{demux:TSDemuxer,remux:MP4Remuxer},{demux:AACDemuxer,remux:MP4Remuxer},{demux:MP3Demuxer,remux:MP4Remuxer}];{muxConfig.splice(2,0,{demux:AC3Demuxer,remux:MP4Remuxer});}var Transmuxer=/*#__PURE__*/function(){function Transmuxer(observer,typeSupported,config,vendor,id){_classCallCheck(this,Transmuxer);this.async=false;this.observer=void 0;this.typeSupported=void 0;this.config=void 0;this.vendor=void 0;this.id=void 0;this.demuxer=void 0;this.remuxer=void 0;this.decrypter=void 0;this.probe=void 0;this.decryptionPromise=null;this.transmuxConfig=void 0;this.currentTransmuxState=void 0;this.observer=observer;this.typeSupported=typeSupported;this.config=config;this.vendor=vendor;this.id=id;}_createClass(Transmuxer,[{key:"configure",value:function configure(transmuxConfig){this.transmuxConfig=transmuxConfig;if(this.decrypter){this.decrypter.reset();}}},{key:"push",value:function push(data,decryptdata,chunkMeta,state){var _this31=this;var stats=chunkMeta.transmuxing;stats.executeStart=now$1();var uintData=new Uint8Array(data);var currentTransmuxState=this.currentTransmuxState,transmuxConfig=this.transmuxConfig;if(state){this.currentTransmuxState=state;}var _ref13=state||currentTransmuxState,contiguous=_ref13.contiguous,discontinuity=_ref13.discontinuity,trackSwitch=_ref13.trackSwitch,accurateTimeOffset=_ref13.accurateTimeOffset,timeOffset=_ref13.timeOffset,initSegmentChange=_ref13.initSegmentChange;var audioCodec=transmuxConfig.audioCodec,videoCodec=transmuxConfig.videoCodec,defaultInitPts=transmuxConfig.defaultInitPts,duration=transmuxConfig.duration,initSegmentData=transmuxConfig.initSegmentData;var keyData=getEncryptionType(uintData,decryptdata);if(keyData&&keyData.method==='AES-128'){var decrypter=this.getDecrypter();// Software decryption is synchronous; webCrypto is not
if(decrypter.isSync()){// Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
// data is handled in the flush() call
var decryptedData=decrypter.softwareDecrypt(uintData,keyData.key.buffer,keyData.iv.buffer);// For Low-Latency HLS Parts, decrypt in place, since part parsing is expected on push progress
var loadingParts=chunkMeta.part>-1;if(loadingParts){decryptedData=decrypter.flush();}if(!decryptedData){stats.executeEnd=now$1();return emptyResult(chunkMeta);}uintData=new Uint8Array(decryptedData);}else {this.decryptionPromise=decrypter.webCryptoDecrypt(uintData,keyData.key.buffer,keyData.iv.buffer).then(function(decryptedData){// Calling push here is important; if flush() is called while this is still resolving, this ensures that
// the decrypted data has been transmuxed
var result=_this31.push(decryptedData,null,chunkMeta);_this31.decryptionPromise=null;return result;});return this.decryptionPromise;}}var resetMuxers=this.needsProbing(discontinuity,trackSwitch);if(resetMuxers){var error=this.configureTransmuxer(uintData);if(error){logger.warn("[transmuxer] ".concat(error.message));this.observer.emit(Events.ERROR,Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.FRAG_PARSING_ERROR,fatal:false,error:error,reason:error.message});stats.executeEnd=now$1();return emptyResult(chunkMeta);}}if(discontinuity||trackSwitch||initSegmentChange||resetMuxers){this.resetInitSegment(initSegmentData,audioCodec,videoCodec,duration,decryptdata);}if(discontinuity||initSegmentChange||resetMuxers){this.resetInitialTimestamp(defaultInitPts);}if(!contiguous){this.resetContiguity();}var result=this.transmux(uintData,keyData,timeOffset,accurateTimeOffset,chunkMeta);var currentState=this.currentTransmuxState;currentState.contiguous=true;currentState.discontinuity=false;currentState.trackSwitch=false;stats.executeEnd=now$1();return result;}// Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
},{key:"flush",value:function flush(chunkMeta){var _this32=this;var stats=chunkMeta.transmuxing;stats.executeStart=now$1();var decrypter=this.decrypter,currentTransmuxState=this.currentTransmuxState,decryptionPromise=this.decryptionPromise;if(decryptionPromise){// Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
// only flushing is required for async decryption
return decryptionPromise.then(function(){return _this32.flush(chunkMeta);});}var transmuxResults=[];var timeOffset=currentTransmuxState.timeOffset;if(decrypter){// The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
// This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
// or for progressive downloads with small segments)
var decryptedData=decrypter.flush();if(decryptedData){// Push always returns a TransmuxerResult if decryptdata is null
transmuxResults.push(this.push(decryptedData,null,chunkMeta));}}var demuxer=this.demuxer,remuxer=this.remuxer;if(!demuxer||!remuxer){// If probing failed, then Hls.js has been given content its not able to handle
stats.executeEnd=now$1();return [emptyResult(chunkMeta)];}var demuxResultOrPromise=demuxer.flush(timeOffset);if(isPromise(demuxResultOrPromise)){// Decrypt final SAMPLE-AES samples
return demuxResultOrPromise.then(function(demuxResult){_this32.flushRemux(transmuxResults,demuxResult,chunkMeta);return transmuxResults;});}this.flushRemux(transmuxResults,demuxResultOrPromise,chunkMeta);return transmuxResults;}},{key:"flushRemux",value:function flushRemux(transmuxResults,demuxResult,chunkMeta){var audioTrack=demuxResult.audioTrack,videoTrack=demuxResult.videoTrack,id3Track=demuxResult.id3Track,textTrack=demuxResult.textTrack;var _this$currentTransmux=this.currentTransmuxState,accurateTimeOffset=_this$currentTransmux.accurateTimeOffset,timeOffset=_this$currentTransmux.timeOffset;logger.log("[transmuxer.ts]: Flushed fragment ".concat(chunkMeta.sn).concat(chunkMeta.part>-1?' p: '+chunkMeta.part:''," of level ").concat(chunkMeta.level));var remuxResult=this.remuxer.remux(audioTrack,videoTrack,id3Track,textTrack,timeOffset,accurateTimeOffset,true,this.id);transmuxResults.push({remuxResult:remuxResult,chunkMeta:chunkMeta});chunkMeta.transmuxing.executeEnd=now$1();}},{key:"resetInitialTimestamp",value:function resetInitialTimestamp(defaultInitPts){var demuxer=this.demuxer,remuxer=this.remuxer;if(!demuxer||!remuxer){return;}demuxer.resetTimeStamp(defaultInitPts);remuxer.resetTimeStamp(defaultInitPts);}},{key:"resetContiguity",value:function resetContiguity(){var demuxer=this.demuxer,remuxer=this.remuxer;if(!demuxer||!remuxer){return;}demuxer.resetContiguity();remuxer.resetNextTimestamp();}},{key:"resetInitSegment",value:function resetInitSegment(initSegmentData,audioCodec,videoCodec,trackDuration,decryptdata){var demuxer=this.demuxer,remuxer=this.remuxer;if(!demuxer||!remuxer){return;}demuxer.resetInitSegment(initSegmentData,audioCodec,videoCodec,trackDuration);remuxer.resetInitSegment(initSegmentData,audioCodec,videoCodec,decryptdata);}},{key:"destroy",value:function destroy(){if(this.demuxer){this.demuxer.destroy();this.demuxer=undefined;}if(this.remuxer){this.remuxer.destroy();this.remuxer=undefined;}}},{key:"transmux",value:function transmux(data,keyData,timeOffset,accurateTimeOffset,chunkMeta){var result;if(keyData&&keyData.method==='SAMPLE-AES'){result=this.transmuxSampleAes(data,keyData,timeOffset,accurateTimeOffset,chunkMeta);}else {result=this.transmuxUnencrypted(data,timeOffset,accurateTimeOffset,chunkMeta);}return result;}},{key:"transmuxUnencrypted",value:function transmuxUnencrypted(data,timeOffset,accurateTimeOffset,chunkMeta){var _this$demuxer$demux=this.demuxer.demux(data,timeOffset,false,!this.config.progressive),audioTrack=_this$demuxer$demux.audioTrack,videoTrack=_this$demuxer$demux.videoTrack,id3Track=_this$demuxer$demux.id3Track,textTrack=_this$demuxer$demux.textTrack;var remuxResult=this.remuxer.remux(audioTrack,videoTrack,id3Track,textTrack,timeOffset,accurateTimeOffset,false,this.id);return {remuxResult:remuxResult,chunkMeta:chunkMeta};}},{key:"transmuxSampleAes",value:function transmuxSampleAes(data,decryptData,timeOffset,accurateTimeOffset,chunkMeta){var _this33=this;return this.demuxer.demuxSampleAes(data,decryptData,timeOffset).then(function(demuxResult){var remuxResult=_this33.remuxer.remux(demuxResult.audioTrack,demuxResult.videoTrack,demuxResult.id3Track,demuxResult.textTrack,timeOffset,accurateTimeOffset,false,_this33.id);return {remuxResult:remuxResult,chunkMeta:chunkMeta};});}},{key:"configureTransmuxer",value:function configureTransmuxer(data){var config=this.config,observer=this.observer,typeSupported=this.typeSupported,vendor=this.vendor;// probe for content type
var mux;for(var i=0,len=muxConfig.length;i<len;i++){var _muxConfig$i$demux;if((_muxConfig$i$demux=muxConfig[i].demux)!=null&&_muxConfig$i$demux.probe(data)){mux=muxConfig[i];break;}}if(!mux){return new Error('Failed to find demuxer by probing fragment data');}// so let's check that current remuxer and demuxer are still valid
var demuxer=this.demuxer;var remuxer=this.remuxer;var Remuxer=mux.remux;var Demuxer=mux.demux;if(!remuxer||!(remuxer instanceof Remuxer)){this.remuxer=new Remuxer(observer,config,typeSupported,vendor);}if(!demuxer||!(demuxer instanceof Demuxer)){this.demuxer=new Demuxer(observer,config,typeSupported);this.probe=Demuxer.probe;}}},{key:"needsProbing",value:function needsProbing(discontinuity,trackSwitch){// in case of continuity change, or track switch
// we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
return !this.demuxer||!this.remuxer||discontinuity||trackSwitch;}},{key:"getDecrypter",value:function getDecrypter(){var decrypter=this.decrypter;if(!decrypter){decrypter=this.decrypter=new Decrypter(this.config);}return decrypter;}}]);return Transmuxer;}();function getEncryptionType(data,decryptData){var encryptionType=null;if(data.byteLength>0&&(decryptData==null?void 0:decryptData.key)!=null&&decryptData.iv!==null&&decryptData.method!=null){encryptionType=decryptData;}return encryptionType;}var emptyResult=function emptyResult(chunkMeta){return {remuxResult:{},chunkMeta:chunkMeta};};function isPromise(p){return 'then'in p&&p.then instanceof Function;}var TransmuxConfig=/*#__PURE__*/_createClass(function TransmuxConfig(audioCodec,videoCodec,initSegmentData,duration,defaultInitPts){_classCallCheck(this,TransmuxConfig);this.audioCodec=void 0;this.videoCodec=void 0;this.initSegmentData=void 0;this.duration=void 0;this.defaultInitPts=void 0;this.audioCodec=audioCodec;this.videoCodec=videoCodec;this.initSegmentData=initSegmentData;this.duration=duration;this.defaultInitPts=defaultInitPts||null;});var TransmuxState=/*#__PURE__*/_createClass(function TransmuxState(discontinuity,contiguous,accurateTimeOffset,trackSwitch,timeOffset,initSegmentChange){_classCallCheck(this,TransmuxState);this.discontinuity=void 0;this.contiguous=void 0;this.accurateTimeOffset=void 0;this.trackSwitch=void 0;this.timeOffset=void 0;this.initSegmentChange=void 0;this.discontinuity=discontinuity;this.contiguous=contiguous;this.accurateTimeOffset=accurateTimeOffset;this.trackSwitch=trackSwitch;this.timeOffset=timeOffset;this.initSegmentChange=initSegmentChange;});var eventemitter3={exports:{}};(function(module){var has=Object.prototype.hasOwnProperty,prefix='~';/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */function Events(){}//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if(Object.create){Events.prototype=Object.create(null);//
// This hack is needed because the `__proto__` property is still inherited in
// some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
//
if(!new Events().__proto__)prefix=false;}/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */function EE(fn,context,once){this.fn=fn;this.context=context;this.once=once||false;}/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */function addListener(emitter,event,fn,context,once){if(typeof fn!=='function'){throw new TypeError('The listener must be a function');}var listener=new EE(fn,context||emitter,once),evt=prefix?prefix+event:event;if(!emitter._events[evt])emitter._events[evt]=listener,emitter._eventsCount++;else if(!emitter._events[evt].fn)emitter._events[evt].push(listener);else emitter._events[evt]=[emitter._events[evt],listener];return emitter;}/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */function clearEvent(emitter,evt){if(--emitter._eventsCount===0)emitter._events=new Events();else delete emitter._events[evt];}/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */function EventEmitter(){this._events=new Events();this._eventsCount=0;}/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */EventEmitter.prototype.eventNames=function eventNames(){var names=[],events,name;if(this._eventsCount===0)return names;for(name in events=this._events){if(has.call(events,name))names.push(prefix?name.slice(1):name);}if(Object.getOwnPropertySymbols){return names.concat(Object.getOwnPropertySymbols(events));}return names;};/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */EventEmitter.prototype.listeners=function listeners(event){var evt=prefix?prefix+event:event,handlers=this._events[evt];if(!handlers)return [];if(handlers.fn)return [handlers.fn];for(var i=0,l=handlers.length,ee=new Array(l);i<l;i++){ee[i]=handlers[i].fn;}return ee;};/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */EventEmitter.prototype.listenerCount=function listenerCount(event){var evt=prefix?prefix+event:event,listeners=this._events[evt];if(!listeners)return 0;if(listeners.fn)return 1;return listeners.length;};/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */EventEmitter.prototype.emit=function emit(event,a1,a2,a3,a4,a5){var evt=prefix?prefix+event:event;if(!this._events[evt])return false;var listeners=this._events[evt],len=arguments.length,args,i;if(listeners.fn){if(listeners.once)this.removeListener(event,listeners.fn,undefined,true);switch(len){case 1:return listeners.fn.call(listeners.context),true;case 2:return listeners.fn.call(listeners.context,a1),true;case 3:return listeners.fn.call(listeners.context,a1,a2),true;case 4:return listeners.fn.call(listeners.context,a1,a2,a3),true;case 5:return listeners.fn.call(listeners.context,a1,a2,a3,a4),true;case 6:return listeners.fn.call(listeners.context,a1,a2,a3,a4,a5),true;}for(i=1,args=new Array(len-1);i<len;i++){args[i-1]=arguments[i];}listeners.fn.apply(listeners.context,args);}else {var length=listeners.length,j;for(i=0;i<length;i++){if(listeners[i].once)this.removeListener(event,listeners[i].fn,undefined,true);switch(len){case 1:listeners[i].fn.call(listeners[i].context);break;case 2:listeners[i].fn.call(listeners[i].context,a1);break;case 3:listeners[i].fn.call(listeners[i].context,a1,a2);break;case 4:listeners[i].fn.call(listeners[i].context,a1,a2,a3);break;default:if(!args)for(j=1,args=new Array(len-1);j<len;j++){args[j-1]=arguments[j];}listeners[i].fn.apply(listeners[i].context,args);}}}return true;};/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */EventEmitter.prototype.on=function on(event,fn,context){return addListener(this,event,fn,context,false);};/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */EventEmitter.prototype.once=function once(event,fn,context){return addListener(this,event,fn,context,true);};/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */EventEmitter.prototype.removeListener=function removeListener(event,fn,context,once){var evt=prefix?prefix+event:event;if(!this._events[evt])return this;if(!fn){clearEvent(this,evt);return this;}var listeners=this._events[evt];if(listeners.fn){if(listeners.fn===fn&&(!once||listeners.once)&&(!context||listeners.context===context)){clearEvent(this,evt);}}else {for(var i=0,events=[],length=listeners.length;i<length;i++){if(listeners[i].fn!==fn||once&&!listeners[i].once||context&&listeners[i].context!==context){events.push(listeners[i]);}}//
// Reset the array, or remove it completely if we have no more listeners.
//
if(events.length)this._events[evt]=events.length===1?events[0]:events;else clearEvent(this,evt);}return this;};/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */EventEmitter.prototype.removeAllListeners=function removeAllListeners(event){var evt;if(event){evt=prefix?prefix+event:event;if(this._events[evt])clearEvent(this,evt);}else {this._events=new Events();this._eventsCount=0;}return this;};//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off=EventEmitter.prototype.removeListener;EventEmitter.prototype.addListener=EventEmitter.prototype.on;//
// Expose the prefix.
//
EventEmitter.prefixed=prefix;//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter=EventEmitter;//
// Expose the module.
//
{module.exports=EventEmitter;}})(eventemitter3);var eventemitter3Exports=eventemitter3.exports;var EventEmitter=/*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);var TransmuxerInterface=/*#__PURE__*/function(){function TransmuxerInterface(hls,id,onTransmuxComplete,onFlush){var _this34=this;_classCallCheck(this,TransmuxerInterface);this.error=null;this.hls=void 0;this.id=void 0;this.observer=void 0;this.frag=null;this.part=null;this.useWorker=void 0;this.workerContext=null;this.onwmsg=void 0;this.transmuxer=null;this.onTransmuxComplete=void 0;this.onFlush=void 0;var config=hls.config;this.hls=hls;this.id=id;this.useWorker=!!config.enableWorker;this.onTransmuxComplete=onTransmuxComplete;this.onFlush=onFlush;var forwardMessage=function forwardMessage(ev,data){data=data||{};data.frag=_this34.frag;data.id=_this34.id;if(ev===Events.ERROR){_this34.error=data.error;}_this34.hls.trigger(ev,data);};// forward events to main thread
this.observer=new EventEmitter();this.observer.on(Events.FRAG_DECRYPTED,forwardMessage);this.observer.on(Events.ERROR,forwardMessage);var MediaSource=_getMediaSource(config.preferManagedMediaSource)||{isTypeSupported:function isTypeSupported(){return false;}};var m2tsTypeSupported={mpeg:MediaSource.isTypeSupported('audio/mpeg'),mp3:MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),ac3:MediaSource.isTypeSupported('audio/mp4; codecs="ac-3"')};if(this.useWorker&&typeof Worker!=='undefined'){var canCreateWorker=config.workerPath||hasUMDWorker();if(canCreateWorker){try{if(config.workerPath){logger.log("loading Web Worker ".concat(config.workerPath," for \"").concat(id,"\""));this.workerContext=loadWorker(config.workerPath);}else {logger.log("injecting Web Worker for \"".concat(id,"\""));this.workerContext=injectWorker();}this.onwmsg=function(event){return _this34.onWorkerMessage(event);};var worker=this.workerContext.worker;worker.addEventListener('message',this.onwmsg);worker.onerror=function(event){var error=new Error("".concat(event.message,"  (").concat(event.filename,":").concat(event.lineno,")"));config.enableWorker=false;logger.warn("Error in \"".concat(id,"\" Web Worker, fallback to inline"));_this34.hls.trigger(Events.ERROR,{type:ErrorTypes.OTHER_ERROR,details:ErrorDetails.INTERNAL_EXCEPTION,fatal:false,event:'demuxerWorker',error:error});};worker.postMessage({cmd:'init',typeSupported:m2tsTypeSupported,vendor:'',id:id,config:JSON.stringify(config)});}catch(err){logger.warn("Error setting up \"".concat(id,"\" Web Worker, fallback to inline"),err);this.resetWorker();this.error=null;this.transmuxer=new Transmuxer(this.observer,m2tsTypeSupported,config,'',id);}return;}}this.transmuxer=new Transmuxer(this.observer,m2tsTypeSupported,config,'',id);}_createClass(TransmuxerInterface,[{key:"resetWorker",value:function resetWorker(){if(this.workerContext){var _this$workerContext2=this.workerContext,worker=_this$workerContext2.worker,objectURL=_this$workerContext2.objectURL;if(objectURL){// revoke the Object URL that was used to create transmuxer worker, so as not to leak it
self.URL.revokeObjectURL(objectURL);}worker.removeEventListener('message',this.onwmsg);worker.onerror=null;worker.terminate();this.workerContext=null;}}},{key:"destroy",value:function destroy(){if(this.workerContext){this.resetWorker();this.onwmsg=undefined;}else {var transmuxer=this.transmuxer;if(transmuxer){transmuxer.destroy();this.transmuxer=null;}}var observer=this.observer;if(observer){observer.removeAllListeners();}this.frag=null;// @ts-ignore
this.observer=null;// @ts-ignore
this.hls=null;}},{key:"push",value:function push(data,initSegmentData,audioCodec,videoCodec,frag,part,duration,accurateTimeOffset,chunkMeta,defaultInitPTS){var _this35=this;var _frag$initSegment,_lastFrag$initSegment;chunkMeta.transmuxing.start=self.performance.now();var transmuxer=this.transmuxer;var timeOffset=part?part.start:frag.start;// TODO: push "clear-lead" decrypt data for unencrypted fragments in streams with encrypted ones
var decryptdata=frag.decryptdata;var lastFrag=this.frag;var discontinuity=!(lastFrag&&frag.cc===lastFrag.cc);var trackSwitch=!(lastFrag&&chunkMeta.level===lastFrag.level);var snDiff=lastFrag?chunkMeta.sn-lastFrag.sn:-1;var partDiff=this.part?chunkMeta.part-this.part.index:-1;var progressive=snDiff===0&&chunkMeta.id>1&&chunkMeta.id===(lastFrag==null?void 0:lastFrag.stats.chunkCount);var contiguous=!trackSwitch&&(snDiff===1||snDiff===0&&(partDiff===1||progressive&&partDiff<=0));var now=self.performance.now();if(trackSwitch||snDiff||frag.stats.parsing.start===0){frag.stats.parsing.start=now;}if(part&&(partDiff||!contiguous)){part.stats.parsing.start=now;}var initSegmentChange=!(lastFrag&&((_frag$initSegment=frag.initSegment)==null?void 0:_frag$initSegment.url)===((_lastFrag$initSegment=lastFrag.initSegment)==null?void 0:_lastFrag$initSegment.url));var state=new TransmuxState(discontinuity,contiguous,accurateTimeOffset,trackSwitch,timeOffset,initSegmentChange);if(!contiguous||discontinuity||initSegmentChange){logger.log("[transmuxer-interface, ".concat(frag.type,"]: Starting new transmux session for sn: ").concat(chunkMeta.sn," p: ").concat(chunkMeta.part," level: ").concat(chunkMeta.level," id: ").concat(chunkMeta.id,"\n        discontinuity: ").concat(discontinuity,"\n        trackSwitch: ").concat(trackSwitch,"\n        contiguous: ").concat(contiguous,"\n        accurateTimeOffset: ").concat(accurateTimeOffset,"\n        timeOffset: ").concat(timeOffset,"\n        initSegmentChange: ").concat(initSegmentChange));var config=new TransmuxConfig(audioCodec,videoCodec,initSegmentData,duration,defaultInitPTS);this.configureTransmuxer(config);}this.frag=frag;this.part=part;// Frags with sn of 'initSegment' are not transmuxed
if(this.workerContext){// post fragment payload as transferable objects for ArrayBuffer (no copy)
this.workerContext.worker.postMessage({cmd:'demux',data:data,decryptdata:decryptdata,chunkMeta:chunkMeta,state:state},data instanceof ArrayBuffer?[data]:[]);}else if(transmuxer){var transmuxResult=transmuxer.push(data,decryptdata,chunkMeta,state);if(isPromise(transmuxResult)){transmuxer.async=true;transmuxResult.then(function(data){_this35.handleTransmuxComplete(data);})["catch"](function(error){_this35.transmuxerError(error,chunkMeta,'transmuxer-interface push error');});}else {transmuxer.async=false;this.handleTransmuxComplete(transmuxResult);}}}},{key:"flush",value:function flush(chunkMeta){var _this36=this;chunkMeta.transmuxing.start=self.performance.now();var transmuxer=this.transmuxer;if(this.workerContext){this.workerContext.worker.postMessage({cmd:'flush',chunkMeta:chunkMeta});}else if(transmuxer){var transmuxResult=transmuxer.flush(chunkMeta);var asyncFlush=isPromise(transmuxResult);if(asyncFlush||transmuxer.async){if(!isPromise(transmuxResult)){transmuxResult=Promise.resolve(transmuxResult);}transmuxResult.then(function(data){_this36.handleFlushResult(data,chunkMeta);})["catch"](function(error){_this36.transmuxerError(error,chunkMeta,'transmuxer-interface flush error');});}else {this.handleFlushResult(transmuxResult,chunkMeta);}}}},{key:"transmuxerError",value:function transmuxerError(error,chunkMeta,reason){if(!this.hls){return;}this.error=error;this.hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.FRAG_PARSING_ERROR,chunkMeta:chunkMeta,frag:this.frag||undefined,fatal:false,error:error,err:error,reason:reason});}},{key:"handleFlushResult",value:function handleFlushResult(results,chunkMeta){var _this37=this;results.forEach(function(result){_this37.handleTransmuxComplete(result);});this.onFlush(chunkMeta);}},{key:"onWorkerMessage",value:function onWorkerMessage(event){var data=event.data;if(!(data!=null&&data.event)){logger.warn("worker message received with no ".concat(data?'event name':'data'));return;}var hls=this.hls;if(!this.hls){return;}switch(data.event){case'init':{var _this$workerContext;var objectURL=(_this$workerContext=this.workerContext)==null?void 0:_this$workerContext.objectURL;if(objectURL){// revoke the Object URL that was used to create transmuxer worker, so as not to leak it
self.URL.revokeObjectURL(objectURL);}break;}case'transmuxComplete':{this.handleTransmuxComplete(data.data);break;}case'flush':{this.onFlush(data.data);break;}// pass logs from the worker thread to the main logger
case'workerLog':if(logger[data.data.logType]){logger[data.data.logType](data.data.message);}break;default:{data.data=data.data||{};data.data.frag=this.frag;data.data.id=this.id;hls.trigger(data.event,data.data);break;}}}},{key:"configureTransmuxer",value:function configureTransmuxer(config){var transmuxer=this.transmuxer;if(this.workerContext){this.workerContext.worker.postMessage({cmd:'configure',config:config});}else if(transmuxer){transmuxer.configure(config);}}},{key:"handleTransmuxComplete",value:function handleTransmuxComplete(result){result.chunkMeta.transmuxing.end=self.performance.now();this.onTransmuxComplete(result);}}]);return TransmuxerInterface;}();function subtitleOptionsIdentical(trackList1,trackList2){if(trackList1.length!==trackList2.length){return false;}for(var i=0;i<trackList1.length;i++){if(!mediaAttributesIdentical(trackList1[i].attrs,trackList2[i].attrs)){return false;}}return true;}function mediaAttributesIdentical(attrs1,attrs2,customAttributes){// Media options with the same rendition ID must be bit identical
var stableRenditionId=attrs1['STABLE-RENDITION-ID'];if(stableRenditionId&&!customAttributes){return stableRenditionId===attrs2['STABLE-RENDITION-ID'];}// When rendition ID is not present, compare attributes
return !(customAttributes||['LANGUAGE','NAME','CHARACTERISTICS','AUTOSELECT','DEFAULT','FORCED','ASSOC-LANGUAGE']).some(function(subtitleAttribute){return attrs1[subtitleAttribute]!==attrs2[subtitleAttribute];});}function subtitleTrackMatchesTextTrack(subtitleTrack,textTrack){return textTrack.label.toLowerCase()===subtitleTrack.name.toLowerCase()&&(!textTrack.language||textTrack.language.toLowerCase()===(subtitleTrack.lang||'').toLowerCase());}var TICK_INTERVAL$2=100;// how often to tick in ms
var AudioStreamController=/*#__PURE__*/function(_BaseStreamController){_inherits(AudioStreamController,_BaseStreamController);var _super9=_createSuper(AudioStreamController);function AudioStreamController(hls,fragmentTracker,keyLoader){var _this38;_classCallCheck(this,AudioStreamController);_this38=_super9.call(this,hls,fragmentTracker,keyLoader,'[audio-stream-controller]',PlaylistLevelType.AUDIO);_this38.videoBuffer=null;_this38.videoTrackCC=-1;_this38.waitingVideoCC=-1;_this38.bufferedTrack=null;_this38.switchingTrack=null;_this38.trackId=-1;_this38.waitingData=null;_this38.mainDetails=null;_this38.flushing=false;_this38.bufferFlushed=false;_this38.cachedTrackLoadedData=null;_this38._registerListeners();return _this38;}_createClass(AudioStreamController,[{key:"onHandlerDestroying",value:function onHandlerDestroying(){this._unregisterListeners();_get(_getPrototypeOf(AudioStreamController.prototype),"onHandlerDestroying",this).call(this);this.mainDetails=null;this.bufferedTrack=null;this.switchingTrack=null;}},{key:"_registerListeners",value:function _registerListeners(){var hls=this.hls;hls.on(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.on(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.on(Events.AUDIO_TRACKS_UPDATED,this.onAudioTracksUpdated,this);hls.on(Events.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this);hls.on(Events.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this);hls.on(Events.ERROR,this.onError,this);hls.on(Events.BUFFER_RESET,this.onBufferReset,this);hls.on(Events.BUFFER_CREATED,this.onBufferCreated,this);hls.on(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);hls.on(Events.BUFFER_FLUSHED,this.onBufferFlushed,this);hls.on(Events.INIT_PTS_FOUND,this.onInitPtsFound,this);hls.on(Events.FRAG_BUFFERED,this.onFragBuffered,this);}},{key:"_unregisterListeners",value:function _unregisterListeners(){var hls=this.hls;hls.off(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.off(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.off(Events.AUDIO_TRACKS_UPDATED,this.onAudioTracksUpdated,this);hls.off(Events.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this);hls.off(Events.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this);hls.off(Events.ERROR,this.onError,this);hls.off(Events.BUFFER_RESET,this.onBufferReset,this);hls.off(Events.BUFFER_CREATED,this.onBufferCreated,this);hls.off(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);hls.off(Events.BUFFER_FLUSHED,this.onBufferFlushed,this);hls.off(Events.INIT_PTS_FOUND,this.onInitPtsFound,this);hls.off(Events.FRAG_BUFFERED,this.onFragBuffered,this);}// INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
},{key:"onInitPtsFound",value:function onInitPtsFound(event,_ref14){var frag=_ref14.frag,id=_ref14.id,initPTS=_ref14.initPTS,timescale=_ref14.timescale;// Always update the new INIT PTS
// Can change due level switch
if(id==='main'){var cc=frag.cc;this.initPTS[frag.cc]={baseTime:initPTS,timescale:timescale};this.log("InitPTS for cc: ".concat(cc," found from main: ").concat(initPTS));this.videoTrackCC=cc;// If we are waiting, tick immediately to unblock audio fragment transmuxing
if(this.state===State.WAITING_INIT_PTS){this.tick();}}}},{key:"startLoad",value:function startLoad(startPosition){if(!this.levels){this.startPosition=startPosition;this.state=State.STOPPED;return;}var lastCurrentTime=this.lastCurrentTime;this.stopLoad();this.setInterval(TICK_INTERVAL$2);if(lastCurrentTime>0&&startPosition===-1){this.log("Override startPosition with lastCurrentTime @".concat(lastCurrentTime.toFixed(3)));startPosition=lastCurrentTime;this.state=State.IDLE;}else {this.loadedmetadata=false;this.state=State.WAITING_TRACK;}this.nextLoadPosition=this.startPosition=this.lastCurrentTime=startPosition;this.tick();}},{key:"doTick",value:function doTick(){switch(this.state){case State.IDLE:this.doTickIdle();break;case State.WAITING_TRACK:{var _levels$trackId;var levels=this.levels,trackId=this.trackId;var details=levels==null?void 0:(_levels$trackId=levels[trackId])==null?void 0:_levels$trackId.details;if(details){if(this.waitForCdnTuneIn(details)){break;}this.state=State.WAITING_INIT_PTS;}break;}case State.FRAG_LOADING_WAITING_RETRY:{var _this$media;var _now2=performance.now();var retryDate=this.retryDate;// if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
if(!retryDate||_now2>=retryDate||(_this$media=this.media)!=null&&_this$media.seeking){var _levels=this.levels,_trackId=this.trackId;this.log('RetryDate reached, switch back to IDLE state');this.resetStartWhenNotLoaded((_levels==null?void 0:_levels[_trackId])||null);this.state=State.IDLE;}break;}case State.WAITING_INIT_PTS:{// Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
var waitingData=this.waitingData;if(waitingData){var frag=waitingData.frag,part=waitingData.part,cache=waitingData.cache,complete=waitingData.complete;if(this.initPTS[frag.cc]!==undefined){this.waitingData=null;this.waitingVideoCC=-1;this.state=State.FRAG_LOADING;var payload=cache.flush();var data={frag:frag,part:part,payload:payload,networkDetails:null};this._handleFragmentLoadProgress(data);if(complete){_get(_getPrototypeOf(AudioStreamController.prototype),"_handleFragmentLoadComplete",this).call(this,data);}}else if(this.videoTrackCC!==this.waitingVideoCC){// Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
this.log("Waiting fragment cc (".concat(frag.cc,") cancelled because video is at cc ").concat(this.videoTrackCC));this.clearWaitingFragment();}else {// Drop waiting fragment if an earlier fragment is needed
var pos=this.getLoadPosition();var bufferInfo=BufferHelper.bufferInfo(this.mediaBuffer,pos,this.config.maxBufferHole);var waitingFragmentAtPosition=fragmentWithinToleranceTest(bufferInfo.end,this.config.maxFragLookUpTolerance,frag);if(waitingFragmentAtPosition<0){this.log("Waiting fragment cc (".concat(frag.cc,") @ ").concat(frag.start," cancelled because another fragment at ").concat(bufferInfo.end," is needed"));this.clearWaitingFragment();}}}else {this.state=State.IDLE;}}}this.onTickEnd();}},{key:"clearWaitingFragment",value:function clearWaitingFragment(){var waitingData=this.waitingData;if(waitingData){this.fragmentTracker.removeFragment(waitingData.frag);this.waitingData=null;this.waitingVideoCC=-1;this.state=State.IDLE;}}},{key:"resetLoadingState",value:function resetLoadingState(){this.clearWaitingFragment();_get(_getPrototypeOf(AudioStreamController.prototype),"resetLoadingState",this).call(this);}},{key:"onTickEnd",value:function onTickEnd(){var media=this.media;if(!(media!=null&&media.readyState)){// Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
return;}this.lastCurrentTime=media.currentTime;}},{key:"doTickIdle",value:function doTickIdle(){var hls=this.hls,levels=this.levels,media=this.media,trackId=this.trackId;var config=hls.config;// 1. if buffering is suspended
// 2. if video not attached AND
//    start fragment already requested OR start frag prefetch not enabled
// 3. if tracks or track not loaded and selected
// then exit loop
// => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
if(!this.buffering||!media&&(this.startFragRequested||!config.startFragPrefetch)||!(levels!=null&&levels[trackId])){return;}var levelInfo=levels[trackId];var trackDetails=levelInfo.details;if(!trackDetails||trackDetails.live&&this.levelLastLoaded!==levelInfo||this.waitForCdnTuneIn(trackDetails)){this.state=State.WAITING_TRACK;return;}var bufferable=this.mediaBuffer?this.mediaBuffer:this.media;if(this.bufferFlushed&&bufferable){this.bufferFlushed=false;this.afterBufferFlushed(bufferable,ElementaryStreamTypes.AUDIO,PlaylistLevelType.AUDIO);}var bufferInfo=this.getFwdBufferInfo(bufferable,PlaylistLevelType.AUDIO);if(bufferInfo===null){return;}var bufferedTrack=this.bufferedTrack,switchingTrack=this.switchingTrack;if(!switchingTrack&&this._streamEnded(bufferInfo,trackDetails)){hls.trigger(Events.BUFFER_EOS,{type:'audio'});this.state=State.ENDED;return;}var mainBufferInfo=this.getFwdBufferInfo(this.videoBuffer?this.videoBuffer:this.media,PlaylistLevelType.MAIN);var bufferLen=bufferInfo.len;var maxBufLen=this.getMaxBufferLength(mainBufferInfo==null?void 0:mainBufferInfo.len);var fragments=trackDetails.fragments;var start=fragments[0].start;var targetBufferTime=this.flushing?this.getLoadPosition():bufferInfo.end;if(switchingTrack&&media){var pos=this.getLoadPosition();// STABLE
if(bufferedTrack&&!mediaAttributesIdentical(switchingTrack.attrs,bufferedTrack.attrs)){targetBufferTime=pos;}// if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
if(trackDetails.PTSKnown&&pos<start){// if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
if(bufferInfo.end>start||bufferInfo.nextStart){this.log('Alt audio track ahead of main track, seek to start of alt audio track');media.currentTime=start+0.05;}}}// if buffer length is less than maxBufLen, or near the end, find a fragment to load
if(bufferLen>=maxBufLen&&!switchingTrack&&targetBufferTime<fragments[fragments.length-1].start){return;}var frag=this.getNextFragment(targetBufferTime,trackDetails);var atGap=false;// Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
if(frag&&this.isLoopLoading(frag,targetBufferTime)){atGap=!!frag.gap;frag=this.getNextFragmentLoopLoading(frag,trackDetails,bufferInfo,PlaylistLevelType.MAIN,maxBufLen);}if(!frag){this.bufferFlushed=true;return;}// Buffer audio up to one target duration ahead of main buffer
var atBufferSyncLimit=mainBufferInfo&&frag.start>mainBufferInfo.end+trackDetails.targetduration;if(atBufferSyncLimit||// Or wait for main buffer after buffing some audio
!(mainBufferInfo!=null&&mainBufferInfo.len)&&bufferInfo.len){// Check fragment-tracker for main fragments since GAP segments do not show up in bufferInfo
var mainFrag=this.getAppendedFrag(frag.start,PlaylistLevelType.MAIN);if(mainFrag===null){return;}// Bridge gaps in main buffer
atGap||(atGap=!!mainFrag.gap||!!atBufferSyncLimit&&mainBufferInfo.len===0);if(atBufferSyncLimit&&!atGap||atGap&&bufferInfo.nextStart&&bufferInfo.nextStart<mainFrag.end){return;}}this.loadFragment(frag,levelInfo,targetBufferTime);}},{key:"getMaxBufferLength",value:function getMaxBufferLength(mainBufferLength){var maxConfigBuffer=_get(_getPrototypeOf(AudioStreamController.prototype),"getMaxBufferLength",this).call(this);if(!mainBufferLength){return maxConfigBuffer;}return Math.min(Math.max(maxConfigBuffer,mainBufferLength),this.config.maxMaxBufferLength);}},{key:"onMediaDetaching",value:function onMediaDetaching(){this.videoBuffer=null;this.bufferFlushed=this.flushing=false;_get(_getPrototypeOf(AudioStreamController.prototype),"onMediaDetaching",this).call(this);}},{key:"onAudioTracksUpdated",value:function onAudioTracksUpdated(event,_ref15){var audioTracks=_ref15.audioTracks;// Reset tranxmuxer is essential for large context switches (Content Steering)
this.resetTransmuxer();this.levels=audioTracks.map(function(mediaPlaylist){return new Level(mediaPlaylist);});}},{key:"onAudioTrackSwitching",value:function onAudioTrackSwitching(event,data){// if any URL found on new audio track, it is an alternate audio track
var altAudio=!!data.url;this.trackId=data.id;var fragCurrent=this.fragCurrent;if(fragCurrent){fragCurrent.abortRequests();this.removeUnbufferedFrags(fragCurrent.start);}this.resetLoadingState();// destroy useless transmuxer when switching audio to main
if(!altAudio){this.resetTransmuxer();}else {// switching to audio track, start timer if not already started
this.setInterval(TICK_INTERVAL$2);}// should we switch tracks ?
if(altAudio){this.switchingTrack=data;// main audio track are handled by stream-controller, just do something if switching to alt audio track
this.state=State.IDLE;this.flushAudioIfNeeded(data);}else {this.switchingTrack=null;this.bufferedTrack=data;this.state=State.STOPPED;}this.tick();}},{key:"onManifestLoading",value:function onManifestLoading(){this.fragmentTracker.removeAllFragments();this.startPosition=this.lastCurrentTime=0;this.bufferFlushed=this.flushing=false;this.levels=this.mainDetails=this.waitingData=this.bufferedTrack=this.cachedTrackLoadedData=this.switchingTrack=null;this.startFragRequested=false;this.trackId=this.videoTrackCC=this.waitingVideoCC=-1;}},{key:"onLevelLoaded",value:function onLevelLoaded(event,data){this.mainDetails=data.details;if(this.cachedTrackLoadedData!==null){this.hls.trigger(Events.AUDIO_TRACK_LOADED,this.cachedTrackLoadedData);this.cachedTrackLoadedData=null;}}},{key:"onAudioTrackLoaded",value:function onAudioTrackLoaded(event,data){var _track$details;if(this.mainDetails==null){this.cachedTrackLoadedData=data;return;}var levels=this.levels;var newDetails=data.details,trackId=data.id;if(!levels){this.warn("Audio tracks were reset while loading level ".concat(trackId));return;}this.log("Audio track ".concat(trackId," loaded [").concat(newDetails.startSN,",").concat(newDetails.endSN,"]").concat(newDetails.lastPartSn?"[part-".concat(newDetails.lastPartSn,"-").concat(newDetails.lastPartIndex,"]"):'',",duration:").concat(newDetails.totalduration));var track=levels[trackId];var sliding=0;if(newDetails.live||(_track$details=track.details)!=null&&_track$details.live){this.checkLiveUpdate(newDetails);var mainDetails=this.mainDetails;if(newDetails.deltaUpdateFailed||!mainDetails){return;}if(!track.details&&newDetails.hasProgramDateTime&&mainDetails.hasProgramDateTime){// Make sure our audio rendition is aligned with the "main" rendition, using
// pdt as our reference times.
alignMediaPlaylistByPDT(newDetails,mainDetails);sliding=newDetails.fragments[0].start;}else {var _this$levelLastLoaded;sliding=this.alignPlaylists(newDetails,track.details,(_this$levelLastLoaded=this.levelLastLoaded)==null?void 0:_this$levelLastLoaded.details);}}track.details=newDetails;this.levelLastLoaded=track;// compute start position if we are aligned with the main playlist
if(!this.startFragRequested&&(this.mainDetails||!newDetails.live)){this.setStartPosition(this.mainDetails||newDetails,sliding);}// only switch back to IDLE state if we were waiting for track to start downloading a new fragment
if(this.state===State.WAITING_TRACK&&!this.waitForCdnTuneIn(newDetails)){this.state=State.IDLE;}// trigger handler right now
this.tick();}},{key:"_handleFragmentLoadProgress",value:function _handleFragmentLoadProgress(data){var _frag$initSegment;var frag=data.frag,part=data.part,payload=data.payload;var config=this.config,trackId=this.trackId,levels=this.levels;if(!levels){this.warn("Audio tracks were reset while fragment load was in progress. Fragment ".concat(frag.sn," of level ").concat(frag.level," will not be buffered"));return;}var track=levels[trackId];if(!track){this.warn('Audio track is undefined on fragment load progress');return;}var details=track.details;if(!details){this.warn('Audio track details undefined on fragment load progress');this.removeUnbufferedFrags(frag.start);return;}var audioCodec=config.defaultAudioCodec||track.audioCodec||'mp4a.40.2';var transmuxer=this.transmuxer;if(!transmuxer){transmuxer=this.transmuxer=new TransmuxerInterface(this.hls,PlaylistLevelType.AUDIO,this._handleTransmuxComplete.bind(this),this._handleTransmuxerFlush.bind(this));}// Check if we have video initPTS
// If not we need to wait for it
var initPTS=this.initPTS[frag.cc];var initSegmentData=(_frag$initSegment=frag.initSegment)==null?void 0:_frag$initSegment.data;if(initPTS!==undefined){// this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
// time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
var accurateTimeOffset=false;// details.PTSKnown || !details.live;
var partIndex=part?part.index:-1;var partial=partIndex!==-1;var chunkMeta=new ChunkMetadata(frag.level,frag.sn,frag.stats.chunkCount,payload.byteLength,partIndex,partial);transmuxer.push(payload,initSegmentData,audioCodec,'',frag,part,details.totalduration,accurateTimeOffset,chunkMeta,initPTS);}else {this.log("Unknown video PTS for cc ".concat(frag.cc,", waiting for video PTS before demuxing audio frag ").concat(frag.sn," of [").concat(details.startSN," ,").concat(details.endSN,"],track ").concat(trackId));var _this$waitingData=this.waitingData=this.waitingData||{frag:frag,part:part,cache:new ChunkCache(),complete:false},cache=_this$waitingData.cache;cache.push(new Uint8Array(payload));this.waitingVideoCC=this.videoTrackCC;this.state=State.WAITING_INIT_PTS;}}},{key:"_handleFragmentLoadComplete",value:function _handleFragmentLoadComplete(fragLoadedData){if(this.waitingData){this.waitingData.complete=true;return;}_get(_getPrototypeOf(AudioStreamController.prototype),"_handleFragmentLoadComplete",this).call(this,fragLoadedData);}},{key:"onBufferReset",value:function onBufferReset(/* event: Events.BUFFER_RESET */){// reset reference to sourcebuffers
this.mediaBuffer=this.videoBuffer=null;this.loadedmetadata=false;}},{key:"onBufferCreated",value:function onBufferCreated(event,data){var audioTrack=data.tracks.audio;if(audioTrack){this.mediaBuffer=audioTrack.buffer||null;}if(data.tracks.video){this.videoBuffer=data.tracks.video.buffer||null;}}},{key:"onFragBuffered",value:function onFragBuffered(event,data){var frag=data.frag,part=data.part;if(frag.type!==PlaylistLevelType.AUDIO){if(!this.loadedmetadata&&frag.type===PlaylistLevelType.MAIN){var bufferable=this.videoBuffer||this.media;if(bufferable){var bufferedTimeRanges=BufferHelper.getBuffered(bufferable);if(bufferedTimeRanges.length){this.loadedmetadata=true;}}}return;}if(this.fragContextChanged(frag)){// If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
// Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
this.warn("Fragment ".concat(frag.sn).concat(part?' p: '+part.index:''," of level ").concat(frag.level," finished buffering, but was aborted. state: ").concat(this.state,", audioSwitch: ").concat(this.switchingTrack?this.switchingTrack.name:'false'));return;}if(frag.sn!=='initSegment'){this.fragPrevious=frag;var track=this.switchingTrack;if(track){this.bufferedTrack=track;this.switchingTrack=null;this.hls.trigger(Events.AUDIO_TRACK_SWITCHED,_objectSpread2$2({},track));}}this.fragBufferedComplete(frag,part);}},{key:"onError",value:function onError(event,data){var _data$context;if(data.fatal){this.state=State.ERROR;return;}switch(data.details){case ErrorDetails.FRAG_GAP:case ErrorDetails.FRAG_PARSING_ERROR:case ErrorDetails.FRAG_DECRYPT_ERROR:case ErrorDetails.FRAG_LOAD_ERROR:case ErrorDetails.FRAG_LOAD_TIMEOUT:case ErrorDetails.KEY_LOAD_ERROR:case ErrorDetails.KEY_LOAD_TIMEOUT:this.onFragmentOrKeyLoadError(PlaylistLevelType.AUDIO,data);break;case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:case ErrorDetails.LEVEL_PARSING_ERROR:// in case of non fatal error while loading track, if not retrying to load track, switch back to IDLE
if(!data.levelRetry&&this.state===State.WAITING_TRACK&&((_data$context=data.context)==null?void 0:_data$context.type)===PlaylistContextType.AUDIO_TRACK){this.state=State.IDLE;}break;case ErrorDetails.BUFFER_APPEND_ERROR:case ErrorDetails.BUFFER_FULL_ERROR:if(!data.parent||data.parent!=='audio'){return;}if(data.details===ErrorDetails.BUFFER_APPEND_ERROR){this.resetLoadingState();return;}if(this.reduceLengthAndFlushBuffer(data)){this.bufferedTrack=null;_get(_getPrototypeOf(AudioStreamController.prototype),"flushMainBuffer",this).call(this,0,Number.POSITIVE_INFINITY,'audio');}break;case ErrorDetails.INTERNAL_EXCEPTION:this.recoverWorkerError(data);break;}}},{key:"onBufferFlushing",value:function onBufferFlushing(event,_ref16){var type=_ref16.type;if(type!==ElementaryStreamTypes.VIDEO){this.flushing=true;}}},{key:"onBufferFlushed",value:function onBufferFlushed(event,_ref17){var type=_ref17.type;if(type!==ElementaryStreamTypes.VIDEO){this.flushing=false;this.bufferFlushed=true;if(this.state===State.ENDED){this.state=State.IDLE;}var mediaBuffer=this.mediaBuffer||this.media;if(mediaBuffer){this.afterBufferFlushed(mediaBuffer,type,PlaylistLevelType.AUDIO);this.tick();}}}},{key:"_handleTransmuxComplete",value:function _handleTransmuxComplete(transmuxResult){var _id3$samples;var id='audio';var hls=this.hls;var remuxResult=transmuxResult.remuxResult,chunkMeta=transmuxResult.chunkMeta;var context=this.getCurrentContext(chunkMeta);if(!context){this.resetWhenMissingContext(chunkMeta);return;}var frag=context.frag,part=context.part,level=context.level;var details=level.details;var audio=remuxResult.audio,text=remuxResult.text,id3=remuxResult.id3,initSegment=remuxResult.initSegment;// Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
// If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
if(this.fragContextChanged(frag)||!details){this.fragmentTracker.removeFragment(frag);return;}this.state=State.PARSING;if(this.switchingTrack&&audio){this.completeAudioSwitch(this.switchingTrack);}if(initSegment!=null&&initSegment.tracks){var mapFragment=frag.initSegment||frag;this._bufferInitSegment(level,initSegment.tracks,mapFragment,chunkMeta);hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT,{frag:mapFragment,id:id,tracks:initSegment.tracks});// Only flush audio from old audio tracks when PTS is known on new audio track
}if(audio){var startPTS=audio.startPTS,endPTS=audio.endPTS,startDTS=audio.startDTS,endDTS=audio.endDTS;if(part){part.elementaryStreams[ElementaryStreamTypes.AUDIO]={startPTS:startPTS,endPTS:endPTS,startDTS:startDTS,endDTS:endDTS};}frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO,startPTS,endPTS,startDTS,endDTS);this.bufferFragmentData(audio,frag,part,chunkMeta);}if(id3!=null&&(_id3$samples=id3.samples)!=null&&_id3$samples.length){var emittedID3=_extends({id:id,frag:frag,details:details},id3);hls.trigger(Events.FRAG_PARSING_METADATA,emittedID3);}if(text){var emittedText=_extends({id:id,frag:frag,details:details},text);hls.trigger(Events.FRAG_PARSING_USERDATA,emittedText);}}},{key:"_bufferInitSegment",value:function _bufferInitSegment(currentLevel,tracks,frag,chunkMeta){if(this.state!==State.PARSING){return;}// delete any video track found on audio transmuxer
if(tracks.video){delete tracks.video;}// include levelCodec in audio and video tracks
var track=tracks.audio;if(!track){return;}track.id='audio';var variantAudioCodecs=currentLevel.audioCodec;this.log("Init audio buffer, container:".concat(track.container,", codecs[level/parsed]=[").concat(variantAudioCodecs,"/").concat(track.codec,"]"));// SourceBuffer will use track.levelCodec if defined
if(variantAudioCodecs&&variantAudioCodecs.split(',').length===1){track.levelCodec=variantAudioCodecs;}this.hls.trigger(Events.BUFFER_CODECS,tracks);var initSegment=track.initSegment;if(initSegment!=null&&initSegment.byteLength){var segment={type:'audio',frag:frag,part:null,chunkMeta:chunkMeta,parent:frag.type,data:initSegment};this.hls.trigger(Events.BUFFER_APPENDING,segment);}// trigger handler right now
this.tickImmediate();}},{key:"loadFragment",value:function loadFragment(frag,track,targetBufferTime){// only load if fragment is not loaded or if in audio switch
var fragState=this.fragmentTracker.getState(frag);this.fragCurrent=frag;// we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
if(this.switchingTrack||fragState===FragmentState.NOT_LOADED||fragState===FragmentState.PARTIAL){var _track$details2;if(frag.sn==='initSegment'){this._loadInitSegment(frag,track);}else if((_track$details2=track.details)!=null&&_track$details2.live&&!this.initPTS[frag.cc]){this.log("Waiting for video PTS in continuity counter ".concat(frag.cc," of live stream before loading audio fragment ").concat(frag.sn," of level ").concat(this.trackId));this.state=State.WAITING_INIT_PTS;var mainDetails=this.mainDetails;if(mainDetails&&mainDetails.fragments[0].start!==track.details.fragments[0].start){alignMediaPlaylistByPDT(track.details,mainDetails);}}else {this.startFragRequested=true;_get(_getPrototypeOf(AudioStreamController.prototype),"loadFragment",this).call(this,frag,track,targetBufferTime);}}else {this.clearTrackerIfNeeded(frag);}}},{key:"flushAudioIfNeeded",value:function flushAudioIfNeeded(switchingTrack){var media=this.media,bufferedTrack=this.bufferedTrack;var bufferedAttributes=bufferedTrack==null?void 0:bufferedTrack.attrs;var switchAttributes=switchingTrack.attrs;if(media&&bufferedAttributes&&(bufferedAttributes.CHANNELS!==switchAttributes.CHANNELS||bufferedTrack.name!==switchingTrack.name||bufferedTrack.lang!==switchingTrack.lang)){this.log('Switching audio track : flushing all audio');_get(_getPrototypeOf(AudioStreamController.prototype),"flushMainBuffer",this).call(this,0,Number.POSITIVE_INFINITY,'audio');this.bufferedTrack=null;}}},{key:"completeAudioSwitch",value:function completeAudioSwitch(switchingTrack){var hls=this.hls;this.flushAudioIfNeeded(switchingTrack);this.bufferedTrack=switchingTrack;this.switchingTrack=null;hls.trigger(Events.AUDIO_TRACK_SWITCHED,_objectSpread2$2({},switchingTrack));}}]);return AudioStreamController;}(BaseStreamController);var AudioTrackController=/*#__PURE__*/function(_BasePlaylistControll){_inherits(AudioTrackController,_BasePlaylistControll);var _super10=_createSuper(AudioTrackController);function AudioTrackController(hls){var _this39;_classCallCheck(this,AudioTrackController);_this39=_super10.call(this,hls,'[audio-track-controller]');_this39.tracks=[];_this39.groupIds=null;_this39.tracksInGroup=[];_this39.trackId=-1;_this39.currentTrack=null;_this39.selectDefaultTrack=true;_this39.registerListeners();return _this39;}_createClass(AudioTrackController,[{key:"registerListeners",value:function registerListeners(){var hls=this.hls;hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.on(Events.LEVEL_LOADING,this.onLevelLoading,this);hls.on(Events.LEVEL_SWITCHING,this.onLevelSwitching,this);hls.on(Events.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this);hls.on(Events.ERROR,this.onError,this);}},{key:"unregisterListeners",value:function unregisterListeners(){var hls=this.hls;hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.off(Events.LEVEL_LOADING,this.onLevelLoading,this);hls.off(Events.LEVEL_SWITCHING,this.onLevelSwitching,this);hls.off(Events.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this);hls.off(Events.ERROR,this.onError,this);}},{key:"destroy",value:function destroy(){this.unregisterListeners();this.tracks.length=0;this.tracksInGroup.length=0;this.currentTrack=null;_get(_getPrototypeOf(AudioTrackController.prototype),"destroy",this).call(this);}},{key:"onManifestLoading",value:function onManifestLoading(){this.tracks=[];this.tracksInGroup=[];this.groupIds=null;this.currentTrack=null;this.trackId=-1;this.selectDefaultTrack=true;}},{key:"onManifestParsed",value:function onManifestParsed(event,data){this.tracks=data.audioTracks||[];}},{key:"onAudioTrackLoaded",value:function onAudioTrackLoaded(event,data){var id=data.id,groupId=data.groupId,details=data.details;var trackInActiveGroup=this.tracksInGroup[id];if(!trackInActiveGroup||trackInActiveGroup.groupId!==groupId){this.warn("Audio track with id:".concat(id," and group:").concat(groupId," not found in active group ").concat(trackInActiveGroup==null?void 0:trackInActiveGroup.groupId));return;}var curDetails=trackInActiveGroup.details;trackInActiveGroup.details=data.details;this.log("Audio track ".concat(id," \"").concat(trackInActiveGroup.name,"\" lang:").concat(trackInActiveGroup.lang," group:").concat(groupId," loaded [").concat(details.startSN,"-").concat(details.endSN,"]"));if(id===this.trackId){this.playlistLoaded(id,data,curDetails);}}},{key:"onLevelLoading",value:function onLevelLoading(event,data){this.switchLevel(data.level);}},{key:"onLevelSwitching",value:function onLevelSwitching(event,data){this.switchLevel(data.level);}},{key:"switchLevel",value:function switchLevel(levelIndex){var levelInfo=this.hls.levels[levelIndex];if(!levelInfo){return;}var audioGroups=levelInfo.audioGroups||null;var currentGroups=this.groupIds;var currentTrack=this.currentTrack;if(!audioGroups||(currentGroups==null?void 0:currentGroups.length)!==(audioGroups==null?void 0:audioGroups.length)||audioGroups!=null&&audioGroups.some(function(groupId){return (currentGroups==null?void 0:currentGroups.indexOf(groupId))===-1;})){this.groupIds=audioGroups;this.trackId=-1;this.currentTrack=null;var audioTracks=this.tracks.filter(function(track){return !audioGroups||audioGroups.indexOf(track.groupId)!==-1;});if(audioTracks.length){// Disable selectDefaultTrack if there are no default tracks
if(this.selectDefaultTrack&&!audioTracks.some(function(track){return track["default"];})){this.selectDefaultTrack=false;}// track.id should match hls.audioTracks index
audioTracks.forEach(function(track,i){track.id=i;});}else if(!currentTrack&&!this.tracksInGroup.length){// Do not dispatch AUDIO_TRACKS_UPDATED when there were and are no tracks
return;}this.tracksInGroup=audioTracks;// Find preferred track
var audioPreference=this.hls.config.audioPreference;if(!currentTrack&&audioPreference){var groupIndex=findMatchingOption(audioPreference,audioTracks,audioMatchPredicate);if(groupIndex>-1){currentTrack=audioTracks[groupIndex];}else {var allIndex=findMatchingOption(audioPreference,this.tracks);currentTrack=this.tracks[allIndex];}}// Select initial track
var trackId=this.findTrackId(currentTrack);if(trackId===-1&&currentTrack){trackId=this.findTrackId(null);}// Dispatch events and load track if needed
var audioTracksUpdated={audioTracks:audioTracks};this.log("Updating audio tracks, ".concat(audioTracks.length," track(s) found in group(s): ").concat(audioGroups==null?void 0:audioGroups.join(',')));this.hls.trigger(Events.AUDIO_TRACKS_UPDATED,audioTracksUpdated);var selectedTrackId=this.trackId;if(trackId!==-1&&selectedTrackId===-1){this.setAudioTrack(trackId);}else if(audioTracks.length&&selectedTrackId===-1){var _this$groupIds;var error=new Error("No audio track selected for current audio group-ID(s): ".concat((_this$groupIds=this.groupIds)==null?void 0:_this$groupIds.join(',')," track count: ").concat(audioTracks.length));this.warn(error.message);this.hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.AUDIO_TRACK_LOAD_ERROR,fatal:true,error:error});}}else if(this.shouldReloadPlaylist(currentTrack)){// Retry playlist loading if no playlist is or has been loaded yet
this.setAudioTrack(this.trackId);}}},{key:"onError",value:function onError(event,data){if(data.fatal||!data.context){return;}if(data.context.type===PlaylistContextType.AUDIO_TRACK&&data.context.id===this.trackId&&(!this.groupIds||this.groupIds.indexOf(data.context.groupId)!==-1)){this.requestScheduled=-1;this.checkRetry(data);}}},{key:"allAudioTracks",get:function get(){return this.tracks;}},{key:"audioTracks",get:function get(){return this.tracksInGroup;}},{key:"audioTrack",get:function get(){return this.trackId;},set:function set(newId){// If audio track is selected from API then don't choose from the manifest default track
this.selectDefaultTrack=false;this.setAudioTrack(newId);}},{key:"setAudioOption",value:function setAudioOption(audioOption){var hls=this.hls;hls.config.audioPreference=audioOption;if(audioOption){var allAudioTracks=this.allAudioTracks;this.selectDefaultTrack=false;if(allAudioTracks.length){// First see if current option matches (no switch op)
var currentTrack=this.currentTrack;if(currentTrack&&matchesOption(audioOption,currentTrack,audioMatchPredicate)){return currentTrack;}// Find option in available tracks (tracksInGroup)
var groupIndex=findMatchingOption(audioOption,this.tracksInGroup,audioMatchPredicate);if(groupIndex>-1){var track=this.tracksInGroup[groupIndex];this.setAudioTrack(groupIndex);return track;}else if(currentTrack){// Find option in nearest level audio group
var searchIndex=hls.loadLevel;if(searchIndex===-1){searchIndex=hls.firstAutoLevel;}var switchIndex=findClosestLevelWithAudioGroup(audioOption,hls.levels,allAudioTracks,searchIndex,audioMatchPredicate);if(switchIndex===-1){// could not find matching variant
return null;}// and switch level to acheive the audio group switch
hls.nextLoadLevel=switchIndex;}if(audioOption.channels||audioOption.audioCodec){// Could not find a match with codec / channels predicate
// Find a match without channels or codec
var withoutCodecAndChannelsMatch=findMatchingOption(audioOption,allAudioTracks);if(withoutCodecAndChannelsMatch>-1){return allAudioTracks[withoutCodecAndChannelsMatch];}}}}return null;}},{key:"setAudioTrack",value:function setAudioTrack(newId){var tracks=this.tracksInGroup;// check if level idx is valid
if(newId<0||newId>=tracks.length){this.warn("Invalid audio track id: ".concat(newId));return;}// stopping live reloading timer if any
this.clearTimer();this.selectDefaultTrack=false;var lastTrack=this.currentTrack;var track=tracks[newId];var trackLoaded=track.details&&!track.details.live;if(newId===this.trackId&&track===lastTrack&&trackLoaded){return;}this.log("Switching to audio-track ".concat(newId," \"").concat(track.name,"\" lang:").concat(track.lang," group:").concat(track.groupId," channels:").concat(track.channels));this.trackId=newId;this.currentTrack=track;this.hls.trigger(Events.AUDIO_TRACK_SWITCHING,_objectSpread2$2({},track));// Do not reload track unless live
if(trackLoaded){return;}var hlsUrlParameters=this.switchParams(track.url,lastTrack==null?void 0:lastTrack.details,track.details);this.loadPlaylist(hlsUrlParameters);}},{key:"findTrackId",value:function findTrackId(currentTrack){var audioTracks=this.tracksInGroup;for(var i=0;i<audioTracks.length;i++){var track=audioTracks[i];if(this.selectDefaultTrack&&!track["default"]){continue;}if(!currentTrack||matchesOption(currentTrack,track,audioMatchPredicate)){return i;}}if(currentTrack){var name=currentTrack.name,lang=currentTrack.lang,assocLang=currentTrack.assocLang,characteristics=currentTrack.characteristics,audioCodec=currentTrack.audioCodec,channels=currentTrack.channels;for(var _i15=0;_i15<audioTracks.length;_i15++){var _track=audioTracks[_i15];if(matchesOption({name:name,lang:lang,assocLang:assocLang,characteristics:characteristics,audioCodec:audioCodec,channels:channels},_track,audioMatchPredicate)){return _i15;}}for(var _i16=0;_i16<audioTracks.length;_i16++){var _track2=audioTracks[_i16];if(mediaAttributesIdentical(currentTrack.attrs,_track2.attrs,['LANGUAGE','ASSOC-LANGUAGE','CHARACTERISTICS'])){return _i16;}}for(var _i17=0;_i17<audioTracks.length;_i17++){var _track3=audioTracks[_i17];if(mediaAttributesIdentical(currentTrack.attrs,_track3.attrs,['LANGUAGE'])){return _i17;}}}return -1;}},{key:"loadPlaylist",value:function loadPlaylist(hlsUrlParameters){var audioTrack=this.currentTrack;if(this.shouldLoadPlaylist(audioTrack)&&audioTrack){_get(_getPrototypeOf(AudioTrackController.prototype),"loadPlaylist",this).call(this);var id=audioTrack.id;var groupId=audioTrack.groupId;var url=audioTrack.url;if(hlsUrlParameters){try{url=hlsUrlParameters.addDirectives(url);}catch(error){this.warn("Could not construct new URL with HLS Delivery Directives: ".concat(error));}}// track not retrieved yet, or live playlist we need to (re)load it
this.log("loading audio-track playlist ".concat(id," \"").concat(audioTrack.name,"\" lang:").concat(audioTrack.lang," group:").concat(groupId));this.clearTimer();this.hls.trigger(Events.AUDIO_TRACK_LOADING,{url:url,id:id,groupId:groupId,deliveryDirectives:hlsUrlParameters||null});}}}]);return AudioTrackController;}(BasePlaylistController);var TICK_INTERVAL$1=500;// how often to tick in ms
var SubtitleStreamController=/*#__PURE__*/function(_BaseStreamController2){_inherits(SubtitleStreamController,_BaseStreamController2);var _super11=_createSuper(SubtitleStreamController);function SubtitleStreamController(hls,fragmentTracker,keyLoader){var _this40;_classCallCheck(this,SubtitleStreamController);_this40=_super11.call(this,hls,fragmentTracker,keyLoader,'[subtitle-stream-controller]',PlaylistLevelType.SUBTITLE);_this40.currentTrackId=-1;_this40.tracksBuffered=[];_this40.mainDetails=null;_this40._registerListeners();return _this40;}_createClass(SubtitleStreamController,[{key:"onHandlerDestroying",value:function onHandlerDestroying(){this._unregisterListeners();_get(_getPrototypeOf(SubtitleStreamController.prototype),"onHandlerDestroying",this).call(this);this.mainDetails=null;}},{key:"_registerListeners",value:function _registerListeners(){var hls=this.hls;hls.on(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.on(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.on(Events.ERROR,this.onError,this);hls.on(Events.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this);hls.on(Events.SUBTITLE_TRACK_SWITCH,this.onSubtitleTrackSwitch,this);hls.on(Events.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this);hls.on(Events.SUBTITLE_FRAG_PROCESSED,this.onSubtitleFragProcessed,this);hls.on(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);hls.on(Events.FRAG_BUFFERED,this.onFragBuffered,this);}},{key:"_unregisterListeners",value:function _unregisterListeners(){var hls=this.hls;hls.off(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.off(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.off(Events.ERROR,this.onError,this);hls.off(Events.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this);hls.off(Events.SUBTITLE_TRACK_SWITCH,this.onSubtitleTrackSwitch,this);hls.off(Events.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this);hls.off(Events.SUBTITLE_FRAG_PROCESSED,this.onSubtitleFragProcessed,this);hls.off(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);hls.off(Events.FRAG_BUFFERED,this.onFragBuffered,this);}},{key:"startLoad",value:function startLoad(startPosition){this.stopLoad();this.state=State.IDLE;this.setInterval(TICK_INTERVAL$1);this.nextLoadPosition=this.startPosition=this.lastCurrentTime=startPosition;this.tick();}},{key:"onManifestLoading",value:function onManifestLoading(){this.mainDetails=null;this.fragmentTracker.removeAllFragments();}},{key:"onMediaDetaching",value:function onMediaDetaching(){this.tracksBuffered=[];_get(_getPrototypeOf(SubtitleStreamController.prototype),"onMediaDetaching",this).call(this);}},{key:"onLevelLoaded",value:function onLevelLoaded(event,data){this.mainDetails=data.details;}},{key:"onSubtitleFragProcessed",value:function onSubtitleFragProcessed(event,data){var frag=data.frag,success=data.success;this.fragPrevious=frag;this.state=State.IDLE;if(!success){return;}var buffered=this.tracksBuffered[this.currentTrackId];if(!buffered){return;}// Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
// so we can re-use the logic used to detect how much has been buffered
var timeRange;var fragStart=frag.start;for(var i=0;i<buffered.length;i++){if(fragStart>=buffered[i].start&&fragStart<=buffered[i].end){timeRange=buffered[i];break;}}var fragEnd=frag.start+frag.duration;if(timeRange){timeRange.end=fragEnd;}else {timeRange={start:fragStart,end:fragEnd};buffered.push(timeRange);}this.fragmentTracker.fragBuffered(frag);this.fragBufferedComplete(frag,null);}},{key:"onBufferFlushing",value:function onBufferFlushing(event,data){var startOffset=data.startOffset,endOffset=data.endOffset;if(startOffset===0&&endOffset!==Number.POSITIVE_INFINITY){var endOffsetSubtitles=endOffset-1;if(endOffsetSubtitles<=0){return;}data.endOffsetSubtitles=Math.max(0,endOffsetSubtitles);this.tracksBuffered.forEach(function(buffered){for(var i=0;i<buffered.length;){if(buffered[i].end<=endOffsetSubtitles){buffered.shift();continue;}else if(buffered[i].start<endOffsetSubtitles){buffered[i].start=endOffsetSubtitles;}else {break;}i++;}});this.fragmentTracker.removeFragmentsInRange(startOffset,endOffsetSubtitles,PlaylistLevelType.SUBTITLE);}}},{key:"onFragBuffered",value:function onFragBuffered(event,data){if(!this.loadedmetadata&&data.frag.type===PlaylistLevelType.MAIN){var _this$media;if((_this$media=this.media)!=null&&_this$media.buffered.length){this.loadedmetadata=true;}}}// If something goes wrong, proceed to next frag, if we were processing one.
},{key:"onError",value:function onError(event,data){var frag=data.frag;if((frag==null?void 0:frag.type)===PlaylistLevelType.SUBTITLE){if(data.details===ErrorDetails.FRAG_GAP){this.fragmentTracker.fragBuffered(frag,true);}if(this.fragCurrent){this.fragCurrent.abortRequests();}if(this.state!==State.STOPPED){this.state=State.IDLE;}}}// Got all new subtitle levels.
},{key:"onSubtitleTracksUpdated",value:function onSubtitleTracksUpdated(event,_ref18){var _this41=this;var subtitleTracks=_ref18.subtitleTracks;if(this.levels&&subtitleOptionsIdentical(this.levels,subtitleTracks)){this.levels=subtitleTracks.map(function(mediaPlaylist){return new Level(mediaPlaylist);});return;}this.tracksBuffered=[];this.levels=subtitleTracks.map(function(mediaPlaylist){var level=new Level(mediaPlaylist);_this41.tracksBuffered[level.id]=[];return level;});this.fragmentTracker.removeFragmentsInRange(0,Number.POSITIVE_INFINITY,PlaylistLevelType.SUBTITLE);this.fragPrevious=null;this.mediaBuffer=null;}},{key:"onSubtitleTrackSwitch",value:function onSubtitleTrackSwitch(event,data){var _this$levels;this.currentTrackId=data.id;if(!((_this$levels=this.levels)!=null&&_this$levels.length)||this.currentTrackId===-1){this.clearInterval();return;}// Check if track has the necessary details to load fragments
var currentTrack=this.levels[this.currentTrackId];if(currentTrack!=null&&currentTrack.details){this.mediaBuffer=this.mediaBufferTimeRanges;}else {this.mediaBuffer=null;}if(currentTrack){this.setInterval(TICK_INTERVAL$1);}}// Got a new set of subtitle fragments.
},{key:"onSubtitleTrackLoaded",value:function onSubtitleTrackLoaded(event,data){var _track$details;var currentTrackId=this.currentTrackId,levels=this.levels;var newDetails=data.details,trackId=data.id;if(!levels){this.warn("Subtitle tracks were reset while loading level ".concat(trackId));return;}var track=levels[trackId];if(trackId>=levels.length||!track){return;}this.log("Subtitle track ".concat(trackId," loaded [").concat(newDetails.startSN,",").concat(newDetails.endSN,"]").concat(newDetails.lastPartSn?"[part-".concat(newDetails.lastPartSn,"-").concat(newDetails.lastPartIndex,"]"):'',",duration:").concat(newDetails.totalduration));this.mediaBuffer=this.mediaBufferTimeRanges;var sliding=0;if(newDetails.live||(_track$details=track.details)!=null&&_track$details.live){var mainDetails=this.mainDetails;if(newDetails.deltaUpdateFailed||!mainDetails){return;}var mainSlidingStartFragment=mainDetails.fragments[0];if(!track.details){if(newDetails.hasProgramDateTime&&mainDetails.hasProgramDateTime){alignMediaPlaylistByPDT(newDetails,mainDetails);sliding=newDetails.fragments[0].start;}else if(mainSlidingStartFragment){// line up live playlist with main so that fragments in range are loaded
sliding=mainSlidingStartFragment.start;addSliding(newDetails,sliding);}}else {var _this$levelLastLoaded;sliding=this.alignPlaylists(newDetails,track.details,(_this$levelLastLoaded=this.levelLastLoaded)==null?void 0:_this$levelLastLoaded.details);if(sliding===0&&mainSlidingStartFragment){// realign with main when there is no overlap with last refresh
sliding=mainSlidingStartFragment.start;addSliding(newDetails,sliding);}}}track.details=newDetails;this.levelLastLoaded=track;if(trackId!==currentTrackId){return;}if(!this.startFragRequested&&(this.mainDetails||!newDetails.live)){this.setStartPosition(this.mainDetails||newDetails,sliding);}// trigger handler right now
this.tick();// If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
if(newDetails.live&&!this.fragCurrent&&this.media&&this.state===State.IDLE){var foundFrag=findFragmentByPTS(null,newDetails.fragments,this.media.currentTime,0);if(!foundFrag){this.warn('Subtitle playlist not aligned with playback');track.details=undefined;}}}},{key:"_handleFragmentLoadComplete",value:function _handleFragmentLoadComplete(fragLoadedData){var _this42=this;var frag=fragLoadedData.frag,payload=fragLoadedData.payload;var decryptData=frag.decryptdata;var hls=this.hls;if(this.fragContextChanged(frag)){return;}// check to see if the payload needs to be decrypted
if(payload&&payload.byteLength>0&&decryptData!=null&&decryptData.key&&decryptData.iv&&decryptData.method==='AES-128'){var startTime=performance.now();// decrypt the subtitles
this.decrypter.decrypt(new Uint8Array(payload),decryptData.key.buffer,decryptData.iv.buffer)["catch"](function(err){hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.FRAG_DECRYPT_ERROR,fatal:false,error:err,reason:err.message,frag:frag});throw err;}).then(function(decryptedData){var endTime=performance.now();hls.trigger(Events.FRAG_DECRYPTED,{frag:frag,payload:decryptedData,stats:{tstart:startTime,tdecrypt:endTime}});})["catch"](function(err){_this42.warn("".concat(err.name,": ").concat(err.message));_this42.state=State.IDLE;});}}},{key:"doTick",value:function doTick(){if(!this.media){this.state=State.IDLE;return;}if(this.state===State.IDLE){var currentTrackId=this.currentTrackId,levels=this.levels;var track=levels==null?void 0:levels[currentTrackId];if(!track||!levels.length||!track.details){return;}var config=this.config;var currentTime=this.getLoadPosition();var bufferedInfo=BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId]||[],currentTime,config.maxBufferHole);var targetBufferTime=bufferedInfo.end,bufferLen=bufferedInfo.len;var mainBufferInfo=this.getFwdBufferInfo(this.media,PlaylistLevelType.MAIN);var trackDetails=track.details;var maxBufLen=this.getMaxBufferLength(mainBufferInfo==null?void 0:mainBufferInfo.len)+trackDetails.levelTargetDuration;if(bufferLen>maxBufLen){return;}var fragments=trackDetails.fragments;var fragLen=fragments.length;var end=trackDetails.edge;var foundFrag=null;var fragPrevious=this.fragPrevious;if(targetBufferTime<end){var tolerance=config.maxFragLookUpTolerance;var lookupTolerance=targetBufferTime>end-tolerance?0:tolerance;foundFrag=findFragmentByPTS(fragPrevious,fragments,Math.max(fragments[0].start,targetBufferTime),lookupTolerance);if(!foundFrag&&fragPrevious&&fragPrevious.start<fragments[0].start){foundFrag=fragments[0];}}else {foundFrag=fragments[fragLen-1];}if(!foundFrag){return;}foundFrag=this.mapToInitFragWhenRequired(foundFrag);if(foundFrag.sn!=='initSegment'){// Load earlier fragment in same discontinuity to make up for misaligned playlists and cues that extend beyond end of segment
var curSNIdx=foundFrag.sn-trackDetails.startSN;var prevFrag=fragments[curSNIdx-1];if(prevFrag&&prevFrag.cc===foundFrag.cc&&this.fragmentTracker.getState(prevFrag)===FragmentState.NOT_LOADED){foundFrag=prevFrag;}}if(this.fragmentTracker.getState(foundFrag)===FragmentState.NOT_LOADED){// only load if fragment is not loaded
this.loadFragment(foundFrag,track,targetBufferTime);}}}},{key:"getMaxBufferLength",value:function getMaxBufferLength(mainBufferLength){var maxConfigBuffer=_get(_getPrototypeOf(SubtitleStreamController.prototype),"getMaxBufferLength",this).call(this);if(!mainBufferLength){return maxConfigBuffer;}return Math.max(maxConfigBuffer,mainBufferLength);}},{key:"loadFragment",value:function loadFragment(frag,level,targetBufferTime){this.fragCurrent=frag;if(frag.sn==='initSegment'){this._loadInitSegment(frag,level);}else {this.startFragRequested=true;_get(_getPrototypeOf(SubtitleStreamController.prototype),"loadFragment",this).call(this,frag,level,targetBufferTime);}}},{key:"mediaBufferTimeRanges",get:function get(){return new BufferableInstance(this.tracksBuffered[this.currentTrackId]||[]);}}]);return SubtitleStreamController;}(BaseStreamController);var BufferableInstance=/*#__PURE__*/_createClass(function BufferableInstance(timeranges){_classCallCheck(this,BufferableInstance);this.buffered=void 0;var getRange=function getRange(name,index,length){index=index>>>0;if(index>length-1){throw new DOMException("Failed to execute '".concat(name,"' on 'TimeRanges': The index provided (").concat(index,") is greater than the maximum bound (").concat(length,")"));}return timeranges[index][name];};this.buffered={get length(){return timeranges.length;},end:function end(index){return getRange('end',index,timeranges.length);},start:function start(index){return getRange('start',index,timeranges.length);}};});var SubtitleTrackController=/*#__PURE__*/function(_BasePlaylistControll2){_inherits(SubtitleTrackController,_BasePlaylistControll2);var _super12=_createSuper(SubtitleTrackController);function SubtitleTrackController(hls){var _this43;_classCallCheck(this,SubtitleTrackController);_this43=_super12.call(this,hls,'[subtitle-track-controller]');_this43.media=null;_this43.tracks=[];_this43.groupIds=null;_this43.tracksInGroup=[];_this43.trackId=-1;_this43.currentTrack=null;_this43.selectDefaultTrack=true;_this43.queuedDefaultTrack=-1;_this43.asyncPollTrackChange=function(){return _this43.pollTrackChange(0);};_this43.useTextTrackPolling=false;_this43.subtitlePollingInterval=-1;_this43._subtitleDisplay=true;_this43.onTextTracksChanged=function(){if(!_this43.useTextTrackPolling){self.clearInterval(_this43.subtitlePollingInterval);}// Media is undefined when switching streams via loadSource()
if(!_this43.media||!_this43.hls.config.renderTextTracksNatively){return;}var textTrack=null;var tracks=filterSubtitleTracks(_this43.media.textTracks);for(var i=0;i<tracks.length;i++){if(tracks[i].mode==='hidden'){// Do not break in case there is a following track with showing.
textTrack=tracks[i];}else if(tracks[i].mode==='showing'){textTrack=tracks[i];break;}}// Find internal track index for TextTrack
var trackId=_this43.findTrackForTextTrack(textTrack);if(_this43.subtitleTrack!==trackId){_this43.setSubtitleTrack(trackId);}};_this43.registerListeners();return _this43;}_createClass(SubtitleTrackController,[{key:"destroy",value:function destroy(){this.unregisterListeners();this.tracks.length=0;this.tracksInGroup.length=0;this.currentTrack=null;this.onTextTracksChanged=this.asyncPollTrackChange=null;_get(_getPrototypeOf(SubtitleTrackController.prototype),"destroy",this).call(this);}},{key:"subtitleDisplay",get:function get(){return this._subtitleDisplay;},set:function set(value){this._subtitleDisplay=value;if(this.trackId>-1){this.toggleTrackModes();}}},{key:"registerListeners",value:function registerListeners(){var hls=this.hls;hls.on(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.on(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.on(Events.LEVEL_LOADING,this.onLevelLoading,this);hls.on(Events.LEVEL_SWITCHING,this.onLevelSwitching,this);hls.on(Events.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this);hls.on(Events.ERROR,this.onError,this);}},{key:"unregisterListeners",value:function unregisterListeners(){var hls=this.hls;hls.off(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.off(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.off(Events.LEVEL_LOADING,this.onLevelLoading,this);hls.off(Events.LEVEL_SWITCHING,this.onLevelSwitching,this);hls.off(Events.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this);hls.off(Events.ERROR,this.onError,this);}// Listen for subtitle track change, then extract the current track ID.
},{key:"onMediaAttached",value:function onMediaAttached(event,data){this.media=data.media;if(!this.media){return;}if(this.queuedDefaultTrack>-1){this.subtitleTrack=this.queuedDefaultTrack;this.queuedDefaultTrack=-1;}this.useTextTrackPolling=!(this.media.textTracks&&'onchange'in this.media.textTracks);if(this.useTextTrackPolling){this.pollTrackChange(500);}else {this.media.textTracks.addEventListener('change',this.asyncPollTrackChange);}}},{key:"pollTrackChange",value:function pollTrackChange(timeout){self.clearInterval(this.subtitlePollingInterval);this.subtitlePollingInterval=self.setInterval(this.onTextTracksChanged,timeout);}},{key:"onMediaDetaching",value:function onMediaDetaching(){if(!this.media){return;}self.clearInterval(this.subtitlePollingInterval);if(!this.useTextTrackPolling){this.media.textTracks.removeEventListener('change',this.asyncPollTrackChange);}if(this.trackId>-1){this.queuedDefaultTrack=this.trackId;}var textTracks=filterSubtitleTracks(this.media.textTracks);// Clear loaded cues on media detachment from tracks
textTracks.forEach(function(track){clearCurrentCues(track);});// Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
this.subtitleTrack=-1;this.media=null;}},{key:"onManifestLoading",value:function onManifestLoading(){this.tracks=[];this.groupIds=null;this.tracksInGroup=[];this.trackId=-1;this.currentTrack=null;this.selectDefaultTrack=true;}// Fired whenever a new manifest is loaded.
},{key:"onManifestParsed",value:function onManifestParsed(event,data){this.tracks=data.subtitleTracks;}},{key:"onSubtitleTrackLoaded",value:function onSubtitleTrackLoaded(event,data){var id=data.id,groupId=data.groupId,details=data.details;var trackInActiveGroup=this.tracksInGroup[id];if(!trackInActiveGroup||trackInActiveGroup.groupId!==groupId){this.warn("Subtitle track with id:".concat(id," and group:").concat(groupId," not found in active group ").concat(trackInActiveGroup==null?void 0:trackInActiveGroup.groupId));return;}var curDetails=trackInActiveGroup.details;trackInActiveGroup.details=data.details;this.log("Subtitle track ".concat(id," \"").concat(trackInActiveGroup.name,"\" lang:").concat(trackInActiveGroup.lang," group:").concat(groupId," loaded [").concat(details.startSN,"-").concat(details.endSN,"]"));if(id===this.trackId){this.playlistLoaded(id,data,curDetails);}}},{key:"onLevelLoading",value:function onLevelLoading(event,data){this.switchLevel(data.level);}},{key:"onLevelSwitching",value:function onLevelSwitching(event,data){this.switchLevel(data.level);}},{key:"switchLevel",value:function switchLevel(levelIndex){var levelInfo=this.hls.levels[levelIndex];if(!levelInfo){return;}var subtitleGroups=levelInfo.subtitleGroups||null;var currentGroups=this.groupIds;var currentTrack=this.currentTrack;if(!subtitleGroups||(currentGroups==null?void 0:currentGroups.length)!==(subtitleGroups==null?void 0:subtitleGroups.length)||subtitleGroups!=null&&subtitleGroups.some(function(groupId){return (currentGroups==null?void 0:currentGroups.indexOf(groupId))===-1;})){this.groupIds=subtitleGroups;this.trackId=-1;this.currentTrack=null;var subtitleTracks=this.tracks.filter(function(track){return !subtitleGroups||subtitleGroups.indexOf(track.groupId)!==-1;});if(subtitleTracks.length){// Disable selectDefaultTrack if there are no default tracks
if(this.selectDefaultTrack&&!subtitleTracks.some(function(track){return track["default"];})){this.selectDefaultTrack=false;}// track.id should match hls.audioTracks index
subtitleTracks.forEach(function(track,i){track.id=i;});}else if(!currentTrack&&!this.tracksInGroup.length){// Do not dispatch SUBTITLE_TRACKS_UPDATED when there were and are no tracks
return;}this.tracksInGroup=subtitleTracks;// Find preferred track
var subtitlePreference=this.hls.config.subtitlePreference;if(!currentTrack&&subtitlePreference){this.selectDefaultTrack=false;var groupIndex=findMatchingOption(subtitlePreference,subtitleTracks);if(groupIndex>-1){currentTrack=subtitleTracks[groupIndex];}else {var allIndex=findMatchingOption(subtitlePreference,this.tracks);currentTrack=this.tracks[allIndex];}}// Select initial track
var trackId=this.findTrackId(currentTrack);if(trackId===-1&&currentTrack){trackId=this.findTrackId(null);}// Dispatch events and load track if needed
var subtitleTracksUpdated={subtitleTracks:subtitleTracks};this.log("Updating subtitle tracks, ".concat(subtitleTracks.length," track(s) found in \"").concat(subtitleGroups==null?void 0:subtitleGroups.join(','),"\" group-id"));this.hls.trigger(Events.SUBTITLE_TRACKS_UPDATED,subtitleTracksUpdated);if(trackId!==-1&&this.trackId===-1){this.setSubtitleTrack(trackId);}}else if(this.shouldReloadPlaylist(currentTrack)){// Retry playlist loading if no playlist is or has been loaded yet
this.setSubtitleTrack(this.trackId);}}},{key:"findTrackId",value:function findTrackId(currentTrack){var tracks=this.tracksInGroup;var selectDefault=this.selectDefaultTrack;for(var i=0;i<tracks.length;i++){var track=tracks[i];if(selectDefault&&!track["default"]||!selectDefault&&!currentTrack){continue;}if(!currentTrack||matchesOption(track,currentTrack)){return i;}}if(currentTrack){for(var _i18=0;_i18<tracks.length;_i18++){var _track4=tracks[_i18];if(mediaAttributesIdentical(currentTrack.attrs,_track4.attrs,['LANGUAGE','ASSOC-LANGUAGE','CHARACTERISTICS'])){return _i18;}}for(var _i19=0;_i19<tracks.length;_i19++){var _track5=tracks[_i19];if(mediaAttributesIdentical(currentTrack.attrs,_track5.attrs,['LANGUAGE'])){return _i19;}}}return -1;}},{key:"findTrackForTextTrack",value:function findTrackForTextTrack(textTrack){if(textTrack){var tracks=this.tracksInGroup;for(var i=0;i<tracks.length;i++){var track=tracks[i];if(subtitleTrackMatchesTextTrack(track,textTrack)){return i;}}}return -1;}},{key:"onError",value:function onError(event,data){if(data.fatal||!data.context){return;}if(data.context.type===PlaylistContextType.SUBTITLE_TRACK&&data.context.id===this.trackId&&(!this.groupIds||this.groupIds.indexOf(data.context.groupId)!==-1)){this.checkRetry(data);}}},{key:"allSubtitleTracks",get:function get(){return this.tracks;}/** get alternate subtitle tracks list from playlist **/},{key:"subtitleTracks",get:function get(){return this.tracksInGroup;}/** get/set index of the selected subtitle track (based on index in subtitle track lists) **/},{key:"subtitleTrack",get:function get(){return this.trackId;},set:function set(newId){this.selectDefaultTrack=false;this.setSubtitleTrack(newId);}},{key:"setSubtitleOption",value:function setSubtitleOption(subtitleOption){this.hls.config.subtitlePreference=subtitleOption;if(subtitleOption){var allSubtitleTracks=this.allSubtitleTracks;this.selectDefaultTrack=false;if(allSubtitleTracks.length){// First see if current option matches (no switch op)
var currentTrack=this.currentTrack;if(currentTrack&&matchesOption(subtitleOption,currentTrack)){return currentTrack;}// Find option in current group
var groupIndex=findMatchingOption(subtitleOption,this.tracksInGroup);if(groupIndex>-1){var track=this.tracksInGroup[groupIndex];this.setSubtitleTrack(groupIndex);return track;}else if(currentTrack){// If this is not the initial selection return null
// option should have matched one in active group
return null;}else {// Find the option in all tracks for initial selection
var allIndex=findMatchingOption(subtitleOption,allSubtitleTracks);if(allIndex>-1){return allSubtitleTracks[allIndex];}}}}return null;}},{key:"loadPlaylist",value:function loadPlaylist(hlsUrlParameters){_get(_getPrototypeOf(SubtitleTrackController.prototype),"loadPlaylist",this).call(this);var currentTrack=this.currentTrack;if(this.shouldLoadPlaylist(currentTrack)&&currentTrack){var id=currentTrack.id;var groupId=currentTrack.groupId;var url=currentTrack.url;if(hlsUrlParameters){try{url=hlsUrlParameters.addDirectives(url);}catch(error){this.warn("Could not construct new URL with HLS Delivery Directives: ".concat(error));}}this.log("Loading subtitle playlist for id ".concat(id));this.hls.trigger(Events.SUBTITLE_TRACK_LOADING,{url:url,id:id,groupId:groupId,deliveryDirectives:hlsUrlParameters||null});}}/**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */},{key:"toggleTrackModes",value:function toggleTrackModes(){var media=this.media;if(!media){return;}var textTracks=filterSubtitleTracks(media.textTracks);var currentTrack=this.currentTrack;var nextTrack;if(currentTrack){nextTrack=textTracks.filter(function(textTrack){return subtitleTrackMatchesTextTrack(currentTrack,textTrack);})[0];if(!nextTrack){this.warn("Unable to find subtitle TextTrack with name \"".concat(currentTrack.name,"\" and language \"").concat(currentTrack.lang,"\""));}}[].slice.call(textTracks).forEach(function(track){if(track.mode!=='disabled'&&track!==nextTrack){track.mode='disabled';}});if(nextTrack){var mode=this.subtitleDisplay?'showing':'hidden';if(nextTrack.mode!==mode){nextTrack.mode=mode;}}}/**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */},{key:"setSubtitleTrack",value:function setSubtitleTrack(newId){var tracks=this.tracksInGroup;// setting this.subtitleTrack will trigger internal logic
// if media has not been attached yet, it will fail
// we keep a reference to the default track id
// and we'll set subtitleTrack when onMediaAttached is triggered
if(!this.media){this.queuedDefaultTrack=newId;return;}// exit if track id as already set or invalid
if(newId<-1||newId>=tracks.length||!isFiniteNumber(newId)){this.warn("Invalid subtitle track id: ".concat(newId));return;}// stopping live reloading timer if any
this.clearTimer();this.selectDefaultTrack=false;var lastTrack=this.currentTrack;var track=tracks[newId]||null;this.trackId=newId;this.currentTrack=track;this.toggleTrackModes();if(!track){// switch to -1
this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH,{id:newId});return;}var trackLoaded=!!track.details&&!track.details.live;if(newId===this.trackId&&track===lastTrack&&trackLoaded){return;}this.log("Switching to subtitle-track ".concat(newId)+(track?" \"".concat(track.name,"\" lang:").concat(track.lang," group:").concat(track.groupId):''));var id=track.id,_track$groupId=track.groupId,groupId=_track$groupId===void 0?'':_track$groupId,name=track.name,type=track.type,url=track.url;this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH,{id:id,groupId:groupId,name:name,type:type,url:url});var hlsUrlParameters=this.switchParams(track.url,lastTrack==null?void 0:lastTrack.details,track.details);this.loadPlaylist(hlsUrlParameters);}}]);return SubtitleTrackController;}(BasePlaylistController);var BufferOperationQueue=/*#__PURE__*/function(){function BufferOperationQueue(sourceBufferReference){_classCallCheck(this,BufferOperationQueue);this.buffers=void 0;this.queues={video:[],audio:[],audiovideo:[]};this.buffers=sourceBufferReference;}_createClass(BufferOperationQueue,[{key:"append",value:function append(operation,type,pending){var queue=this.queues[type];queue.push(operation);if(queue.length===1&&!pending){this.executeNext(type);}}},{key:"insertAbort",value:function insertAbort(operation,type){var queue=this.queues[type];queue.unshift(operation);this.executeNext(type);}},{key:"appendBlocker",value:function appendBlocker(type){var execute;var promise=new Promise(function(resolve){execute=resolve;});var operation={execute:execute,onStart:function onStart(){},onComplete:function onComplete(){},onError:function onError(){}};this.append(operation,type);return promise;}},{key:"executeNext",value:function executeNext(type){var queue=this.queues[type];if(queue.length){var operation=queue[0];try{// Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
// which do not end with this event must call _onSBUpdateEnd manually
operation.execute();}catch(error){logger.warn("[buffer-operation-queue]: Exception executing \"".concat(type,"\" SourceBuffer operation: ").concat(error));operation.onError(error);// Only shift the current operation off, otherwise the updateend handler will do this for us
var sb=this.buffers[type];if(!(sb!=null&&sb.updating)){this.shiftAndExecuteNext(type);}}}}},{key:"shiftAndExecuteNext",value:function shiftAndExecuteNext(type){this.queues[type].shift();this.executeNext(type);}},{key:"current",value:function current(type){return this.queues[type][0];}}]);return BufferOperationQueue;}();var VIDEO_CODEC_PROFILE_REPLACE=/(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;var BufferController=/*#__PURE__*/function(){function BufferController(hls){var _this44=this;_classCallCheck(this,BufferController);// The level details used to determine duration, target-duration and live
this.details=null;// cache the self generated object url to detect hijack of video tag
this._objectUrl=null;// A queue of buffer operations which require the SourceBuffer to not be updating upon execution
this.operationQueue=void 0;// References to event listeners for each SourceBuffer, so that they can be referenced for event removal
this.listeners=void 0;this.hls=void 0;// The number of BUFFER_CODEC events received before any sourceBuffers are created
this.bufferCodecEventsExpected=0;// The total number of BUFFER_CODEC events received
this._bufferCodecEventsTotal=0;// A reference to the attached media element
this.media=null;// A reference to the active media source
this.mediaSource=null;// Last MP3 audio chunk appended
this.lastMpegAudioChunk=null;this.appendSource=void 0;// counters
this.appendErrors={audio:0,video:0,audiovideo:0};this.tracks={};this.pendingTracks={};this.sourceBuffer=void 0;this.log=void 0;this.warn=void 0;this.error=void 0;this._onEndStreaming=function(event){if(!_this44.hls){return;}_this44.hls.pauseBuffering();};this._onStartStreaming=function(event){if(!_this44.hls){return;}_this44.hls.resumeBuffering();};// Keep as arrow functions so that we can directly reference these functions directly as event listeners
this._onMediaSourceOpen=function(){var media=_this44.media,mediaSource=_this44.mediaSource;_this44.log('Media source opened');if(media){media.removeEventListener('emptied',_this44._onMediaEmptied);_this44.updateMediaElementDuration();_this44.hls.trigger(Events.MEDIA_ATTACHED,{media:media,mediaSource:mediaSource});}if(mediaSource){// once received, don't listen anymore to sourceopen event
mediaSource.removeEventListener('sourceopen',_this44._onMediaSourceOpen);}_this44.checkPendingTracks();};this._onMediaSourceClose=function(){_this44.log('Media source closed');};this._onMediaSourceEnded=function(){_this44.log('Media source ended');};this._onMediaEmptied=function(){var mediaSrc=_this44.mediaSrc,_objectUrl=_this44._objectUrl;if(mediaSrc!==_objectUrl){logger.error("Media element src was set while attaching MediaSource (".concat(_objectUrl," > ").concat(mediaSrc,")"));}};this.hls=hls;var logPrefix='[buffer-controller]';this.appendSource=isManagedMediaSource(_getMediaSource(hls.config.preferManagedMediaSource));this.log=logger.log.bind(logger,logPrefix);this.warn=logger.warn.bind(logger,logPrefix);this.error=logger.error.bind(logger,logPrefix);this._initSourceBuffer();this.registerListeners();}_createClass(BufferController,[{key:"hasSourceTypes",value:function hasSourceTypes(){return this.getSourceBufferTypes().length>0||Object.keys(this.pendingTracks).length>0;}},{key:"destroy",value:function destroy(){this.unregisterListeners();this.details=null;this.lastMpegAudioChunk=null;// @ts-ignore
this.hls=null;}},{key:"registerListeners",value:function registerListeners(){var hls=this.hls;hls.on(Events.MEDIA_ATTACHING,this.onMediaAttaching,this);hls.on(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.on(Events.BUFFER_RESET,this.onBufferReset,this);hls.on(Events.BUFFER_APPENDING,this.onBufferAppending,this);hls.on(Events.BUFFER_CODECS,this.onBufferCodecs,this);hls.on(Events.BUFFER_EOS,this.onBufferEos,this);hls.on(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);hls.on(Events.LEVEL_UPDATED,this.onLevelUpdated,this);hls.on(Events.FRAG_PARSED,this.onFragParsed,this);hls.on(Events.FRAG_CHANGED,this.onFragChanged,this);}},{key:"unregisterListeners",value:function unregisterListeners(){var hls=this.hls;hls.off(Events.MEDIA_ATTACHING,this.onMediaAttaching,this);hls.off(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.off(Events.BUFFER_RESET,this.onBufferReset,this);hls.off(Events.BUFFER_APPENDING,this.onBufferAppending,this);hls.off(Events.BUFFER_CODECS,this.onBufferCodecs,this);hls.off(Events.BUFFER_EOS,this.onBufferEos,this);hls.off(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);hls.off(Events.LEVEL_UPDATED,this.onLevelUpdated,this);hls.off(Events.FRAG_PARSED,this.onFragParsed,this);hls.off(Events.FRAG_CHANGED,this.onFragChanged,this);}},{key:"_initSourceBuffer",value:function _initSourceBuffer(){this.sourceBuffer={};this.operationQueue=new BufferOperationQueue(this.sourceBuffer);this.listeners={audio:[],video:[],audiovideo:[]};this.appendErrors={audio:0,video:0,audiovideo:0};this.lastMpegAudioChunk=null;}},{key:"onManifestLoading",value:function onManifestLoading(){this.bufferCodecEventsExpected=this._bufferCodecEventsTotal=0;this.details=null;}},{key:"onManifestParsed",value:function onManifestParsed(event,data){// in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
// sourcebuffers will be created all at once when the expected nb of tracks will be reached
// in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
// it will contain the expected nb of source buffers, no need to compute it
var codecEvents=2;if(data.audio&&!data.video||!data.altAudio||!true){codecEvents=1;}this.bufferCodecEventsExpected=this._bufferCodecEventsTotal=codecEvents;this.log("".concat(this.bufferCodecEventsExpected," bufferCodec event(s) expected"));}},{key:"onMediaAttaching",value:function onMediaAttaching(event,data){var media=this.media=data.media;var MediaSource=_getMediaSource(this.appendSource);if(media&&MediaSource){var _ms$constructor;var ms=this.mediaSource=new MediaSource();this.log("created media source: ".concat((_ms$constructor=ms.constructor)==null?void 0:_ms$constructor.name));// MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
ms.addEventListener('sourceopen',this._onMediaSourceOpen);ms.addEventListener('sourceended',this._onMediaSourceEnded);ms.addEventListener('sourceclose',this._onMediaSourceClose);if(this.appendSource){ms.addEventListener('startstreaming',this._onStartStreaming);ms.addEventListener('endstreaming',this._onEndStreaming);}// cache the locally generated object url
var objectUrl=this._objectUrl=self.URL.createObjectURL(ms);// link video and media Source
if(this.appendSource){try{media.removeAttribute('src');// ManagedMediaSource will not open without disableRemotePlayback set to false or source alternatives
var MMS=self.ManagedMediaSource;media.disableRemotePlayback=media.disableRemotePlayback||MMS&&ms instanceof MMS;removeSourceChildren(media);addSource(media,objectUrl);media.load();}catch(error){media.src=objectUrl;}}else {media.src=objectUrl;}media.addEventListener('emptied',this._onMediaEmptied);}}},{key:"onMediaDetaching",value:function onMediaDetaching(){var media=this.media,mediaSource=this.mediaSource,_objectUrl=this._objectUrl;if(mediaSource){this.log('media source detaching');if(mediaSource.readyState==='open'){try{// endOfStream could trigger exception if any sourcebuffer is in updating state
// we don't really care about checking sourcebuffer state here,
// as we are anyway detaching the MediaSource
// let's just avoid this exception to propagate
mediaSource.endOfStream();}catch(err){this.warn("onMediaDetaching: ".concat(err.message," while calling endOfStream"));}}// Clean up the SourceBuffers by invoking onBufferReset
this.onBufferReset();mediaSource.removeEventListener('sourceopen',this._onMediaSourceOpen);mediaSource.removeEventListener('sourceended',this._onMediaSourceEnded);mediaSource.removeEventListener('sourceclose',this._onMediaSourceClose);if(this.appendSource){mediaSource.removeEventListener('startstreaming',this._onStartStreaming);mediaSource.removeEventListener('endstreaming',this._onEndStreaming);}// Detach properly the MediaSource from the HTMLMediaElement as
// suggested in https://github.com/w3c/media-source/issues/53.
if(media){media.removeEventListener('emptied',this._onMediaEmptied);if(_objectUrl){self.URL.revokeObjectURL(_objectUrl);}// clean up video tag src only if it's our own url. some external libraries might
// hijack the video tag and change its 'src' without destroying the Hls instance first
if(this.mediaSrc===_objectUrl){media.removeAttribute('src');if(this.appendSource){removeSourceChildren(media);}media.load();}else {this.warn('media|source.src was changed by a third party - skip cleanup');}}this.mediaSource=null;this.media=null;this._objectUrl=null;this.bufferCodecEventsExpected=this._bufferCodecEventsTotal;this.pendingTracks={};this.tracks={};}this.hls.trigger(Events.MEDIA_DETACHED,undefined);}},{key:"onBufferReset",value:function onBufferReset(){var _this45=this;this.getSourceBufferTypes().forEach(function(type){_this45.resetBuffer(type);});this._initSourceBuffer();this.hls.resumeBuffering();}},{key:"resetBuffer",value:function resetBuffer(type){var sb=this.sourceBuffer[type];try{if(sb){var _this$mediaSource;this.removeBufferListeners(type);// Synchronously remove the SB from the map before the next call in order to prevent an async function from
// accessing it
this.sourceBuffer[type]=undefined;if((_this$mediaSource=this.mediaSource)!=null&&_this$mediaSource.sourceBuffers.length){this.mediaSource.removeSourceBuffer(sb);}}}catch(err){this.warn("onBufferReset ".concat(type),err);}}},{key:"onBufferCodecs",value:function onBufferCodecs(event,data){var _this46=this;var sourceBufferCount=this.getSourceBufferTypes().length;var trackNames=Object.keys(data);trackNames.forEach(function(trackName){if(sourceBufferCount){// check if SourceBuffer codec needs to change
var track=_this46.tracks[trackName];if(track&&typeof track.buffer.changeType==='function'){var _trackCodec;var _data$trackName=data[trackName],id=_data$trackName.id,codec=_data$trackName.codec,levelCodec=_data$trackName.levelCodec,container=_data$trackName.container,metadata=_data$trackName.metadata;var currentCodecFull=pickMostCompleteCodecName(track.codec,track.levelCodec);var currentCodec=currentCodecFull==null?void 0:currentCodecFull.replace(VIDEO_CODEC_PROFILE_REPLACE,'$1');var trackCodec=pickMostCompleteCodecName(codec,levelCodec);var nextCodec=(_trackCodec=trackCodec)==null?void 0:_trackCodec.replace(VIDEO_CODEC_PROFILE_REPLACE,'$1');if(trackCodec&&currentCodec!==nextCodec){if(trackName.slice(0,5)==='audio'){trackCodec=getCodecCompatibleName(trackCodec,_this46.appendSource);}var mimeType="".concat(container,";codecs=").concat(trackCodec);_this46.appendChangeType(trackName,mimeType);_this46.log("switching codec ".concat(currentCodecFull," to ").concat(trackCodec));_this46.tracks[trackName]={buffer:track.buffer,codec:codec,container:container,levelCodec:levelCodec,metadata:metadata,id:id};}}}else {// if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
_this46.pendingTracks[trackName]=data[trackName];}});// if sourcebuffers already created, do nothing ...
if(sourceBufferCount){return;}var bufferCodecEventsExpected=Math.max(this.bufferCodecEventsExpected-1,0);if(this.bufferCodecEventsExpected!==bufferCodecEventsExpected){this.log("".concat(bufferCodecEventsExpected," bufferCodec event(s) expected ").concat(trackNames.join(',')));this.bufferCodecEventsExpected=bufferCodecEventsExpected;}if(this.mediaSource&&this.mediaSource.readyState==='open'){this.checkPendingTracks();}}},{key:"appendChangeType",value:function appendChangeType(type,mimeType){var _this47=this;var operationQueue=this.operationQueue;var operation={execute:function execute(){var sb=_this47.sourceBuffer[type];if(sb){_this47.log("changing ".concat(type," sourceBuffer type to ").concat(mimeType));sb.changeType(mimeType);}operationQueue.shiftAndExecuteNext(type);},onStart:function onStart(){},onComplete:function onComplete(){},onError:function onError(error){_this47.warn("Failed to change ".concat(type," SourceBuffer type"),error);}};operationQueue.append(operation,type,!!this.pendingTracks[type]);}},{key:"onBufferAppending",value:function onBufferAppending(event,eventData){var _this48=this;var hls=this.hls,operationQueue=this.operationQueue,tracks=this.tracks;var data=eventData.data,type=eventData.type,frag=eventData.frag,part=eventData.part,chunkMeta=eventData.chunkMeta;var chunkStats=chunkMeta.buffering[type];var bufferAppendingStart=self.performance.now();chunkStats.start=bufferAppendingStart;var fragBuffering=frag.stats.buffering;var partBuffering=part?part.stats.buffering:null;if(fragBuffering.start===0){fragBuffering.start=bufferAppendingStart;}if(partBuffering&&partBuffering.start===0){partBuffering.start=bufferAppendingStart;}// TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
// Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
// in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
// is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
// More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
var audioTrack=tracks.audio;var checkTimestampOffset=false;if(type==='audio'&&(audioTrack==null?void 0:audioTrack.container)==='audio/mpeg'){checkTimestampOffset=!this.lastMpegAudioChunk||chunkMeta.id===1||this.lastMpegAudioChunk.sn!==chunkMeta.sn;this.lastMpegAudioChunk=chunkMeta;}var fragStart=frag.start;var operation={execute:function execute(){chunkStats.executeStart=self.performance.now();if(checkTimestampOffset){var sb=_this48.sourceBuffer[type];if(sb){var delta=fragStart-sb.timestampOffset;if(Math.abs(delta)>=0.1){_this48.log("Updating audio SourceBuffer timestampOffset to ".concat(fragStart," (delta: ").concat(delta,") sn: ").concat(frag.sn,")"));sb.timestampOffset=fragStart;}}}_this48.appendExecutor(data,type);},onStart:function onStart(){// logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
},onComplete:function onComplete(){// logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
var end=self.performance.now();chunkStats.executeEnd=chunkStats.end=end;if(fragBuffering.first===0){fragBuffering.first=end;}if(partBuffering&&partBuffering.first===0){partBuffering.first=end;}var sourceBuffer=_this48.sourceBuffer;var timeRanges={};for(var _type in sourceBuffer){timeRanges[_type]=BufferHelper.getBuffered(sourceBuffer[_type]);}_this48.appendErrors[type]=0;if(type==='audio'||type==='video'){_this48.appendErrors.audiovideo=0;}else {_this48.appendErrors.audio=0;_this48.appendErrors.video=0;}_this48.hls.trigger(Events.BUFFER_APPENDED,{type:type,frag:frag,part:part,chunkMeta:chunkMeta,parent:frag.type,timeRanges:timeRanges});},onError:function onError(error){// in case any error occured while appending, put back segment in segments table
var event={type:ErrorTypes.MEDIA_ERROR,parent:frag.type,details:ErrorDetails.BUFFER_APPEND_ERROR,sourceBufferName:type,frag:frag,part:part,chunkMeta:chunkMeta,error:error,err:error,fatal:false};if(error.code===DOMException.QUOTA_EXCEEDED_ERR){// QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
// let's stop appending any segments, and report BUFFER_FULL_ERROR error
event.details=ErrorDetails.BUFFER_FULL_ERROR;}else {var appendErrorCount=++_this48.appendErrors[type];event.details=ErrorDetails.BUFFER_APPEND_ERROR;/* with UHD content, we could get loop of quota exceeded error until
            browser is able to evict some data from sourcebuffer. Retrying can help recover.
          */_this48.warn("Failed ".concat(appendErrorCount,"/").concat(hls.config.appendErrorMaxRetry," times to append segment in \"").concat(type,"\" sourceBuffer"));if(appendErrorCount>=hls.config.appendErrorMaxRetry){event.fatal=true;}}hls.trigger(Events.ERROR,event);}};operationQueue.append(operation,type,!!this.pendingTracks[type]);}},{key:"onBufferFlushing",value:function onBufferFlushing(event,data){var _this49=this;var operationQueue=this.operationQueue;var flushOperation=function flushOperation(type){return {execute:_this49.removeExecutor.bind(_this49,type,data.startOffset,data.endOffset),onStart:function onStart(){// logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
},onComplete:function onComplete(){// logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
_this49.hls.trigger(Events.BUFFER_FLUSHED,{type:type});},onError:function onError(error){_this49.warn("Failed to remove from ".concat(type," SourceBuffer"),error);}};};if(data.type){operationQueue.append(flushOperation(data.type),data.type);}else {this.getSourceBufferTypes().forEach(function(type){operationQueue.append(flushOperation(type),type);});}}},{key:"onFragParsed",value:function onFragParsed(event,data){var _this50=this;var frag=data.frag,part=data.part;var buffersAppendedTo=[];var elementaryStreams=part?part.elementaryStreams:frag.elementaryStreams;if(elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO]){buffersAppendedTo.push('audiovideo');}else {if(elementaryStreams[ElementaryStreamTypes.AUDIO]){buffersAppendedTo.push('audio');}if(elementaryStreams[ElementaryStreamTypes.VIDEO]){buffersAppendedTo.push('video');}}var onUnblocked=function onUnblocked(){var now=self.performance.now();frag.stats.buffering.end=now;if(part){part.stats.buffering.end=now;}var stats=part?part.stats:frag.stats;_this50.hls.trigger(Events.FRAG_BUFFERED,{frag:frag,part:part,stats:stats,id:frag.type});};if(buffersAppendedTo.length===0){this.warn("Fragments must have at least one ElementaryStreamType set. type: ".concat(frag.type," level: ").concat(frag.level," sn: ").concat(frag.sn));}this.blockBuffers(onUnblocked,buffersAppendedTo);}},{key:"onFragChanged",value:function onFragChanged(event,data){this.trimBuffers();}// on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
// an undefined data.type will mark all buffers as EOS.
},{key:"onBufferEos",value:function onBufferEos(event,data){var _this51=this;var ended=this.getSourceBufferTypes().reduce(function(acc,type){var sb=_this51.sourceBuffer[type];if(sb&&(!data.type||data.type===type)){sb.ending=true;if(!sb.ended){sb.ended=true;_this51.log("".concat(type," sourceBuffer now EOS"));}}return acc&&!!(!sb||sb.ended);},true);if(ended){this.log("Queueing mediaSource.endOfStream()");this.blockBuffers(function(){_this51.getSourceBufferTypes().forEach(function(type){var sb=_this51.sourceBuffer[type];if(sb){sb.ending=false;}});var mediaSource=_this51.mediaSource;if(!mediaSource||mediaSource.readyState!=='open'){if(mediaSource){_this51.log("Could not call mediaSource.endOfStream(). mediaSource.readyState: ".concat(mediaSource.readyState));}return;}_this51.log("Calling mediaSource.endOfStream()");// Allow this to throw and be caught by the enqueueing function
mediaSource.endOfStream();});}}},{key:"onLevelUpdated",value:function onLevelUpdated(event,_ref19){var details=_ref19.details;if(!details.fragments.length){return;}this.details=details;if(this.getSourceBufferTypes().length){this.blockBuffers(this.updateMediaElementDuration.bind(this));}else {this.updateMediaElementDuration();}}},{key:"trimBuffers",value:function trimBuffers(){var hls=this.hls,details=this.details,media=this.media;if(!media||details===null){return;}var sourceBufferTypes=this.getSourceBufferTypes();if(!sourceBufferTypes.length){return;}var config=hls.config;var currentTime=media.currentTime;var targetDuration=details.levelTargetDuration;// Support for deprecated liveBackBufferLength
var backBufferLength=details.live&&config.liveBackBufferLength!==null?config.liveBackBufferLength:config.backBufferLength;if(isFiniteNumber(backBufferLength)&&backBufferLength>0){var maxBackBufferLength=Math.max(backBufferLength,targetDuration);var targetBackBufferPosition=Math.floor(currentTime/targetDuration)*targetDuration-maxBackBufferLength;this.flushBackBuffer(currentTime,targetDuration,targetBackBufferPosition);}if(isFiniteNumber(config.frontBufferFlushThreshold)&&config.frontBufferFlushThreshold>0){var frontBufferLength=Math.max(config.maxBufferLength,config.frontBufferFlushThreshold);var maxFrontBufferLength=Math.max(frontBufferLength,targetDuration);var targetFrontBufferPosition=Math.floor(currentTime/targetDuration)*targetDuration+maxFrontBufferLength;this.flushFrontBuffer(currentTime,targetDuration,targetFrontBufferPosition);}}},{key:"flushBackBuffer",value:function flushBackBuffer(currentTime,targetDuration,targetBackBufferPosition){var _this52=this;var details=this.details,sourceBuffer=this.sourceBuffer;var sourceBufferTypes=this.getSourceBufferTypes();sourceBufferTypes.forEach(function(type){var sb=sourceBuffer[type];if(sb){var buffered=BufferHelper.getBuffered(sb);// when target buffer start exceeds actual buffer start
if(buffered.length>0&&targetBackBufferPosition>buffered.start(0)){_this52.hls.trigger(Events.BACK_BUFFER_REACHED,{bufferEnd:targetBackBufferPosition});// Support for deprecated event:
if(details!=null&&details.live){_this52.hls.trigger(Events.LIVE_BACK_BUFFER_REACHED,{bufferEnd:targetBackBufferPosition});}else if(sb.ended&&buffered.end(buffered.length-1)-currentTime<targetDuration*2){_this52.log("Cannot flush ".concat(type," back buffer while SourceBuffer is in ended state"));return;}_this52.hls.trigger(Events.BUFFER_FLUSHING,{startOffset:0,endOffset:targetBackBufferPosition,type:type});}}});}},{key:"flushFrontBuffer",value:function flushFrontBuffer(currentTime,targetDuration,targetFrontBufferPosition){var _this53=this;var sourceBuffer=this.sourceBuffer;var sourceBufferTypes=this.getSourceBufferTypes();sourceBufferTypes.forEach(function(type){var sb=sourceBuffer[type];if(sb){var buffered=BufferHelper.getBuffered(sb);var numBufferedRanges=buffered.length;// The buffer is either empty or contiguous
if(numBufferedRanges<2){return;}var bufferStart=buffered.start(numBufferedRanges-1);var bufferEnd=buffered.end(numBufferedRanges-1);// No flush if we can tolerate the current buffer length or the current buffer range we would flush is contiguous with current position
if(targetFrontBufferPosition>bufferStart||currentTime>=bufferStart&&currentTime<=bufferEnd){return;}else if(sb.ended&&currentTime-bufferEnd<2*targetDuration){_this53.log("Cannot flush ".concat(type," front buffer while SourceBuffer is in ended state"));return;}_this53.hls.trigger(Events.BUFFER_FLUSHING,{startOffset:bufferStart,endOffset:Infinity,type:type});}});}/**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */},{key:"updateMediaElementDuration",value:function updateMediaElementDuration(){if(!this.details||!this.media||!this.mediaSource||this.mediaSource.readyState!=='open'){return;}var details=this.details,hls=this.hls,media=this.media,mediaSource=this.mediaSource;var levelDuration=details.fragments[0].start+details.totalduration;var mediaDuration=media.duration;var msDuration=isFiniteNumber(mediaSource.duration)?mediaSource.duration:0;if(details.live&&hls.config.liveDurationInfinity){// Override duration to Infinity
mediaSource.duration=Infinity;this.updateSeekableRange(details);}else if(levelDuration>msDuration&&levelDuration>mediaDuration||!isFiniteNumber(mediaDuration)){// levelDuration was the last value we set.
// not using mediaSource.duration as the browser may tweak this value
// only update Media Source duration if its value increase, this is to avoid
// flushing already buffered portion when switching between quality level
this.log("Updating Media Source duration to ".concat(levelDuration.toFixed(3)));mediaSource.duration=levelDuration;}}},{key:"updateSeekableRange",value:function updateSeekableRange(levelDetails){var mediaSource=this.mediaSource;var fragments=levelDetails.fragments;var len=fragments.length;if(len&&levelDetails.live&&mediaSource!=null&&mediaSource.setLiveSeekableRange){var start=Math.max(0,fragments[0].start);var end=Math.max(start,start+levelDetails.totalduration);this.log("Media Source duration is set to ".concat(mediaSource.duration,". Setting seekable range to ").concat(start,"-").concat(end,"."));mediaSource.setLiveSeekableRange(start,end);}}},{key:"checkPendingTracks",value:function checkPendingTracks(){var bufferCodecEventsExpected=this.bufferCodecEventsExpected,operationQueue=this.operationQueue,pendingTracks=this.pendingTracks;// Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
// This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
// data has been appended to existing ones.
// 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
var pendingTracksCount=Object.keys(pendingTracks).length;if(pendingTracksCount&&(!bufferCodecEventsExpected||pendingTracksCount===2||'audiovideo'in pendingTracks)){// ok, let's create them now !
this.createSourceBuffers(pendingTracks);this.pendingTracks={};// append any pending segments now !
var buffers=this.getSourceBufferTypes();if(buffers.length){this.hls.trigger(Events.BUFFER_CREATED,{tracks:this.tracks});buffers.forEach(function(type){operationQueue.executeNext(type);});}else {var error=new Error('could not create source buffer for media codec(s)');this.hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,fatal:true,error:error,reason:error.message});}}}},{key:"createSourceBuffers",value:function createSourceBuffers(tracks){var _this54=this;var sourceBuffer=this.sourceBuffer,mediaSource=this.mediaSource;if(!mediaSource){throw Error('createSourceBuffers called when mediaSource was null');}var _loop6=function _loop6(trackName){if(!sourceBuffer[trackName]){var track=tracks[trackName];if(!track){throw Error("source buffer exists for track ".concat(trackName,", however track does not"));}// use levelCodec as first priority unless it contains multiple comma-separated codec values
var codec=((_track$levelCodec=track.levelCodec)==null?void 0:_track$levelCodec.indexOf(','))===-1?track.levelCodec:track.codec;if(codec){if(trackName.slice(0,5)==='audio'){codec=getCodecCompatibleName(codec,_this54.appendSource);}}var mimeType="".concat(track.container,";codecs=").concat(codec);_this54.log("creating sourceBuffer(".concat(mimeType,")"));try{var sb=sourceBuffer[trackName]=mediaSource.addSourceBuffer(mimeType);var sbName=trackName;_this54.addBufferListener(sbName,'updatestart',_this54._onSBUpdateStart);_this54.addBufferListener(sbName,'updateend',_this54._onSBUpdateEnd);_this54.addBufferListener(sbName,'error',_this54._onSBUpdateError);// ManagedSourceBuffer bufferedchange event
if(_this54.appendSource){_this54.addBufferListener(sbName,'bufferedchange',function(type,event){// If media was ejected check for a change. Added ranges are redundant with changes on 'updateend' event.
var removedRanges=event.removedRanges;if(removedRanges!=null&&removedRanges.length){_this54.hls.trigger(Events.BUFFER_FLUSHED,{type:trackName});}});}_this54.tracks[trackName]={buffer:sb,codec:codec,container:track.container,levelCodec:track.levelCodec,metadata:track.metadata,id:track.id};}catch(err){_this54.error("error while trying to add sourceBuffer: ".concat(err.message));_this54.hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.BUFFER_ADD_CODEC_ERROR,fatal:false,error:err,sourceBufferName:trackName,mimeType:mimeType});}}},_track$levelCodec;for(var trackName in tracks){_loop6(trackName);}}},{key:"mediaSrc",get:function get(){var _this$media,_this$media$querySele;var media=((_this$media=this.media)==null?void 0:(_this$media$querySele=_this$media.querySelector)==null?void 0:_this$media$querySele.call(_this$media,'source'))||this.media;return media==null?void 0:media.src;}},{key:"_onSBUpdateStart",value:function _onSBUpdateStart(type){var operationQueue=this.operationQueue;var operation=operationQueue.current(type);operation.onStart();}},{key:"_onSBUpdateEnd",value:function _onSBUpdateEnd(type){var _this$mediaSource2;if(((_this$mediaSource2=this.mediaSource)==null?void 0:_this$mediaSource2.readyState)==='closed'){this.resetBuffer(type);return;}var operationQueue=this.operationQueue;var operation=operationQueue.current(type);operation.onComplete();operationQueue.shiftAndExecuteNext(type);}},{key:"_onSBUpdateError",value:function _onSBUpdateError(type,event){var _this$mediaSource3;var error=new Error("".concat(type," SourceBuffer error. MediaSource readyState: ").concat((_this$mediaSource3=this.mediaSource)==null?void 0:_this$mediaSource3.readyState));this.error("".concat(error),event);// according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
// SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
this.hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.BUFFER_APPENDING_ERROR,sourceBufferName:type,error:error,fatal:false});// updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
var operation=this.operationQueue.current(type);if(operation){operation.onError(error);}}// This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
},{key:"removeExecutor",value:function removeExecutor(type,startOffset,endOffset){var media=this.media,mediaSource=this.mediaSource,operationQueue=this.operationQueue,sourceBuffer=this.sourceBuffer;var sb=sourceBuffer[type];if(!media||!mediaSource||!sb){this.warn("Attempting to remove from the ".concat(type," SourceBuffer, but it does not exist"));operationQueue.shiftAndExecuteNext(type);return;}var mediaDuration=isFiniteNumber(media.duration)?media.duration:Infinity;var msDuration=isFiniteNumber(mediaSource.duration)?mediaSource.duration:Infinity;var removeStart=Math.max(0,startOffset);var removeEnd=Math.min(endOffset,mediaDuration,msDuration);if(removeEnd>removeStart&&(!sb.ending||sb.ended)){sb.ended=false;this.log("Removing [".concat(removeStart,",").concat(removeEnd,"] from the ").concat(type," SourceBuffer"));sb.remove(removeStart,removeEnd);}else {// Cycle the queue
operationQueue.shiftAndExecuteNext(type);}}// This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
},{key:"appendExecutor",value:function appendExecutor(data,type){var sb=this.sourceBuffer[type];if(!sb){if(!this.pendingTracks[type]){throw new Error("Attempting to append to the ".concat(type," SourceBuffer, but it does not exist"));}return;}sb.ended=false;sb.appendBuffer(data);}// Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
// resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
// upon completion, since we already do it here
},{key:"blockBuffers",value:function blockBuffers(onUnblocked){var _this55=this;var buffers=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.getSourceBufferTypes();if(!buffers.length){this.log('Blocking operation requested, but no SourceBuffers exist');Promise.resolve().then(onUnblocked);return;}var operationQueue=this.operationQueue;// logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
var blockingOperations=buffers.map(function(type){return operationQueue.appendBlocker(type);});Promise.all(blockingOperations).then(function(){// logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
onUnblocked();buffers.forEach(function(type){var sb=_this55.sourceBuffer[type];// Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
// true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
// While this is a workaround, it's probably useful to have around
if(!(sb!=null&&sb.updating)){operationQueue.shiftAndExecuteNext(type);}});});}},{key:"getSourceBufferTypes",value:function getSourceBufferTypes(){return Object.keys(this.sourceBuffer);}},{key:"addBufferListener",value:function addBufferListener(type,event,fn){var buffer=this.sourceBuffer[type];if(!buffer){return;}var listener=fn.bind(this,type);this.listeners[type].push({event:event,listener:listener});buffer.addEventListener(event,listener);}},{key:"removeBufferListeners",value:function removeBufferListeners(type){var buffer=this.sourceBuffer[type];if(!buffer){return;}this.listeners[type].forEach(function(l){buffer.removeEventListener(l.event,l.listener);});}}]);return BufferController;}();function removeSourceChildren(node){var sourceChildren=node.querySelectorAll('source');[].slice.call(sourceChildren).forEach(function(source){node.removeChild(source);});}function addSource(media,url){var source=self.document.createElement('source');source.type='video/mp4';source.src=url;media.appendChild(source);}/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */ /**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */var specialCea608CharsCodes={0x2a:0xe1,// lowercase a, acute accent
0x5c:0xe9,// lowercase e, acute accent
0x5e:0xed,// lowercase i, acute accent
0x5f:0xf3,// lowercase o, acute accent
0x60:0xfa,// lowercase u, acute accent
0x7b:0xe7,// lowercase c with cedilla
0x7c:0xf7,// division symbol
0x7d:0xd1,// uppercase N tilde
0x7e:0xf1,// lowercase n tilde
0x7f:0x2588,// Full block
// THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
// THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
// THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
0x80:0xae,// Registered symbol (R)
0x81:0xb0,// degree sign
0x82:0xbd,// 1/2 symbol
0x83:0xbf,// Inverted (open) question mark
0x84:0x2122,// Trademark symbol (TM)
0x85:0xa2,// Cents symbol
0x86:0xa3,// Pounds sterling
0x87:0x266a,// Music 8'th note
0x88:0xe0,// lowercase a, grave accent
0x89:0x20,// transparent space (regular)
0x8a:0xe8,// lowercase e, grave accent
0x8b:0xe2,// lowercase a, circumflex accent
0x8c:0xea,// lowercase e, circumflex accent
0x8d:0xee,// lowercase i, circumflex accent
0x8e:0xf4,// lowercase o, circumflex accent
0x8f:0xfb,// lowercase u, circumflex accent
// THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
// THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
0x90:0xc1,// capital letter A with acute
0x91:0xc9,// capital letter E with acute
0x92:0xd3,// capital letter O with acute
0x93:0xda,// capital letter U with acute
0x94:0xdc,// capital letter U with diaresis
0x95:0xfc,// lowercase letter U with diaeresis
0x96:0x2018,// opening single quote
0x97:0xa1,// inverted exclamation mark
0x98:0x2a,// asterisk
0x99:0x2019,// closing single quote
0x9a:0x2501,// box drawings heavy horizontal
0x9b:0xa9,// copyright sign
0x9c:0x2120,// Service mark
0x9d:0x2022,// (round) bullet
0x9e:0x201c,// Left double quotation mark
0x9f:0x201d,// Right double quotation mark
0xa0:0xc0,// uppercase A, grave accent
0xa1:0xc2,// uppercase A, circumflex
0xa2:0xc7,// uppercase C with cedilla
0xa3:0xc8,// uppercase E, grave accent
0xa4:0xca,// uppercase E, circumflex
0xa5:0xcb,// capital letter E with diaresis
0xa6:0xeb,// lowercase letter e with diaresis
0xa7:0xce,// uppercase I, circumflex
0xa8:0xcf,// uppercase I, with diaresis
0xa9:0xef,// lowercase i, with diaresis
0xaa:0xd4,// uppercase O, circumflex
0xab:0xd9,// uppercase U, grave accent
0xac:0xf9,// lowercase u, grave accent
0xad:0xdb,// uppercase U, circumflex
0xae:0xab,// left-pointing double angle quotation mark
0xaf:0xbb,// right-pointing double angle quotation mark
// THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
// THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
0xb0:0xc3,// Uppercase A, tilde
0xb1:0xe3,// Lowercase a, tilde
0xb2:0xcd,// Uppercase I, acute accent
0xb3:0xcc,// Uppercase I, grave accent
0xb4:0xec,// Lowercase i, grave accent
0xb5:0xd2,// Uppercase O, grave accent
0xb6:0xf2,// Lowercase o, grave accent
0xb7:0xd5,// Uppercase O, tilde
0xb8:0xf5,// Lowercase o, tilde
0xb9:0x7b,// Open curly brace
0xba:0x7d,// Closing curly brace
0xbb:0x5c,// Backslash
0xbc:0x5e,// Caret
0xbd:0x5f,// Underscore
0xbe:0x7c,// Pipe (vertical line)
0xbf:0x223c,// Tilde operator
0xc0:0xc4,// Uppercase A, umlaut
0xc1:0xe4,// Lowercase A, umlaut
0xc2:0xd6,// Uppercase O, umlaut
0xc3:0xf6,// Lowercase o, umlaut
0xc4:0xdf,// Esszett (sharp S)
0xc5:0xa5,// Yen symbol
0xc6:0xa4,// Generic currency sign
0xc7:0x2503,// Box drawings heavy vertical
0xc8:0xc5,// Uppercase A, ring
0xc9:0xe5,// Lowercase A, ring
0xca:0xd8,// Uppercase O, stroke
0xcb:0xf8,// Lowercase o, strok
0xcc:0x250f,// Box drawings heavy down and right
0xcd:0x2513,// Box drawings heavy down and left
0xce:0x2517,// Box drawings heavy up and right
0xcf:0x251b// Box drawings heavy up and left
};/**
 * Utils
 */var getCharForByte=function getCharForByte(_byte3){return String.fromCharCode(specialCea608CharsCodes[_byte3]||_byte3);};var NR_ROWS=15;var NR_COLS=100;// Tables to look up row from PAC data
var rowsLowCh1={0x11:1,0x12:3,0x15:5,0x16:7,0x17:9,0x10:11,0x13:12,0x14:14};var rowsHighCh1={0x11:2,0x12:4,0x15:6,0x16:8,0x17:10,0x13:13,0x14:15};var rowsLowCh2={0x19:1,0x1a:3,0x1d:5,0x1e:7,0x1f:9,0x18:11,0x1b:12,0x1c:14};var rowsHighCh2={0x19:2,0x1a:4,0x1d:6,0x1e:8,0x1f:10,0x1b:13,0x1c:15};var backgroundColors=['white','green','blue','cyan','red','yellow','magenta','black','transparent'];var CaptionsLogger=/*#__PURE__*/function(){function CaptionsLogger(){_classCallCheck(this,CaptionsLogger);this.time=null;this.verboseLevel=0;}_createClass(CaptionsLogger,[{key:"log",value:function log(severity,msg){if(this.verboseLevel>=severity){var m=typeof msg==='function'?msg():msg;logger.log("".concat(this.time," [").concat(severity,"] ").concat(m));}}}]);return CaptionsLogger;}();var numArrayToHexArray=function numArrayToHexArray(numArray){var hexArray=[];for(var j=0;j<numArray.length;j++){hexArray.push(numArray[j].toString(16));}return hexArray;};var PenState=/*#__PURE__*/function(){function PenState(){_classCallCheck(this,PenState);this.foreground='white';this.underline=false;this.italics=false;this.background='black';this.flash=false;}_createClass(PenState,[{key:"reset",value:function reset(){this.foreground='white';this.underline=false;this.italics=false;this.background='black';this.flash=false;}},{key:"setStyles",value:function setStyles(styles){var attribs=['foreground','underline','italics','background','flash'];for(var i=0;i<attribs.length;i++){var style=attribs[i];if(styles.hasOwnProperty(style)){this[style]=styles[style];}}}},{key:"isDefault",value:function isDefault(){return this.foreground==='white'&&!this.underline&&!this.italics&&this.background==='black'&&!this.flash;}},{key:"equals",value:function equals(other){return this.foreground===other.foreground&&this.underline===other.underline&&this.italics===other.italics&&this.background===other.background&&this.flash===other.flash;}},{key:"copy",value:function copy(newPenState){this.foreground=newPenState.foreground;this.underline=newPenState.underline;this.italics=newPenState.italics;this.background=newPenState.background;this.flash=newPenState.flash;}},{key:"toString",value:function toString(){return 'color='+this.foreground+', underline='+this.underline+', italics='+this.italics+', background='+this.background+', flash='+this.flash;}}]);return PenState;}();/**
 * Unicode character with styling and background.
 * @constructor
 */var StyledUnicodeChar=/*#__PURE__*/function(){function StyledUnicodeChar(){_classCallCheck(this,StyledUnicodeChar);this.uchar=' ';this.penState=new PenState();}_createClass(StyledUnicodeChar,[{key:"reset",value:function reset(){this.uchar=' ';this.penState.reset();}},{key:"setChar",value:function setChar(uchar,newPenState){this.uchar=uchar;this.penState.copy(newPenState);}},{key:"setPenState",value:function setPenState(newPenState){this.penState.copy(newPenState);}},{key:"equals",value:function equals(other){return this.uchar===other.uchar&&this.penState.equals(other.penState);}},{key:"copy",value:function copy(newChar){this.uchar=newChar.uchar;this.penState.copy(newChar.penState);}},{key:"isEmpty",value:function isEmpty(){return this.uchar===' '&&this.penState.isDefault();}}]);return StyledUnicodeChar;}();/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */var Row=/*#__PURE__*/function(){function Row(logger){_classCallCheck(this,Row);this.chars=[];this.pos=0;this.currPenState=new PenState();this.cueStartTime=null;this.logger=void 0;for(var i=0;i<NR_COLS;i++){this.chars.push(new StyledUnicodeChar());}this.logger=logger;}_createClass(Row,[{key:"equals",value:function equals(other){for(var i=0;i<NR_COLS;i++){if(!this.chars[i].equals(other.chars[i])){return false;}}return true;}},{key:"copy",value:function copy(other){for(var i=0;i<NR_COLS;i++){this.chars[i].copy(other.chars[i]);}}},{key:"isEmpty",value:function isEmpty(){var empty=true;for(var i=0;i<NR_COLS;i++){if(!this.chars[i].isEmpty()){empty=false;break;}}return empty;}/**
   *  Set the cursor to a valid column.
   */},{key:"setCursor",value:function setCursor(absPos){if(this.pos!==absPos){this.pos=absPos;}if(this.pos<0){this.logger.log(3,'Negative cursor position '+this.pos);this.pos=0;}else if(this.pos>NR_COLS){this.logger.log(3,'Too large cursor position '+this.pos);this.pos=NR_COLS;}}/**
   * Move the cursor relative to current position.
   */},{key:"moveCursor",value:function moveCursor(relPos){var newPos=this.pos+relPos;if(relPos>1){for(var i=this.pos+1;i<newPos+1;i++){this.chars[i].setPenState(this.currPenState);}}this.setCursor(newPos);}/**
   * Backspace, move one step back and clear character.
   */},{key:"backSpace",value:function backSpace(){this.moveCursor(-1);this.chars[this.pos].setChar(' ',this.currPenState);}},{key:"insertChar",value:function insertChar(_byte4){var _this56=this;if(_byte4>=0x90){// Extended char
this.backSpace();}var _char=getCharForByte(_byte4);if(this.pos>=NR_COLS){this.logger.log(0,function(){return 'Cannot insert '+_byte4.toString(16)+' ('+_char+') at position '+_this56.pos+'. Skipping it!';});return;}this.chars[this.pos].setChar(_char,this.currPenState);this.moveCursor(1);}},{key:"clearFromPos",value:function clearFromPos(startPos){var i;for(i=startPos;i<NR_COLS;i++){this.chars[i].reset();}}},{key:"clear",value:function clear(){this.clearFromPos(0);this.pos=0;this.currPenState.reset();}},{key:"clearToEndOfRow",value:function clearToEndOfRow(){this.clearFromPos(this.pos);}},{key:"getTextString",value:function getTextString(){var chars=[];var empty=true;for(var i=0;i<NR_COLS;i++){var _char2=this.chars[i].uchar;if(_char2!==' '){empty=false;}chars.push(_char2);}if(empty){return '';}else {return chars.join('');}}},{key:"setPenStyles",value:function setPenStyles(styles){this.currPenState.setStyles(styles);var currChar=this.chars[this.pos];currChar.setPenState(this.currPenState);}}]);return Row;}();/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
 */var CaptionScreen=/*#__PURE__*/function(){function CaptionScreen(logger){_classCallCheck(this,CaptionScreen);this.rows=[];this.currRow=NR_ROWS-1;this.nrRollUpRows=null;this.lastOutputScreen=null;this.logger=void 0;for(var i=0;i<NR_ROWS;i++){this.rows.push(new Row(logger));}this.logger=logger;}_createClass(CaptionScreen,[{key:"reset",value:function reset(){for(var i=0;i<NR_ROWS;i++){this.rows[i].clear();}this.currRow=NR_ROWS-1;}},{key:"equals",value:function equals(other){var equal=true;for(var i=0;i<NR_ROWS;i++){if(!this.rows[i].equals(other.rows[i])){equal=false;break;}}return equal;}},{key:"copy",value:function copy(other){for(var i=0;i<NR_ROWS;i++){this.rows[i].copy(other.rows[i]);}}},{key:"isEmpty",value:function isEmpty(){var empty=true;for(var i=0;i<NR_ROWS;i++){if(!this.rows[i].isEmpty()){empty=false;break;}}return empty;}},{key:"backSpace",value:function backSpace(){var row=this.rows[this.currRow];row.backSpace();}},{key:"clearToEndOfRow",value:function clearToEndOfRow(){var row=this.rows[this.currRow];row.clearToEndOfRow();}/**
   * Insert a character (without styling) in the current row.
   */},{key:"insertChar",value:function insertChar(_char3){var row=this.rows[this.currRow];row.insertChar(_char3);}},{key:"setPen",value:function setPen(styles){var row=this.rows[this.currRow];row.setPenStyles(styles);}},{key:"moveCursor",value:function moveCursor(relPos){var row=this.rows[this.currRow];row.moveCursor(relPos);}},{key:"setCursor",value:function setCursor(absPos){this.logger.log(2,'setCursor: '+absPos);var row=this.rows[this.currRow];row.setCursor(absPos);}},{key:"setPAC",value:function setPAC(pacData){this.logger.log(2,function(){return 'pacData = '+JSON.stringify(pacData);});var newRow=pacData.row-1;if(this.nrRollUpRows&&newRow<this.nrRollUpRows-1){newRow=this.nrRollUpRows-1;}// Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
if(this.nrRollUpRows&&this.currRow!==newRow){// clear all rows first
for(var i=0;i<NR_ROWS;i++){this.rows[i].clear();}// Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
// topRowIndex - the start of rows to copy (inclusive index)
var topRowIndex=this.currRow+1-this.nrRollUpRows;// We only copy if the last position was already shown.
// We use the cueStartTime value to check this.
var lastOutputScreen=this.lastOutputScreen;if(lastOutputScreen){var prevLineTime=lastOutputScreen.rows[topRowIndex].cueStartTime;var time=this.logger.time;if(prevLineTime!==null&&time!==null&&prevLineTime<time){for(var _i20=0;_i20<this.nrRollUpRows;_i20++){this.rows[newRow-this.nrRollUpRows+_i20+1].copy(lastOutputScreen.rows[topRowIndex+_i20]);}}}}this.currRow=newRow;var row=this.rows[this.currRow];if(pacData.indent!==null){var indent=pacData.indent;var prevPos=Math.max(indent-1,0);row.setCursor(pacData.indent);pacData.color=row.chars[prevPos].penState.foreground;}var styles={foreground:pacData.color,underline:pacData.underline,italics:pacData.italics,background:'black',flash:false};this.setPen(styles);}/**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */},{key:"setBkgData",value:function setBkgData(bkgData){this.logger.log(2,function(){return 'bkgData = '+JSON.stringify(bkgData);});this.backSpace();this.setPen(bkgData);this.insertChar(0x20);// Space
}},{key:"setRollUpRows",value:function setRollUpRows(nrRows){this.nrRollUpRows=nrRows;}},{key:"rollUp",value:function rollUp(){var _this57=this;if(this.nrRollUpRows===null){this.logger.log(3,'roll_up but nrRollUpRows not set yet');return;// Not properly setup
}this.logger.log(1,function(){return _this57.getDisplayText();});var topRowIndex=this.currRow+1-this.nrRollUpRows;var topRow=this.rows.splice(topRowIndex,1)[0];topRow.clear();this.rows.splice(this.currRow,0,topRow);this.logger.log(2,'Rolling up');// this.logger.log(VerboseLevel.TEXT, this.get_display_text())
}/**
   * Get all non-empty rows with as unicode text.
   */},{key:"getDisplayText",value:function getDisplayText(asOneRow){asOneRow=asOneRow||false;var displayText=[];var text='';var rowNr=-1;for(var i=0;i<NR_ROWS;i++){var rowText=this.rows[i].getTextString();if(rowText){rowNr=i+1;if(asOneRow){displayText.push('Row '+rowNr+": '"+rowText+"'");}else {displayText.push(rowText.trim());}}}if(displayText.length>0){if(asOneRow){text='['+displayText.join(' | ')+']';}else {text=displayText.join('\n');}}return text;}},{key:"getTextAndFormat",value:function getTextAndFormat(){return this.rows;}}]);return CaptionScreen;}();// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
var Cea608Channel=/*#__PURE__*/function(){function Cea608Channel(channelNumber,outputFilter,logger){_classCallCheck(this,Cea608Channel);this.chNr=void 0;this.outputFilter=void 0;this.mode=void 0;this.verbose=void 0;this.displayedMemory=void 0;this.nonDisplayedMemory=void 0;this.lastOutputScreen=void 0;this.currRollUpRow=void 0;this.writeScreen=void 0;this.cueStartTime=void 0;this.logger=void 0;this.chNr=channelNumber;this.outputFilter=outputFilter;this.mode=null;this.verbose=0;this.displayedMemory=new CaptionScreen(logger);this.nonDisplayedMemory=new CaptionScreen(logger);this.lastOutputScreen=new CaptionScreen(logger);this.currRollUpRow=this.displayedMemory.rows[NR_ROWS-1];this.writeScreen=this.displayedMemory;this.mode=null;this.cueStartTime=null;// Keeps track of where a cue started.
this.logger=logger;}_createClass(Cea608Channel,[{key:"reset",value:function reset(){this.mode=null;this.displayedMemory.reset();this.nonDisplayedMemory.reset();this.lastOutputScreen.reset();this.outputFilter.reset();this.currRollUpRow=this.displayedMemory.rows[NR_ROWS-1];this.writeScreen=this.displayedMemory;this.mode=null;this.cueStartTime=null;}},{key:"getHandler",value:function getHandler(){return this.outputFilter;}},{key:"setHandler",value:function setHandler(newHandler){this.outputFilter=newHandler;}},{key:"setPAC",value:function setPAC(pacData){this.writeScreen.setPAC(pacData);}},{key:"setBkgData",value:function setBkgData(bkgData){this.writeScreen.setBkgData(bkgData);}},{key:"setMode",value:function setMode(newMode){if(newMode===this.mode){return;}this.mode=newMode;this.logger.log(2,function(){return 'MODE='+newMode;});if(this.mode==='MODE_POP-ON'){this.writeScreen=this.nonDisplayedMemory;}else {this.writeScreen=this.displayedMemory;this.writeScreen.reset();}if(this.mode!=='MODE_ROLL-UP'){this.displayedMemory.nrRollUpRows=null;this.nonDisplayedMemory.nrRollUpRows=null;}this.mode=newMode;}},{key:"insertChars",value:function insertChars(chars){var _this58=this;for(var i=0;i<chars.length;i++){this.writeScreen.insertChar(chars[i]);}var screen=this.writeScreen===this.displayedMemory?'DISP':'NON_DISP';this.logger.log(2,function(){return screen+': '+_this58.writeScreen.getDisplayText(true);});if(this.mode==='MODE_PAINT-ON'||this.mode==='MODE_ROLL-UP'){this.logger.log(1,function(){return 'DISPLAYED: '+_this58.displayedMemory.getDisplayText(true);});this.outputDataUpdate();}}},{key:"ccRCL",value:function ccRCL(){// Resume Caption Loading (switch mode to Pop On)
this.logger.log(2,'RCL - Resume Caption Loading');this.setMode('MODE_POP-ON');}},{key:"ccBS",value:function ccBS(){// BackSpace
this.logger.log(2,'BS - BackSpace');if(this.mode==='MODE_TEXT'){return;}this.writeScreen.backSpace();if(this.writeScreen===this.displayedMemory){this.outputDataUpdate();}}},{key:"ccAOF",value:function ccAOF(){// Reserved (formerly Alarm Off)
}},{key:"ccAON",value:function ccAON(){// Reserved (formerly Alarm On)
}},{key:"ccDER",value:function ccDER(){// Delete to End of Row
this.logger.log(2,'DER- Delete to End of Row');this.writeScreen.clearToEndOfRow();this.outputDataUpdate();}},{key:"ccRU",value:function ccRU(nrRows){// Roll-Up Captions-2,3,or 4 Rows
this.logger.log(2,'RU('+nrRows+') - Roll Up');this.writeScreen=this.displayedMemory;this.setMode('MODE_ROLL-UP');this.writeScreen.setRollUpRows(nrRows);}},{key:"ccFON",value:function ccFON(){// Flash On
this.logger.log(2,'FON - Flash On');this.writeScreen.setPen({flash:true});}},{key:"ccRDC",value:function ccRDC(){// Resume Direct Captioning (switch mode to PaintOn)
this.logger.log(2,'RDC - Resume Direct Captioning');this.setMode('MODE_PAINT-ON');}},{key:"ccTR",value:function ccTR(){// Text Restart in text mode (not supported, however)
this.logger.log(2,'TR');this.setMode('MODE_TEXT');}},{key:"ccRTD",value:function ccRTD(){// Resume Text Display in Text mode (not supported, however)
this.logger.log(2,'RTD');this.setMode('MODE_TEXT');}},{key:"ccEDM",value:function ccEDM(){// Erase Displayed Memory
this.logger.log(2,'EDM - Erase Displayed Memory');this.displayedMemory.reset();this.outputDataUpdate(true);}},{key:"ccCR",value:function ccCR(){// Carriage Return
this.logger.log(2,'CR - Carriage Return');this.writeScreen.rollUp();this.outputDataUpdate(true);}},{key:"ccENM",value:function ccENM(){// Erase Non-Displayed Memory
this.logger.log(2,'ENM - Erase Non-displayed Memory');this.nonDisplayedMemory.reset();}},{key:"ccEOC",value:function ccEOC(){var _this59=this;// End of Caption (Flip Memories)
this.logger.log(2,'EOC - End Of Caption');if(this.mode==='MODE_POP-ON'){var tmp=this.displayedMemory;this.displayedMemory=this.nonDisplayedMemory;this.nonDisplayedMemory=tmp;this.writeScreen=this.nonDisplayedMemory;this.logger.log(1,function(){return 'DISP: '+_this59.displayedMemory.getDisplayText();});}this.outputDataUpdate(true);}},{key:"ccTO",value:function ccTO(nrCols){// Tab Offset 1,2, or 3 columns
this.logger.log(2,'TO('+nrCols+') - Tab Offset');this.writeScreen.moveCursor(nrCols);}},{key:"ccMIDROW",value:function ccMIDROW(secondByte){// Parse MIDROW command
var styles={flash:false};styles.underline=secondByte%2===1;styles.italics=secondByte>=0x2e;if(!styles.italics){var colorIndex=Math.floor(secondByte/2)-0x10;var colors=['white','green','blue','cyan','red','yellow','magenta'];styles.foreground=colors[colorIndex];}else {styles.foreground='white';}this.logger.log(2,'MIDROW: '+JSON.stringify(styles));this.writeScreen.setPen(styles);}},{key:"outputDataUpdate",value:function outputDataUpdate(){var dispatch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var time=this.logger.time;if(time===null){return;}if(this.outputFilter){if(this.cueStartTime===null&&!this.displayedMemory.isEmpty()){// Start of a new cue
this.cueStartTime=time;}else {if(!this.displayedMemory.equals(this.lastOutputScreen)){this.outputFilter.newCue(this.cueStartTime,time,this.lastOutputScreen);if(dispatch&&this.outputFilter.dispatchCue){this.outputFilter.dispatchCue();}this.cueStartTime=this.displayedMemory.isEmpty()?null:time;}}this.lastOutputScreen.copy(this.displayedMemory);}}},{key:"cueSplitAtTime",value:function cueSplitAtTime(t){if(this.outputFilter){if(!this.displayedMemory.isEmpty()){if(this.outputFilter.newCue){this.outputFilter.newCue(this.cueStartTime,t,this.displayedMemory);}this.cueStartTime=t;}}}}]);return Cea608Channel;}();// Will be 1 or 2 when parsing captions
var Cea608Parser=/*#__PURE__*/function(){function Cea608Parser(field,out1,out2){_classCallCheck(this,Cea608Parser);this.channels=void 0;this.currentChannel=0;this.cmdHistory=createCmdHistory();this.logger=void 0;var logger=this.logger=new CaptionsLogger();this.channels=[null,new Cea608Channel(field,out1,logger),new Cea608Channel(field+1,out2,logger)];}_createClass(Cea608Parser,[{key:"getHandler",value:function getHandler(channel){return this.channels[channel].getHandler();}},{key:"setHandler",value:function setHandler(channel,newHandler){this.channels[channel].setHandler(newHandler);}/**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */},{key:"addData",value:function addData(time,byteList){var _this60=this;this.logger.time=time;var _loop7=function _loop7(i){var a=byteList[i]&0x7f;var b=byteList[i+1]&0x7f;var cmdFound=false;var charsFound=null;if(a===0&&b===0){return 0;// continue
}else {_this60.logger.log(3,function(){return '['+numArrayToHexArray([byteList[i],byteList[i+1]])+'] -> ('+numArrayToHexArray([a,b])+')';});}var cmdHistory=_this60.cmdHistory;var isControlCode=a>=0x10&&a<=0x1f;if(isControlCode){// Skip redundant control codes
if(hasCmdRepeated(a,b,cmdHistory)){setLastCmd(null,null,cmdHistory);_this60.logger.log(3,function(){return 'Repeated command ('+numArrayToHexArray([a,b])+') is dropped';});return 0;// continue
}setLastCmd(a,b,_this60.cmdHistory);cmdFound=_this60.parseCmd(a,b);if(!cmdFound){cmdFound=_this60.parseMidrow(a,b);}if(!cmdFound){cmdFound=_this60.parsePAC(a,b);}if(!cmdFound){cmdFound=_this60.parseBackgroundAttributes(a,b);}}else {setLastCmd(null,null,cmdHistory);}if(!cmdFound){charsFound=_this60.parseChars(a,b);if(charsFound){var currChNr=_this60.currentChannel;if(currChNr&&currChNr>0){var channel=_this60.channels[currChNr];channel.insertChars(charsFound);}else {_this60.logger.log(2,'No channel found yet. TEXT-MODE?');}}}if(!cmdFound&&!charsFound){_this60.logger.log(2,function(){return "Couldn't parse cleaned data "+numArrayToHexArray([a,b])+' orig: '+numArrayToHexArray([byteList[i],byteList[i+1]]);});}},_ret3;for(var i=0;i<byteList.length;i+=2){_ret3=_loop7(i);if(_ret3===0)continue;}}/**
   * Parse Command.
   * @returns True if a command was found
   */},{key:"parseCmd",value:function parseCmd(a,b){var cond1=(a===0x14||a===0x1c||a===0x15||a===0x1d)&&b>=0x20&&b<=0x2f;var cond2=(a===0x17||a===0x1f)&&b>=0x21&&b<=0x23;if(!(cond1||cond2)){return false;}var chNr=a===0x14||a===0x15||a===0x17?1:2;var channel=this.channels[chNr];if(a===0x14||a===0x15||a===0x1c||a===0x1d){if(b===0x20){channel.ccRCL();}else if(b===0x21){channel.ccBS();}else if(b===0x22){channel.ccAOF();}else if(b===0x23){channel.ccAON();}else if(b===0x24){channel.ccDER();}else if(b===0x25){channel.ccRU(2);}else if(b===0x26){channel.ccRU(3);}else if(b===0x27){channel.ccRU(4);}else if(b===0x28){channel.ccFON();}else if(b===0x29){channel.ccRDC();}else if(b===0x2a){channel.ccTR();}else if(b===0x2b){channel.ccRTD();}else if(b===0x2c){channel.ccEDM();}else if(b===0x2d){channel.ccCR();}else if(b===0x2e){channel.ccENM();}else if(b===0x2f){channel.ccEOC();}}else {// a == 0x17 || a == 0x1F
channel.ccTO(b-0x20);}this.currentChannel=chNr;return true;}/**
   * Parse midrow styling command
   */},{key:"parseMidrow",value:function parseMidrow(a,b){var chNr=0;if((a===0x11||a===0x19)&&b>=0x20&&b<=0x2f){if(a===0x11){chNr=1;}else {chNr=2;}if(chNr!==this.currentChannel){this.logger.log(0,'Mismatch channel in midrow parsing');return false;}var channel=this.channels[chNr];if(!channel){return false;}channel.ccMIDROW(b);this.logger.log(3,function(){return 'MIDROW ('+numArrayToHexArray([a,b])+')';});return true;}return false;}/**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */},{key:"parsePAC",value:function parsePAC(a,b){var row;var case1=(a>=0x11&&a<=0x17||a>=0x19&&a<=0x1f)&&b>=0x40&&b<=0x7f;var case2=(a===0x10||a===0x18)&&b>=0x40&&b<=0x5f;if(!(case1||case2)){return false;}var chNr=a<=0x17?1:2;if(b>=0x40&&b<=0x5f){row=chNr===1?rowsLowCh1[a]:rowsLowCh2[a];}else {// 0x60 <= b <= 0x7F
row=chNr===1?rowsHighCh1[a]:rowsHighCh2[a];}var channel=this.channels[chNr];if(!channel){return false;}channel.setPAC(this.interpretPAC(row,b));this.currentChannel=chNr;return true;}/**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */},{key:"interpretPAC",value:function interpretPAC(row,_byte5){var pacIndex;var pacData={color:null,italics:false,indent:null,underline:false,row:row};if(_byte5>0x5f){pacIndex=_byte5-0x60;}else {pacIndex=_byte5-0x40;}pacData.underline=(pacIndex&1)===1;if(pacIndex<=0xd){pacData.color=['white','green','blue','cyan','red','yellow','magenta','white'][Math.floor(pacIndex/2)];}else if(pacIndex<=0xf){pacData.italics=true;pacData.color='white';}else {pacData.indent=Math.floor((pacIndex-0x10)/2)*4;}return pacData;// Note that row has zero offset. The spec uses 1.
}/**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */},{key:"parseChars",value:function parseChars(a,b){var channelNr;var charCodes=null;var charCode1=null;if(a>=0x19){channelNr=2;charCode1=a-8;}else {channelNr=1;charCode1=a;}if(charCode1>=0x11&&charCode1<=0x13){// Special character
var oneCode;if(charCode1===0x11){oneCode=b+0x50;}else if(charCode1===0x12){oneCode=b+0x70;}else {oneCode=b+0x90;}this.logger.log(2,function(){return "Special char '"+getCharForByte(oneCode)+"' in channel "+channelNr;});charCodes=[oneCode];}else if(a>=0x20&&a<=0x7f){charCodes=b===0?[a]:[a,b];}if(charCodes){this.logger.log(3,function(){return 'Char codes =  '+numArrayToHexArray(charCodes).join(',');});}return charCodes;}/**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */},{key:"parseBackgroundAttributes",value:function parseBackgroundAttributes(a,b){var case1=(a===0x10||a===0x18)&&b>=0x20&&b<=0x2f;var case2=(a===0x17||a===0x1f)&&b>=0x2d&&b<=0x2f;if(!(case1||case2)){return false;}var index;var bkgData={};if(a===0x10||a===0x18){index=Math.floor((b-0x20)/2);bkgData.background=backgroundColors[index];if(b%2===1){bkgData.background=bkgData.background+'_semi';}}else if(b===0x2d){bkgData.background='transparent';}else {bkgData.foreground='black';if(b===0x2f){bkgData.underline=true;}}var chNr=a<=0x17?1:2;var channel=this.channels[chNr];channel.setBkgData(bkgData);return true;}/**
   * Reset state of parser and its channels.
   */},{key:"reset",value:function reset(){for(var i=0;i<Object.keys(this.channels).length;i++){var channel=this.channels[i];if(channel){channel.reset();}}setLastCmd(null,null,this.cmdHistory);}/**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */},{key:"cueSplitAtTime",value:function cueSplitAtTime(t){for(var i=0;i<this.channels.length;i++){var channel=this.channels[i];if(channel){channel.cueSplitAtTime(t);}}}}]);return Cea608Parser;}();function setLastCmd(a,b,cmdHistory){cmdHistory.a=a;cmdHistory.b=b;}function hasCmdRepeated(a,b,cmdHistory){return cmdHistory.a===a&&cmdHistory.b===b;}function createCmdHistory(){return {a:null,b:null};}var OutputFilter=/*#__PURE__*/function(){function OutputFilter(timelineController,trackName){_classCallCheck(this,OutputFilter);this.timelineController=void 0;this.cueRanges=[];this.trackName=void 0;this.startTime=null;this.endTime=null;this.screen=null;this.timelineController=timelineController;this.trackName=trackName;}_createClass(OutputFilter,[{key:"dispatchCue",value:function dispatchCue(){if(this.startTime===null){return;}this.timelineController.addCues(this.trackName,this.startTime,this.endTime,this.screen,this.cueRanges);this.startTime=null;}},{key:"newCue",value:function newCue(startTime,endTime,screen){if(this.startTime===null||this.startTime>startTime){this.startTime=startTime;}this.endTime=endTime;this.screen=screen;this.timelineController.createCaptionsTrack(this.trackName);}},{key:"reset",value:function reset(){this.cueRanges=[];this.startTime=null;}}]);return OutputFilter;}();/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var VTTCue=function(){if(optionalSelf!=null&&optionalSelf.VTTCue){return self.VTTCue;}var AllowedDirections=['','lr','rl'];var AllowedAlignments=['start','middle','end','left','right'];function isAllowedValue(allowed,value){if(typeof value!=='string'){return false;}// necessary for assuring the generic conforms to the Array interface
if(!Array.isArray(allowed)){return false;}// reset the type so that the next narrowing works well
var lcValue=value.toLowerCase();// use the allow list to narrow the type to a specific subset of strings
if(~allowed.indexOf(lcValue)){return lcValue;}return false;}function findDirectionSetting(value){return isAllowedValue(AllowedDirections,value);}function findAlignSetting(value){return isAllowedValue(AllowedAlignments,value);}function extend(obj){for(var _len4=arguments.length,rest=new Array(_len4>1?_len4-1:0),_key4=1;_key4<_len4;_key4++){rest[_key4-1]=arguments[_key4];}var i=1;for(;i<arguments.length;i++){var cobj=arguments[i];for(var p in cobj){obj[p]=cobj[p];}}return obj;}function VTTCue(startTime,endTime,text){var cue=this;var baseObj={enumerable:true};/**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */ // Lets us know when the VTTCue's data has changed in such a way that we need
// to recompute its display state. This lets us compute its display state
// lazily.
cue.hasBeenReset=false;/**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */var _id='';var _pauseOnExit=false;var _startTime=startTime;var _endTime=endTime;var _text=text;var _region=null;var _vertical='';var _snapToLines=true;var _line='auto';var _lineAlign='start';var _position=50;var _positionAlign='middle';var _size=50;var _align='middle';Object.defineProperty(cue,'id',extend({},baseObj,{get:function get(){return _id;},set:function set(value){_id=''+value;}}));Object.defineProperty(cue,'pauseOnExit',extend({},baseObj,{get:function get(){return _pauseOnExit;},set:function set(value){_pauseOnExit=!!value;}}));Object.defineProperty(cue,'startTime',extend({},baseObj,{get:function get(){return _startTime;},set:function set(value){if(typeof value!=='number'){throw new TypeError('Start time must be set to a number.');}_startTime=value;this.hasBeenReset=true;}}));Object.defineProperty(cue,'endTime',extend({},baseObj,{get:function get(){return _endTime;},set:function set(value){if(typeof value!=='number'){throw new TypeError('End time must be set to a number.');}_endTime=value;this.hasBeenReset=true;}}));Object.defineProperty(cue,'text',extend({},baseObj,{get:function get(){return _text;},set:function set(value){_text=''+value;this.hasBeenReset=true;}}));// todo: implement VTTRegion polyfill?
Object.defineProperty(cue,'region',extend({},baseObj,{get:function get(){return _region;},set:function set(value){_region=value;this.hasBeenReset=true;}}));Object.defineProperty(cue,'vertical',extend({},baseObj,{get:function get(){return _vertical;},set:function set(value){var setting=findDirectionSetting(value);// Have to check for false because the setting an be an empty string.
if(setting===false){throw new SyntaxError('An invalid or illegal string was specified.');}_vertical=setting;this.hasBeenReset=true;}}));Object.defineProperty(cue,'snapToLines',extend({},baseObj,{get:function get(){return _snapToLines;},set:function set(value){_snapToLines=!!value;this.hasBeenReset=true;}}));Object.defineProperty(cue,'line',extend({},baseObj,{get:function get(){return _line;},set:function set(value){if(typeof value!=='number'&&value!=='auto'){throw new SyntaxError('An invalid number or illegal string was specified.');}_line=value;this.hasBeenReset=true;}}));Object.defineProperty(cue,'lineAlign',extend({},baseObj,{get:function get(){return _lineAlign;},set:function set(value){var setting=findAlignSetting(value);if(!setting){throw new SyntaxError('An invalid or illegal string was specified.');}_lineAlign=setting;this.hasBeenReset=true;}}));Object.defineProperty(cue,'position',extend({},baseObj,{get:function get(){return _position;},set:function set(value){if(value<0||value>100){throw new Error('Position must be between 0 and 100.');}_position=value;this.hasBeenReset=true;}}));Object.defineProperty(cue,'positionAlign',extend({},baseObj,{get:function get(){return _positionAlign;},set:function set(value){var setting=findAlignSetting(value);if(!setting){throw new SyntaxError('An invalid or illegal string was specified.');}_positionAlign=setting;this.hasBeenReset=true;}}));Object.defineProperty(cue,'size',extend({},baseObj,{get:function get(){return _size;},set:function set(value){if(value<0||value>100){throw new Error('Size must be between 0 and 100.');}_size=value;this.hasBeenReset=true;}}));Object.defineProperty(cue,'align',extend({},baseObj,{get:function get(){return _align;},set:function set(value){var setting=findAlignSetting(value);if(!setting){throw new SyntaxError('An invalid or illegal string was specified.');}_align=setting;this.hasBeenReset=true;}}));/**
     * Other <track> spec defined properties
     */ // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
cue.displayState=undefined;}/**
   * VTTCue methods
   */VTTCue.prototype.getCueAsHTML=function(){// Assume WebVTT.convertCueToDOMTree is on the global.
var WebVTT=self.WebVTT;return WebVTT.convertCueToDOMTree(self,this.text);};// this is a polyfill hack
return VTTCue;}();/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
 */var StringDecoder=/*#__PURE__*/function(){function StringDecoder(){_classCallCheck(this,StringDecoder);}_createClass(StringDecoder,[{key:"decode",value:// eslint-disable-next-line @typescript-eslint/no-unused-vars
function decode(data,options){if(!data){return '';}if(typeof data!=='string'){throw new Error('Error - expected string data.');}return decodeURIComponent(encodeURIComponent(data));}}]);return StringDecoder;}();// Try to parse input as a time stamp.
function parseTimeStamp(input){function computeSeconds(h,m,s,f){return (h|0)*3600+(m|0)*60+(s|0)+parseFloat(f||0);}var m=input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);if(!m){return null;}if(parseFloat(m[2])>59){// Timestamp takes the form of [hours]:[minutes].[milliseconds]
// First position is hours as it's over 59.
return computeSeconds(m[2],m[3],0,m[4]);}// Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
return computeSeconds(m[1],m[2],m[3],m[4]);}// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
var Settings=/*#__PURE__*/function(){function Settings(){_classCallCheck(this,Settings);this.values=Object.create(null);}// Only accept the first assignment to any key.
_createClass(Settings,[{key:"set",value:function set(k,v){if(!this.get(k)&&v!==''){this.values[k]=v;}}// Return the value for a key, or a default value.
// If 'defaultKey' is passed then 'dflt' is assumed to be an object with
// a number of possible default values as properties where 'defaultKey' is
// the key of the property that will be chosen; otherwise it's assumed to be
// a single value.
},{key:"get",value:function get(k,dflt,defaultKey){if(defaultKey){return this.has(k)?this.values[k]:dflt[defaultKey];}return this.has(k)?this.values[k]:dflt;}// Check whether we have a value for a key.
},{key:"has",value:function has(k){return k in this.values;}// Accept a setting if its one of the given alternatives.
},{key:"alt",value:function alt(k,v,a){for(var n=0;n<a.length;++n){if(v===a[n]){this.set(k,v);break;}}}// Accept a setting if its a valid (signed) integer.
},{key:"integer",value:function integer(k,v){if(/^-?\d+$/.test(v)){// integer
this.set(k,parseInt(v,10));}}// Accept a setting if its a valid percentage.
},{key:"percent",value:function percent(k,v){if(/^([\d]{1,3})(\.[\d]*)?%$/.test(v)){var percent=parseFloat(v);if(percent>=0&&percent<=100){this.set(k,percent);return true;}}return false;}}]);return Settings;}();// Helper function to parse input into groups separated by 'groupDelim', and
// interpret each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input,callback,keyValueDelim,groupDelim){var groups=groupDelim?input.split(groupDelim):[input];for(var i in groups){if(typeof groups[i]!=='string'){continue;}var kv=groups[i].split(keyValueDelim);if(kv.length!==2){continue;}var k=kv[0];var v=kv[1];callback(k,v);}}var defaults$2=new VTTCue(0,0,'');// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
var center=defaults$2.align==='middle'?'middle':'center';function parseCue(input,cue,regionList){// Remember the original input if we need to throw an error.
var oInput=input;// 4.1 WebVTT timestamp
function consumeTimeStamp(){var ts=parseTimeStamp(input);if(ts===null){throw new Error('Malformed timestamp: '+oInput);}// Remove time stamp from input.
input=input.replace(/^[^\sa-zA-Z-]+/,'');return ts;}// 4.4.2 WebVTT cue settings
function consumeCueSettings(input,cue){var settings=new Settings();parseOptions(input,function(k,v){var vals;switch(k){case'region':// Find the last region we parsed with the same region id.
for(var i=regionList.length-1;i>=0;i--){if(regionList[i].id===v){settings.set(k,regionList[i].region);break;}}break;case'vertical':settings.alt(k,v,['rl','lr']);break;case'line':vals=v.split(',');settings.integer(k,vals[0]);if(settings.percent(k,vals[0])){settings.set('snapToLines',false);}settings.alt(k,vals[0],['auto']);if(vals.length===2){settings.alt('lineAlign',vals[1],['start',center,'end']);}break;case'position':vals=v.split(',');settings.percent(k,vals[0]);if(vals.length===2){settings.alt('positionAlign',vals[1],['start',center,'end','line-left','line-right','auto']);}break;case'size':settings.percent(k,v);break;case'align':settings.alt(k,v,['start',center,'end','left','right']);break;}},/:/,/\s/);// Apply default values for any missing fields.
cue.region=settings.get('region',null);cue.vertical=settings.get('vertical','');var line=settings.get('line','auto');if(line==='auto'&&defaults$2.line===-1){// set numeric line number for Safari
line=-1;}cue.line=line;cue.lineAlign=settings.get('lineAlign','start');cue.snapToLines=settings.get('snapToLines',true);cue.size=settings.get('size',100);cue.align=settings.get('align',center);var position=settings.get('position','auto');if(position==='auto'&&defaults$2.position===50){// set numeric position for Safari
position=cue.align==='start'||cue.align==='left'?0:cue.align==='end'||cue.align==='right'?100:50;}cue.position=position;}function skipWhitespace(){input=input.replace(/^\s+/,'');}// 4.1 WebVTT cue timings.
skipWhitespace();cue.startTime=consumeTimeStamp();// (1) collect cue start time
skipWhitespace();if(input.slice(0,3)!=='-->'){// (3) next characters must match '-->'
throw new Error("Malformed time stamp (time stamps must be separated by '-->'): "+oInput);}input=input.slice(3);skipWhitespace();cue.endTime=consumeTimeStamp();// (5) collect cue end time
// 4.1 WebVTT cue settings list.
skipWhitespace();consumeCueSettings(input,cue);}function fixLineBreaks(input){return input.replace(/<br(?: \/)?>/gi,'\n');}var VTTParser=/*#__PURE__*/function(){function VTTParser(){_classCallCheck(this,VTTParser);this.state='INITIAL';this.buffer='';this.decoder=new StringDecoder();this.regionList=[];this.cue=null;this.oncue=void 0;this.onparsingerror=void 0;this.onflush=void 0;}_createClass(VTTParser,[{key:"parse",value:function parse(data){var _this=this;// If there is no data then we won't decode it, but will just try to parse
// whatever is in buffer already. This may occur in circumstances, for
// example when flush() is called.
if(data){// Try to decode the data that we received.
_this.buffer+=_this.decoder.decode(data,{stream:true});}function collectNextLine(){var buffer=_this.buffer;var pos=0;buffer=fixLineBreaks(buffer);while(pos<buffer.length&&buffer[pos]!=='\r'&&buffer[pos]!=='\n'){++pos;}var line=buffer.slice(0,pos);// Advance the buffer early in case we fail below.
if(buffer[pos]==='\r'){++pos;}if(buffer[pos]==='\n'){++pos;}_this.buffer=buffer.slice(pos);return line;}// 3.2 WebVTT metadata header syntax
function parseHeader(input){parseOptions(input,function(k,v){// switch (k) {
// case 'region':
// 3.3 WebVTT region metadata header syntax
// console.log('parse region', v);
// parseRegion(v);
// break;
// }
},/:/);}// 5.1 WebVTT file parsing.
try{var line='';if(_this.state==='INITIAL'){// We can't start parsing until we have the first line.
if(!/\r\n|\n/.test(_this.buffer)){return this;}line=collectNextLine();// strip of UTF-8 BOM if any
// https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
var m=line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);if(!(m!=null&&m[0])){throw new Error('Malformed WebVTT signature.');}_this.state='HEADER';}var alreadyCollectedLine=false;while(_this.buffer){// We can't parse a line until we have the full line.
if(!/\r\n|\n/.test(_this.buffer)){return this;}if(!alreadyCollectedLine){line=collectNextLine();}else {alreadyCollectedLine=false;}switch(_this.state){case'HEADER':// 13-18 - Allow a header (metadata) under the WEBVTT line.
if(/:/.test(line)){parseHeader(line);}else if(!line){// An empty line terminates the header and starts the body (cues).
_this.state='ID';}continue;case'NOTE':// Ignore NOTE blocks.
if(!line){_this.state='ID';}continue;case'ID':// Check for the start of NOTE blocks.
if(/^NOTE($|[ \t])/.test(line)){_this.state='NOTE';break;}// 19-29 - Allow any number of line terminators, then initialize new cue values.
if(!line){continue;}_this.cue=new VTTCue(0,0,'');_this.state='CUE';// 30-39 - Check if self line contains an optional identifier or timing data.
if(line.indexOf('-->')===-1){_this.cue.id=line;continue;}// Process line as start of a cue.
/* falls through */case'CUE':// 40 - Collect cue timings and settings.
if(!_this.cue){_this.state='BADCUE';continue;}try{parseCue(line,_this.cue,_this.regionList);}catch(e){// In case of an error ignore rest of the cue.
_this.cue=null;_this.state='BADCUE';continue;}_this.state='CUETEXT';continue;case'CUETEXT':{var hasSubstring=line.indexOf('-->')!==-1;// 34 - If we have an empty line then report the cue.
// 35 - If we have the special substring '-->' then report the cue,
// but do not collect the line as we need to process the current
// one as a new cue.
if(!line||hasSubstring&&(alreadyCollectedLine=true)){// We are done parsing self cue.
if(_this.oncue&&_this.cue){_this.oncue(_this.cue);}_this.cue=null;_this.state='ID';continue;}if(_this.cue===null){continue;}if(_this.cue.text){_this.cue.text+='\n';}_this.cue.text+=line;}continue;case'BADCUE':// 54-62 - Collect and discard the remaining cue.
if(!line){_this.state='ID';}}}}catch(e){// If we are currently parsing a cue, report what we have.
if(_this.state==='CUETEXT'&&_this.cue&&_this.oncue){_this.oncue(_this.cue);}_this.cue=null;// Enter BADWEBVTT state if header was not parsed correctly otherwise
// another exception occurred so enter BADCUE state.
_this.state=_this.state==='INITIAL'?'BADWEBVTT':'BADCUE';}return this;}},{key:"flush",value:function flush(){var _this=this;try{// Finish decoding the stream.
// _this.buffer += _this.decoder.decode();
// Synthesize the end of the current cue or region.
if(_this.cue||_this.state==='HEADER'){_this.buffer+='\n\n';_this.parse();}// If we've flushed, parsed, and we're still on the INITIAL state then
// that means we don't have enough of the stream to parse the first
// line.
if(_this.state==='INITIAL'||_this.state==='BADWEBVTT'){throw new Error('Malformed WebVTT signature.');}}catch(e){if(_this.onparsingerror){_this.onparsingerror(e);}}if(_this.onflush){_this.onflush();}return this;}}]);return VTTParser;}();var LINEBREAKS=/\r\n|\n\r|\n|\r/g;// String.prototype.startsWith is not supported in IE11
var startsWith$1=function startsWith(inputString,searchString){var position=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return inputString.slice(position,position+searchString.length)===searchString;};var cueString2millis=function cueString2millis(timeString){var ts=parseInt(timeString.slice(-3));var secs=parseInt(timeString.slice(-6,-4));var mins=parseInt(timeString.slice(-9,-7));var hours=timeString.length>9?parseInt(timeString.substring(0,timeString.indexOf(':'))):0;if(!isFiniteNumber(ts)||!isFiniteNumber(secs)||!isFiniteNumber(mins)||!isFiniteNumber(hours)){throw Error("Malformed X-TIMESTAMP-MAP: Local:".concat(timeString));}ts+=1000*secs;ts+=60*1000*mins;ts+=60*60*1000*hours;return ts;};// From https://github.com/darkskyapp/string-hash
var hash=function hash(text){var _hash=5381;var i=text.length;while(i){_hash=_hash*33^text.charCodeAt(--i);}return (_hash>>>0).toString();};// Create a unique hash id for a cue based on start/end times and text.
// This helps timeline-controller to avoid showing repeated captions.
function generateCueId(startTime,endTime,text){return hash(startTime.toString())+hash(endTime.toString())+hash(text);}var calculateOffset=function calculateOffset(vttCCs,cc,presentationTime){var currCC=vttCCs[cc];var prevCC=vttCCs[currCC.prevCC];// This is the first discontinuity or cues have been processed since the last discontinuity
// Offset = current discontinuity time
if(!prevCC||!prevCC["new"]&&currCC["new"]){vttCCs.ccOffset=vttCCs.presentationOffset=currCC.start;currCC["new"]=false;return;}// There have been discontinuities since cues were last parsed.
// Offset = time elapsed
while((_prevCC=prevCC)!=null&&_prevCC["new"]){var _prevCC;vttCCs.ccOffset+=currCC.start-prevCC.start;currCC["new"]=false;currCC=prevCC;prevCC=vttCCs[currCC.prevCC];}vttCCs.presentationOffset=presentationTime;};function parseWebVTT(vttByteArray,initPTS,vttCCs,cc,timeOffset,callBack,errorCallBack){var parser=new VTTParser();// Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
// Uint8Array.prototype.reduce is not implemented in IE11
var vttLines=utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace(LINEBREAKS,'\n').split('\n');var cues=[];var init90kHz=initPTS?toMpegTsClockFromTimescale(initPTS.baseTime,initPTS.timescale):0;var cueTime='00:00.000';var timestampMapMPEGTS=0;var timestampMapLOCAL=0;var parsingError;var inHeader=true;parser.oncue=function(cue){// Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
var currCC=vttCCs[cc];var cueOffset=vttCCs.ccOffset;// Calculate subtitle PTS offset
var webVttMpegTsMapOffset=(timestampMapMPEGTS-init90kHz)/90000;// Update offsets for new discontinuities
if(currCC!=null&&currCC["new"]){if(timestampMapLOCAL!==undefined){// When local time is provided, offset = discontinuity start time - local time
cueOffset=vttCCs.ccOffset=currCC.start;}else {calculateOffset(vttCCs,cc,webVttMpegTsMapOffset);}}if(webVttMpegTsMapOffset){if(!initPTS){parsingError=new Error('Missing initPTS for VTT MPEGTS');return;}// If we have MPEGTS, offset = presentation time + discontinuity offset
cueOffset=webVttMpegTsMapOffset-vttCCs.presentationOffset;}var duration=cue.endTime-cue.startTime;var startTime=normalizePts((cue.startTime+cueOffset-timestampMapLOCAL)*90000,timeOffset*90000)/90000;cue.startTime=Math.max(startTime,0);cue.endTime=Math.max(startTime+duration,0);//trim trailing webvtt block whitespaces
var text=cue.text.trim();// Fix encoding of special characters
cue.text=decodeURIComponent(encodeURIComponent(text));// If the cue was not assigned an id from the VTT file (line above the content), create one.
if(!cue.id){cue.id=generateCueId(cue.startTime,cue.endTime,text);}if(cue.endTime>0){cues.push(cue);}};parser.onparsingerror=function(error){parsingError=error;};parser.onflush=function(){if(parsingError){errorCallBack(parsingError);return;}callBack(cues);};// Go through contents line by line.
vttLines.forEach(function(line){if(inHeader){// Look for X-TIMESTAMP-MAP in header.
if(startsWith$1(line,'X-TIMESTAMP-MAP=')){// Once found, no more are allowed anyway, so stop searching.
inHeader=false;// Extract LOCAL and MPEGTS.
line.slice(16).split(',').forEach(function(timestamp){if(startsWith$1(timestamp,'LOCAL:')){cueTime=timestamp.slice(6);}else if(startsWith$1(timestamp,'MPEGTS:')){timestampMapMPEGTS=parseInt(timestamp.slice(7));}});try{// Convert cue time to seconds
timestampMapLOCAL=cueString2millis(cueTime)/1000;}catch(error){parsingError=error;}// Return without parsing X-TIMESTAMP-MAP line.
return;}else if(line===''){inHeader=false;}}// Parse line by default.
parser.parse(line+'\n');});parser.flush();}var IMSC1_CODEC='stpp.ttml.im1t';// Time format: h:m:s:frames(.subframes)
var HMSF_REGEX=/^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;// Time format: hours, minutes, seconds, milliseconds, frames, ticks
var TIME_UNIT_REGEX=/^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;var textAlignToLineAlign={left:'start',center:'center',right:'end',start:'start',end:'end'};function parseIMSC1(payload,initPTS,callBack,errorCallBack){var results=findBox(new Uint8Array(payload),['mdat']);if(results.length===0){errorCallBack(new Error('Could not parse IMSC1 mdat'));return;}var ttmlList=results.map(function(mdat){return utf8ArrayToStr(mdat);});var syncTime=toTimescaleFromScale(initPTS.baseTime,1,initPTS.timescale);try{ttmlList.forEach(function(ttml){return callBack(parseTTML(ttml,syncTime));});}catch(error){errorCallBack(error);}}function parseTTML(ttml,syncTime){var parser=new DOMParser();var xmlDoc=parser.parseFromString(ttml,'text/xml');var tt=xmlDoc.getElementsByTagName('tt')[0];if(!tt){throw new Error('Invalid ttml');}var defaultRateInfo={frameRate:30,subFrameRate:1,frameRateMultiplier:0,tickRate:0};var rateInfo=Object.keys(defaultRateInfo).reduce(function(result,key){result[key]=tt.getAttribute("ttp:".concat(key))||defaultRateInfo[key];return result;},{});var trim=tt.getAttribute('xml:space')!=='preserve';var styleElements=collectionToDictionary(getElementCollection(tt,'styling','style'));var regionElements=collectionToDictionary(getElementCollection(tt,'layout','region'));var cueElements=getElementCollection(tt,'body','[begin]');return [].map.call(cueElements,function(cueElement){var cueText=getTextContent(cueElement,trim);if(!cueText||!cueElement.hasAttribute('begin')){return null;}var startTime=parseTtmlTime(cueElement.getAttribute('begin'),rateInfo);var duration=parseTtmlTime(cueElement.getAttribute('dur'),rateInfo);var endTime=parseTtmlTime(cueElement.getAttribute('end'),rateInfo);if(startTime===null){throw timestampParsingError(cueElement);}if(endTime===null){if(duration===null){throw timestampParsingError(cueElement);}endTime=startTime+duration;}var cue=new VTTCue(startTime-syncTime,endTime-syncTime,cueText);cue.id=generateCueId(cue.startTime,cue.endTime,cue.text);var region=regionElements[cueElement.getAttribute('region')];var style=styleElements[cueElement.getAttribute('style')];// Apply styles to cue
var styles=getTtmlStyles(region,style,styleElements);var textAlign=styles.textAlign;if(textAlign){// cue.positionAlign not settable in FF~2016
var lineAlign=textAlignToLineAlign[textAlign];if(lineAlign){cue.lineAlign=lineAlign;}cue.align=textAlign;}_extends(cue,styles);return cue;}).filter(function(cue){return cue!==null;});}function getElementCollection(fromElement,parentName,childName){var parent=fromElement.getElementsByTagName(parentName)[0];if(parent){return [].slice.call(parent.querySelectorAll(childName));}return [];}function collectionToDictionary(elementsWithId){return elementsWithId.reduce(function(dict,element){var id=element.getAttribute('xml:id');if(id){dict[id]=element;}return dict;},{});}function getTextContent(element,trim){return [].slice.call(element.childNodes).reduce(function(str,node,i){var _node$childNodes;if(node.nodeName==='br'&&i){return str+'\n';}if((_node$childNodes=node.childNodes)!=null&&_node$childNodes.length){return getTextContent(node,trim);}else if(trim){return str+node.textContent.trim().replace(/\s+/g,' ');}return str+node.textContent;},'');}function getTtmlStyles(region,style,styleElements){var ttsNs='http://www.w3.org/ns/ttml#styling';var regionStyle=null;var styleAttributes=['displayAlign','textAlign','color','backgroundColor','fontSize','fontFamily'// 'fontWeight',
// 'lineHeight',
// 'wrapOption',
// 'fontStyle',
// 'direction',
// 'writingMode'
];var regionStyleName=region!=null&&region.hasAttribute('style')?region.getAttribute('style'):null;if(regionStyleName&&styleElements.hasOwnProperty(regionStyleName)){regionStyle=styleElements[regionStyleName];}return styleAttributes.reduce(function(styles,name){var value=getAttributeNS(style,ttsNs,name)||getAttributeNS(region,ttsNs,name)||getAttributeNS(regionStyle,ttsNs,name);if(value){styles[name]=value;}return styles;},{});}function getAttributeNS(element,ns,name){if(!element){return null;}return element.hasAttributeNS(ns,name)?element.getAttributeNS(ns,name):null;}function timestampParsingError(node){return new Error("Could not parse ttml timestamp ".concat(node));}function parseTtmlTime(timeAttributeValue,rateInfo){if(!timeAttributeValue){return null;}var seconds=parseTimeStamp(timeAttributeValue);if(seconds===null){if(HMSF_REGEX.test(timeAttributeValue)){seconds=parseHoursMinutesSecondsFrames(timeAttributeValue,rateInfo);}else if(TIME_UNIT_REGEX.test(timeAttributeValue)){seconds=parseTimeUnits(timeAttributeValue,rateInfo);}}return seconds;}function parseHoursMinutesSecondsFrames(timeAttributeValue,rateInfo){var m=HMSF_REGEX.exec(timeAttributeValue);var frames=(m[4]|0)+(m[5]|0)/rateInfo.subFrameRate;return (m[1]|0)*3600+(m[2]|0)*60+(m[3]|0)+frames/rateInfo.frameRate;}function parseTimeUnits(timeAttributeValue,rateInfo){var m=TIME_UNIT_REGEX.exec(timeAttributeValue);var value=Number(m[1]);var unit=m[2];switch(unit){case'h':return value*3600;case'm':return value*60;case'ms':return value*1000;case'f':return value/rateInfo.frameRate;case't':return value/rateInfo.tickRate;}return value;}var TimelineController=/*#__PURE__*/function(){function TimelineController(hls){_classCallCheck(this,TimelineController);this.hls=void 0;this.media=null;this.config=void 0;this.enabled=true;this.Cues=void 0;this.textTracks=[];this.tracks=[];this.initPTS=[];this.unparsedVttFrags=[];this.captionsTracks={};this.nonNativeCaptionsTracks={};this.cea608Parser1=void 0;this.cea608Parser2=void 0;this.lastCc=-1;// Last video (CEA-608) fragment CC
this.lastSn=-1;// Last video (CEA-608) fragment MSN
this.lastPartIndex=-1;// Last video (CEA-608) fragment Part Index
this.prevCC=-1;// Last subtitle fragment CC
this.vttCCs=newVTTCCs();this.captionsProperties=void 0;this.hls=hls;this.config=hls.config;this.Cues=hls.config.cueHandler;this.captionsProperties={textTrack1:{label:this.config.captionsTextTrack1Label,languageCode:this.config.captionsTextTrack1LanguageCode},textTrack2:{label:this.config.captionsTextTrack2Label,languageCode:this.config.captionsTextTrack2LanguageCode},textTrack3:{label:this.config.captionsTextTrack3Label,languageCode:this.config.captionsTextTrack3LanguageCode},textTrack4:{label:this.config.captionsTextTrack4Label,languageCode:this.config.captionsTextTrack4LanguageCode}};hls.on(Events.MEDIA_ATTACHING,this.onMediaAttaching,this);hls.on(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.MANIFEST_LOADED,this.onManifestLoaded,this);hls.on(Events.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this);hls.on(Events.FRAG_LOADING,this.onFragLoading,this);hls.on(Events.FRAG_LOADED,this.onFragLoaded,this);hls.on(Events.FRAG_PARSING_USERDATA,this.onFragParsingUserdata,this);hls.on(Events.FRAG_DECRYPTED,this.onFragDecrypted,this);hls.on(Events.INIT_PTS_FOUND,this.onInitPtsFound,this);hls.on(Events.SUBTITLE_TRACKS_CLEARED,this.onSubtitleTracksCleared,this);hls.on(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);}_createClass(TimelineController,[{key:"destroy",value:function destroy(){var hls=this.hls;hls.off(Events.MEDIA_ATTACHING,this.onMediaAttaching,this);hls.off(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.MANIFEST_LOADED,this.onManifestLoaded,this);hls.off(Events.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this);hls.off(Events.FRAG_LOADING,this.onFragLoading,this);hls.off(Events.FRAG_LOADED,this.onFragLoaded,this);hls.off(Events.FRAG_PARSING_USERDATA,this.onFragParsingUserdata,this);hls.off(Events.FRAG_DECRYPTED,this.onFragDecrypted,this);hls.off(Events.INIT_PTS_FOUND,this.onInitPtsFound,this);hls.off(Events.SUBTITLE_TRACKS_CLEARED,this.onSubtitleTracksCleared,this);hls.off(Events.BUFFER_FLUSHING,this.onBufferFlushing,this);// @ts-ignore
this.hls=this.config=null;this.cea608Parser1=this.cea608Parser2=undefined;}},{key:"initCea608Parsers",value:function initCea608Parsers(){if(this.config.enableCEA708Captions&&(!this.cea608Parser1||!this.cea608Parser2)){var channel1=new OutputFilter(this,'textTrack1');var channel2=new OutputFilter(this,'textTrack2');var channel3=new OutputFilter(this,'textTrack3');var channel4=new OutputFilter(this,'textTrack4');this.cea608Parser1=new Cea608Parser(1,channel1,channel2);this.cea608Parser2=new Cea608Parser(3,channel3,channel4);}}},{key:"addCues",value:function addCues(trackName,startTime,endTime,screen,cueRanges){// skip cues which overlap more than 50% with previously parsed time ranges
var merged=false;for(var i=cueRanges.length;i--;){var cueRange=cueRanges[i];var overlap=intersection$1(cueRange[0],cueRange[1],startTime,endTime);if(overlap>=0){cueRange[0]=Math.min(cueRange[0],startTime);cueRange[1]=Math.max(cueRange[1],endTime);merged=true;if(overlap/(endTime-startTime)>0.5){return;}}}if(!merged){cueRanges.push([startTime,endTime]);}if(this.config.renderTextTracksNatively){var track=this.captionsTracks[trackName];this.Cues.newCue(track,startTime,endTime,screen);}else {var cues=this.Cues.newCue(null,startTime,endTime,screen);this.hls.trigger(Events.CUES_PARSED,{type:'captions',cues:cues,track:trackName});}}// Triggered when an initial PTS is found; used for synchronisation of WebVTT.
},{key:"onInitPtsFound",value:function onInitPtsFound(event,_ref20){var _this61=this;var frag=_ref20.frag,id=_ref20.id,initPTS=_ref20.initPTS,timescale=_ref20.timescale;var unparsedVttFrags=this.unparsedVttFrags;if(id==='main'){this.initPTS[frag.cc]={baseTime:initPTS,timescale:timescale};}// Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
// Parse any unparsed fragments upon receiving the initial PTS.
if(unparsedVttFrags.length){this.unparsedVttFrags=[];unparsedVttFrags.forEach(function(frag){_this61.onFragLoaded(Events.FRAG_LOADED,frag);});}}},{key:"getExistingTrack",value:function getExistingTrack(label,language){var media=this.media;if(media){for(var i=0;i<media.textTracks.length;i++){var textTrack=media.textTracks[i];if(canReuseVttTextTrack(textTrack,{name:label,lang:language,attrs:{}})){return textTrack;}}}return null;}},{key:"createCaptionsTrack",value:function createCaptionsTrack(trackName){if(this.config.renderTextTracksNatively){this.createNativeTrack(trackName);}else {this.createNonNativeTrack(trackName);}}},{key:"createNativeTrack",value:function createNativeTrack(trackName){if(this.captionsTracks[trackName]){return;}var captionsProperties=this.captionsProperties,captionsTracks=this.captionsTracks,media=this.media;var _captionsProperties$t=captionsProperties[trackName],label=_captionsProperties$t.label,languageCode=_captionsProperties$t.languageCode;// Enable reuse of existing text track.
var existingTrack=this.getExistingTrack(label,languageCode);if(!existingTrack){var textTrack=this.createTextTrack('captions',label,languageCode);if(textTrack){// Set a special property on the track so we know it's managed by Hls.js
textTrack[trackName]=true;captionsTracks[trackName]=textTrack;}}else {captionsTracks[trackName]=existingTrack;clearCurrentCues(captionsTracks[trackName]);sendAddTrackEvent(captionsTracks[trackName],media);}}},{key:"createNonNativeTrack",value:function createNonNativeTrack(trackName){if(this.nonNativeCaptionsTracks[trackName]){return;}// Create a list of a single track for the provider to consume
var trackProperties=this.captionsProperties[trackName];if(!trackProperties){return;}var label=trackProperties.label;var track={_id:trackName,label:label,kind:'captions',"default":trackProperties.media?!!trackProperties.media["default"]:false,closedCaptions:trackProperties.media};this.nonNativeCaptionsTracks[trackName]=track;this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND,{tracks:[track]});}},{key:"createTextTrack",value:function createTextTrack(kind,label,lang){var media=this.media;if(!media){return;}return media.addTextTrack(kind,label,lang);}},{key:"onMediaAttaching",value:function onMediaAttaching(event,data){this.media=data.media;this._cleanTracks();}},{key:"onMediaDetaching",value:function onMediaDetaching(){var captionsTracks=this.captionsTracks;Object.keys(captionsTracks).forEach(function(trackName){clearCurrentCues(captionsTracks[trackName]);delete captionsTracks[trackName];});this.nonNativeCaptionsTracks={};}},{key:"onManifestLoading",value:function onManifestLoading(){// Detect discontinuity in video fragment (CEA-608) parsing
this.lastCc=-1;this.lastSn=-1;this.lastPartIndex=-1;// Detect discontinuity in subtitle manifests
this.prevCC=-1;this.vttCCs=newVTTCCs();// Reset tracks
this._cleanTracks();this.tracks=[];this.captionsTracks={};this.nonNativeCaptionsTracks={};this.textTracks=[];this.unparsedVttFrags=[];this.initPTS=[];if(this.cea608Parser1&&this.cea608Parser2){this.cea608Parser1.reset();this.cea608Parser2.reset();}}},{key:"_cleanTracks",value:function _cleanTracks(){// clear outdated subtitles
var media=this.media;if(!media){return;}var textTracks=media.textTracks;if(textTracks){for(var i=0;i<textTracks.length;i++){clearCurrentCues(textTracks[i]);}}}},{key:"onSubtitleTracksUpdated",value:function onSubtitleTracksUpdated(event,data){var _this62=this;var tracks=data.subtitleTracks||[];var hasIMSC1=tracks.some(function(track){return track.textCodec===IMSC1_CODEC;});if(this.config.enableWebVTT||hasIMSC1&&this.config.enableIMSC1){var listIsIdentical=subtitleOptionsIdentical(this.tracks,tracks);if(listIsIdentical){this.tracks=tracks;return;}this.textTracks=[];this.tracks=tracks;if(this.config.renderTextTracksNatively){var media=this.media;var inUseTracks=media?filterSubtitleTracks(media.textTracks):null;this.tracks.forEach(function(track,index){// Reuse tracks with the same label and lang, but do not reuse 608/708 tracks
var textTrack;if(inUseTracks){var inUseTrack=null;for(var i=0;i<inUseTracks.length;i++){if(inUseTracks[i]&&canReuseVttTextTrack(inUseTracks[i],track)){inUseTrack=inUseTracks[i];inUseTracks[i]=null;break;}}if(inUseTrack){textTrack=inUseTrack;}}if(textTrack){clearCurrentCues(textTrack);}else {var textTrackKind=captionsOrSubtitlesFromCharacteristics(track);textTrack=_this62.createTextTrack(textTrackKind,track.name,track.lang);if(textTrack){textTrack.mode='disabled';}}if(textTrack){_this62.textTracks.push(textTrack);}});// Warn when video element has captions or subtitle TextTracks carried over from another source
if(inUseTracks!=null&&inUseTracks.length){var unusedTextTracks=inUseTracks.filter(function(t){return t!==null;}).map(function(t){return t.label;});if(unusedTextTracks.length){logger.warn("Media element contains unused subtitle tracks: ".concat(unusedTextTracks.join(', '),". Replace media element for each source to clear TextTracks and captions menu."));}}}else if(this.tracks.length){// Create a list of tracks for the provider to consume
var tracksList=this.tracks.map(function(track){return {label:track.name,kind:track.type.toLowerCase(),"default":track["default"],subtitleTrack:track};});this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND,{tracks:tracksList});}}}},{key:"onManifestLoaded",value:function onManifestLoaded(event,data){var _this63=this;if(this.config.enableCEA708Captions&&data.captions){data.captions.forEach(function(captionsTrack){var instreamIdMatch=/(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);if(!instreamIdMatch){return;}var trackName="textTrack".concat(instreamIdMatch[1]);var trackProperties=_this63.captionsProperties[trackName];if(!trackProperties){return;}trackProperties.label=captionsTrack.name;if(captionsTrack.lang){// optional attribute
trackProperties.languageCode=captionsTrack.lang;}trackProperties.media=captionsTrack;});}}},{key:"closedCaptionsForLevel",value:function closedCaptionsForLevel(frag){var level=this.hls.levels[frag.level];return level==null?void 0:level.attrs['CLOSED-CAPTIONS'];}},{key:"onFragLoading",value:function onFragLoading(event,data){// if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
if(this.enabled&&data.frag.type===PlaylistLevelType.MAIN){var _data$part$index,_data$part;var cea608Parser1=this.cea608Parser1,cea608Parser2=this.cea608Parser2,lastSn=this.lastSn;var _data$frag3=data.frag,cc=_data$frag3.cc,sn=_data$frag3.sn;var partIndex=(_data$part$index=(_data$part=data.part)==null?void 0:_data$part.index)!=null?_data$part$index:-1;if(cea608Parser1&&cea608Parser2){if(sn!==lastSn+1||sn===lastSn&&partIndex!==this.lastPartIndex+1||cc!==this.lastCc){cea608Parser1.reset();cea608Parser2.reset();}}this.lastCc=cc;this.lastSn=sn;this.lastPartIndex=partIndex;}}},{key:"onFragLoaded",value:function onFragLoaded(event,data){var frag=data.frag,payload=data.payload;if(frag.type===PlaylistLevelType.SUBTITLE){// If fragment is subtitle type, parse as WebVTT.
if(payload.byteLength){var decryptData=frag.decryptdata;// fragment after decryption has a stats object
var decrypted=('stats'in data);// If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
if(decryptData==null||!decryptData.encrypted||decrypted){var trackPlaylistMedia=this.tracks[frag.level];var vttCCs=this.vttCCs;if(!vttCCs[frag.cc]){vttCCs[frag.cc]={start:frag.start,prevCC:this.prevCC,"new":true};this.prevCC=frag.cc;}if(trackPlaylistMedia&&trackPlaylistMedia.textCodec===IMSC1_CODEC){this._parseIMSC1(frag,payload);}else {this._parseVTTs(data);}}}else {// In case there is no payload, finish unsuccessfully.
this.hls.trigger(Events.SUBTITLE_FRAG_PROCESSED,{success:false,frag:frag,error:new Error('Empty subtitle payload')});}}}},{key:"_parseIMSC1",value:function _parseIMSC1(frag,payload){var _this64=this;var hls=this.hls;parseIMSC1(payload,this.initPTS[frag.cc],function(cues){_this64._appendCues(cues,frag.level);hls.trigger(Events.SUBTITLE_FRAG_PROCESSED,{success:true,frag:frag});},function(error){logger.log("Failed to parse IMSC1: ".concat(error));hls.trigger(Events.SUBTITLE_FRAG_PROCESSED,{success:false,frag:frag,error:error});});}},{key:"_parseVTTs",value:function _parseVTTs(data){var _this65=this;var _frag$initSegment;var frag=data.frag,payload=data.payload;// We need an initial synchronisation PTS. Store fragments as long as none has arrived
var initPTS=this.initPTS,unparsedVttFrags=this.unparsedVttFrags;var maxAvCC=initPTS.length-1;if(!initPTS[frag.cc]&&maxAvCC===-1){unparsedVttFrags.push(data);return;}var hls=this.hls;// Parse the WebVTT file contents.
var payloadWebVTT=(_frag$initSegment=frag.initSegment)!=null&&_frag$initSegment.data?appendUint8Array(frag.initSegment.data,new Uint8Array(payload)):payload;parseWebVTT(payloadWebVTT,this.initPTS[frag.cc],this.vttCCs,frag.cc,frag.start,function(cues){_this65._appendCues(cues,frag.level);hls.trigger(Events.SUBTITLE_FRAG_PROCESSED,{success:true,frag:frag});},function(error){var missingInitPTS=error.message==='Missing initPTS for VTT MPEGTS';if(missingInitPTS){unparsedVttFrags.push(data);}else {_this65._fallbackToIMSC1(frag,payload);}// Something went wrong while parsing. Trigger event with success false.
logger.log("Failed to parse VTT cue: ".concat(error));if(missingInitPTS&&maxAvCC>frag.cc){return;}hls.trigger(Events.SUBTITLE_FRAG_PROCESSED,{success:false,frag:frag,error:error});});}},{key:"_fallbackToIMSC1",value:function _fallbackToIMSC1(frag,payload){var _this66=this;// If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
var trackPlaylistMedia=this.tracks[frag.level];if(!trackPlaylistMedia.textCodec){parseIMSC1(payload,this.initPTS[frag.cc],function(){trackPlaylistMedia.textCodec=IMSC1_CODEC;_this66._parseIMSC1(frag,payload);},function(){trackPlaylistMedia.textCodec='wvtt';});}}},{key:"_appendCues",value:function _appendCues(cues,fragLevel){var hls=this.hls;if(this.config.renderTextTracksNatively){var textTrack=this.textTracks[fragLevel];// WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
// before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
// and trying to access getCueById method of cues will throw an exception
// Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
if(!textTrack||textTrack.mode==='disabled'){return;}cues.forEach(function(cue){return addCueToTrack(textTrack,cue);});}else {var currentTrack=this.tracks[fragLevel];if(!currentTrack){return;}var track=currentTrack["default"]?'default':'subtitles'+fragLevel;hls.trigger(Events.CUES_PARSED,{type:'subtitles',cues:cues,track:track});}}},{key:"onFragDecrypted",value:function onFragDecrypted(event,data){var frag=data.frag;if(frag.type===PlaylistLevelType.SUBTITLE){this.onFragLoaded(Events.FRAG_LOADED,data);}}},{key:"onSubtitleTracksCleared",value:function onSubtitleTracksCleared(){this.tracks=[];this.captionsTracks={};}},{key:"onFragParsingUserdata",value:function onFragParsingUserdata(event,data){this.initCea608Parsers();var cea608Parser1=this.cea608Parser1,cea608Parser2=this.cea608Parser2;if(!this.enabled||!cea608Parser1||!cea608Parser2){return;}var frag=data.frag,samples=data.samples;if(frag.type===PlaylistLevelType.MAIN&&this.closedCaptionsForLevel(frag)==='NONE'){return;}// If the event contains captions (found in the bytes property), push all bytes into the parser immediately
// It will create the proper timestamps based on the PTS value
for(var i=0;i<samples.length;i++){var ccBytes=samples[i].bytes;if(ccBytes){var ccdatas=this.extractCea608Data(ccBytes);cea608Parser1.addData(samples[i].pts,ccdatas[0]);cea608Parser2.addData(samples[i].pts,ccdatas[1]);}}}},{key:"onBufferFlushing",value:function onBufferFlushing(event,_ref21){var startOffset=_ref21.startOffset,endOffset=_ref21.endOffset,endOffsetSubtitles=_ref21.endOffsetSubtitles,type=_ref21.type;var media=this.media;if(!media||media.currentTime<endOffset){return;}// Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
// Forward cues are never removed because we can loose streamed 608 content from recent fragments
if(!type||type==='video'){var captionsTracks=this.captionsTracks;Object.keys(captionsTracks).forEach(function(trackName){return removeCuesInRange(captionsTracks[trackName],startOffset,endOffset);});}if(this.config.renderTextTracksNatively){// Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
if(startOffset===0&&endOffsetSubtitles!==undefined){var textTracks=this.textTracks;Object.keys(textTracks).forEach(function(trackName){return removeCuesInRange(textTracks[trackName],startOffset,endOffsetSubtitles);});}}}},{key:"extractCea608Data",value:function extractCea608Data(byteArray){var actualCCBytes=[[],[]];var count=byteArray[0]&0x1f;var position=2;for(var j=0;j<count;j++){var tmpByte=byteArray[position++];var ccbyte1=0x7f&byteArray[position++];var ccbyte2=0x7f&byteArray[position++];if(ccbyte1===0&&ccbyte2===0){continue;}var ccValid=(0x04&tmpByte)!==0;// Support all four channels
if(ccValid){var ccType=0x03&tmpByte;if(0x00/* CEA608 field1*/===ccType||0x01/* CEA608 field2*/===ccType){// Exclude CEA708 CC data.
actualCCBytes[ccType].push(ccbyte1);actualCCBytes[ccType].push(ccbyte2);}}}return actualCCBytes;}}]);return TimelineController;}();function captionsOrSubtitlesFromCharacteristics(track){if(track.characteristics){if(/transcribes-spoken-dialog/gi.test(track.characteristics)&&/describes-music-and-sound/gi.test(track.characteristics)){return 'captions';}}return 'subtitles';}function canReuseVttTextTrack(inUseTrack,manifestTrack){return !!inUseTrack&&inUseTrack.kind===captionsOrSubtitlesFromCharacteristics(manifestTrack)&&subtitleTrackMatchesTextTrack(manifestTrack,inUseTrack);}function intersection$1(x1,x2,y1,y2){return Math.min(x2,y2)-Math.max(x1,y1);}function newVTTCCs(){return {ccOffset:0,presentationOffset:0,0:{start:0,prevCC:-1,"new":true}};}var CapLevelController=/*#__PURE__*/function(){function CapLevelController(hls){_classCallCheck(this,CapLevelController);this.hls=void 0;this.autoLevelCapping=void 0;this.firstLevel=void 0;this.media=void 0;this.restrictedLevels=void 0;this.timer=void 0;this.clientRect=void 0;this.streamController=void 0;this.hls=hls;this.autoLevelCapping=Number.POSITIVE_INFINITY;this.firstLevel=-1;this.media=null;this.restrictedLevels=[];this.timer=undefined;this.clientRect=null;this.registerListeners();}_createClass(CapLevelController,[{key:"setStreamController",value:function setStreamController(streamController){this.streamController=streamController;}},{key:"destroy",value:function destroy(){if(this.hls){this.unregisterListener();}if(this.timer){this.stopCapping();}this.media=null;this.clientRect=null;// @ts-ignore
this.hls=this.streamController=null;}},{key:"registerListeners",value:function registerListeners(){var hls=this.hls;hls.on(Events.FPS_DROP_LEVEL_CAPPING,this.onFpsDropLevelCapping,this);hls.on(Events.MEDIA_ATTACHING,this.onMediaAttaching,this);hls.on(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.on(Events.LEVELS_UPDATED,this.onLevelsUpdated,this);hls.on(Events.BUFFER_CODECS,this.onBufferCodecs,this);hls.on(Events.MEDIA_DETACHING,this.onMediaDetaching,this);}},{key:"unregisterListener",value:function unregisterListener(){var hls=this.hls;hls.off(Events.FPS_DROP_LEVEL_CAPPING,this.onFpsDropLevelCapping,this);hls.off(Events.MEDIA_ATTACHING,this.onMediaAttaching,this);hls.off(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.off(Events.LEVELS_UPDATED,this.onLevelsUpdated,this);hls.off(Events.BUFFER_CODECS,this.onBufferCodecs,this);hls.off(Events.MEDIA_DETACHING,this.onMediaDetaching,this);}},{key:"onFpsDropLevelCapping",value:function onFpsDropLevelCapping(event,data){// Don't add a restricted level more than once
var level=this.hls.levels[data.droppedLevel];if(this.isLevelAllowed(level)){this.restrictedLevels.push({bitrate:level.bitrate,height:level.height,width:level.width});}}},{key:"onMediaAttaching",value:function onMediaAttaching(event,data){this.media=data.media instanceof HTMLVideoElement?data.media:null;this.clientRect=null;if(this.timer&&this.hls.levels.length){this.detectPlayerSize();}}},{key:"onManifestParsed",value:function onManifestParsed(event,data){var hls=this.hls;this.restrictedLevels=[];this.firstLevel=data.firstLevel;if(hls.config.capLevelToPlayerSize&&data.video){// Start capping immediately if the manifest has signaled video codecs
this.startCapping();}}},{key:"onLevelsUpdated",value:function onLevelsUpdated(event,data){if(this.timer&&isFiniteNumber(this.autoLevelCapping)){this.detectPlayerSize();}}// Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
// to the first level
},{key:"onBufferCodecs",value:function onBufferCodecs(event,data){var hls=this.hls;if(hls.config.capLevelToPlayerSize&&data.video){// If the manifest did not signal a video codec capping has been deferred until we're certain video is present
this.startCapping();}}},{key:"onMediaDetaching",value:function onMediaDetaching(){this.stopCapping();}},{key:"detectPlayerSize",value:function detectPlayerSize(){if(this.media){if(this.mediaHeight<=0||this.mediaWidth<=0){this.clientRect=null;return;}var levels=this.hls.levels;if(levels.length){var hls=this.hls;var maxLevel=this.getMaxLevel(levels.length-1);if(maxLevel!==this.autoLevelCapping){logger.log("Setting autoLevelCapping to ".concat(maxLevel,": ").concat(levels[maxLevel].height,"p@").concat(levels[maxLevel].bitrate," for media ").concat(this.mediaWidth,"x").concat(this.mediaHeight));}hls.autoLevelCapping=maxLevel;if(hls.autoLevelCapping>this.autoLevelCapping&&this.streamController){// if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
// usually happen when the user go to the fullscreen mode.
this.streamController.nextLevelSwitch();}this.autoLevelCapping=hls.autoLevelCapping;}}}/*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */},{key:"getMaxLevel",value:function getMaxLevel(capLevelIndex){var _this67=this;var levels=this.hls.levels;if(!levels.length){return -1;}var validLevels=levels.filter(function(level,index){return _this67.isLevelAllowed(level)&&index<=capLevelIndex;});this.clientRect=null;return CapLevelController.getMaxLevelByMediaSize(validLevels,this.mediaWidth,this.mediaHeight);}},{key:"startCapping",value:function startCapping(){if(this.timer){// Don't reset capping if started twice; this can happen if the manifest signals a video codec
return;}this.autoLevelCapping=Number.POSITIVE_INFINITY;self.clearInterval(this.timer);this.timer=self.setInterval(this.detectPlayerSize.bind(this),1000);this.detectPlayerSize();}},{key:"stopCapping",value:function stopCapping(){this.restrictedLevels=[];this.firstLevel=-1;this.autoLevelCapping=Number.POSITIVE_INFINITY;if(this.timer){self.clearInterval(this.timer);this.timer=undefined;}}},{key:"getDimensions",value:function getDimensions(){if(this.clientRect){return this.clientRect;}var media=this.media;var boundsRect={width:0,height:0};if(media){var clientRect=media.getBoundingClientRect();boundsRect.width=clientRect.width;boundsRect.height=clientRect.height;if(!boundsRect.width&&!boundsRect.height){// When the media element has no width or height (equivalent to not being in the DOM),
// then use its width and height attributes (media.width, media.height)
boundsRect.width=clientRect.right-clientRect.left||media.width||0;boundsRect.height=clientRect.bottom-clientRect.top||media.height||0;}}this.clientRect=boundsRect;return boundsRect;}},{key:"mediaWidth",get:function get(){return this.getDimensions().width*this.contentScaleFactor;}},{key:"mediaHeight",get:function get(){return this.getDimensions().height*this.contentScaleFactor;}},{key:"contentScaleFactor",get:function get(){var pixelRatio=1;if(!this.hls.config.ignoreDevicePixelRatio){try{pixelRatio=self.devicePixelRatio;}catch(e){/* no-op */}}return pixelRatio;}},{key:"isLevelAllowed",value:function isLevelAllowed(level){var restrictedLevels=this.restrictedLevels;return !restrictedLevels.some(function(restrictedLevel){return level.bitrate===restrictedLevel.bitrate&&level.width===restrictedLevel.width&&level.height===restrictedLevel.height;});}}],[{key:"getMaxLevelByMediaSize",value:function getMaxLevelByMediaSize(levels,width,height){if(!(levels!=null&&levels.length)){return -1;}// Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
// to determine whether we've chosen the greatest bandwidth for the media's dimensions
var atGreatestBandwidth=function atGreatestBandwidth(curLevel,nextLevel){if(!nextLevel){return true;}return curLevel.width!==nextLevel.width||curLevel.height!==nextLevel.height;};// If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
// the max level
var maxLevelIndex=levels.length-1;// Prevent changes in aspect-ratio from causing capping to toggle back and forth
var squareSize=Math.max(width,height);for(var i=0;i<levels.length;i+=1){var level=levels[i];if((level.width>=squareSize||level.height>=squareSize)&&atGreatestBandwidth(level,levels[i+1])){maxLevelIndex=i;break;}}return maxLevelIndex;}}]);return CapLevelController;}();var FPSController=/*#__PURE__*/function(){function FPSController(hls){_classCallCheck(this,FPSController);this.hls=void 0;this.isVideoPlaybackQualityAvailable=false;this.timer=void 0;this.media=null;this.lastTime=void 0;this.lastDroppedFrames=0;this.lastDecodedFrames=0;// stream controller must be provided as a dependency!
this.streamController=void 0;this.hls=hls;this.registerListeners();}_createClass(FPSController,[{key:"setStreamController",value:function setStreamController(streamController){this.streamController=streamController;}},{key:"registerListeners",value:function registerListeners(){this.hls.on(Events.MEDIA_ATTACHING,this.onMediaAttaching,this);}},{key:"unregisterListeners",value:function unregisterListeners(){this.hls.off(Events.MEDIA_ATTACHING,this.onMediaAttaching,this);}},{key:"destroy",value:function destroy(){if(this.timer){clearInterval(this.timer);}this.unregisterListeners();this.isVideoPlaybackQualityAvailable=false;this.media=null;}},{key:"onMediaAttaching",value:function onMediaAttaching(event,data){var config=this.hls.config;if(config.capLevelOnFPSDrop){var media=data.media instanceof self.HTMLVideoElement?data.media:null;this.media=media;if(media&&typeof media.getVideoPlaybackQuality==='function'){this.isVideoPlaybackQualityAvailable=true;}self.clearInterval(this.timer);this.timer=self.setInterval(this.checkFPSInterval.bind(this),config.fpsDroppedMonitoringPeriod);}}},{key:"checkFPS",value:function checkFPS(video,decodedFrames,droppedFrames){var currentTime=performance.now();if(decodedFrames){if(this.lastTime){var currentPeriod=currentTime-this.lastTime;var currentDropped=droppedFrames-this.lastDroppedFrames;var currentDecoded=decodedFrames-this.lastDecodedFrames;var droppedFPS=1000*currentDropped/currentPeriod;var hls=this.hls;hls.trigger(Events.FPS_DROP,{currentDropped:currentDropped,currentDecoded:currentDecoded,totalDroppedFrames:droppedFrames});if(droppedFPS>0){// logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
if(currentDropped>hls.config.fpsDroppedMonitoringThreshold*currentDecoded){var currentLevel=hls.currentLevel;logger.warn('drop FPS ratio greater than max allowed value for currentLevel: '+currentLevel);if(currentLevel>0&&(hls.autoLevelCapping===-1||hls.autoLevelCapping>=currentLevel)){currentLevel=currentLevel-1;hls.trigger(Events.FPS_DROP_LEVEL_CAPPING,{level:currentLevel,droppedLevel:hls.currentLevel});hls.autoLevelCapping=currentLevel;this.streamController.nextLevelSwitch();}}}}this.lastTime=currentTime;this.lastDroppedFrames=droppedFrames;this.lastDecodedFrames=decodedFrames;}}},{key:"checkFPSInterval",value:function checkFPSInterval(){var video=this.media;if(video){if(this.isVideoPlaybackQualityAvailable){var videoPlaybackQuality=video.getVideoPlaybackQuality();this.checkFPS(video,videoPlaybackQuality.totalVideoFrames,videoPlaybackQuality.droppedVideoFrames);}else {// HTMLVideoElement doesn't include the webkit types
this.checkFPS(video,video.webkitDecodedFrameCount,video.webkitDroppedFrameCount);}}}}]);return FPSController;}();var LOGGER_PREFIX='[eme]';/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */var EMEController=/*#__PURE__*/function(){function EMEController(hls){_classCallCheck(this,EMEController);this.hls=void 0;this.config=void 0;this.media=null;this.keyFormatPromise=null;this.keySystemAccessPromises={};this._requestLicenseFailureCount=0;this.mediaKeySessions=[];this.keyIdToKeySessionPromise={};this.setMediaKeysQueue=EMEController.CDMCleanupPromise?[EMEController.CDMCleanupPromise]:[];this.onMediaEncrypted=this._onMediaEncrypted.bind(this);this.onWaitingForKey=this._onWaitingForKey.bind(this);this.debug=logger.debug.bind(logger,LOGGER_PREFIX);this.log=logger.log.bind(logger,LOGGER_PREFIX);this.warn=logger.warn.bind(logger,LOGGER_PREFIX);this.error=logger.error.bind(logger,LOGGER_PREFIX);this.hls=hls;this.config=hls.config;this.registerListeners();}_createClass(EMEController,[{key:"destroy",value:function destroy(){this.unregisterListeners();this.onMediaDetached();// Remove any references that could be held in config options or callbacks
var config=this.config;config.requestMediaKeySystemAccessFunc=null;config.licenseXhrSetup=config.licenseResponseCallback=undefined;config.drmSystems=config.drmSystemOptions={};// @ts-ignore
this.hls=this.onMediaEncrypted=this.onWaitingForKey=this.keyIdToKeySessionPromise=null;// @ts-ignore
this.config=null;}},{key:"registerListeners",value:function registerListeners(){this.hls.on(Events.MEDIA_ATTACHED,this.onMediaAttached,this);this.hls.on(Events.MEDIA_DETACHED,this.onMediaDetached,this);this.hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);this.hls.on(Events.MANIFEST_LOADED,this.onManifestLoaded,this);}},{key:"unregisterListeners",value:function unregisterListeners(){this.hls.off(Events.MEDIA_ATTACHED,this.onMediaAttached,this);this.hls.off(Events.MEDIA_DETACHED,this.onMediaDetached,this);this.hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);this.hls.off(Events.MANIFEST_LOADED,this.onManifestLoaded,this);}},{key:"getLicenseServerUrl",value:function getLicenseServerUrl(keySystem){var _this$config3=this.config,drmSystems=_this$config3.drmSystems,widevineLicenseUrl=_this$config3.widevineLicenseUrl;var keySystemConfiguration=drmSystems[keySystem];if(keySystemConfiguration){return keySystemConfiguration.licenseUrl;}// For backward compatibility
if(keySystem===KeySystems.WIDEVINE&&widevineLicenseUrl){return widevineLicenseUrl;}throw new Error("no license server URL configured for key-system \"".concat(keySystem,"\""));}},{key:"getServerCertificateUrl",value:function getServerCertificateUrl(keySystem){var drmSystems=this.config.drmSystems;var keySystemConfiguration=drmSystems[keySystem];if(keySystemConfiguration){return keySystemConfiguration.serverCertificateUrl;}else {this.log("No Server Certificate in config.drmSystems[\"".concat(keySystem,"\"]"));}}},{key:"attemptKeySystemAccess",value:function attemptKeySystemAccess(keySystemsToAttempt){var _this68=this;var levels=this.hls.levels;var uniqueCodec=function uniqueCodec(value,i,a){return !!value&&a.indexOf(value)===i;};var audioCodecs=levels.map(function(level){return level.audioCodec;}).filter(uniqueCodec);var videoCodecs=levels.map(function(level){return level.videoCodec;}).filter(uniqueCodec);if(audioCodecs.length+videoCodecs.length===0){videoCodecs.push('avc1.42e01e');}return new Promise(function(resolve,reject){var attempt=function attempt(keySystems){var keySystem=keySystems.shift();_this68.getMediaKeysPromise(keySystem,audioCodecs,videoCodecs).then(function(mediaKeys){return resolve({keySystem:keySystem,mediaKeys:mediaKeys});})["catch"](function(error){if(keySystems.length){attempt(keySystems);}else if(error instanceof EMEKeyError){reject(error);}else {reject(new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_NO_ACCESS,error:error,fatal:true},error.message));}});};attempt(keySystemsToAttempt);});}},{key:"requestMediaKeySystemAccess",value:function requestMediaKeySystemAccess(keySystem,supportedConfigurations){var requestMediaKeySystemAccessFunc=this.config.requestMediaKeySystemAccessFunc;if(!(typeof requestMediaKeySystemAccessFunc==='function')){var errMessage="Configured requestMediaKeySystemAccess is not a function ".concat(requestMediaKeySystemAccessFunc);if(_requestMediaKeySystemAccess===null&&self.location.protocol==='http:'){errMessage="navigator.requestMediaKeySystemAccess is not available over insecure protocol ".concat(location.protocol);}return Promise.reject(new Error(errMessage));}return requestMediaKeySystemAccessFunc(keySystem,supportedConfigurations);}},{key:"getMediaKeysPromise",value:function getMediaKeysPromise(keySystem,audioCodecs,videoCodecs){var _this69=this;// This can throw, but is caught in event handler callpath
var mediaKeySystemConfigs=getSupportedMediaKeySystemConfigurations(keySystem,audioCodecs,videoCodecs,this.config.drmSystemOptions);var keySystemAccessPromises=this.keySystemAccessPromises[keySystem];var keySystemAccess=keySystemAccessPromises==null?void 0:keySystemAccessPromises.keySystemAccess;if(!keySystemAccess){this.log("Requesting encrypted media \"".concat(keySystem,"\" key-system access with config: ").concat(JSON.stringify(mediaKeySystemConfigs)));keySystemAccess=this.requestMediaKeySystemAccess(keySystem,mediaKeySystemConfigs);var _keySystemAccessPromises=this.keySystemAccessPromises[keySystem]={keySystemAccess:keySystemAccess};keySystemAccess["catch"](function(error){_this69.log("Failed to obtain access to key-system \"".concat(keySystem,"\": ").concat(error));});return keySystemAccess.then(function(mediaKeySystemAccess){_this69.log("Access for key-system \"".concat(mediaKeySystemAccess.keySystem,"\" obtained"));var certificateRequest=_this69.fetchServerCertificate(keySystem);_this69.log("Create media-keys for \"".concat(keySystem,"\""));_keySystemAccessPromises.mediaKeys=mediaKeySystemAccess.createMediaKeys().then(function(mediaKeys){_this69.log("Media-keys created for \"".concat(keySystem,"\""));return certificateRequest.then(function(certificate){if(certificate){return _this69.setMediaKeysServerCertificate(mediaKeys,keySystem,certificate);}return mediaKeys;});});_keySystemAccessPromises.mediaKeys["catch"](function(error){_this69.error("Failed to create media-keys for \"".concat(keySystem,"\"}: ").concat(error));});return _keySystemAccessPromises.mediaKeys;});}return keySystemAccess.then(function(){return keySystemAccessPromises.mediaKeys;});}},{key:"createMediaKeySessionContext",value:function createMediaKeySessionContext(_ref22){var decryptdata=_ref22.decryptdata,keySystem=_ref22.keySystem,mediaKeys=_ref22.mediaKeys;this.log("Creating key-system session \"".concat(keySystem,"\" keyId: ").concat(Hex.hexDump(decryptdata.keyId||[])));var mediaKeysSession=mediaKeys.createSession();var mediaKeySessionContext={decryptdata:decryptdata,keySystem:keySystem,mediaKeys:mediaKeys,mediaKeysSession:mediaKeysSession,keyStatus:'status-pending'};this.mediaKeySessions.push(mediaKeySessionContext);return mediaKeySessionContext;}},{key:"renewKeySession",value:function renewKeySession(mediaKeySessionContext){var decryptdata=mediaKeySessionContext.decryptdata;if(decryptdata.pssh){var keySessionContext=this.createMediaKeySessionContext(mediaKeySessionContext);var keyId=this.getKeyIdString(decryptdata);var scheme='cenc';this.keyIdToKeySessionPromise[keyId]=this.generateRequestWithPreferredKeySession(keySessionContext,scheme,decryptdata.pssh,'expired');}else {this.warn("Could not renew expired session. Missing pssh initData.");}this.removeSession(mediaKeySessionContext);}},{key:"getKeyIdString",value:function getKeyIdString(decryptdata){if(!decryptdata){throw new Error('Could not read keyId of undefined decryptdata');}if(decryptdata.keyId===null){throw new Error('keyId is null');}return Hex.hexDump(decryptdata.keyId);}},{key:"updateKeySession",value:function updateKeySession(mediaKeySessionContext,data){var _mediaKeySessionConte;var keySession=mediaKeySessionContext.mediaKeysSession;this.log("Updating key-session \"".concat(keySession.sessionId,"\" for keyID ").concat(Hex.hexDump(((_mediaKeySessionConte=mediaKeySessionContext.decryptdata)==null?void 0:_mediaKeySessionConte.keyId)||[]),"\n      } (data length: ").concat(data?data.byteLength:data,")"));return keySession.update(data);}},{key:"selectKeySystemFormat",value:function selectKeySystemFormat(frag){var keyFormats=Object.keys(frag.levelkeys||{});if(!this.keyFormatPromise){this.log("Selecting key-system from fragment (sn: ".concat(frag.sn," ").concat(frag.type,": ").concat(frag.level,") key formats ").concat(keyFormats.join(', ')));this.keyFormatPromise=this.getKeyFormatPromise(keyFormats);}return this.keyFormatPromise;}},{key:"getKeyFormatPromise",value:function getKeyFormatPromise(keyFormats){var _this70=this;return new Promise(function(resolve,reject){var keySystemsInConfig=getKeySystemsForConfig(_this70.config);var keySystemsToAttempt=keyFormats.map(keySystemFormatToKeySystemDomain).filter(function(value){return !!value&&keySystemsInConfig.indexOf(value)!==-1;});return _this70.getKeySystemSelectionPromise(keySystemsToAttempt).then(function(_ref23){var keySystem=_ref23.keySystem;var keySystemFormat=keySystemDomainToKeySystemFormat(keySystem);if(keySystemFormat){resolve(keySystemFormat);}else {reject(new Error("Unable to find format for key-system \"".concat(keySystem,"\"")));}})["catch"](reject);});}},{key:"loadKey",value:function loadKey(data){var _this71=this;var decryptdata=data.keyInfo.decryptdata;var keyId=this.getKeyIdString(decryptdata);var keyDetails="(keyId: ".concat(keyId," format: \"").concat(decryptdata.keyFormat,"\" method: ").concat(decryptdata.method," uri: ").concat(decryptdata.uri,")");this.log("Starting session for key ".concat(keyDetails));var keySessionContextPromise=this.keyIdToKeySessionPromise[keyId];if(!keySessionContextPromise){keySessionContextPromise=this.keyIdToKeySessionPromise[keyId]=this.getKeySystemForKeyPromise(decryptdata).then(function(_ref24){var keySystem=_ref24.keySystem,mediaKeys=_ref24.mediaKeys;_this71.throwIfDestroyed();_this71.log("Handle encrypted media sn: ".concat(data.frag.sn," ").concat(data.frag.type,": ").concat(data.frag.level," using key ").concat(keyDetails));return _this71.attemptSetMediaKeys(keySystem,mediaKeys).then(function(){_this71.throwIfDestroyed();var keySessionContext=_this71.createMediaKeySessionContext({keySystem:keySystem,mediaKeys:mediaKeys,decryptdata:decryptdata});var scheme='cenc';return _this71.generateRequestWithPreferredKeySession(keySessionContext,scheme,decryptdata.pssh,'playlist-key');});});keySessionContextPromise["catch"](function(error){return _this71.handleError(error);});}return keySessionContextPromise;}},{key:"throwIfDestroyed",value:function throwIfDestroyed(){if(!this.hls){throw new Error('invalid state');}}},{key:"handleError",value:function handleError(error){if(!this.hls){return;}this.error(error.message);if(error instanceof EMEKeyError){this.hls.trigger(Events.ERROR,error.data);}else {this.hls.trigger(Events.ERROR,{type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_NO_KEYS,error:error,fatal:true});}}},{key:"getKeySystemForKeyPromise",value:function getKeySystemForKeyPromise(decryptdata){var keyId=this.getKeyIdString(decryptdata);var mediaKeySessionContext=this.keyIdToKeySessionPromise[keyId];if(!mediaKeySessionContext){var keySystem=keySystemFormatToKeySystemDomain(decryptdata.keyFormat);var keySystemsToAttempt=keySystem?[keySystem]:getKeySystemsForConfig(this.config);return this.attemptKeySystemAccess(keySystemsToAttempt);}return mediaKeySessionContext;}},{key:"getKeySystemSelectionPromise",value:function getKeySystemSelectionPromise(keySystemsToAttempt){if(!keySystemsToAttempt.length){keySystemsToAttempt=getKeySystemsForConfig(this.config);}if(keySystemsToAttempt.length===0){throw new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,fatal:true},"Missing key-system license configuration options ".concat(JSON.stringify({drmSystems:this.config.drmSystems})));}return this.attemptKeySystemAccess(keySystemsToAttempt);}},{key:"_onMediaEncrypted",value:function _onMediaEncrypted(event){var _this72=this;var initDataType=event.initDataType,initData=event.initData;var logMessage="\"".concat(event.type,"\" event: init data type: \"").concat(initDataType,"\"");this.debug(logMessage);// Ignore event when initData is null
if(initData===null){return;}var keyId;var keySystemDomain;if(initDataType==='sinf'&&this.config.drmSystems[KeySystems.FAIRPLAY]){// Match sinf keyId to playlist skd://keyId=
var json=bin2str(new Uint8Array(initData));try{var sinf=base64Decode(JSON.parse(json).sinf);var tenc=parseSinf(new Uint8Array(sinf));if(!tenc){throw new Error("'schm' box missing or not cbcs/cenc with schi > tenc");}keyId=tenc.subarray(8,24);keySystemDomain=KeySystems.FAIRPLAY;}catch(error){this.warn("".concat(logMessage," Failed to parse sinf: ").concat(error));return;}}else {// Support Widevine clear-lead key-session creation (otherwise depend on playlist keys)
var psshResults=parseMultiPssh(initData);var psshInfo=psshResults.filter(function(pssh){return pssh.systemId===KeySystemIds.WIDEVINE;})[0];if(!psshInfo){if(psshResults.length===0||psshResults.some(function(pssh){return !pssh.systemId;})){this.warn("".concat(logMessage," contains incomplete or invalid pssh data"));}else {this.log("ignoring ".concat(logMessage," for ").concat(psshResults.map(function(pssh){return keySystemIdToKeySystemDomain(pssh.systemId);}).join(',')," pssh data in favor of playlist keys"));}return;}keySystemDomain=keySystemIdToKeySystemDomain(psshInfo.systemId);if(psshInfo.version===0&&psshInfo.data){var offset=psshInfo.data.length-22;keyId=psshInfo.data.subarray(offset,offset+16);}}if(!keySystemDomain||!keyId){return;}var keyIdHex=Hex.hexDump(keyId);var keyIdToKeySessionPromise=this.keyIdToKeySessionPromise,mediaKeySessions=this.mediaKeySessions;var keySessionContextPromise=keyIdToKeySessionPromise[keyIdHex];var _loop8=function _loop8(){// Match playlist key
var keyContext=mediaKeySessions[i];var decryptdata=keyContext.decryptdata;if(!decryptdata.keyId){return 0;// continue
}var oldKeyIdHex=Hex.hexDump(decryptdata.keyId);if(keyIdHex===oldKeyIdHex||decryptdata.uri.replace(/-/g,'').indexOf(keyIdHex)!==-1){keySessionContextPromise=keyIdToKeySessionPromise[oldKeyIdHex];if(decryptdata.pssh){return 1;// break
}delete keyIdToKeySessionPromise[oldKeyIdHex];decryptdata.pssh=new Uint8Array(initData);decryptdata.keyId=keyId;keySessionContextPromise=keyIdToKeySessionPromise[keyIdHex]=keySessionContextPromise.then(function(){return _this72.generateRequestWithPreferredKeySession(keyContext,initDataType,initData,'encrypted-event-key-match');});return 1;// break
}},_ret4;for(var i=0;i<mediaKeySessions.length;i++){_ret4=_loop8();if(_ret4===0)continue;if(_ret4===1)break;}if(!keySessionContextPromise){// Clear-lead key (not encountered in playlist)
keySessionContextPromise=keyIdToKeySessionPromise[keyIdHex]=this.getKeySystemSelectionPromise([keySystemDomain]).then(function(_ref25){var keySystem=_ref25.keySystem,mediaKeys=_ref25.mediaKeys;var _keySystemToKeySystem;_this72.throwIfDestroyed();var decryptdata=new LevelKey('ISO-23001-7',keyIdHex,(_keySystemToKeySystem=keySystemDomainToKeySystemFormat(keySystem))!=null?_keySystemToKeySystem:'');decryptdata.pssh=new Uint8Array(initData);decryptdata.keyId=keyId;return _this72.attemptSetMediaKeys(keySystem,mediaKeys).then(function(){_this72.throwIfDestroyed();var keySessionContext=_this72.createMediaKeySessionContext({decryptdata:decryptdata,keySystem:keySystem,mediaKeys:mediaKeys});return _this72.generateRequestWithPreferredKeySession(keySessionContext,initDataType,initData,'encrypted-event-no-match');});});}keySessionContextPromise["catch"](function(error){return _this72.handleError(error);});}},{key:"_onWaitingForKey",value:function _onWaitingForKey(event){this.log("\"".concat(event.type,"\" event"));}},{key:"attemptSetMediaKeys",value:function attemptSetMediaKeys(keySystem,mediaKeys){var _this73=this;var queue=this.setMediaKeysQueue.slice();this.log("Setting media-keys for \"".concat(keySystem,"\""));// Only one setMediaKeys() can run at one time, and multiple setMediaKeys() operations
// can be queued for execution for multiple key sessions.
var setMediaKeysPromise=Promise.all(queue).then(function(){if(!_this73.media){throw new Error('Attempted to set mediaKeys without media element attached');}return _this73.media.setMediaKeys(mediaKeys);});this.setMediaKeysQueue.push(setMediaKeysPromise);return setMediaKeysPromise.then(function(){_this73.log("Media-keys set for \"".concat(keySystem,"\""));queue.push(setMediaKeysPromise);_this73.setMediaKeysQueue=_this73.setMediaKeysQueue.filter(function(p){return queue.indexOf(p)===-1;});});}},{key:"generateRequestWithPreferredKeySession",value:function generateRequestWithPreferredKeySession(context,initDataType,initData,reason){var _this74=this;var _this$config$drmSyste,_this$config$drmSyste2;var generateRequestFilter=(_this$config$drmSyste=this.config.drmSystems)==null?void 0:(_this$config$drmSyste2=_this$config$drmSyste[context.keySystem])==null?void 0:_this$config$drmSyste2.generateRequest;if(generateRequestFilter){try{var mappedInitData=generateRequestFilter.call(this.hls,initDataType,initData,context);if(!mappedInitData){throw new Error('Invalid response from configured generateRequest filter');}initDataType=mappedInitData.initDataType;initData=context.decryptdata.pssh=mappedInitData.initData?new Uint8Array(mappedInitData.initData):null;}catch(error){var _this$hls;this.warn(error.message);if((_this$hls=this.hls)!=null&&_this$hls.config.debug){throw error;}}}if(initData===null){this.log("Skipping key-session request for \"".concat(reason,"\" (no initData)"));return Promise.resolve(context);}var keyId=this.getKeyIdString(context.decryptdata);this.log("Generating key-session request for \"".concat(reason,"\": ").concat(keyId," (init data type: ").concat(initDataType," length: ").concat(initData?initData.byteLength:null,")"));var licenseStatus=new EventEmitter();var onmessage=context._onmessage=function(event){var keySession=context.mediaKeysSession;if(!keySession){licenseStatus.emit('error',new Error('invalid state'));return;}var messageType=event.messageType,message=event.message;_this74.log("\"".concat(messageType,"\" message event for session \"").concat(keySession.sessionId,"\" message size: ").concat(message.byteLength));if(messageType==='license-request'||messageType==='license-renewal'){_this74.renewLicense(context,message)["catch"](function(error){_this74.handleError(error);licenseStatus.emit('error',error);});}else if(messageType==='license-release'){if(context.keySystem===KeySystems.FAIRPLAY){_this74.updateKeySession(context,strToUtf8array('acknowledged'));_this74.removeSession(context);}}else {_this74.warn("unhandled media key message type \"".concat(messageType,"\""));}};var onkeystatuseschange=context._onkeystatuseschange=function(event){var keySession=context.mediaKeysSession;if(!keySession){licenseStatus.emit('error',new Error('invalid state'));return;}_this74.onKeyStatusChange(context);var keyStatus=context.keyStatus;licenseStatus.emit('keyStatus',keyStatus);if(keyStatus==='expired'){_this74.warn("".concat(context.keySystem," expired for key ").concat(keyId));_this74.renewKeySession(context);}};context.mediaKeysSession.addEventListener('message',onmessage);context.mediaKeysSession.addEventListener('keystatuseschange',onkeystatuseschange);var keyUsablePromise=new Promise(function(resolve,reject){licenseStatus.on('error',reject);licenseStatus.on('keyStatus',function(keyStatus){if(keyStatus.startsWith('usable')){resolve();}else if(keyStatus==='output-restricted'){reject(new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,fatal:false},'HDCP level output restricted'));}else if(keyStatus==='internal-error'){reject(new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR,fatal:true},"key status changed to \"".concat(keyStatus,"\"")));}else if(keyStatus==='expired'){reject(new Error('key expired while generating request'));}else {_this74.warn("unhandled key status change \"".concat(keyStatus,"\""));}});});return context.mediaKeysSession.generateRequest(initDataType,initData).then(function(){var _context$mediaKeysSes;_this74.log("Request generated for key-session \"".concat((_context$mediaKeysSes=context.mediaKeysSession)==null?void 0:_context$mediaKeysSes.sessionId,"\" keyId: ").concat(keyId));})["catch"](function(error){throw new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_NO_SESSION,error:error,fatal:false},"Error generating key-session request: ".concat(error));}).then(function(){return keyUsablePromise;})["catch"](function(error){licenseStatus.removeAllListeners();_this74.removeSession(context);throw error;}).then(function(){licenseStatus.removeAllListeners();return context;});}},{key:"onKeyStatusChange",value:function onKeyStatusChange(mediaKeySessionContext){var _this75=this;mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach(function(status,keyId){_this75.log("key status change \"".concat(status,"\" for keyStatuses keyId: ").concat(Hex.hexDump('buffer'in keyId?new Uint8Array(keyId.buffer,keyId.byteOffset,keyId.byteLength):new Uint8Array(keyId))," session keyId: ").concat(Hex.hexDump(new Uint8Array(mediaKeySessionContext.decryptdata.keyId||[]))," uri: ").concat(mediaKeySessionContext.decryptdata.uri));mediaKeySessionContext.keyStatus=status;});}},{key:"fetchServerCertificate",value:function fetchServerCertificate(keySystem){var config=this.config;var Loader=config.loader;var certLoader=new Loader(config);var url=this.getServerCertificateUrl(keySystem);if(!url){return Promise.resolve();}this.log("Fetching server certificate for \"".concat(keySystem,"\""));return new Promise(function(resolve,reject){var loaderContext={responseType:'arraybuffer',url:url};var loadPolicy=config.certLoadPolicy["default"];var loaderConfig={loadPolicy:loadPolicy,timeout:loadPolicy.maxLoadTimeMs,maxRetry:0,retryDelay:0,maxRetryDelay:0};var loaderCallbacks={onSuccess:function onSuccess(response,stats,context,networkDetails){resolve(response.data);},onError:function onError(response,contex,networkDetails,stats){reject(new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,fatal:true,networkDetails:networkDetails,response:_objectSpread2$2({url:loaderContext.url,data:undefined},response)},"\"".concat(keySystem,"\" certificate request failed (").concat(url,"). Status: ").concat(response.code," (").concat(response.text,")")));},onTimeout:function onTimeout(stats,context,networkDetails){reject(new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,fatal:true,networkDetails:networkDetails,response:{url:loaderContext.url,data:undefined}},"\"".concat(keySystem,"\" certificate request timed out (").concat(url,")")));},onAbort:function onAbort(stats,context,networkDetails){reject(new Error('aborted'));}};certLoader.load(loaderContext,loaderConfig,loaderCallbacks);});}},{key:"setMediaKeysServerCertificate",value:function setMediaKeysServerCertificate(mediaKeys,keySystem,cert){var _this76=this;return new Promise(function(resolve,reject){mediaKeys.setServerCertificate(cert).then(function(success){_this76.log("setServerCertificate ".concat(success?'success':'not supported by CDM'," (").concat(cert==null?void 0:cert.byteLength,") on \"").concat(keySystem,"\""));resolve(mediaKeys);})["catch"](function(error){reject(new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,error:error,fatal:true},error.message));});});}},{key:"renewLicense",value:function renewLicense(context,keyMessage){var _this77=this;return this.requestLicense(context,new Uint8Array(keyMessage)).then(function(data){return _this77.updateKeySession(context,new Uint8Array(data))["catch"](function(error){throw new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,error:error,fatal:true},error.message);});});}},{key:"unpackPlayReadyKeyMessage",value:function unpackPlayReadyKeyMessage(xhr,licenseChallenge){// On Edge, the raw license message is UTF-16-encoded XML.  We need
// to unpack the Challenge element (base64-encoded string containing the
// actual license request) and any HttpHeader elements (sent as request
// headers).
// For PlayReady CDMs, we need to dig the Challenge out of the XML.
var xmlString=String.fromCharCode.apply(null,new Uint16Array(licenseChallenge.buffer));if(!xmlString.includes('PlayReadyKeyMessage')){// This does not appear to be a wrapped message as on Edge.  Some
// clients do not need this unwrapping, so we will assume this is one of
// them.  Note that "xml" at this point probably looks like random
// garbage, since we interpreted UTF-8 as UTF-16.
xhr.setRequestHeader('Content-Type','text/xml; charset=utf-8');return licenseChallenge;}var keyMessageXml=new DOMParser().parseFromString(xmlString,'application/xml');// Set request headers.
var headers=keyMessageXml.querySelectorAll('HttpHeader');if(headers.length>0){var header;for(var i=0,len=headers.length;i<len;i++){var _header$querySelector,_header$querySelector2;header=headers[i];var name=(_header$querySelector=header.querySelector('name'))==null?void 0:_header$querySelector.textContent;var value=(_header$querySelector2=header.querySelector('value'))==null?void 0:_header$querySelector2.textContent;if(name&&value){xhr.setRequestHeader(name,value);}}}var challengeElement=keyMessageXml.querySelector('Challenge');var challengeText=challengeElement==null?void 0:challengeElement.textContent;if(!challengeText){throw new Error("Cannot find <Challenge> in key message");}return strToUtf8array(atob(challengeText));}},{key:"setupLicenseXHR",value:function setupLicenseXHR(xhr,url,keysListItem,licenseChallenge){var _this78=this;var licenseXhrSetup=this.config.licenseXhrSetup;if(!licenseXhrSetup){xhr.open('POST',url,true);return Promise.resolve({xhr:xhr,licenseChallenge:licenseChallenge});}return Promise.resolve().then(function(){if(!keysListItem.decryptdata){throw new Error('Key removed');}return licenseXhrSetup.call(_this78.hls,xhr,url,keysListItem,licenseChallenge);})["catch"](function(error){if(!keysListItem.decryptdata){// Key session removed. Cancel license request.
throw error;}// let's try to open before running setup
xhr.open('POST',url,true);return licenseXhrSetup.call(_this78.hls,xhr,url,keysListItem,licenseChallenge);}).then(function(licenseXhrSetupResult){// if licenseXhrSetup did not yet call open, let's do it now
if(!xhr.readyState){xhr.open('POST',url,true);}var finalLicenseChallenge=licenseXhrSetupResult?licenseXhrSetupResult:licenseChallenge;return {xhr:xhr,licenseChallenge:finalLicenseChallenge};});}},{key:"requestLicense",value:function requestLicense(keySessionContext,licenseChallenge){var _this79=this;var keyLoadPolicy=this.config.keyLoadPolicy["default"];return new Promise(function(resolve,reject){var url=_this79.getLicenseServerUrl(keySessionContext.keySystem);_this79.log("Sending license request to URL: ".concat(url));var xhr=new XMLHttpRequest();xhr.responseType='arraybuffer';xhr.onreadystatechange=function(){if(!_this79.hls||!keySessionContext.mediaKeysSession){return reject(new Error('invalid state'));}if(xhr.readyState===4){if(xhr.status===200){_this79._requestLicenseFailureCount=0;var data=xhr.response;_this79.log("License received ".concat(data instanceof ArrayBuffer?data.byteLength:data));var licenseResponseCallback=_this79.config.licenseResponseCallback;if(licenseResponseCallback){try{data=licenseResponseCallback.call(_this79.hls,xhr,url,keySessionContext);}catch(error){_this79.error(error);}}resolve(data);}else {var retryConfig=keyLoadPolicy.errorRetry;var maxNumRetry=retryConfig?retryConfig.maxNumRetry:0;_this79._requestLicenseFailureCount++;if(_this79._requestLicenseFailureCount>maxNumRetry||xhr.status>=400&&xhr.status<500){reject(new EMEKeyError({type:ErrorTypes.KEY_SYSTEM_ERROR,details:ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,fatal:true,networkDetails:xhr,response:{url:url,data:undefined,code:xhr.status,text:xhr.statusText}},"License Request XHR failed (".concat(url,"). Status: ").concat(xhr.status," (").concat(xhr.statusText,")")));}else {var attemptsLeft=maxNumRetry-_this79._requestLicenseFailureCount+1;_this79.warn("Retrying license request, ".concat(attemptsLeft," attempts left"));_this79.requestLicense(keySessionContext,licenseChallenge).then(resolve,reject);}}}};if(keySessionContext.licenseXhr&&keySessionContext.licenseXhr.readyState!==XMLHttpRequest.DONE){keySessionContext.licenseXhr.abort();}keySessionContext.licenseXhr=xhr;_this79.setupLicenseXHR(xhr,url,keySessionContext,licenseChallenge).then(function(_ref26){var xhr=_ref26.xhr,licenseChallenge=_ref26.licenseChallenge;if(keySessionContext.keySystem==KeySystems.PLAYREADY){licenseChallenge=_this79.unpackPlayReadyKeyMessage(xhr,licenseChallenge);}xhr.send(licenseChallenge);});});}},{key:"onMediaAttached",value:function onMediaAttached(event,data){if(!this.config.emeEnabled){return;}var media=data.media;// keep reference of media
this.media=media;media.addEventListener('encrypted',this.onMediaEncrypted);media.addEventListener('waitingforkey',this.onWaitingForKey);}},{key:"onMediaDetached",value:function onMediaDetached(){var _this80=this;var media=this.media;var mediaKeysList=this.mediaKeySessions;if(media){media.removeEventListener('encrypted',this.onMediaEncrypted);media.removeEventListener('waitingforkey',this.onWaitingForKey);this.media=null;}this._requestLicenseFailureCount=0;this.setMediaKeysQueue=[];this.mediaKeySessions=[];this.keyIdToKeySessionPromise={};LevelKey.clearKeyUriToKeyIdMap();// Close all sessions and remove media keys from the video element.
var keySessionCount=mediaKeysList.length;EMEController.CDMCleanupPromise=Promise.all(mediaKeysList.map(function(mediaKeySessionContext){return _this80.removeSession(mediaKeySessionContext);}).concat(media==null?void 0:media.setMediaKeys(null)["catch"](function(error){_this80.log("Could not clear media keys: ".concat(error));}))).then(function(){if(keySessionCount){_this80.log('finished closing key sessions and clearing media keys');mediaKeysList.length=0;}})["catch"](function(error){_this80.log("Could not close sessions and clear media keys: ".concat(error));});}},{key:"onManifestLoading",value:function onManifestLoading(){this.keyFormatPromise=null;}},{key:"onManifestLoaded",value:function onManifestLoaded(event,_ref27){var sessionKeys=_ref27.sessionKeys;if(!sessionKeys||!this.config.emeEnabled){return;}if(!this.keyFormatPromise){var keyFormats=sessionKeys.reduce(function(formats,sessionKey){if(formats.indexOf(sessionKey.keyFormat)===-1){formats.push(sessionKey.keyFormat);}return formats;},[]);this.log("Selecting key-system from session-keys ".concat(keyFormats.join(', ')));this.keyFormatPromise=this.getKeyFormatPromise(keyFormats);}}},{key:"removeSession",value:function removeSession(mediaKeySessionContext){var _this81=this;var mediaKeysSession=mediaKeySessionContext.mediaKeysSession,licenseXhr=mediaKeySessionContext.licenseXhr;if(mediaKeysSession){this.log("Remove licenses and keys and close session ".concat(mediaKeysSession.sessionId));if(mediaKeySessionContext._onmessage){mediaKeysSession.removeEventListener('message',mediaKeySessionContext._onmessage);mediaKeySessionContext._onmessage=undefined;}if(mediaKeySessionContext._onkeystatuseschange){mediaKeysSession.removeEventListener('keystatuseschange',mediaKeySessionContext._onkeystatuseschange);mediaKeySessionContext._onkeystatuseschange=undefined;}if(licenseXhr&&licenseXhr.readyState!==XMLHttpRequest.DONE){licenseXhr.abort();}mediaKeySessionContext.mediaKeysSession=mediaKeySessionContext.decryptdata=mediaKeySessionContext.licenseXhr=undefined;var index=this.mediaKeySessions.indexOf(mediaKeySessionContext);if(index>-1){this.mediaKeySessions.splice(index,1);}return mediaKeysSession.remove()["catch"](function(error){_this81.log("Could not remove session: ".concat(error));}).then(function(){return mediaKeysSession.close();})["catch"](function(error){_this81.log("Could not close session: ".concat(error));});}}}]);return EMEController;}();EMEController.CDMCleanupPromise=void 0;var EMEKeyError=/*#__PURE__*/function(_Error2){_inherits(EMEKeyError,_Error2);var _super13=_createSuper(EMEKeyError);function EMEKeyError(data,message){var _this82;_classCallCheck(this,EMEKeyError);_this82=_super13.call(this,message);_this82.data=void 0;data.error||(data.error=new Error(message));_this82.data=data;data.err=data.error;return _this82;}return _createClass(EMEKeyError);}(/*#__PURE__*/_wrapNativeSuper(Error));/**
 * Common Media Object Type
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */var CmObjectType;(function(CmObjectType){/**
   * text file, such as a manifest or playlist
   */CmObjectType["MANIFEST"]="m";/**
   * audio only
   */CmObjectType["AUDIO"]="a";/**
   * video only
   */CmObjectType["VIDEO"]="v";/**
   * muxed audio and video
   */CmObjectType["MUXED"]="av";/**
   * init segment
   */CmObjectType["INIT"]="i";/**
   * caption or subtitle
   */CmObjectType["CAPTION"]="c";/**
   * ISOBMFF timed text track
   */CmObjectType["TIMED_TEXT"]="tt";/**
   * cryptographic key, license or certificate.
   */CmObjectType["KEY"]="k";/**
   * other
   */CmObjectType["OTHER"]="o";})(CmObjectType||(CmObjectType={}));/**
 * Common Media Streaming Format
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */var CmStreamingFormat;(function(CmStreamingFormat){/**
   * MPEG DASH
   */CmStreamingFormat["DASH"]="d";/**
   * HTTP Live Streaming (HLS)
   */CmStreamingFormat["HLS"]="h";/**
   * Smooth Streaming
   */CmStreamingFormat["SMOOTH"]="s";/**
   * Other
   */CmStreamingFormat["OTHER"]="o";})(CmStreamingFormat||(CmStreamingFormat={}));/**
 * CMCD header fields.
 *
 * @group CMCD
 *
 * @beta
 */var CmcdHeaderField;(function(CmcdHeaderField){/**
   * keys whose values vary with the object being requested.
   */CmcdHeaderField["OBJECT"]="CMCD-Object";/**
   * keys whose values vary with each request.
   */CmcdHeaderField["REQUEST"]="CMCD-Request";/**
   * keys whose values are expected to be invariant over the life of the session.
   */CmcdHeaderField["SESSION"]="CMCD-Session";/**
   * keys whose values do not vary with every request or object.
   */CmcdHeaderField["STATUS"]="CMCD-Status";})(CmcdHeaderField||(CmcdHeaderField={}));/**
 * The map of CMCD header fields to official CMCD keys.
 *
 * @internal
 *
 * @group CMCD
 */var CmcdHeaderMap=(_CmcdHeaderMap={},_defineProperty$3(_CmcdHeaderMap,CmcdHeaderField.OBJECT,['br','d','ot','tb']),_defineProperty$3(_CmcdHeaderMap,CmcdHeaderField.REQUEST,['bl','dl','mtp','nor','nrr','su']),_defineProperty$3(_CmcdHeaderMap,CmcdHeaderField.SESSION,['cid','pr','sf','sid','st','v']),_defineProperty$3(_CmcdHeaderMap,CmcdHeaderField.STATUS,['bs','rtp']),_CmcdHeaderMap);/**
 * Structured Field Item
 *
 * @group Structured Field
 *
 * @beta
 */var SfItem=/*#__PURE__*/_createClass(function SfItem(value,params){_classCallCheck(this,SfItem);this.value=void 0;this.params=void 0;if(Array.isArray(value)){value=value.map(function(v){return v instanceof SfItem?v:new SfItem(v);});}this.value=value;this.params=params;});/**
 * A class to represent structured field tokens when `Symbol` is not available.
 *
 * @group Structured Field
 *
 * @beta
 */var SfToken=/*#__PURE__*/_createClass(function SfToken(description){_classCallCheck(this,SfToken);this.description=void 0;this.description=description;});var DICT='Dict';function format(value){if(Array.isArray(value)){return JSON.stringify(value);}if(value instanceof Map){return 'Map{}';}if(value instanceof Set){return 'Set{}';}if(_typeof(value)==='object'){return JSON.stringify(value);}return String(value);}function throwError(action,src,type,cause){return new Error("failed to ".concat(action," \"").concat(format(src),"\" as ").concat(type),{cause:cause});}var BARE_ITEM='Bare Item';var BOOLEAN='Boolean';var BYTES='Byte Sequence';var DECIMAL='Decimal';var INTEGER='Integer';function isInvalidInt(value){return value<-999999999999999||999999999999999<value;}var STRING_REGEX=/[\x00-\x1f\x7f]+/;// eslint-disable-line no-control-regex
var TOKEN='Token';var KEY='Key';function serializeError(src,type,cause){return throwError('serialize',src,type,cause);}// 4.1.9.  Serializing a Boolean
//
// Given a Boolean as input_boolean, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  If input_boolean is not a boolean, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append "?" to output.
//
// 4.  If input_boolean is true, append "1" to output.
//
// 5.  If input_boolean is false, append "0" to output.
//
// 6.  Return output.
function serializeBoolean(value){if(typeof value!=='boolean'){throw serializeError(value,BOOLEAN);}return value?'?1':'?0';}/**
 * Encodes binary data to base64
 *
 * @param binary - The binary data to encode
 * @returns The base64 encoded string
 *
 * @group Utils
 *
 * @beta
 */function base64encode(binary){return btoa(String.fromCharCode.apply(String,_toConsumableArray(binary)));}// 4.1.8.  Serializing a Byte Sequence
//
// Given a Byte Sequence as input_bytes, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_bytes is not a sequence of bytes, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append ":" to output.
//
// 4.  Append the result of base64-encoding input_bytes as per
//     [RFC4648], Section 4, taking account of the requirements below.
//
// 5.  Append ":" to output.
//
// 6.  Return output.
//
// The encoded data is required to be padded with "=", as per [RFC4648],
// Section 3.2.
//
// Likewise, encoded data SHOULD have pad bits set to zero, as per
// [RFC4648], Section 3.5, unless it is not possible to do so due to
// implementation constraints.
function serializeByteSequence(value){if(ArrayBuffer.isView(value)===false){throw serializeError(value,BYTES);}return ":".concat(base64encode(value),":");}// 4.1.4.  Serializing an Integer
//
// Given an Integer as input_integer, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_integer is not an integer in the range of
//     -999,999,999,999,999 to 999,999,999,999,999 inclusive, fail
//     serialization.
//
// 2.  Let output be an empty string.
//
// 3.  If input_integer is less than (but not equal to) 0, append "-" to
//     output.
//
// 4.  Append input_integer's numeric value represented in base 10 using
//     only decimal digits to output.
//
// 5.  Return output.
function serializeInteger(value){if(isInvalidInt(value)){throw serializeError(value,INTEGER);}return value.toString();}// 4.1.10.  Serializing a Date
//
// Given a Date as input_integer, return an ASCII string suitable for
// use in an HTTP field value.
// 1.  Let output be "@".
// 2.  Append to output the result of running Serializing an Integer
//     with input_date (Section 4.1.4).
// 3.  Return output.
function serializeDate(value){return "@".concat(serializeInteger(value.getTime()/1000));}/**
 * This implements the rounding procedure described in step 2 of the "Serializing a Decimal" specification.
 * This rounding style is known as "even rounding", "banker's rounding", or "commercial rounding".
 *
 * @param value - The value to round
 * @param precision - The number of decimal places to round to
 * @returns The rounded value
 *
 * @group Utils
 *
 * @beta
 */function roundToEven(value,precision){if(value<0){return -roundToEven(-value,precision);}var decimalShift=Math.pow(10,precision);var isEquidistant=Math.abs(value*decimalShift%1-0.5)<Number.EPSILON;if(isEquidistant){// If the tail of the decimal place is 'equidistant' we round to the nearest even value
var flooredValue=Math.floor(value*decimalShift);return (flooredValue%2===0?flooredValue:flooredValue+1)/decimalShift;}else {// Otherwise, proceed as normal
return Math.round(value*decimalShift)/decimalShift;}}// 4.1.5.  Serializing a Decimal
//
// Given a decimal number as input_decimal, return an ASCII string
// suitable for use in a HTTP field value.
//
// 1.   If input_decimal is not a decimal number, fail serialization.
//
// 2.   If input_decimal has more than three significant digits to the
//      right of the decimal point, round it to three decimal places,
//      rounding the final digit to the nearest value, or to the even
//      value if it is equidistant.
//
// 3.   If input_decimal has more than 12 significant digits to the left
//      of the decimal point after rounding, fail serialization.
//
// 4.   Let output be an empty string.
//
// 5.   If input_decimal is less than (but not equal to) 0, append "-"
//      to output.
//
// 6.   Append input_decimal's integer component represented in base 10
//      (using only decimal digits) to output; if it is zero, append
//      "0".
//
// 7.   Append "." to output.
//
// 8.   If input_decimal's fractional component is zero, append "0" to
//      output.
//
// 9.   Otherwise, append the significant digits of input_decimal's
//      fractional component represented in base 10 (using only decimal
//      digits) to output.
//
// 10.  Return output.
function serializeDecimal(value){var roundedValue=roundToEven(value,3);// round to 3 decimal places
if(Math.floor(Math.abs(roundedValue)).toString().length>12){throw serializeError(value,DECIMAL);}var stringValue=roundedValue.toString();return stringValue.includes('.')?stringValue:"".concat(stringValue,".0");}var STRING='String';// 4.1.6.  Serializing a String
//
// Given a String as input_string, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Convert input_string into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_string contains characters in the range %x00-1f or %x7f
//     (i.e., not in VCHAR or SP), fail serialization.
//
// 3.  Let output be the string DQUOTE.
//
// 4.  For each character char in input_string:
//
//     1.  If char is "\" or DQUOTE:
//
//         1.  Append "\" to output.
//
//     2.  Append char to output.
//
// 5.  Append DQUOTE to output.
//
// 6.  Return output.
function serializeString(value){if(STRING_REGEX.test(value)){throw serializeError(value,STRING);}return "\"".concat(value.replace(/\\/g,"\\\\").replace(/"/g,"\\\""),"\"");}function symbolToStr(symbol){return symbol.description||symbol.toString().slice(7,-1);}function serializeToken(token){var value=symbolToStr(token);if(/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(value)===false){throw serializeError(value,TOKEN);}return value;}// 4.1.3.1.  Serializing a Bare Item
//
// Given an Item as input_item, return an ASCII string suitable for use
// in a HTTP field value.
//
// 1.  If input_item is an Integer, return the result of running
//     Serializing an Integer (Section 4.1.4) with input_item.
//
// 2.  If input_item is a Decimal, return the result of running
//     Serializing a Decimal (Section 4.1.5) with input_item.
//
// 3.  If input_item is a String, return the result of running
//     Serializing a String (Section 4.1.6) with input_item.
//
// 4.  If input_item is a Token, return the result of running
//     Serializing a Token (Section 4.1.7) with input_item.
//
// 5.  If input_item is a Boolean, return the result of running
//     Serializing a Boolean (Section 4.1.9) with input_item.
//
// 6.  If input_item is a Byte Sequence, return the result of running
//     Serializing a Byte Sequence (Section 4.1.8) with input_item.
//
// 7.  If input_item is a Date, return the result of running Serializing
//     a Date (Section 4.1.10) with input_item.
//
// 8.  Otherwise, fail serialization.
function serializeBareItem(value){switch(_typeof(value)){case'number':if(!isFiniteNumber(value)){throw serializeError(value,BARE_ITEM);}if(Number.isInteger(value)){return serializeInteger(value);}return serializeDecimal(value);case'string':return serializeString(value);case'symbol':return serializeToken(value);case'boolean':return serializeBoolean(value);case'object':if(value instanceof Date){return serializeDate(value);}if(value instanceof Uint8Array){return serializeByteSequence(value);}if(value instanceof SfToken){return serializeToken(value);}default:// fail
throw serializeError(value,BARE_ITEM);}}// 4.1.1.3.  Serializing a Key
//
// Given a key as input_key, return an ASCII string suitable for use in
// a HTTP field value.
//
// 1.  Convert input_key into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_key contains characters not in lcalpha, DIGIT, "_", "-",
//     ".", or "*" fail serialization.
//
// 3.  If the first character of input_key is not lcalpha or "*", fail
//     serialization.
//
// 4.  Let output be an empty string.
//
// 5.  Append input_key to output.
//
// 6.  Return output.
function serializeKey(value){if(/^[a-z*][a-z0-9\-_.*]*$/.test(value)===false){throw serializeError(value,KEY);}return value;}// 4.1.1.2.  Serializing Parameters
//
// Given an ordered Dictionary as input_parameters (each member having a
// param_name and a param_value), return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each param_name with a value of param_value in
//     input_parameters:
//
//     1.  Append ";" to output.
//
//     2.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with param_name to output.
//
//     3.  If param_value is not Boolean true:
//
//         1.  Append "=" to output.
//
//         2.  Append the result of running Serializing a bare Item
//             (Section 4.1.3.1) with param_value to output.
//
// 3.  Return output.
function serializeParams(params){if(params==null){return '';}return Object.entries(params).map(function(_ref28){var _ref29=_slicedToArray(_ref28,2),key=_ref29[0],value=_ref29[1];if(value===true){return ";".concat(serializeKey(key));// omit true
}return ";".concat(serializeKey(key),"=").concat(serializeBareItem(value));}).join('');}// 4.1.3.  Serializing an Item
//
// Given an Item as bare_item and Parameters as item_parameters, return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  Append the result of running Serializing a Bare Item
//     Section 4.1.3.1 with bare_item to output.
//
// 3.  Append the result of running Serializing Parameters
//     Section 4.1.1.2 with item_parameters to output.
//
// 4.  Return output.
function serializeItem(value){if(value instanceof SfItem){return "".concat(serializeBareItem(value.value)).concat(serializeParams(value.params));}else {return serializeBareItem(value);}}// 4.1.1.1.  Serializing an Inner List
//
// Given an array of (member_value, parameters) tuples as inner_list,
// and parameters as list_parameters, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  Let output be the string "(".
//
// 2.  For each (member_value, parameters) of inner_list:
//
//     1.  Append the result of running Serializing an Item
//         (Section 4.1.3) with (member_value, parameters) to output.
//
//     2.  If more values remain in inner_list, append a single SP to
//         output.
//
// 3.  Append ")" to output.
//
// 4.  Append the result of running Serializing Parameters
//     (Section 4.1.1.2) with list_parameters to output.
//
// 5.  Return output.
function serializeInnerList(value){return "(".concat(value.value.map(serializeItem).join(' '),")").concat(serializeParams(value.params));}// 4.1.2.  Serializing a Dictionary
//
// Given an ordered Dictionary as input_dictionary (each member having a
// member_name and a tuple value of (member_value, parameters)), return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each member_name with a value of (member_value, parameters)
//     in input_dictionary:
//
//     1.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with member's member_name to output.
//
//     2.  If member_value is Boolean true:
//
//         1.  Append the result of running Serializing Parameters
//             (Section 4.1.1.2) with parameters to output.
//
//     3.  Otherwise:
//
//         1.  Append "=" to output.
//
//         2.  If member_value is an array, append the result of running
//             Serializing an Inner List (Section 4.1.1.1) with
//             (member_value, parameters) to output.
//
//         3.  Otherwise, append the result of running Serializing an
//             Item (Section 4.1.3) with (member_value, parameters) to
//             output.
//
//     4.  If more members remain in input_dictionary:
//
//         1.  Append "," to output.
//
//         2.  Append a single SP to output.
//
// 3.  Return output.
function serializeDict(dict){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{whitespace:true};if(_typeof(dict)!=='object'){throw serializeError(dict,DICT);}var entries=dict instanceof Map?dict.entries():Object.entries(dict);var optionalWhiteSpace=options!=null&&options.whitespace?' ':'';return Array.from(entries).map(function(_ref30){var _ref31=_slicedToArray(_ref30,2),key=_ref31[0],item=_ref31[1];if(item instanceof SfItem===false){item=new SfItem(item);}var output=serializeKey(key);if(item.value===true){output+=serializeParams(item.params);}else {output+='=';if(Array.isArray(item.value)){output+=serializeInnerList(item);}else {output+=serializeItem(item);}}return output;}).join(",".concat(optionalWhiteSpace));}/**
 * Encode an object into a structured field dictionary
 *
 * @param input - The structured field dictionary to encode
 * @returns The structured field string
 *
 * @group Structured Field
 *
 * @beta
 */function encodeSfDict(value,options){return serializeDict(value,options);}/**
 * Checks if the given key is a token field.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a token field.
 *
 * @internal
 *
 * @group CMCD
 */var isTokenField=function isTokenField(key){return key==='ot'||key==='sf'||key==='st';};var isValid=function isValid(value){if(typeof value==='number'){return isFiniteNumber(value);}return value!=null&&value!==''&&value!==false;};/**
 * Constructs a relative path from a URL.
 *
 * @param url - The destination URL
 * @param base - The base URL
 * @returns The relative path
 *
 * @group Utils
 *
 * @beta
 */function urlToRelativePath(url,base){var to=new URL(url);var from=new URL(base);if(to.origin!==from.origin){return url;}var toPath=to.pathname.split('/').slice(1);var fromPath=from.pathname.split('/').slice(1,-1);// remove common parents
while(toPath[0]===fromPath[0]){toPath.shift();fromPath.shift();}// add back paths
while(fromPath.length){fromPath.shift();toPath.unshift('..');}return toPath.join('/');}/**
 * Generate a random v4 UUID
 *
 * @returns A random v4 UUID
 *
 * @group Utils
 *
 * @beta
 */function uuid(){try{return crypto.randomUUID();}catch(error){try{var url=URL.createObjectURL(new Blob());var _uuid=url.toString();URL.revokeObjectURL(url);return _uuid.slice(_uuid.lastIndexOf('/')+1);}catch(error){var dt=new Date().getTime();var _uuid2='xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){var r=(dt+Math.random()*16)%16|0;dt=Math.floor(dt/16);return (c=='x'?r:r&0x3|0x8).toString(16);});return _uuid2;}}}var toRounded=function toRounded(value){return Math.round(value);};var toUrlSafe=function toUrlSafe(value,options){if(options!=null&&options.baseUrl){value=urlToRelativePath(value,options.baseUrl);}return encodeURIComponent(value);};var toHundred=function toHundred(value){return toRounded(value/100)*100;};/**
 * The default formatters for CMCD values.
 *
 * @group CMCD
 *
 * @beta
 */var CmcdFormatters={/**
   * Bitrate (kbps) rounded integer
   */br:toRounded,/**
   * Duration (milliseconds) rounded integer
   */d:toRounded,/**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */bl:toHundred,/**
   * Deadline (milliseconds) rounded nearest 100ms
   */dl:toHundred,/**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */mtp:toHundred,/**
   * Next Object Request URL encoded
   */nor:toUrlSafe,/**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */rtp:toHundred,/**
   * Top Bitrate (kbps) rounded integer
   */tb:toRounded};/**
 * Internal CMCD processing function.
 *
 * @param obj - The CMCD object to process.
 * @param map - The mapping function to use.
 * @param options - Options for encoding.
 *
 * @internal
 *
 * @group CMCD
 */function processCmcd(obj,options){var results={};if(obj==null||_typeof(obj)!=='object'){return results;}var keys=Object.keys(obj).sort();var formatters=_extends({},CmcdFormatters,options==null?void 0:options.formatters);var filter=options==null?void 0:options.filter;keys.forEach(function(key){if(filter!=null&&filter(key)){return;}var value=obj[key];var formatter=formatters[key];if(formatter){value=formatter(value,options);}// Version should only be reported if not equal to 1.
if(key==='v'&&value===1){return;}// Playback rate should only be sent if not equal to 1.
if(key=='pr'&&value===1){return;}// ignore invalid values
if(!isValid(value)){return;}if(isTokenField(key)&&typeof value==='string'){value=new SfToken(value);}results[key]=value;});return results;}/**
 * Encode a CMCD object to a string.
 *
 * @param cmcd - The CMCD object to encode.
 * @param options - Options for encoding.
 *
 * @returns The encoded CMCD string.
 *
 * @group CMCD
 *
 * @beta
 */function encodeCmcd(cmcd){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!cmcd){return '';}return encodeSfDict(processCmcd(cmcd,options),_extends({whitespace:false},options));}/**
 * Convert a CMCD data object to request headers
 *
 * @param cmcd - The CMCD data object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD header shards.
 *
 * @group CMCD
 *
 * @beta
 */function toCmcdHeaders(cmcd){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!cmcd){return {};}var entries=Object.entries(cmcd);var headerMap=Object.entries(CmcdHeaderMap).concat(Object.entries((options==null?void 0:options.customHeaderMap)||{}));var shards=entries.reduce(function(acc,entry){var _headerMap$find,_acc$field;var _entry=_slicedToArray(entry,2),key=_entry[0],value=_entry[1];var field=((_headerMap$find=headerMap.find(function(entry){return entry[1].includes(key);}))==null?void 0:_headerMap$find[0])||CmcdHeaderField.REQUEST;(_acc$field=acc[field])!=null?_acc$field:acc[field]={};acc[field][key]=value;return acc;},{});return Object.entries(shards).reduce(function(acc,_ref32){var _ref33=_slicedToArray(_ref32,2),field=_ref33[0],value=_ref33[1];acc[field]=encodeCmcd(value,options);return acc;},{});}/**
 * Append CMCD query args to a header object.
 *
 * @param headers - The headers to append to.
 * @param cmcd - The CMCD object to append.
 * @param customHeaderMap - A map of custom CMCD keys to header fields.
 *
 * @returns The headers with the CMCD header shards appended.
 *
 * @group CMCD
 *
 * @beta
 */function appendCmcdHeaders(headers,cmcd,options){return _extends(headers,toCmcdHeaders(cmcd,options));}/**
 * CMCD parameter name.
 *
 * @group CMCD
 *
 * @beta
 */var CMCD_PARAM='CMCD';/**
 * Convert a CMCD data object to a query arg.
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD query arg.
 *
 * @group CMCD
 *
 * @beta
 */function toCmcdQuery(cmcd){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!cmcd){return '';}var params=encodeCmcd(cmcd,options);return "".concat(CMCD_PARAM,"=").concat(encodeURIComponent(params));}var REGEX=/CMCD=[^&#]+/;/**
 * Append CMCD query args to a URL.
 *
 * @param url - The URL to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The URL with the CMCD query args appended.
 *
 * @group CMCD
 *
 * @beta
 */function appendCmcdQuery(url,cmcd,options){// TODO: Replace with URLSearchParams once we drop Safari < 10.1 & Chrome < 49 support.
// https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
var query=toCmcdQuery(cmcd,options);if(!query){return url;}if(REGEX.test(url)){return url.replace(REGEX,query);}var separator=url.includes('?')?'&':'?';return "".concat(url).concat(separator).concat(query);}/**
 * Controller to deal with Common Media Client Data (CMCD)
 * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
 */var CMCDController=/*#__PURE__*/function(){// eslint-disable-line no-restricted-globals
function CMCDController(hls){var _this83=this;_classCallCheck(this,CMCDController);this.hls=void 0;this.config=void 0;this.media=void 0;this.sid=void 0;this.cid=void 0;this.useHeaders=false;this.includeKeys=void 0;this.initialized=false;this.starved=false;this.buffering=true;this.audioBuffer=void 0;// eslint-disable-line no-restricted-globals
this.videoBuffer=void 0;this.onWaiting=function(){if(_this83.initialized){_this83.starved=true;}_this83.buffering=true;};this.onPlaying=function(){if(!_this83.initialized){_this83.initialized=true;}_this83.buffering=false;};/**
     * Apply CMCD data to a manifest request.
     */this.applyPlaylistData=function(context){try{_this83.apply(context,{ot:CmObjectType.MANIFEST,su:!_this83.initialized});}catch(error){logger.warn('Could not generate manifest CMCD data.',error);}};/**
     * Apply CMCD data to a segment request
     */this.applyFragmentData=function(context){try{var fragment=context.frag;var level=_this83.hls.levels[fragment.level];var ot=_this83.getObjectType(fragment);var data={d:fragment.duration*1000,ot:ot};if(ot===CmObjectType.VIDEO||ot===CmObjectType.AUDIO||ot==CmObjectType.MUXED){data.br=level.bitrate/1000;data.tb=_this83.getTopBandwidth(ot)/1000;data.bl=_this83.getBufferLength(ot);}_this83.apply(context,data);}catch(error){logger.warn('Could not generate segment CMCD data.',error);}};this.hls=hls;var config=this.config=hls.config;var cmcd=config.cmcd;if(cmcd!=null){config.pLoader=this.createPlaylistLoader();config.fLoader=this.createFragmentLoader();this.sid=cmcd.sessionId||uuid();this.cid=cmcd.contentId;this.useHeaders=cmcd.useHeaders===true;this.includeKeys=cmcd.includeKeys;this.registerListeners();}}_createClass(CMCDController,[{key:"registerListeners",value:function registerListeners(){var hls=this.hls;hls.on(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.on(Events.MEDIA_DETACHED,this.onMediaDetached,this);hls.on(Events.BUFFER_CREATED,this.onBufferCreated,this);}},{key:"unregisterListeners",value:function unregisterListeners(){var hls=this.hls;hls.off(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.off(Events.MEDIA_DETACHED,this.onMediaDetached,this);hls.off(Events.BUFFER_CREATED,this.onBufferCreated,this);}},{key:"destroy",value:function destroy(){this.unregisterListeners();this.onMediaDetached();// @ts-ignore
this.hls=this.config=this.audioBuffer=this.videoBuffer=null;// @ts-ignore
this.onWaiting=this.onPlaying=null;}},{key:"onMediaAttached",value:function onMediaAttached(event,data){this.media=data.media;this.media.addEventListener('waiting',this.onWaiting);this.media.addEventListener('playing',this.onPlaying);}},{key:"onMediaDetached",value:function onMediaDetached(){if(!this.media){return;}this.media.removeEventListener('waiting',this.onWaiting);this.media.removeEventListener('playing',this.onPlaying);// @ts-ignore
this.media=null;}},{key:"onBufferCreated",value:function onBufferCreated(event,data){var _data$tracks$audio,_data$tracks$video;this.audioBuffer=(_data$tracks$audio=data.tracks.audio)==null?void 0:_data$tracks$audio.buffer;this.videoBuffer=(_data$tracks$video=data.tracks.video)==null?void 0:_data$tracks$video.buffer;}/**
   * Create baseline CMCD data
   */},{key:"createData",value:function createData(){var _this$media;return {v:1,sf:CmStreamingFormat.HLS,sid:this.sid,cid:this.cid,pr:(_this$media=this.media)==null?void 0:_this$media.playbackRate,mtp:this.hls.bandwidthEstimate/1000};}/**
   * Apply CMCD data to a request.
   */},{key:"apply",value:function apply(context){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};// apply baseline data
_extends(data,this.createData());var isVideo=data.ot===CmObjectType.INIT||data.ot===CmObjectType.VIDEO||data.ot===CmObjectType.MUXED;if(this.starved&&isVideo){data.bs=true;data.su=true;this.starved=false;}if(data.su==null){data.su=this.buffering;}// TODO: Implement rtp, nrr, nor, dl
var includeKeys=this.includeKeys;if(includeKeys){data=Object.keys(data).reduce(function(acc,key){includeKeys.includes(key)&&(acc[key]=data[key]);return acc;},{});}if(this.useHeaders){if(!context.headers){context.headers={};}appendCmcdHeaders(context.headers,data);}else {context.url=appendCmcdQuery(context.url,data);}}/**
   * The CMCD object type.
   */},{key:"getObjectType",value:function getObjectType(fragment){var type=fragment.type;if(type==='subtitle'){return CmObjectType.TIMED_TEXT;}if(fragment.sn==='initSegment'){return CmObjectType.INIT;}if(type==='audio'){return CmObjectType.AUDIO;}if(type==='main'){if(!this.hls.audioTracks.length){return CmObjectType.MUXED;}return CmObjectType.VIDEO;}return undefined;}/**
   * Get the highest bitrate.
   */},{key:"getTopBandwidth",value:function getTopBandwidth(type){var bitrate=0;var levels;var hls=this.hls;if(type===CmObjectType.AUDIO){levels=hls.audioTracks;}else {var max=hls.maxAutoLevel;var len=max>-1?max+1:hls.levels.length;levels=hls.levels.slice(0,len);}var _iterator=_createForOfIteratorHelper(levels),_step;try{for(_iterator.s();!(_step=_iterator.n()).done;){var level=_step.value;if(level.bitrate>bitrate){bitrate=level.bitrate;}}}catch(err){_iterator.e(err);}finally{_iterator.f();}return bitrate>0?bitrate:NaN;}/**
   * Get the buffer length for a media type in milliseconds
   */},{key:"getBufferLength",value:function getBufferLength(type){var media=this.hls.media;var buffer=type===CmObjectType.AUDIO?this.audioBuffer:this.videoBuffer;if(!buffer||!media){return NaN;}var info=BufferHelper.bufferInfo(buffer,media.currentTime,this.config.maxBufferHole);return info.len*1000;}/**
   * Create a playlist loader
   */},{key:"createPlaylistLoader",value:function createPlaylistLoader(){var pLoader=this.config.pLoader;var apply=this.applyPlaylistData;var Ctor=pLoader||this.config.loader;return/*#__PURE__*/function(){function CmcdPlaylistLoader(config){_classCallCheck(this,CmcdPlaylistLoader);this.loader=void 0;this.loader=new Ctor(config);}_createClass(CmcdPlaylistLoader,[{key:"stats",get:function get(){return this.loader.stats;}},{key:"context",get:function get(){return this.loader.context;}},{key:"destroy",value:function destroy(){this.loader.destroy();}},{key:"abort",value:function abort(){this.loader.abort();}},{key:"load",value:function load(context,config,callbacks){apply(context);this.loader.load(context,config,callbacks);}}]);return CmcdPlaylistLoader;}();}/**
   * Create a playlist loader
   */},{key:"createFragmentLoader",value:function createFragmentLoader(){var fLoader=this.config.fLoader;var apply=this.applyFragmentData;var Ctor=fLoader||this.config.loader;return/*#__PURE__*/function(){function CmcdFragmentLoader(config){_classCallCheck(this,CmcdFragmentLoader);this.loader=void 0;this.loader=new Ctor(config);}_createClass(CmcdFragmentLoader,[{key:"stats",get:function get(){return this.loader.stats;}},{key:"context",get:function get(){return this.loader.context;}},{key:"destroy",value:function destroy(){this.loader.destroy();}},{key:"abort",value:function abort(){this.loader.abort();}},{key:"load",value:function load(context,config,callbacks){apply(context);this.loader.load(context,config,callbacks);}}]);return CmcdFragmentLoader;}();}}]);return CMCDController;}();var PATHWAY_PENALTY_DURATION_MS=300000;var ContentSteeringController=/*#__PURE__*/function(){function ContentSteeringController(hls){_classCallCheck(this,ContentSteeringController);this.hls=void 0;this.log=void 0;this.loader=null;this.uri=null;this.pathwayId='.';this.pathwayPriority=null;this.timeToLoad=300;this.reloadTimer=-1;this.updated=0;this.started=false;this.enabled=true;this.levels=null;this.audioTracks=null;this.subtitleTracks=null;this.penalizedPathways={};this.hls=hls;this.log=logger.log.bind(logger,"[content-steering]:");this.registerListeners();}_createClass(ContentSteeringController,[{key:"registerListeners",value:function registerListeners(){var hls=this.hls;hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.MANIFEST_LOADED,this.onManifestLoaded,this);hls.on(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.on(Events.ERROR,this.onError,this);}},{key:"unregisterListeners",value:function unregisterListeners(){var hls=this.hls;if(!hls){return;}hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.MANIFEST_LOADED,this.onManifestLoaded,this);hls.off(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.off(Events.ERROR,this.onError,this);}},{key:"startLoad",value:function startLoad(){this.started=true;this.clearTimeout();if(this.enabled&&this.uri){if(this.updated){var ttl=this.timeToLoad*1000-(performance.now()-this.updated);if(ttl>0){this.scheduleRefresh(this.uri,ttl);return;}}this.loadSteeringManifest(this.uri);}}},{key:"stopLoad",value:function stopLoad(){this.started=false;if(this.loader){this.loader.destroy();this.loader=null;}this.clearTimeout();}},{key:"clearTimeout",value:function clearTimeout(){if(this.reloadTimer!==-1){self.clearTimeout(this.reloadTimer);this.reloadTimer=-1;}}},{key:"destroy",value:function destroy(){this.unregisterListeners();this.stopLoad();// @ts-ignore
this.hls=null;this.levels=this.audioTracks=this.subtitleTracks=null;}},{key:"removeLevel",value:function removeLevel(levelToRemove){var levels=this.levels;if(levels){this.levels=levels.filter(function(level){return level!==levelToRemove;});}}},{key:"onManifestLoading",value:function onManifestLoading(){this.stopLoad();this.enabled=true;this.timeToLoad=300;this.updated=0;this.uri=null;this.pathwayId='.';this.levels=this.audioTracks=this.subtitleTracks=null;}},{key:"onManifestLoaded",value:function onManifestLoaded(event,data){var contentSteering=data.contentSteering;if(contentSteering===null){return;}this.pathwayId=contentSteering.pathwayId;this.uri=contentSteering.uri;if(this.started){this.startLoad();}}},{key:"onManifestParsed",value:function onManifestParsed(event,data){this.audioTracks=data.audioTracks;this.subtitleTracks=data.subtitleTracks;}},{key:"onError",value:function onError(event,data){var errorAction=data.errorAction;if((errorAction==null?void 0:errorAction.action)===NetworkErrorAction.SendAlternateToPenaltyBox&&errorAction.flags===ErrorActionFlags.MoveAllAlternatesMatchingHost){var levels=this.levels;var pathwayPriority=this.pathwayPriority;var errorPathway=this.pathwayId;if(data.context){var _data$context3=data.context,groupId=_data$context3.groupId,pathwayId=_data$context3.pathwayId,type=_data$context3.type;if(groupId&&levels){errorPathway=this.getPathwayForGroupId(groupId,type,errorPathway);}else if(pathwayId){errorPathway=pathwayId;}}if(!(errorPathway in this.penalizedPathways)){this.penalizedPathways[errorPathway]=performance.now();}if(!pathwayPriority&&levels){// If PATHWAY-PRIORITY was not provided, list pathways for error handling
pathwayPriority=levels.reduce(function(pathways,level){if(pathways.indexOf(level.pathwayId)===-1){pathways.push(level.pathwayId);}return pathways;},[]);}if(pathwayPriority&&pathwayPriority.length>1){this.updatePathwayPriority(pathwayPriority);errorAction.resolved=this.pathwayId!==errorPathway;}if(!errorAction.resolved){logger.warn("Could not resolve ".concat(data.details," (\"").concat(data.error.message,"\") with content-steering for Pathway: ").concat(errorPathway," levels: ").concat(levels?levels.length:levels," priorities: ").concat(JSON.stringify(pathwayPriority)," penalized: ").concat(JSON.stringify(this.penalizedPathways)));}}}},{key:"filterParsedLevels",value:function filterParsedLevels(levels){// Filter levels to only include those that are in the initial pathway
this.levels=levels;var pathwayLevels=this.getLevelsForPathway(this.pathwayId);if(pathwayLevels.length===0){var pathwayId=levels[0].pathwayId;this.log("No levels found in Pathway ".concat(this.pathwayId,". Setting initial Pathway to \"").concat(pathwayId,"\""));pathwayLevels=this.getLevelsForPathway(pathwayId);this.pathwayId=pathwayId;}if(pathwayLevels.length!==levels.length){this.log("Found ".concat(pathwayLevels.length,"/").concat(levels.length," levels in Pathway \"").concat(this.pathwayId,"\""));}return pathwayLevels;}},{key:"getLevelsForPathway",value:function getLevelsForPathway(pathwayId){if(this.levels===null){return [];}return this.levels.filter(function(level){return pathwayId===level.pathwayId;});}},{key:"updatePathwayPriority",value:function updatePathwayPriority(pathwayPriority){this.pathwayPriority=pathwayPriority;var levels;// Evaluate if we should remove the pathway from the penalized list
var penalizedPathways=this.penalizedPathways;var now=performance.now();Object.keys(penalizedPathways).forEach(function(pathwayId){if(now-penalizedPathways[pathwayId]>PATHWAY_PENALTY_DURATION_MS){delete penalizedPathways[pathwayId];}});for(var i=0;i<pathwayPriority.length;i++){var pathwayId=pathwayPriority[i];if(pathwayId in penalizedPathways){continue;}if(pathwayId===this.pathwayId){return;}var selectedIndex=this.hls.nextLoadLevel;var selectedLevel=this.hls.levels[selectedIndex];levels=this.getLevelsForPathway(pathwayId);if(levels.length>0){this.log("Setting Pathway to \"".concat(pathwayId,"\""));this.pathwayId=pathwayId;reassignFragmentLevelIndexes(levels);this.hls.trigger(Events.LEVELS_UPDATED,{levels:levels});// Set LevelController's level to trigger LEVEL_SWITCHING which loads playlist if needed
var levelAfterChange=this.hls.levels[selectedIndex];if(selectedLevel&&levelAfterChange&&this.levels){if(levelAfterChange.attrs['STABLE-VARIANT-ID']!==selectedLevel.attrs['STABLE-VARIANT-ID']&&levelAfterChange.bitrate!==selectedLevel.bitrate){this.log("Unstable Pathways change from bitrate ".concat(selectedLevel.bitrate," to ").concat(levelAfterChange.bitrate));}this.hls.nextLoadLevel=selectedIndex;}break;}}}},{key:"getPathwayForGroupId",value:function getPathwayForGroupId(groupId,type,defaultPathway){var levels=this.getLevelsForPathway(defaultPathway).concat(this.levels||[]);for(var i=0;i<levels.length;i++){if(type===PlaylistContextType.AUDIO_TRACK&&levels[i].hasAudioGroup(groupId)||type===PlaylistContextType.SUBTITLE_TRACK&&levels[i].hasSubtitleGroup(groupId)){return levels[i].pathwayId;}}return defaultPathway;}},{key:"clonePathways",value:function clonePathways(pathwayClones){var _this84=this;var levels=this.levels;if(!levels){return;}var audioGroupCloneMap={};var subtitleGroupCloneMap={};pathwayClones.forEach(function(pathwayClone){var cloneId=pathwayClone.ID,baseId=pathwayClone['BASE-ID'],uriReplacement=pathwayClone['URI-REPLACEMENT'];if(levels.some(function(level){return level.pathwayId===cloneId;})){return;}var clonedVariants=_this84.getLevelsForPathway(baseId).map(function(baseLevel){var attributes=new AttrList(baseLevel.attrs);attributes['PATHWAY-ID']=cloneId;var clonedAudioGroupId=attributes.AUDIO&&"".concat(attributes.AUDIO,"_clone_").concat(cloneId);var clonedSubtitleGroupId=attributes.SUBTITLES&&"".concat(attributes.SUBTITLES,"_clone_").concat(cloneId);if(clonedAudioGroupId){audioGroupCloneMap[attributes.AUDIO]=clonedAudioGroupId;attributes.AUDIO=clonedAudioGroupId;}if(clonedSubtitleGroupId){subtitleGroupCloneMap[attributes.SUBTITLES]=clonedSubtitleGroupId;attributes.SUBTITLES=clonedSubtitleGroupId;}var url=performUriReplacement(baseLevel.uri,attributes['STABLE-VARIANT-ID'],'PER-VARIANT-URIS',uriReplacement);var clonedLevel=new Level({attrs:attributes,audioCodec:baseLevel.audioCodec,bitrate:baseLevel.bitrate,height:baseLevel.height,name:baseLevel.name,url:url,videoCodec:baseLevel.videoCodec,width:baseLevel.width});if(baseLevel.audioGroups){for(var i=1;i<baseLevel.audioGroups.length;i++){clonedLevel.addGroupId('audio',"".concat(baseLevel.audioGroups[i],"_clone_").concat(cloneId));}}if(baseLevel.subtitleGroups){for(var _i21=1;_i21<baseLevel.subtitleGroups.length;_i21++){clonedLevel.addGroupId('text',"".concat(baseLevel.subtitleGroups[_i21],"_clone_").concat(cloneId));}}return clonedLevel;});levels.push.apply(levels,_toConsumableArray(clonedVariants));cloneRenditionGroups(_this84.audioTracks,audioGroupCloneMap,uriReplacement,cloneId);cloneRenditionGroups(_this84.subtitleTracks,subtitleGroupCloneMap,uriReplacement,cloneId);});}},{key:"loadSteeringManifest",value:function loadSteeringManifest(uri){var _this85=this;var config=this.hls.config;var Loader=config.loader;if(this.loader){this.loader.destroy();}this.loader=new Loader(config);var url;try{url=new self.URL(uri);}catch(error){this.enabled=false;this.log("Failed to parse Steering Manifest URI: ".concat(uri));return;}if(url.protocol!=='data:'){var throughput=(this.hls.bandwidthEstimate||config.abrEwmaDefaultEstimate)|0;url.searchParams.set('_HLS_pathway',this.pathwayId);url.searchParams.set('_HLS_throughput',''+throughput);}var context={responseType:'json',url:url.href};var loadPolicy=config.steeringManifestLoadPolicy["default"];var legacyRetryCompatibility=loadPolicy.errorRetry||loadPolicy.timeoutRetry||{};var loaderConfig={loadPolicy:loadPolicy,timeout:loadPolicy.maxLoadTimeMs,maxRetry:legacyRetryCompatibility.maxNumRetry||0,retryDelay:legacyRetryCompatibility.retryDelayMs||0,maxRetryDelay:legacyRetryCompatibility.maxRetryDelayMs||0};var callbacks={onSuccess:function onSuccess(response,stats,context,networkDetails){_this85.log("Loaded steering manifest: \"".concat(url,"\""));var steeringData=response.data;if(steeringData.VERSION!==1){_this85.log("Steering VERSION ".concat(steeringData.VERSION," not supported!"));return;}_this85.updated=performance.now();_this85.timeToLoad=steeringData.TTL;var reloadUri=steeringData['RELOAD-URI'],pathwayClones=steeringData['PATHWAY-CLONES'],pathwayPriority=steeringData['PATHWAY-PRIORITY'];if(reloadUri){try{_this85.uri=new self.URL(reloadUri,url).href;}catch(error){_this85.enabled=false;_this85.log("Failed to parse Steering Manifest RELOAD-URI: ".concat(reloadUri));return;}}_this85.scheduleRefresh(_this85.uri||context.url);if(pathwayClones){_this85.clonePathways(pathwayClones);}var loadedSteeringData={steeringManifest:steeringData,url:url.toString()};_this85.hls.trigger(Events.STEERING_MANIFEST_LOADED,loadedSteeringData);if(pathwayPriority){_this85.updatePathwayPriority(pathwayPriority);}},onError:function onError(error,context,networkDetails,stats){_this85.log("Error loading steering manifest: ".concat(error.code," ").concat(error.text," (").concat(context.url,")"));_this85.stopLoad();if(error.code===410){_this85.enabled=false;_this85.log("Steering manifest ".concat(context.url," no longer available"));return;}var ttl=_this85.timeToLoad*1000;if(error.code===429){var loader=_this85.loader;if(typeof(loader==null?void 0:loader.getResponseHeader)==='function'){var retryAfter=loader.getResponseHeader('Retry-After');if(retryAfter){ttl=parseFloat(retryAfter)*1000;}}_this85.log("Steering manifest ".concat(context.url," rate limited"));return;}_this85.scheduleRefresh(_this85.uri||context.url,ttl);},onTimeout:function onTimeout(stats,context,networkDetails){_this85.log("Timeout loading steering manifest (".concat(context.url,")"));_this85.scheduleRefresh(_this85.uri||context.url);}};this.log("Requesting steering manifest: ".concat(url));this.loader.load(context,loaderConfig,callbacks);}},{key:"scheduleRefresh",value:function scheduleRefresh(uri){var _this86=this;var ttlMs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.timeToLoad*1000;this.clearTimeout();this.reloadTimer=self.setTimeout(function(){var _this$hls;var media=(_this$hls=_this86.hls)==null?void 0:_this$hls.media;if(media&&!media.ended){_this86.loadSteeringManifest(uri);return;}_this86.scheduleRefresh(uri,_this86.timeToLoad*1000);},ttlMs);}}]);return ContentSteeringController;}();function cloneRenditionGroups(tracks,groupCloneMap,uriReplacement,cloneId){if(!tracks){return;}Object.keys(groupCloneMap).forEach(function(audioGroupId){var clonedTracks=tracks.filter(function(track){return track.groupId===audioGroupId;}).map(function(track){var clonedTrack=_extends({},track);clonedTrack.details=undefined;clonedTrack.attrs=new AttrList(clonedTrack.attrs);clonedTrack.url=clonedTrack.attrs.URI=performUriReplacement(track.url,track.attrs['STABLE-RENDITION-ID'],'PER-RENDITION-URIS',uriReplacement);clonedTrack.groupId=clonedTrack.attrs['GROUP-ID']=groupCloneMap[audioGroupId];clonedTrack.attrs['PATHWAY-ID']=cloneId;return clonedTrack;});tracks.push.apply(tracks,_toConsumableArray(clonedTracks));});}function performUriReplacement(uri,stableId,perOptionKey,uriReplacement){var host=uriReplacement.HOST,params=uriReplacement.PARAMS,perOptionUris=uriReplacement[perOptionKey];var perVariantUri;if(stableId){perVariantUri=perOptionUris==null?void 0:perOptionUris[stableId];if(perVariantUri){uri=perVariantUri;}}var url=new self.URL(uri);if(host&&!perVariantUri){url.host=host;}if(params){Object.keys(params).sort().forEach(function(key){if(key){url.searchParams.set(key,params[key]);}});}return url.href;}var AGE_HEADER_LINE_REGEX=/^age:\s*[\d.]+\s*$/im;var XhrLoader=/*#__PURE__*/function(){function XhrLoader(config){_classCallCheck(this,XhrLoader);this.xhrSetup=void 0;this.requestTimeout=void 0;this.retryTimeout=void 0;this.retryDelay=void 0;this.config=null;this.callbacks=null;this.context=null;this.loader=null;this.stats=void 0;this.xhrSetup=config?config.xhrSetup||null:null;this.stats=new LoadStats();this.retryDelay=0;}_createClass(XhrLoader,[{key:"destroy",value:function destroy(){this.callbacks=null;this.abortInternal();this.loader=null;this.config=null;this.context=null;this.xhrSetup=null;}},{key:"abortInternal",value:function abortInternal(){var loader=this.loader;self.clearTimeout(this.requestTimeout);self.clearTimeout(this.retryTimeout);if(loader){loader.onreadystatechange=null;loader.onprogress=null;if(loader.readyState!==4){this.stats.aborted=true;loader.abort();}}}},{key:"abort",value:function abort(){var _this$callbacks;this.abortInternal();if((_this$callbacks=this.callbacks)!=null&&_this$callbacks.onAbort){this.callbacks.onAbort(this.stats,this.context,this.loader);}}},{key:"load",value:function load(context,config,callbacks){if(this.stats.loading.start){throw new Error('Loader can only be used once.');}this.stats.loading.start=self.performance.now();this.context=context;this.config=config;this.callbacks=callbacks;this.loadInternal();}},{key:"loadInternal",value:function loadInternal(){var _this87=this;var config=this.config,context=this.context;if(!config||!context){return;}var xhr=this.loader=new self.XMLHttpRequest();var stats=this.stats;stats.loading.first=0;stats.loaded=0;stats.aborted=false;var xhrSetup=this.xhrSetup;if(xhrSetup){Promise.resolve().then(function(){if(_this87.loader!==xhr||_this87.stats.aborted)return;return xhrSetup(xhr,context.url);})["catch"](function(error){if(_this87.loader!==xhr||_this87.stats.aborted)return;xhr.open('GET',context.url,true);return xhrSetup(xhr,context.url);}).then(function(){if(_this87.loader!==xhr||_this87.stats.aborted)return;_this87.openAndSendXhr(xhr,context,config);})["catch"](function(error){// IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
_this87.callbacks.onError({code:xhr.status,text:error.message},context,xhr,stats);return;});}else {this.openAndSendXhr(xhr,context,config);}}},{key:"openAndSendXhr",value:function openAndSendXhr(xhr,context,config){if(!xhr.readyState){xhr.open('GET',context.url,true);}var headers=context.headers;var _config$loadPolicy=config.loadPolicy,maxTimeToFirstByteMs=_config$loadPolicy.maxTimeToFirstByteMs,maxLoadTimeMs=_config$loadPolicy.maxLoadTimeMs;if(headers){for(var header in headers){xhr.setRequestHeader(header,headers[header]);}}if(context.rangeEnd){xhr.setRequestHeader('Range','bytes='+context.rangeStart+'-'+(context.rangeEnd-1));}xhr.onreadystatechange=this.readystatechange.bind(this);xhr.onprogress=this.loadprogress.bind(this);xhr.responseType=context.responseType;// setup timeout before we perform request
self.clearTimeout(this.requestTimeout);config.timeout=maxTimeToFirstByteMs&&isFiniteNumber(maxTimeToFirstByteMs)?maxTimeToFirstByteMs:maxLoadTimeMs;this.requestTimeout=self.setTimeout(this.loadtimeout.bind(this),config.timeout);xhr.send();}},{key:"readystatechange",value:function readystatechange(){var context=this.context,xhr=this.loader,stats=this.stats;if(!context||!xhr){return;}var readyState=xhr.readyState;var config=this.config;// don't proceed if xhr has been aborted
if(stats.aborted){return;}// >= HEADERS_RECEIVED
if(readyState>=2){if(stats.loading.first===0){stats.loading.first=Math.max(self.performance.now(),stats.loading.start);// readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
if(config.timeout!==config.loadPolicy.maxLoadTimeMs){self.clearTimeout(this.requestTimeout);config.timeout=config.loadPolicy.maxLoadTimeMs;this.requestTimeout=self.setTimeout(this.loadtimeout.bind(this),config.loadPolicy.maxLoadTimeMs-(stats.loading.first-stats.loading.start));}}if(readyState===4){self.clearTimeout(this.requestTimeout);xhr.onreadystatechange=null;xhr.onprogress=null;var _status=xhr.status;// http status between 200 to 299 are all successful
var useResponseText=xhr.responseType==='text'?xhr.responseText:null;if(_status>=200&&_status<300){var data=useResponseText!=null?useResponseText:xhr.response;if(data!=null){stats.loading.end=Math.max(self.performance.now(),stats.loading.first);var len=xhr.responseType==='arraybuffer'?data.byteLength:data.length;stats.loaded=stats.total=len;stats.bwEstimate=stats.total*8000/(stats.loading.end-stats.loading.first);if(!this.callbacks){return;}var onProgress=this.callbacks.onProgress;if(onProgress){onProgress(stats,context,data,xhr);}if(!this.callbacks){return;}var _response={url:xhr.responseURL,data:data,code:_status};this.callbacks.onSuccess(_response,stats,context,xhr);return;}}// Handle bad status or nullish response
var retryConfig=config.loadPolicy.errorRetry;var retryCount=stats.retry;// if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
var response={url:context.url,data:undefined,code:_status};if(shouldRetry(retryConfig,retryCount,false,response)){this.retry(retryConfig);}else {logger.error("".concat(_status," while loading ").concat(context.url));this.callbacks.onError({code:_status,text:xhr.statusText},context,xhr,stats);}}}}},{key:"loadtimeout",value:function loadtimeout(){if(!this.config)return;var retryConfig=this.config.loadPolicy.timeoutRetry;var retryCount=this.stats.retry;if(shouldRetry(retryConfig,retryCount,true)){this.retry(retryConfig);}else {var _this$context;logger.warn("timeout while loading ".concat((_this$context=this.context)==null?void 0:_this$context.url));var callbacks=this.callbacks;if(callbacks){this.abortInternal();callbacks.onTimeout(this.stats,this.context,this.loader);}}}},{key:"retry",value:function retry(retryConfig){var context=this.context,stats=this.stats;this.retryDelay=getRetryDelay(retryConfig,stats.retry);stats.retry++;logger.warn("".concat(status?'HTTP Status '+status:'Timeout'," while loading ").concat(context==null?void 0:context.url,", retrying ").concat(stats.retry,"/").concat(retryConfig.maxNumRetry," in ").concat(this.retryDelay,"ms"));// abort and reset internal state
this.abortInternal();this.loader=null;// schedule retry
self.clearTimeout(this.retryTimeout);this.retryTimeout=self.setTimeout(this.loadInternal.bind(this),this.retryDelay);}},{key:"loadprogress",value:function loadprogress(event){var stats=this.stats;stats.loaded=event.loaded;if(event.lengthComputable){stats.total=event.total;}}},{key:"getCacheAge",value:function getCacheAge(){var result=null;if(this.loader&&AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())){var ageHeader=this.loader.getResponseHeader('age');result=ageHeader?parseFloat(ageHeader):null;}return result;}},{key:"getResponseHeader",value:function getResponseHeader(name){if(this.loader&&new RegExp("^".concat(name,":\\s*[\\d.]+\\s*$"),'im').test(this.loader.getAllResponseHeaders())){return this.loader.getResponseHeader(name);}return null;}}]);return XhrLoader;}();function fetchSupported(){if(// @ts-ignore
self.fetch&&self.AbortController&&self.ReadableStream&&self.Request){try{new self.ReadableStream({});// eslint-disable-line no-new
return true;}catch(e){/* noop */}}return false;}var BYTERANGE=/(\d+)-(\d+)\/(\d+)/;var FetchLoader=/*#__PURE__*/function(){function FetchLoader(config/* HlsConfig */){_classCallCheck(this,FetchLoader);this.fetchSetup=void 0;this.requestTimeout=void 0;this.request=null;this.response=null;this.controller=void 0;this.context=null;this.config=null;this.callbacks=null;this.stats=void 0;this.loader=null;this.fetchSetup=config.fetchSetup||getRequest;this.controller=new self.AbortController();this.stats=new LoadStats();}_createClass(FetchLoader,[{key:"destroy",value:function destroy(){this.loader=this.callbacks=this.context=this.config=this.request=null;this.abortInternal();this.response=null;// @ts-ignore
this.fetchSetup=this.controller=this.stats=null;}},{key:"abortInternal",value:function abortInternal(){if(this.controller&&!this.stats.loading.end){this.stats.aborted=true;this.controller.abort();}}},{key:"abort",value:function abort(){var _this$callbacks;this.abortInternal();if((_this$callbacks=this.callbacks)!=null&&_this$callbacks.onAbort){this.callbacks.onAbort(this.stats,this.context,this.response);}}},{key:"load",value:function load(context,config,callbacks){var _this88=this;var stats=this.stats;if(stats.loading.start){throw new Error('Loader can only be used once.');}stats.loading.start=self.performance.now();var initParams=getRequestParameters(context,this.controller.signal);var onProgress=callbacks.onProgress;var isArrayBuffer=context.responseType==='arraybuffer';var LENGTH=isArrayBuffer?'byteLength':'length';var _config$loadPolicy2=config.loadPolicy,maxTimeToFirstByteMs=_config$loadPolicy2.maxTimeToFirstByteMs,maxLoadTimeMs=_config$loadPolicy2.maxLoadTimeMs;this.context=context;this.config=config;this.callbacks=callbacks;this.request=this.fetchSetup(context,initParams);self.clearTimeout(this.requestTimeout);config.timeout=maxTimeToFirstByteMs&&isFiniteNumber(maxTimeToFirstByteMs)?maxTimeToFirstByteMs:maxLoadTimeMs;this.requestTimeout=self.setTimeout(function(){_this88.abortInternal();callbacks.onTimeout(stats,context,_this88.response);},config.timeout);self.fetch(this.request).then(function(response){_this88.response=_this88.loader=response;var first=Math.max(self.performance.now(),stats.loading.start);self.clearTimeout(_this88.requestTimeout);config.timeout=maxLoadTimeMs;_this88.requestTimeout=self.setTimeout(function(){_this88.abortInternal();callbacks.onTimeout(stats,context,_this88.response);},maxLoadTimeMs-(first-stats.loading.start));if(!response.ok){var _status2=response.status,statusText=response.statusText;throw new FetchError(statusText||'fetch, bad network response',_status2,response);}stats.loading.first=first;stats.total=getContentLength(response.headers)||stats.total;if(onProgress&&isFiniteNumber(config.highWaterMark)){return _this88.loadProgressively(response,stats,context,config.highWaterMark,onProgress);}if(isArrayBuffer){return response.arrayBuffer();}if(context.responseType==='json'){return response.json();}return response.text();}).then(function(responseData){var response=_this88.response;if(!response){throw new Error('loader destroyed');}self.clearTimeout(_this88.requestTimeout);stats.loading.end=Math.max(self.performance.now(),stats.loading.first);var total=responseData[LENGTH];if(total){stats.loaded=stats.total=total;}var loaderResponse={url:response.url,data:responseData,code:response.status};if(onProgress&&!isFiniteNumber(config.highWaterMark)){onProgress(stats,context,responseData,response);}callbacks.onSuccess(loaderResponse,stats,context,response);})["catch"](function(error){self.clearTimeout(_this88.requestTimeout);if(stats.aborted){return;}// CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
// when destroying, 'error' itself can be undefined
var code=!error?0:error.code||0;var text=!error?null:error.message;callbacks.onError({code:code,text:text},context,error?error.details:null,stats);});}},{key:"getCacheAge",value:function getCacheAge(){var result=null;if(this.response){var ageHeader=this.response.headers.get('age');result=ageHeader?parseFloat(ageHeader):null;}return result;}},{key:"getResponseHeader",value:function getResponseHeader(name){return this.response?this.response.headers.get(name):null;}},{key:"loadProgressively",value:function loadProgressively(response,stats,context){var highWaterMark=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var onProgress=arguments.length>4?arguments[4]:undefined;var chunkCache=new ChunkCache();var reader=response.body.getReader();var pump=function pump(){return reader.read().then(function(data){if(data.done){if(chunkCache.dataLength){onProgress(stats,context,chunkCache.flush(),response);}return Promise.resolve(new ArrayBuffer(0));}var chunk=data.value;var len=chunk.length;stats.loaded+=len;if(len<highWaterMark||chunkCache.dataLength){// The current chunk is too small to to be emitted or the cache already has data
// Push it to the cache
chunkCache.push(chunk);if(chunkCache.dataLength>=highWaterMark){// flush in order to join the typed arrays
onProgress(stats,context,chunkCache.flush(),response);}}else {// If there's nothing cached already, and the chache is large enough
// just emit the progress event
onProgress(stats,context,chunk,response);}return pump();})["catch"](function(){/* aborted */return Promise.reject();});};return pump();}}]);return FetchLoader;}();function getRequestParameters(context,signal){var initParams={method:'GET',mode:'cors',credentials:'same-origin',signal:signal,headers:new self.Headers(_extends({},context.headers))};if(context.rangeEnd){initParams.headers.set('Range','bytes='+context.rangeStart+'-'+String(context.rangeEnd-1));}return initParams;}function getByteRangeLength(byteRangeHeader){var result=BYTERANGE.exec(byteRangeHeader);if(result){return parseInt(result[2])-parseInt(result[1])+1;}}function getContentLength(headers){var contentRange=headers.get('Content-Range');if(contentRange){var byteRangeLength=getByteRangeLength(contentRange);if(isFiniteNumber(byteRangeLength)){return byteRangeLength;}}var contentLength=headers.get('Content-Length');if(contentLength){return parseInt(contentLength);}}function getRequest(context,initParams){return new self.Request(context.url,initParams);}var FetchError=/*#__PURE__*/function(_Error3){_inherits(FetchError,_Error3);var _super14=_createSuper(FetchError);function FetchError(message,code,details){var _this89;_classCallCheck(this,FetchError);_this89=_super14.call(this,message);_this89.code=void 0;_this89.details=void 0;_this89.code=code;_this89.details=details;return _this89;}return _createClass(FetchError);}(/*#__PURE__*/_wrapNativeSuper(Error));var WHITESPACE_CHAR=/\s/;var Cues={newCue:function newCue(track,startTime,endTime,captionScreen){var result=[];var row;// the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
var cue;var indenting;var indent;var text;var Cue=self.VTTCue||self.TextTrackCue;for(var r=0;r<captionScreen.rows.length;r++){row=captionScreen.rows[r];indenting=true;indent=0;text='';if(!row.isEmpty()){var _track$cues;for(var c=0;c<row.chars.length;c++){if(WHITESPACE_CHAR.test(row.chars[c].uchar)&&indenting){indent++;}else {text+=row.chars[c].uchar;indenting=false;}}// To be used for cleaning-up orphaned roll-up captions
row.cueStartTime=startTime;// Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
if(startTime===endTime){endTime+=0.0001;}if(indent>=16){indent--;}else {indent++;}var cueText=fixLineBreaks(text.trim());var id=generateCueId(startTime,endTime,cueText);// If this cue already exists in the track do not push it
if(!(track!=null&&(_track$cues=track.cues)!=null&&_track$cues.getCueById(id))){cue=new Cue(startTime,endTime,cueText);cue.id=id;cue.line=r+1;cue.align='left';// Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
// https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
// Firefox throws an exception and captions break with out of bounds 0-100 values
cue.position=10+Math.min(80,Math.floor(indent*8/32)*10);result.push(cue);}}}if(track&&result.length){// Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
result.sort(function(cueA,cueB){if(cueA.line==='auto'||cueB.line==='auto'){return 0;}if(cueA.line>8&&cueB.line>8){return cueB.line-cueA.line;}return cueA.line-cueB.line;});result.forEach(function(cue){return addCueToTrack(track,cue);});}return result;}};/**
 * @deprecated use fragLoadPolicy.default
 */ /**
 * @deprecated use manifestLoadPolicy.default and playlistLoadPolicy.default
 */var defaultLoadPolicy={maxTimeToFirstByteMs:8000,maxLoadTimeMs:20000,timeoutRetry:null,errorRetry:null};/**
 * @ignore
 * If possible, keep hlsDefaultConfig shallow
 * It is cloned whenever a new Hls instance is created, by keeping the config
 * shallow the properties are cloned, and we don't end up manipulating the default
 */var hlsDefaultConfig=_objectSpread2$2(_objectSpread2$2({autoStartLoad:true,// used by stream-controller
startPosition:-1,// used by stream-controller
defaultAudioCodec:undefined,// used by stream-controller
debug:false,// used by logger
capLevelOnFPSDrop:false,// used by fps-controller
capLevelToPlayerSize:false,// used by cap-level-controller
ignoreDevicePixelRatio:false,// used by cap-level-controller
preferManagedMediaSource:true,initialLiveManifestSize:1,// used by stream-controller
maxBufferLength:30,// used by stream-controller
backBufferLength:Infinity,// used by buffer-controller
frontBufferFlushThreshold:Infinity,maxBufferSize:60*1000*1000,// used by stream-controller
maxBufferHole:0.1,// used by stream-controller
highBufferWatchdogPeriod:2,// used by stream-controller
nudgeOffset:0.1,// used by stream-controller
nudgeMaxRetry:3,// used by stream-controller
maxFragLookUpTolerance:0.25,// used by stream-controller
liveSyncDurationCount:3,// used by latency-controller
liveMaxLatencyDurationCount:Infinity,// used by latency-controller
liveSyncDuration:undefined,// used by latency-controller
liveMaxLatencyDuration:undefined,// used by latency-controller
maxLiveSyncPlaybackRate:1,// used by latency-controller
liveDurationInfinity:false,// used by buffer-controller
/**
   * @deprecated use backBufferLength
   */liveBackBufferLength:null,// used by buffer-controller
maxMaxBufferLength:600,// used by stream-controller
enableWorker:true,// used by transmuxer
workerPath:null,// used by transmuxer
enableSoftwareAES:true,// used by decrypter
startLevel:undefined,// used by level-controller
startFragPrefetch:false,// used by stream-controller
fpsDroppedMonitoringPeriod:5000,// used by fps-controller
fpsDroppedMonitoringThreshold:0.2,// used by fps-controller
appendErrorMaxRetry:3,// used by buffer-controller
loader:XhrLoader,// loader: FetchLoader,
fLoader:undefined,// used by fragment-loader
pLoader:undefined,// used by playlist-loader
xhrSetup:undefined,// used by xhr-loader
licenseXhrSetup:undefined,// used by eme-controller
licenseResponseCallback:undefined,// used by eme-controller
abrController:AbrController,bufferController:BufferController,capLevelController:CapLevelController,errorController:ErrorController,fpsController:FPSController,stretchShortVideoTrack:false,// used by mp4-remuxer
maxAudioFramesDrift:1,// used by mp4-remuxer
forceKeyFrameOnDiscontinuity:true,// used by ts-demuxer
abrEwmaFastLive:3,// used by abr-controller
abrEwmaSlowLive:9,// used by abr-controller
abrEwmaFastVoD:3,// used by abr-controller
abrEwmaSlowVoD:9,// used by abr-controller
abrEwmaDefaultEstimate:5e5,// 500 kbps  // used by abr-controller
abrEwmaDefaultEstimateMax:5e6,// 5 mbps
abrBandWidthFactor:0.95,// used by abr-controller
abrBandWidthUpFactor:0.7,// used by abr-controller
abrMaxWithRealBitrate:false,// used by abr-controller
maxStarvationDelay:4,// used by abr-controller
maxLoadingDelay:4,// used by abr-controller
minAutoBitrate:0,// used by hls
emeEnabled:false,// used by eme-controller
widevineLicenseUrl:undefined,// used by eme-controller
drmSystems:{},// used by eme-controller
drmSystemOptions:{},// used by eme-controller
requestMediaKeySystemAccessFunc:_requestMediaKeySystemAccess,// used by eme-controller
testBandwidth:true,progressive:false,lowLatencyMode:true,cmcd:undefined,enableDateRangeMetadataCues:true,enableEmsgMetadataCues:true,enableID3MetadataCues:true,useMediaCapabilities:true,certLoadPolicy:{"default":defaultLoadPolicy},keyLoadPolicy:{"default":{maxTimeToFirstByteMs:8000,maxLoadTimeMs:20000,timeoutRetry:{maxNumRetry:1,retryDelayMs:1000,maxRetryDelayMs:20000,backoff:'linear'},errorRetry:{maxNumRetry:8,retryDelayMs:1000,maxRetryDelayMs:20000,backoff:'linear'}}},manifestLoadPolicy:{"default":{maxTimeToFirstByteMs:Infinity,maxLoadTimeMs:20000,timeoutRetry:{maxNumRetry:2,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:1,retryDelayMs:1000,maxRetryDelayMs:8000}}},playlistLoadPolicy:{"default":{maxTimeToFirstByteMs:10000,maxLoadTimeMs:20000,timeoutRetry:{maxNumRetry:2,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:2,retryDelayMs:1000,maxRetryDelayMs:8000}}},fragLoadPolicy:{"default":{maxTimeToFirstByteMs:10000,maxLoadTimeMs:120000,timeoutRetry:{maxNumRetry:4,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:6,retryDelayMs:1000,maxRetryDelayMs:8000}}},steeringManifestLoadPolicy:{"default":{maxTimeToFirstByteMs:10000,maxLoadTimeMs:20000,timeoutRetry:{maxNumRetry:2,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:1,retryDelayMs:1000,maxRetryDelayMs:8000}}},// These default settings are deprecated in favor of the above policies
// and are maintained for backwards compatibility
manifestLoadingTimeOut:10000,manifestLoadingMaxRetry:1,manifestLoadingRetryDelay:1000,manifestLoadingMaxRetryTimeout:64000,levelLoadingTimeOut:10000,levelLoadingMaxRetry:4,levelLoadingRetryDelay:1000,levelLoadingMaxRetryTimeout:64000,fragLoadingTimeOut:20000,fragLoadingMaxRetry:6,fragLoadingRetryDelay:1000,fragLoadingMaxRetryTimeout:64000},timelineConfig()),{},{subtitleStreamController:SubtitleStreamController,subtitleTrackController:SubtitleTrackController,timelineController:TimelineController,audioStreamController:AudioStreamController,audioTrackController:AudioTrackController,emeController:EMEController,cmcdController:CMCDController,contentSteeringController:ContentSteeringController});function timelineConfig(){return {cueHandler:Cues,// used by timeline-controller
enableWebVTT:true,// used by timeline-controller
enableIMSC1:true,// used by timeline-controller
enableCEA708Captions:true,// used by timeline-controller
captionsTextTrack1Label:'English',// used by timeline-controller
captionsTextTrack1LanguageCode:'en',// used by timeline-controller
captionsTextTrack2Label:'Spanish',// used by timeline-controller
captionsTextTrack2LanguageCode:'es',// used by timeline-controller
captionsTextTrack3Label:'Unknown CC',// used by timeline-controller
captionsTextTrack3LanguageCode:'',// used by timeline-controller
captionsTextTrack4Label:'Unknown CC',// used by timeline-controller
captionsTextTrack4LanguageCode:'',// used by timeline-controller
renderTextTracksNatively:true};}/**
 * @ignore
 */function mergeConfig$1(defaultConfig,userConfig){if((userConfig.liveSyncDurationCount||userConfig.liveMaxLatencyDurationCount)&&(userConfig.liveSyncDuration||userConfig.liveMaxLatencyDuration)){throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");}if(userConfig.liveMaxLatencyDurationCount!==undefined&&(userConfig.liveSyncDurationCount===undefined||userConfig.liveMaxLatencyDurationCount<=userConfig.liveSyncDurationCount)){throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');}if(userConfig.liveMaxLatencyDuration!==undefined&&(userConfig.liveSyncDuration===undefined||userConfig.liveMaxLatencyDuration<=userConfig.liveSyncDuration)){throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');}var defaultsCopy=deepCpy(defaultConfig);// Backwards compatibility with deprecated config values
var deprecatedSettingTypes=['manifest','level','frag'];var deprecatedSettings=['TimeOut','MaxRetry','RetryDelay','MaxRetryTimeout'];deprecatedSettingTypes.forEach(function(type){var policyName="".concat(type==='level'?'playlist':type,"LoadPolicy");var policyNotSet=userConfig[policyName]===undefined;var report=[];deprecatedSettings.forEach(function(setting){var deprecatedSetting="".concat(type,"Loading").concat(setting);var value=userConfig[deprecatedSetting];if(value!==undefined&&policyNotSet){report.push(deprecatedSetting);var settings=defaultsCopy[policyName]["default"];userConfig[policyName]={"default":settings};switch(setting){case'TimeOut':settings.maxLoadTimeMs=value;settings.maxTimeToFirstByteMs=value;break;case'MaxRetry':settings.errorRetry.maxNumRetry=value;settings.timeoutRetry.maxNumRetry=value;break;case'RetryDelay':settings.errorRetry.retryDelayMs=value;settings.timeoutRetry.retryDelayMs=value;break;case'MaxRetryTimeout':settings.errorRetry.maxRetryDelayMs=value;settings.timeoutRetry.maxRetryDelayMs=value;break;}}});if(report.length){logger.warn("hls.js config: \"".concat(report.join('", "'),"\" setting(s) are deprecated, use \"").concat(policyName,"\": ").concat(JSON.stringify(userConfig[policyName])));}});return _objectSpread2$2(_objectSpread2$2({},defaultsCopy),userConfig);}function deepCpy(obj){if(obj&&_typeof(obj)==='object'){if(Array.isArray(obj)){return obj.map(deepCpy);}return Object.keys(obj).reduce(function(result,key){result[key]=deepCpy(obj[key]);return result;},{});}return obj;}/**
 * @ignore
 */function enableStreamingMode(config){var currentLoader=config.loader;if(currentLoader!==FetchLoader&&currentLoader!==XhrLoader){// If a developer has configured their own loader, respect that choice
logger.log('[config]: Custom loader detected, cannot enable progressive streaming');config.progressive=false;}else {var canStreamProgressively=fetchSupported();if(canStreamProgressively){config.loader=FetchLoader;config.progressive=true;config.enableSoftwareAES=true;logger.log('[config]: Progressive streaming enabled, using FetchLoader');}}}var chromeOrFirefox;var LevelController=/*#__PURE__*/function(_BasePlaylistControll3){_inherits(LevelController,_BasePlaylistControll3);var _super15=_createSuper(LevelController);function LevelController(hls,contentSteeringController){var _this90;_classCallCheck(this,LevelController);_this90=_super15.call(this,hls,'[level-controller]');_this90._levels=[];_this90._firstLevel=-1;_this90._maxAutoLevel=-1;_this90._startLevel=void 0;_this90.currentLevel=null;_this90.currentLevelIndex=-1;_this90.manualLevelIndex=-1;_this90.steering=void 0;_this90.onParsedComplete=void 0;_this90.steering=contentSteeringController;_this90._registerListeners();return _this90;}_createClass(LevelController,[{key:"_registerListeners",value:function _registerListeners(){var hls=this.hls;hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.MANIFEST_LOADED,this.onManifestLoaded,this);hls.on(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.on(Events.LEVELS_UPDATED,this.onLevelsUpdated,this);hls.on(Events.FRAG_BUFFERED,this.onFragBuffered,this);hls.on(Events.ERROR,this.onError,this);}},{key:"_unregisterListeners",value:function _unregisterListeners(){var hls=this.hls;hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.MANIFEST_LOADED,this.onManifestLoaded,this);hls.off(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.off(Events.LEVELS_UPDATED,this.onLevelsUpdated,this);hls.off(Events.FRAG_BUFFERED,this.onFragBuffered,this);hls.off(Events.ERROR,this.onError,this);}},{key:"destroy",value:function destroy(){this._unregisterListeners();this.steering=null;this.resetLevels();_get(_getPrototypeOf(LevelController.prototype),"destroy",this).call(this);}},{key:"stopLoad",value:function stopLoad(){var levels=this._levels;// clean up live level details to force reload them, and reset load errors
levels.forEach(function(level){level.loadError=0;level.fragmentError=0;});_get(_getPrototypeOf(LevelController.prototype),"stopLoad",this).call(this);}},{key:"resetLevels",value:function resetLevels(){this._startLevel=undefined;this.manualLevelIndex=-1;this.currentLevelIndex=-1;this.currentLevel=null;this._levels=[];this._maxAutoLevel=-1;}},{key:"onManifestLoading",value:function onManifestLoading(event,data){this.resetLevels();}},{key:"onManifestLoaded",value:function onManifestLoaded(event,data){var preferManagedMediaSource=this.hls.config.preferManagedMediaSource;var levels=[];var redundantSet={};var generatePathwaySet={};var resolutionFound=false;var videoCodecFound=false;var audioCodecFound=false;data.levels.forEach(function(levelParsed){var _audioCodec,_videoCodec;var attributes=levelParsed.attrs;// erase audio codec info if browser does not support mp4a.40.34.
// demuxer will autodetect codec and fallback to mpeg/audio
var audioCodec=levelParsed.audioCodec,videoCodec=levelParsed.videoCodec;if(((_audioCodec=audioCodec)==null?void 0:_audioCodec.indexOf('mp4a.40.34'))!==-1){chromeOrFirefox||(chromeOrFirefox=/chrome|firefox/i.test(navigator.userAgent));if(chromeOrFirefox){levelParsed.audioCodec=audioCodec=undefined;}}if(audioCodec){levelParsed.audioCodec=audioCodec=getCodecCompatibleName(audioCodec,preferManagedMediaSource);}if(((_videoCodec=videoCodec)==null?void 0:_videoCodec.indexOf('avc1'))===0){videoCodec=levelParsed.videoCodec=convertAVC1ToAVCOTI(videoCodec);}// only keep levels with supported audio/video codecs
var width=levelParsed.width,height=levelParsed.height,unknownCodecs=levelParsed.unknownCodecs;resolutionFound||(resolutionFound=!!(width&&height));videoCodecFound||(videoCodecFound=!!videoCodec);audioCodecFound||(audioCodecFound=!!audioCodec);if(unknownCodecs!=null&&unknownCodecs.length||audioCodec&&!areCodecsMediaSourceSupported(audioCodec,'audio',preferManagedMediaSource)||videoCodec&&!areCodecsMediaSourceSupported(videoCodec,'video',preferManagedMediaSource)){return;}var CODECS=attributes.CODECS,FRAMERATE=attributes['FRAME-RATE'],HDCP=attributes['HDCP-LEVEL'],PATHWAY=attributes['PATHWAY-ID'],RESOLUTION=attributes.RESOLUTION,VIDEO_RANGE=attributes['VIDEO-RANGE'];var contentSteeringPrefix="".concat(PATHWAY||'.',"-");var levelKey="".concat(contentSteeringPrefix).concat(levelParsed.bitrate,"-").concat(RESOLUTION,"-").concat(FRAMERATE,"-").concat(CODECS,"-").concat(VIDEO_RANGE,"-").concat(HDCP);if(!redundantSet[levelKey]){var level=new Level(levelParsed);redundantSet[levelKey]=level;generatePathwaySet[levelKey]=1;levels.push(level);}else if(redundantSet[levelKey].uri!==levelParsed.url&&!levelParsed.attrs['PATHWAY-ID']){// Assign Pathway IDs to Redundant Streams (default Pathways is ".". Redundant Streams "..", "...", and so on.)
// Content Steering controller to handles Pathway fallback on error
var pathwayCount=generatePathwaySet[levelKey]+=1;levelParsed.attrs['PATHWAY-ID']=new Array(pathwayCount+1).join('.');var _level4=new Level(levelParsed);redundantSet[levelKey]=_level4;levels.push(_level4);}else {redundantSet[levelKey].addGroupId('audio',attributes.AUDIO);redundantSet[levelKey].addGroupId('text',attributes.SUBTITLES);}});this.filterAndSortMediaOptions(levels,data,resolutionFound,videoCodecFound,audioCodecFound);}},{key:"filterAndSortMediaOptions",value:function filterAndSortMediaOptions(filteredLevels,data,resolutionFound,videoCodecFound,audioCodecFound){var _this91=this;var audioTracks=[];var subtitleTracks=[];var levels=filteredLevels;// remove audio-only and invalid video-range levels if we also have levels with video codecs or RESOLUTION signalled
if((resolutionFound||videoCodecFound)&&audioCodecFound){levels=levels.filter(function(_ref34){var videoCodec=_ref34.videoCodec,videoRange=_ref34.videoRange,width=_ref34.width,height=_ref34.height;return (!!videoCodec||!!(width&&height))&&isVideoRange(videoRange);});}if(levels.length===0){// Dispatch error after MANIFEST_LOADED is done propagating
Promise.resolve().then(function(){if(_this91.hls){if(data.levels.length){_this91.warn("One or more CODECS in variant not supported: ".concat(JSON.stringify(data.levels[0].attrs)));}var error=new Error('no level with compatible codecs found in manifest');_this91.hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,fatal:true,url:data.url,error:error,reason:error.message});}});return;}if(data.audioTracks){var preferManagedMediaSource=this.hls.config.preferManagedMediaSource;audioTracks=data.audioTracks.filter(function(track){return !track.audioCodec||areCodecsMediaSourceSupported(track.audioCodec,'audio',preferManagedMediaSource);});// Assign ids after filtering as array indices by group-id
assignTrackIdsByGroup(audioTracks);}if(data.subtitles){subtitleTracks=data.subtitles;assignTrackIdsByGroup(subtitleTracks);}// start bitrate is the first bitrate of the manifest
var unsortedLevels=levels.slice(0);// sort levels from lowest to highest
levels.sort(function(a,b){if(a.attrs['HDCP-LEVEL']!==b.attrs['HDCP-LEVEL']){return (a.attrs['HDCP-LEVEL']||'')>(b.attrs['HDCP-LEVEL']||'')?1:-1;}// sort on height before bitrate for cap-level-controller
if(resolutionFound&&a.height!==b.height){return a.height-b.height;}if(a.frameRate!==b.frameRate){return a.frameRate-b.frameRate;}if(a.videoRange!==b.videoRange){return VideoRangeValues.indexOf(a.videoRange)-VideoRangeValues.indexOf(b.videoRange);}if(a.videoCodec!==b.videoCodec){var valueA=videoCodecPreferenceValue(a.videoCodec);var valueB=videoCodecPreferenceValue(b.videoCodec);if(valueA!==valueB){return valueB-valueA;}}if(a.uri===b.uri&&a.codecSet!==b.codecSet){var _valueA=codecsSetSelectionPreferenceValue(a.codecSet);var _valueB=codecsSetSelectionPreferenceValue(b.codecSet);if(_valueA!==_valueB){return _valueB-_valueA;}}if(a.averageBitrate!==b.averageBitrate){return a.averageBitrate-b.averageBitrate;}return 0;});var firstLevelInPlaylist=unsortedLevels[0];if(this.steering){levels=this.steering.filterParsedLevels(levels);if(levels.length!==unsortedLevels.length){for(var i=0;i<unsortedLevels.length;i++){if(unsortedLevels[i].pathwayId===levels[0].pathwayId){firstLevelInPlaylist=unsortedLevels[i];break;}}}}this._levels=levels;// find index of first level in sorted levels
for(var _i22=0;_i22<levels.length;_i22++){if(levels[_i22]===firstLevelInPlaylist){var _this$hls$userConfig;this._firstLevel=_i22;var firstLevelBitrate=firstLevelInPlaylist.bitrate;var bandwidthEstimate=this.hls.bandwidthEstimate;this.log("manifest loaded, ".concat(levels.length," level(s) found, first bitrate: ").concat(firstLevelBitrate));// Update default bwe to first variant bitrate as long it has not been configured or set
if(((_this$hls$userConfig=this.hls.userConfig)==null?void 0:_this$hls$userConfig.abrEwmaDefaultEstimate)===undefined){var startingBwEstimate=Math.min(firstLevelBitrate,this.hls.config.abrEwmaDefaultEstimateMax);if(startingBwEstimate>bandwidthEstimate&&bandwidthEstimate===hlsDefaultConfig.abrEwmaDefaultEstimate){this.hls.bandwidthEstimate=startingBwEstimate;}}break;}}// Audio is only alternate if manifest include a URI along with the audio group tag,
// and this is not an audio-only stream where levels contain audio-only
var audioOnly=audioCodecFound&&!videoCodecFound;var edata={levels:levels,audioTracks:audioTracks,subtitleTracks:subtitleTracks,sessionData:data.sessionData,sessionKeys:data.sessionKeys,firstLevel:this._firstLevel,stats:data.stats,audio:audioCodecFound,video:videoCodecFound,altAudio:!audioOnly&&audioTracks.some(function(t){return !!t.url;})};this.hls.trigger(Events.MANIFEST_PARSED,edata);// Initiate loading after all controllers have received MANIFEST_PARSED
if(this.hls.config.autoStartLoad||this.hls.forceStartLoad){this.hls.startLoad(this.hls.config.startPosition);}}},{key:"levels",get:function get(){if(this._levels.length===0){return null;}return this._levels;}},{key:"level",get:function get(){return this.currentLevelIndex;},set:function set(newLevel){var levels=this._levels;if(levels.length===0){return;}// check if level idx is valid
if(newLevel<0||newLevel>=levels.length){// invalid level id given, trigger error
var error=new Error('invalid level idx');var fatal=newLevel<0;this.hls.trigger(Events.ERROR,{type:ErrorTypes.OTHER_ERROR,details:ErrorDetails.LEVEL_SWITCH_ERROR,level:newLevel,fatal:fatal,error:error,reason:error.message});if(fatal){return;}newLevel=Math.min(newLevel,levels.length-1);}var lastLevelIndex=this.currentLevelIndex;var lastLevel=this.currentLevel;var lastPathwayId=lastLevel?lastLevel.attrs['PATHWAY-ID']:undefined;var level=levels[newLevel];var pathwayId=level.attrs['PATHWAY-ID'];this.currentLevelIndex=newLevel;this.currentLevel=level;if(lastLevelIndex===newLevel&&level.details&&lastLevel&&lastPathwayId===pathwayId){return;}this.log("Switching to level ".concat(newLevel," (").concat(level.height?level.height+'p ':'').concat(level.videoRange?level.videoRange+' ':'').concat(level.codecSet?level.codecSet+' ':'',"@").concat(level.bitrate,")").concat(pathwayId?' with Pathway '+pathwayId:''," from level ").concat(lastLevelIndex).concat(lastPathwayId?' with Pathway '+lastPathwayId:''));var levelSwitchingData={level:newLevel,attrs:level.attrs,details:level.details,bitrate:level.bitrate,averageBitrate:level.averageBitrate,maxBitrate:level.maxBitrate,realBitrate:level.realBitrate,width:level.width,height:level.height,codecSet:level.codecSet,audioCodec:level.audioCodec,videoCodec:level.videoCodec,audioGroups:level.audioGroups,subtitleGroups:level.subtitleGroups,loaded:level.loaded,loadError:level.loadError,fragmentError:level.fragmentError,name:level.name,id:level.id,uri:level.uri,url:level.url,urlId:0,audioGroupIds:level.audioGroupIds,textGroupIds:level.textGroupIds};this.hls.trigger(Events.LEVEL_SWITCHING,levelSwitchingData);// check if we need to load playlist for this level
var levelDetails=level.details;if(!levelDetails||levelDetails.live){// level not retrieved yet, or live playlist we need to (re)load it
var hlsUrlParameters=this.switchParams(level.uri,lastLevel==null?void 0:lastLevel.details,levelDetails);this.loadPlaylist(hlsUrlParameters);}}},{key:"manualLevel",get:function get(){return this.manualLevelIndex;},set:function set(newLevel){this.manualLevelIndex=newLevel;if(this._startLevel===undefined){this._startLevel=newLevel;}if(newLevel!==-1){this.level=newLevel;}}},{key:"firstLevel",get:function get(){return this._firstLevel;},set:function set(newLevel){this._firstLevel=newLevel;}},{key:"startLevel",get:function get(){// Setting hls.startLevel (this._startLevel) overrides config.startLevel
if(this._startLevel===undefined){var configStartLevel=this.hls.config.startLevel;if(configStartLevel!==undefined){return configStartLevel;}return this.hls.firstAutoLevel;}return this._startLevel;},set:function set(newLevel){this._startLevel=newLevel;}},{key:"onError",value:function onError(event,data){if(data.fatal||!data.context){return;}if(data.context.type===PlaylistContextType.LEVEL&&data.context.level===this.level){this.checkRetry(data);}}// reset errors on the successful load of a fragment
},{key:"onFragBuffered",value:function onFragBuffered(event,_ref35){var frag=_ref35.frag;if(frag!==undefined&&frag.type===PlaylistLevelType.MAIN){var el=frag.elementaryStreams;if(!Object.keys(el).some(function(type){return !!el[type];})){return;}var level=this._levels[frag.level];if(level!=null&&level.loadError){this.log("Resetting level error count of ".concat(level.loadError," on frag buffered"));level.loadError=0;}}}},{key:"onLevelLoaded",value:function onLevelLoaded(event,data){var _data$deliveryDirecti2;var level=data.level,details=data.details;var curLevel=this._levels[level];if(!curLevel){var _data$deliveryDirecti;this.warn("Invalid level index ".concat(level));if((_data$deliveryDirecti=data.deliveryDirectives)!=null&&_data$deliveryDirecti.skip){details.deltaUpdateFailed=true;}return;}// only process level loaded events matching with expected level
if(level===this.currentLevelIndex){// reset level load error counter on successful level loaded only if there is no issues with fragments
if(curLevel.fragmentError===0){curLevel.loadError=0;}this.playlistLoaded(level,data,curLevel.details);}else if((_data$deliveryDirecti2=data.deliveryDirectives)!=null&&_data$deliveryDirecti2.skip){// received a delta playlist update that cannot be merged
details.deltaUpdateFailed=true;}}},{key:"loadPlaylist",value:function loadPlaylist(hlsUrlParameters){_get(_getPrototypeOf(LevelController.prototype),"loadPlaylist",this).call(this);var currentLevelIndex=this.currentLevelIndex;var currentLevel=this.currentLevel;if(currentLevel&&this.shouldLoadPlaylist(currentLevel)){var url=currentLevel.uri;if(hlsUrlParameters){try{url=hlsUrlParameters.addDirectives(url);}catch(error){this.warn("Could not construct new URL with HLS Delivery Directives: ".concat(error));}}var pathwayId=currentLevel.attrs['PATHWAY-ID'];this.log("Loading level index ".concat(currentLevelIndex).concat((hlsUrlParameters==null?void 0:hlsUrlParameters.msn)!==undefined?' at sn '+hlsUrlParameters.msn+' part '+hlsUrlParameters.part:''," with").concat(pathwayId?' Pathway '+pathwayId:''," ").concat(url));// console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
// console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
this.clearTimer();this.hls.trigger(Events.LEVEL_LOADING,{url:url,level:currentLevelIndex,pathwayId:currentLevel.attrs['PATHWAY-ID'],id:0,// Deprecated Level urlId
deliveryDirectives:hlsUrlParameters||null});}}},{key:"nextLoadLevel",get:function get(){if(this.manualLevelIndex!==-1){return this.manualLevelIndex;}else {return this.hls.nextAutoLevel;}},set:function set(nextLevel){this.level=nextLevel;if(this.manualLevelIndex===-1){this.hls.nextAutoLevel=nextLevel;}}},{key:"removeLevel",value:function removeLevel(levelIndex){var _this92=this;var _this$currentLevel;var levels=this._levels.filter(function(level,index){if(index!==levelIndex){return true;}if(_this92.steering){_this92.steering.removeLevel(level);}if(level===_this92.currentLevel){_this92.currentLevel=null;_this92.currentLevelIndex=-1;if(level.details){level.details.fragments.forEach(function(f){return f.level=-1;});}}return false;});reassignFragmentLevelIndexes(levels);this._levels=levels;if(this.currentLevelIndex>-1&&(_this$currentLevel=this.currentLevel)!=null&&_this$currentLevel.details){this.currentLevelIndex=this.currentLevel.details.fragments[0].level;}this.hls.trigger(Events.LEVELS_UPDATED,{levels:levels});}},{key:"onLevelsUpdated",value:function onLevelsUpdated(event,_ref36){var levels=_ref36.levels;this._levels=levels;}},{key:"checkMaxAutoUpdated",value:function checkMaxAutoUpdated(){var _this$hls5=this.hls,autoLevelCapping=_this$hls5.autoLevelCapping,maxAutoLevel=_this$hls5.maxAutoLevel,maxHdcpLevel=_this$hls5.maxHdcpLevel;if(this._maxAutoLevel!==maxAutoLevel){this._maxAutoLevel=maxAutoLevel;this.hls.trigger(Events.MAX_AUTO_LEVEL_UPDATED,{autoLevelCapping:autoLevelCapping,levels:this.levels,maxAutoLevel:maxAutoLevel,minAutoLevel:this.hls.minAutoLevel,maxHdcpLevel:maxHdcpLevel});}}}]);return LevelController;}(BasePlaylistController);function assignTrackIdsByGroup(tracks){var groups={};tracks.forEach(function(track){var groupId=track.groupId||'';track.id=groups[groupId]=groups[groupId]||0;groups[groupId]++;});}var KeyLoader=/*#__PURE__*/function(){function KeyLoader(config){_classCallCheck(this,KeyLoader);this.config=void 0;this.keyUriToKeyInfo={};this.emeController=null;this.config=config;}_createClass(KeyLoader,[{key:"abort",value:function abort(type){for(var uri in this.keyUriToKeyInfo){var loader=this.keyUriToKeyInfo[uri].loader;if(loader){var _loader$context;if(type&&type!==((_loader$context=loader.context)==null?void 0:_loader$context.frag.type)){return;}loader.abort();}}}},{key:"detach",value:function detach(){for(var uri in this.keyUriToKeyInfo){var keyInfo=this.keyUriToKeyInfo[uri];// Remove cached EME keys on detach
if(keyInfo.mediaKeySessionContext||keyInfo.decryptdata.isCommonEncryption){delete this.keyUriToKeyInfo[uri];}}}},{key:"destroy",value:function destroy(){this.detach();for(var uri in this.keyUriToKeyInfo){var loader=this.keyUriToKeyInfo[uri].loader;if(loader){loader.destroy();}}this.keyUriToKeyInfo={};}},{key:"createKeyLoadError",value:function createKeyLoadError(frag){var details=arguments.length>1&&arguments[1]!==undefined?arguments[1]:ErrorDetails.KEY_LOAD_ERROR;var error=arguments.length>2?arguments[2]:undefined;var networkDetails=arguments.length>3?arguments[3]:undefined;var response=arguments.length>4?arguments[4]:undefined;return new LoadError({type:ErrorTypes.NETWORK_ERROR,details:details,fatal:false,frag:frag,response:response,error:error,networkDetails:networkDetails});}},{key:"loadClear",value:function loadClear(loadingFrag,encryptedFragments){var _this93=this;if(this.emeController&&this.config.emeEnabled){// access key-system with nearest key on start (loaidng frag is unencrypted)
var sn=loadingFrag.sn,cc=loadingFrag.cc;var _loop9=function _loop9(){var frag=encryptedFragments[i];if(cc<=frag.cc&&(sn==='initSegment'||frag.sn==='initSegment'||sn<frag.sn)){_this93.emeController.selectKeySystemFormat(frag).then(function(keySystemFormat){frag.setKeyFormat(keySystemFormat);});return 1;// break
}};for(var i=0;i<encryptedFragments.length;i++){if(_loop9())break;}}}},{key:"load",value:function load(frag){var _this94=this;if(!frag.decryptdata&&frag.encrypted&&this.emeController){// Multiple keys, but none selected, resolve in eme-controller
return this.emeController.selectKeySystemFormat(frag).then(function(keySystemFormat){return _this94.loadInternal(frag,keySystemFormat);});}return this.loadInternal(frag);}},{key:"loadInternal",value:function loadInternal(frag,keySystemFormat){var _keyInfo,_keyInfo2;if(keySystemFormat){frag.setKeyFormat(keySystemFormat);}var decryptdata=frag.decryptdata;if(!decryptdata){var error=new Error(keySystemFormat?"Expected frag.decryptdata to be defined after setting format ".concat(keySystemFormat):'Missing decryption data on fragment in onKeyLoading');return Promise.reject(this.createKeyLoadError(frag,ErrorDetails.KEY_LOAD_ERROR,error));}var uri=decryptdata.uri;if(!uri){return Promise.reject(this.createKeyLoadError(frag,ErrorDetails.KEY_LOAD_ERROR,new Error("Invalid key URI: \"".concat(uri,"\""))));}var keyInfo=this.keyUriToKeyInfo[uri];if((_keyInfo=keyInfo)!=null&&_keyInfo.decryptdata.key){decryptdata.key=keyInfo.decryptdata.key;return Promise.resolve({frag:frag,keyInfo:keyInfo});}// Return key load promise as long as it does not have a mediakey session with an unusable key status
if((_keyInfo2=keyInfo)!=null&&_keyInfo2.keyLoadPromise){var _keyInfo$mediaKeySess;switch((_keyInfo$mediaKeySess=keyInfo.mediaKeySessionContext)==null?void 0:_keyInfo$mediaKeySess.keyStatus){case undefined:case'status-pending':case'usable':case'usable-in-future':return keyInfo.keyLoadPromise.then(function(keyLoadedData){// Return the correct fragment with updated decryptdata key and loaded keyInfo
decryptdata.key=keyLoadedData.keyInfo.decryptdata.key;return {frag:frag,keyInfo:keyInfo};});}// If we have a key session and status and it is not pending or usable, continue
// This will go back to the eme-controller for expired keys to get a new keyLoadPromise
}// Load the key or return the loading promise
keyInfo=this.keyUriToKeyInfo[uri]={decryptdata:decryptdata,keyLoadPromise:null,loader:null,mediaKeySessionContext:null};switch(decryptdata.method){case'ISO-23001-7':case'SAMPLE-AES':case'SAMPLE-AES-CENC':case'SAMPLE-AES-CTR':if(decryptdata.keyFormat==='identity'){// loadKeyHTTP handles http(s) and data URLs
return this.loadKeyHTTP(keyInfo,frag);}return this.loadKeyEME(keyInfo,frag);case'AES-128':return this.loadKeyHTTP(keyInfo,frag);default:return Promise.reject(this.createKeyLoadError(frag,ErrorDetails.KEY_LOAD_ERROR,new Error("Key supplied with unsupported METHOD: \"".concat(decryptdata.method,"\""))));}}},{key:"loadKeyEME",value:function loadKeyEME(keyInfo,frag){var keyLoadedData={frag:frag,keyInfo:keyInfo};if(this.emeController&&this.config.emeEnabled){var keySessionContextPromise=this.emeController.loadKey(keyLoadedData);if(keySessionContextPromise){return (keyInfo.keyLoadPromise=keySessionContextPromise.then(function(keySessionContext){keyInfo.mediaKeySessionContext=keySessionContext;return keyLoadedData;}))["catch"](function(error){// Remove promise for license renewal or retry
keyInfo.keyLoadPromise=null;throw error;});}}return Promise.resolve(keyLoadedData);}},{key:"loadKeyHTTP",value:function loadKeyHTTP(keyInfo,frag){var _this95=this;var config=this.config;var Loader=config.loader;var keyLoader=new Loader(config);frag.keyLoader=keyInfo.loader=keyLoader;return keyInfo.keyLoadPromise=new Promise(function(resolve,reject){var loaderContext={keyInfo:keyInfo,frag:frag,responseType:'arraybuffer',url:keyInfo.decryptdata.uri};// maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
// key-loader will trigger an error and rely on stream-controller to handle retry logic.
// this will also align retry logic with fragment-loader
var loadPolicy=config.keyLoadPolicy["default"];var loaderConfig={loadPolicy:loadPolicy,timeout:loadPolicy.maxLoadTimeMs,maxRetry:0,retryDelay:0,maxRetryDelay:0};var loaderCallbacks={onSuccess:function onSuccess(response,stats,context,networkDetails){var frag=context.frag,keyInfo=context.keyInfo,uri=context.url;if(!frag.decryptdata||keyInfo!==_this95.keyUriToKeyInfo[uri]){return reject(_this95.createKeyLoadError(frag,ErrorDetails.KEY_LOAD_ERROR,new Error('after key load, decryptdata unset or changed'),networkDetails));}keyInfo.decryptdata.key=frag.decryptdata.key=new Uint8Array(response.data);// detach fragment key loader on load success
frag.keyLoader=null;keyInfo.loader=null;resolve({frag:frag,keyInfo:keyInfo});},onError:function onError(response,context,networkDetails,stats){_this95.resetLoader(context);reject(_this95.createKeyLoadError(frag,ErrorDetails.KEY_LOAD_ERROR,new Error("HTTP Error ".concat(response.code," loading key ").concat(response.text)),networkDetails,_objectSpread2$2({url:loaderContext.url,data:undefined},response)));},onTimeout:function onTimeout(stats,context,networkDetails){_this95.resetLoader(context);reject(_this95.createKeyLoadError(frag,ErrorDetails.KEY_LOAD_TIMEOUT,new Error('key loading timed out'),networkDetails));},onAbort:function onAbort(stats,context,networkDetails){_this95.resetLoader(context);reject(_this95.createKeyLoadError(frag,ErrorDetails.INTERNAL_ABORTED,new Error('key loading aborted'),networkDetails));}};keyLoader.load(loaderContext,loaderConfig,loaderCallbacks);});}},{key:"resetLoader",value:function resetLoader(context){var frag=context.frag,keyInfo=context.keyInfo,uri=context.url;var loader=keyInfo.loader;if(frag.keyLoader===loader){frag.keyLoader=null;keyInfo.loader=null;}delete this.keyUriToKeyInfo[uri];if(loader){loader.destroy();}}}]);return KeyLoader;}();function getSourceBuffer(){return self.SourceBuffer||self.WebKitSourceBuffer;}function _isMSESupported(){var mediaSource=_getMediaSource();if(!mediaSource){return false;}// if SourceBuffer is exposed ensure its API is valid
// Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
var sourceBuffer=getSourceBuffer();return !sourceBuffer||sourceBuffer.prototype&&typeof sourceBuffer.prototype.appendBuffer==='function'&&typeof sourceBuffer.prototype.remove==='function';}function _isSupported(){if(!_isMSESupported()){return false;}var mediaSource=_getMediaSource();return typeof(mediaSource==null?void 0:mediaSource.isTypeSupported)==='function'&&(['avc1.42E01E,mp4a.40.2','av01.0.01M.08','vp09.00.50.08'].some(function(codecsForVideoContainer){return mediaSource.isTypeSupported(mimeTypeForCodec(codecsForVideoContainer,'video'));})||['mp4a.40.2','fLaC'].some(function(codecForAudioContainer){return mediaSource.isTypeSupported(mimeTypeForCodec(codecForAudioContainer,'audio'));}));}function changeTypeSupported(){var _sourceBuffer$prototy;var sourceBuffer=getSourceBuffer();return typeof(sourceBuffer==null?void 0:(_sourceBuffer$prototy=sourceBuffer.prototype)==null?void 0:_sourceBuffer$prototy.changeType)==='function';}var STALL_MINIMUM_DURATION_MS=250;var MAX_START_GAP_JUMP=2.0;var SKIP_BUFFER_HOLE_STEP_SECONDS=0.1;var SKIP_BUFFER_RANGE_START=0.05;var GapController=/*#__PURE__*/function(){function GapController(config,media,fragmentTracker,hls){_classCallCheck(this,GapController);this.config=void 0;this.media=null;this.fragmentTracker=void 0;this.hls=void 0;this.nudgeRetry=0;this.stallReported=false;this.stalled=null;this.moved=false;this.seeking=false;this.config=config;this.media=media;this.fragmentTracker=fragmentTracker;this.hls=hls;}_createClass(GapController,[{key:"destroy",value:function destroy(){this.media=null;// @ts-ignore
this.hls=this.fragmentTracker=null;}/**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */},{key:"poll",value:function poll(lastCurrentTime,activeFrag){var config=this.config,media=this.media,stalled=this.stalled;if(media===null){return;}var currentTime=media.currentTime,seeking=media.seeking;var seeked=this.seeking&&!seeking;var beginSeek=!this.seeking&&seeking;this.seeking=seeking;// The playhead is moving, no-op
if(currentTime!==lastCurrentTime){this.moved=true;if(!seeking){this.nudgeRetry=0;}if(stalled!==null){// The playhead is now moving, but was previously stalled
if(this.stallReported){var _stalledDuration=self.performance.now()-stalled;logger.warn("playback not stuck anymore @".concat(currentTime,", after ").concat(Math.round(_stalledDuration),"ms"));this.stallReported=false;}this.stalled=null;}return;}// Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
if(beginSeek||seeked){this.stalled=null;return;}// The playhead should not be moving
if(media.paused&&!seeking||media.ended||media.playbackRate===0||!BufferHelper.getBuffered(media).length){this.nudgeRetry=0;return;}var bufferInfo=BufferHelper.bufferInfo(media,currentTime,0);var nextStart=bufferInfo.nextStart||0;if(seeking){// Waiting for seeking in a buffered range to complete
var hasEnoughBuffer=bufferInfo.len>MAX_START_GAP_JUMP;// Next buffered range is too far ahead to jump to while still seeking
var noBufferGap=!nextStart||activeFrag&&activeFrag.start<=currentTime||nextStart-currentTime>MAX_START_GAP_JUMP&&!this.fragmentTracker.getPartialFragment(currentTime);if(hasEnoughBuffer||noBufferGap){return;}// Reset moved state when seeking to a point in or before a gap
this.moved=false;}// Skip start gaps if we haven't played, but the last poll detected the start of a stall
// The addition poll gives the browser a chance to jump the gap for us
if(!this.moved&&this.stalled!==null){var _level$details;// There is no playable buffer (seeked, waiting for buffer)
var isBuffered=bufferInfo.len>0;if(!isBuffered&&!nextStart){return;}// Jump start gaps within jump threshold
var startJump=Math.max(nextStart,bufferInfo.start||0)-currentTime;// When joining a live stream with audio tracks, account for live playlist window sliding by allowing
// a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
// that begins over 1 target duration after the video start position.
var level=this.hls.levels?this.hls.levels[this.hls.currentLevel]:null;var isLive=level==null?void 0:(_level$details=level.details)==null?void 0:_level$details.live;var maxStartGapJump=isLive?level.details.targetduration*2:MAX_START_GAP_JUMP;var partialOrGap=this.fragmentTracker.getPartialFragment(currentTime);if(startJump>0&&(startJump<=maxStartGapJump||partialOrGap)){if(!media.paused){this._trySkipBufferHole(partialOrGap);}return;}}// Start tracking stall time
var tnow=self.performance.now();if(stalled===null){this.stalled=tnow;return;}var stalledDuration=tnow-stalled;if(!seeking&&stalledDuration>=STALL_MINIMUM_DURATION_MS){// Report stalling after trying to fix
this._reportStall(bufferInfo);if(!this.media){return;}}var bufferedWithHoles=BufferHelper.bufferInfo(media,currentTime,config.maxBufferHole);this._tryFixBufferStall(bufferedWithHoles,stalledDuration);}/**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */},{key:"_tryFixBufferStall",value:function _tryFixBufferStall(bufferInfo,stalledDurationMs){var config=this.config,fragmentTracker=this.fragmentTracker,media=this.media;if(media===null){return;}var currentTime=media.currentTime;var partial=fragmentTracker.getPartialFragment(currentTime);if(partial){// Try to skip over the buffer hole caused by a partial fragment
// This method isn't limited by the size of the gap between buffered ranges
var targetTime=this._trySkipBufferHole(partial);// we return here in this case, meaning
// the branch below only executes when we haven't seeked to a new position
if(targetTime||!this.media){return;}}// if we haven't had to skip over a buffer hole of a partial fragment
// we may just have to "nudge" the playlist as the browser decoding/rendering engine
// needs to cross some sort of threshold covering all source-buffers content
// to start playing properly.
if((bufferInfo.len>config.maxBufferHole||bufferInfo.nextStart&&bufferInfo.nextStart-currentTime<config.maxBufferHole)&&stalledDurationMs>config.highBufferWatchdogPeriod*1000){logger.warn('Trying to nudge playhead over buffer-hole');// Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
// We only try to jump the hole if it's under the configured size
// Reset stalled so to rearm watchdog timer
this.stalled=null;this._tryNudgeBuffer();}}/**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */},{key:"_reportStall",value:function _reportStall(bufferInfo){var hls=this.hls,media=this.media,stallReported=this.stallReported;if(!stallReported&&media){// Report stalled error once
this.stallReported=true;var error=new Error("Playback stalling at @".concat(media.currentTime," due to low buffer (").concat(JSON.stringify(bufferInfo),")"));logger.warn(error.message);hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.BUFFER_STALLED_ERROR,fatal:false,error:error,buffer:bufferInfo.len});}}/**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */},{key:"_trySkipBufferHole",value:function _trySkipBufferHole(partial){var config=this.config,hls=this.hls,media=this.media;if(media===null){return 0;}// Check if currentTime is between unbuffered regions of partial fragments
var currentTime=media.currentTime;var bufferInfo=BufferHelper.bufferInfo(media,currentTime,0);var startTime=currentTime<bufferInfo.start?bufferInfo.start:bufferInfo.nextStart;if(startTime){var bufferStarved=bufferInfo.len<=config.maxBufferHole;var waiting=bufferInfo.len>0&&bufferInfo.len<1&&media.readyState<3;var gapLength=startTime-currentTime;if(gapLength>0&&(bufferStarved||waiting)){// Only allow large gaps to be skipped if it is a start gap, or all fragments in skip range are partial
if(gapLength>config.maxBufferHole){var fragmentTracker=this.fragmentTracker;var startGap=false;if(currentTime===0){var startFrag=fragmentTracker.getAppendedFrag(0,PlaylistLevelType.MAIN);if(startFrag&&startTime<startFrag.end){startGap=true;}}if(!startGap){var startProvisioned=partial||fragmentTracker.getAppendedFrag(currentTime,PlaylistLevelType.MAIN);if(startProvisioned){var moreToLoad=false;var pos=startProvisioned.end;while(pos<startTime){var provisioned=fragmentTracker.getPartialFragment(pos);if(provisioned){pos+=provisioned.duration;}else {moreToLoad=true;break;}}if(moreToLoad){return 0;}}}}var targetTime=Math.max(startTime+SKIP_BUFFER_RANGE_START,currentTime+SKIP_BUFFER_HOLE_STEP_SECONDS);logger.warn("skipping hole, adjusting currentTime from ".concat(currentTime," to ").concat(targetTime));this.moved=true;this.stalled=null;media.currentTime=targetTime;if(partial&&!partial.gap){var error=new Error("fragment loaded with buffer holes, seeking from ".concat(currentTime," to ").concat(targetTime));hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.BUFFER_SEEK_OVER_HOLE,fatal:false,error:error,reason:error.message,frag:partial});}return targetTime;}}return 0;}/**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */},{key:"_tryNudgeBuffer",value:function _tryNudgeBuffer(){var config=this.config,hls=this.hls,media=this.media,nudgeRetry=this.nudgeRetry;if(media===null){return;}var currentTime=media.currentTime;this.nudgeRetry++;if(nudgeRetry<config.nudgeMaxRetry){var targetTime=currentTime+(nudgeRetry+1)*config.nudgeOffset;// playback stalled in buffered area ... let's nudge currentTime to try to overcome this
var error=new Error("Nudging 'currentTime' from ".concat(currentTime," to ").concat(targetTime));logger.warn(error.message);media.currentTime=targetTime;hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.BUFFER_NUDGE_ON_STALL,error:error,fatal:false});}else {var _error2=new Error("Playhead still not moving while enough data buffered @".concat(currentTime," after ").concat(config.nudgeMaxRetry," nudges"));logger.error(_error2.message);hls.trigger(Events.ERROR,{type:ErrorTypes.MEDIA_ERROR,details:ErrorDetails.BUFFER_STALLED_ERROR,error:_error2,fatal:true});}}}]);return GapController;}();var TICK_INTERVAL=100;// how often to tick in ms
var StreamController=/*#__PURE__*/function(_BaseStreamController3){_inherits(StreamController,_BaseStreamController3);var _super16=_createSuper(StreamController);function StreamController(hls,fragmentTracker,keyLoader){var _this96;_classCallCheck(this,StreamController);_this96=_super16.call(this,hls,fragmentTracker,keyLoader,'[stream-controller]',PlaylistLevelType.MAIN);_this96.audioCodecSwap=false;_this96.gapController=null;_this96.level=-1;_this96._forceStartLoad=false;_this96.altAudio=false;_this96.audioOnly=false;_this96.fragPlaying=null;_this96.onvplaying=null;_this96.onvseeked=null;_this96.fragLastKbps=0;_this96.couldBacktrack=false;_this96.backtrackFragment=null;_this96.audioCodecSwitch=false;_this96.videoBuffer=null;_this96._registerListeners();return _this96;}_createClass(StreamController,[{key:"_registerListeners",value:function _registerListeners(){var hls=this.hls;hls.on(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.on(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.on(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.on(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.on(Events.LEVEL_LOADING,this.onLevelLoading,this);hls.on(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.on(Events.FRAG_LOAD_EMERGENCY_ABORTED,this.onFragLoadEmergencyAborted,this);hls.on(Events.ERROR,this.onError,this);hls.on(Events.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this);hls.on(Events.AUDIO_TRACK_SWITCHED,this.onAudioTrackSwitched,this);hls.on(Events.BUFFER_CREATED,this.onBufferCreated,this);hls.on(Events.BUFFER_FLUSHED,this.onBufferFlushed,this);hls.on(Events.LEVELS_UPDATED,this.onLevelsUpdated,this);hls.on(Events.FRAG_BUFFERED,this.onFragBuffered,this);}},{key:"_unregisterListeners",value:function _unregisterListeners(){var hls=this.hls;hls.off(Events.MEDIA_ATTACHED,this.onMediaAttached,this);hls.off(Events.MEDIA_DETACHING,this.onMediaDetaching,this);hls.off(Events.MANIFEST_LOADING,this.onManifestLoading,this);hls.off(Events.MANIFEST_PARSED,this.onManifestParsed,this);hls.off(Events.LEVEL_LOADED,this.onLevelLoaded,this);hls.off(Events.FRAG_LOAD_EMERGENCY_ABORTED,this.onFragLoadEmergencyAborted,this);hls.off(Events.ERROR,this.onError,this);hls.off(Events.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this);hls.off(Events.AUDIO_TRACK_SWITCHED,this.onAudioTrackSwitched,this);hls.off(Events.BUFFER_CREATED,this.onBufferCreated,this);hls.off(Events.BUFFER_FLUSHED,this.onBufferFlushed,this);hls.off(Events.LEVELS_UPDATED,this.onLevelsUpdated,this);hls.off(Events.FRAG_BUFFERED,this.onFragBuffered,this);}},{key:"onHandlerDestroying",value:function onHandlerDestroying(){this._unregisterListeners();_get(_getPrototypeOf(StreamController.prototype),"onHandlerDestroying",this).call(this);}},{key:"startLoad",value:function startLoad(startPosition){if(this.levels){var lastCurrentTime=this.lastCurrentTime,hls=this.hls;this.stopLoad();this.setInterval(TICK_INTERVAL);this.level=-1;if(!this.startFragRequested){// determine load level
var startLevel=hls.startLevel;if(startLevel===-1){if(hls.config.testBandwidth&&this.levels.length>1){// -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
startLevel=0;this.bitrateTest=true;}else {startLevel=hls.firstAutoLevel;}}// set new level to playlist loader : this will trigger start level load
// hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
hls.nextLoadLevel=startLevel;this.level=hls.loadLevel;this.loadedmetadata=false;}// if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
if(lastCurrentTime>0&&startPosition===-1){this.log("Override startPosition with lastCurrentTime @".concat(lastCurrentTime.toFixed(3)));startPosition=lastCurrentTime;}this.state=State.IDLE;this.nextLoadPosition=this.startPosition=this.lastCurrentTime=startPosition;this.tick();}else {this._forceStartLoad=true;this.state=State.STOPPED;}}},{key:"stopLoad",value:function stopLoad(){this._forceStartLoad=false;_get(_getPrototypeOf(StreamController.prototype),"stopLoad",this).call(this);}},{key:"doTick",value:function doTick(){switch(this.state){case State.WAITING_LEVEL:{var levels=this.levels,level=this.level;var currentLevel=levels==null?void 0:levels[level];var details=currentLevel==null?void 0:currentLevel.details;if(details&&(!details.live||this.levelLastLoaded===currentLevel)){if(this.waitForCdnTuneIn(details)){break;}this.state=State.IDLE;break;}else if(this.hls.nextLoadLevel!==this.level){this.state=State.IDLE;break;}break;}case State.FRAG_LOADING_WAITING_RETRY:{var _this$media;var _now3=self.performance.now();var retryDate=this.retryDate;// if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
if(!retryDate||_now3>=retryDate||(_this$media=this.media)!=null&&_this$media.seeking){var _levels2=this.levels,_level5=this.level;var _currentLevel=_levels2==null?void 0:_levels2[_level5];this.resetStartWhenNotLoaded(_currentLevel||null);this.state=State.IDLE;}}break;}if(this.state===State.IDLE){this.doTickIdle();}this.onTickEnd();}},{key:"onTickEnd",value:function onTickEnd(){_get(_getPrototypeOf(StreamController.prototype),"onTickEnd",this).call(this);this.checkBuffer();this.checkFragmentChanged();}},{key:"doTickIdle",value:function doTickIdle(){var hls=this.hls,levelLastLoaded=this.levelLastLoaded,levels=this.levels,media=this.media;// if start level not parsed yet OR
// if video not attached AND start fragment already requested OR start frag prefetch not enabled
// exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
if(levelLastLoaded===null||!media&&(this.startFragRequested||!hls.config.startFragPrefetch)){return;}// If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
if(this.altAudio&&this.audioOnly){return;}var level=this.buffering?hls.nextLoadLevel:hls.loadLevel;if(!(levels!=null&&levels[level])){return;}var levelInfo=levels[level];// if buffer length is less than maxBufLen try to load a new fragment
var bufferInfo=this.getMainFwdBufferInfo();if(bufferInfo===null){return;}var lastDetails=this.getLevelDetails();if(lastDetails&&this._streamEnded(bufferInfo,lastDetails)){var data={};if(this.altAudio){data.type='video';}this.hls.trigger(Events.BUFFER_EOS,data);this.state=State.ENDED;return;}if(!this.buffering){return;}// set next load level : this will trigger a playlist load if needed
if(hls.loadLevel!==level&&hls.manualLevel===-1){this.log("Adapting to level ".concat(level," from level ").concat(this.level));}this.level=hls.nextLoadLevel=level;var levelDetails=levelInfo.details;// if level info not retrieved yet, switch state and wait for level retrieval
// if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
// a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
if(!levelDetails||this.state===State.WAITING_LEVEL||levelDetails.live&&this.levelLastLoaded!==levelInfo){this.level=level;this.state=State.WAITING_LEVEL;return;}var bufferLen=bufferInfo.len;// compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
var maxBufLen=this.getMaxBufferLength(levelInfo.maxBitrate);// Stay idle if we are still with buffer margins
if(bufferLen>=maxBufLen){return;}if(this.backtrackFragment&&this.backtrackFragment.start>bufferInfo.end){this.backtrackFragment=null;}var targetBufferTime=this.backtrackFragment?this.backtrackFragment.start:bufferInfo.end;var frag=this.getNextFragment(targetBufferTime,levelDetails);// Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
if(this.couldBacktrack&&!this.fragPrevious&&frag&&frag.sn!=='initSegment'&&this.fragmentTracker.getState(frag)!==FragmentState.OK){var _this$backtrackFragme;var backtrackSn=((_this$backtrackFragme=this.backtrackFragment)!=null?_this$backtrackFragme:frag).sn;var fragIdx=backtrackSn-levelDetails.startSN;var backtrackFrag=levelDetails.fragments[fragIdx-1];if(backtrackFrag&&frag.cc===backtrackFrag.cc){frag=backtrackFrag;this.fragmentTracker.removeFragment(backtrackFrag);}}else if(this.backtrackFragment&&bufferInfo.len){this.backtrackFragment=null;}// Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
if(frag&&this.isLoopLoading(frag,targetBufferTime)){var gapStart=frag.gap;if(!gapStart){// Cleanup the fragment tracker before trying to find the next unbuffered fragment
var type=this.audioOnly&&!this.altAudio?ElementaryStreamTypes.AUDIO:ElementaryStreamTypes.VIDEO;var mediaBuffer=(type===ElementaryStreamTypes.VIDEO?this.videoBuffer:this.mediaBuffer)||this.media;if(mediaBuffer){this.afterBufferFlushed(mediaBuffer,type,PlaylistLevelType.MAIN);}}frag=this.getNextFragmentLoopLoading(frag,levelDetails,bufferInfo,PlaylistLevelType.MAIN,maxBufLen);}if(!frag){return;}if(frag.initSegment&&!frag.initSegment.data&&!this.bitrateTest){frag=frag.initSegment;}this.loadFragment(frag,levelInfo,targetBufferTime);}},{key:"loadFragment",value:function loadFragment(frag,level,targetBufferTime){// Check if fragment is not loaded
var fragState=this.fragmentTracker.getState(frag);this.fragCurrent=frag;if(fragState===FragmentState.NOT_LOADED||fragState===FragmentState.PARTIAL){if(frag.sn==='initSegment'){this._loadInitSegment(frag,level);}else if(this.bitrateTest){this.log("Fragment ".concat(frag.sn," of level ").concat(frag.level," is being downloaded to test bitrate and will not be buffered"));this._loadBitrateTestFrag(frag,level);}else {this.startFragRequested=true;_get(_getPrototypeOf(StreamController.prototype),"loadFragment",this).call(this,frag,level,targetBufferTime);}}else {this.clearTrackerIfNeeded(frag);}}},{key:"getBufferedFrag",value:function getBufferedFrag(position){return this.fragmentTracker.getBufferedFrag(position,PlaylistLevelType.MAIN);}},{key:"followingBufferedFrag",value:function followingBufferedFrag(frag){if(frag){// try to get range of next fragment (500ms after this range)
return this.getBufferedFrag(frag.end+0.5);}return null;}/*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */},{key:"immediateLevelSwitch",value:function immediateLevelSwitch(){this.abortCurrentFrag();this.flushMainBuffer(0,Number.POSITIVE_INFINITY);}/**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */},{key:"nextLevelSwitch",value:function nextLevelSwitch(){var levels=this.levels,media=this.media;// ensure that media is defined and that metadata are available (to retrieve currentTime)
if(media!=null&&media.readyState){var fetchdelay;var fragPlayingCurrent=this.getAppendedFrag(media.currentTime);if(fragPlayingCurrent&&fragPlayingCurrent.start>1){// flush buffer preceding current fragment (flush until current fragment start offset)
// minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
this.flushMainBuffer(0,fragPlayingCurrent.start-1);}var levelDetails=this.getLevelDetails();if(levelDetails!=null&&levelDetails.live){var bufferInfo=this.getMainFwdBufferInfo();// Do not flush in live stream with low buffer
if(!bufferInfo||bufferInfo.len<levelDetails.targetduration*2){return;}}if(!media.paused&&levels){// add a safety delay of 1s
var nextLevelId=this.hls.nextLoadLevel;var nextLevel=levels[nextLevelId];var fragLastKbps=this.fragLastKbps;if(fragLastKbps&&this.fragCurrent){fetchdelay=this.fragCurrent.duration*nextLevel.maxBitrate/(1000*fragLastKbps)+1;}else {fetchdelay=0;}}else {fetchdelay=0;}// this.log('fetchdelay:'+fetchdelay);
// find buffer range that will be reached once new fragment will be fetched
var bufferedFrag=this.getBufferedFrag(media.currentTime+fetchdelay);if(bufferedFrag){// we can flush buffer range following this one without stalling playback
var nextBufferedFrag=this.followingBufferedFrag(bufferedFrag);if(nextBufferedFrag){// if we are here, we can also cancel any loading/demuxing in progress, as they are useless
this.abortCurrentFrag();// start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
var maxStart=nextBufferedFrag.maxStartPTS?nextBufferedFrag.maxStartPTS:nextBufferedFrag.start;var fragDuration=nextBufferedFrag.duration;var startPts=Math.max(bufferedFrag.end,maxStart+Math.min(Math.max(fragDuration-this.config.maxFragLookUpTolerance,fragDuration*(this.couldBacktrack?0.5:0.125)),fragDuration*(this.couldBacktrack?0.75:0.25)));this.flushMainBuffer(startPts,Number.POSITIVE_INFINITY);}}}}},{key:"abortCurrentFrag",value:function abortCurrentFrag(){var fragCurrent=this.fragCurrent;this.fragCurrent=null;this.backtrackFragment=null;if(fragCurrent){fragCurrent.abortRequests();this.fragmentTracker.removeFragment(fragCurrent);}switch(this.state){case State.KEY_LOADING:case State.FRAG_LOADING:case State.FRAG_LOADING_WAITING_RETRY:case State.PARSING:case State.PARSED:this.state=State.IDLE;break;}this.nextLoadPosition=this.getLoadPosition();}},{key:"flushMainBuffer",value:function flushMainBuffer(startOffset,endOffset){_get(_getPrototypeOf(StreamController.prototype),"flushMainBuffer",this).call(this,startOffset,endOffset,this.altAudio?'video':null);}},{key:"onMediaAttached",value:function onMediaAttached(event,data){_get(_getPrototypeOf(StreamController.prototype),"onMediaAttached",this).call(this,event,data);var media=data.media;this.onvplaying=this.onMediaPlaying.bind(this);this.onvseeked=this.onMediaSeeked.bind(this);media.addEventListener('playing',this.onvplaying);media.addEventListener('seeked',this.onvseeked);this.gapController=new GapController(this.config,media,this.fragmentTracker,this.hls);}},{key:"onMediaDetaching",value:function onMediaDetaching(){var media=this.media;if(media&&this.onvplaying&&this.onvseeked){media.removeEventListener('playing',this.onvplaying);media.removeEventListener('seeked',this.onvseeked);this.onvplaying=this.onvseeked=null;this.videoBuffer=null;}this.fragPlaying=null;if(this.gapController){this.gapController.destroy();this.gapController=null;}_get(_getPrototypeOf(StreamController.prototype),"onMediaDetaching",this).call(this);}},{key:"onMediaPlaying",value:function onMediaPlaying(){// tick to speed up FRAG_CHANGED triggering
this.tick();}},{key:"onMediaSeeked",value:function onMediaSeeked(){var media=this.media;var currentTime=media?media.currentTime:null;if(isFiniteNumber(currentTime)){this.log("Media seeked to ".concat(currentTime.toFixed(3)));}// If seeked was issued before buffer was appended do not tick immediately
var bufferInfo=this.getMainFwdBufferInfo();if(bufferInfo===null||bufferInfo.len===0){this.warn("Main forward buffer length on \"seeked\" event ".concat(bufferInfo?bufferInfo.len:'empty',")"));return;}// tick to speed up FRAG_CHANGED triggering
this.tick();}},{key:"onManifestLoading",value:function onManifestLoading(){// reset buffer on manifest loading
this.log('Trigger BUFFER_RESET');this.hls.trigger(Events.BUFFER_RESET,undefined);this.fragmentTracker.removeAllFragments();this.couldBacktrack=false;this.startPosition=this.lastCurrentTime=this.fragLastKbps=0;this.levels=this.fragPlaying=this.backtrackFragment=this.levelLastLoaded=null;this.altAudio=this.audioOnly=this.startFragRequested=false;}},{key:"onManifestParsed",value:function onManifestParsed(event,data){// detect if we have different kind of audio codecs used amongst playlists
var aac=false;var heaac=false;data.levels.forEach(function(level){var codec=level.audioCodec;if(codec){aac=aac||codec.indexOf('mp4a.40.2')!==-1;heaac=heaac||codec.indexOf('mp4a.40.5')!==-1;}});this.audioCodecSwitch=aac&&heaac&&!changeTypeSupported();if(this.audioCodecSwitch){this.log('Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');}this.levels=data.levels;this.startFragRequested=false;}},{key:"onLevelLoading",value:function onLevelLoading(event,data){var levels=this.levels;if(!levels||this.state!==State.IDLE){return;}var level=levels[data.level];if(!level.details||level.details.live&&this.levelLastLoaded!==level||this.waitForCdnTuneIn(level.details)){this.state=State.WAITING_LEVEL;}}},{key:"onLevelLoaded",value:function onLevelLoaded(event,data){var _curLevel$details;var levels=this.levels;var newLevelId=data.level;var newDetails=data.details;var duration=newDetails.totalduration;if(!levels){this.warn("Levels were reset while loading level ".concat(newLevelId));return;}this.log("Level ".concat(newLevelId," loaded [").concat(newDetails.startSN,",").concat(newDetails.endSN,"]").concat(newDetails.lastPartSn?"[part-".concat(newDetails.lastPartSn,"-").concat(newDetails.lastPartIndex,"]"):'',", cc [").concat(newDetails.startCC,", ").concat(newDetails.endCC,"] duration:").concat(duration));var curLevel=levels[newLevelId];var fragCurrent=this.fragCurrent;if(fragCurrent&&(this.state===State.FRAG_LOADING||this.state===State.FRAG_LOADING_WAITING_RETRY)){if(fragCurrent.level!==data.level&&fragCurrent.loader){this.abortCurrentFrag();}}var sliding=0;if(newDetails.live||(_curLevel$details=curLevel.details)!=null&&_curLevel$details.live){var _this$levelLastLoaded;this.checkLiveUpdate(newDetails);if(newDetails.deltaUpdateFailed){return;}sliding=this.alignPlaylists(newDetails,curLevel.details,(_this$levelLastLoaded=this.levelLastLoaded)==null?void 0:_this$levelLastLoaded.details);}// override level info
curLevel.details=newDetails;this.levelLastLoaded=curLevel;this.hls.trigger(Events.LEVEL_UPDATED,{details:newDetails,level:newLevelId});// only switch back to IDLE state if we were waiting for level to start downloading a new fragment
if(this.state===State.WAITING_LEVEL){if(this.waitForCdnTuneIn(newDetails)){// Wait for Low-Latency CDN Tune-in
return;}this.state=State.IDLE;}if(!this.startFragRequested){this.setStartPosition(newDetails,sliding);}else if(newDetails.live){this.synchronizeToLiveEdge(newDetails);}// trigger handler right now
this.tick();}},{key:"_handleFragmentLoadProgress",value:function _handleFragmentLoadProgress(data){var _frag$initSegment;var frag=data.frag,part=data.part,payload=data.payload;var levels=this.levels;if(!levels){this.warn("Levels were reset while fragment load was in progress. Fragment ".concat(frag.sn," of level ").concat(frag.level," will not be buffered"));return;}var currentLevel=levels[frag.level];var details=currentLevel.details;if(!details){this.warn("Dropping fragment ".concat(frag.sn," of level ").concat(frag.level," after level details were reset"));this.fragmentTracker.removeFragment(frag);return;}var videoCodec=currentLevel.videoCodec;// time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
var accurateTimeOffset=details.PTSKnown||!details.live;var initSegmentData=(_frag$initSegment=frag.initSegment)==null?void 0:_frag$initSegment.data;var audioCodec=this._getAudioCodec(currentLevel);// transmux the MPEG-TS data to ISO-BMFF segments
// this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
var transmuxer=this.transmuxer=this.transmuxer||new TransmuxerInterface(this.hls,PlaylistLevelType.MAIN,this._handleTransmuxComplete.bind(this),this._handleTransmuxerFlush.bind(this));var partIndex=part?part.index:-1;var partial=partIndex!==-1;var chunkMeta=new ChunkMetadata(frag.level,frag.sn,frag.stats.chunkCount,payload.byteLength,partIndex,partial);var initPTS=this.initPTS[frag.cc];transmuxer.push(payload,initSegmentData,audioCodec,videoCodec,frag,part,details.totalduration,accurateTimeOffset,chunkMeta,initPTS);}},{key:"onAudioTrackSwitching",value:function onAudioTrackSwitching(event,data){// if any URL found on new audio track, it is an alternate audio track
var fromAltAudio=this.altAudio;var altAudio=!!data.url;// if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
// don't do anything if we switch to alt audio: audio stream controller is handling it.
// we will just have to change buffer scheduling on audioTrackSwitched
if(!altAudio){if(this.mediaBuffer!==this.media){this.log('Switching on main audio, use media.buffered to schedule main fragment loading');this.mediaBuffer=this.media;var fragCurrent=this.fragCurrent;// we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
if(fragCurrent){this.log('Switching to main audio track, cancel main fragment load');fragCurrent.abortRequests();this.fragmentTracker.removeFragment(fragCurrent);}// destroy transmuxer to force init segment generation (following audio switch)
this.resetTransmuxer();// switch to IDLE state to load new fragment
this.resetLoadingState();}else if(this.audioOnly){// Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
this.resetTransmuxer();}var hls=this.hls;// If switching from alt to main audio, flush all audio and trigger track switched
if(fromAltAudio){hls.trigger(Events.BUFFER_FLUSHING,{startOffset:0,endOffset:Number.POSITIVE_INFINITY,type:null});this.fragmentTracker.removeAllFragments();}hls.trigger(Events.AUDIO_TRACK_SWITCHED,data);}}},{key:"onAudioTrackSwitched",value:function onAudioTrackSwitched(event,data){var trackId=data.id;var altAudio=!!this.hls.audioTracks[trackId].url;if(altAudio){var videoBuffer=this.videoBuffer;// if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
if(videoBuffer&&this.mediaBuffer!==videoBuffer){this.log('Switching on alternate audio, use video.buffered to schedule main fragment loading');this.mediaBuffer=videoBuffer;}}this.altAudio=altAudio;this.tick();}},{key:"onBufferCreated",value:function onBufferCreated(event,data){var tracks=data.tracks;var mediaTrack;var name;var alternate=false;for(var type in tracks){var track=tracks[type];if(track.id==='main'){name=type;mediaTrack=track;// keep video source buffer reference
if(type==='video'){var videoTrack=tracks[type];if(videoTrack){this.videoBuffer=videoTrack.buffer;}}}else {alternate=true;}}if(alternate&&mediaTrack){this.log("Alternate track found, use ".concat(name,".buffered to schedule main fragment loading"));this.mediaBuffer=mediaTrack.buffer;}else {this.mediaBuffer=this.media;}}},{key:"onFragBuffered",value:function onFragBuffered(event,data){var frag=data.frag,part=data.part;if(frag&&frag.type!==PlaylistLevelType.MAIN){return;}if(this.fragContextChanged(frag)){// If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
// Avoid setting state back to IDLE, since that will interfere with a level switch
this.warn("Fragment ".concat(frag.sn).concat(part?' p: '+part.index:''," of level ").concat(frag.level," finished buffering, but was aborted. state: ").concat(this.state));if(this.state===State.PARSED){this.state=State.IDLE;}return;}var stats=part?part.stats:frag.stats;this.fragLastKbps=Math.round(8*stats.total/(stats.buffering.end-stats.loading.first));if(frag.sn!=='initSegment'){this.fragPrevious=frag;}this.fragBufferedComplete(frag,part);}},{key:"onError",value:function onError(event,data){var _data$context;if(data.fatal){this.state=State.ERROR;return;}switch(data.details){case ErrorDetails.FRAG_GAP:case ErrorDetails.FRAG_PARSING_ERROR:case ErrorDetails.FRAG_DECRYPT_ERROR:case ErrorDetails.FRAG_LOAD_ERROR:case ErrorDetails.FRAG_LOAD_TIMEOUT:case ErrorDetails.KEY_LOAD_ERROR:case ErrorDetails.KEY_LOAD_TIMEOUT:this.onFragmentOrKeyLoadError(PlaylistLevelType.MAIN,data);break;case ErrorDetails.LEVEL_LOAD_ERROR:case ErrorDetails.LEVEL_LOAD_TIMEOUT:case ErrorDetails.LEVEL_PARSING_ERROR:// in case of non fatal error while loading level, if level controller is not retrying to load level, switch back to IDLE
if(!data.levelRetry&&this.state===State.WAITING_LEVEL&&((_data$context=data.context)==null?void 0:_data$context.type)===PlaylistContextType.LEVEL){this.state=State.IDLE;}break;case ErrorDetails.BUFFER_APPEND_ERROR:case ErrorDetails.BUFFER_FULL_ERROR:if(!data.parent||data.parent!=='main'){return;}if(data.details===ErrorDetails.BUFFER_APPEND_ERROR){this.resetLoadingState();return;}if(this.reduceLengthAndFlushBuffer(data)){this.flushMainBuffer(0,Number.POSITIVE_INFINITY);}break;case ErrorDetails.INTERNAL_EXCEPTION:this.recoverWorkerError(data);break;}}// Checks the health of the buffer and attempts to resolve playback stalls.
},{key:"checkBuffer",value:function checkBuffer(){var media=this.media,gapController=this.gapController;if(!media||!gapController||!media.readyState){// Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
return;}if(this.loadedmetadata||!BufferHelper.getBuffered(media).length){// Resolve gaps using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
var activeFrag=this.state!==State.IDLE?this.fragCurrent:null;gapController.poll(this.lastCurrentTime,activeFrag);}this.lastCurrentTime=media.currentTime;}},{key:"onFragLoadEmergencyAborted",value:function onFragLoadEmergencyAborted(){this.state=State.IDLE;// if loadedmetadata is not set, it means that we are emergency switch down on first frag
// in that case, reset startFragRequested flag
if(!this.loadedmetadata){this.startFragRequested=false;this.nextLoadPosition=this.startPosition;}this.tickImmediate();}},{key:"onBufferFlushed",value:function onBufferFlushed(event,_ref37){var type=_ref37.type;if(type!==ElementaryStreamTypes.AUDIO||this.audioOnly&&!this.altAudio){var mediaBuffer=(type===ElementaryStreamTypes.VIDEO?this.videoBuffer:this.mediaBuffer)||this.media;this.afterBufferFlushed(mediaBuffer,type,PlaylistLevelType.MAIN);this.tick();}}},{key:"onLevelsUpdated",value:function onLevelsUpdated(event,data){if(this.level>-1&&this.fragCurrent){this.level=this.fragCurrent.level;}this.levels=data.levels;}},{key:"swapAudioCodec",value:function swapAudioCodec(){this.audioCodecSwap=!this.audioCodecSwap;}/**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */},{key:"seekToStartPos",value:function seekToStartPos(){var media=this.media;if(!media){return;}var currentTime=media.currentTime;var startPosition=this.startPosition;// only adjust currentTime if different from startPosition or if startPosition not buffered
// at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
if(startPosition>=0&&currentTime<startPosition){if(media.seeking){this.log("could not seek to ".concat(startPosition,", already seeking at ").concat(currentTime));return;}var buffered=BufferHelper.getBuffered(media);var bufferStart=buffered.length?buffered.start(0):0;var delta=bufferStart-startPosition;if(delta>0&&(delta<this.config.maxBufferHole||delta<this.config.maxFragLookUpTolerance)){this.log("adjusting start position by ".concat(delta," to match buffer start"));startPosition+=delta;this.startPosition=startPosition;}this.log("seek to target start position ".concat(startPosition," from current time ").concat(currentTime));media.currentTime=startPosition;}}},{key:"_getAudioCodec",value:function _getAudioCodec(currentLevel){var audioCodec=this.config.defaultAudioCodec||currentLevel.audioCodec;if(this.audioCodecSwap&&audioCodec){this.log('Swapping audio codec');if(audioCodec.indexOf('mp4a.40.5')!==-1){audioCodec='mp4a.40.2';}else {audioCodec='mp4a.40.5';}}return audioCodec;}},{key:"_loadBitrateTestFrag",value:function _loadBitrateTestFrag(frag,level){var _this97=this;frag.bitrateTest=true;this._doFragLoad(frag,level).then(function(data){var hls=_this97.hls;if(!data||_this97.fragContextChanged(frag)){return;}level.fragmentError=0;_this97.state=State.IDLE;_this97.startFragRequested=false;_this97.bitrateTest=false;var stats=frag.stats;// Bitrate tests fragments are neither parsed nor buffered
stats.parsing.start=stats.parsing.end=stats.buffering.start=stats.buffering.end=self.performance.now();hls.trigger(Events.FRAG_LOADED,data);frag.bitrateTest=false;});}},{key:"_handleTransmuxComplete",value:function _handleTransmuxComplete(transmuxResult){var _id3$samples;var id='main';var hls=this.hls;var remuxResult=transmuxResult.remuxResult,chunkMeta=transmuxResult.chunkMeta;var context=this.getCurrentContext(chunkMeta);if(!context){this.resetWhenMissingContext(chunkMeta);return;}var frag=context.frag,part=context.part,level=context.level;var video=remuxResult.video,text=remuxResult.text,id3=remuxResult.id3,initSegment=remuxResult.initSegment;var details=level.details;// The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
var audio=this.altAudio?undefined:remuxResult.audio;// Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
// If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
if(this.fragContextChanged(frag)){this.fragmentTracker.removeFragment(frag);return;}this.state=State.PARSING;if(initSegment){if(initSegment!=null&&initSegment.tracks){var mapFragment=frag.initSegment||frag;this._bufferInitSegment(level,initSegment.tracks,mapFragment,chunkMeta);hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT,{frag:mapFragment,id:id,tracks:initSegment.tracks});}// This would be nice if Number.isFinite acted as a typeguard, but it doesn't. See: https://github.com/Microsoft/TypeScript/issues/10038
var initPTS=initSegment.initPTS;var timescale=initSegment.timescale;if(isFiniteNumber(initPTS)){this.initPTS[frag.cc]={baseTime:initPTS,timescale:timescale};hls.trigger(Events.INIT_PTS_FOUND,{frag:frag,id:id,initPTS:initPTS,timescale:timescale});}}// Avoid buffering if backtracking this fragment
if(video&&details&&frag.sn!=='initSegment'){var prevFrag=details.fragments[frag.sn-1-details.startSN];var isFirstFragment=frag.sn===details.startSN;var isFirstInDiscontinuity=!prevFrag||frag.cc>prevFrag.cc;if(remuxResult.independent!==false){var startPTS=video.startPTS,endPTS=video.endPTS,startDTS=video.startDTS,endDTS=video.endDTS;if(part){part.elementaryStreams[video.type]={startPTS:startPTS,endPTS:endPTS,startDTS:startDTS,endDTS:endDTS};}else {if(video.firstKeyFrame&&video.independent&&chunkMeta.id===1&&!isFirstInDiscontinuity){this.couldBacktrack=true;}if(video.dropped&&video.independent){// Backtrack if dropped frames create a gap after currentTime
var bufferInfo=this.getMainFwdBufferInfo();var targetBufferTime=(bufferInfo?bufferInfo.end:this.getLoadPosition())+this.config.maxBufferHole;var startTime=video.firstKeyFramePTS?video.firstKeyFramePTS:startPTS;if(!isFirstFragment&&targetBufferTime<startTime-this.config.maxBufferHole&&!isFirstInDiscontinuity){this.backtrack(frag);return;}else if(isFirstInDiscontinuity){// Mark segment with a gap to avoid loop loading
frag.gap=true;}// Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
frag.setElementaryStreamInfo(video.type,frag.start,endPTS,frag.start,endDTS,true);}else if(isFirstFragment&&startPTS>MAX_START_GAP_JUMP){// Mark segment with a gap to skip large start gap
frag.gap=true;}}frag.setElementaryStreamInfo(video.type,startPTS,endPTS,startDTS,endDTS);if(this.backtrackFragment){this.backtrackFragment=frag;}this.bufferFragmentData(video,frag,part,chunkMeta,isFirstFragment||isFirstInDiscontinuity);}else if(isFirstFragment||isFirstInDiscontinuity){// Mark segment with a gap to avoid loop loading
frag.gap=true;}else {this.backtrack(frag);return;}}if(audio){var _startPTS2=audio.startPTS,_endPTS=audio.endPTS,_startDTS=audio.startDTS,_endDTS=audio.endDTS;if(part){part.elementaryStreams[ElementaryStreamTypes.AUDIO]={startPTS:_startPTS2,endPTS:_endPTS,startDTS:_startDTS,endDTS:_endDTS};}frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO,_startPTS2,_endPTS,_startDTS,_endDTS);this.bufferFragmentData(audio,frag,part,chunkMeta);}if(details&&id3!=null&&(_id3$samples=id3.samples)!=null&&_id3$samples.length){var emittedID3={id:id,frag:frag,details:details,samples:id3.samples};hls.trigger(Events.FRAG_PARSING_METADATA,emittedID3);}if(details&&text){var emittedText={id:id,frag:frag,details:details,samples:text.samples};hls.trigger(Events.FRAG_PARSING_USERDATA,emittedText);}}},{key:"_bufferInitSegment",value:function _bufferInitSegment(currentLevel,tracks,frag,chunkMeta){var _this98=this;if(this.state!==State.PARSING){return;}this.audioOnly=!!tracks.audio&&!tracks.video;// if audio track is expected to come from audio stream controller, discard any coming from main
if(this.altAudio&&!this.audioOnly){delete tracks.audio;}// include levelCodec in audio and video tracks
var audio=tracks.audio,video=tracks.video,audiovideo=tracks.audiovideo;if(audio){var audioCodec=currentLevel.audioCodec;var ua=navigator.userAgent.toLowerCase();if(this.audioCodecSwitch){if(audioCodec){if(audioCodec.indexOf('mp4a.40.5')!==-1){audioCodec='mp4a.40.2';}else {audioCodec='mp4a.40.5';}}// In the case that AAC and HE-AAC audio codecs are signalled in manifest,
// force HE-AAC, as it seems that most browsers prefers it.
// don't force HE-AAC if mono stream, or in Firefox
var audioMetadata=audio.metadata;if(audioMetadata&&'channelCount'in audioMetadata&&(audioMetadata.channelCount||1)!==1&&ua.indexOf('firefox')===-1){audioCodec='mp4a.40.5';}}// HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
if(audioCodec&&audioCodec.indexOf('mp4a.40.5')!==-1&&ua.indexOf('android')!==-1&&audio.container!=='audio/mpeg'){// Exclude mpeg audio
audioCodec='mp4a.40.2';this.log("Android: force audio codec to ".concat(audioCodec));}if(currentLevel.audioCodec&&currentLevel.audioCodec!==audioCodec){this.log("Swapping manifest audio codec \"".concat(currentLevel.audioCodec,"\" for \"").concat(audioCodec,"\""));}audio.levelCodec=audioCodec;audio.id='main';this.log("Init audio buffer, container:".concat(audio.container,", codecs[selected/level/parsed]=[").concat(audioCodec||'',"/").concat(currentLevel.audioCodec||'',"/").concat(audio.codec,"]"));}if(video){video.levelCodec=currentLevel.videoCodec;video.id='main';this.log("Init video buffer, container:".concat(video.container,", codecs[level/parsed]=[").concat(currentLevel.videoCodec||'',"/").concat(video.codec,"]"));}if(audiovideo){this.log("Init audiovideo buffer, container:".concat(audiovideo.container,", codecs[level/parsed]=[").concat(currentLevel.codecs,"/").concat(audiovideo.codec,"]"));}this.hls.trigger(Events.BUFFER_CODECS,tracks);// loop through tracks that are going to be provided to bufferController
Object.keys(tracks).forEach(function(trackName){var track=tracks[trackName];var initSegment=track.initSegment;if(initSegment!=null&&initSegment.byteLength){_this98.hls.trigger(Events.BUFFER_APPENDING,{type:trackName,data:initSegment,frag:frag,part:null,chunkMeta:chunkMeta,parent:frag.type});}});// trigger handler right now
this.tickImmediate();}},{key:"getMainFwdBufferInfo",value:function getMainFwdBufferInfo(){return this.getFwdBufferInfo(this.mediaBuffer?this.mediaBuffer:this.media,PlaylistLevelType.MAIN);}},{key:"backtrack",value:function backtrack(frag){this.couldBacktrack=true;// Causes findFragments to backtrack through fragments to find the keyframe
this.backtrackFragment=frag;this.resetTransmuxer();this.flushBufferGap(frag);this.fragmentTracker.removeFragment(frag);this.fragPrevious=null;this.nextLoadPosition=frag.start;this.state=State.IDLE;}},{key:"checkFragmentChanged",value:function checkFragmentChanged(){var video=this.media;var fragPlayingCurrent=null;if(video&&video.readyState>1&&video.seeking===false){var currentTime=video.currentTime;/* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */if(BufferHelper.isBuffered(video,currentTime)){fragPlayingCurrent=this.getAppendedFrag(currentTime);}else if(BufferHelper.isBuffered(video,currentTime+0.1)){/* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */fragPlayingCurrent=this.getAppendedFrag(currentTime+0.1);}if(fragPlayingCurrent){this.backtrackFragment=null;var fragPlaying=this.fragPlaying;var fragCurrentLevel=fragPlayingCurrent.level;if(!fragPlaying||fragPlayingCurrent.sn!==fragPlaying.sn||fragPlaying.level!==fragCurrentLevel){this.fragPlaying=fragPlayingCurrent;this.hls.trigger(Events.FRAG_CHANGED,{frag:fragPlayingCurrent});if(!fragPlaying||fragPlaying.level!==fragCurrentLevel){this.hls.trigger(Events.LEVEL_SWITCHED,{level:fragCurrentLevel});}}}}}},{key:"nextLevel",get:function get(){var frag=this.nextBufferedFrag;if(frag){return frag.level;}return -1;}},{key:"currentFrag",get:function get(){var media=this.media;if(media){return this.fragPlaying||this.getAppendedFrag(media.currentTime);}return null;}},{key:"currentProgramDateTime",get:function get(){var media=this.media;if(media){var currentTime=media.currentTime;var frag=this.currentFrag;if(frag&&isFiniteNumber(currentTime)&&isFiniteNumber(frag.programDateTime)){var epocMs=frag.programDateTime+(currentTime-frag.start)*1000;return new Date(epocMs);}}return null;}},{key:"currentLevel",get:function get(){var frag=this.currentFrag;if(frag){return frag.level;}return -1;}},{key:"nextBufferedFrag",get:function get(){var frag=this.currentFrag;if(frag){return this.followingBufferedFrag(frag);}return null;}},{key:"forceStartLoad",get:function get(){return this._forceStartLoad;}}]);return StreamController;}(BaseStreamController);/**
 * The `Hls` class is the core of the HLS.js library used to instantiate player instances.
 * @public
 */var Hls=/*#__PURE__*/function(){/**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */function Hls(){var userConfig=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,Hls);/**
     * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
     */this.config=void 0;/**
     * The configuration object provided on player instantiation.
     */this.userConfig=void 0;this.coreComponents=void 0;this.networkControllers=void 0;this.started=false;this._emitter=new EventEmitter();this._autoLevelCapping=-1;this._maxHdcpLevel=null;this.abrController=void 0;this.bufferController=void 0;this.capLevelController=void 0;this.latencyController=void 0;this.levelController=void 0;this.streamController=void 0;this.audioTrackController=void 0;this.subtitleTrackController=void 0;this.emeController=void 0;this.cmcdController=void 0;this._media=null;this.url=null;this.triggeringException=void 0;enableLogs(userConfig.debug||false,'Hls instance');var config=this.config=mergeConfig$1(Hls.DefaultConfig,userConfig);this.userConfig=userConfig;if(config.progressive){enableStreamingMode(config);}// core controllers and network loaders
var ConfigAbrController=config.abrController,ConfigBufferController=config.bufferController,ConfigCapLevelController=config.capLevelController,ConfigErrorController=config.errorController,ConfigFpsController=config.fpsController;var errorController=new ConfigErrorController(this);var abrController=this.abrController=new ConfigAbrController(this);var bufferController=this.bufferController=new ConfigBufferController(this);var capLevelController=this.capLevelController=new ConfigCapLevelController(this);var fpsController=new ConfigFpsController(this);var playListLoader=new PlaylistLoader(this);var id3TrackController=new ID3TrackController(this);var ConfigContentSteeringController=config.contentSteeringController;// ConentSteeringController is defined before LevelController to receive Multivariant Playlist events first
var contentSteering=ConfigContentSteeringController?new ConfigContentSteeringController(this):null;var levelController=this.levelController=new LevelController(this,contentSteering);// FragmentTracker must be defined before StreamController because the order of event handling is important
var fragmentTracker=new FragmentTracker(this);var keyLoader=new KeyLoader(this.config);var streamController=this.streamController=new StreamController(this,fragmentTracker,keyLoader);// Cap level controller uses streamController to flush the buffer
capLevelController.setStreamController(streamController);// fpsController uses streamController to switch when frames are being dropped
fpsController.setStreamController(streamController);var networkControllers=[playListLoader,levelController,streamController];if(contentSteering){networkControllers.splice(1,0,contentSteering);}this.networkControllers=networkControllers;var coreComponents=[abrController,bufferController,capLevelController,fpsController,id3TrackController,fragmentTracker];this.audioTrackController=this.createController(config.audioTrackController,networkControllers);var AudioStreamControllerClass=config.audioStreamController;if(AudioStreamControllerClass){networkControllers.push(new AudioStreamControllerClass(this,fragmentTracker,keyLoader));}// subtitleTrackController must be defined before subtitleStreamController because the order of event handling is important
this.subtitleTrackController=this.createController(config.subtitleTrackController,networkControllers);var SubtitleStreamControllerClass=config.subtitleStreamController;if(SubtitleStreamControllerClass){networkControllers.push(new SubtitleStreamControllerClass(this,fragmentTracker,keyLoader));}this.createController(config.timelineController,coreComponents);keyLoader.emeController=this.emeController=this.createController(config.emeController,coreComponents);this.cmcdController=this.createController(config.cmcdController,coreComponents);this.latencyController=this.createController(LatencyController,coreComponents);this.coreComponents=coreComponents;// Error controller handles errors before and after all other controllers
// This listener will be invoked after all other controllers error listeners
networkControllers.push(errorController);var onErrorOut=errorController.onErrorOut;if(typeof onErrorOut==='function'){this.on(Events.ERROR,onErrorOut,errorController);}}_createClass(Hls,[{key:"createController",value:function createController(ControllerClass,components){if(ControllerClass){var controllerInstance=new ControllerClass(this);if(components){components.push(controllerInstance);}return controllerInstance;}return null;}// Delegate the EventEmitter through the public API of Hls.js
},{key:"on",value:function on(event,listener){var context=arguments.length>2&&arguments[2]!==undefined?arguments[2]:this;this._emitter.on(event,listener,context);}},{key:"once",value:function once(event,listener){var context=arguments.length>2&&arguments[2]!==undefined?arguments[2]:this;this._emitter.once(event,listener,context);}},{key:"removeAllListeners",value:function removeAllListeners(event){this._emitter.removeAllListeners(event);}},{key:"off",value:function off(event,listener){var context=arguments.length>2&&arguments[2]!==undefined?arguments[2]:this;var once=arguments.length>3?arguments[3]:undefined;this._emitter.off(event,listener,context,once);}},{key:"listeners",value:function listeners(event){return this._emitter.listeners(event);}},{key:"emit",value:function emit(event,name,eventObject){return this._emitter.emit(event,name,eventObject);}},{key:"trigger",value:function trigger(event,eventObject){if(this.config.debug){return this.emit(event,event,eventObject);}else {try{return this.emit(event,event,eventObject);}catch(error){logger.error('An internal error happened while handling event '+event+'. Error message: "'+error.message+'". Here is a stacktrace:',error);// Prevent recursion in error event handlers that throw #5497
if(!this.triggeringException){this.triggeringException=true;var fatal=event===Events.ERROR;this.trigger(Events.ERROR,{type:ErrorTypes.OTHER_ERROR,details:ErrorDetails.INTERNAL_EXCEPTION,fatal:fatal,event:event,error:error});this.triggeringException=false;}}}return false;}},{key:"listenerCount",value:function listenerCount(event){return this._emitter.listenerCount(event);}/**
   * Dispose of the instance
   */},{key:"destroy",value:function destroy(){logger.log('destroy');this.trigger(Events.DESTROYING,undefined);this.detachMedia();this.removeAllListeners();this._autoLevelCapping=-1;this.url=null;this.networkControllers.forEach(function(component){return component.destroy();});this.networkControllers.length=0;this.coreComponents.forEach(function(component){return component.destroy();});this.coreComponents.length=0;// Remove any references that could be held in config options or callbacks
var config=this.config;config.xhrSetup=config.fetchSetup=undefined;// @ts-ignore
this.userConfig=null;}/**
   * Attaches Hls.js to a media element
   */},{key:"attachMedia",value:function attachMedia(media){logger.log('attachMedia');this._media=media;this.trigger(Events.MEDIA_ATTACHING,{media:media});}/**
   * Detach Hls.js from the media
   */},{key:"detachMedia",value:function detachMedia(){logger.log('detachMedia');this.trigger(Events.MEDIA_DETACHING,undefined);this._media=null;}/**
   * Set the source URL. Can be relative or absolute.
   */},{key:"loadSource",value:function loadSource(url){this.stopLoad();var media=this.media;var loadedSource=this.url;var loadingSource=this.url=urlToolkitExports.buildAbsoluteURL(self.location.href,url,{alwaysNormalize:true});this._autoLevelCapping=-1;this._maxHdcpLevel=null;logger.log("loadSource:".concat(loadingSource));if(media&&loadedSource&&(loadedSource!==loadingSource||this.bufferController.hasSourceTypes())){this.detachMedia();this.attachMedia(media);}// when attaching to a source URL, trigger a playlist load
this.trigger(Events.MANIFEST_LOADING,{url:url});}/**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */},{key:"startLoad",value:function startLoad(){var startPosition=arguments.length>0&&arguments[0]!==undefined?arguments[0]:-1;logger.log("startLoad(".concat(startPosition,")"));this.started=true;this.resumeBuffering();for(var i=0;i<this.networkControllers.length;i++){this.networkControllers[i].startLoad(startPosition);if(!this.started||!this.networkControllers){break;}}}/**
   * Stop loading of any stream data.
   */},{key:"stopLoad",value:function stopLoad(){logger.log('stopLoad');this.started=false;for(var i=0;i<this.networkControllers.length;i++){this.networkControllers[i].stopLoad();if(this.started||!this.networkControllers){break;}}}/**
   * Resumes stream controller segment loading after `pauseBuffering` has been called.
   */},{key:"resumeBuffering",value:function resumeBuffering(){logger.log("resume buffering");this.networkControllers.forEach(function(controller){if(controller.resumeBuffering){controller.resumeBuffering();}});}/**
   * Prevents stream controller from loading new segments until `resumeBuffering` is called.
   * This allows for media buffering to be paused without interupting playlist loading.
   */},{key:"pauseBuffering",value:function pauseBuffering(){logger.log("pause buffering");this.networkControllers.forEach(function(controller){if(controller.pauseBuffering){controller.pauseBuffering();}});}/**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */},{key:"swapAudioCodec",value:function swapAudioCodec(){logger.log('swapAudioCodec');this.streamController.swapAudioCodec();}/**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */},{key:"recoverMediaError",value:function recoverMediaError(){logger.log('recoverMediaError');var media=this._media;this.detachMedia();if(media){this.attachMedia(media);}}},{key:"removeLevel",value:function removeLevel(levelIndex){this.levelController.removeLevel(levelIndex);}/**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */},{key:"levels",get:function get(){var levels=this.levelController.levels;return levels?levels:[];}/**
   * Index of quality level (variant) currently played
   */},{key:"currentLevel",get:function get(){return this.streamController.currentLevel;}/**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */,set:function set(newLevel){logger.log("set currentLevel:".concat(newLevel));this.levelController.manualLevel=newLevel;this.streamController.immediateLevelSwitch();}/**
   * Index of next quality level loaded as scheduled by stream controller.
   */},{key:"nextLevel",get:function get(){return this.streamController.nextLevel;}/**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */,set:function set(newLevel){logger.log("set nextLevel:".concat(newLevel));this.levelController.manualLevel=newLevel;this.streamController.nextLevelSwitch();}/**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */},{key:"loadLevel",get:function get(){return this.levelController.level;}/**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */,set:function set(newLevel){logger.log("set loadLevel:".concat(newLevel));this.levelController.manualLevel=newLevel;}/**
   * get next quality level loaded
   */},{key:"nextLoadLevel",get:function get(){return this.levelController.nextLoadLevel;}/**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */,set:function set(level){this.levelController.nextLoadLevel=level;}/**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */},{key:"firstLevel",get:function get(){return Math.max(this.levelController.firstLevel,this.minAutoLevel);}/**
   * Sets "first-level", see getter.
   */,set:function set(newLevel){logger.log("set firstLevel:".concat(newLevel));this.levelController.firstLevel=newLevel;}/**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */},{key:"startLevel",get:function get(){var startLevel=this.levelController.startLevel;if(startLevel===-1&&this.abrController.forcedAutoLevel>-1){return this.abrController.forcedAutoLevel;}return startLevel;}/**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */,set:function set(newLevel){logger.log("set startLevel:".concat(newLevel));// if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
if(newLevel!==-1){newLevel=Math.max(newLevel,this.minAutoLevel);}this.levelController.startLevel=newLevel;}/**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */},{key:"capLevelToPlayerSize",get:function get(){return this.config.capLevelToPlayerSize;}/**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */,set:function set(shouldStartCapping){var newCapLevelToPlayerSize=!!shouldStartCapping;if(newCapLevelToPlayerSize!==this.config.capLevelToPlayerSize){if(newCapLevelToPlayerSize){this.capLevelController.startCapping();// If capping occurs, nextLevelSwitch will happen based on size.
}else {this.capLevelController.stopCapping();this.autoLevelCapping=-1;this.streamController.nextLevelSwitch();// Now we're uncapped, get the next level asap.
}this.config.capLevelToPlayerSize=newCapLevelToPlayerSize;}}/**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */},{key:"autoLevelCapping",get:function get(){return this._autoLevelCapping;}/**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */,set:/**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */function set(newLevel){if(this._autoLevelCapping!==newLevel){logger.log("set autoLevelCapping:".concat(newLevel));this._autoLevelCapping=newLevel;this.levelController.checkMaxAutoUpdated();}}},{key:"bandwidthEstimate",get:function get(){var bwEstimator=this.abrController.bwEstimator;if(!bwEstimator){return NaN;}return bwEstimator.getEstimate();},set:function set(abrEwmaDefaultEstimate){this.abrController.resetEstimator(abrEwmaDefaultEstimate);}/**
   * get time to first byte estimate
   * @type {number}
   */},{key:"ttfbEstimate",get:function get(){var bwEstimator=this.abrController.bwEstimator;if(!bwEstimator){return NaN;}return bwEstimator.getEstimateTTFB();}},{key:"maxHdcpLevel",get:function get(){return this._maxHdcpLevel;},set:function set(value){if(isHdcpLevel(value)&&this._maxHdcpLevel!==value){this._maxHdcpLevel=value;this.levelController.checkMaxAutoUpdated();}}/**
   * True when automatic level selection enabled
   */},{key:"autoLevelEnabled",get:function get(){return this.levelController.manualLevel===-1;}/**
   * Level set manually (if any)
   */},{key:"manualLevel",get:function get(){return this.levelController.manualLevel;}/**
   * min level selectable in auto mode according to config.minAutoBitrate
   */},{key:"minAutoLevel",get:function get(){var levels=this.levels,minAutoBitrate=this.config.minAutoBitrate;if(!levels)return 0;var len=levels.length;for(var i=0;i<len;i++){if(levels[i].maxBitrate>=minAutoBitrate){return i;}}return 0;}/**
   * max level selectable in auto mode according to autoLevelCapping
   */},{key:"maxAutoLevel",get:function get(){var levels=this.levels,autoLevelCapping=this.autoLevelCapping,maxHdcpLevel=this.maxHdcpLevel;var maxAutoLevel;if(autoLevelCapping===-1&&levels!=null&&levels.length){maxAutoLevel=levels.length-1;}else {maxAutoLevel=autoLevelCapping;}if(maxHdcpLevel){for(var i=maxAutoLevel;i--;){var hdcpLevel=levels[i].attrs['HDCP-LEVEL'];if(hdcpLevel&&hdcpLevel<=maxHdcpLevel){return i;}}}return maxAutoLevel;}},{key:"firstAutoLevel",get:function get(){return this.abrController.firstAutoLevel;}/**
   * next automatically selected quality level
   */},{key:"nextAutoLevel",get:function get(){return this.abrController.nextAutoLevel;}/**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */,set:function set(nextLevel){this.abrController.nextAutoLevel=nextLevel;}/**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */},{key:"playingDate",get:function get(){return this.streamController.currentProgramDateTime;}},{key:"mainForwardBufferInfo",get:function get(){return this.streamController.getMainFwdBufferInfo();}/**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */},{key:"setAudioOption",value:function setAudioOption(audioOption){var _this$audioTrackContr;return (_this$audioTrackContr=this.audioTrackController)==null?void 0:_this$audioTrackContr.setAudioOption(audioOption);}/**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */},{key:"setSubtitleOption",value:function setSubtitleOption(subtitleOption){var _this$subtitleTrackCo;(_this$subtitleTrackCo=this.subtitleTrackController)==null?void 0:_this$subtitleTrackCo.setSubtitleOption(subtitleOption);return null;}/**
   * Get the complete list of audio tracks across all media groups
   */},{key:"allAudioTracks",get:function get(){var audioTrackController=this.audioTrackController;return audioTrackController?audioTrackController.allAudioTracks:[];}/**
   * Get the list of selectable audio tracks
   */},{key:"audioTracks",get:function get(){var audioTrackController=this.audioTrackController;return audioTrackController?audioTrackController.audioTracks:[];}/**
   * index of the selected audio track (index in audio track lists)
   */},{key:"audioTrack",get:function get(){var audioTrackController=this.audioTrackController;return audioTrackController?audioTrackController.audioTrack:-1;}/**
   * selects an audio track, based on its index in audio track lists
   */,set:function set(audioTrackId){var audioTrackController=this.audioTrackController;if(audioTrackController){audioTrackController.audioTrack=audioTrackId;}}/**
   * get the complete list of subtitle tracks across all media groups
   */},{key:"allSubtitleTracks",get:function get(){var subtitleTrackController=this.subtitleTrackController;return subtitleTrackController?subtitleTrackController.allSubtitleTracks:[];}/**
   * get alternate subtitle tracks list from playlist
   */},{key:"subtitleTracks",get:function get(){var subtitleTrackController=this.subtitleTrackController;return subtitleTrackController?subtitleTrackController.subtitleTracks:[];}/**
   * index of the selected subtitle track (index in subtitle track lists)
   */},{key:"subtitleTrack",get:function get(){var subtitleTrackController=this.subtitleTrackController;return subtitleTrackController?subtitleTrackController.subtitleTrack:-1;},set:/**
   * select an subtitle track, based on its index in subtitle track lists
   */function set(subtitleTrackId){var subtitleTrackController=this.subtitleTrackController;if(subtitleTrackController){subtitleTrackController.subtitleTrack=subtitleTrackId;}}/**
   * Whether subtitle display is enabled or not
   */},{key:"media",get:function get(){return this._media;}},{key:"subtitleDisplay",get:function get(){var subtitleTrackController=this.subtitleTrackController;return subtitleTrackController?subtitleTrackController.subtitleDisplay:false;}/**
   * Enable/disable subtitle display rendering
   */,set:function set(value){var subtitleTrackController=this.subtitleTrackController;if(subtitleTrackController){subtitleTrackController.subtitleDisplay=value;}}/**
   * get mode for Low-Latency HLS loading
   */},{key:"lowLatencyMode",get:function get(){return this.config.lowLatencyMode;}/**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */,set:function set(mode){this.config.lowLatencyMode=mode;}/**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */},{key:"liveSyncPosition",get:function get(){return this.latencyController.liveSyncPosition;}/**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */},{key:"latency",get:function get(){return this.latencyController.latency;}/**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */},{key:"maxLatency",get:function get(){return this.latencyController.maxLatency;}/**
   * target distance from the edge as calculated by the latency controller
   */},{key:"targetLatency",get:function get(){return this.latencyController.targetLatency;}/**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */},{key:"drift",get:function get(){return this.latencyController.drift;}/**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */},{key:"forceStartLoad",get:function get(){return this.streamController.forceStartLoad;}}],[{key:"version",get:/**
   * Get the video-dev/hls.js package version.
   */function get(){return "1.5.18";}/**
   * Check if the required MediaSource Extensions are available.
   */},{key:"isMSESupported",value:function isMSESupported(){return _isMSESupported();}/**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */},{key:"isSupported",value:function isSupported(){return _isSupported();}/**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */},{key:"getMediaSource",value:function getMediaSource(){return _getMediaSource();}},{key:"Events",get:function get(){return Events;}},{key:"ErrorTypes",get:function get(){return ErrorTypes;}},{key:"ErrorDetails",get:function get(){return ErrorDetails;}/**
   * Get the default configuration applied to new instances.
   */},{key:"DefaultConfig",get:function get(){if(!Hls.defaultConfig){return hlsDefaultConfig;}return Hls.defaultConfig;}/**
   * Replace the default configuration applied to new instances.
   */,set:function set(defaultConfig){Hls.defaultConfig=defaultConfig;}}]);return Hls;}();Hls.defaultConfig=void 0;

var createSession = function createSession(context, signal) {
  return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, createFetch(context, "session", {
            method: 'POST',
            signal: signal
          })];
        case 1:
          res = _a.sent();
          if (!res.ok) {
            throw new Error("Failed to create session: ".concat(res.status));
          }
          return [4 /*yield*/, res.text()];
        case 2:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};

var useHls = function useHls(props) {
  var enabled = props.enabled,
    videoRef = props.videoRef,
    baseUrl = props.baseUrl,
    apiKey = props.apiKey,
    initTs = props.initTs,
    playbackRate = props.playbackRate,
    onInitialized = props.onInitialized,
    onMediaAttached = props.onMediaAttached,
    onManifestLoaded = props.onManifestLoaded,
    onLevelLoaded = props.onLevelLoaded,
    onFragBuffered = props.onFragBuffered,
    onError = props.onError,
    onInitializationFailed = props.onInitializationFailed,
    onDestroyed = props.onDestroyed;
  var hlsRef = useRef(null);
  var _a = useState(false),
    isError = _a[0],
    setIsError = _a[1];
  var destoryHls = function destoryHls() {
    onDestroyed === null || onDestroyed === void 0 ? void 0 : onDestroyed();
    if (hlsRef.current) {
      var hls = hlsRef.current;
      // HLS 내부 정리 루틴보다 먼저 removeAllListeners()를 호출하면
      // MEDIA_DETACHING / DESTROYING 이벤트가 내부 컨트롤러에 전달되지 않아
      // destroy 이후에도 seeking/seeked 리스너가 남을 수 있습니다.
      hls.config.autoStartLoad = false;
      if (videoRef.current) {
        videoRef.current.pause();
      }
      hls.stopLoad();
      hls.destroy();
      hlsRef.current = null;
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.removeAttribute('src'); // video 태그 src 초기화
        videoRef.current.load(); // video 태그 초기화
      }

      logger$1.debug('HLS destoryed.');
    }
  };
  /**
   * Initialize HLS
   */
  var initializeHls = function initializeHls(options) {
    return __awaiter(void 0, void 0, void 0, function () {
      var effectiveInitTs, session, searchParams, source, error_1;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            /**
             * hls 인스턴스가 아직 남아있다면 파괴 후 재생성할 수 있도록 합니다.
             */
            destoryHls();
            effectiveInitTs = (_a = options === null || options === void 0 ? void 0 : options.initTs) !== null && _a !== void 0 ? _a : initTs;
            if (!Hls.isSupported()) return [2 /*return*/];
            if (!enabled || !videoRef.current || !effectiveInitTs || !baseUrl || !apiKey) {
              return [2 /*return*/];
            }

            logger$1.info('HLS 인스턴스를 초기화합니다.');
            setIsError(false);
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            return [4 /*yield*/, createSession({
              baseUrl: baseUrl,
              apiKey: apiKey
            }, options === null || options === void 0 ? void 0 : options.signal)];
          case 2:
            session = _b.sent();
            logger$1.debug('CMAS Session created', session);
            if (!session) {
              throw new Error('Session is not created.');
            }
            searchParams = new URLSearchParams({
              client_id: session,
              initTs: effectiveInitTs.toString()
            });
            source = "".concat(baseUrl, "/segment/playlist?").concat(searchParams.toString());
            hlsRef.current = new Hls({
              lowLatencyMode: false,
              // 저 FPS 스트림의 프레임 간 PTS 간격을 과도한 buffer hole로 오판하지 않도록 완화합니다.
              maxBufferHole: 2,
              maxBufferLength: 30,
              nudgeOffset: 0.2,
              nudgeMaxRetry: 5,
              forceKeyFrameOnDiscontinuity: true,
              fragLoadingMaxRetry: 5,
              xhrSetup: function xhrSetup(xhr, url) {
                if (url.includes('https://caas-cctv.s3.ap-northeast-2.amazonaws.com/') || url.includes('https://caas-cctv.s3.amazonaws.com/')) {
                  var replacedUrl = url.replaceAll('https://caas-cctv.s3.ap-northeast-2.amazonaws.com/', 'https://d21c0x6k4esz52.cloudfront.net/').replaceAll('https://caas-cctv.s3.amazonaws.com/', 'https://d21c0x6k4esz52.cloudfront.net/');
                  xhr.open('GET', replacedUrl);
                }
                if (url.includes('/segment')) {
                  xhr.setRequestHeader('Authorization', "apikey ".concat(apiKey));
                }
              }
            });
            hlsRef.current.loadSource(source);
            hlsRef.current.attachMedia(videoRef.current);
            if (onManifestLoaded) {
              hlsRef.current.on(Hls.Events.MANIFEST_LOADED, onManifestLoaded);
            }
            if (onLevelLoaded) {
              hlsRef.current.on(Hls.Events.LEVEL_LOADED, onLevelLoaded);
            }
            hlsRef.current.on(Hls.Events.LEVEL_UPDATED, function (event, data) {
              return logger$1.debug('HLS LEVEL_UPDATED', event, data);
            });
            if (onFragBuffered) {
              hlsRef.current.on(Hls.Events.FRAG_BUFFERED, onFragBuffered);
            }
            hlsRef.current.on(Hls.Events.ERROR, function (event, data) {
              logger$1.error('HLS ERROR', event, data);
              onError === null || onError === void 0 ? void 0 : onError(event, data);
            });
            /**
             * Auto play
             */
            hlsRef.current.on(Hls.Events.MEDIA_ATTACHED, function (event, data) {
              if (videoRef.current) {
                playMediaSafely(videoRef.current, 'hls-media-attached');
                videoRef.current.playbackRate = playbackRate !== null && playbackRate !== void 0 ? playbackRate : 1;
              }
              onMediaAttached === null || onMediaAttached === void 0 ? void 0 : onMediaAttached(event, data);
            });
            onInitialized === null || onInitialized === void 0 ? void 0 : onInitialized();
            return [3 /*break*/, 4];
          case 3:
            error_1 = _b.sent();
            logger$1.error('HLS initialization failed', error_1);
            if (error_1.name === 'AbortError') {
              logger$1.info('HLS 초기화 중 세션 요청이 취소되었습니다.');
              destoryHls();
              return [2 /*return*/];
            }

            destoryHls();
            onInitializationFailed === null || onInitializationFailed === void 0 ? void 0 : onInitializationFailed(error_1);
            if (onInitializationFailed) {
              return [2 /*return*/];
            }

            setIsError(true);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    var abortController = new AbortController();
    var signal = abortController.signal;
    initializeHls({
      signal: signal
    });
    return function () {
      abortController.abort();
      destoryHls();
    };
  }, [baseUrl, videoRef.current, initTs, enabled, apiKey]);
  var initHls = function initHls(initTsOverride) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, initializeHls({
          initTs: initTsOverride
        })];
      });
    });
  };
  return {
    hlsRef: hlsRef,
    isError: isError,
    initHls: initHls,
    destoryHls: destoryHls
  };
};

var isFunction$1 = function (value) {
  return typeof value === 'function';
};

var isDev = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
var isDev$1 = isDev;

function depsAreSame(oldDeps, deps) {
  if (oldDeps === deps) return true;
  for (var i = 0; i < oldDeps.length; i++) {
    if (!Object.is(oldDeps[i], deps[i])) return false;
  }
  return true;
}

function useLatest(value) {
  var ref = useRef(value);
  ref.current = value;
  return ref;
}

var useUnmount = function (fn) {
  if (isDev$1) {
    if (!isFunction$1(fn)) {
      console.error("useUnmount expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = useLatest(fn);
  useEffect(function () {
    return function () {
      fnRef.current();
    };
  }, []);
};
var useUnmount$1 = useUnmount;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var _Symbol = root.Symbol;

/** Used for built-in method references. */
var objectProto$s = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$o = objectProto$s.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$3 = objectProto$s.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$o.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$r = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$r.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$2.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$3;
}

/** Used as references for various `Number` constants. */
var NAN$2 = 0 / 0;

/**
 * The base implementation of `_.toNumber` which doesn't ensure correct
 * conversions of binary, hexadecimal, or octal string values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 */
function baseToNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN$2;
  }
  return +value;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** Used as references for various `Number` constants. */
var INFINITY$5 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined,
  symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$5 ? '-0' : result;
}

/**
 * Creates a function that performs a mathematical operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @param {number} [defaultValue] The value used for `undefined` arguments.
 * @returns {Function} Returns the new mathematical operation function.
 */
function createMathOperation(operator, defaultValue) {
  return function (value, other) {
    var result;
    if (value === undefined && other === undefined) {
      return defaultValue;
    }
    if (value !== undefined) {
      result = value;
    }
    if (other !== undefined) {
      if (result === undefined) {
        return other;
      }
      if (typeof value == 'string' || typeof other == 'string') {
        value = baseToString(value);
        other = baseToString(other);
      } else {
        value = baseToNumber(value);
        other = baseToNumber(other);
      }
      result = operator(value, other);
    }
    return result;
  };
}

/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = createMathOperation(function (augend, addend) {
  return augend + addend;
}, 0);

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used to match leading whitespace. */
var reTrimStart$2 = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart$2, '') : string;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN$1;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN$1 : +value;
}

/** Used as references for various `Number` constants. */
var INFINITY$4 = 1 / 0,
  MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY$4 || value === -INFINITY$4) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
    remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$b = 'Expected a function';

/**
 * The opposite of `_.before`; this method creates a function that invokes
 * `func` once it's called `n` or more times.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {number} n The number of calls before `func` is invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var saves = ['profile', 'settings'];
 *
 * var done = _.after(saves.length, function() {
 *   console.log('done saving!');
 * });
 *
 * _.forEach(saves, function(type) {
 *   asyncSave({ 'type': type, 'complete': done });
 * });
 * // => Logs 'done saving!' after the two async saves have completed.
 */
function after(n, func) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$b);
  }
  n = toInteger(n);
  return function () {
    if (--n < 1) {
      return func.apply(this, arguments);
    }
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity$1(value) {
  return value;
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
  objectProto$q = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$n = objectProto$q.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$n).replace(reRegExpChar$1, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root, 'WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap$1 && new WeakMap$1();

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity$1 : function (func, data) {
  metaMap.set(func, data);
  return func;
};

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function () {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0:
        return new Ctor();
      case 1:
        return new Ctor(args[0]);
      case 2:
        return new Ctor(args[0], args[1]);
      case 3:
        return new Ctor(args[0], args[1], args[2]);
      case 4:
        return new Ctor(args[0], args[1], args[2], args[3]);
      case 5:
        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
      result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$8 = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG$8,
    Ctor = createCtor(func);
  function wrapper() {
    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$g = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
    argsLength = args.length,
    holdersLength = holders.length,
    leftIndex = -1,
    leftLength = partials.length,
    rangeLength = nativeMax$g(argsLength - holdersLength, 0),
    result = Array(leftLength + rangeLength),
    isUncurried = !isCurried;
  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$f = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
    argsLength = args.length,
    holdersIndex = -1,
    holdersLength = holders.length,
    rightIndex = -1,
    rightLength = partials.length,
    rangeLength = nativeMax$f(argsLength - holdersLength, 0),
    result = Array(rangeLength + rightLength),
    isUncurried = !isCurried;
  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
    result = 0;
  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$6 = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH$6;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop$2() {
  // No operation performed.
}

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop$2 : function (func) {
  return metaMap.get(func);
};

/** Used to lookup unminified function names. */
var realNames = {};

/** Used for built-in method references. */
var objectProto$p = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$m = objectProto$p.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = func.name + '',
    array = realNames[result],
    length = hasOwnProperty$m.call(realNames, result) ? array.length : 0;
  while (length--) {
    var data = array[length],
      otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}
LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__ = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

/** Used for built-in method references. */
var objectProto$o = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$l = objectProto$o.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty$l.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
    other = lodash[funcName];
  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
  HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
      remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
  reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity$1 : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
    index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
    length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$7 = 1,
  WRAP_BIND_KEY_FLAG$6 = 2,
  WRAP_CURRY_FLAG$6 = 8,
  WRAP_CURRY_RIGHT_FLAG$3 = 16,
  WRAP_PARTIAL_FLAG$6 = 32,
  WRAP_PARTIAL_RIGHT_FLAG$3 = 64,
  WRAP_ARY_FLAG$4 = 128,
  WRAP_REARG_FLAG$3 = 256,
  WRAP_FLIP_FLAG$2 = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [['ary', WRAP_ARY_FLAG$4], ['bind', WRAP_BIND_FLAG$7], ['bindKey', WRAP_BIND_KEY_FLAG$6], ['curry', WRAP_CURRY_FLAG$6], ['curryRight', WRAP_CURRY_RIGHT_FLAG$3], ['flip', WRAP_FLIP_FLAG$2], ['partial', WRAP_PARTIAL_FLAG$6], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG$3], ['rearg', WRAP_REARG_FLAG$3]];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function (pair) {
    var value = '_.' + pair[0];
    if (bitmask & pair[1] && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = reference + '';
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$6 = 1,
  WRAP_BIND_KEY_FLAG$5 = 2,
  WRAP_CURRY_BOUND_FLAG$1 = 4,
  WRAP_CURRY_FLAG$5 = 8,
  WRAP_PARTIAL_FLAG$5 = 32,
  WRAP_PARTIAL_RIGHT_FLAG$2 = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG$5,
    newHolders = isCurry ? holders : undefined,
    newHoldersRight = isCurry ? undefined : holders,
    newPartials = isCurry ? partials : undefined,
    newPartialsRight = isCurry ? undefined : partials;
  bitmask |= isCurry ? WRAP_PARTIAL_FLAG$5 : WRAP_PARTIAL_RIGHT_FLAG$2;
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG$2 : WRAP_PARTIAL_FLAG$5);
  if (!(bitmask & WRAP_CURRY_BOUND_FLAG$1)) {
    bitmask &= ~(WRAP_BIND_FLAG$6 | WRAP_BIND_KEY_FLAG$5);
  }
  var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$5 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER$5 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$e = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
    length = nativeMin$e(indexes.length, arrLength),
    oldArray = copyArray(array);
  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/** Used as the internal argument placeholder. */
var PLACEHOLDER$1 = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
    length = array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER$1) {
      array[index] = PLACEHOLDER$1;
      result[resIndex++] = index;
    }
  }
  return result;
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$5 = 1,
  WRAP_BIND_KEY_FLAG$4 = 2,
  WRAP_CURRY_FLAG$4 = 8,
  WRAP_CURRY_RIGHT_FLAG$2 = 16,
  WRAP_ARY_FLAG$3 = 128,
  WRAP_FLIP_FLAG$1 = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG$3,
    isBind = bitmask & WRAP_BIND_FLAG$5,
    isBindKey = bitmask & WRAP_BIND_KEY_FLAG$4,
    isCurried = bitmask & (WRAP_CURRY_FLAG$4 | WRAP_CURRY_RIGHT_FLAG$2),
    isFlip = bitmask & WRAP_FLIP_FLAG$1,
    Ctor = isBindKey ? undefined : createCtor(func);
  function wrapper() {
    var length = arguments.length,
      args = Array(length),
      index = length;
    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
        holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
    }
    var thisBinding = isBind ? thisArg : this,
      fn = isBindKey ? thisBinding[func] : func;
    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);
  function wrapper() {
    var length = arguments.length,
      args = Array(length),
      index = length,
      placeholder = getHolder(wrapper);
    while (index--) {
      args[index] = arguments[index];
    }
    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
    length -= holders.length;
    if (length < arity) {
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
    }
    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$4 = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG$4,
    Ctor = createCtor(func);
  function wrapper() {
    var argsIndex = -1,
      argsLength = arguments.length,
      leftIndex = -1,
      leftLength = partials.length,
      args = Array(leftLength + argsLength),
      fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$3 = 1,
  WRAP_BIND_KEY_FLAG$3 = 2,
  WRAP_CURRY_BOUND_FLAG = 4,
  WRAP_CURRY_FLAG$3 = 8,
  WRAP_ARY_FLAG$2 = 128,
  WRAP_REARG_FLAG$2 = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$d = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
    srcBitmask = source[1],
    newBitmask = bitmask | srcBitmask,
    isCommon = newBitmask < (WRAP_BIND_FLAG$3 | WRAP_BIND_KEY_FLAG$3 | WRAP_ARY_FLAG$2);
  var isCombo = srcBitmask == WRAP_ARY_FLAG$2 && bitmask == WRAP_CURRY_FLAG$3 || srcBitmask == WRAP_ARY_FLAG$2 && bitmask == WRAP_REARG_FLAG$2 && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG$2 | WRAP_REARG_FLAG$2) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG$3;

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG$3) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG$3 ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG$2) {
    data[8] = data[8] == null ? source[8] : nativeMin$d(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;
  return data;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$a = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$2 = 1,
  WRAP_BIND_KEY_FLAG$2 = 2,
  WRAP_CURRY_FLAG$2 = 8,
  WRAP_CURRY_RIGHT_FLAG$1 = 16,
  WRAP_PARTIAL_FLAG$4 = 32,
  WRAP_PARTIAL_RIGHT_FLAG$1 = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$e = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG$2;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$a);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG$4 | WRAP_PARTIAL_RIGHT_FLAG$1);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax$e(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;
  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG$1) {
    var partialsRight = partials,
      holdersRight = holders;
    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);
  var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax$e(newData[9] - length, 0);
  if (!arity && bitmask & (WRAP_CURRY_FLAG$2 | WRAP_CURRY_RIGHT_FLAG$1)) {
    bitmask &= ~(WRAP_CURRY_FLAG$2 | WRAP_CURRY_RIGHT_FLAG$1);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG$2) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG$2 || bitmask == WRAP_CURRY_RIGHT_FLAG$1) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG$4 || bitmask == (WRAP_BIND_FLAG$2 | WRAP_PARTIAL_FLAG$4)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG$1 = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = func && n == null ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG$1, undefined, undefined, undefined, undefined, n);
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto$n = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$k = objectProto$n.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$k.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$d = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$d(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax$d(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity$1), func + '');
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$4 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$4;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
      length = sources.length,
      customizer = length > 1 ? sources[length - 1] : undefined,
      guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Used for built-in method references. */
var objectProto$m = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$m;
  return value === proto;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
}

/** Used for built-in method references. */
var objectProto$l = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$j = objectProto$l.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$l.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$j.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && (typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
  arrayTag$2 = '[object Array]',
  boolTag$4 = '[object Boolean]',
  dateTag$4 = '[object Date]',
  errorTag$3 = '[object Error]',
  funcTag$1 = '[object Function]',
  mapTag$9 = '[object Map]',
  numberTag$4 = '[object Number]',
  objectTag$4 = '[object Object]',
  regexpTag$4 = '[object RegExp]',
  setTag$9 = '[object Set]',
  stringTag$4 = '[object String]',
  weakMapTag$3 = '[object WeakMap]';
var arrayBufferTag$4 = '[object ArrayBuffer]',
  dataViewTag$4 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$4] = typedArrayTags[boolTag$4] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$4] = typedArrayTags[errorTag$3] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$9] = typedArrayTags[numberTag$4] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$4] = typedArrayTags[setTag$9] = typedArrayTags[stringTag$4] = typedArrayTags[weakMapTag$3] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && (typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** Used for built-in method references. */
var objectProto$k = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$i = objectProto$k.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
    isArg = !isArr && isArguments(value),
    isBuff = !isArr && !isArg && isBuffer(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$i.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$j = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$h = objectProto$j.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$h.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$i.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function (object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty$g.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$h.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$f.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function (object, source) {
  copyObject(source, keysIn(source), object);
});

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keys(source), object, customizer);
});

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$g.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$e.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$d.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto$5 = Array.prototype;

/** Built-in value references. */
var splice$2 = arrayProto$5.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$2.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root, 'Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$1 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Error message constants. */
var FUNC_ERROR_TEXT$9 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$9);
  }
  var memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$3 ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.at` without support for individual paths.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {string[]} paths The property paths to pick.
 * @returns {Array} Returns the picked elements.
 */
function baseAt(object, paths) {
  var index = -1,
    length = paths.length,
    result = Array(length),
    skip = object == null;
  while (++index < length) {
    result[index] = skip ? undefined : get(object, paths[index]);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

/**
 * Creates an array of values corresponding to `paths` of `object`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Array} Returns the picked values.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _.at(object, ['a[0].b.c', 'a[1]']);
 * // => [3, 4]
 */
var at = flatRest(baseAt);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$e = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$c.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
  errorTag$2 = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag$2 || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function (func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/** Error message constants. */
var FUNC_ERROR_TEXT$8 = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$8);
  }
  n = toInteger(n);
  return function () {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$1 = 1,
  WRAP_PARTIAL_FLAG$3 = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function (func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG$1;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG$3;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

/**
 * Binds methods of an object to the object itself, overwriting the existing
 * method.
 *
 * **Note:** This method doesn't set the "length" property of bound functions.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Object} object The object to bind and assign the bound methods to.
 * @param {...(string|string[])} methodNames The object method names to bind.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var view = {
 *   'label': 'docs',
 *   'click': function() {
 *     console.log('clicked ' + this.label);
 *   }
 * };
 *
 * _.bindAll(view, ['click']);
 * jQuery(element).on('click', view.click);
 * // => Logs 'clicked docs' when clicked.
 */
var bindAll = flatRest(function (object, methodNames) {
  arrayEach(methodNames, function (key) {
    key = toKey(key);
    baseAssignValue(object, key, bind(object[key], object));
  });
  return object;
});

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
  WRAP_BIND_KEY_FLAG$1 = 2,
  WRAP_PARTIAL_FLAG$2 = 32;

/**
 * Creates a function that invokes the method at `object[key]` with `partials`
 * prepended to the arguments it receives.
 *
 * This method differs from `_.bind` by allowing bound functions to reference
 * methods that may be redefined or don't yet exist. See
 * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
 * for more details.
 *
 * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Function
 * @param {Object} object The object to invoke the method on.
 * @param {string} key The key of the method.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var object = {
 *   'user': 'fred',
 *   'greet': function(greeting, punctuation) {
 *     return greeting + ' ' + this.user + punctuation;
 *   }
 * };
 *
 * var bound = _.bindKey(object, 'greet', 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * object.greet = function(greeting, punctuation) {
 *   return greeting + 'ya ' + this.user + punctuation;
 * };
 *
 * bound('!');
 * // => 'hiya fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bindKey(object, 'greet', _, '!');
 * bound('hi');
 * // => 'hiya fred!'
 */
var bindKey = baseRest(function (object, key, partials) {
  var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG$1;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bindKey));
    bitmask |= WRAP_PARTIAL_FLAG$2;
  }
  return createWrap(key, bitmask, object, partials, holders);
});

// Assign default placeholders.
bindKey.placeholder = {};

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}

/** Used to compose unicode character classes. */
var rsAstralRange$3 = "\\ud800-\\udfff",
  rsComboMarksRange$4 = "\\u0300-\\u036f",
  reComboHalfMarksRange$4 = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange$4 = "\\u20d0-\\u20ff",
  rsComboRange$4 = rsComboMarksRange$4 + reComboHalfMarksRange$4 + rsComboSymbolsRange$4,
  rsVarRange$3 = "\\ufe0e\\ufe0f";

/** Used to compose unicode capture groups. */
var rsZWJ$3 = "\\u200d";

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$3 + rsAstralRange$3 + rsComboRange$4 + rsVarRange$3 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/** Used to compose unicode character classes. */
var rsAstralRange$2 = "\\ud800-\\udfff",
  rsComboMarksRange$3 = "\\u0300-\\u036f",
  reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange$3 = "\\u20d0-\\u20ff",
  rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
  rsVarRange$2 = "\\ufe0e\\ufe0f";

/** Used to compose unicode capture groups. */
var rsAstral$1 = '[' + rsAstralRange$2 + ']',
  rsCombo$3 = '[' + rsComboRange$3 + ']',
  rsFitz$2 = "\\ud83c[\\udffb-\\udfff]",
  rsModifier$2 = '(?:' + rsCombo$3 + '|' + rsFitz$2 + ')',
  rsNonAstral$2 = '[^' + rsAstralRange$2 + ']',
  rsRegional$2 = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  rsSurrPair$2 = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  rsZWJ$2 = "\\u200d";

/** Used to compose unicode regexes. */
var reOptMod$2 = rsModifier$2 + '?',
  rsOptVar$2 = '[' + rsVarRange$2 + ']?',
  rsOptJoin$2 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$2, rsRegional$2, rsSurrPair$2].join('|') + ')' + rsOptVar$2 + reOptMod$2 + ')*',
  rsSeq$2 = rsOptVar$2 + reOptMod$2 + rsOptJoin$2,
  rsSymbol$1 = '(?:' + [rsNonAstral$2 + rsCombo$3 + '?', rsCombo$3, rsRegional$2, rsSurrPair$2, rsAstral$1].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode$1 = RegExp(rsFitz$2 + '(?=' + rsFitz$2 + ')|' + rsSymbol$1 + rsSeq$2, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode$1) || [];
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function (string) {
    string = toString(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
    return chr[methodName]() + trailing;
  };
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize$1(string) {
  return upperFirst(toString(string).toLowerCase());
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
    length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',
  '\xc1': 'A',
  '\xc2': 'A',
  '\xc3': 'A',
  '\xc4': 'A',
  '\xc5': 'A',
  '\xe0': 'a',
  '\xe1': 'a',
  '\xe2': 'a',
  '\xe3': 'a',
  '\xe4': 'a',
  '\xe5': 'a',
  '\xc7': 'C',
  '\xe7': 'c',
  '\xd0': 'D',
  '\xf0': 'd',
  '\xc8': 'E',
  '\xc9': 'E',
  '\xca': 'E',
  '\xcb': 'E',
  '\xe8': 'e',
  '\xe9': 'e',
  '\xea': 'e',
  '\xeb': 'e',
  '\xcc': 'I',
  '\xcd': 'I',
  '\xce': 'I',
  '\xcf': 'I',
  '\xec': 'i',
  '\xed': 'i',
  '\xee': 'i',
  '\xef': 'i',
  '\xd1': 'N',
  '\xf1': 'n',
  '\xd2': 'O',
  '\xd3': 'O',
  '\xd4': 'O',
  '\xd5': 'O',
  '\xd6': 'O',
  '\xd8': 'O',
  '\xf2': 'o',
  '\xf3': 'o',
  '\xf4': 'o',
  '\xf5': 'o',
  '\xf6': 'o',
  '\xf8': 'o',
  '\xd9': 'U',
  '\xda': 'U',
  '\xdb': 'U',
  '\xdc': 'U',
  '\xf9': 'u',
  '\xfa': 'u',
  '\xfb': 'u',
  '\xfc': 'u',
  '\xdd': 'Y',
  '\xfd': 'y',
  '\xff': 'y',
  '\xc6': 'Ae',
  '\xe6': 'ae',
  '\xde': 'Th',
  '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  "\u0100": 'A',
  "\u0102": 'A',
  "\u0104": 'A',
  "\u0101": 'a',
  "\u0103": 'a',
  "\u0105": 'a',
  "\u0106": 'C',
  "\u0108": 'C',
  "\u010A": 'C',
  "\u010C": 'C',
  "\u0107": 'c',
  "\u0109": 'c',
  "\u010B": 'c',
  "\u010D": 'c',
  "\u010E": 'D',
  "\u0110": 'D',
  "\u010F": 'd',
  "\u0111": 'd',
  "\u0112": 'E',
  "\u0114": 'E',
  "\u0116": 'E',
  "\u0118": 'E',
  "\u011A": 'E',
  "\u0113": 'e',
  "\u0115": 'e',
  "\u0117": 'e',
  "\u0119": 'e',
  "\u011B": 'e',
  "\u011C": 'G',
  "\u011E": 'G',
  "\u0120": 'G',
  "\u0122": 'G',
  "\u011D": 'g',
  "\u011F": 'g',
  "\u0121": 'g',
  "\u0123": 'g',
  "\u0124": 'H',
  "\u0126": 'H',
  "\u0125": 'h',
  "\u0127": 'h',
  "\u0128": 'I',
  "\u012A": 'I',
  "\u012C": 'I',
  "\u012E": 'I',
  "\u0130": 'I',
  "\u0129": 'i',
  "\u012B": 'i',
  "\u012D": 'i',
  "\u012F": 'i',
  "\u0131": 'i',
  "\u0134": 'J',
  "\u0135": 'j',
  "\u0136": 'K',
  "\u0137": 'k',
  "\u0138": 'k',
  "\u0139": 'L',
  "\u013B": 'L',
  "\u013D": 'L',
  "\u013F": 'L',
  "\u0141": 'L',
  "\u013A": 'l',
  "\u013C": 'l',
  "\u013E": 'l',
  "\u0140": 'l',
  "\u0142": 'l',
  "\u0143": 'N',
  "\u0145": 'N',
  "\u0147": 'N',
  "\u014A": 'N',
  "\u0144": 'n',
  "\u0146": 'n',
  "\u0148": 'n',
  "\u014B": 'n',
  "\u014C": 'O',
  "\u014E": 'O',
  "\u0150": 'O',
  "\u014D": 'o',
  "\u014F": 'o',
  "\u0151": 'o',
  "\u0154": 'R',
  "\u0156": 'R',
  "\u0158": 'R',
  "\u0155": 'r',
  "\u0157": 'r',
  "\u0159": 'r',
  "\u015A": 'S',
  "\u015C": 'S',
  "\u015E": 'S',
  "\u0160": 'S',
  "\u015B": 's',
  "\u015D": 's',
  "\u015F": 's',
  "\u0161": 's',
  "\u0162": 'T',
  "\u0164": 'T',
  "\u0166": 'T',
  "\u0163": 't',
  "\u0165": 't',
  "\u0167": 't',
  "\u0168": 'U',
  "\u016A": 'U',
  "\u016C": 'U',
  "\u016E": 'U',
  "\u0170": 'U',
  "\u0172": 'U',
  "\u0169": 'u',
  "\u016B": 'u',
  "\u016D": 'u',
  "\u016F": 'u',
  "\u0171": 'u',
  "\u0173": 'u',
  "\u0174": 'W',
  "\u0175": 'w',
  "\u0176": 'Y',
  "\u0177": 'y',
  "\u0178": 'Y',
  "\u0179": 'Z',
  "\u017B": 'Z',
  "\u017D": 'Z',
  "\u017A": 'z',
  "\u017C": 'z',
  "\u017E": 'z',
  "\u0132": 'IJ',
  "\u0133": 'ij',
  "\u0152": 'Oe',
  "\u0153": 'oe',
  "\u0149": "'n",
  "\u017F": 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$2 = "\\u0300-\\u036f",
  reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange$2 = "\\u20d0-\\u20ff",
  rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2;

/** Used to compose unicode capture groups. */
var rsCombo$2 = '[' + rsComboRange$2 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$2, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/** Used to compose unicode character classes. */
var rsAstralRange$1 = "\\ud800-\\udfff",
  rsComboMarksRange$1 = "\\u0300-\\u036f",
  reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange$1 = "\\u20d0-\\u20ff",
  rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
  rsDingbatRange = "\\u2700-\\u27bf",
  rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
  rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
  rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
  rsPunctuationRange = "\\u2000-\\u206f",
  rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
  rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
  rsVarRange$1 = "\\ufe0e\\ufe0f",
  rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
  rsBreak = '[' + rsBreakRange + ']',
  rsCombo$1 = '[' + rsComboRange$1 + ']',
  rsDigits = '\\d+',
  rsDingbat = '[' + rsDingbatRange + ']',
  rsLower = '[' + rsLowerRange + ']',
  rsMisc = '[^' + rsAstralRange$1 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
  rsFitz$1 = "\\ud83c[\\udffb-\\udfff]",
  rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
  rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
  rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  rsUpper = '[' + rsUpperRange + ']',
  rsZWJ$1 = "\\u200d";

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
  rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
  rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
  rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
  reOptMod$1 = rsModifier$1 + '?',
  rsOptVar$1 = '[' + rsVarRange$1 + ']?',
  rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
  rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
  rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
  rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
  rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;
  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function (string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function (result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize$1(word) : word);
});

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite$1 = root.isFinite,
  nativeMin$c = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function (number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin$c(toInteger(precision), 292);
    if (precision && nativeIsFinite$1(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
        value = func(pair[0] + 'e' + (+pair[1] + precision));
      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

/**
 * Computes `number` rounded up to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round up.
 * @param {number} [precision=0] The precision to round up to.
 * @returns {number} Returns the rounded up number.
 * @example
 *
 * _.ceil(4.006);
 * // => 5
 *
 * _.ceil(6.004, 2);
 * // => 6.01
 *
 * _.ceil(6040, -2);
 * // => 6100
 */
var ceil = createRound('ceil');

/**
 * Creates a `lodash` wrapper instance that wraps `value` with explicit method
 * chain sequences enabled. The result of such sequences must be unwrapped
 * with `_#value`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Seq
 * @param {*} value The value to wrap.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36 },
 *   { 'user': 'fred',    'age': 40 },
 *   { 'user': 'pebbles', 'age': 1 }
 * ];
 *
 * var youngest = _
 *   .chain(users)
 *   .sortBy('age')
 *   .map(function(o) {
 *     return o.user + ' is ' + o.age;
 *   })
 *   .head()
 *   .value();
 * // => 'pebbles is 1'
 */
function chain$1(value) {
  var result = lodash(value);
  result.__chain__ = true;
  return result;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil$3 = Math.ceil,
  nativeMax$c = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
    size = 1;
  } else {
    size = nativeMax$c(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
    resIndex = 0,
    result = Array(nativeCeil$3(length / size));
  while (index < length) {
    result[resIndex++] = baseSlice(array, index, index += size);
  }
  return result;
}

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp$2(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$2 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE$2 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */
var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && (typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
  allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$d.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative(root, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root, 'Promise');

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root, 'Set');

/** `Object#toString` result references. */
var mapTag$8 = '[object Map]',
  objectTag$2 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$8 = '[object Set]',
  weakMapTag$2 = '[object WeakMap]';
var dataViewTag$3 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
  mapCtorString = toSource(Map$1),
  promiseCtorString = toSource(Promise$1),
  setCtorString = toSource(Set$1),
  weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$3 || Map$1 && getTag(new Map$1()) != mapTag$8 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$8 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$2) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$2 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$3;
        case mapCtorString:
          return mapTag$8;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$8;
        case weakMapCtorString:
          return weakMapTag$2;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$c.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$b.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/** Built-in value references. */
var Uint8Array$1 = root.Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags$1 = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags$1.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
  dateTag$3 = '[object Date]',
  mapTag$7 = '[object Map]',
  numberTag$3 = '[object Number]',
  regexpTag$3 = '[object RegExp]',
  setTag$7 = '[object Set]',
  stringTag$3 = '[object String]',
  symbolTag$2 = '[object Symbol]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
  dataViewTag$2 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$3:
      return cloneArrayBuffer(object);
    case boolTag$3:
    case dateTag$3:
      return new Ctor(+object);
    case dataViewTag$2:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$7:
      return new Ctor();
    case numberTag$3:
    case stringTag$3:
      return new Ctor(object);
    case regexpTag$3:
      return cloneRegExp(object);
    case setTag$7:
      return new Ctor();
    case symbolTag$2:
      return cloneSymbol(object);
  }
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

/** `Object#toString` result references. */
var mapTag$6 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$6;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

/** `Object#toString` result references. */
var setTag$6 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$6;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$7 = 1,
  CLONE_FLAT_FLAG$1 = 2,
  CLONE_SYMBOLS_FLAG$5 = 4;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag$2 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  mapTag$5 = '[object Map]',
  numberTag$2 = '[object Number]',
  objectTag$1 = '[object Object]',
  regexpTag$2 = '[object RegExp]',
  setTag$5 = '[object Set]',
  stringTag$2 = '[object String]',
  symbolTag$1 = '[object Symbol]',
  weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$5] = cloneableTags[numberTag$2] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$2] = cloneableTags[setTag$5] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$7,
    isFlat = bitmask & CLONE_FLAT_FLAG$1,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$5;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
      isFunc = tag == funcTag || tag == genTag;
    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag$1 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG$4 = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG$4);
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$6 = 1,
  CLONE_SYMBOLS_FLAG$3 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG$6 | CLONE_SYMBOLS_FLAG$3);
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$5 = 1,
  CLONE_SYMBOLS_FLAG$2 = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG$5 | CLONE_SYMBOLS_FLAG$2, customizer);
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.clone` except that it accepts `customizer` which
 * is invoked to produce the cloned value. If `customizer` returns `undefined`,
 * cloning is handled by the method instead. The `customizer` is invoked with
 * up to four arguments; (value [, index|key, object, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeepWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * }
 *
 * var el = _.cloneWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 0
 */
function cloneWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_SYMBOLS_FLAG$1, customizer);
}

/**
 * Executes the chain sequence and returns the wrapped result.
 *
 * @name commit
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2];
 * var wrapped = _(array).push(3);
 *
 * console.log(array);
 * // => [1, 2]
 *
 * wrapped = wrapped.commit();
 * console.log(array);
 * // => [1, 2, 3]
 *
 * wrapped.last();
 * // => 3
 *
 * console.log(array);
 * // => [1, 2, 3]
 */
function wrapperCommit() {
  return new LodashWrapper(this.value(), this.__chain__);
}

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
    array = arguments[0],
    index = length;
  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  errorTag = '[object Error]',
  mapTag$4 = '[object Map]',
  numberTag$1 = '[object Number]',
  regexpTag$1 = '[object RegExp]',
  setTag$4 = '[object Set]',
  stringTag$1 = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag$4:
      var convert = mapToArray;
    case setTag$4:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$b.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$a.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
    othIsArr = isArray(other),
    objTag = objIsArr ? arrayTag : getTag$1(object),
    othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
    length = result.length;
  while (length--) {
    var key = result[length],
      value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (_typeof(value) == 'object') {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$7 = 'Expected a function';

/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */
function cond(pairs) {
  var length = pairs == null ? 0 : pairs.length,
    toIteratee = baseIteratee;
  pairs = !length ? [] : arrayMap(pairs, function (pair) {
    if (typeof pair[1] != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT$7);
    }
    return [toIteratee(pair[0]), pair[1]];
  });
  return baseRest(function (args) {
    var index = -1;
    while (++index < length) {
      var pair = pairs[index];
      if (apply(pair[0], this, args)) {
        return apply(pair[1], this, args);
      }
    }
  });
}

/**
 * The base implementation of `_.conformsTo` which accepts `props` to check.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 */
function baseConformsTo(object, source, props) {
  var length = props.length;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (length--) {
    var key = props[length],
      predicate = source[key],
      value = object[key];
    if (value === undefined && !(key in object) || !predicate(value)) {
      return false;
    }
  }
  return true;
}

/**
 * The base implementation of `_.conforms` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 */
function baseConforms(source) {
  var props = keys(source);
  return function (object) {
    return baseConformsTo(object, source, props);
  };
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$4 = 1;

/**
 * Creates a function that invokes the predicate properties of `source` with
 * the corresponding property values of a given object, returning `true` if
 * all predicates return truthy, else `false`.
 *
 * **Note:** The created function is equivalent to `_.conformsTo` with
 * `source` partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 2, 'b': 1 },
 *   { 'a': 1, 'b': 2 }
 * ];
 *
 * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
 * // => [{ 'a': 1, 'b': 2 }]
 */
function conforms(source) {
  return baseConforms(baseClone(source, CLONE_DEEP_FLAG$4));
}

/**
 * Checks if `object` conforms to `source` by invoking the predicate
 * properties of `source` with the corresponding property values of `object`.
 *
 * **Note:** This method is equivalent to `_.conforms` when `source` is
 * partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
 * // => true
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
 * // => false
 */
function conformsTo(object, source) {
  return source == null || baseConformsTo(object, source, keys(source));
}

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
      index = fromRight ? length : -1,
      iterable = Object(collection);
    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function (value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function (collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
      accumulator = initializer ? initializer() : {};
    return func(collection, setter, baseIteratee(iteratee), accumulator);
  };
}

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */
var countBy = createAggregator(function (result, value, key) {
  if (hasOwnProperty$8.call(result, key)) {
    ++result[key];
  } else {
    baseAssignValue(result, key, 1);
  }
});

/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = baseCreate(prototype);
  return properties == null ? result : baseAssign(result, properties);
}

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG$1 = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG$1, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_RIGHT_FLAG = 16;

/**
 * This method is like `_.curry` except that arguments are applied to `func`
 * in the manner of `_.partialRight` instead of `_.partial`.
 *
 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curryRight(abc);
 *
 * curried(3)(2)(1);
 * // => [1, 2, 3]
 *
 * curried(2, 3)(1);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(3)(1, _)(2);
 * // => [1, 2, 3]
 */
function curryRight(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curryRight.placeholder;
  return result;
}

// Assign default placeholders.
curryRight.placeholder = {};

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/** Error message constants. */
var FUNC_ERROR_TEXT$6 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$b = Math.max,
  nativeMin$b = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$6);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$b(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin$b(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Util
 * @param {*} value The value to check.
 * @param {*} defaultValue The default value.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * _.defaultTo(1, 10);
 * // => 1
 *
 * _.defaultTo(undefined, 10);
 * // => 10
 */
function defaultTo(value, defaultValue) {
  return value == null || value !== value ? defaultValue : value;
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults$1 = baseRest(function (object, sources) {
  object = Object(object);
  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;
  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }
  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;
    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];
      if (value === undefined || eq(value, objectProto$8[key]) && !hasOwnProperty$7.call(object, key)) {
        object[key] = source[key];
      }
    }
  }
  return object;
});

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }
  if (key == '__proto__') {
    return;
  }
  return object[key];
}

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
    srcValue = safeGet(source, key),
    stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
  var isCommon = newValue === undefined;
  if (isCommon) {
    var isArr = isArray(srcValue),
      isBuff = !isArr && isBuffer(srcValue),
      isTyped = !isArr && !isBuff && isTypedArray(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function (srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function (args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

/** Error message constants. */
var FUNC_ERROR_TEXT$5 = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$5);
  }
  return setTimeout(function () {
    func.apply(undefined, args);
  }, wait);
}

/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = baseRest(function (func, args) {
  return baseDelay(func, 1, args);
});

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function (func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
    includes = arrayIncludes,
    isCommon = true,
    length = array.length,
    result = [],
    valuesLength = values.length;
  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE$1) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer: while (++index < length) {
    var value = array[index],
      computed = iteratee == null ? value : iteratee(value);
    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    } else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function (array, values) {
  return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
});

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = baseRest(function (array, values) {
  var iteratee = last(values);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee)) : [];
});

/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = baseRest(function (array, values) {
  var comparator = last(values);
  if (isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
});

/**
 * Divide two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} dividend The first number in a division.
 * @param {number} divisor The second number in a division.
 * @returns {number} Returns the quotient.
 * @example
 *
 * _.divide(6, 4);
 * // => 1.5
 */
var divide = createMathOperation(function (dividend, divisor) {
  return dividend / divisor;
}, 1);

/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function drop(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = guard || n === undefined ? 1 : toInteger(n);
  return baseSlice(array, n < 0 ? 0 : n, length);
}

/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = guard || n === undefined ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */
function baseWhile(array, predicate, isDrop, fromRight) {
  var length = array.length,
    index = fromRight ? length : -1;
  while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
  return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
}

/**
 * Creates a slice of `array` excluding elements dropped from the end.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.dropRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropRightWhile(users, ['active', false]);
 * // => objects for ['barney']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropRightWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropRightWhile(array, predicate) {
  return array && array.length ? baseWhile(array, baseIteratee(predicate), true, true) : [];
}

/**
 * Creates a slice of `array` excluding elements dropped from the beginning.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.dropWhile(users, function(o) { return !o.active; });
 * // => objects for ['pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropWhile(users, ['active', false]);
 * // => objects for ['pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropWhile(array, predicate) {
  return array && array.length ? baseWhile(array, baseIteratee(predicate), true) : [];
}

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity$1;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

/**
 * A specialized version of `_.forEachRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEachRight(array, iteratee) {
  var length = array == null ? 0 : array.length;
  while (length--) {
    if (iteratee(array[length], length, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

/**
 * This method is like `_.forEach` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @alias eachRight
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEach
 * @example
 *
 * _.forEachRight([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `2` then `1`.
 */
function forEachRight(collection, iteratee) {
  var func = isArray(collection) ? arrayEachRight : baseEachRight;
  return func(collection, castFunction(iteratee));
}

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = toString(string);
  target = baseToString(target);
  var length = string.length;
  position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function (key) {
    return [key, object[key]];
  });
}

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = [value, value];
  });
  return result;
}

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
  setTag$3 = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function (object) {
    var tag = getTag$1(object);
    if (tag == mapTag$3) {
      return mapToArray(object);
    }
    if (tag == setTag$3) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

/**
 * Creates an array of own and inherited enumerable string keyed-value pairs
 * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
 * or set, its entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entriesIn
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairsIn(new Foo);
 * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
 */
var toPairsIn = createToPairs(keysIn);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
  reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
  reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
}

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function (value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate));
}

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$5 = 4294967295;

/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */
function toLength(value) {
  return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH$5) : 0;
}

/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */
function baseFill(array, value, start, end) {
  var length = array.length;
  start = toInteger(start);
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end === undefined || end > length ? length : toInteger(end);
  if (end < 0) {
    end += length;
  }
  end = start > end ? 0 : toLength(end);
  while (start < end) {
    array[start++] = value;
  }
  return array;
}

/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */
function fill(array, value, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
    start = 0;
    end = length;
  }
  return baseFill(array, value, start, end);
}

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function (value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate));
}

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function (collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate);
      collection = keys(collection);
      predicate = function predicate(key) {
        return iteratee(iterable[key], key, iterable);
      };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$a = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex$1(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax$a(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate), index);
}

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex$1);

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function (value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate), baseForOwn);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$9 = Math.max,
  nativeMin$a = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0 ? nativeMax$9(length + index, 0) : nativeMin$a(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate), index, true);
}

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate), baseForOwnRight);
}

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return array && array.length ? array[0] : undefined;
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
    result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMapDeep(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), INFINITY$2);
}

/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDepth([1, 2], duplicate, 2);
 * // => [[1, 1], [2, 2]]
 */
function flatMapDepth(collection, iteratee, depth) {
  depth = depth === undefined ? 1 : toInteger(depth);
  return baseFlatten(map(collection, iteratee), depth);
}

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, INFINITY$1) : [];
}

/**
 * Recursively flatten `array` up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * var array = [1, [2, [3, [4]], 5]];
 *
 * _.flattenDepth(array, 1);
 * // => [1, 2, [3, [4]], 5]
 *
 * _.flattenDepth(array, 2);
 * // => [1, 2, 3, [4], 5]
 */
function flattenDepth(array, depth) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  depth = depth === undefined ? 1 : toInteger(depth);
  return baseFlatten(array, depth);
}

/** Used to compose bitmasks for function metadata. */
var WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that invokes `func` with arguments reversed.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to flip arguments for.
 * @returns {Function} Returns the new flipped function.
 * @example
 *
 * var flipped = _.flip(function() {
 *   return _.toArray(arguments);
 * });
 *
 * flipped('a', 'b', 'c', 'd');
 * // => ['d', 'c', 'b', 'a']
 */
function flip(func) {
  return createWrap(func, WRAP_FLIP_FLAG);
}

/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */
var floor = createRound('floor');

/** Error message constants. */
var FUNC_ERROR_TEXT$4 = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
  WRAP_PARTIAL_FLAG$1 = 32,
  WRAP_ARY_FLAG = 128,
  WRAP_REARG_FLAG$1 = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function (funcs) {
    var length = funcs.length,
      index = length,
      prereq = LodashWrapper.prototype.thru;
    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT$4);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];
      var funcName = getFuncName(func),
        data = funcName == 'wrapper' ? getData(func) : undefined;
      if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG$1 | WRAP_REARG_FLAG$1) && !data[4].length && data[9] == 1) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
      }
    }
    return function () {
      var args = arguments,
        value = args[0];
      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
        result = length ? funcs[index].apply(this, args) : value;
      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null ? object : baseFor(object, castFunction(iteratee), keysIn);
}

/**
 * This method is like `_.forIn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forInRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
 */
function forInRight(object, iteratee) {
  return object == null ? object : baseForRight(object, castFunction(iteratee), keysIn);
}

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

/**
 * This method is like `_.forOwn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwnRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
 */
function forOwnRight(object, iteratee) {
  return object && baseForOwnRight(object, castFunction(iteratee));
}

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
    length = pairs == null ? 0 : pairs.length,
    result = {};
  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

/**
 * The base implementation of `_.functions` which creates an array of
 * `object` function property names filtered from `props`.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} props The property names to filter.
 * @returns {Array} Returns the function names.
 */
function baseFunctions(object, props) {
  return arrayFilter(props, function (key) {
    return isFunction(object[key]);
  });
}

/**
 * Creates an array of function property names from own enumerable properties
 * of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functionsIn
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functions(new Foo);
 * // => ['a', 'b']
 */
function functions(object) {
  return object == null ? [] : baseFunctions(object, keys(object));
}

/**
 * Creates an array of function property names from own and inherited
 * enumerable properties of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functions
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functionsIn(new Foo);
 * // => ['a', 'b', 'c']
 */
function functionsIn(object) {
  return object == null ? [] : baseFunctions(object, keysIn(object));
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function (result, value, key) {
  if (hasOwnProperty$6.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

/**
 * Creates a function that performs a relational operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @returns {Function} Returns the new relational operation function.
 */
function createRelationalOperation(operator) {
  return function (value, other) {
    if (!(typeof value == 'string' && typeof other == 'string')) {
      value = toNumber(value);
      other = toNumber(other);
    }
    return operator(value, other);
  };
}

/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 * @see _.lt
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
var gt = createRelationalOperation(baseGt);

/**
 * Checks if `value` is greater than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than or equal to
 *  `other`, else `false`.
 * @see _.lte
 * @example
 *
 * _.gte(3, 1);
 * // => true
 *
 * _.gte(3, 3);
 * // => true
 *
 * _.gte(1, 3);
 * // => false
 */
var gte = createRelationalOperation(function (value, other) {
  return value >= other;
});

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty$5.call(object, key);
}

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$8 = Math.max,
  nativeMin$9 = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin$9(start, end) && number < nativeMax$8(start, end);
}

/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = toFinite(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = toFinite(end);
  }
  number = toNumber(number);
  return baseInRange(number, start, end);
}

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$7 = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax$7(length + fromIndex, 0);
  }
  return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$6 = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax$6(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */
function initial(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 0, -1) : [];
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$8 = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
    length = arrays[0].length,
    othLength = arrays.length,
    othIndex = othLength,
    caches = Array(othLength),
    maxLength = Infinity,
    result = [];
  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin$8(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
  }
  array = arrays[0];
  var index = -1,
    seen = caches[0];
  outer: while (++index < length && result.length < maxLength) {
    var value = array[index],
      computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;
    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function (arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});

/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = baseRest(function (arrays) {
  var iteratee = last(arrays),
    mapped = arrayMap(arrays, castArrayLikeObject);
  if (iteratee === last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, baseIteratee(iteratee)) : [];
});

/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = baseRest(function (arrays) {
  var comparator = last(arrays),
    mapped = arrayMap(arrays, castArrayLikeObject);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
});

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function (value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function (object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$5.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function (result, value, key) {
  if (value != null && typeof value.toString != 'function') {
    value = nativeObjectToString$1.call(value);
  }
  result[value] = key;
}, constant(identity$1));

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$4.toString;

/**
 * This method is like `_.invert` except that the inverted object is generated
 * from the results of running each element of `object` thru `iteratee`. The
 * corresponding inverted value of each inverted key is an array of keys
 * responsible for generating the inverted value. The iteratee is invoked
 * with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Object
 * @param {Object} object The object to invert.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invertBy(object);
 * // => { '1': ['a', 'c'], '2': ['b'] }
 *
 * _.invertBy(object, function(value) {
 *   return 'group' + value;
 * });
 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
 */
var invertBy = createInverter(function (result, value, key) {
  if (value != null && typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }
  if (hasOwnProperty$4.call(result, value)) {
    result[value].push(key);
  } else {
    result[value] = [key];
  }
}, baseIteratee);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = baseRest(baseInvoke);

/**
 * Invokes the method at `path` of each element in `collection`, returning
 * an array of the results of each invoked method. Any additional arguments
 * are provided to each invoked method. If `path` is a function, it's invoked
 * for, and `this` bound to, each element in `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array|Function|string} path The path of the method to invoke or
 *  the function invoked per iteration.
 * @param {...*} [args] The arguments to invoke each method with.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
 * // => [[1, 5, 7], [1, 2, 3]]
 *
 * _.invokeMap([123, 456], String.prototype.split, '');
 * // => [['1', '2', '3'], ['4', '5', '6']]
 */
var invokeMap = baseRest(function (collection, path, args) {
  var index = -1,
    isFunc = typeof path == 'function',
    result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function (value) {
    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
  });
  return result;
});

var arrayBufferTag = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
}

/* Node.js helper references. */
var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer;

/**
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 * @example
 *
 * _.isArrayBuffer(new ArrayBuffer(2));
 * // => true
 *
 * _.isArrayBuffer(new Array(2));
 * // => false
 */
var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
}

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
  setTag$2 = '[object Set]';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag$2 || tag == setTag$2) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$3.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual$1(value, other) {
  return baseIsEqual(value, other);
}

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite$1(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || baseIsMatch(object, source, getMatchData(source));
}

/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */
function isMatchWith(object, source, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseIsMatch(object, source, getMatchData(source), customizer);
}

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
}

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN$1(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

/**
 * Checks if `func` is capable of being masked.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
 */
var isMaskable = coreJsData ? isFunction : stubFalse;

/** Error message constants. */
var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.';

/**
 * Checks if `value` is a pristine native function.
 *
 * **Note:** This method can't reliably detect native functions in the presence
 * of the core-js package because core-js circumvents this kind of detection.
 * Despite multiple requests, the core-js maintainer has made it clear: any
 * attempt to fix the detection will be obstructed. As a result, we're left
 * with little choice but to throw an error. Unfortunately, this also affects
 * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
 * which rely on core-js.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (isMaskable(value)) {
    throw new Error(CORE_ERROR_TEXT);
  }
  return baseIsNative(value);
}

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$3 = 9007199254740991;

/**
 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
 * double precision number which isn't the result of a rounded unsafe integer.
 *
 * **Note:** This method is based on
 * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
 * @example
 *
 * _.isSafeInteger(3);
 * // => true
 *
 * _.isSafeInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isSafeInteger(Infinity);
 * // => false
 *
 * _.isSafeInteger('3');
 * // => false
 */
function isSafeInteger(value) {
  return isInteger(value) && value >= -MAX_SAFE_INTEGER$3 && value <= MAX_SAFE_INTEGER$3;
}

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag$1(value) == weakMapTag;
}

/** `Object#toString` result references. */
var weakSetTag = '[object WeakSet]';

/**
 * Checks if `value` is classified as a `WeakSet` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
 * @example
 *
 * _.isWeakSet(new WeakSet);
 * // => true
 *
 * _.isWeakSet(new Set);
 * // => false
 */
function isWeakSet(value) {
  return isObjectLike(value) && baseGetTag(value) == weakSetTag;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$3 = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG$3));
}

/** Used for built-in method references. */
var arrayProto$4 = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto$4.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function (result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function (result, value, key) {
  baseAssignValue(result, key, value);
});

/**
 * A specialized version of `_.lastIndexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictLastIndexOf(array, value, fromIndex) {
  var index = fromIndex + 1;
  while (index--) {
    if (array[index] === value) {
      return index;
    }
  }
  return index;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$5 = Math.max,
  nativeMin$7 = Math.min;

/**
 * This method is like `_.indexOf` except that it iterates over elements of
 * `array` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.lastIndexOf([1, 2, 1, 2], 2);
 * // => 3
 *
 * // Search from the `fromIndex`.
 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
 * // => 1
 */
function lastIndexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = index < 0 ? nativeMax$5(length + index, 0) : nativeMin$7(index, length - 1);
  }
  return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
}

/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */
var lowerCase = createCompounder(function (result, word, index) {
  return result + (index ? ' ' : '') + word.toLowerCase();
});

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

/**
 * Checks if `value` is less than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 * @see _.gt
 * @example
 *
 * _.lt(1, 3);
 * // => true
 *
 * _.lt(3, 3);
 * // => false
 *
 * _.lt(3, 1);
 * // => false
 */
var lt = createRelationalOperation(baseLt);

/**
 * Checks if `value` is less than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than or equal to
 *  `other`, else `false`.
 * @see _.gte
 * @example
 *
 * _.lte(1, 3);
 * // => true
 *
 * _.lte(3, 3);
 * // => true
 *
 * _.lte(3, 1);
 * // => false
 */
var lte = createRelationalOperation(function (value, other) {
  return value <= other;
});

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);
  baseForOwn(object, function (value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues$1(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);
  baseForOwn(object, function (value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$2 = 1;

/**
 * Creates a function that performs a partial deep comparison between a given
 * object and `source`, returning `true` if the given object has equivalent
 * property values, else `false`.
 *
 * **Note:** The created function is equivalent to `_.isMatch` with `source`
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
 * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */
function matches(source) {
  return baseMatches(baseClone(source, CLONE_DEEP_FLAG$2));
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1;

/**
 * Creates a function that performs a partial deep comparison between the
 * value at `path` of a given object to `srcValue`, returning `true` if the
 * object value is equivalent, else `false`.
 *
 * **Note:** Partial comparisons will match empty array and empty object
 * `srcValue` values against any array or object value, respectively. See
 * `_.isEqual` for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.find(objects, _.matchesProperty('a', 4));
 * // => { 'a': 4, 'b': 5, 'c': 6 }
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */
function matchesProperty(path, srcValue) {
  return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG$1));
}

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
    length = array.length;
  while (++index < length) {
    var value = array[index],
      current = iteratee(value);
    if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) {
      var computed = current,
        result = value;
    }
  }
  return result;
}

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return array && array.length ? baseExtremum(array, identity$1, baseGt) : undefined;
}

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return array && array.length ? baseExtremum(array, baseIteratee(iteratee), baseGt) : undefined;
}

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
    index = -1,
    length = array.length;
  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : result + current;
    }
  }
  return result;
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */
function baseMean(array, iteratee) {
  var length = array == null ? 0 : array.length;
  return length ? baseSum(array, iteratee) / length : NAN;
}

/**
 * Computes the mean of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the mean.
 * @example
 *
 * _.mean([4, 2, 8, 6]);
 * // => 5
 */
function mean(array) {
  return baseMean(array, identity$1);
}

/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */
function meanBy(array, iteratee) {
  return baseMean(array, baseIteratee(iteratee));
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that invokes the method at `path` of a given object.
 * Any additional arguments are provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': _.constant(2) } },
 *   { 'a': { 'b': _.constant(1) } }
 * ];
 *
 * _.map(objects, _.method('a.b'));
 * // => [2, 1]
 *
 * _.map(objects, _.method(['a', 'b']));
 * // => [2, 1]
 */
var method = baseRest(function (path, args) {
  return function (object) {
    return baseInvoke(object, path, args);
  };
});

/**
 * The opposite of `_.method`; this method creates a function that invokes
 * the method at a given path of `object`. Any additional arguments are
 * provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Object} object The object to query.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var array = _.times(3, _.constant),
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.methodOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
 * // => [2, 0]
 */
var methodOf = baseRest(function (object, args) {
  return function (path) {
    return baseInvoke(object, path, args);
  };
});

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return array && array.length ? baseExtremum(array, identity$1, baseLt) : undefined;
}

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return array && array.length ? baseExtremum(array, baseIteratee(iteratee), baseLt) : undefined;
}

/**
 * Adds all own enumerable string keyed function properties of a source
 * object to the destination object. If `object` is a function, then methods
 * are added to its prototype as well.
 *
 * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
 * avoid conflicts caused by modifying the original.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Function|Object} [object=lodash] The destination object.
 * @param {Object} source The object of functions to add.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
 * @returns {Function|Object} Returns `object`.
 * @example
 *
 * function vowels(string) {
 *   return _.filter(string, function(v) {
 *     return /[aeiou]/i.test(v);
 *   });
 * }
 *
 * _.mixin({ 'vowels': vowels });
 * _.vowels('fred');
 * // => ['e']
 *
 * _('fred').vowels().value();
 * // => ['e']
 *
 * _.mixin({ 'vowels': vowels }, { 'chain': false });
 * _('fred').vowels();
 * // => ['e']
 */
function mixin$1(object, source, options) {
  var props = keys(source),
    methodNames = baseFunctions(source, props);
  var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
    isFunc = isFunction(object);
  arrayEach(methodNames, function (methodName) {
    var func = source[methodName];
    object[methodName] = func;
    if (isFunc) {
      object.prototype[methodName] = function () {
        var chainAll = this.__chain__;
        if (chain || chainAll) {
          var result = object(this.__wrapped__),
            actions = result.__actions__ = copyArray(this.__actions__);
          actions.push({
            'func': func,
            'args': arguments,
            'thisArg': object
          });
          result.__chain__ = chainAll;
          return result;
        }
        return func.apply(object, arrayPush([this.value()], arguments));
      };
    }
  });
  return object;
}

/**
 * Multiply two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} multiplier The first number in a multiplication.
 * @param {number} multiplicand The second number in a multiplication.
 * @returns {number} Returns the product.
 * @example
 *
 * _.multiply(6, 4);
 * // => 24
 */
var multiply = createMathOperation(function (multiplier, multiplicand) {
  return multiplier * multiplicand;
}, 1);

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  return function () {
    var args = arguments;
    switch (args.length) {
      case 0:
        return !predicate.call(this);
      case 1:
        return !predicate.call(this, args[0]);
      case 2:
        return !predicate.call(this, args[0], args[1]);
      case 3:
        return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
    result = [];
  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
  setTag$1 = '[object Set]';

/** Built-in value references. */
var symIterator$1 = _Symbol ? _Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray$1(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator$1 && value[symIterator$1]) {
    return iteratorToArray(value[symIterator$1]());
  }
  var tag = getTag$1(value),
    func = tag == mapTag$1 ? mapToArray : tag == setTag$1 ? setToArray : values;
  return func(value);
}

/**
 * Gets the next value on a wrapped object following the
 * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
 *
 * @name next
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the next iterator value.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 1 }
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 2 }
 *
 * wrapped.next();
 * // => { 'done': true, 'value': undefined }
 */
function wrapperNext() {
  if (this.__values__ === undefined) {
    this.__values__ = toArray$1(this.value());
  }
  var done = this.__index__ >= this.__values__.length,
    value = done ? undefined : this.__values__[this.__index__++];
  return {
    'done': done,
    'value': value
  };
}

/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return isIndex(n, length) ? array[n] : undefined;
}

/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return array && array.length ? baseNth(array, toInteger(n)) : undefined;
}

/**
 * Creates a function that gets the argument at index `n`. If `n` is negative,
 * the nth argument from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [n=0] The index of the argument to return.
 * @returns {Function} Returns the new pass-thru function.
 * @example
 *
 * var func = _.nthArg(1);
 * func('a', 'b', 'c', 'd');
 * // => 'b'
 *
 * var func = _.nthArg(-2);
 * func('a', 'b', 'c', 'd');
 * // => 'c'
 */
function nthArg(n) {
  n = toInteger(n);
  return baseRest(function (args) {
    return baseNth(args, n);
  });
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function (object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function (path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
    length = paths.length,
    result = {};
  while (++index < length) {
    var path = paths[index],
      value = baseGet(object, path);
    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function (prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function (value, path) {
    return predicate(value, path[0]);
  });
}

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once$1(func) {
  return before(2, func);
}

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;
  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
      valIsNull = value === null,
      valIsReflexive = value === value,
      valIsSymbol = isSymbol(value);
    var othIsDefined = other !== undefined,
      othIsNull = other === null,
      othIsReflexive = other === other,
      othIsSymbol = isSymbol(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
    objCriteria = object.criteria,
    othCriteria = other.criteria,
    length = objCriteria.length,
    ordersLength = orders.length;
  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function (iteratee) {
      if (isArray(iteratee)) {
        return function (value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$1];
  }
  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
  var result = baseMap(collection, function (value, key, collection) {
    var criteria = arrayMap(iteratees, function (iteratee) {
      return iteratee(value);
    });
    return {
      'criteria': criteria,
      'index': ++index,
      'value': value
    };
  });
  return baseSortBy(result, function (object, other) {
    return compareMultiple(object, other, orders);
  });
}

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */
function createOver(arrayFunc) {
  return flatRest(function (iteratees) {
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    return baseRest(function (args) {
      var thisArg = this;
      return arrayFunc(iteratees, function (iteratee) {
        return apply(iteratee, thisArg, args);
      });
    });
  });
}

/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */
var over = createOver(arrayMap);

/**
 * A `baseRest` alias which can be replaced with `identity` by module
 * replacement plugins.
 *
 * @private
 * @type {Function}
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
var castRest = baseRest;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$6 = Math.min;

/**
 * Creates a function that invokes `func` with its arguments transformed.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Function
 * @param {Function} func The function to wrap.
 * @param {...(Function|Function[])} [transforms=[_.identity]]
 *  The argument transforms.
 * @returns {Function} Returns the new function.
 * @example
 *
 * function doubled(n) {
 *   return n * 2;
 * }
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var func = _.overArgs(function(x, y) {
 *   return [x, y];
 * }, [square, doubled]);
 *
 * func(9, 3);
 * // => [81, 6]
 *
 * func(10, 5);
 * // => [100, 10]
 */
var overArgs = castRest(function (func, transforms) {
  transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(baseIteratee)) : arrayMap(baseFlatten(transforms, 1), baseUnary(baseIteratee));
  var funcsLength = transforms.length;
  return baseRest(function (args) {
    var index = -1,
      length = nativeMin$6(args.length, funcsLength);
    while (++index < length) {
      args[index] = transforms[index].call(this, args[index]);
    }
    return apply(func, this, args);
  });
});

/**
 * Creates a function that checks if **all** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * Following shorthands are possible for providing predicates.
 * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
 * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overEvery([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => false
 *
 * func(NaN);
 * // => false
 */
var overEvery = createOver(arrayEvery);

/**
 * Creates a function that checks if **any** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * Following shorthands are possible for providing predicates.
 * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
 * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overSome([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => true
 *
 * func(NaN);
 * // => false
 *
 * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
 * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
 */
var overSome = createOver(arraySome);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor$3 = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER$2) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor$3(n / 2);
    if (n) {
      string += string;
    }
  } while (n);
  return result;
}

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

/** Used to compose unicode character classes. */
var rsAstralRange = "\\ud800-\\udfff",
  rsComboMarksRange = "\\u0300-\\u036f",
  reComboHalfMarksRange = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange = "\\u20d0-\\u20ff",
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = "\\ufe0e\\ufe0f";

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
  rsCombo = '[' + rsComboRange + ']',
  rsFitz = "\\ud83c[\\udffb-\\udfff]",
  rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
  rsNonAstral = '[^' + rsAstralRange + ']',
  rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  rsZWJ = "\\u200d";

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
  rsOptVar = '[' + rsVarRange + ']?',
  rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
  rsSeq = rsOptVar + reOptMod + rsOptJoin,
  rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil$2 = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString(chars);
  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil$2(length / stringSize(chars)));
  return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil$1 = Math.ceil,
  nativeFloor$2 = Math.floor;

/**
 * Pads `string` on the left and right sides if it's shorter than `length`.
 * Padding characters are truncated if they can't be evenly divided by `length`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.pad('abc', 8);
 * // => '  abc   '
 *
 * _.pad('abc', 8, '_-');
 * // => '_-abc_-_'
 *
 * _.pad('abc', 3);
 * // => 'abc'
 */
function pad(string, length, chars) {
  string = toString(string);
  length = toInteger(length);
  var strLength = length ? stringSize(string) : 0;
  if (!length || strLength >= length) {
    return string;
  }
  var mid = (length - strLength) / 2;
  return createPadding(nativeFloor$2(mid), chars) + string + createPadding(nativeCeil$1(mid), chars);
}

/**
 * Pads `string` on the right side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padEnd('abc', 6);
 * // => 'abc   '
 *
 * _.padEnd('abc', 6, '_-');
 * // => 'abc_-_'
 *
 * _.padEnd('abc', 3);
 * // => 'abc'
 */
function padEnd(string, length, chars) {
  string = toString(string);
  length = toInteger(length);
  var strLength = length ? stringSize(string) : 0;
  return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
}

/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = toString(string);
  length = toInteger(length);
  var strLength = length ? stringSize(string) : 0;
  return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
}

/** Used to match leading whitespace. */
var reTrimStart$1 = /^\s+/;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeParseInt = root.parseInt;

/**
 * Converts `string` to an integer of the specified radix. If `radix` is
 * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
 * hexadecimal, in which case a `radix` of `16` is used.
 *
 * **Note:** This method aligns with the
 * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category String
 * @param {string} string The string to convert.
 * @param {number} [radix=10] The radix to interpret `value` by.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.parseInt('08');
 * // => 8
 *
 * _.map(['6', '08', '10'], _.parseInt);
 * // => [6, 8, 10]
 */
function parseInt$1(string, radix, guard) {
  if (guard || radix == null) {
    radix = 0;
  } else if (radix) {
    radix = +radix;
  }
  return nativeParseInt(toString(string).replace(reTrimStart$1, ''), radix || 0);
}

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function (func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = baseRest(function (func, partials) {
  var holders = replaceHolders(partials, getHolder(partialRight));
  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = createAggregator(function (result, value, key) {
  result[key ? 0 : 1].push(value);
}, function () {
  return [[], []];
});

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});

/**
 * Creates a clone of the chain sequence planting `value` as the wrapped value.
 *
 * @name plant
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @param {*} value The value to plant.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2]).map(square);
 * var other = wrapped.plant([3, 4]);
 *
 * other.value();
 * // => [9, 16]
 *
 * wrapped.value();
 * // => [1, 4]
 */
function wrapperPlant(value) {
  var result,
    parent = this;
  while (parent instanceof baseLodash) {
    var clone = wrapperClone(parent);
    clone.__index__ = 0;
    clone.__values__ = undefined;
    if (result) {
      previous.__wrapped__ = clone;
    } else {
      result = clone;
    }
    var previous = clone;
    parent = parent.__wrapped__;
  }
  previous.__wrapped__ = value;
  return result;
}

/**
 * The opposite of `_.property`; this method creates a function that returns
 * the value at a given path of `object`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var array = [0, 1, 2],
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
 * // => [2, 0]
 */
function propertyOf(object) {
  return function (path) {
    return object == null ? undefined : baseGet(object, path);
  };
}

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
    length = array.length;
  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto$3 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$3.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
    index = -1,
    length = values.length,
    seen = array;
  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap(array, baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
      value = values[index],
      computed = iteratee ? iteratee(value) : value;
    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice$1.call(seen, fromIndex, 1);
      }
      splice$1.call(array, fromIndex, 1);
    }
  }
  return array;
}

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return array && array.length && values && values.length ? basePullAll(array, values) : array;
}

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

/**
 * This method is like `_.pullAll` except that it accepts `iteratee` which is
 * invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The iteratee is invoked with one argument: (value).
 *
 * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
 *
 * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
 * console.log(array);
 * // => [{ 'x': 2 }]
 */
function pullAllBy(array, values, iteratee) {
  return array && array.length && values && values.length ? basePullAll(array, values, baseIteratee(iteratee)) : array;
}

/**
 * This method is like `_.pullAll` except that it accepts `comparator` which
 * is invoked to compare elements of `array` to `values`. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
 *
 * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
 * console.log(array);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
 */
function pullAllWith(array, values, comparator) {
  return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
}

/** Used for built-in method references. */
var arrayProto$2 = Array.prototype;

/** Built-in value references. */
var splice = arrayProto$2.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
    lastIndex = length - 1;
  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

/**
 * Removes elements from `array` corresponding to `indexes` and returns an
 * array of removed elements.
 *
 * **Note:** Unlike `_.at`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...(number|number[])} [indexes] The indexes of elements to remove.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 * var pulled = _.pullAt(array, [1, 3]);
 *
 * console.log(array);
 * // => ['a', 'c']
 *
 * console.log(pulled);
 * // => ['b', 'd']
 */
var pullAt = flatRest(function (array, indexes) {
  var length = array == null ? 0 : array.length,
    result = baseAt(array, indexes);
  basePullAt(array, arrayMap(indexes, function (index) {
    return isIndex(index, length) ? +index : index;
  }).sort(compareAscending));
  return result;
});

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor$1 = Math.floor,
  nativeRandom$1 = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor$1(nativeRandom$1() * (upper - lower + 1));
}

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$5 = Math.min,
  nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    } else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  } else {
    lower = toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin$5(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
  }
  return baseRandom(lower, upper);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
  nativeMax$4 = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
    length = nativeMax$4(nativeCeil((end - start) / (step || 1)), 0),
    result = Array(length);
  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function (start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

/**
 * This method is like `_.range` except that it populates values in
 * descending order.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.range
 * @example
 *
 * _.rangeRight(4);
 * // => [3, 2, 1, 0]
 *
 * _.rangeRight(-4);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 5);
 * // => [4, 3, 2, 1]
 *
 * _.rangeRight(0, 20, 5);
 * // => [15, 10, 5, 0]
 *
 * _.rangeRight(0, -4, -1);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.rangeRight(0);
 * // => []
 */
var rangeRight = createRange(true);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function (func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function (value, index, collection) {
    accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
    initAccum = arguments.length < 3;
  return func(collection, baseIteratee(iteratee), accumulator, initAccum, baseEach);
}

/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduceRight(array, iteratee, accumulator, initAccum) {
  var length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[--length];
  }
  while (length--) {
    accumulator = iteratee(accumulator, array[length], length, array);
  }
  return accumulator;
}

/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduce
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */
function reduceRight(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduceRight : baseReduce,
    initAccum = arguments.length < 3;
  return func(collection, baseIteratee(iteratee), accumulator, initAccum, baseEachRight);
}

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate)));
}

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
    indexes = [],
    length = array.length;
  predicate = baseIteratee(predicate);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

/**
 * Repeats the given string `n` times.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to repeat.
 * @param {number} [n=1] The number of times to repeat the string.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the repeated string.
 * @example
 *
 * _.repeat('*', 3);
 * // => '***'
 *
 * _.repeat('abc', 2);
 * // => 'abcabc'
 *
 * _.repeat('abc', 0);
 * // => ''
 */
function repeat(string, n, guard) {
  if (guard ? isIterateeCall(string, n, guard) : n === undefined) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  return baseRepeat(toString(string), n);
}

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
    string = toString(args[0]);
  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as
 * an array.
 *
 * **Note:** This method is based on the
 * [rest parameter](https://mdn.io/rest_parameters).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.rest(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function rest(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  start = start === undefined ? start : toInteger(start);
  return baseRest(func, start);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = castPath(path, object);
  var index = -1,
    length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    length = 1;
    object = undefined;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeReverse = arrayProto$1.reverse;

/**
 * Reverses `array` so that the first element becomes the last, the second
 * element becomes the second to last, and so on.
 *
 * **Note:** This method mutates `array` and is based on
 * [`Array#reverse`](https://mdn.io/Array/reverse).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.reverse(array);
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function reverse(array) {
  return array == null ? array : nativeReverse.call(array);
}

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[baseRandom(0, length - 1)] : undefined;
}

/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return arraySample(values(collection));
}

/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = isArray(collection) ? arraySample : baseSample;
  return func(collection);
}

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
    length = array.length,
    lastIndex = length - 1;
  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
      value = array[rand];
    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if (guard ? isIterateeCall(collection, n, guard) : n === undefined) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
  return func(collection, n);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseSet(object, path, value, customizer);
}

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

/** `Object#toString` result references. */
var mapTag = '[object Map]',
  setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag$1(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  } else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function (result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;
  baseEach(collection, function (value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate));
}

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function (collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$4 = 4294967295,
  MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH$4 - 1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
  nativeMin$4 = Math.min;

/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndexBy(array, value, iteratee, retHighest) {
  var low = 0,
    high = array == null ? 0 : array.length;
  if (high === 0) {
    return 0;
  }
  value = iteratee(value);
  var valIsNaN = value !== value,
    valIsNull = value === null,
    valIsSymbol = isSymbol(value),
    valIsUndefined = value === undefined;
  while (low < high) {
    var mid = nativeFloor((low + high) / 2),
      computed = iteratee(array[mid]),
      othIsDefined = computed !== undefined,
      othIsNull = computed === null,
      othIsReflexive = computed === computed,
      othIsSymbol = isSymbol(computed);
    if (valIsNaN) {
      var setLow = retHighest || othIsReflexive;
    } else if (valIsUndefined) {
      setLow = othIsReflexive && (retHighest || othIsDefined);
    } else if (valIsNull) {
      setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
    } else if (valIsSymbol) {
      setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
    } else if (othIsNull || othIsSymbol) {
      setLow = false;
    } else {
      setLow = retHighest ? computed <= value : computed < value;
    }
    if (setLow) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return nativeMin$4(high, MAX_ARRAY_INDEX);
}

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$3 = 4294967295,
  HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH$3 >>> 1;

/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndex(array, value, retHighest) {
  var low = 0,
    high = array == null ? low : array.length;
  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
    while (low < high) {
      var mid = low + high >>> 1,
        computed = array[mid];
      if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return high;
  }
  return baseSortedIndexBy(array, value, identity$1, retHighest);
}

/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */
function sortedIndex(array, value) {
  return baseSortedIndex(array, value);
}

/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */
function sortedIndexBy(array, value, iteratee) {
  return baseSortedIndexBy(array, value, baseIteratee(iteratee));
}

/**
 * This method is like `_.indexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
 * // => 1
 */
function sortedIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = baseSortedIndex(array, value);
    if (index < length && eq(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/**
 * This method is like `_.sortedIndex` except that it returns the highest
 * index at which `value` should be inserted into `array` in order to
 * maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
 * // => 4
 */
function sortedLastIndex(array, value) {
  return baseSortedIndex(array, value, true);
}

/**
 * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 1
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
 * // => 1
 */
function sortedLastIndexBy(array, value, iteratee) {
  return baseSortedIndexBy(array, value, baseIteratee(iteratee), true);
}

/**
 * This method is like `_.lastIndexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
 * // => 3
 */
function sortedLastIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = baseSortedIndex(array, value, true) - 1;
    if (eq(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
  var index = -1,
    length = array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index],
      computed = iteratee ? iteratee(value) : value;
    if (!index || !eq(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}

/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */
function sortedUniq(array) {
  return array && array.length ? baseSortedUniq(array) : [];
}

/**
 * This method is like `_.uniqBy` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
 * // => [1.1, 2.3]
 */
function sortedUniqBy(array, iteratee) {
  return array && array.length ? baseSortedUniq(array, baseIteratee(iteratee)) : [];
}

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$2 = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH$2 : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * create function and an array of arguments much like
 * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
 *
 * **Note:** This method is based on the
 * [spread operator](https://mdn.io/spread_operator).
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Function
 * @param {Function} func The function to spread arguments over.
 * @param {number} [start=0] The start position of the spread.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.spread(function(who, what) {
 *   return who + ' says ' + what;
 * });
 *
 * say(['fred', 'hello']);
 * // => 'fred says hello'
 *
 * var numbers = Promise.all([
 *   Promise.resolve(40),
 *   Promise.resolve(36)
 * ]);
 *
 * numbers.then(_.spread(function(x, y) {
 *   return x + y;
 * }));
 * // => a Promise of 76
 */
function spread(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  start = start == null ? 0 : nativeMax$3(toInteger(start), 0);
  return baseRest(function (args) {
    var array = args[start],
      otherArgs = castSlice(args, 0, start);
    if (array) {
      arrayPush(otherArgs, array);
    }
    return apply(func, this, otherArgs);
  });
}

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function (result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

/**
 * This method returns a new empty object.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Object} Returns the new empty object.
 * @example
 *
 * var objects = _.times(2, _.stubObject);
 *
 * console.log(objects);
 * // => [{}, {}]
 *
 * console.log(objects[0] === objects[1]);
 * // => false
 */
function stubObject() {
  return {};
}

/**
 * This method returns an empty string.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {string} Returns the empty string.
 * @example
 *
 * _.times(2, _.stubString);
 * // => ['', '']
 */
function stubString() {
  return '';
}

/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

/**
 * Subtract two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {number} minuend The first number in a subtraction.
 * @param {number} subtrahend The second number in a subtraction.
 * @returns {number} Returns the difference.
 * @example
 *
 * _.subtract(6, 4);
 * // => 2
 */
var subtract = createMathOperation(function (minuend, subtrahend) {
  return minuend - subtrahend;
}, 0);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return array && array.length ? baseSum(array, identity$1) : 0;
}

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return array && array.length ? baseSum(array, baseIteratee(iteratee)) : 0;
}

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 1, length) : [];
}

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = guard || n === undefined ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = guard || n === undefined ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, n < 0 ? 0 : n, length);
}

/**
 * Creates a slice of `array` with elements taken from the end. Elements are
 * taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.takeRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeRightWhile(users, ['active', false]);
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeRightWhile(users, 'active');
 * // => []
 */
function takeRightWhile(array, predicate) {
  return array && array.length ? baseWhile(array, baseIteratee(predicate), false, true) : [];
}

/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */
function takeWhile(array, predicate) {
  return array && array.length ? baseWhile(array, baseIteratee(predicate)) : [];
}

/**
 * This method invokes `interceptor` and returns `value`. The interceptor
 * is invoked with one argument; (value). The purpose of this method is to
 * "tap into" a method chain sequence in order to modify intermediate results.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns `value`.
 * @example
 *
 * _([1, 2, 3])
 *  .tap(function(array) {
 *    // Mutate input array.
 *    array.pop();
 *  })
 *  .reverse()
 *  .value();
 * // => [2, 1]
 */
function tap(value, interceptor) {
  interceptor(value);
  return value;
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto$2[key]) && !hasOwnProperty$2.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  "\u2028": 'u2028',
  "\u2029": 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
 * following template settings to use alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {
  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,
  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,
  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,
  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',
  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {
    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': {
      'escape': escape
    }
  }
};

/** Error message constants. */
var INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
  reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
  reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to validate the `validate` option in `_.template` variable.
 *
 * Forbids characters which could potentially change the meaning of the function argument definition:
 * - "()," (modification of function parameters)
 * - "=" (default value)
 * - "[]{}" (destructuring of function parameters)
 * - "/" (beginning of a comment)
 * - whitespace
 */
var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES template literal delimiter as an "interpolate" delimiter.
 * // Disable support by replacing the "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;
  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, customDefaultsAssignIn);
  var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
    importsKeys = keys(imports),
    importsValues = baseValues(imports, importsKeys);
  var isEscaping,
    isEvaluating,
    index = 0,
    interpolate = options.interpolate || reNoMatch,
    source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

  // Use a sourceURL for easier debugging.
  // The sourceURL gets injected into the source that's eval-ed, so be careful
  // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
  // and escape the comment, thus injecting code that gets evaled.
  var sourceURL = hasOwnProperty$1.call(options, 'sourceURL') ? '//# sourceURL=' + (options.sourceURL + '').replace(/\s/g, ' ') + '\n' : '';
  string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });
  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = hasOwnProperty$1.call(options, 'variable') && options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Throw an error if a forbidden character was found in `variable`, to prevent
  // potential command injection attacks.
  else if (reForbiddenIdentifierChars.test(variable)) {
    throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
  }

  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
  var result = attempt(function () {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * This method is like `_.tap` except that it returns the result of `interceptor`.
 * The purpose of this method is to "pass thru" values replacing intermediate
 * results in a method chain sequence.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns the result of `interceptor`.
 * @example
 *
 * _('  abc  ')
 *  .chain()
 *  .trim()
 *  .thru(function(value) {
 *    return [value];
 *  })
 *  .value();
 * // => ['abc']
 */
function thru(value, interceptor) {
  return interceptor(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$1 = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$3 = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER$1) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH$1,
    length = nativeMin$3(n, MAX_ARRAY_LENGTH$1);
  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH$1;
  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

/**
 * Enables the wrapper to be iterable.
 *
 * @name Symbol.iterator
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the wrapper object.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped[Symbol.iterator]() === wrapped;
 * // => true
 *
 * Array.from(wrapped);
 * // => [1, 2]
 */
function wrapperToIterator() {
  return this;
}

/**
 * The base implementation of `wrapperValue` which returns the result of
 * performing a sequence of actions on the unwrapped `value`, where each
 * successive action is supplied the return value of the previous.
 *
 * @private
 * @param {*} value The unwrapped value.
 * @param {Array} actions Actions to perform to resolve the unwrapped value.
 * @returns {*} Returns the resolved value.
 */
function baseWrapperValue(value, actions) {
  var result = value;
  if (result instanceof LazyWrapper) {
    result = result.value();
  }
  return arrayReduce(actions, function (result, action) {
    return action.func.apply(action.thisArg, arrayPush([result], action.args));
  }, result);
}

/**
 * Executes the chain sequence to resolve the unwrapped value.
 *
 * @name value
 * @memberOf _
 * @since 0.1.0
 * @alias toJSON, valueOf
 * @category Seq
 * @returns {*} Returns the resolved unwrapped value.
 * @example
 *
 * _([1, 2, 3]).value();
 * // => [1, 2, 3]
 */
function wrapperValue() {
  return baseWrapperValue(this.__wrapped__, this.__actions__);
}

/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return toString(value).toLowerCase();
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */
function toSafeInteger(value) {
  return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
}

/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return toString(value).toUpperCase();
}

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
    isArrLike = isArr || isBuffer(object) || isTypedArray(object);
  iteratee = baseIteratee(iteratee);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor() : [];
    } else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    } else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;
  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
    length = strSymbols.length;
  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim(string);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
    chrSymbols = stringToArray(chars),
    start = charsStartIndex(strSymbols, chrSymbols),
    end = charsEndIndex(strSymbols, chrSymbols) + 1;
  return castSlice(strSymbols, start, end).join('');
}

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.slice(0, trimmedEndIndex(string) + 1);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
    end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
  return castSlice(strSymbols, 0, end).join('');
}

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimStart, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
    start = charsStartIndex(strSymbols, stringToArray(chars));
  return castSlice(strSymbols, start).join('');
}

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
  DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
    omission = DEFAULT_TRUNC_OMISSION;
  if (isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger(options.length) : length;
    omission = 'omission' in options ? baseToString(options.omission) : omission;
  }
  string = toString(string);
  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += result.length - end;
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
        substring = result;
      if (!separator.global) {
        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while (match = separator.exec(substring)) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

/**
 * Creates a function that accepts up to one argument, ignoring any
 * additional arguments.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.unary(parseInt));
 * // => [6, 8, 10]
 */
function unary(func) {
  return ary(func, 1);
}

/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
  reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape$1(string) {
  string = toString(string);
  return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set$1 && 1 / setToArray(new Set$1([, -0]))[1] == INFINITY) ? noop$2 : function (values) {
  return new Set$1(values);
};

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
    includes = arrayIncludes,
    length = array.length,
    isCommon = true,
    result = [],
    seen = result;
  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
      computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function (arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function (arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee));
});

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function (arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return array && array.length ? baseUniq(array) : [];
}

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return array && array.length ? baseUniq(array, baseIteratee(iteratee)) : [];
}

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return array && array.length ? baseUniq(array, undefined, comparator) : [];
}

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */
function unzip(array) {
  if (!(array && array.length)) {
    return [];
  }
  var length = 0;
  array = arrayFilter(array, function (group) {
    if (isArrayLikeObject(group)) {
      length = nativeMax$2(group.length, length);
      return true;
    }
  });
  return baseTimes(length, function (index) {
    return arrayMap(array, baseProperty(index));
  });
}

/**
 * This method is like `_.unzip` except that it accepts `iteratee` to specify
 * how regrouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  regrouped values.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
 * // => [[1, 10, 100], [2, 20, 200]]
 *
 * _.unzipWith(zipped, _.add);
 * // => [3, 30, 300]
 */
function unzipWith(array, iteratee) {
  if (!(array && array.length)) {
    return [];
  }
  var result = unzip(array);
  if (iteratee == null) {
    return result;
  }
  return arrayMap(result, function (group) {
    return apply(iteratee, undefined, group);
  });
}

/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseUpdate(object, path, updater, customizer) {
  return baseSet(object, path, updater(baseGet(object, path)), customizer);
}

/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */
function update$1(object, path, updater) {
  return object == null ? object : baseUpdate(object, path, castFunction(updater));
}

/**
 * This method is like `_.update` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.updateWith(object, '[0][1]', _.constant('a'), Object);
 * // => { '0': { '1': 'a' } }
 */
function updateWith(object, path, updater, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
}

/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = createCompounder(function (result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});

/**
 * Creates an array of the own and inherited enumerable string keyed property
 * values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.valuesIn(new Foo);
 * // => [1, 2, 3] (iteration order is not guaranteed)
 */
function valuesIn(object) {
  return object == null ? [] : baseValues(object, keysIn(object));
}

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function (array, values) {
  return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});

/**
 * Creates a function that provides `value` to `wrapper` as its first
 * argument. Any additional arguments provided to the function are appended
 * to those provided to the `wrapper`. The wrapper is invoked with the `this`
 * binding of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {*} value The value to wrap.
 * @param {Function} [wrapper=identity] The wrapper function.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var p = _.wrap(_.escape, function(func, text) {
 *   return '<p>' + func(text) + '</p>';
 * });
 *
 * p('fred, barney, & pebbles');
 * // => '<p>fred, barney, &amp; pebbles</p>'
 */
function wrap(value, wrapper) {
  return partial(castFunction(wrapper), value);
}

/**
 * This method is the wrapper version of `_.at`.
 *
 * @name at
 * @memberOf _
 * @since 1.0.0
 * @category Seq
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _(object).at(['a[0].b.c', 'a[1]']).value();
 * // => [3, 4]
 */
var wrapperAt = flatRest(function (paths) {
  var length = paths.length,
    start = length ? paths[0] : 0,
    value = this.__wrapped__,
    interceptor = function interceptor(object) {
      return baseAt(object, paths);
    };
  if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
    return this.thru(interceptor);
  }
  value = value.slice(start, +start + (length ? 1 : 0));
  value.__actions__.push({
    'func': thru,
    'args': [interceptor],
    'thisArg': undefined
  });
  return new LodashWrapper(value, this.__chain__).thru(function (array) {
    if (length && !array.length) {
      array.push(undefined);
    }
    return array;
  });
});

/**
 * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
 *
 * @name chain
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 }
 * ];
 *
 * // A sequence without explicit chaining.
 * _(users).head();
 * // => { 'user': 'barney', 'age': 36 }
 *
 * // A sequence with explicit chaining.
 * _(users)
 *   .chain()
 *   .head()
 *   .pick('user')
 *   .value();
 * // => { 'user': 'barney' }
 */
function wrapperChain() {
  return chain$1(this);
}

/**
 * This method is the wrapper version of `_.reverse`.
 *
 * **Note:** This method mutates the wrapped array.
 *
 * @name reverse
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _(array).reverse().value()
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function wrapperReverse() {
  var value = this.__wrapped__;
  if (value instanceof LazyWrapper) {
    var wrapped = value;
    if (this.__actions__.length) {
      wrapped = new LazyWrapper(this);
    }
    wrapped = wrapped.reverse();
    wrapped.__actions__.push({
      'func': thru,
      'args': [reverse],
      'thisArg': undefined
    });
    return new LodashWrapper(wrapped, this.__chain__);
  }
  return this.thru(reverse);
}

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
    result = Array(length);
  while (++index < length) {
    var array = arrays[index],
      othIndex = -1;
    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function (arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var xorBy = baseRest(function (arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseXor(arrayFilter(arrays, isArrayLikeObject), baseIteratee(iteratee));
});

/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var xorWith = baseRest(function (arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
});

/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */
var zip = baseRest(unzip);

/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
    length = props.length,
    valsLength = values.length,
    result = {};
  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return baseZipObject(props || [], values || [], assignValue);
}

/**
 * This method is like `_.zipObject` except that it supports property paths.
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
 */
function zipObjectDeep(props, values) {
  return baseZipObject(props || [], values || [], baseSet);
}

/**
 * This method is like `_.zip` except that it accepts `iteratee` to specify
 * how grouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  grouped values.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
 *   return a + b + c;
 * });
 * // => [111, 222]
 */
var zipWith = baseRest(function (arrays) {
  var length = arrays.length,
    iteratee = length > 1 ? arrays[length - 1] : undefined;
  iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
  return unzipWith(arrays, iteratee);
});

var array = {
  chunk: chunk,
  compact: compact,
  concat: concat,
  difference: difference,
  differenceBy: differenceBy,
  differenceWith: differenceWith,
  drop: drop,
  dropRight: dropRight,
  dropRightWhile: dropRightWhile,
  dropWhile: dropWhile,
  fill: fill,
  findIndex: findIndex$1,
  findLastIndex: findLastIndex,
  first: head,
  flatten: flatten,
  flattenDeep: flattenDeep,
  flattenDepth: flattenDepth,
  fromPairs: fromPairs,
  head: head,
  indexOf: indexOf,
  initial: initial,
  intersection: intersection,
  intersectionBy: intersectionBy,
  intersectionWith: intersectionWith,
  join: join,
  last: last,
  lastIndexOf: lastIndexOf,
  nth: nth,
  pull: pull,
  pullAll: pullAll,
  pullAllBy: pullAllBy,
  pullAllWith: pullAllWith,
  pullAt: pullAt,
  remove: remove,
  reverse: reverse,
  slice: slice,
  sortedIndex: sortedIndex,
  sortedIndexBy: sortedIndexBy,
  sortedIndexOf: sortedIndexOf,
  sortedLastIndex: sortedLastIndex,
  sortedLastIndexBy: sortedLastIndexBy,
  sortedLastIndexOf: sortedLastIndexOf,
  sortedUniq: sortedUniq,
  sortedUniqBy: sortedUniqBy,
  tail: tail,
  take: take,
  takeRight: takeRight,
  takeRightWhile: takeRightWhile,
  takeWhile: takeWhile,
  union: union,
  unionBy: unionBy,
  unionWith: unionWith,
  uniq: uniq,
  uniqBy: uniqBy,
  uniqWith: uniqWith,
  unzip: unzip,
  unzipWith: unzipWith,
  without: without,
  xor: xor,
  xorBy: xorBy,
  xorWith: xorWith,
  zip: zip,
  zipObject: zipObject,
  zipObjectDeep: zipObjectDeep,
  zipWith: zipWith
};

var collection = {
  countBy: countBy,
  each: forEach,
  eachRight: forEachRight,
  every: every,
  filter: filter,
  find: find,
  findLast: findLast,
  flatMap: flatMap,
  flatMapDeep: flatMapDeep,
  flatMapDepth: flatMapDepth,
  forEach: forEach,
  forEachRight: forEachRight,
  groupBy: groupBy,
  includes: includes,
  invokeMap: invokeMap,
  keyBy: keyBy,
  map: map,
  orderBy: orderBy,
  partition: partition,
  reduce: reduce,
  reduceRight: reduceRight,
  reject: reject,
  sample: sample,
  sampleSize: sampleSize,
  shuffle: shuffle,
  size: size,
  some: some,
  sortBy: sortBy
};

var date = {
  now: now
};

var func = {
  after: after,
  ary: ary,
  before: before,
  bind: bind,
  bindKey: bindKey,
  curry: curry,
  curryRight: curryRight,
  debounce: debounce,
  defer: defer,
  delay: delay,
  flip: flip,
  memoize: memoize,
  negate: negate,
  once: once$1,
  overArgs: overArgs,
  partial: partial,
  partialRight: partialRight,
  rearg: rearg,
  rest: rest,
  spread: spread,
  throttle: throttle$1,
  unary: unary,
  wrap: wrap
};

var lang = {
  castArray: castArray,
  clone: clone,
  cloneDeep: cloneDeep,
  cloneDeepWith: cloneDeepWith,
  cloneWith: cloneWith,
  conformsTo: conformsTo,
  eq: eq,
  gt: gt,
  gte: gte,
  isArguments: isArguments,
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isArrayLike: isArrayLike,
  isArrayLikeObject: isArrayLikeObject,
  isBoolean: isBoolean,
  isBuffer: isBuffer,
  isDate: isDate,
  isElement: isElement,
  isEmpty: isEmpty,
  isEqual: isEqual$1,
  isEqualWith: isEqualWith,
  isError: isError,
  isFinite: isFinite$1,
  isFunction: isFunction,
  isInteger: isInteger,
  isLength: isLength,
  isMap: isMap,
  isMatch: isMatch,
  isMatchWith: isMatchWith,
  isNaN: isNaN$1,
  isNative: isNative,
  isNil: isNil,
  isNull: isNull,
  isNumber: isNumber,
  isObject: isObject,
  isObjectLike: isObjectLike,
  isPlainObject: isPlainObject,
  isRegExp: isRegExp,
  isSafeInteger: isSafeInteger,
  isSet: isSet,
  isString: isString,
  isSymbol: isSymbol,
  isTypedArray: isTypedArray,
  isUndefined: isUndefined,
  isWeakMap: isWeakMap,
  isWeakSet: isWeakSet,
  lt: lt,
  lte: lte,
  toArray: toArray$1,
  toFinite: toFinite,
  toInteger: toInteger,
  toLength: toLength,
  toNumber: toNumber,
  toPlainObject: toPlainObject,
  toSafeInteger: toSafeInteger,
  toString: toString
};

var math = {
  add: add,
  ceil: ceil,
  divide: divide,
  floor: floor,
  max: max,
  maxBy: maxBy,
  mean: mean,
  meanBy: meanBy,
  min: min,
  minBy: minBy,
  multiply: multiply,
  round: round,
  subtract: subtract,
  sum: sum,
  sumBy: sumBy
};

var number = {
  clamp: clamp$2,
  inRange: inRange,
  random: random
};

var object = {
  assign: assign,
  assignIn: assignIn,
  assignInWith: assignInWith,
  assignWith: assignWith,
  at: at,
  create: create,
  defaults: defaults$1,
  defaultsDeep: defaultsDeep,
  entries: toPairs,
  entriesIn: toPairsIn,
  extend: assignIn,
  extendWith: assignInWith,
  findKey: findKey,
  findLastKey: findLastKey,
  forIn: forIn,
  forInRight: forInRight,
  forOwn: forOwn,
  forOwnRight: forOwnRight,
  functions: functions,
  functionsIn: functionsIn,
  get: get,
  has: has,
  hasIn: hasIn,
  invert: invert,
  invertBy: invertBy,
  invoke: invoke,
  keys: keys,
  keysIn: keysIn,
  mapKeys: mapKeys,
  mapValues: mapValues$1,
  merge: merge,
  mergeWith: mergeWith,
  omit: omit,
  omitBy: omitBy,
  pick: pick,
  pickBy: pickBy,
  result: result,
  set: set,
  setWith: setWith,
  toPairs: toPairs,
  toPairsIn: toPairsIn,
  transform: transform,
  unset: unset,
  update: update$1,
  updateWith: updateWith,
  values: values,
  valuesIn: valuesIn
};

var seq = {
  at: wrapperAt,
  chain: chain$1,
  commit: wrapperCommit,
  lodash: lodash,
  next: wrapperNext,
  plant: wrapperPlant,
  reverse: wrapperReverse,
  tap: tap,
  thru: thru,
  toIterator: wrapperToIterator,
  toJSON: wrapperValue,
  value: wrapperValue,
  valueOf: wrapperValue,
  wrapperChain: wrapperChain
};

var string = {
  camelCase: camelCase,
  capitalize: capitalize$1,
  deburr: deburr,
  endsWith: endsWith,
  escape: escape,
  escapeRegExp: escapeRegExp,
  kebabCase: kebabCase,
  lowerCase: lowerCase,
  lowerFirst: lowerFirst,
  pad: pad,
  padEnd: padEnd,
  padStart: padStart,
  parseInt: parseInt$1,
  repeat: repeat,
  replace: replace,
  snakeCase: snakeCase,
  split: split,
  startCase: startCase,
  startsWith: startsWith,
  template: template,
  templateSettings: templateSettings,
  toLower: toLower,
  toUpper: toUpper,
  trim: trim,
  trimEnd: trimEnd,
  trimStart: trimStart,
  truncate: truncate,
  unescape: unescape$1,
  upperCase: upperCase,
  upperFirst: upperFirst,
  words: words
};

var util = {
  attempt: attempt,
  bindAll: bindAll,
  cond: cond,
  conforms: conforms,
  constant: constant,
  defaultTo: defaultTo,
  flow: flow,
  flowRight: flowRight,
  identity: identity$1,
  iteratee: iteratee,
  matches: matches,
  matchesProperty: matchesProperty,
  method: method,
  methodOf: methodOf,
  mixin: mixin$1,
  noop: noop$2,
  nthArg: nthArg,
  over: over,
  overEvery: overEvery,
  overSome: overSome,
  property: property,
  propertyOf: propertyOf,
  range: range,
  rangeRight: rangeRight,
  stubArray: stubArray,
  stubFalse: stubFalse,
  stubObject: stubObject,
  stubString: stubString,
  stubTrue: stubTrue,
  times: times,
  toPath: toPath,
  uniqueId: uniqueId
};

/**
 * Creates a clone of the lazy wrapper object.
 *
 * @private
 * @name clone
 * @memberOf LazyWrapper
 * @returns {Object} Returns the cloned `LazyWrapper` object.
 */
function lazyClone() {
  var result = new LazyWrapper(this.__wrapped__);
  result.__actions__ = copyArray(this.__actions__);
  result.__dir__ = this.__dir__;
  result.__filtered__ = this.__filtered__;
  result.__iteratees__ = copyArray(this.__iteratees__);
  result.__takeCount__ = this.__takeCount__;
  result.__views__ = copyArray(this.__views__);
  return result;
}

/**
 * Reverses the direction of lazy iteration.
 *
 * @private
 * @name reverse
 * @memberOf LazyWrapper
 * @returns {Object} Returns the new reversed `LazyWrapper` object.
 */
function lazyReverse() {
  if (this.__filtered__) {
    var result = new LazyWrapper(this);
    result.__dir__ = -1;
    result.__filtered__ = true;
  } else {
    result = this.clone();
    result.__dir__ *= -1;
  }
  return result;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
  nativeMin$2 = Math.min;

/**
 * Gets the view, applying any `transforms` to the `start` and `end` positions.
 *
 * @private
 * @param {number} start The start of the view.
 * @param {number} end The end of the view.
 * @param {Array} transforms The transformations to apply to the view.
 * @returns {Object} Returns an object containing the `start` and `end`
 *  positions of the view.
 */
function getView(start, end, transforms) {
  var index = -1,
    length = transforms.length;
  while (++index < length) {
    var data = transforms[index],
      size = data.size;
    switch (data.type) {
      case 'drop':
        start += size;
        break;
      case 'dropRight':
        end -= size;
        break;
      case 'take':
        end = nativeMin$2(end, start + size);
        break;
      case 'takeRight':
        start = nativeMax$1(start, end - size);
        break;
    }
  }
  return {
    'start': start,
    'end': end
  };
}

/** Used to indicate the type of lazy iteratees. */
var LAZY_FILTER_FLAG$1 = 1,
  LAZY_MAP_FLAG = 2;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$1 = Math.min;

/**
 * Extracts the unwrapped value from its lazy wrapper.
 *
 * @private
 * @name value
 * @memberOf LazyWrapper
 * @returns {*} Returns the unwrapped value.
 */
function lazyValue() {
  var array = this.__wrapped__.value(),
    dir = this.__dir__,
    isArr = isArray(array),
    isRight = dir < 0,
    arrLength = isArr ? array.length : 0,
    view = getView(0, arrLength, this.__views__),
    start = view.start,
    end = view.end,
    length = end - start,
    index = isRight ? end : start - 1,
    iteratees = this.__iteratees__,
    iterLength = iteratees.length,
    resIndex = 0,
    takeCount = nativeMin$1(length, this.__takeCount__);
  if (!isArr || !isRight && arrLength == length && takeCount == length) {
    return baseWrapperValue(array, this.__actions__);
  }
  var result = [];
  outer: while (length-- && resIndex < takeCount) {
    index += dir;
    var iterIndex = -1,
      value = array[index];
    while (++iterIndex < iterLength) {
      var data = iteratees[iterIndex],
        iteratee = data.iteratee,
        type = data.type,
        computed = iteratee(value);
      if (type == LAZY_MAP_FLAG) {
        value = computed;
      } else if (!computed) {
        if (type == LAZY_FILTER_FLAG$1) {
          continue outer;
        } else {
          break outer;
        }
      }
    }
    result[resIndex++] = value;
  }
  return result;
}

/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the semantic version number. */
var VERSION = '4.17.21';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_KEY_FLAG = 2;

/** Used to indicate the type of lazy iteratees. */
var LAZY_FILTER_FLAG = 1,
  LAZY_WHILE_FLAG = 3;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/** Used for built-in method references. */
var arrayProto = Array.prototype,
  objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var symIterator = _Symbol ? _Symbol.iterator : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

// wrap `_.mixin` so it works when provided only one argument
var mixin = function (func) {
  return function (object, source, options) {
    if (options == null) {
      var isObj = isObject(source),
        props = isObj && keys(source),
        methodNames = props && props.length && baseFunctions(source, props);
      if (!(methodNames ? methodNames.length : isObj)) {
        options = source;
        source = object;
        object = this;
      }
    }
    return func(object, source, options);
  };
}(mixin$1);

// Add methods that return wrapped values in chain sequences.
lodash.after = func.after;
lodash.ary = func.ary;
lodash.assign = object.assign;
lodash.assignIn = object.assignIn;
lodash.assignInWith = object.assignInWith;
lodash.assignWith = object.assignWith;
lodash.at = object.at;
lodash.before = func.before;
lodash.bind = func.bind;
lodash.bindAll = util.bindAll;
lodash.bindKey = func.bindKey;
lodash.castArray = lang.castArray;
lodash.chain = seq.chain;
lodash.chunk = array.chunk;
lodash.compact = array.compact;
lodash.concat = array.concat;
lodash.cond = util.cond;
lodash.conforms = util.conforms;
lodash.constant = util.constant;
lodash.countBy = collection.countBy;
lodash.create = object.create;
lodash.curry = func.curry;
lodash.curryRight = func.curryRight;
lodash.debounce = func.debounce;
lodash.defaults = object.defaults;
lodash.defaultsDeep = object.defaultsDeep;
lodash.defer = func.defer;
lodash.delay = func.delay;
lodash.difference = array.difference;
lodash.differenceBy = array.differenceBy;
lodash.differenceWith = array.differenceWith;
lodash.drop = array.drop;
lodash.dropRight = array.dropRight;
lodash.dropRightWhile = array.dropRightWhile;
lodash.dropWhile = array.dropWhile;
lodash.fill = array.fill;
lodash.filter = collection.filter;
lodash.flatMap = collection.flatMap;
lodash.flatMapDeep = collection.flatMapDeep;
lodash.flatMapDepth = collection.flatMapDepth;
lodash.flatten = array.flatten;
lodash.flattenDeep = array.flattenDeep;
lodash.flattenDepth = array.flattenDepth;
lodash.flip = func.flip;
lodash.flow = util.flow;
lodash.flowRight = util.flowRight;
lodash.fromPairs = array.fromPairs;
lodash.functions = object.functions;
lodash.functionsIn = object.functionsIn;
lodash.groupBy = collection.groupBy;
lodash.initial = array.initial;
lodash.intersection = array.intersection;
lodash.intersectionBy = array.intersectionBy;
lodash.intersectionWith = array.intersectionWith;
lodash.invert = object.invert;
lodash.invertBy = object.invertBy;
lodash.invokeMap = collection.invokeMap;
lodash.iteratee = util.iteratee;
lodash.keyBy = collection.keyBy;
lodash.keys = keys;
lodash.keysIn = object.keysIn;
lodash.map = collection.map;
lodash.mapKeys = object.mapKeys;
lodash.mapValues = object.mapValues;
lodash.matches = util.matches;
lodash.matchesProperty = util.matchesProperty;
lodash.memoize = func.memoize;
lodash.merge = object.merge;
lodash.mergeWith = object.mergeWith;
lodash.method = util.method;
lodash.methodOf = util.methodOf;
lodash.mixin = mixin;
lodash.negate = negate;
lodash.nthArg = util.nthArg;
lodash.omit = object.omit;
lodash.omitBy = object.omitBy;
lodash.once = func.once;
lodash.orderBy = collection.orderBy;
lodash.over = util.over;
lodash.overArgs = func.overArgs;
lodash.overEvery = util.overEvery;
lodash.overSome = util.overSome;
lodash.partial = func.partial;
lodash.partialRight = func.partialRight;
lodash.partition = collection.partition;
lodash.pick = object.pick;
lodash.pickBy = object.pickBy;
lodash.property = util.property;
lodash.propertyOf = util.propertyOf;
lodash.pull = array.pull;
lodash.pullAll = array.pullAll;
lodash.pullAllBy = array.pullAllBy;
lodash.pullAllWith = array.pullAllWith;
lodash.pullAt = array.pullAt;
lodash.range = util.range;
lodash.rangeRight = util.rangeRight;
lodash.rearg = func.rearg;
lodash.reject = collection.reject;
lodash.remove = array.remove;
lodash.rest = func.rest;
lodash.reverse = array.reverse;
lodash.sampleSize = collection.sampleSize;
lodash.set = object.set;
lodash.setWith = object.setWith;
lodash.shuffle = collection.shuffle;
lodash.slice = array.slice;
lodash.sortBy = collection.sortBy;
lodash.sortedUniq = array.sortedUniq;
lodash.sortedUniqBy = array.sortedUniqBy;
lodash.split = string.split;
lodash.spread = func.spread;
lodash.tail = array.tail;
lodash.take = array.take;
lodash.takeRight = array.takeRight;
lodash.takeRightWhile = array.takeRightWhile;
lodash.takeWhile = array.takeWhile;
lodash.tap = seq.tap;
lodash.throttle = func.throttle;
lodash.thru = thru;
lodash.toArray = lang.toArray;
lodash.toPairs = object.toPairs;
lodash.toPairsIn = object.toPairsIn;
lodash.toPath = util.toPath;
lodash.toPlainObject = lang.toPlainObject;
lodash.transform = object.transform;
lodash.unary = func.unary;
lodash.union = array.union;
lodash.unionBy = array.unionBy;
lodash.unionWith = array.unionWith;
lodash.uniq = array.uniq;
lodash.uniqBy = array.uniqBy;
lodash.uniqWith = array.uniqWith;
lodash.unset = object.unset;
lodash.unzip = array.unzip;
lodash.unzipWith = array.unzipWith;
lodash.update = object.update;
lodash.updateWith = object.updateWith;
lodash.values = object.values;
lodash.valuesIn = object.valuesIn;
lodash.without = array.without;
lodash.words = string.words;
lodash.wrap = func.wrap;
lodash.xor = array.xor;
lodash.xorBy = array.xorBy;
lodash.xorWith = array.xorWith;
lodash.zip = array.zip;
lodash.zipObject = array.zipObject;
lodash.zipObjectDeep = array.zipObjectDeep;
lodash.zipWith = array.zipWith;

// Add aliases.
lodash.entries = object.toPairs;
lodash.entriesIn = object.toPairsIn;
lodash.extend = object.assignIn;
lodash.extendWith = object.assignInWith;

// Add methods to `lodash.prototype`.
mixin(lodash, lodash);

// Add methods that return unwrapped values in chain sequences.
lodash.add = math.add;
lodash.attempt = util.attempt;
lodash.camelCase = string.camelCase;
lodash.capitalize = string.capitalize;
lodash.ceil = math.ceil;
lodash.clamp = number.clamp;
lodash.clone = lang.clone;
lodash.cloneDeep = lang.cloneDeep;
lodash.cloneDeepWith = lang.cloneDeepWith;
lodash.cloneWith = lang.cloneWith;
lodash.conformsTo = lang.conformsTo;
lodash.deburr = string.deburr;
lodash.defaultTo = util.defaultTo;
lodash.divide = math.divide;
lodash.endsWith = string.endsWith;
lodash.eq = lang.eq;
lodash.escape = string.escape;
lodash.escapeRegExp = string.escapeRegExp;
lodash.every = collection.every;
lodash.find = collection.find;
lodash.findIndex = array.findIndex;
lodash.findKey = object.findKey;
lodash.findLast = collection.findLast;
lodash.findLastIndex = array.findLastIndex;
lodash.findLastKey = object.findLastKey;
lodash.floor = math.floor;
lodash.forEach = collection.forEach;
lodash.forEachRight = collection.forEachRight;
lodash.forIn = object.forIn;
lodash.forInRight = object.forInRight;
lodash.forOwn = object.forOwn;
lodash.forOwnRight = object.forOwnRight;
lodash.get = object.get;
lodash.gt = lang.gt;
lodash.gte = lang.gte;
lodash.has = object.has;
lodash.hasIn = object.hasIn;
lodash.head = array.head;
lodash.identity = identity$1;
lodash.includes = collection.includes;
lodash.indexOf = array.indexOf;
lodash.inRange = number.inRange;
lodash.invoke = object.invoke;
lodash.isArguments = lang.isArguments;
lodash.isArray = isArray;
lodash.isArrayBuffer = lang.isArrayBuffer;
lodash.isArrayLike = lang.isArrayLike;
lodash.isArrayLikeObject = lang.isArrayLikeObject;
lodash.isBoolean = lang.isBoolean;
lodash.isBuffer = lang.isBuffer;
lodash.isDate = lang.isDate;
lodash.isElement = lang.isElement;
lodash.isEmpty = lang.isEmpty;
lodash.isEqual = lang.isEqual;
lodash.isEqualWith = lang.isEqualWith;
lodash.isError = lang.isError;
lodash.isFinite = lang.isFinite;
lodash.isFunction = lang.isFunction;
lodash.isInteger = lang.isInteger;
lodash.isLength = lang.isLength;
lodash.isMap = lang.isMap;
lodash.isMatch = lang.isMatch;
lodash.isMatchWith = lang.isMatchWith;
lodash.isNaN = lang.isNaN;
lodash.isNative = lang.isNative;
lodash.isNil = lang.isNil;
lodash.isNull = lang.isNull;
lodash.isNumber = lang.isNumber;
lodash.isObject = isObject;
lodash.isObjectLike = lang.isObjectLike;
lodash.isPlainObject = lang.isPlainObject;
lodash.isRegExp = lang.isRegExp;
lodash.isSafeInteger = lang.isSafeInteger;
lodash.isSet = lang.isSet;
lodash.isString = lang.isString;
lodash.isSymbol = lang.isSymbol;
lodash.isTypedArray = lang.isTypedArray;
lodash.isUndefined = lang.isUndefined;
lodash.isWeakMap = lang.isWeakMap;
lodash.isWeakSet = lang.isWeakSet;
lodash.join = array.join;
lodash.kebabCase = string.kebabCase;
lodash.last = last;
lodash.lastIndexOf = array.lastIndexOf;
lodash.lowerCase = string.lowerCase;
lodash.lowerFirst = string.lowerFirst;
lodash.lt = lang.lt;
lodash.lte = lang.lte;
lodash.max = math.max;
lodash.maxBy = math.maxBy;
lodash.mean = math.mean;
lodash.meanBy = math.meanBy;
lodash.min = math.min;
lodash.minBy = math.minBy;
lodash.stubArray = util.stubArray;
lodash.stubFalse = util.stubFalse;
lodash.stubObject = util.stubObject;
lodash.stubString = util.stubString;
lodash.stubTrue = util.stubTrue;
lodash.multiply = math.multiply;
lodash.nth = array.nth;
lodash.noop = util.noop;
lodash.now = date.now;
lodash.pad = string.pad;
lodash.padEnd = string.padEnd;
lodash.padStart = string.padStart;
lodash.parseInt = string.parseInt;
lodash.random = number.random;
lodash.reduce = collection.reduce;
lodash.reduceRight = collection.reduceRight;
lodash.repeat = string.repeat;
lodash.replace = string.replace;
lodash.result = object.result;
lodash.round = math.round;
lodash.sample = collection.sample;
lodash.size = collection.size;
lodash.snakeCase = string.snakeCase;
lodash.some = collection.some;
lodash.sortedIndex = array.sortedIndex;
lodash.sortedIndexBy = array.sortedIndexBy;
lodash.sortedIndexOf = array.sortedIndexOf;
lodash.sortedLastIndex = array.sortedLastIndex;
lodash.sortedLastIndexBy = array.sortedLastIndexBy;
lodash.sortedLastIndexOf = array.sortedLastIndexOf;
lodash.startCase = string.startCase;
lodash.startsWith = string.startsWith;
lodash.subtract = math.subtract;
lodash.sum = math.sum;
lodash.sumBy = math.sumBy;
lodash.template = string.template;
lodash.times = util.times;
lodash.toFinite = lang.toFinite;
lodash.toInteger = toInteger;
lodash.toLength = lang.toLength;
lodash.toLower = string.toLower;
lodash.toNumber = lang.toNumber;
lodash.toSafeInteger = lang.toSafeInteger;
lodash.toString = lang.toString;
lodash.toUpper = string.toUpper;
lodash.trim = string.trim;
lodash.trimEnd = string.trimEnd;
lodash.trimStart = string.trimStart;
lodash.truncate = string.truncate;
lodash.unescape = string.unescape;
lodash.uniqueId = util.uniqueId;
lodash.upperCase = string.upperCase;
lodash.upperFirst = string.upperFirst;

// Add aliases.
lodash.each = collection.forEach;
lodash.eachRight = collection.forEachRight;
lodash.first = array.head;
mixin(lodash, function () {
  var source = {};
  baseForOwn(lodash, function (func, methodName) {
    if (!hasOwnProperty.call(lodash.prototype, methodName)) {
      source[methodName] = func;
    }
  });
  return source;
}(), {
  'chain': false
});

/**
 * The semantic version number.
 *
 * @static
 * @memberOf _
 * @type {string}
 */
lodash.VERSION = VERSION;
(lodash.templateSettings = string.templateSettings).imports._ = lodash;

// Assign default placeholders.
arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
  lodash[methodName].placeholder = lodash;
});

// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop', 'take'], function (methodName, index) {
  LazyWrapper.prototype[methodName] = function (n) {
    n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
    var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
    if (result.__filtered__) {
      result.__takeCount__ = nativeMin(n, result.__takeCount__);
    } else {
      result.__views__.push({
        'size': nativeMin(n, MAX_ARRAY_LENGTH),
        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
      });
    }
    return result;
  };
  LazyWrapper.prototype[methodName + 'Right'] = function (n) {
    return this.reverse()[methodName](n).reverse();
  };
});

// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
  var type = index + 1,
    isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
  LazyWrapper.prototype[methodName] = function (iteratee) {
    var result = this.clone();
    result.__iteratees__.push({
      'iteratee': baseIteratee(iteratee),
      'type': type
    });
    result.__filtered__ = result.__filtered__ || isFilter;
    return result;
  };
});

// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head', 'last'], function (methodName, index) {
  var takeName = 'take' + (index ? 'Right' : '');
  LazyWrapper.prototype[methodName] = function () {
    return this[takeName](1).value()[0];
  };
});

// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial', 'tail'], function (methodName, index) {
  var dropName = 'drop' + (index ? '' : 'Right');
  LazyWrapper.prototype[methodName] = function () {
    return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
  };
});
LazyWrapper.prototype.compact = function () {
  return this.filter(identity$1);
};
LazyWrapper.prototype.find = function (predicate) {
  return this.filter(predicate).head();
};
LazyWrapper.prototype.findLast = function (predicate) {
  return this.reverse().find(predicate);
};
LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
  if (typeof path == 'function') {
    return new LazyWrapper(this);
  }
  return this.map(function (value) {
    return baseInvoke(value, path, args);
  });
});
LazyWrapper.prototype.reject = function (predicate) {
  return this.filter(negate(baseIteratee(predicate)));
};
LazyWrapper.prototype.slice = function (start, end) {
  start = toInteger(start);
  var result = this;
  if (result.__filtered__ && (start > 0 || end < 0)) {
    return new LazyWrapper(result);
  }
  if (start < 0) {
    result = result.takeRight(-start);
  } else if (start) {
    result = result.drop(start);
  }
  if (end !== undefined) {
    end = toInteger(end);
    result = end < 0 ? result.dropRight(-end) : result.take(end - start);
  }
  return result;
};
LazyWrapper.prototype.takeRightWhile = function (predicate) {
  return this.reverse().takeWhile(predicate).reverse();
};
LazyWrapper.prototype.toArray = function () {
  return this.take(MAX_ARRAY_LENGTH);
};

// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn(LazyWrapper.prototype, function (func, methodName) {
  var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
    isTaker = /^(?:head|last)$/.test(methodName),
    lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
    retUnwrapped = isTaker || /^find/.test(methodName);
  if (!lodashFunc) {
    return;
  }
  lodash.prototype[methodName] = function () {
    var value = this.__wrapped__,
      args = isTaker ? [1] : arguments,
      isLazy = value instanceof LazyWrapper,
      iteratee = args[0],
      useLazy = isLazy || isArray(value);
    var interceptor = function interceptor(value) {
      var result = lodashFunc.apply(lodash, arrayPush([value], args));
      return isTaker && chainAll ? result[0] : result;
    };
    if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
      // Avoid lazy use if the iteratee has a "length" value other than `1`.
      isLazy = useLazy = false;
    }
    var chainAll = this.__chain__,
      isHybrid = !!this.__actions__.length,
      isUnwrapped = retUnwrapped && !chainAll,
      onlyLazy = isLazy && !isHybrid;
    if (!retUnwrapped && useLazy) {
      value = onlyLazy ? value : new LazyWrapper(this);
      var result = func.apply(value, args);
      result.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(result, chainAll);
    }
    if (isUnwrapped && onlyLazy) {
      return func.apply(this, args);
    }
    result = this.thru(interceptor);
    return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
  };
});

// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
  var func = arrayProto[methodName],
    chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
    retUnwrapped = /^(?:pop|shift)$/.test(methodName);
  lodash.prototype[methodName] = function () {
    var args = arguments;
    if (retUnwrapped && !this.__chain__) {
      var value = this.value();
      return func.apply(isArray(value) ? value : [], args);
    }
    return this[chainName](function (value) {
      return func.apply(isArray(value) ? value : [], args);
    });
  };
});

// Map minified method names to their real names.
baseForOwn(LazyWrapper.prototype, function (func, methodName) {
  var lodashFunc = lodash[methodName];
  if (lodashFunc) {
    var key = lodashFunc.name + '';
    if (!hasOwnProperty.call(realNames, key)) {
      realNames[key] = [];
    }
    realNames[key].push({
      'name': methodName,
      'func': lodashFunc
    });
  }
});
realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
  'name': 'wrapper',
  'func': undefined
}];

// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone = lazyClone;
LazyWrapper.prototype.reverse = lazyReverse;
LazyWrapper.prototype.value = lazyValue;

// Add chain sequence methods to the `lodash` wrapper.
lodash.prototype.at = seq.at;
lodash.prototype.chain = seq.wrapperChain;
lodash.prototype.commit = seq.commit;
lodash.prototype.next = seq.next;
lodash.prototype.plant = seq.plant;
lodash.prototype.reverse = seq.reverse;
lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = seq.value;

// Add lazy aliases.
lodash.prototype.first = lodash.prototype.head;
if (symIterator) {
  lodash.prototype[symIterator] = seq.toIterator;
}

var isBrowser$2 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var isBrowser$3 = isBrowser$2;

function getTargetElement(target, defaultElement) {
  if (!isBrowser$3) {
    return undefined;
  }
  if (!target) {
    return defaultElement;
  }
  var targetElement;
  if (isFunction$1(target)) {
    targetElement = target();
  } else if ('current' in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }
  return targetElement;
}

var createEffectWithTarget = function (useEffectType) {
  /**
   *
   * @param effect
   * @param deps
   * @param target target should compare ref.current vs ref.current, dom vs dom, ()=>dom vs ()=>dom
   */
  var useEffectWithTarget = function (effect, deps, target) {
    var hasInitRef = useRef(false);
    var lastElementRef = useRef([]);
    var lastDepsRef = useRef([]);
    var unLoadRef = useRef();
    useEffectType(function () {
      var _a;
      var targets = Array.isArray(target) ? target : [target];
      var els = targets.map(function (item) {
        return getTargetElement(item);
      });
      // init run
      if (!hasInitRef.current) {
        hasInitRef.current = true;
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect();
        return;
      }
      if (els.length !== lastElementRef.current.length || !depsAreSame(els, lastElementRef.current) || !depsAreSame(deps, lastDepsRef.current)) {
        (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect();
      }
    });
    useUnmount$1(function () {
      var _a;
      (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
      // for react-refresh
      hasInitRef.current = false;
    });
  };
  return useEffectWithTarget;
};
var createEffectWithTarget$1 = createEffectWithTarget;

var useEffectWithTarget$1 = createEffectWithTarget$1(useEffect);
var useEffectWithTarget$2 = useEffectWithTarget$1;

var useIsomorphicLayoutEffect$1 = isBrowser$3 ? useLayoutEffect : useEffect;
var useIsomorphicLayoutEffect$2 = useIsomorphicLayoutEffect$1;

function useRafState(initialState) {
  var ref = useRef(0);
  var _a = __read(useState(initialState), 2),
    state = _a[0],
    setState = _a[1];
  var setRafState = useCallback(function (value) {
    cancelAnimationFrame(ref.current);
    ref.current = requestAnimationFrame(function () {
      setState(value);
    });
  }, []);
  useUnmount$1(function () {
    cancelAnimationFrame(ref.current);
  });
  return [state, setRafState];
}

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
  if (typeof Map !== 'undefined') {
    return Map;
  }
  /**
   * Returns index in provided array that matches the specified key.
   *
   * @param {Array<Array>} arr
   * @param {*} key
   * @returns {number}
   */
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      if (entry[0] === key) {
        result = index;
        return true;
      }
      return false;
    });
    return result;
  }
  return (/** @class */function () {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function get() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      /**
       * @param {*} key
       * @returns {*}
       */
      class_1.prototype.get = function (key) {
        var index = getIndex(this.__entries__, key);
        var entry = this.__entries__[index];
        return entry && entry[1];
      };
      /**
       * @param {*} key
       * @param {*} value
       * @returns {void}
       */
      class_1.prototype.set = function (key, value) {
        var index = getIndex(this.__entries__, key);
        if (~index) {
          this.__entries__[index][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */
      class_1.prototype["delete"] = function (key) {
        var entries = this.__entries__;
        var index = getIndex(entries, key);
        if (~index) {
          entries.splice(index, 1);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */
      class_1.prototype.has = function (key) {
        return !!~getIndex(this.__entries__, key);
      };
      /**
       * @returns {void}
       */
      class_1.prototype.clear = function () {
        this.__entries__.splice(0);
      };
      /**
       * @param {Function} callback
       * @param {*} [ctx=null]
       * @returns {void}
       */
      class_1.prototype.forEach = function (callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    }()
  );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
  if (typeof global !== 'undefined' && global.Math === Math) {
    return global;
  }
  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }
  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  }
  // eslint-disable-next-line no-new-func
  return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
  if (typeof requestAnimationFrame === 'function') {
    // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
  }
  return function (callback) {
    return setTimeout(function () {
      return callback(Date.now());
    }, 1000 / 60);
  };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
  var leadingCall = false,
    trailingCall = false,
    lastCallTime = 0;
  /**
   * Invokes the original callback function and schedules new invocation if
   * the "proxy" was called during current request.
   *
   * @returns {void}
   */
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  /**
   * Callback invoked after the specified delay. It will further postpone
   * invocation of the original function delegating it to the
   * requestAnimationFrame.
   *
   * @returns {void}
   */
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  /**
   * Schedules invocation of the original function.
   *
   * @returns {void}
   */
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      // Reject immediately following calls.
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      // Schedule new call to be in invoked when the pending one is resolved.
      // This is important for "transitions" which never actually start
      // immediately so there is a chance that we might miss one if change
      // happens amids the pending invocation.
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserverController.
   *
   * @private
   */
  function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;
    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;
    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;
    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  /**
   * Adds observer to observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be added.
   * @returns {void}
   */
  ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
      this.connect_();
    }
  };
  /**
   * Removes observer from observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be removed.
   * @returns {void}
   */
  ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);
    // Remove observer if it's present in registry.
    if (~index) {
      observers.splice(index, 1);
    }
    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
      this.disconnect_();
    }
  };
  /**
   * Invokes the update of observers. It will continue running updates insofar
   * it detects changes.
   *
   * @returns {void}
   */
  ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();
    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
      this.refresh();
    }
  };
  /**
   * Updates every observer from observers list and notifies them of queued
   * entries.
   *
   * @private
   * @returns {boolean} Returns "true" if any observer has detected changes in
   *      dimensions of it's elements.
   */
  ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  /**
   * Initializes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser$1 || this.connected_) {
      return;
    }
    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);
    window.addEventListener('resize', this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMSubtreeModified', this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  /**
   * Removes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser$1 || !this.connected_) {
      return;
    }
    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener('DOMSubtreeModified', this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  /**
   * "Transitionend" event handler.
   *
   * @private
   * @param {TransitionEvent} event
   * @returns {void}
   */
  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
    var _b = _a.propertyName,
      propertyName = _b === void 0 ? '' : _b;
    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
      return !!~propertyName.indexOf(key);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  /**
   * Returns instance of the ResizeObserverController.
   *
   * @returns {ResizeObserverController}
   */
  ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController();
    }
    return this.instance_;
  };
  /**
   * Holds reference to the controller's instance.
   *
   * @private {ResizeObserverController}
   */
  ResizeObserverController.instance_ = null;
  return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  // Return the local global object if it's not possible extract one from
  // provided element.
  return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
  return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function (size, position) {
    var value = styles['border-' + position + '-width'];
    return size + toFloat(value);
  }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
  var positions = ['top', 'right', 'bottom', 'left'];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles['padding-' + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
  // Client width & height properties can't be
  // used exclusively as they provide rounded values.
  var clientWidth = target.clientWidth,
    clientHeight = target.clientHeight;
  // By this condition we can catch all non-replaced inline, hidden and
  // detached elements. Though elements with width & height properties less
  // than 0.5 will be discarded as well.
  //
  // Without it we would need to implement separate methods for each of
  // those cases and it's not possible to perform a precise and performance
  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
  // gives wrong results for elements with width & height less than 0.5.
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  // Computed styles of width & height are being used because they are the
  // only dimensions available to JS that contain non-rounded values. It could
  // be possible to utilize the getBoundingClientRect if only it's data wasn't
  // affected by CSS transformations let alone paddings, borders and scroll bars.
  var width = toFloat(styles.width),
    height = toFloat(styles.height);
  // Width & height include paddings and borders when the 'border-box' box
  // model is applied (except for IE).
  if (styles.boxSizing === 'border-box') {
    // Following conditions are required to handle Internet Explorer which
    // doesn't include paddings and borders to computed CSS dimensions.
    //
    // We can say that if CSS dimensions + paddings are equal to the "client"
    // properties then it's either IE, and thus we don't need to subtract
    // anything, or an element merely doesn't have paddings/borders styles.
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, 'left', 'right') + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
  }
  // Following steps can't be applied to the document's root element as its
  // client[Width/Height] properties represent viewport area of the window.
  // Besides, it's as well not necessary as the <html> itself neither has
  // rendered scroll bars nor it can be clipped.
  if (!isDocumentElement(target)) {
    // In some browsers (only in Firefox, actually) CSS width & height
    // include scroll bars size which can be removed at this step as scroll
    // bars are the only difference between rounded dimensions + paddings
    // and "client" properties, though that is not always true in Chrome.
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    // Chrome has a rather weird rounding of "client" properties.
    // E.g. for an element with content width of 314.2px it sometimes gives
    // the client width of 315px and for the width of 314.7px it may give
    // 314px. And it doesn't happen all the time. So just ignore this delta
    // as a non-relevant.
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
  // interface.
  if (typeof SVGGraphicsElement !== 'undefined') {
    return function (target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  // If it's so, then check that element is at least an instance of the
  // SVGElement and that it has the "getBBox" method.
  // eslint-disable-next-line no-extra-parens
  return function (target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
  };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
  if (!isBrowser$1) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
  var x = _a.x,
    y = _a.y,
    width = _a.width,
    height = _a.height;
  // If DOMRectReadOnly is available use it as a prototype for the rectangle.
  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  // Rectangle's properties are not writable and non-enumerable.
  defineConfigurable(rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
  /**
   * Creates an instance of ResizeObservation.
   *
   * @param {Element} target - Element to be observed.
   */
  function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;
    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;
    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  /**
   * Updates content rectangle and tells whether it's width or height properties
   * have changed since the last broadcast.
   *
   * @returns {boolean}
   */
  ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  /**
   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
   * from the corresponding properties of the last observed content rectangle.
   *
   * @returns {DOMRectInit} Last observed content rectangle.
   */
  ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */function () {
  /**
   * Creates an instance of ResizeObserverEntry.
   *
   * @param {Element} target - Element that is being observed.
   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
   */
  function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, {
      target: target,
      contentRect: contentRect
    });
  }
  return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback function that is invoked
   *      when one of the observed elements changes it's content dimensions.
   * @param {ResizeObserverController} controller - Controller instance which
   *      is responsible for the updates of observer.
   * @param {ResizeObserver} callbackCtx - Reference to the public
   *      ResizeObserver instance which will be passed to callback function.
   */
  function ResizeObserverSPI(callback, controller, callbackCtx) {
    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];
    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();
    if (typeof callback !== 'function') {
      throw new TypeError('The callback provided as parameter 1 is not a function.');
    }
    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  /**
   * Starts observing provided element.
   *
   * @param {Element} target - Element to be observed.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is already being observed.
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    // Force the update of observations.
    this.controller_.refresh();
  };
  /**
   * Stops observing provided element.
   *
   * @param {Element} target - Element to stop observing.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
      return;
    }
    observations["delete"](target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  /**
   * Stops observing all elements.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  /**
   * Collects observation instances the associated element of which has changed
   * it's content rectangle.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.gatherActive = function () {
    var _this = this;
    this.clearActive();
    this.observations_.forEach(function (observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  /**
   * Invokes initial callback function with a list of ResizeObserverEntry
   * instances collected from active resize observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  /**
   * Clears the collection of active observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
  };
  /**
   * Tells whether observer has active observations.
   *
   * @returns {boolean}
   */
  ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback that is invoked when
   *      dimensions of the observed elements change.
   */
  function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
      throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
  ResizeObserver.prototype[method] = function () {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index = function () {
  // Export existing implementation if available.
  if (typeof global$1.ResizeObserver !== 'undefined') {
    return global$1.ResizeObserver;
  }
  return ResizeObserver;
}();

var useEffectWithTarget = createEffectWithTarget$1(useLayoutEffect);
var useLayoutEffectWithTarget = useEffectWithTarget;

var useIsomorphicLayoutEffectWithTarget = isBrowser$3 ? useLayoutEffectWithTarget : useEffectWithTarget$2;
var useIsomorphicLayoutEffectWithTarget$1 = useIsomorphicLayoutEffectWithTarget;

function useSize(target) {
  var _a = __read(useRafState(function () {
      var el = getTargetElement(target);
      return el ? {
        width: el.clientWidth,
        height: el.clientHeight
      } : undefined;
    }), 2),
    state = _a[0],
    setState = _a[1];
  useIsomorphicLayoutEffectWithTarget$1(function () {
    var el = getTargetElement(target);
    if (!el) {
      return;
    }
    var resizeObserver = new index(function (entries) {
      entries.forEach(function (entry) {
        var _a = entry.target,
          clientWidth = _a.clientWidth,
          clientHeight = _a.clientHeight;
        setState({
          width: clientWidth,
          height: clientHeight
        });
      });
    });
    resizeObserver.observe(el);
    return function () {
      resizeObserver.disconnect();
    };
  }, [], target);
  return state;
}

function useThrottleFn(fn, options) {
  var _a;
  if (isDev$1) {
    if (!isFunction$1(fn)) {
      console.error("useThrottleFn expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = useLatest(fn);
  var wait = (_a = options === null || options === void 0 ? void 0 : options.wait) !== null && _a !== void 0 ? _a : 1000;
  var throttled = useMemo(function () {
    return throttle$1(function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return fnRef.current.apply(fnRef, __spreadArray([], __read(args), false));
    }, wait, options);
  }, []);
  useUnmount$1(function () {
    throttled.cancel();
  });
  return {
    run: throttled,
    cancel: throttled.cancel,
    flush: throttled.flush
  };
}

/**
 * 화면 크기가 아닌 userAgent를 검사하여 모바일 환경인지 검사합니다.
 */
var useIsMobileEnv = function useIsMobileEnv() {
  var _a = useState(false),
    isMobile = _a[0],
    setIsMobile = _a[1];
  useEffect(function () {
    var checkIsMobile = function checkIsMobile() {
      var userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
      var mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      setIsMobile(mobile || 'ontouchstart' in window && window.innerWidth <= 1024);
    };
    checkIsMobile();
  }, []);
  return isMobile;
};

var useResolution = function useResolution(props) {
  var isFullscreen = props.isFullscreen,
    containerRef = props.containerRef,
    setResolution = props.setResolution,
    userSetResolution = props.userSetResolution;
  var size = useSize(containerRef);
  var isMobileEnv = useIsMobileEnv();
  useEffect(function () {
    var _a;
    if (userSetResolution) return;
    // 전체화면일 경우 무조건 1080으로 설정
    if (isFullscreen) {
      setResolution(1080);
      return;
    }
    // 모바일 환경일 경우 전체화면인 경우를 제외하고 무조건 360p로 설정합니다.
    if (isMobileEnv) {
      setResolution(360);
      return;
    }
    // 플레이어 가로폭이 666px보다 작을 경우 360p로 전환
    if (((_a = size === null || size === void 0 ? void 0 : size.width) !== null && _a !== void 0 ? _a : 0) <= 666) {
      setResolution(360);
    } else {
      setResolution(1080);
    }
  }, [isFullscreen, isMobileEnv, userSetResolution, size === null || size === void 0 ? void 0 : size.width]);
};

var useTime = function useTime(props) {
  var originalApiKey = props.originalApiKey,
    position = props.position;
  var _a = useState(false),
    isInitialized = _a[0],
    setIsInitialized = _a[1];
  var _b = useState(0),
    now = _b[0],
    setNow = _b[1];
  var _c = useState(now),
    initTs = _c[0],
    setInitTs = _c[1];
  var _d = useState(now),
    currentTs = _d[0],
    setCurrentTs = _d[1];
  var _e = useState(sub(new Date(now), {
      minutes: 30
    }).getTime()),
    startTs = _e[0],
    setStartTs = _e[1];
  var getTokenInfo = function getTokenInfo() {
    if (!originalApiKey) return null;
    return JSON.parse(atob(originalApiKey));
  };
  var getNow = function getNow() {
    var tokenInfo = getTokenInfo();
    /**
     * 토큰 정보에 `hls_time` 속성이 있을 경우 해당 값을 liveSyncOffset으로 지정
     * liveSyncoffset은 초단위입니다.
     */
    var liveSyncOffset = (tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.hls_time) ? Number(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.hls_time) * 3 : DEFAULT_LIVE_SYNC_OFFSET;
    return sub(new Date(), {
      seconds: liveSyncOffset
    }).getTime();
  };
  var resetInitTime = function resetInitTime(forcePositionSet) {
    setIsInitialized(false);
    if (!originalApiKey) return;
    var now = getNow();
    /**
     * 포지션에 따라 현재 시간을 변경합니다.
     * 이때 position값이 변경될 때에만 다음의 로직이 동작할 수 있어야 하기 때문에
     * isInitialized가 true라면 position을 반영하지 않도록 하되,
     * forcePositionSet이 true라면 무조건 position을 반영하도록 합니다.
     * 이 방식은 아래의 useEffect들을 확인하면 구조를 이해할 수 있습니다.
     */
    if (!isInitialized || forcePositionSet) {
      if (position && position > 0) {
        now = addMinutes(now, position).getTime();
      } else if (position && position < 0) {
        now = subMinutes(now, position).getTime();
      }
    }
    logger$1.info('Initialize play time.');
    setInitTs(now);
    setCurrentTs(now);
    setStartTs(sub(new Date(now), {
      hours: 0.5
    }).getTime());
    setIsInitialized(true);
  };
  /**
   * Initialize timeline on change originalApiKey
   * 토큰이 변경되면 초기화합니다.
   */
  useEffect(function () {
    resetInitTime();
  }, [originalApiKey]);
  /**
   * initialize timeline on change position
   * 포지션값이 변경되면 초기화합니다.
   */
  useEffect(function () {
    resetInitTime(true);
  }, [position]);
  /**
   * 매초마다 현재시간을 갱신
   */
  useEffect(function () {
    var interval = setInterval(function () {
      // DEFAULT_LIVE_SYNC_OFFSET이 적용된 시간을 현재시간으로 인식
      var now = getNow();
      setNow(now);
    }, 1000);
    return function () {
      clearInterval(interval);
    };
  }, []);
  var endTs = useMemo(function () {
    return add$1(new Date(startTs), {
      hours: 1
    }).getTime();
  }, [startTs]);
  /**
   * 재생시점과 현재시간이 일치할 경우 true를 반환합니다.
   * 이때 일치 여부는 60초 이내로 판단합니다.
   */
  var isLive = useMemo(function () {
    var nowDate = new Date(now);
    var currentDate = new Date(currentTs);
    return differenceInSeconds(nowDate, currentDate) <= 60;
  }, [now, currentTs]);
  return {
    isInitialized: isInitialized,
    now: now,
    getNow: getNow,
    initTs: initTs,
    setInitTs: setInitTs,
    currentTs: currentTs,
    setCurrentTs: setCurrentTs,
    startTs: startTs,
    setStartTs: setStartTs,
    endTs: endTs,
    resetInitTime: resetInitTime,
    isLive: isLive
  };
};

var getPlayerTimeline = function getPlayerTimeline(context, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    var queryString, res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          queryString = new URLSearchParams({
            startTime: params.startTime.toString(),
            endTime: params.endTime.toString()
          }).toString();
          return [4 /*yield*/, createFetch(context, "player/timeline?".concat(queryString), {
            method: 'GET'
          })];
        case 1:
          res = _a.sent();
          return [4 /*yield*/, res.json()];
        case 2:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};

var useTimeline = function useTimeline(props) {
  var baseUrl = props.baseUrl,
    apiKey = props.apiKey,
    isInitialized = props.isInitialized,
    getNow = props.getNow,
    startTs = props.startTs,
    endTs = props.endTs;
  /**
   * 타임라인 쿼리
   * 특정 파라미터 조합의 키를 기준으로 타임라인 데이터를 캐싱합니다.
   * 이 상태를 다룰 때 주의할 점은 push 등의 메서드를 사용하지 않고
   * 아래와 같이 새로운 배열을 생성하여 react의 상태 관리 원칙과 동일하게 다루어야 합니다.
   *
   * ```ts
   * timelineQueries.current = [...timelineQueries.current, ...newQueries]
   * ```
   */
  var timelineQueries = useRef([]);
  var currentQueryKey = useRef({
    apiKey: apiKey,
    startTs: startTs,
    endTs: endTs
  });
  var _a = useState(false);
    _a[0];
    var setIsTimelineLoading = _a[1];
  /**
   * 타임라인 쿼리의 키값으로 쓰일 상태들이 변동될 때마다 currentQueryKey를 업데이트합니다.
   */
  useEffect(function () {
    currentQueryKey.current = {
      apiKey: apiKey,
      startTs: startTs,
      endTs: endTs
    };
  }, [apiKey, startTs, endTs]);
  /**
   * 라이브 시간대를 포함한 재생 유효 범위입니다.
   * 라이브 시간대는 아직 타임라인이 생성되지 않았을 수 있기 때문에 가상으로 2분 가량의 범위를 가상으로 만들어냅니다.
   * 특별한 경우가 아니라면 원본인 `timelineQueries`를 직접 참조하지 않도록 해야합니다.
   */
  var extractTimelineData = function extractTimelineData(quries) {
    /**
     * 현재 apiKey에 부합하는 쿼리를 찾아 timeline 배열로 변환합니다.
     */
    var timelineData = quries.filter(function (query) {
      return query.key.apiKey === apiKey;
    }).flatMap(function (query) {
      return query.data;
    });
    var sortedTimelineData = timelineData.sort(function (a, b) {
      return new Date(a.startTime).getTime() - new Date(b.startTime).getTime();
    });
    return sortedTimelineData.reduce(function (acc, currentItem) {
      var startTime = new Date(currentItem.startTime).getTime();
      var endTime = new Date(currentItem.endTime).getTime();
      if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || endTime <= startTime) {
        return acc;
      }
      var prevItem = acc[acc.length - 1];
      if (!prevItem) {
        return __spreadArray(__spreadArray([], acc, true), [{
          startTime: startTime,
          endTime: endTime
        }], false);
      }
      var prevEndTime = new Date(prevItem.endTime).getTime();
      if (startTime <= prevEndTime) {
        acc[acc.length - 1] = {
          startTime: prevItem.startTime,
          endTime: Math.max(prevEndTime, endTime)
        };
        return acc;
      }
      return __spreadArray(__spreadArray([], acc, true), [{
        startTime: startTime,
        endTime: endTime
      }], false);
    }, []);
  };
  var _b = useState([]),
    timelineDataWithLive = _b[0],
    setTimeDataWithLive = _b[1];
  var updateTimelineQuery = function updateTimelineQuery(queries) {
    timelineQueries.current = __spreadArray([], queries, true);
    setTimeDataWithLive(extractTimelineData(queries));
  };
  /**
   * 타임라인 쿼리를 안전하게 추가합니다.
   * 동일한 쿼리가 있다면 대치하고 없다면 추가하는 방식으로 데이터를 업데이트합니다.
   */
  var insertTimelineQuery = function insertTimelineQuery(newQuery) {
    var isAlreadyExist = false;
    // timelineQueries는 한 번 루프하여 동일한 쿼리가 있다면 데이터만 신규 데이터로 대치합니다.
    updateTimelineQuery(__spreadArray([], timelineQueries.current.map(function (query) {
      if (JSON.stringify(query.key) === JSON.stringify(newQuery.key)) {
        // 동일한 쿼리를 찾았다면 isAlreadyExist 플래그를 활성화합니다.
        isAlreadyExist = true;
        logger$1.debug('타임라인: 동일한 쿼리가 존재합니다. 데이터를 대치합니다.', {
          key: query.key,
          data: __spreadArray(__spreadArray([], query.data, true), newQuery.data, true)
        });
        return {
          key: query.key,
          data: __spreadArray(__spreadArray([], query.data, true), newQuery.data, true)
        };
      }
      return query;
    }), true));
    // 이미 동일한 쿼리가 있다면 별도의 추가 작업을 하지 않습니다.
    if (isAlreadyExist) return;
    // 새로운 쿼리를 추가합니다.
    updateTimelineQuery(__spreadArray(__spreadArray([], timelineQueries.current, true), [newQuery], false));
  };
  var resetTimelineQuery = function resetTimelineQuery() {
    updateTimelineQuery([]);
  };
  /**
   * 타임라인 데이터를 갱신합니다.
   */
  var fetchTimeline = function fetchTimeline(options) {
    return __awaiter(void 0, void 0, void 0, function () {
      var matchedTimelineCache, data, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!isInitialized) {
              logger$1.debug('아직 HLS가 초기화되지 않았습니다.');
              return [2 /*return*/];
            }
            /**
             * 동일한 쿼리가 존재할 경우 데이터를 요청하지 않습니다.
             * 단, force 옵션이 활성화되어 있을 경우 이 과정을 무시합니다. (중복 허용)
             */
            if (!(options === null || options === void 0 ? void 0 : options.force)) {
              matchedTimelineCache = timelineQueries.current.find(function (cache) {
                return JSON.stringify(cache.key) === JSON.stringify(currentQueryKey.current);
              });
              if (matchedTimelineCache) {
                if (isBefore(getNow(), matchedTimelineCache.key.endTs)) {
                  logger$1.debug('타임라인: 이미 데이터가 존재하는 시간대이기 때문에 데이터를 요청하지 않습니다.', currentQueryKey.current);
                  return [2 /*return*/];
                }
              }
            }

            setIsTimelineLoading(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            logger$1.debug('타임라인: 새로운 데이터를 불러옵니다.');
            return [4 /*yield*/, getPlayerTimeline({
              baseUrl: baseUrl,
              apiKey: apiKey
            }, {
              startTime: startTs,
              endTime: endTs
            })];
          case 2:
            data = _a.sent();
            if (!(data === null || data === void 0 ? void 0 : data.length)) return [2 /*return*/];
            /**
             * 데이터가 있다면 timelineQueries에 추가합니다.
             */
            insertTimelineQuery({
              key: currentQueryKey.current,
              data: data
            });
            return [3 /*break*/, 5];
          case 3:
            error_1 = _a.sent();
            logger$1.error('타임라인 데이터 로드 실패', error_1);
            return [3 /*break*/, 5];
          case 4:
            setIsTimelineLoading(false);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * apiKey가 변경될 경우 기존 캐싱된 타임라인 데이터를 제거하고
   * 새로운 타임라인 데이터를 불러옵니다.
   */
  useEffect(function () {
    // 타임라인 쿼리를 미리 초기화
    resetTimelineQuery();
    fetchTimeline({
      force: true
    });
  }, [apiKey]);
  /**
   * startTs가 바뀔 때마다 타임라인 데이터를 갱신합니다.
   */
  useEffect(function () {
    logger$1.debug('타임라인: startTs의 변경이 감지되어 타임라인 데이터를 새로 불러옵니다.');
    fetchTimeline();
  }, [startTs]);
  return {
    currentQueryKey: currentQueryKey,
    timelineQueries: timelineQueries,
    timelineDataWithLive: timelineDataWithLive,
    fetchTimeline: fetchTimeline,
    insertTimelineQuery: insertTimelineQuery
  };
};

function _toPrimitive$1(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function mapValues(input, fn) {
  var result = {};
  for (var _key in input) {
    result[_key] = fn(input[_key], _key);
  }
  return result;
}
var shouldApplyCompound = function shouldApplyCompound(compoundCheck, selections, defaultVariants) {
  for (var _i = 0, _Object$keys = Object.keys(compoundCheck); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var _selections$key;
    if (compoundCheck[key] !== ((_selections$key = selections[key]) !== null && _selections$key !== void 0 ? _selections$key : defaultVariants[key])) {
      return false;
    }
  }
  return true;
};
var createRuntimeFn = function createRuntimeFn(config) {
  var runtimeFn = function runtimeFn(options) {
    var className = config.defaultClassName;
    var selections = _objectSpread2$1(_objectSpread2$1({}, config.defaultVariants), options);
    for (var variantName in selections) {
      var _selections$variantNa;
      var variantSelection = (_selections$variantNa = selections[variantName]) !== null && _selections$variantNa !== void 0 ? _selections$variantNa : config.defaultVariants[variantName];
      if (variantSelection != null) {
        var selection = variantSelection;
        if (typeof selection === 'boolean') {
          // @ts-expect-error
          selection = selection === true ? 'true' : 'false';
        }
        var selectionClassName =
        // @ts-expect-error
        config.variantClassNames[variantName][selection];
        if (selectionClassName) {
          className += ' ' + selectionClassName;
        }
      }
    }
    var _iterator = _createForOfIteratorHelper(config.compoundVariants),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          compoundCheck = _step$value[0],
          compoundClassName = _step$value[1];
        if (shouldApplyCompound(compoundCheck, selections, config.defaultVariants)) {
          className += ' ' + compoundClassName;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return className;
  };
  runtimeFn.variants = function () {
    return Object.keys(config.variantClassNames);
  };
  runtimeFn.classNames = {
    get base() {
      return config.defaultClassName.split(' ')[0];
    },
    get variants() {
      return mapValues(config.variantClassNames, function (classNames) {
        return mapValues(classNames, function (className) {
          return className.split(' ')[0];
        });
      });
    }
  };
  return runtimeFn;
};

var container$2 = 'styles_container__1ukkljn3';
var mediaEmpty = 'styles_mediaEmpty__1ukkljn6';
var overlayLoading = createRuntimeFn({
  defaultClassName: 'styles_overlayLoading__1ukkljn9',
  variantClassNames: {
    loading: {
      "true": 'styles_overlayLoading_loading_true__1ukkljna'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var playerWrapper = createRuntimeFn({
  defaultClassName: 'styles_playerWrapper__1ukkljn0',
  variantClassNames: {
    aspectRatio: {
      '16:9': 'styles_playerWrapper_aspectRatio_16:9__1ukkljn1',
      full: 'styles_playerWrapper_aspectRatio_full__1ukkljn2'
    }
  },
  defaultVariants: {
    aspectRatio: '16:9'
  },
  compoundVariants: []
});
var toolbar = 'styles_toolbar__1ukkljnc';
var toolbarButton = createRuntimeFn({
  defaultClassName: 'styles_toolbarButton__1ukkljnd',
  variantClassNames: {
    variant: {
      ghost: 'styles_toolbarButton_variant_ghost__1ukkljne',
      filled: 'styles_toolbarButton_variant_filled__1ukkljnf',
      outline: 'styles_toolbarButton_variant_outline__1ukkljng'
    },
    layout: {
      iconOnly: 'styles_toolbarButton_layout_iconOnly__1ukkljnh',
      withText: 'styles_toolbarButton_layout_withText__1ukkljni'
    }
  },
  defaultVariants: {
    variant: 'ghost',
    layout: 'iconOnly'
  },
  compoundVariants: []
});
var videoElement = 'styles_videoElement__1ukkljn5';
var videoOverlay = createRuntimeFn({
  defaultClassName: 'styles_videoOverlay__1ukkljn7',
  variantClassNames: {
    hide: {
      "true": 'styles_videoOverlay_hide_true__1ukkljn8'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var videoWrapper = 'styles_videoWrapper__1ukkljn4';

var MediaPlayerEmpty = function MediaPlayerEmpty(props) {
  var aspectRatio = props.aspectRatio,
    wrapperProps = __rest(props, ["aspectRatio"]);
  return jsx("span", _assign$1({}, wrapperProps, {
    children: jsx("div", {
      className: playerWrapper({
        aspectRatio: aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : '16:9'
      }),
      children: jsxs("div", {
        className: mediaEmpty,
        children: [jsxs("svg", {
          width: "73",
          height: "72",
          viewBox: "0 0 73 72",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [jsx("rect", {
            x: "3.99976",
            y: "14",
            width: "46.8",
            height: "39.6",
            rx: "7.2",
            stroke: "#BFBFBF",
            strokeWidth: "3"
          }), jsx("path", {
            d: "M19.9998 27L34.3998 41.4",
            stroke: "#BFBFBF",
            strokeWidth: "3",
            strokeLinecap: "round"
          }), jsx("path", {
            d: "M34.4001 27L20.0001 41.4",
            stroke: "#BFBFBF",
            strokeWidth: "3",
            strokeLinecap: "round"
          }), jsx("path", {
            d: "M50.7996 25.6927L64.4333 19.4004C66.4721 18.4594 68.7996 19.9486 68.7996 22.1941V45.8062C68.7996 48.0516 66.4721 49.5408 64.4333 48.5999L50.7996 42.3075",
            stroke: "#BFBFBF",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })]
        }), jsx("div", {
          children: "\uCE74\uBA54\uB77C\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
        })]
      })
    })
  }));
};

var isTouchDevice = function isTouchDevice() {
  if (!window) return false;
  return /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
};

/**
 * 미디어 플레이어의 툴바 버튼 컴포넌트입니다.
 * Controls 영역의 기본 버튼들과 동일한 스타일을 제공합니다.
 *
 * @example
 * ```tsx
 * import { ToolbarButton } from '@caas/media-player';
 *
 * // 아이콘 전용 버튼 (기본)
 * <ToolbarButton onClick={handleCustomAction}>
 *   <CustomIcon />
 * </ToolbarButton>
 *
 * // 텍스트 포함 버튼
 * <ToolbarButton layout="withText" onClick={handleCustomAction}>
 *   <Icon />
 *   <span>다운로드</span>
 * </ToolbarButton>
 *
 * // Filled 스타일 버튼
 * <ToolbarButton variant="filled" layout="withText" onClick={handleCustomAction}>
 *   공유하기
 * </ToolbarButton>
 * ```
 */
var ToolbarButton = forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    _a = props.variant,
    variant = _a === void 0 ? 'ghost' : _a,
    _b = props.layout,
    layout = _b === void 0 ? 'iconOnly' : _b,
    rest = __rest(props, ["children", "className", "variant", "layout"]);
  return jsx("button", _assign$1({
    ref: ref,
    className: clsx(toolbarButton({
      variant: variant,
      layout: layout
    }), className)
  }, rest, {
    children: children
  }));
});
ToolbarButton.displayName = 'ToolbarButton';

var getPlayerCalendar = function getPlayerCalendar(context, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    var queryString, res, _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          queryString = new URLSearchParams(_assign$1({}, params)).toString();
          return [4 /*yield*/, createFetch(context, "player/calendar?".concat(queryString), {
            method: 'GET'
          })];
        case 1:
          res = _b.sent();
          if (!!res.ok) return [3 /*break*/, 3];
          _a = Error.bind;
          return [4 /*yield*/, res.json()];
        case 2:
          throw new (_a.apply(Error, [void 0, _b.sent()]))();
        case 3:
          return [4 /*yield*/, res.json()];
        case 4:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};

var useClickOutside = function useClickOutside(targetRef, onClickOutside) {
  /**
   * event target type error를 우회하기 위한 함수
   * @param e
   */
  function assertIsNode(e) {
    if (!e || !('nodeType' in e)) {
      throw new Error("Node expected");
    }
  }
  var handleClickOutside = function handleClickOutside(event) {
    var _a;
    assertIsNode(event.target);
    /**
     * If click outside, call `onClickOutside` function.
     */
    if (!((_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
      onClickOutside(event);
    }
  };
  useEffect(function () {
    if (!document) return;
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [targetRef.current, onClickOutside]);
};

var useIsMobile = function useIsMobile() {
  var _a = useState(false),
    isMobile = _a[0],
    setIsMobile = _a[1];
  var handleResize = function handleResize() {
    if (window.innerWidth <= MEDIA_MOBILE_MAX_WIDTH) {
      setIsMobile(true);
      return;
    }
    setIsMobile(false);
  };
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return isMobile;
};

var calendarCell = 'styles_calendarCell__4xfnjb7';
var calendarCellBlock = createRuntimeFn({
  defaultClassName: 'styles_calendarCellBlock__4xfnjb8',
  variantClassNames: {
    isSunday: {
      "true": 'styles_calendarCellBlock_isSunday_true__4xfnjb9'
    },
    isNotCurrentMonth: {
      "true": 'styles_calendarCellBlock_isNotCurrentMonth_true__4xfnjba'
    },
    isToday: {
      "true": 'styles_calendarCellBlock_isToday_true__4xfnjbb'
    },
    isSelected: {
      "true": 'styles_calendarCellBlock_isSelected_true__4xfnjbc'
    },
    disabled: {
      "true": 'styles_calendarCellBlock_disabled_true__4xfnjbd'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var calendarCellText = 'styles_calendarCellText__4xfnjbe';
var calendarChevron = 'styles_calendarChevron__4xfnjb2';
var calendarContainer = 'styles_calendarContainer__4xfnjb0';
var calendarControl = 'styles_calendarControl__4xfnjb1';
var calendarControlMonth = 'styles_calendarControlMonth__4xfnjb3';
var calendarHeaderCell = createRuntimeFn({
  defaultClassName: 'styles_calendarHeaderCell__4xfnjb5',
  variantClassNames: {
    isSunday: {
      "true": 'styles_calendarHeaderCell_isSunday_true__4xfnjb6'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var calendarRow = 'styles_calendarRow__4xfnjb4';

var Calendar = function Calendar(props) {
  var calendarData = props.calendarData,
    value = props.value,
    onChange = props.onChange,
    onChangeMonth = props.onChangeMonth;
  var intlFormat = useFormat().intlFormat;
  var nextMonth = function nextMonth() {
    onChangeMonth(addMonths(value, 1));
  };
  var prevMonth = function prevMonth() {
    onChangeMonth(subMonths(value, 1));
  };
  var daysOfWeek = Array.from({
    length: 7
  }).map(function (_, day) {
    return jsx("div", {
      className: calendarHeaderCell({
        isSunday: day === 0
      }),
      children: intlFormat(setDay(value, day), {
        weekday: 'short'
      })
    }, day);
  });
  var getCalendarWeeks = function getCalendarWeeks() {
    var start = startOfMonth(value);
    var end = endOfMonth(value);
    var weeks = eachWeekOfInterval({
      start: start,
      end: end
    });
    return weeks.map(function (weekStart) {
      var weekEnd = endOfWeek(weekStart);
      var weekDays = eachDayOfInterval({
        start: weekStart,
        end: weekEnd
      });
      return weekDays;
    });
  };

  return jsx(Fragment$1, {
    children: jsxs("div", {
      className: calendarContainer,
      children: [jsxs("div", {
        className: calendarControl,
        children: [jsx("button", {
          className: calendarChevron,
          onClick: prevMonth,
          children: jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            children: jsx("path", {
              d: "M14.5 17L9.5 12L14.5 7",
              stroke: "currentColor",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          })
        }), jsx("div", {
          className: calendarControlMonth,
          children: intlFormat(value, {
            year: 'numeric',
            month: 'short'
          })
        }), jsx("button", {
          className: calendarChevron,
          onClick: nextMonth,
          children: jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            children: jsx("path", {
              d: "M9.5 7L14.5 12L9.5 17",
              stroke: "currentColor",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          })
        })]
      }), jsx("div", {
        className: calendarRow,
        children: daysOfWeek
      }), getCalendarWeeks().map(function (week, rowIndex) {
        return jsx("div", {
          className: calendarRow,
          children: week.map(function (date, dayIndex) {
            var isValid = calendarData.some(function (e) {
              return isSameDay(date, e.date) && e.isExist;
            });
            var disabled = isAfter(date, new Date()) || !isValid;
            return jsx("div", {
              className: calendarCell,
              children: jsx("div", {
                className: calendarCellBlock({
                  isSelected: isSameDay(date, value),
                  isToday: isToday(date),
                  isSunday: isSunday(date),
                  isNotCurrentMonth: !isSameMonth(date, value),
                  disabled: disabled
                }),
                onClick: function onClick() {
                  if (disabled) return;
                  onChange(date);
                },
                children: jsx("div", {
                  className: calendarCellText,
                  children: date.getDate()
                })
              })
            }, dayIndex);
          })
        }, rowIndex);
      })]
    })
  });
};

var getPlayerDay = function getPlayerDay(context, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    var queryString, res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          queryString = new URLSearchParams({
            date: params.date,
            interval: params.interval.toString()
          }).toString();
          return [4 /*yield*/, createFetch(context, "player/day?".concat(queryString), {
            method: 'GET'
          })];
        case 1:
          res = _a.sent();
          return [4 /*yield*/, res.json()];
        case 2:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};

var column = 'styles_column__1edepkr3';
var columnItem = createRuntimeFn({
  defaultClassName: 'styles_columnItem__1edepkr5',
  variantClassNames: {
    disabled: {
      "true": 'styles_columnItem_disabled_true__1edepkr6'
    },
    textAlign: {
      left: 'styles_columnItem_textAlign_left__1edepkr7',
      right: 'styles_columnItem_textAlign_right__1edepkr8'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var columnWheel = 'styles_columnWheel__1edepkr4';
var container$1 = 'styles_container__1edepkr0';
var maskBottom = 'styles_maskBottom__1edepkr2';
var maskTop = 'styles_maskTop__1edepkr1';

var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/globals.ts
var globals_exports = {};
__export(globals_exports, {
  assign: function assign() {
    return _assign;
  },
  colors: function colors() {
    return _colors;
  },
  createStringInterpolator: function createStringInterpolator() {
    return _createStringInterpolator;
  },
  skipAnimation: function skipAnimation() {
    return _skipAnimation;
  },
  to: function to() {
    return _to;
  },
  willAdvance: function willAdvance() {
    return _willAdvance;
  }
});

// ../rafz/dist/react-spring_rafz.modern.mjs
var updateQueue = makeQueue();
var raf = function raf(fn) {
  return schedule(fn, updateQueue);
};
var writeQueue = makeQueue();
raf.write = function (fn) {
  return schedule(fn, writeQueue);
};
var onStartQueue = makeQueue();
raf.onStart = function (fn) {
  return schedule(fn, onStartQueue);
};
var onFrameQueue = makeQueue();
raf.onFrame = function (fn) {
  return schedule(fn, onFrameQueue);
};
var onFinishQueue = makeQueue();
raf.onFinish = function (fn) {
  return schedule(fn, onFinishQueue);
};
var timeouts = [];
raf.setTimeout = function (handler, ms) {
  var time = raf.now() + ms;
  var cancel = function cancel() {
    var i = timeouts.findIndex(function (t) {
      return t.cancel == cancel;
    });
    if (~i) timeouts.splice(i, 1);
    pendingCount -= ~i ? 1 : 0;
  };
  var timeout = {
    time: time,
    handler: handler,
    cancel: cancel
  };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start();
  return timeout;
};
var findTimeout = function findTimeout(time) {
  return ~(~timeouts.findIndex(function (t) {
    return t.time > time;
  }) || ~timeouts.length);
};
raf.cancel = function (fn) {
  onStartQueue["delete"](fn);
  onFrameQueue["delete"](fn);
  onFinishQueue["delete"](fn);
  updateQueue["delete"](fn);
  writeQueue["delete"](fn);
};
raf.sync = function (fn) {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};
raf.throttle = function (fn) {
  var lastArgs;
  function queuedFn() {
    try {
      fn.apply(void 0, _toConsumableArray(lastArgs));
    } finally {
      lastArgs = null;
    }
  }
  function throttled() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    lastArgs = args;
    raf.onStart(queuedFn);
  }
  throttled.handler = fn;
  throttled.cancel = function () {
    onStartQueue["delete"](queuedFn);
    lastArgs = null;
  };
  return throttled;
};
var nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame :
// eslint-disable-next-line @typescript-eslint/no-empty-function
function () {};
raf.use = function (impl) {
  return nativeRaf = impl;
};
raf.now = typeof performance != "undefined" ? function () {
  return performance.now();
} : Date.now;
raf.batchedUpdates = function (fn) {
  return fn();
};
raf["catch"] = console.error;
raf.frameLoop = "always";
raf.advance = function () {
  if (raf.frameLoop !== "demand") {
    console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
  } else {
    update();
  }
};
var ts = -1;
var pendingCount = 0;
var sync = false;
function schedule(fn, queue) {
  if (sync) {
    queue["delete"](fn);
    fn(0);
  } else {
    queue.add(fn);
    start();
  }
}
function start() {
  if (ts < 0) {
    ts = 0;
    if (raf.frameLoop !== "demand") {
      nativeRaf(loop);
    }
  }
}
function stop() {
  ts = -1;
}
function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}
function update() {
  var prevTs = ts;
  ts = raf.now();
  var count = findTimeout(ts);
  if (count) {
    eachSafely(timeouts.splice(0, count), function (t) {
      return t.handler();
    });
    pendingCount -= count;
  }
  if (!pendingCount) {
    stop();
    return;
  }
  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();
}
function makeQueue() {
  var next = /* @__PURE__ */new Set();
  var current = next;
  return {
    add: function add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },
    "delete": function _delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next["delete"](fn);
    },
    flush: function flush(arg) {
      if (current.size) {
        next = /* @__PURE__ */new Set();
        pendingCount -= current.size;
        eachSafely(current, function (fn) {
          return fn(arg) && next.add(fn);
        });
        pendingCount += next.size;
        current = next;
      }
    }
  };
}
function eachSafely(values, each2) {
  values.forEach(function (value) {
    try {
      each2(value);
    } catch (e) {
      raf["catch"](e);
    }
  });
}

// src/helpers.ts
function noop$1() {}
var defineHidden = function defineHidden(obj, key, value) {
  return Object.defineProperty(obj, key, {
    value: value,
    writable: true,
    configurable: true
  });
};
var is = {
  arr: Array.isArray,
  obj: function obj(a) {
    return !!a && a.constructor.name === "Object";
  },
  fun: function fun(a) {
    return typeof a === "function";
  },
  str: function str(a) {
    return typeof a === "string";
  },
  num: function num(a) {
    return typeof a === "number";
  },
  und: function und(a) {
    return a === void 0;
  }
};
function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  return a === b;
}
var each = function each(obj, fn) {
  return obj.forEach(fn);
};
function eachProp(obj, fn, ctx) {
  if (is.arr(obj)) {
    for (var i = 0; i < obj.length; i++) {
      fn.call(ctx, obj[i], "".concat(i));
    }
    return;
  }
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx, obj[key], key);
    }
  }
}
var toArray = function toArray(a) {
  return is.und(a) ? [] : is.arr(a) ? a : [a];
};
function flush(queue, iterator) {
  if (queue.size) {
    var items = Array.from(queue);
    queue.clear();
    each(items, iterator);
  }
}
var flushCalls = function flushCalls(queue) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  return flush(queue, function (fn) {
    return fn.apply(void 0, args);
  });
};
var isSSR = function isSSR() {
  return typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
};

// src/globals.ts
var _createStringInterpolator;
var _to;
var _colors = null;
var _skipAnimation = false;
var _willAdvance = noop$1;
var _assign = function _assign(globals) {
  if (globals.to) _to = globals.to;
  if (globals.now) raf.now = globals.now;
  if (globals.colors !== void 0) _colors = globals.colors;
  if (globals.skipAnimation != null) _skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator) _createStringInterpolator = globals.createStringInterpolator;
  if (globals.requestAnimationFrame) raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates) raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance) _willAdvance = globals.willAdvance;
  if (globals.frameLoop) raf.frameLoop = globals.frameLoop;
};

// src/FrameLoop.ts
var startQueue = /* @__PURE__ */new Set();
var currentFrame = [];
var prevFrame = [];
var priority = 0;
var frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },
  /** Advance the given animation on every frame until idle. */start: function start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },
  /** Advance all animations by the given time. */
  advance: advance,
  /** Call this when an animation's priority changes. */sort: function sort(animation) {
    if (priority) {
      raf.onFrame(function () {
        return frameLoop.sort(animation);
      });
    } else {
      var prevIndex = currentFrame.indexOf(animation);
      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear: function clear() {
    currentFrame = [];
    startQueue.clear();
  }
};
function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}
function startSafely(animation) {
  if (!currentFrame.includes(animation)) startUnsafely(animation);
}
function startUnsafely(animation) {
  currentFrame.splice(findIndex(currentFrame, function (other) {
    return other.priority > animation.priority;
  }), 0, animation);
}
function advance(dt) {
  var nextFrame = prevFrame;
  for (var i = 0; i < currentFrame.length; i++) {
    var animation = currentFrame[i];
    priority = animation.priority;
    if (!animation.idle) {
      _willAdvance(animation);
      animation.advance(dt);
      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }
  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}
function findIndex(arr, test) {
  var index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

// src/clamp.ts
var clamp$1 = function clamp(min, max, v) {
  return Math.min(Math.max(v, min), max);
};

// src/colors.ts
var colors2 = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};

// src/colorMatchers.ts
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call$1() {
  for (var _len3 = arguments.length, parts = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    parts[_key3] = arguments[_key3];
  }
  return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rgb = new RegExp("rgb" + call$1(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp("rgba" + call$1(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp("hsl" + call$1(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp("hsla" + call$1(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;

// src/normalizeColor.ts
function normalizeColor(color) {
  var match;
  if (typeof color === "number") {
    return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
  }
  if (match = hex6.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
  if (_colors && _colors[color] !== void 0) {
    return _colors[color];
  }
  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 |
    // r
    parse255(match[2]) << 16 |
    // g
    parse255(match[3]) << 8 |
    // b
    255) >>>
    // a
    0;
  }
  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 |
    // r
    parse255(match[2]) << 16 |
    // g
    parse255(match[3]) << 8 |
    // b
    parse1(match[4])) >>>
    // a
    0;
  }
  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] +
    // r
    match[2] + match[2] +
    // g
    match[3] + match[3] +
    // b
    "ff",
    // a
    16) >>> 0;
  }
  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;
  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] +
    // r
    match[2] + match[2] +
    // g
    match[3] + match[3] +
    // b
    match[4] + match[4],
    // a
    16) >>> 0;
  }
  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]),
    // h
    parsePercentage(match[2]),
    // s
    parsePercentage(match[3])
    // l
    ) | 255) >>>
    // a
    0;
  }
  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]),
    // h
    parsePercentage(match[2]),
    // s
    parsePercentage(match[3])
    // l
    ) | parse1(match[4])) >>>
    // a
    0;
  }
  return null;
}
function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslToRgb(h, s, l) {
  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2rgb(p, q, h + 1 / 3);
  var g = hue2rgb(p, q, h);
  var b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function parse255(str) {
  var _int = parseInt(str, 10);
  if (_int < 0) return 0;
  if (_int > 255) return 255;
  return _int;
}
function parse360(str) {
  var _int2 = parseFloat(str);
  return (_int2 % 360 + 360) % 360 / 360;
}
function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}
function parsePercentage(str) {
  var _int3 = parseFloat(str);
  if (_int3 < 0) return 0;
  if (_int3 > 100) return 1;
  return _int3 / 100;
}

// src/colorToRgba.ts
function colorToRgba(input) {
  var int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  var r = (int32Color & 4278190080) >>> 24;
  var g = (int32Color & 16711680) >>> 16;
  var b = (int32Color & 65280) >>> 8;
  var a = (int32Color & 255) / 255;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}

// src/createInterpolator.ts
var createInterpolator = function createInterpolator(range, output, extrapolate) {
  if (is.fun(range)) {
    return range;
  }
  if (is.arr(range)) {
    return createInterpolator({
      range: range,
      output: output,
      extrapolate: extrapolate
    });
  }
  if (is.str(range.output[0])) {
    return _createStringInterpolator(range);
  }
  var config = range;
  var outputRange = config.output;
  var inputRange = config.range || [0, 1];
  var extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
  var extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
  var easing = config.easing || function (t) {
    return t;
  };
  return function (input) {
    var range2 = findRange(input, inputRange);
    return interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
};
function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  var result = map ? map(input) : input;
  if (result < inputMin) {
    if (extrapolateLeft === "identity") return result;else if (extrapolateLeft === "clamp") result = inputMin;
  }
  if (result > inputMax) {
    if (extrapolateRight === "identity") return result;else if (extrapolateRight === "clamp") result = inputMax;
  }
  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}
function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;
  return i - 1;
}

// src/easings.ts
var steps = function steps(steps2) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "end";
  return function (progress2) {
    progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
    var expanded = progress2 * steps2;
    var rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
    return clamp$1(0, 1, rounded / steps2);
  };
};
var c1 = 1.70158;
var c2 = c1 * 1.525;
var c3 = c1 + 1;
var c4 = 2 * Math.PI / 3;
var c5 = 2 * Math.PI / 4.5;
var bounceOut = function bounceOut(x) {
  var n1 = 7.5625;
  var d1 = 2.75;
  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
};
var easings = {
  linear: function linear(x) {
    return x;
  },
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  easeOutQuad: function easeOutQuad(x) {
    return 1 - (1 - x) * (1 - x);
  },
  easeInOutQuad: function easeInOutQuad(x) {
    return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
  },
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  easeOutCubic: function easeOutCubic(x) {
    return 1 - Math.pow(1 - x, 3);
  },
  easeInOutCubic: function easeInOutCubic(x) {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  },
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  easeOutQuart: function easeOutQuart(x) {
    return 1 - Math.pow(1 - x, 4);
  },
  easeInOutQuart: function easeInOutQuart(x) {
    return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
  },
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  easeOutQuint: function easeOutQuint(x) {
    return 1 - Math.pow(1 - x, 5);
  },
  easeInOutQuint: function easeInOutQuint(x) {
    return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
  },
  easeInSine: function easeInSine(x) {
    return 1 - Math.cos(x * Math.PI / 2);
  },
  easeOutSine: function easeOutSine(x) {
    return Math.sin(x * Math.PI / 2);
  },
  easeInOutSine: function easeInOutSine(x) {
    return -(Math.cos(Math.PI * x) - 1) / 2;
  },
  easeInExpo: function easeInExpo(x) {
    return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
  },
  easeOutExpo: function easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  },
  easeInOutExpo: function easeInOutExpo(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2;
  },
  easeInCirc: function easeInCirc(x) {
    return 1 - Math.sqrt(1 - Math.pow(x, 2));
  },
  easeOutCirc: function easeOutCirc(x) {
    return Math.sqrt(1 - Math.pow(x - 1, 2));
  },
  easeInOutCirc: function easeInOutCirc(x) {
    return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
  },
  easeInBack: function easeInBack(x) {
    return c3 * x * x * x - c1 * x * x;
  },
  easeOutBack: function easeOutBack(x) {
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
  },
  easeInOutBack: function easeInOutBack(x) {
    return x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
  },
  easeInElastic: function easeInElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4);
  },
  easeOutElastic: function easeOutElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
  },
  easeInOutElastic: function easeInOutElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1;
  },
  easeInBounce: function easeInBounce(x) {
    return 1 - bounceOut(1 - x);
  },
  easeOutBounce: bounceOut,
  easeInOutBounce: function easeInOutBounce(x) {
    return x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2;
  },
  steps: steps
};

// src/fluids.ts
var $get = Symbol["for"]("FluidValue.get");
var $observers = Symbol["for"]("FluidValue.observers");
var hasFluidValue = function hasFluidValue(arg) {
  return Boolean(arg && arg[$get]);
};
var getFluidValue = function getFluidValue(arg) {
  return arg && arg[$get] ? arg[$get]() : arg;
};
var getFluidObservers = function getFluidObservers(target) {
  return target[$observers] || null;
};
function callFluidObserver(observer2, event) {
  if (observer2.eventObserved) {
    observer2.eventObserved(event);
  } else {
    observer2(event);
  }
}
function callFluidObservers(target, event) {
  var observers = target[$observers];
  if (observers) {
    observers.forEach(function (observer2) {
      callFluidObserver(observer2, event);
    });
  }
}
var FluidValue = /*#__PURE__*/_createClass(function FluidValue(get) {
  _classCallCheck(this, FluidValue);
  if (!get && !(get = this.get)) {
    throw Error("Unknown getter");
  }
  setFluidGetter(this, get);
});
var setFluidGetter = function setFluidGetter(target, get) {
  return setHidden(target, $get, get);
};
function addFluidObserver(target, observer2) {
  if (target[$get]) {
    var observers = target[$observers];
    if (!observers) {
      setHidden(target, $observers, observers = /* @__PURE__ */new Set());
    }
    if (!observers.has(observer2)) {
      observers.add(observer2);
      if (target.observerAdded) {
        target.observerAdded(observers.size, observer2);
      }
    }
  }
  return observer2;
}
function removeFluidObserver(target, observer2) {
  var observers = target[$observers];
  if (observers && observers.has(observer2)) {
    var count = observers.size - 1;
    if (count) {
      observers["delete"](observer2);
    } else {
      target[$observers] = null;
    }
    if (target.observerRemoved) {
      target.observerRemoved(count, observer2);
    }
  }
}
var setHidden = function setHidden(target, key, value) {
  return Object.defineProperty(target, key, {
    value: value,
    writable: true,
    configurable: true
  });
};

// src/regexs.ts
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var unitRegex = new RegExp("(".concat(numberRegex.source, ")(%|[a-z]+)"), "i");
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

// src/variableToRgba.ts
var variableToRgba = function variableToRgba(input) {
  var _parseCSSVariable = parseCSSVariable(input),
    _parseCSSVariable2 = _slicedToArray(_parseCSSVariable, 2),
    token = _parseCSSVariable2[0],
    fallback = _parseCSSVariable2[1];
  if (!token || isSSR()) {
    return input;
  }
  var value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith("--")) {
    var value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
    if (value2) {
      return value2;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }
  return input;
};
var parseCSSVariable = function parseCSSVariable(current) {
  var match = cssVariableRegex.exec(current);
  if (!match) return [,];
  var _match = _slicedToArray(match, 3),
    token = _match[1],
    fallback = _match[2];
  return [token, fallback];
};

// src/stringInterpolation.ts
var namedColorRegex;
var rgbaRound = function rgbaRound(_, p1, p2, p3, p4) {
  return "rgba(".concat(Math.round(p1), ", ").concat(Math.round(p2), ", ").concat(Math.round(p3), ", ").concat(p4, ")");
};
var createStringInterpolator2 = function createStringInterpolator2(config) {
  if (!namedColorRegex) namedColorRegex = _colors ?
  // match color names, ignore partial matches
  new RegExp("(".concat(Object.keys(_colors).join("|"), ")(?!\\w)"), "g") :
  // never match
  /^\b$/;
  var output = config.output.map(function (value) {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  var keyframes = output.map(function (value) {
    return value.match(numberRegex).map(Number);
  });
  var outputRanges = keyframes[0].map(function (_, i) {
    return keyframes.map(function (values) {
      if (!(i in values)) {
        throw Error('The arity of each "output" value must be equal');
      }
      return values[i];
    });
  });
  var interpolators = outputRanges.map(function (output2) {
    return createInterpolator(_objectSpread2$3(_objectSpread2$3({}, config), {}, {
      output: output2
    }));
  });
  return function (input) {
    var _output$find;
    var missingUnit = !unitRegex.test(output[0]) && ((_output$find = output.find(function (value) {
      return unitRegex.test(value);
    })) === null || _output$find === void 0 ? void 0 : _output$find.replace(numberRegex, ""));
    var i = 0;
    return output[0].replace(numberRegex, function () {
      return "".concat(interpolators[i++](input)).concat(missingUnit || "");
    }).replace(rgbaRegex, rgbaRound);
  };
};

// src/deprecations.ts
var prefix = "react-spring: ";
var once = function once(fn) {
  var func = fn;
  var called = false;
  if (typeof func != "function") {
    throw new TypeError("".concat(prefix, "once requires a function parameter"));
  }
  return function () {
    if (!called) {
      func.apply(void 0, arguments);
      called = true;
    }
  };
};
var warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate("".concat(prefix, "The \"interpolate\" function is deprecated in v9 (use \"to\" instead)"));
}
var warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall("".concat(prefix, "Directly calling start instead of using the api object is deprecated in v9 (use \".start\" instead), this will be removed in later 0.X.0 versions"));
}

// src/isAnimatedString.ts
function isAnimatedString(value) {
  return is.str(value) && (value[0] == "#" || /\d/.test(value) ||
  // Do not identify a CSS variable as an AnimatedString if its SSR
  !isSSR() && cssVariableRegex.test(value) || value in (_colors || {}));
}
var useIsomorphicLayoutEffect = isSSR() ? useEffect : useLayoutEffect;

// src/hooks/useIsMounted.ts
var useIsMounted = function useIsMounted() {
  var isMounted = useRef(false);
  useIsomorphicLayoutEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

// src/hooks/useForceUpdate.ts
function useForceUpdate() {
  var update2 = useState()[1];
  var isMounted = useIsMounted();
  return function () {
    if (isMounted.current) {
      update2(Math.random());
    }
  };
}
function useMemoOne(getResult, inputs) {
  var _useState = useState(function () {
      return {
        inputs: inputs,
        result: getResult()
      };
    }),
    _useState2 = _slicedToArray(_useState, 1),
    initial = _useState2[0];
  var committed = useRef();
  var prevCache = committed.current;
  var cache = prevCache;
  if (cache) {
    var useCache = Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs));
    if (!useCache) {
      cache = {
        inputs: inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }
  useEffect(function () {
    committed.current = cache;
    if (prevCache == initial) {
      initial.inputs = initial.result = void 0;
    }
  }, [cache]);
  return cache.result;
}
function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }
  for (var i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }
  return true;
}
var useOnce = function useOnce(effect) {
  return useEffect(effect, emptyDeps);
};
var emptyDeps = [];
function usePrev(value) {
  var prevRef = useRef();
  useEffect(function () {
    prevRef.current = value;
  });
  return prevRef.current;
}

var $node = Symbol["for"]("Animated:node");
var isAnimated = function isAnimated(value) {
  return !!value && value[$node] === value;
};
var getAnimated = function getAnimated(owner) {
  return owner && owner[$node];
};
var setAnimated = function setAnimated(owner, node) {
  return defineHidden(owner, $node, node);
};
var getPayload = function getPayload(owner) {
  return owner && owner[$node] && owner[$node].getPayload();
};
var Animated = /*#__PURE__*/function () {
  function Animated() {
    _classCallCheck(this, Animated);
    setAnimated(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  _createClass(Animated, [{
    key: "getPayload",
    value: function getPayload() {
      return this.payload || [];
    }
  }]);
  return Animated;
}();
var AnimatedValue = /*#__PURE__*/function (_Animated) {
  _inherits(AnimatedValue, _Animated);
  var _super = _createSuper(AnimatedValue);
  function AnimatedValue(_value) {
    var _this;
    _classCallCheck(this, AnimatedValue);
    _this = _super.call(this);
    _this._value = _value;
    _this.done = true;
    _this.durationProgress = 0;
    if (is.num(_this._value)) {
      _this.lastPosition = _this._value;
    }
    return _this;
  }
  /** @internal */
  _createClass(AnimatedValue, [{
    key: "getPayload",
    value: function getPayload() {
      return [this];
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this._value;
    }
  }, {
    key: "setValue",
    value: function setValue(value, step) {
      if (is.num(value)) {
        this.lastPosition = value;
        if (step) {
          value = Math.round(value / step) * step;
          if (this.done) {
            this.lastPosition = value;
          }
        }
      }
      if (this._value === value) {
        return false;
      }
      this._value = value;
      return true;
    }
  }, {
    key: "reset",
    value: function reset() {
      var done = this.done;
      this.done = false;
      if (is.num(this._value)) {
        this.elapsedTime = 0;
        this.durationProgress = 0;
        this.lastPosition = this._value;
        if (done) this.lastVelocity = null;
        this.v0 = null;
      }
    }
  }], [{
    key: "create",
    value: function create(value) {
      return new AnimatedValue(value);
    }
  }]);
  return AnimatedValue;
}(Animated);
var AnimatedString = /*#__PURE__*/function (_AnimatedValue) {
  _inherits(AnimatedString, _AnimatedValue);
  var _super2 = _createSuper(AnimatedString);
  function AnimatedString(value) {
    var _this2;
    _classCallCheck(this, AnimatedString);
    _this2 = _super2.call(this, 0);
    _this2._string = null;
    _this2._toString = createInterpolator({
      output: [value, value]
    });
    return _this2;
  }
  /** @internal */
  _createClass(AnimatedString, [{
    key: "getValue",
    value: function getValue() {
      var value = this._string;
      return value == null ? this._string = this._toString(this._value) : value;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      if (is.str(value)) {
        if (value == this._string) {
          return false;
        }
        this._string = value;
        this._value = 1;
      } else if (_get(_getPrototypeOf(AnimatedString.prototype), "setValue", this).call(this, value)) {
        this._string = null;
      } else {
        return false;
      }
      return true;
    }
  }, {
    key: "reset",
    value: function reset(goal) {
      if (goal) {
        this._toString = createInterpolator({
          output: [this.getValue(), goal]
        });
      }
      this._value = 0;
      _get(_getPrototypeOf(AnimatedString.prototype), "reset", this).call(this);
    }
  }], [{
    key: "create",
    value: function create(value) {
      return new AnimatedString(value);
    }
  }]);
  return AnimatedString;
}(AnimatedValue);

// src/context.ts
var TreeContext = {
  dependencies: null
};

// src/AnimatedObject.ts
var AnimatedObject = /*#__PURE__*/function (_Animated2) {
  _inherits(AnimatedObject, _Animated2);
  var _super3 = _createSuper(AnimatedObject);
  function AnimatedObject(source) {
    var _this3;
    _classCallCheck(this, AnimatedObject);
    _this3 = _super3.call(this);
    _this3.source = source;
    _this3.setValue(source);
    return _this3;
  }
  _createClass(AnimatedObject, [{
    key: "getValue",
    value: function getValue(animated) {
      var values = {};
      eachProp(this.source, function (source, key) {
        if (isAnimated(source)) {
          values[key] = source.getValue(animated);
        } else if (hasFluidValue(source)) {
          values[key] = getFluidValue(source);
        } else if (!animated) {
          values[key] = source;
        }
      });
      return values;
    }
    /** Replace the raw object data */
  }, {
    key: "setValue",
    value: function setValue(source) {
      this.source = source;
      this.payload = this._makePayload(source);
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.payload) {
        each(this.payload, function (node) {
          return node.reset();
        });
      }
    }
    /** Create a payload set. */
  }, {
    key: "_makePayload",
    value: function _makePayload(source) {
      if (source) {
        var payload = /* @__PURE__ */new Set();
        eachProp(source, this._addToPayload, payload);
        return Array.from(payload);
      }
    }
    /** Add to a payload set. */
  }, {
    key: "_addToPayload",
    value: function _addToPayload(source) {
      var _this4 = this;
      if (TreeContext.dependencies && hasFluidValue(source)) {
        TreeContext.dependencies.add(source);
      }
      var payload = getPayload(source);
      if (payload) {
        each(payload, function (node) {
          return _this4.add(node);
        });
      }
    }
  }]);
  return AnimatedObject;
}(Animated);

// src/AnimatedArray.ts
var AnimatedArray = /*#__PURE__*/function (_AnimatedObject) {
  _inherits(AnimatedArray, _AnimatedObject);
  var _super4 = _createSuper(AnimatedArray);
  function AnimatedArray(source) {
    _classCallCheck(this, AnimatedArray);
    return _super4.call(this, source);
  }
  /** @internal */
  _createClass(AnimatedArray, [{
    key: "getValue",
    value: function getValue() {
      return this.source.map(function (node) {
        return node.getValue();
      });
    }
  }, {
    key: "setValue",
    value: function setValue(source) {
      var payload = this.getPayload();
      if (source.length == payload.length) {
        return payload.map(function (node, i) {
          return node.setValue(source[i]);
        }).some(Boolean);
      }
      _get(_getPrototypeOf(AnimatedArray.prototype), "setValue", this).call(this, source.map(makeAnimated));
      return true;
    }
  }], [{
    key: "create",
    value: function create(source) {
      return new AnimatedArray(source);
    }
  }]);
  return AnimatedArray;
}(AnimatedObject);
function makeAnimated(value) {
  var nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}
function getAnimatedType(value) {
  var parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}
var withAnimated = function withAnimated(Component, host) {
  var hasInstance =
  // Function components must use "forwardRef" to avoid being
  // re-rendered on every animation frame.
  !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
  return forwardRef(function (givenProps, givenRef) {
    var instanceRef = useRef(null);
    var ref = hasInstance &&
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useCallback(function (value) {
      instanceRef.current = updateRef(givenRef, value);
    }, [givenRef]);
    var _getAnimatedState = getAnimatedState(givenProps, host),
      _getAnimatedState2 = _slicedToArray(_getAnimatedState, 2),
      props = _getAnimatedState2[0],
      deps = _getAnimatedState2[1];
    var forceUpdate = useForceUpdate();
    var callback = function callback() {
      var instance = instanceRef.current;
      if (hasInstance && !instance) {
        return;
      }
      var didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
      if (didUpdate === false) {
        forceUpdate();
      }
    };
    var observer = new PropsObserver(callback, deps);
    var observerRef = useRef();
    useIsomorphicLayoutEffect(function () {
      observerRef.current = observer;
      each(deps, function (dep) {
        return addFluidObserver(dep, observer);
      });
      return function () {
        if (observerRef.current) {
          each(observerRef.current.deps, function (dep) {
            return removeFluidObserver(dep, observerRef.current);
          });
          raf.cancel(observerRef.current.update);
        }
      };
    });
    useEffect(callback, []);
    useOnce(function () {
      return function () {
        var observer2 = observerRef.current;
        each(observer2.deps, function (dep) {
          return removeFluidObserver(dep, observer2);
        });
      };
    });
    var usedProps = host.getComponentProps(props.getValue());
    return /* @__PURE__ */React.createElement(Component, _objectSpread2$3(_objectSpread2$3({}, usedProps), {}, {
      ref: ref
    }));
  });
};
var PropsObserver = /*#__PURE__*/function () {
  function PropsObserver(update, deps) {
    _classCallCheck(this, PropsObserver);
    this.update = update;
    this.deps = deps;
  }
  _createClass(PropsObserver, [{
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        raf.write(this.update);
      }
    }
  }]);
  return PropsObserver;
}();
function getAnimatedState(props, host) {
  var dependencies = /* @__PURE__ */new Set();
  TreeContext.dependencies = dependencies;
  if (props.style) props = _objectSpread2$3(_objectSpread2$3({}, props), {}, {
    style: host.createAnimatedStyle(props.style)
  });
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}
function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref)) ref(value);else ref.current = value;
  }
  return value;
}

// src/createHost.ts
var cacheKey = Symbol["for"]("AnimatedComponent");
var createHost = function createHost(components) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$applyAnimatedVal = _ref.applyAnimatedValues,
    applyAnimatedValues = _ref$applyAnimatedVal === void 0 ? function () {
      return false;
    } : _ref$applyAnimatedVal,
    _ref$createAnimatedSt = _ref.createAnimatedStyle,
    createAnimatedStyle = _ref$createAnimatedSt === void 0 ? function (style) {
      return new AnimatedObject(style);
    } : _ref$createAnimatedSt,
    _ref$getComponentProp = _ref.getComponentProps,
    getComponentProps = _ref$getComponentProp === void 0 ? function (props) {
      return props;
    } : _ref$getComponentProp;
  var hostConfig = {
    applyAnimatedValues: applyAnimatedValues,
    createAnimatedStyle: createAnimatedStyle,
    getComponentProps: getComponentProps
  };
  var animated = function animated(Component) {
    var displayName = getDisplayName(Component) || "Anonymous";
    if (is.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }
    Component.displayName = "Animated(".concat(displayName, ")");
    return Component;
  };
  eachProp(components, function (Component, key) {
    if (is.arr(components)) {
      key = getDisplayName(Component);
    }
    animated[key] = animated(Component);
  });
  return {
    animated: animated
  };
};
var getDisplayName = function getDisplayName(arg) {
  return is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;
};

var _excluded$2 = ["children"];
function callProp(value) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return is.fun(value) ? value.apply(void 0, args) : value;
}
var matchProp = function matchProp(value, key) {
  return value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));
};
var resolveProp = function resolveProp(prop, key) {
  return is.obj(prop) ? key && prop[key] : prop;
};
var getDefaultProp = function getDefaultProp(props, key) {
  return props["default"] === true ? props[key] : props["default"] ? props["default"][key] : void 0;
};
var noopTransform = function noopTransform(value) {
  return value;
};
var getDefaultProps = function getDefaultProps(props) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noopTransform;
  var keys = DEFAULT_PROPS;
  if (props["default"] && props["default"] !== true) {
    props = props["default"];
    keys = Object.keys(props);
  }
  var defaults2 = {};
  var _iterator = _createForOfIteratorHelper(keys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      var value = transform(props[key], key);
      if (!is.und(value)) {
        defaults2[key] = value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return defaults2;
};
var DEFAULT_PROPS = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"];
var RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  "default": 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function getForwardProps(props) {
  var forward = {};
  var count = 0;
  eachProp(props, function (value, prop) {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });
  if (count) {
    return forward;
  }
}
function inferTo(props) {
  var to2 = getForwardProps(props);
  if (to2) {
    var out = {
      to: to2
    };
    eachProp(props, function (val, key) {
      return key in to2 || (out[key] = val);
    });
    return out;
  }
  return _objectSpread2$3({}, props);
}
function computeGoal(value) {
  value = getFluidValue(value);
  return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals_exports.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (var _ in props) return true;
  return false;
}
function isAsyncTo(to2) {
  return is.fun(to2) || is.arr(to2) && is.obj(to2[0]);
}
function detachRefs(ctrl, ref) {
  var _ctrl$ref;
  (_ctrl$ref = ctrl.ref) === null || _ctrl$ref === void 0 ? void 0 : _ctrl$ref["delete"](ctrl);
  ref === null || ref === void 0 ? void 0 : ref["delete"](ctrl);
}
function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    var _ctrl$ref2;
    (_ctrl$ref2 = ctrl.ref) === null || _ctrl$ref2 === void 0 ? void 0 : _ctrl$ref2["delete"](ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

// src/constants.ts
var config = {
  "default": {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};

// src/AnimationConfig.ts
var defaults = _objectSpread2$3(_objectSpread2$3({}, config["default"]), {}, {
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
});
var AnimationConfig = /*#__PURE__*/_createClass(function AnimationConfig() {
  _classCallCheck(this, AnimationConfig);
  /**
   * The initial velocity of one or more values.
   *
   * @default 0
   */
  this.velocity = 0;
  Object.assign(this, defaults);
});
function mergeConfig(config2, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = _objectSpread2$3({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = _objectSpread2$3(_objectSpread2$3({}, defaultConfig), newConfig);
  }
  sanitizeConfig(config2, newConfig);
  Object.assign(config2, newConfig);
  for (var key in defaults) {
    if (config2[key] == null) {
      config2[key] = defaults[key];
    }
  }
  var frequency = config2.frequency,
    damping = config2.damping;
  var mass = config2.mass;
  if (!is.und(frequency)) {
    if (frequency < 0.01) frequency = 0.01;
    if (damping < 0) damping = 0;
    config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config2.friction = 4 * Math.PI * damping * mass / frequency;
  }
  return config2;
}
function sanitizeConfig(config2, props) {
  if (!is.und(props.decay)) {
    config2.duration = void 0;
  } else {
    var isTensionConfig = !is.und(props.tension) || !is.und(props.friction);
    if (isTensionConfig || !is.und(props.frequency) || !is.und(props.damping) || !is.und(props.mass)) {
      config2.duration = void 0;
      config2.decay = void 0;
    }
    if (isTensionConfig) {
      config2.frequency = void 0;
    }
  }
}

// src/Animation.ts
var emptyArray = [];
var Animation = /*#__PURE__*/_createClass(function Animation() {
  _classCallCheck(this, Animation);
  this.changed = false;
  this.values = emptyArray;
  this.toValues = null;
  this.fromValues = emptyArray;
  this.config = new AnimationConfig();
  this.immediate = false;
});
function scheduleProps(callId, _ref) {
  var key = _ref.key,
    props = _ref.props,
    defaultProps = _ref.defaultProps,
    state = _ref.state,
    actions = _ref.actions;
  return new Promise(function (resolve, reject) {
    var _props$cancel;
    var delay;
    var timeout;
    var cancel = matchProp((_props$cancel = props.cancel) !== null && _props$cancel !== void 0 ? _props$cancel : defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.cancel, key);
    if (cancel) {
      onStart();
    } else {
      if (!is.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }
      var pause = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.pause;
      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }
      delay = callProp(props.delay || 0, key);
      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }
    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts["delete"](timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }
    function onResume() {
      if (delay > 0 && !globals_exports.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }
    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }
      state.pauseQueue["delete"](onPause);
      state.timeouts["delete"](timeout);
      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }
      try {
        actions.start(_objectSpread2$3(_objectSpread2$3({}, props), {}, {
          callId: callId,
          cancel: cancel
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

// src/AnimationResult.ts
var getCombinedResult = function getCombinedResult(target, results) {
  return results.length == 1 ? results[0] : results.some(function (result) {
    return result.cancelled;
  }) ? getCancelledResult(target.get()) : results.every(function (result) {
    return result.noop;
  }) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(function (result) {
    return result.finished;
  }));
};
var getNoopResult = function getNoopResult(value) {
  return {
    value: value,
    noop: true,
    finished: true,
    cancelled: false
  };
};
var getFinishedResult = function getFinishedResult(value, finished) {
  var cancelled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    value: value,
    finished: finished,
    cancelled: cancelled
  };
};
var getCancelledResult = function getCancelledResult(value) {
  return {
    value: value,
    cancelled: true,
    finished: false
  };
};

// src/runAsync.ts
function runAsync(to2, props, state, target) {
  var callId = props.callId,
    parentId = props.parentId,
    onRest = props.onRest;
  var prevTo = state.asyncTo,
    prevPromise = state.promise;
  if (!parentId && to2 === prevTo && !props.reset) {
    return prevPromise;
  }
  return state.promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var defaultProps, preventBail, bail, bailPromise, bailIfEnded, animate, result, animating;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          state.asyncId = callId;
          state.asyncTo = to2;
          defaultProps = getDefaultProps(props, function (value, key) {
            return (
              // The `onRest` prop is only called when the `runAsync` promise is resolved.
              key === "onRest" ? void 0 : value
            );
          });
          bailPromise = new Promise(function (resolve, reject) {
            return preventBail = resolve, bail = reject;
          });
          bailIfEnded = function bailIfEnded(bailSignal) {
            var bailResult =
            // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && getCancelledResult(target) ||
            // The async `to` prop was replaced.
            callId !== state.asyncId && getFinishedResult(target, false);
            if (bailResult) {
              bailSignal.result = bailResult;
              bail(bailSignal);
              throw bailSignal;
            }
          };
          animate = function animate(arg1, arg2) {
            var bailSignal = new BailSignal();
            var skipAnimationSignal = new SkipAnimationSignal();
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var props2, result2;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!globals_exports.skipAnimation) {
                      _context.next = 5;
                      break;
                    }
                    stopAsync(state);
                    skipAnimationSignal.result = getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                  case 5:
                    bailIfEnded(bailSignal);
                    props2 = is.obj(arg1) ? _objectSpread2$3({}, arg1) : _objectSpread2$3(_objectSpread2$3({}, arg2), {}, {
                      to: arg1
                    });
                    props2.parentId = callId;
                    eachProp(defaultProps, function (value, key) {
                      if (is.und(props2[key])) {
                        props2[key] = value;
                      }
                    });
                    _context.next = 11;
                    return target.start(props2);
                  case 11:
                    result2 = _context.sent;
                    bailIfEnded(bailSignal);
                    if (!state.paused) {
                      _context.next = 16;
                      break;
                    }
                    _context.next = 16;
                    return new Promise(function (resume) {
                      state.resumeQueue.add(resume);
                    });
                  case 16:
                    return _context.abrupt("return", result2);
                  case 17:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }))();
          };
          if (!globals_exports.skipAnimation) {
            _context3.next = 9;
            break;
          }
          stopAsync(state);
          return _context3.abrupt("return", getFinishedResult(target, false));
        case 9:
          _context3.prev = 9;
          if (is.arr(to2)) {
            animating = function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(queue) {
                var _iterator2, _step2, props2;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _iterator2 = _createForOfIteratorHelper(queue);
                      _context2.prev = 1;
                      _iterator2.s();
                    case 3:
                      if ((_step2 = _iterator2.n()).done) {
                        _context2.next = 9;
                        break;
                      }
                      props2 = _step2.value;
                      _context2.next = 7;
                      return animate(props2);
                    case 7:
                      _context2.next = 3;
                      break;
                    case 9:
                      _context2.next = 14;
                      break;
                    case 11:
                      _context2.prev = 11;
                      _context2.t0 = _context2["catch"](1);
                      _iterator2.e(_context2.t0);
                    case 14:
                      _context2.prev = 14;
                      _iterator2.f();
                      return _context2.finish(14);
                    case 17:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[1, 11, 14, 17]]);
              }));
              return function (_x) {
                return _ref4.apply(this, arguments);
              };
            }()(to2);
          } else {
            animating = Promise.resolve(to2(animate, target.stop.bind(target)));
          }
          _context3.next = 13;
          return Promise.all([animating.then(preventBail), bailPromise]);
        case 13:
          result = getFinishedResult(target.get(), true, false);
          _context3.next = 27;
          break;
        case 16:
          _context3.prev = 16;
          _context3.t0 = _context3["catch"](9);
          if (!(_context3.t0 instanceof BailSignal)) {
            _context3.next = 22;
            break;
          }
          result = _context3.t0.result;
          _context3.next = 27;
          break;
        case 22:
          if (!(_context3.t0 instanceof SkipAnimationSignal)) {
            _context3.next = 26;
            break;
          }
          result = _context3.t0.result;
          _context3.next = 27;
          break;
        case 26:
          throw _context3.t0;
        case 27:
          _context3.prev = 27;
          if (callId == state.asyncId) {
            state.asyncId = parentId;
            state.asyncTo = parentId ? prevTo : void 0;
            state.promise = parentId ? prevPromise : void 0;
          }
          return _context3.finish(27);
        case 30:
          if (is.fun(onRest)) {
            raf.batchedUpdates(function () {
              onRest(result, target, target.item);
            });
          }
          return _context3.abrupt("return", result);
        case 32:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[9, 16, 27, 30]]);
  }))();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, function (t) {
    return t.cancel();
  });
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = void 0;
  if (cancelId) state.cancelId = cancelId;
}
var BailSignal = /*#__PURE__*/function (_Error) {
  _inherits(BailSignal, _Error);
  var _super = _createSuper(BailSignal);
  function BailSignal() {
    _classCallCheck(this, BailSignal);
    return _super.call(this, "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
  }
  return _createClass(BailSignal);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var SkipAnimationSignal = /*#__PURE__*/function (_Error2) {
  _inherits(SkipAnimationSignal, _Error2);
  var _super2 = _createSuper(SkipAnimationSignal);
  function SkipAnimationSignal() {
    _classCallCheck(this, SkipAnimationSignal);
    return _super2.call(this, "SkipAnimationSignal");
  }
  return _createClass(SkipAnimationSignal);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var isFrameValue = function isFrameValue(value) {
  return value instanceof FrameValue;
};
var nextId = 1;
var FrameValue = /*#__PURE__*/function (_FluidValue) {
  _inherits(FrameValue, _FluidValue);
  var _super3 = _createSuper(FrameValue);
  function FrameValue() {
    var _this;
    _classCallCheck(this, FrameValue);
    _this = _super3.apply(this, arguments);
    _this.id = nextId++;
    _this._priority = 0;
    return _this;
  }
  _createClass(FrameValue, [{
    key: "priority",
    get: function get() {
      return this._priority;
    },
    set: function set(priority) {
      if (this._priority != priority) {
        this._priority = priority;
        this._onPriorityChange(priority);
      }
    }
    /** Get the current value */
  }, {
    key: "get",
    value: function get() {
      var node = getAnimated(this);
      return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */
  }, {
    key: "to",
    value: function to() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return globals_exports.to(this, args);
    }
    /** @deprecated Use the `to` method instead. */
  }, {
    key: "interpolate",
    value: function interpolate() {
      deprecateInterpolate();
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return globals_exports.to(this, args);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.get();
    }
  }, {
    key: "observerAdded",
    value: function observerAdded(count) {
      if (count == 1) this._attach();
    }
  }, {
    key: "observerRemoved",
    value: function observerRemoved(count) {
      if (count == 0) this._detach();
    }
    /** Called when the first child is added. */
  }, {
    key: "_attach",
    value: function _attach() {}
    /** Called when the last child is removed. */
  }, {
    key: "_detach",
    value: function _detach() {}
    /** Tell our children about our new value */
  }, {
    key: "_onChange",
    value: function _onChange(value) {
      var idle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      callFluidObservers(this, {
        type: "change",
        parent: this,
        value: value,
        idle: idle
      });
    }
    /** Tell our children about our new priority */
  }, {
    key: "_onPriorityChange",
    value: function _onPriorityChange(priority) {
      if (!this.idle) {
        frameLoop.sort(this);
      }
      callFluidObservers(this, {
        type: "priority",
        parent: this,
        priority: priority
      });
    }
  }]);
  return FrameValue;
}(FluidValue);

// src/SpringPhase.ts
var $P = Symbol["for"]("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;
var hasAnimated = function hasAnimated(target) {
  return (target[$P] & HAS_ANIMATED) > 0;
};
var isAnimating = function isAnimating(target) {
  return (target[$P] & IS_ANIMATING) > 0;
};
var isPaused = function isPaused(target) {
  return (target[$P] & IS_PAUSED) > 0;
};
var setActiveBit = function setActiveBit(target, active) {
  return active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
};
var setPausedBit = function setPausedBit(target, paused) {
  return paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;
};

// src/SpringValue.ts
var SpringValue = /*#__PURE__*/function (_FrameValue) {
  _inherits(SpringValue, _FrameValue);
  var _super4 = _createSuper(SpringValue);
  function SpringValue(arg1, arg2) {
    var _this2;
    _classCallCheck(this, SpringValue);
    _this2 = _super4.call(this);
    /** The animation state */
    _this2.animation = new Animation();
    /** Some props have customizable default values */
    _this2.defaultProps = {};
    /** The state for `runAsync` calls */
    _this2._state = {
      paused: false,
      delayed: false,
      pauseQueue: /* @__PURE__ */new Set(),
      resumeQueue: /* @__PURE__ */new Set(),
      timeouts: /* @__PURE__ */new Set()
    };
    /** The promise resolvers of pending `start` calls */
    _this2._pendingCalls = /* @__PURE__ */new Set();
    /** The counter for tracking `scheduleProps` calls */
    _this2._lastCallId = 0;
    /** The last `scheduleProps` call that changed the `to` prop */
    _this2._lastToId = 0;
    _this2._memoizedDuration = 0;
    if (!is.und(arg1) || !is.und(arg2)) {
      var props = is.obj(arg1) ? _objectSpread2$3({}, arg1) : _objectSpread2$3(_objectSpread2$3({}, arg2), {}, {
        from: arg1
      });
      if (is.und(props["default"])) {
        props["default"] = true;
      }
      _this2.start(props);
    }
    return _this2;
  }
  /** Equals true when not advancing on each frame. */
  _createClass(SpringValue, [{
    key: "idle",
    get: function get() {
      return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
    }
  }, {
    key: "goal",
    get: function get() {
      return getFluidValue(this.animation.to);
    }
  }, {
    key: "velocity",
    get: function get() {
      var node = getAnimated(this);
      return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map(function (node2) {
        return node2.lastVelocity || 0;
      });
    }
    /**
     * When true, this value has been animated at least once.
     */
  }, {
    key: "hasAnimated",
    get: function get() {
      return hasAnimated(this);
    }
    /**
     * When true, this value has an unfinished animation,
     * which is either active or paused.
     */
  }, {
    key: "isAnimating",
    get: function get() {
      return isAnimating(this);
    }
    /**
     * When true, all current and future animations are paused.
     */
  }, {
    key: "isPaused",
    get: function get() {
      return isPaused(this);
    }
    /**
     *
     *
     */
  }, {
    key: "isDelayed",
    get: function get() {
      return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */
  }, {
    key: "advance",
    value: function advance(dt) {
      var _this3 = this;
      var idle = true;
      var changed = false;
      var anim = this.animation;
      var toValues = anim.toValues;
      var config2 = anim.config;
      var payload = getPayload(anim.to);
      if (!payload && hasFluidValue(anim.to)) {
        toValues = toArray(getFluidValue(anim.to));
      }
      anim.values.forEach(function (node2, i) {
        if (node2.done) return;
        var to2 =
        // Animated strings always go from 0 to 1.
        node2.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
        var finished = anim.immediate;
        var position = to2;
        if (!finished) {
          position = node2.lastPosition;
          if (config2.tension <= 0) {
            node2.done = true;
            return;
          }
          var elapsed = node2.elapsedTime += dt;
          var from = anim.fromValues[i];
          var v0 = node2.v0 != null ? node2.v0 : node2.v0 = is.arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
          var velocity;
          var precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
          if (!is.und(config2.duration)) {
            var p = 1;
            if (config2.duration > 0) {
              if (_this3._memoizedDuration !== config2.duration) {
                _this3._memoizedDuration = config2.duration;
                if (node2.durationProgress > 0) {
                  node2.elapsedTime = config2.duration * node2.durationProgress;
                  elapsed = node2.elapsedTime += dt;
                }
              }
              p = (config2.progress || 0) + elapsed / _this3._memoizedDuration;
              p = p > 1 ? 1 : p < 0 ? 0 : p;
              node2.durationProgress = p;
            }
            position = from + config2.easing(p) * (to2 - from);
            velocity = (position - node2.lastPosition) / dt;
            finished = p == 1;
          } else if (config2.decay) {
            var decay = config2.decay === true ? 0.998 : config2.decay;
            var e = Math.exp(-(1 - decay) * elapsed);
            position = from + v0 / (1 - decay) * (1 - e);
            finished = Math.abs(node2.lastPosition - position) <= precision;
            velocity = v0 * e;
          } else {
            velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
            var restVelocity = config2.restVelocity || precision / 10;
            var bounceFactor = config2.clamp ? 0 : config2.bounce;
            var canBounce = !is.und(bounceFactor);
            var isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
            var isMoving;
            var isBouncing = false;
            var step = 1;
            var numSteps = Math.ceil(dt / step);
            for (var n = 0; n < numSteps; ++n) {
              isMoving = Math.abs(velocity) > restVelocity;
              if (!isMoving) {
                finished = Math.abs(to2 - position) <= precision;
                if (finished) {
                  break;
                }
              }
              if (canBounce) {
                isBouncing = position == to2 || position > to2 == isGrowing;
                if (isBouncing) {
                  velocity = -velocity * bounceFactor;
                  position = to2;
                }
              }
              var springForce = -config2.tension * 1e-6 * (position - to2);
              var dampingForce = -config2.friction * 1e-3 * velocity;
              var acceleration = (springForce + dampingForce) / config2.mass;
              velocity = velocity + acceleration * step;
              position = position + velocity * step;
            }
          }
          node2.lastVelocity = velocity;
          if (Number.isNaN(position)) {
            console.warn("Got NaN while animating:", _this3);
            finished = true;
          }
        }
        if (payload && !payload[i].done) {
          finished = false;
        }
        if (finished) {
          node2.done = true;
        } else {
          idle = false;
        }
        if (node2.setValue(position, config2.round)) {
          changed = true;
        }
      });
      var node = getAnimated(this);
      var currVal = node.getValue();
      if (idle) {
        var finalVal = getFluidValue(anim.to);
        if ((currVal !== finalVal || changed) && !config2.decay) {
          node.setValue(finalVal);
          this._onChange(finalVal);
        } else if (changed && config2.decay) {
          this._onChange(currVal);
        }
        this._stop();
      } else if (changed) {
        this._onChange(currVal);
      }
    }
    /** Set the current value, while stopping the current animation */
  }, {
    key: "set",
    value: function set(value) {
      var _this4 = this;
      raf.batchedUpdates(function () {
        _this4._stop();
        _this4._focus(value);
        _this4._set(value);
      });
      return this;
    }
    /**
     * Freeze the active animation in time, as well as any updates merged
     * before `resume` is called.
     */
  }, {
    key: "pause",
    value: function pause() {
      this._update({
        pause: true
      });
    }
    /** Resume the animation if paused. */
  }, {
    key: "resume",
    value: function resume() {
      this._update({
        pause: false
      });
    }
    /** Skip to the end of the current animation. */
  }, {
    key: "finish",
    value: function finish() {
      var _this5 = this;
      if (isAnimating(this)) {
        var _this$animation = this.animation,
          to2 = _this$animation.to,
          config2 = _this$animation.config;
        raf.batchedUpdates(function () {
          _this5._onStart();
          if (!config2.decay) {
            _this5._set(to2, false);
          }
          _this5._stop();
        });
      }
      return this;
    }
    /** Push props into the pending queue. */
  }, {
    key: "update",
    value: function update(props) {
      var queue = this.queue || (this.queue = []);
      queue.push(props);
      return this;
    }
  }, {
    key: "start",
    value: function start(to2, arg2) {
      var _this6 = this;
      var queue;
      if (!is.und(to2)) {
        queue = [is.obj(to2) ? to2 : _objectSpread2$3(_objectSpread2$3({}, arg2), {}, {
          to: to2
        })];
      } else {
        queue = this.queue || [];
        this.queue = [];
      }
      return Promise.all(queue.map(function (props) {
        var up = _this6._update(props);
        return up;
      })).then(function (results) {
        return getCombinedResult(_this6, results);
      });
    }
    /**
     * Stop the current animation, and cancel any delayed updates.
     *
     * Pass `true` to call `onRest` with `cancelled: true`.
     */
  }, {
    key: "stop",
    value: function stop(cancel) {
      var _this7 = this;
      var to2 = this.animation.to;
      this._focus(this.get());
      stopAsync(this._state, cancel && this._lastCallId);
      raf.batchedUpdates(function () {
        return _this7._stop(to2, cancel);
      });
      return this;
    }
    /** Restart the animation. */
  }, {
    key: "reset",
    value: function reset() {
      this._update({
        reset: true
      });
    }
    /** @internal */
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        this._start();
      } else if (event.type == "priority") {
        this.priority = event.priority + 1;
      }
    }
    /**
     * Parse the `to` and `from` range from the given `props` object.
     *
     * This also ensures the initial value is available to animated components
     * during the render phase.
     */
  }, {
    key: "_prepareNode",
    value: function _prepareNode(props) {
      var key = this.key || "";
      var to2 = props.to,
        from = props.from;
      to2 = is.obj(to2) ? to2[key] : to2;
      if (to2 == null || isAsyncTo(to2)) {
        to2 = void 0;
      }
      from = is.obj(from) ? from[key] : from;
      if (from == null) {
        from = void 0;
      }
      var range = {
        to: to2,
        from: from
      };
      if (!hasAnimated(this)) {
        if (props.reverse) {
          var _ref5 = [from, to2];
          to2 = _ref5[0];
          from = _ref5[1];
        }
        from = getFluidValue(from);
        if (!is.und(from)) {
          this._set(from);
        } else if (!getAnimated(this)) {
          this._set(to2);
        }
      }
      return range;
    }
    /** Every update is processed by this method before merging. */
  }, {
    key: "_update",
    value: function _update(_ref6, isLoop) {
      var _this8 = this;
      var props = _extends$1({}, (_objectDestructuringEmpty(_ref6), _ref6));
      var key = this.key,
        defaultProps = this.defaultProps;
      if (props["default"]) Object.assign(defaultProps, getDefaultProps(props, function (value, prop) {
        return /^on/.test(prop) ? resolveProp(value, key) : value;
      }));
      mergeActiveFn(this, props, "onProps");
      sendEvent(this, "onProps", props, this);
      var range = this._prepareNode(props);
      if (Object.isFrozen(this)) {
        throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
      }
      var state = this._state;
      return scheduleProps(++this._lastCallId, {
        key: key,
        props: props,
        defaultProps: defaultProps,
        state: state,
        actions: {
          pause: function pause() {
            if (!isPaused(_this8)) {
              setPausedBit(_this8, true);
              flushCalls(state.pauseQueue);
              sendEvent(_this8, "onPause", getFinishedResult(_this8, checkFinished(_this8, _this8.animation.to)), _this8);
            }
          },
          resume: function resume() {
            if (isPaused(_this8)) {
              setPausedBit(_this8, false);
              if (isAnimating(_this8)) {
                _this8._resume();
              }
              flushCalls(state.resumeQueue);
              sendEvent(_this8, "onResume", getFinishedResult(_this8, checkFinished(_this8, _this8.animation.to)), _this8);
            }
          },
          start: this._merge.bind(this, range)
        }
      }).then(function (result) {
        if (props.loop && result.finished && !(isLoop && result.noop)) {
          var nextProps = createLoopUpdate(props);
          if (nextProps) {
            return _this8._update(nextProps, true);
          }
        }
        return result;
      });
    }
    /** Merge props into the current animation */
  }, {
    key: "_merge",
    value: function _merge(range, props, resolve) {
      var _this9 = this;
      if (props.cancel) {
        this.stop(true);
        return resolve(getCancelledResult(this));
      }
      var hasToProp = !is.und(range.to);
      var hasFromProp = !is.und(range.from);
      if (hasToProp || hasFromProp) {
        if (props.callId > this._lastToId) {
          this._lastToId = props.callId;
        } else {
          return resolve(getCancelledResult(this));
        }
      }
      var key = this.key,
        defaultProps = this.defaultProps,
        anim = this.animation;
      var prevTo = anim.to,
        prevFrom = anim.from;
      var _range$to = range.to,
        to2 = _range$to === void 0 ? prevTo : _range$to,
        _range$from = range.from,
        from = _range$from === void 0 ? prevFrom : _range$from;
      if (hasFromProp && !hasToProp && (!props["default"] || is.und(to2))) {
        to2 = from;
      }
      if (props.reverse) {
        var _ref7 = [from, to2];
        to2 = _ref7[0];
        from = _ref7[1];
      }
      var hasFromChanged = !isEqual(from, prevFrom);
      if (hasFromChanged) {
        anim.from = from;
      }
      from = getFluidValue(from);
      var hasToChanged = !isEqual(to2, prevTo);
      if (hasToChanged) {
        this._focus(to2);
      }
      var hasAsyncTo = isAsyncTo(props.to);
      var config2 = anim.config;
      var decay = config2.decay,
        velocity = config2.velocity;
      if (hasToProp || hasFromProp) {
        config2.velocity = 0;
      }
      if (props.config && !hasAsyncTo) {
        mergeConfig(config2, callProp(props.config, key),
        // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
      }
      var node = getAnimated(this);
      if (!node || is.und(to2)) {
        return resolve(getFinishedResult(this, true));
      }
      var reset =
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      is.und(props.reset) ? hasFromProp && !props["default"] : !is.und(from) && matchProp(props.reset, key);
      var value = reset ? from : this.get();
      var goal = computeGoal(to2);
      var isAnimatable = is.num(goal) || is.arr(goal) || isAnimatedString(goal);
      var immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
      if (hasToChanged) {
        var nodeType = getAnimatedType(to2);
        if (nodeType !== node.constructor) {
          if (immediate) {
            node = this._set(goal);
          } else throw Error("Cannot animate between ".concat(node.constructor.name, " and ").concat(nodeType.name, ", as the \"to\" prop suggests"));
        }
      }
      var goalType = node.constructor;
      var started = hasFluidValue(to2);
      var finished = false;
      if (!started) {
        var hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
        if (hasToChanged || hasValueChanged) {
          finished = isEqual(computeGoal(value), goal);
          started = !finished;
        }
        if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config2.decay, decay) || !isEqual(config2.velocity, velocity)) {
          started = true;
        }
      }
      if (finished && isAnimating(this)) {
        if (anim.changed && !reset) {
          started = true;
        } else if (!started) {
          this._stop(prevTo);
        }
      }
      if (!hasAsyncTo) {
        if (started || hasFluidValue(prevTo)) {
          anim.values = node.getPayload();
          anim.toValues = hasFluidValue(to2) ? null : goalType == AnimatedString ? [1] : toArray(goal);
        }
        if (anim.immediate != immediate) {
          anim.immediate = immediate;
          if (!immediate && !reset) {
            this._set(prevTo);
          }
        }
        if (started) {
          var onRest = anim.onRest;
          each(ACTIVE_EVENTS, function (type) {
            return mergeActiveFn(_this9, props, type);
          });
          var result = getFinishedResult(this, checkFinished(this, prevTo));
          flushCalls(this._pendingCalls, result);
          this._pendingCalls.add(resolve);
          if (anim.changed) raf.batchedUpdates(function () {
            anim.changed = !reset;
            onRest === null || onRest === void 0 ? void 0 : onRest(result, _this9);
            if (reset) {
              callProp(defaultProps.onRest, result);
            } else {
              var _anim$onStart;
              (_anim$onStart = anim.onStart) === null || _anim$onStart === void 0 ? void 0 : _anim$onStart.call(anim, result, _this9);
            }
          });
        }
      }
      if (reset) {
        this._set(value);
      }
      if (hasAsyncTo) {
        resolve(runAsync(props.to, props, this._state, this));
      } else if (started) {
        this._start();
      } else if (isAnimating(this) && !hasToChanged) {
        this._pendingCalls.add(resolve);
      } else {
        resolve(getNoopResult(value));
      }
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */
  }, {
    key: "_focus",
    value: function _focus(value) {
      var anim = this.animation;
      if (value !== anim.to) {
        if (getFluidObservers(this)) {
          this._detach();
        }
        anim.to = value;
        if (getFluidObservers(this)) {
          this._attach();
        }
      }
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var priority = 0;
      var to2 = this.animation.to;
      if (hasFluidValue(to2)) {
        addFluidObserver(to2, this);
        if (isFrameValue(to2)) {
          priority = to2.priority + 1;
        }
      }
      this.priority = priority;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      var to2 = this.animation.to;
      if (hasFluidValue(to2)) {
        removeFluidObserver(to2, this);
      }
    }
    /**
     * Update the current value from outside the frameloop,
     * and return the `Animated` node.
     */
  }, {
    key: "_set",
    value: function _set(arg) {
      var _this10 = this;
      var idle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var value = getFluidValue(arg);
      if (!is.und(value)) {
        var oldNode = getAnimated(this);
        if (!oldNode || !isEqual(value, oldNode.getValue())) {
          var nodeType = getAnimatedType(value);
          if (!oldNode || oldNode.constructor != nodeType) {
            setAnimated(this, nodeType.create(value));
          } else {
            oldNode.setValue(value);
          }
          if (oldNode) {
            raf.batchedUpdates(function () {
              _this10._onChange(value, idle);
            });
          }
        }
      }
      return getAnimated(this);
    }
  }, {
    key: "_onStart",
    value: function _onStart() {
      var anim = this.animation;
      if (!anim.changed) {
        anim.changed = true;
        sendEvent(this, "onStart", getFinishedResult(this, checkFinished(this, anim.to)), this);
      }
    }
  }, {
    key: "_onChange",
    value: function _onChange(value, idle) {
      if (!idle) {
        this._onStart();
        callProp(this.animation.onChange, value, this);
      }
      callProp(this.defaultProps.onChange, value, this);
      _get(_getPrototypeOf(SpringValue.prototype), "_onChange", this).call(this, value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
  }, {
    key: "_start",
    value: function _start() {
      var anim = this.animation;
      getAnimated(this).reset(getFluidValue(anim.to));
      if (!anim.immediate) {
        anim.fromValues = anim.values.map(function (node) {
          return node.lastPosition;
        });
      }
      if (!isAnimating(this)) {
        setActiveBit(this, true);
        if (!isPaused(this)) {
          this._resume();
        }
      }
    }
  }, {
    key: "_resume",
    value: function _resume() {
      if (globals_exports.skipAnimation) {
        this.finish();
      } else {
        frameLoop.start(this);
      }
    }
    /**
     * Exit the frameloop and notify `onRest` listeners.
     *
     * Always wrap `_stop` calls with `batchedUpdates`.
     */
  }, {
    key: "_stop",
    value: function _stop(goal, cancel) {
      if (isAnimating(this)) {
        setActiveBit(this, false);
        var anim = this.animation;
        each(anim.values, function (node) {
          node.done = true;
        });
        if (anim.toValues) {
          anim.onChange = anim.onPause = anim.onResume = void 0;
        }
        callFluidObservers(this, {
          type: "idle",
          parent: this
        });
        var result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal !== null && goal !== void 0 ? goal : anim.to));
        flushCalls(this._pendingCalls, result);
        if (anim.changed) {
          anim.changed = false;
          sendEvent(this, "onRest", result, this);
        }
      }
    }
  }]);
  return SpringValue;
}(FrameValue);
function checkFinished(target, to2) {
  var goal = computeGoal(to2);
  var value = computeGoal(target.get());
  return isEqual(value, goal);
}
function createLoopUpdate(props) {
  var loop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.loop;
  var to2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : props.to;
  var loopRet = callProp(loop);
  if (loopRet) {
    var overrides = loopRet !== true && inferTo(loopRet);
    var reverse = (overrides || props).reverse;
    var reset = !overrides || overrides.reset;
    return createUpdate(_objectSpread2$3(_objectSpread2$3({}, props), {}, {
      loop: loop,
      // Avoid updating default props when looping.
      "default": false,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !reverse || isAsyncTo(to2) ? to2 : void 0,
      // Ignore the "from" prop except on reset.
      from: reset ? props.from : void 0,
      reset: reset
    }, overrides));
  }
}
function createUpdate(props) {
  var _props = props = inferTo(props),
    to2 = _props.to,
    from = _props.from;
  var keys = /* @__PURE__ */new Set();
  if (is.obj(to2)) findDefined(to2, keys);
  if (is.obj(from)) findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  var update2 = createUpdate(props);
  if (is.und(update2["default"])) {
    update2["default"] = getDefaultProps(update2);
  }
  return update2;
}
function findDefined(values, keys) {
  eachProp(values, function (value, key) {
    return value != null && keys.add(key);
  });
}
var ACTIVE_EVENTS = ["onStart", "onRest", "onChange", "onPause", "onResume"];
function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}
function sendEvent(target, type) {
  var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;
  for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    args[_key4 - 2] = arguments[_key4];
  }
  (_target$animation$typ = (_target$animation = target.animation)[type]) === null || _target$animation$typ === void 0 ? void 0 : _target$animation$typ.call.apply(_target$animation$typ, [_target$animation].concat(args));
  (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) === null || _target$defaultProps$ === void 0 ? void 0 : _target$defaultProps$.call.apply(_target$defaultProps$, [_target$defaultProps].concat(args));
}
var BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
var nextId2 = 1;
var Controller$1 = /*#__PURE__*/function () {
  function Controller(props, flush3) {
    _classCallCheck(this, Controller);
    this.id = nextId2++;
    /** The animated values */
    this.springs = {};
    /** The queue of props passed to the `update` method. */
    this.queue = [];
    /** The counter for tracking `scheduleProps` calls */
    this._lastAsyncId = 0;
    /** The values currently being animated */
    this._active = /* @__PURE__ */new Set();
    /** The values that changed recently */
    this._changed = /* @__PURE__ */new Set();
    /** Equals false when `onStart` listeners can be called */
    this._started = false;
    /** State used by the `runAsync` function */
    this._state = {
      paused: false,
      pauseQueue: /* @__PURE__ */new Set(),
      resumeQueue: /* @__PURE__ */new Set(),
      timeouts: /* @__PURE__ */new Set()
    };
    /** The event queues that are flushed once per frame maximum */
    this._events = {
      onStart: /* @__PURE__ */new Map(),
      onChange: /* @__PURE__ */new Map(),
      onRest: /* @__PURE__ */new Map()
    };
    this._onFrame = this._onFrame.bind(this);
    if (flush3) {
      this._flush = flush3;
    }
    if (props) {
      this.start(_objectSpread2$3({
        "default": true
      }, props));
    }
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  _createClass(Controller, [{
    key: "idle",
    get: function get() {
      return !this._state.asyncTo && Object.values(this.springs).every(function (spring) {
        return spring.idle && !spring.isDelayed && !spring.isPaused;
      });
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(item) {
      this._item = item;
    }
    /** Get the current values of our springs */
  }, {
    key: "get",
    value: function get() {
      var values = {};
      this.each(function (spring, key) {
        return values[key] = spring.get();
      });
      return values;
    }
    /** Set the current values without animating. */
  }, {
    key: "set",
    value: function set(values) {
      for (var key in values) {
        var value = values[key];
        if (!is.und(value)) {
          this.springs[key].set(value);
        }
      }
    }
    /** Push an update onto the queue of each value. */
  }, {
    key: "update",
    value: function update(props) {
      if (props) {
        this.queue.push(createUpdate(props));
      }
      return this;
    }
    /**
     * Start the queued animations for every spring, and resolve the returned
     * promise once all queued animations have finished or been cancelled.
     *
     * When you pass a queue (instead of nothing), that queue is used instead of
     * the queued animations added with the `update` method, which are left alone.
     */
  }, {
    key: "start",
    value: function start(props) {
      var queue = this.queue;
      if (props) {
        queue = toArray(props).map(createUpdate);
      } else {
        this.queue = [];
      }
      if (this._flush) {
        return this._flush(this, queue);
      }
      prepareKeys(this, queue);
      return flushUpdateQueue(this, queue);
    }
    /** @internal */
  }, {
    key: "stop",
    value: function stop(arg, keys) {
      if (arg !== !!arg) {
        keys = arg;
      }
      if (keys) {
        var springs = this.springs;
        each(toArray(keys), function (key) {
          return springs[key].stop(!!arg);
        });
      } else {
        stopAsync(this._state, this._lastAsyncId);
        this.each(function (spring) {
          return spring.stop(!!arg);
        });
      }
      return this;
    }
    /** Freeze the active animation in time */
  }, {
    key: "pause",
    value: function pause(keys) {
      if (is.und(keys)) {
        this.start({
          pause: true
        });
      } else {
        var springs = this.springs;
        each(toArray(keys), function (key) {
          return springs[key].pause();
        });
      }
      return this;
    }
    /** Resume the animation if paused. */
  }, {
    key: "resume",
    value: function resume(keys) {
      if (is.und(keys)) {
        this.start({
          pause: false
        });
      } else {
        var springs = this.springs;
        each(toArray(keys), function (key) {
          return springs[key].resume();
        });
      }
      return this;
    }
    /** Call a function once per spring value */
  }, {
    key: "each",
    value: function each(iterator) {
      eachProp(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */
  }, {
    key: "_onFrame",
    value: function _onFrame() {
      var _this11 = this;
      var _this$_events = this._events,
        onStart = _this$_events.onStart,
        onChange = _this$_events.onChange,
        onRest = _this$_events.onRest;
      var active = this._active.size > 0;
      var changed = this._changed.size > 0;
      if (active && !this._started || changed && !this._started) {
        this._started = true;
        flush(onStart, function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
            onStart2 = _ref9[0],
            result = _ref9[1];
          result.value = _this11.get();
          onStart2(result, _this11, _this11._item);
        });
      }
      var idle = !active && this._started;
      var values = changed || idle && onRest.size ? this.get() : null;
      if (changed && onChange.size) {
        flush(onChange, function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
            onChange2 = _ref11[0],
            result = _ref11[1];
          result.value = values;
          onChange2(result, _this11, _this11._item);
        });
      }
      if (idle) {
        this._started = false;
        flush(onRest, function (_ref12) {
          var _ref13 = _slicedToArray(_ref12, 2),
            onRest2 = _ref13[0],
            result = _ref13[1];
          result.value = values;
          onRest2(result, _this11, _this11._item);
        });
      }
    }
    /** @internal */
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        this._changed.add(event.parent);
        if (!event.idle) {
          this._active.add(event.parent);
        }
      } else if (event.type == "idle") {
        this._active["delete"](event.parent);
      } else return;
      raf.onFrame(this._onFrame);
    }
  }]);
  return Controller;
}();
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map(function (props) {
    return flushUpdate(ctrl, props);
  })).then(function (results) {
    return getCombinedResult(ctrl, results);
  });
}
function flushUpdate(_x2, _x3, _x4) {
  return _flushUpdate.apply(this, arguments);
}
function _flushUpdate() {
  _flushUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(ctrl, props, isLoop) {
    var keys, to2, from, loop, onRest, onResolve, defaults2, asyncTo, state, promises, cancel, result, nextProps;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          keys = props.keys, to2 = props.to, from = props.from, loop = props.loop, onRest = props.onRest, onResolve = props.onResolve;
          defaults2 = is.obj(props["default"]) && props["default"];
          if (loop) {
            props.loop = false;
          }
          if (to2 === false) props.to = null;
          if (from === false) props.from = null;
          asyncTo = is.arr(to2) || is.fun(to2) ? to2 : void 0;
          if (asyncTo) {
            props.to = void 0;
            props.onRest = void 0;
            if (defaults2) {
              defaults2.onRest = void 0;
            }
          } else {
            each(BATCHED_EVENTS, function (key) {
              var handler = props[key];
              if (is.fun(handler)) {
                var queue = ctrl["_events"][key];
                props[key] = function (_ref29) {
                  var finished = _ref29.finished,
                    cancelled = _ref29.cancelled;
                  var result2 = queue.get(handler);
                  if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                  } else {
                    queue.set(handler, {
                      value: null,
                      finished: finished || false,
                      cancelled: cancelled || false
                    });
                  }
                };
                if (defaults2) {
                  defaults2[key] = props[key];
                }
              }
            });
          }
          state = ctrl["_state"];
          if (props.pause === !state.paused) {
            state.paused = props.pause;
            flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
          } else if (state.paused) {
            props.pause = true;
          }
          promises = (keys || Object.keys(ctrl.springs)).map(function (key) {
            return ctrl.springs[key].start(props);
          });
          cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;
          if (asyncTo || cancel && state.asyncId) {
            promises.push(scheduleProps(++ctrl["_lastAsyncId"], {
              props: props,
              state: state,
              actions: {
                pause: noop$1,
                resume: noop$1,
                start: function start(props2, resolve) {
                  if (cancel) {
                    stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve(getCancelledResult(ctrl));
                  } else {
                    props2.onRest = onRest;
                    resolve(runAsync(asyncTo, props2, state, ctrl));
                  }
                }
              }
            }));
          }
          if (!state.paused) {
            _context4.next = 15;
            break;
          }
          _context4.next = 15;
          return new Promise(function (resume) {
            state.resumeQueue.add(resume);
          });
        case 15:
          _context4.t0 = getCombinedResult;
          _context4.t1 = ctrl;
          _context4.next = 19;
          return Promise.all(promises);
        case 19:
          _context4.t2 = _context4.sent;
          result = (0, _context4.t0)(_context4.t1, _context4.t2);
          if (!(loop && result.finished && !(isLoop && result.noop))) {
            _context4.next = 26;
            break;
          }
          nextProps = createLoopUpdate(props, loop, to2);
          if (!nextProps) {
            _context4.next = 26;
            break;
          }
          prepareKeys(ctrl, [nextProps]);
          return _context4.abrupt("return", flushUpdate(ctrl, nextProps, true));
        case 26:
          if (onResolve) {
            raf.batchedUpdates(function () {
              return onResolve(result, ctrl, ctrl.item);
            });
          }
          return _context4.abrupt("return", result);
        case 28:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _flushUpdate.apply(this, arguments);
}
function getSprings(ctrl, props) {
  var springs = _objectSpread2$3({}, ctrl.springs);
  if (props) {
    each(toArray(props), function (props2) {
      if (is.und(props2.keys)) {
        props2 = createUpdate(props2);
      }
      if (!is.obj(props2.to)) {
        props2 = _objectSpread2$3(_objectSpread2$3({}, props2), {}, {
          to: void 0
        });
      }
      prepareSprings(springs, props2, function (key) {
        return createSpring(key);
      });
    });
  }
  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp(springs, function (spring, key) {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}
function createSpring(key, observer) {
  var spring = new SpringValue();
  spring.key = key;
  if (observer) {
    addFluidObserver(spring, observer);
  }
  return spring;
}
function prepareSprings(springs, props, create) {
  if (props.keys) {
    each(props.keys, function (key) {
      var spring = springs[key] || (springs[key] = create(key));
      spring["_prepareNode"](props);
    });
  }
}
function prepareKeys(ctrl, queue) {
  each(queue, function (props) {
    prepareSprings(ctrl.springs, props, function (key) {
      return createSpring(key, ctrl);
    });
  });
}
var SpringContext = function SpringContext(_ref14) {
  var children = _ref14.children,
    props = _objectWithoutProperties$1(_ref14, _excluded$2);
  var inherited = useContext(ctx);
  var pause = props.pause || !!inherited.pause,
    immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(function () {
    return {
      pause: pause,
      immediate: immediate
    };
  }, [pause, immediate]);
  var Provider = ctx.Provider;
  return /* @__PURE__ */React.createElement(Provider, {
    value: props
  }, children);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init) {
  Object.assign(target, React.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}
var SpringRef = function SpringRef() {
  var current = [];
  var SpringRef2 = function SpringRef2(props) {
    deprecateDirectCall();
    var results = [];
    each(current, function (ctrl, i) {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        var update2 = _getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.current = current;
  SpringRef2.add = function (ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };
  SpringRef2["delete"] = function (ctrl) {
    var i = current.indexOf(ctrl);
    if (~i) current.splice(i, 1);
  };
  SpringRef2.pause = function () {
    var _arguments = arguments;
    each(current, function (ctrl) {
      return ctrl.pause.apply(ctrl, _toConsumableArray(_arguments));
    });
    return this;
  };
  SpringRef2.resume = function () {
    var _arguments2 = arguments;
    each(current, function (ctrl) {
      return ctrl.resume.apply(ctrl, _toConsumableArray(_arguments2));
    });
    return this;
  };
  SpringRef2.set = function (values) {
    each(current, function (ctrl, i) {
      var update2 = is.fun(values) ? values(i, ctrl) : values;
      if (update2) {
        ctrl.set(update2);
      }
    });
  };
  SpringRef2.start = function (props) {
    var _this12 = this;
    var results = [];
    each(current, function (ctrl, i) {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        var update2 = _this12._getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.stop = function () {
    var _arguments3 = arguments;
    each(current, function (ctrl) {
      return ctrl.stop.apply(ctrl, _toConsumableArray(_arguments3));
    });
    return this;
  };
  SpringRef2.update = function (props) {
    var _this13 = this;
    each(current, function (ctrl, i) {
      return ctrl.update(_this13._getProps(props, ctrl, i));
    });
    return this;
  };
  var _getProps = function _getProps(arg, ctrl, index) {
    return is.fun(arg) ? arg(index, ctrl) : arg;
  };
  SpringRef2._getProps = _getProps;
  return SpringRef2;
};

// src/hooks/useSprings.ts
function useSprings(length, props, deps) {
  var _arguments4 = arguments;
  var propsFn = is.fun(props) && props;
  if (propsFn && !deps) deps = [];
  var ref = useMemo(function () {
    return propsFn || _arguments4.length == 3 ? SpringRef() : void 0;
  }, []);
  var layoutId = useRef(0);
  var forceUpdate = useForceUpdate();
  var state = useMemo(function () {
    return {
      ctrls: [],
      queue: [],
      flush: function flush(ctrl, updates2) {
        var springs2 = getSprings(ctrl, updates2);
        var canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some(function (key) {
          return !ctrl.springs[key];
        });
        return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise(function (resolve) {
          setSprings(ctrl, springs2);
          state.queue.push(function () {
            resolve(flushUpdateQueue(ctrl, updates2));
          });
          forceUpdate();
        });
      }
    };
  }, []);
  var ctrls = useRef(_toConsumableArray(state.ctrls));
  var updates = [];
  var prevLength = usePrev(length) || 0;
  useMemo(function () {
    each(ctrls.current.slice(length, prevLength), function (ctrl) {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  useMemo(function () {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);
  function declareUpdates(startIndex, endIndex) {
    for (var i = startIndex; i < endIndex; i++) {
      var ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller$1(null, state.flush));
      var update2 = propsFn ? propsFn(i, ctrl) : props[i];
      if (update2) {
        updates[i] = declareUpdate(update2);
      }
    }
  }
  var springs = ctrls.current.map(function (ctrl, i) {
    return getSprings(ctrl, updates[i]);
  });
  var context = useContext(SpringContext);
  var prevContext = usePrev(context);
  var hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect(function () {
    layoutId.current++;
    state.ctrls = ctrls.current;
    var queue = state.queue;
    if (queue.length) {
      state.queue = [];
      each(queue, function (cb) {
        return cb();
      });
    }
    each(ctrls.current, function (ctrl, i) {
      ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
      if (hasContext) {
        ctrl.start({
          "default": context
        });
      }
      var update2 = updates[i];
      if (update2) {
        replaceRef(ctrl, update2.ref);
        if (ctrl.ref) {
          ctrl.queue.push(update2);
        } else {
          ctrl.start(update2);
        }
      }
    });
  });
  useOnce(function () {
    return function () {
      each(state.ctrls, function (ctrl) {
        return ctrl.stop(true);
      });
    };
  });
  var values = springs.map(function (x) {
    return _objectSpread2$3({}, x);
  });
  return ref ? [values, ref] : values;
}

// src/hooks/useSpring.ts
function useSpring(props, deps) {
  var isFn = is.fun(props);
  var _useSprings = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps),
    _useSprings2 = _slicedToArray(_useSprings, 2),
    _useSprings2$ = _slicedToArray(_useSprings2[0], 1),
    values = _useSprings2$[0],
    ref = _useSprings2[1];
  return isFn || arguments.length == 2 ? [values, ref] : values;
}
var Interpolation = /*#__PURE__*/function (_FrameValue2) {
  _inherits(Interpolation, _FrameValue2);
  var _super5 = _createSuper(Interpolation);
  function Interpolation(source, args) {
    var _this14;
    _classCallCheck(this, Interpolation);
    _this14 = _super5.call(this);
    _this14.source = source;
    /** Equals false when in the frameloop */
    _this14.idle = true;
    /** The inputs which are currently animating */
    _this14._active = /* @__PURE__ */new Set();
    _this14.calc = createInterpolator.apply(void 0, _toConsumableArray(args));
    var value = _this14._get();
    var nodeType = getAnimatedType(value);
    setAnimated(_assertThisInitialized(_this14), nodeType.create(value));
    return _this14;
  }
  _createClass(Interpolation, [{
    key: "advance",
    value: function advance(_dt) {
      var value = this._get();
      var oldValue = this.get();
      if (!isEqual(value, oldValue)) {
        getAnimated(this).setValue(value);
        this._onChange(value, this.idle);
      }
      if (!this.idle && checkIdle(this._active)) {
        becomeIdle(this);
      }
    }
  }, {
    key: "_get",
    value: function _get() {
      var inputs = is.arr(this.source) ? this.source.map(getFluidValue) : toArray(getFluidValue(this.source));
      return this.calc.apply(this, _toConsumableArray(inputs));
    }
  }, {
    key: "_start",
    value: function _start() {
      var _this15 = this;
      if (this.idle && !checkIdle(this._active)) {
        this.idle = false;
        each(getPayload(this), function (node) {
          node.done = false;
        });
        if (globals_exports.skipAnimation) {
          raf.batchedUpdates(function () {
            return _this15.advance();
          });
          becomeIdle(this);
        } else {
          frameLoop.start(this);
        }
      }
    }
    // Observe our sources only when we're observed.
  }, {
    key: "_attach",
    value: function _attach() {
      var _this16 = this;
      var priority = 1;
      each(toArray(this.source), function (source) {
        if (hasFluidValue(source)) {
          addFluidObserver(source, _this16);
        }
        if (isFrameValue(source)) {
          if (!source.idle) {
            _this16._active.add(source);
          }
          priority = Math.max(priority, source.priority + 1);
        }
      });
      this.priority = priority;
      this._start();
    }
    // Stop observing our sources once we have no observers.
  }, {
    key: "_detach",
    value: function _detach() {
      var _this17 = this;
      each(toArray(this.source), function (source) {
        if (hasFluidValue(source)) {
          removeFluidObserver(source, _this17);
        }
      });
      this._active.clear();
      becomeIdle(this);
    }
    /** @internal */
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        if (event.idle) {
          this.advance();
        } else {
          this._active.add(event.parent);
          this._start();
        }
      } else if (event.type == "idle") {
        this._active["delete"](event.parent);
      } else if (event.type == "priority") {
        this.priority = toArray(this.source).reduce(function (highest, parent) {
          return Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1);
        }, 0);
      }
    }
  }]);
  return Interpolation;
}(FrameValue);
function isIdle(source) {
  return source.idle !== false;
}
function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    each(getPayload(self), function (node) {
      node.done = true;
    });
    callFluidObservers(self, {
      type: "idle",
      parent: self
    });
  }
}
globals_exports.assign({
  createStringInterpolator: createStringInterpolator2,
  to: function to(source, args) {
    return new Interpolation(source, args);
  }
});

var _excluded$1 = ["style", "children", "scrollTop", "scrollLeft", "viewBox"],
  _excluded2 = ["x", "y", "z"],
  _excluded3 = ["scrollTop", "scrollLeft"];

// src/applyAnimatedValues.ts
var isCustomPropRE = /^--/;
function dangerousStyleValue(name, value) {
  if (value == null || typeof value === "boolean" || value === "") return "";
  if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px";
  return ("" + value).trim();
}
var attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }
  var isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
  var style = props.style,
    children = props.children,
    scrollTop = props.scrollTop,
    scrollLeft = props.scrollLeft,
    viewBox = props.viewBox,
    attributes = _objectWithoutProperties$1(props, _excluded$1);
  var values = Object.values(attributes);
  var names = Object.keys(attributes).map(function (name) {
    return isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g,
    // Attributes are written in dash case
    function (n) {
      return "-" + n.toLowerCase();
    }));
  });
  if (children !== void 0) {
    instance.textContent = children;
  }
  for (var name in style) {
    if (style.hasOwnProperty(name)) {
      var value = dangerousStyleValue(name, style[name]);
      if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }
  names.forEach(function (name, i) {
    instance.setAttribute(name, values[i]);
  });
  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }
  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
  if (viewBox !== void 0) {
    instance.setAttribute("viewBox", viewBox);
  }
}
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
var prefixKey = function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};
var prefixes = ["Webkit", "Ms", "Moz", "O"];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce(function (acc, prop) {
  prefixes.forEach(function (prefix) {
    return acc[prefixKey(prefix, prop)] = acc[prop];
  });
  return acc;
}, isUnitlessNumber);
var domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var pxTransforms = /^(translate)/;
var degTransforms = /^(rotate|skew)/;
var addUnit = function addUnit(value, unit) {
  return is.num(value) && value !== 0 ? value + unit : value;
};
var isValueIdentity = function isValueIdentity(value, id) {
  return is.arr(value) ? value.every(function (v) {
    return isValueIdentity(v, id);
  }) : is.num(value) ? value === id : parseFloat(value) === id;
};
var AnimatedStyle = /*#__PURE__*/function (_AnimatedObject) {
  _inherits(AnimatedStyle, _AnimatedObject);
  var _super = _createSuper(AnimatedStyle);
  function AnimatedStyle(_ref) {
    var x = _ref.x,
      y = _ref.y,
      z = _ref.z,
      style = _objectWithoutProperties$1(_ref, _excluded2);
    _classCallCheck(this, AnimatedStyle);
    var inputs = [];
    var transforms = [];
    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push(function (xyz) {
        return ["translate3d(".concat(xyz.map(function (v) {
          return addUnit(v, "px");
        }).join(","), ")"),
        // prettier-ignore
        isValueIdentity(xyz, 0)];
      });
    }
    eachProp(style, function (value, key) {
      if (key === "transform") {
        inputs.push([value || ""]);
        transforms.push(function (transform) {
          return [transform, transform === ""];
        });
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (is.und(value)) return;
        var unit = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
        inputs.push(toArray(value));
        transforms.push(key === "rotate3d" ? function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 4),
            x2 = _ref3[0],
            y2 = _ref3[1],
            z2 = _ref3[2],
            deg = _ref3[3];
          return ["rotate3d(".concat(x2, ",").concat(y2, ",").concat(z2, ",").concat(addUnit(deg, unit), ")"), isValueIdentity(deg, 0)];
        } : function (input) {
          return ["".concat(key, "(").concat(input.map(function (v) {
            return addUnit(v, unit);
          }).join(","), ")"), isValueIdentity(input, key.startsWith("scale") ? 1 : 0)];
        });
      }
    });
    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }
    return _super.call(this, style);
  }
  return _createClass(AnimatedStyle);
}(AnimatedObject);
var FluidTransform = /*#__PURE__*/function (_FluidValue) {
  _inherits(FluidTransform, _FluidValue);
  var _super2 = _createSuper(FluidTransform);
  function FluidTransform(inputs, transforms) {
    var _this;
    _classCallCheck(this, FluidTransform);
    _this = _super2.call(this);
    _this.inputs = inputs;
    _this.transforms = transforms;
    _this._value = null;
    return _this;
  }
  _createClass(FluidTransform, [{
    key: "get",
    value: function get() {
      return this._value || (this._value = this._get());
    }
  }, {
    key: "_get",
    value: function _get() {
      var _this2 = this;
      var transform = "";
      var identity = true;
      each(this.inputs, function (input, i) {
        var arg1 = getFluidValue(input[0]);
        var _this2$transforms$i = _this2.transforms[i](is.arr(arg1) ? arg1 : input.map(getFluidValue)),
          _this2$transforms$i2 = _slicedToArray(_this2$transforms$i, 2),
          t = _this2$transforms$i2[0],
          id = _this2$transforms$i2[1];
        transform += " " + t;
        identity = identity && id;
      });
      return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
  }, {
    key: "observerAdded",
    value: function observerAdded(count) {
      var _this3 = this;
      if (count == 1) each(this.inputs, function (input) {
        return each(input, function (value) {
          return hasFluidValue(value) && addFluidObserver(value, _this3);
        });
      });
    }
    // Stop observing our inputs once we have no observers.
  }, {
    key: "observerRemoved",
    value: function observerRemoved(count) {
      var _this4 = this;
      if (count == 0) each(this.inputs, function (input) {
        return each(input, function (value) {
          return hasFluidValue(value) && removeFluidObserver(value, _this4);
        });
      });
    }
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        this._value = null;
      }
      callFluidObservers(this, event);
    }
  }]);
  return FluidTransform;
}(FluidValue);

// src/primitives.ts
var primitives = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr",
// SVG
"circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"];
globals_exports.assign({
  batchedUpdates: unstable_batchedUpdates,
  createStringInterpolator: createStringInterpolator2,
  colors: colors2
});
var host = createHost(primitives, {
  applyAnimatedValues: applyAnimatedValues,
  createAnimatedStyle: function createAnimatedStyle(style) {
    return new AnimatedStyle(style);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: function getComponentProps(_ref4) {
    _ref4.scrollTop;
      _ref4.scrollLeft;
      var props = _objectWithoutProperties$1(_ref4, _excluded3);
    return props;
  }
});
var animated = host.animated;

function clamp(v, min, max) {
  return Math.max(min, Math.min(v, max));
}
var V = {
  toVector: function toVector(v, fallback) {
    if (v === undefined) v = fallback;
    return Array.isArray(v) ? v : [v, v];
  },
  add: function add(v1, v2) {
    return [v1[0] + v2[0], v1[1] + v2[1]];
  },
  sub: function sub(v1, v2) {
    return [v1[0] - v2[0], v1[1] - v2[1]];
  },
  addTo: function addTo(v1, v2) {
    v1[0] += v2[0];
    v1[1] += v2[1];
  },
  subTo: function subTo(v1, v2) {
    v1[0] -= v2[0];
    v1[1] -= v2[1];
  }
};
function rubberband$1(distance, dimension, constant) {
  if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, constant * 5);
  return distance * dimension * constant / (dimension + constant * distance);
}
function rubberbandIfOutOfBounds$1(position, min, max) {
  var constant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.15;
  if (constant === 0) return clamp(position, min, max);
  if (position < min) return -rubberband$1(min - position, max - min, constant) + min;
  if (position > max) return +rubberband$1(position - max, max - min, constant) + max;
  return position;
}
function computeRubberband(bounds, _ref, _ref2) {
  var _ref3 = _slicedToArray(_ref, 2),
    Vx = _ref3[0],
    Vy = _ref3[1];
  var _ref4 = _slicedToArray(_ref2, 2),
    Rx = _ref4[0],
    Ry = _ref4[1];
  var _bounds = _slicedToArray(bounds, 2),
    _bounds$ = _slicedToArray(_bounds[0], 2),
    X0 = _bounds$[0],
    X1 = _bounds$[1],
    _bounds$2 = _slicedToArray(_bounds[1], 2),
    Y0 = _bounds$2[0],
    Y1 = _bounds$2[1];
  return [rubberbandIfOutOfBounds$1(Vx, X0, X1, Rx), rubberbandIfOutOfBounds$1(Vy, Y0, Y1, Ry)];
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var EVENT_TYPE_MAP = {
  pointer: {
    start: 'down',
    change: 'move',
    end: 'up'
  },
  mouse: {
    start: 'down',
    change: 'move',
    end: 'up'
  },
  touch: {
    start: 'start',
    change: 'move',
    end: 'end'
  },
  gesture: {
    start: 'start',
    change: 'change',
    end: 'end'
  }
};
function capitalize(string) {
  if (!string) return '';
  return string[0].toUpperCase() + string.slice(1);
}
var actionsWithoutCaptureSupported = ['enter', 'leave'];
function hasCapture() {
  var capture = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var actionKey = arguments.length > 1 ? arguments[1] : undefined;
  return capture && !actionsWithoutCaptureSupported.includes(actionKey);
}
function toHandlerProp(device) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var deviceProps = EVENT_TYPE_MAP[device];
  var actionKey = deviceProps ? deviceProps[action] || action : action;
  return 'on' + capitalize(device) + capitalize(actionKey) + (hasCapture(capture, actionKey) ? 'Capture' : '');
}
var pointerCaptureEvents = ['gotpointercapture', 'lostpointercapture'];
function parseProp(prop) {
  var eventKey = prop.substring(2).toLowerCase();
  var passive = !!~eventKey.indexOf('passive');
  if (passive) eventKey = eventKey.replace('passive', '');
  var captureKey = pointerCaptureEvents.includes(eventKey) ? 'capturecapture' : 'capture';
  var capture = !!~eventKey.indexOf(captureKey);
  if (capture) eventKey = eventKey.replace('capture', '');
  return {
    device: eventKey,
    capture: capture,
    passive: passive
  };
}
function toDomEventType(device) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var deviceProps = EVENT_TYPE_MAP[device];
  var actionKey = deviceProps ? deviceProps[action] || action : action;
  return device + actionKey;
}
function isTouch(event) {
  return 'touches' in event;
}
function getPointerType(event) {
  if (isTouch(event)) return 'touch';
  if ('pointerType' in event) return event.pointerType;
  return 'mouse';
}
function getCurrentTargetTouchList(event) {
  return Array.from(event.touches).filter(function (e) {
    var _event$currentTarget, _event$currentTarget$;
    return e.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e.target));
  });
}
function getTouchList(event) {
  return event.type === 'touchend' || event.type === 'touchcancel' ? event.changedTouches : event.targetTouches;
}
function getValueEvent(event) {
  return isTouch(event) ? getTouchList(event)[0] : event;
}
function touchIds(event) {
  return getCurrentTargetTouchList(event).map(function (touch) {
    return touch.identifier;
  });
}
function pointerId(event) {
  var valueEvent = getValueEvent(event);
  return isTouch(event) ? valueEvent.identifier : valueEvent.pointerId;
}
function pointerValues(event) {
  var valueEvent = getValueEvent(event);
  return [valueEvent.clientX, valueEvent.clientY];
}
function getEventDetails(event) {
  var payload = {};
  if ('buttons' in event) payload.buttons = event.buttons;
  if ('shiftKey' in event) {
    var shiftKey = event.shiftKey,
      altKey = event.altKey,
      metaKey = event.metaKey,
      ctrlKey = event.ctrlKey;
    Object.assign(payload, {
      shiftKey: shiftKey,
      altKey: altKey,
      metaKey: metaKey,
      ctrlKey: ctrlKey
    });
  }
  return payload;
}
function call(v) {
  if (typeof v === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return v.apply(void 0, args);
  } else {
    return v;
  }
}
function noop() {}
function chain() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  if (fns.length === 0) return noop;
  if (fns.length === 1) return fns[0];
  return function () {
    var result;
    for (var _i = 0, _fns = fns; _i < _fns.length; _i++) {
      var fn = _fns[_i];
      result = fn.apply(this, arguments) || result;
    }
    return result;
  };
}
function assignDefault(value, fallback) {
  return Object.assign({}, fallback, value || {});
}
var BEFORE_LAST_KINEMATICS_DELAY = 32;
var Engine = /*#__PURE__*/function () {
  function Engine(ctrl, args, key) {
    _classCallCheck(this, Engine);
    this.ctrl = ctrl;
    this.args = args;
    this.key = key;
    if (!this.state) {
      this.state = {};
      this.computeValues([0, 0]);
      this.computeInitial();
      if (this.init) this.init();
      this.reset();
    }
  }
  _createClass(Engine, [{
    key: "state",
    get: function get() {
      return this.ctrl.state[this.key];
    },
    set: function set(state) {
      this.ctrl.state[this.key] = state;
    }
  }, {
    key: "shared",
    get: function get() {
      return this.ctrl.state.shared;
    }
  }, {
    key: "eventStore",
    get: function get() {
      return this.ctrl.gestureEventStores[this.key];
    }
  }, {
    key: "timeoutStore",
    get: function get() {
      return this.ctrl.gestureTimeoutStores[this.key];
    }
  }, {
    key: "config",
    get: function get() {
      return this.ctrl.config[this.key];
    }
  }, {
    key: "sharedConfig",
    get: function get() {
      return this.ctrl.config.shared;
    }
  }, {
    key: "handler",
    get: function get() {
      return this.ctrl.handlers[this.key];
    }
  }, {
    key: "reset",
    value: function reset() {
      var state = this.state,
        shared = this.shared,
        ingKey = this.ingKey,
        args = this.args;
      shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
      state._step = [false, false];
      state.intentional = false;
      state._movement = [0, 0];
      state._distance = [0, 0];
      state._direction = [0, 0];
      state._delta = [0, 0];
      state._bounds = [[-Infinity, Infinity], [-Infinity, Infinity]];
      state.args = args;
      state.axis = undefined;
      state.memo = undefined;
      state.elapsedTime = state.timeDelta = 0;
      state.direction = [0, 0];
      state.distance = [0, 0];
      state.overflow = [0, 0];
      state._movementBound = [false, false];
      state.velocity = [0, 0];
      state.movement = [0, 0];
      state.delta = [0, 0];
      state.timeStamp = 0;
    }
  }, {
    key: "start",
    value: function start(event) {
      var state = this.state;
      var config = this.config;
      if (!state._active) {
        this.reset();
        this.computeInitial();
        state._active = true;
        state.target = event.target;
        state.currentTarget = event.currentTarget;
        state.lastOffset = config.from ? call(config.from, state) : state.offset;
        state.offset = state.lastOffset;
        state.startTime = state.timeStamp = event.timeStamp;
      }
    }
  }, {
    key: "computeValues",
    value: function computeValues(values) {
      var state = this.state;
      state._values = values;
      state.values = this.config.transform(values);
    }
  }, {
    key: "computeInitial",
    value: function computeInitial() {
      var state = this.state;
      state._initial = state._values;
      state.initial = state.values;
    }
  }, {
    key: "compute",
    value: function compute(event) {
      var state = this.state,
        config = this.config,
        shared = this.shared;
      state.args = this.args;
      var dt = 0;
      if (event) {
        state.event = event;
        if (config.preventDefault && event.cancelable) state.event.preventDefault();
        state.type = event.type;
        shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
        shared.locked = !!document.pointerLockElement;
        Object.assign(shared, getEventDetails(event));
        shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
        dt = event.timeStamp - state.timeStamp;
        state.timeStamp = event.timeStamp;
        state.elapsedTime = state.timeStamp - state.startTime;
      }
      if (state._active) {
        var _absoluteDelta = state._delta.map(Math.abs);
        V.addTo(state._distance, _absoluteDelta);
      }
      if (this.axisIntent) this.axisIntent(event);
      var _state$_movement = _slicedToArray(state._movement, 2),
        _m0 = _state$_movement[0],
        _m1 = _state$_movement[1];
      var _config$threshold = _slicedToArray(config.threshold, 2),
        t0 = _config$threshold[0],
        t1 = _config$threshold[1];
      var _step = state._step,
        values = state.values;
      if (config.hasCustomTransform) {
        if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
        if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
      } else {
        if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
        if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
      }
      state.intentional = _step[0] !== false || _step[1] !== false;
      if (!state.intentional) return;
      var movement = [0, 0];
      if (config.hasCustomTransform) {
        var _values2 = _slicedToArray(values, 2),
          v0 = _values2[0],
          v1 = _values2[1];
        movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
        movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
      } else {
        movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
        movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
      }
      if (this.restrictToAxis && !state._blocked) this.restrictToAxis(movement);
      var previousOffset = state.offset;
      var gestureIsActive = state._active && !state._blocked || state.active;
      if (gestureIsActive) {
        state.first = state._active && !state.active;
        state.last = !state._active && state.active;
        state.active = shared[this.ingKey] = state._active;
        if (event) {
          if (state.first) {
            if ('bounds' in config) state._bounds = call(config.bounds, state);
            if (this.setup) this.setup();
          }
          state.movement = movement;
          this.computeOffset();
        }
      }
      var _state$offset = _slicedToArray(state.offset, 2),
        ox = _state$offset[0],
        oy = _state$offset[1];
      var _state$_bounds = _slicedToArray(state._bounds, 2),
        _state$_bounds$ = _slicedToArray(_state$_bounds[0], 2),
        x0 = _state$_bounds$[0],
        x1 = _state$_bounds$[1],
        _state$_bounds$2 = _slicedToArray(_state$_bounds[1], 2),
        y0 = _state$_bounds$2[0],
        y1 = _state$_bounds$2[1];
      state.overflow = [ox < x0 ? -1 : ox > x1 ? 1 : 0, oy < y0 ? -1 : oy > y1 ? 1 : 0];
      state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
      state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
      var rubberband = state._active ? config.rubberband || [0, 0] : [0, 0];
      state.offset = computeRubberband(state._bounds, state.offset, rubberband);
      state.delta = V.sub(state.offset, previousOffset);
      this.computeMovement();
      if (gestureIsActive && (!state.last || dt > BEFORE_LAST_KINEMATICS_DELAY)) {
        state.delta = V.sub(state.offset, previousOffset);
        var absoluteDelta = state.delta.map(Math.abs);
        V.addTo(state.distance, absoluteDelta);
        state.direction = state.delta.map(Math.sign);
        state._direction = state._delta.map(Math.sign);
        if (!state.first && dt > 0) {
          state.velocity = [absoluteDelta[0] / dt, absoluteDelta[1] / dt];
          state.timeDelta = dt;
        }
      }
    }
  }, {
    key: "emit",
    value: function emit() {
      var state = this.state;
      var shared = this.shared;
      var config = this.config;
      if (!state._active) this.clean();
      if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
      var memo = this.handler(_objectSpread2(_objectSpread2(_objectSpread2({}, shared), state), {}, _defineProperty$3({}, this.aliasKey, state.values)));
      if (memo !== undefined) state.memo = memo;
    }
  }, {
    key: "clean",
    value: function clean() {
      this.eventStore.clean();
      this.timeoutStore.clean();
    }
  }]);
  return Engine;
}();
function selectAxis(_ref3, threshold) {
  var _ref4 = _slicedToArray(_ref3, 2),
    dx = _ref4[0],
    dy = _ref4[1];
  var absDx = Math.abs(dx);
  var absDy = Math.abs(dy);
  if (absDx > absDy && absDx > threshold) {
    return 'x';
  }
  if (absDy > absDx && absDy > threshold) {
    return 'y';
  }
  return undefined;
}
var CoordinatesEngine = /*#__PURE__*/function (_Engine) {
  _inherits(CoordinatesEngine, _Engine);
  var _super = _createSuper(CoordinatesEngine);
  function CoordinatesEngine() {
    var _this;
    _classCallCheck(this, CoordinatesEngine);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "aliasKey", 'xy');
    return _this;
  }
  _createClass(CoordinatesEngine, [{
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(CoordinatesEngine.prototype), "reset", this).call(this);
      this.state.axis = undefined;
    }
  }, {
    key: "init",
    value: function init() {
      this.state.offset = [0, 0];
      this.state.lastOffset = [0, 0];
    }
  }, {
    key: "computeOffset",
    value: function computeOffset() {
      this.state.offset = V.add(this.state.lastOffset, this.state.movement);
    }
  }, {
    key: "computeMovement",
    value: function computeMovement() {
      this.state.movement = V.sub(this.state.offset, this.state.lastOffset);
    }
  }, {
    key: "axisIntent",
    value: function axisIntent(event) {
      var state = this.state;
      var config = this.config;
      if (!state.axis && event) {
        var threshold = _typeof(config.axisThreshold) === 'object' ? config.axisThreshold[getPointerType(event)] : config.axisThreshold;
        state.axis = selectAxis(state._movement, threshold);
      }
      state._blocked = (config.lockDirection || !!config.axis) && !state.axis || !!config.axis && config.axis !== state.axis;
    }
  }, {
    key: "restrictToAxis",
    value: function restrictToAxis(v) {
      if (this.config.axis || this.config.lockDirection) {
        switch (this.state.axis) {
          case 'x':
            v[1] = 0;
            break;
          case 'y':
            v[0] = 0;
            break;
        }
      }
    }
  }]);
  return CoordinatesEngine;
}(Engine);
var identity = function identity(v) {
  return v;
};
var DEFAULT_RUBBERBAND = 0.15;
var commonConfigResolver = {
  enabled: function enabled() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  },
  eventOptions: function eventOptions(value, _k, config) {
    return _objectSpread2(_objectSpread2({}, config.shared.eventOptions), value);
  },
  preventDefault: function preventDefault() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return value;
  },
  triggerAllEvents: function triggerAllEvents() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return value;
  },
  rubberband: function rubberband() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    switch (value) {
      case true:
        return [DEFAULT_RUBBERBAND, DEFAULT_RUBBERBAND];
      case false:
        return [0, 0];
      default:
        return V.toVector(value);
    }
  },
  from: function from(value) {
    if (typeof value === 'function') return value;
    if (value != null) return V.toVector(value);
  },
  transform: function transform(value, _k, config) {
    var transform = value || config.shared.transform;
    this.hasCustomTransform = !!transform;
    if (process.env.NODE_ENV === 'development') {
      var originalTransform = transform || identity;
      return function (v) {
        var r = originalTransform(v);
        if (!isFinite(r[0]) || !isFinite(r[1])) {
          console.warn("[@use-gesture]: config.transform() must produce a valid result, but it was: [".concat(r[0], ",").concat([1], "]"));
        }
        return r;
      };
    }
    return transform || identity;
  },
  threshold: function threshold(value) {
    return V.toVector(value, 0);
  }
};
if (process.env.NODE_ENV === 'development') {
  Object.assign(commonConfigResolver, {
    domTarget: function domTarget(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `domTarget` option has been renamed to `target`.");
      }
      return NaN;
    },
    lockDirection: function lockDirection(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `lockDirection` option has been merged with `axis`. Use it as in `{ axis: 'lock' }`");
      }
      return NaN;
    },
    initial: function initial(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `initial` option has been renamed to `from`.");
      }
      return NaN;
    }
  });
}
var DEFAULT_AXIS_THRESHOLD = 0;
var coordinatesConfigResolver = _objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  axis: function axis(_v, _k, _ref5) {
    var axis = _ref5.axis;
    this.lockDirection = axis === 'lock';
    if (!this.lockDirection) return axis;
  },
  axisThreshold: function axisThreshold() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AXIS_THRESHOLD;
    return value;
  },
  bounds: function bounds() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (typeof value === 'function') {
      return function (state) {
        return coordinatesConfigResolver.bounds(value(state));
      };
    }
    if ('current' in value) {
      return function () {
        return value.current;
      };
    }
    if (typeof HTMLElement === 'function' && value instanceof HTMLElement) {
      return value;
    }
    var _value$left = value.left,
      left = _value$left === void 0 ? -Infinity : _value$left,
      _value$right = value.right,
      right = _value$right === void 0 ? Infinity : _value$right,
      _value$top = value.top,
      top = _value$top === void 0 ? -Infinity : _value$top,
      _value$bottom = value.bottom,
      bottom = _value$bottom === void 0 ? Infinity : _value$bottom;
    return [[left, right], [top, bottom]];
  }
});
var KEYS_DELTA_MAP = {
  ArrowRight: function ArrowRight(displacement) {
    var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return [displacement * factor, 0];
  },
  ArrowLeft: function ArrowLeft(displacement) {
    var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return [-1 * displacement * factor, 0];
  },
  ArrowUp: function ArrowUp(displacement) {
    var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return [0, -1 * displacement * factor];
  },
  ArrowDown: function ArrowDown(displacement) {
    var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return [0, displacement * factor];
  }
};
var DragEngine = /*#__PURE__*/function (_CoordinatesEngine) {
  _inherits(DragEngine, _CoordinatesEngine);
  var _super2 = _createSuper(DragEngine);
  function DragEngine() {
    var _this2;
    _classCallCheck(this, DragEngine);
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "ingKey", 'dragging');
    return _this2;
  }
  _createClass(DragEngine, [{
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(DragEngine.prototype), "reset", this).call(this);
      var state = this.state;
      state._pointerId = undefined;
      state._pointerActive = false;
      state._keyboardActive = false;
      state._preventScroll = false;
      state._delayed = false;
      state.swipe = [0, 0];
      state.tap = false;
      state.canceled = false;
      state.cancel = this.cancel.bind(this);
    }
  }, {
    key: "setup",
    value: function setup() {
      var state = this.state;
      if (state._bounds instanceof HTMLElement) {
        var boundRect = state._bounds.getBoundingClientRect();
        var targetRect = state.currentTarget.getBoundingClientRect();
        var _bounds = {
          left: boundRect.left - targetRect.left + state.offset[0],
          right: boundRect.right - targetRect.right + state.offset[0],
          top: boundRect.top - targetRect.top + state.offset[1],
          bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
        };
        state._bounds = coordinatesConfigResolver.bounds(_bounds);
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this3 = this;
      var state = this.state;
      if (state.canceled) return;
      state.canceled = true;
      state._active = false;
      setTimeout(function () {
        _this3.compute();
        _this3.emit();
      }, 0);
    }
  }, {
    key: "setActive",
    value: function setActive() {
      this.state._active = this.state._pointerActive || this.state._keyboardActive;
    }
  }, {
    key: "clean",
    value: function clean() {
      this.pointerClean();
      this.state._pointerActive = false;
      this.state._keyboardActive = false;
      _get(_getPrototypeOf(DragEngine.prototype), "clean", this).call(this);
    }
  }, {
    key: "pointerDown",
    value: function pointerDown(event) {
      var config = this.config;
      var state = this.state;
      if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
      var ctrlIds = this.ctrl.setEventIds(event);
      if (config.pointerCapture) {
        event.target.setPointerCapture(event.pointerId);
      }
      if (ctrlIds && ctrlIds.size > 1 && state._pointerActive) return;
      this.start(event);
      this.setupPointer(event);
      state._pointerId = pointerId(event);
      state._pointerActive = true;
      this.computeValues(pointerValues(event));
      this.computeInitial();
      if (config.preventScrollAxis && getPointerType(event) !== 'mouse') {
        state._active = false;
        this.setupScrollPrevention(event);
      } else if (config.delay > 0) {
        this.setupDelayTrigger(event);
        if (config.triggerAllEvents) {
          this.compute(event);
          this.emit();
        }
      } else {
        this.startPointerDrag(event);
      }
    }
  }, {
    key: "startPointerDrag",
    value: function startPointerDrag(event) {
      var state = this.state;
      state._active = true;
      state._preventScroll = true;
      state._delayed = false;
      this.compute(event);
      this.emit();
    }
  }, {
    key: "pointerMove",
    value: function pointerMove(event) {
      var state = this.state;
      var config = this.config;
      if (!state._pointerActive) return;
      var id = pointerId(event);
      if (state._pointerId !== undefined && id !== state._pointerId) return;
      var _values = pointerValues(event);
      if (document.pointerLockElement === event.target) {
        state._delta = [event.movementX, event.movementY];
      } else {
        state._delta = V.sub(_values, state._values);
        this.computeValues(_values);
      }
      V.addTo(state._movement, state._delta);
      this.compute(event);
      if (state._delayed && state.intentional) {
        this.timeoutStore.remove('dragDelay');
        state.active = false;
        this.startPointerDrag(event);
        return;
      }
      if (config.preventScrollAxis && !state._preventScroll) {
        if (state.axis) {
          if (state.axis === config.preventScrollAxis || config.preventScrollAxis === 'xy') {
            state._active = false;
            this.clean();
            return;
          } else {
            this.timeoutStore.remove('startPointerDrag');
            this.startPointerDrag(event);
            return;
          }
        } else {
          return;
        }
      }
      this.emit();
    }
  }, {
    key: "pointerUp",
    value: function pointerUp(event) {
      this.ctrl.setEventIds(event);
      try {
        if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) {
          ;
          event.target.releasePointerCapture(event.pointerId);
        }
      } catch (_unused) {
        if (process.env.NODE_ENV === 'development') {
          console.warn("[@use-gesture]: If you see this message, it's likely that you're using an outdated version of `@react-three/fiber`. \n\nPlease upgrade to the latest version.");
        }
      }
      var state = this.state;
      var config = this.config;
      if (!state._active || !state._pointerActive) return;
      var id = pointerId(event);
      if (state._pointerId !== undefined && id !== state._pointerId) return;
      this.state._pointerActive = false;
      this.setActive();
      this.compute(event);
      var _state$_distance = _slicedToArray(state._distance, 2),
        dx = _state$_distance[0],
        dy = _state$_distance[1];
      state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;
      if (state.tap && config.filterTaps) {
        state._force = true;
      } else {
        var _state$_delta = _slicedToArray(state._delta, 2),
          _dx = _state$_delta[0],
          _dy = _state$_delta[1];
        var _state$_movement2 = _slicedToArray(state._movement, 2),
          _mx = _state$_movement2[0],
          _my = _state$_movement2[1];
        var _config$swipe$velocit = _slicedToArray(config.swipe.velocity, 2),
          svx = _config$swipe$velocit[0],
          svy = _config$swipe$velocit[1];
        var _config$swipe$distanc = _slicedToArray(config.swipe.distance, 2),
          sx = _config$swipe$distanc[0],
          sy = _config$swipe$distanc[1];
        var sdt = config.swipe.duration;
        if (state.elapsedTime < sdt) {
          var _vx = Math.abs(_dx / state.timeDelta);
          var _vy = Math.abs(_dy / state.timeDelta);
          if (_vx > svx && Math.abs(_mx) > sx) state.swipe[0] = Math.sign(_dx);
          if (_vy > svy && Math.abs(_my) > sy) state.swipe[1] = Math.sign(_dy);
        }
      }
      this.emit();
    }
  }, {
    key: "pointerClick",
    value: function pointerClick(event) {
      if (!this.state.tap && event.detail > 0) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    key: "setupPointer",
    value: function setupPointer(event) {
      var config = this.config;
      var device = config.device;
      if (process.env.NODE_ENV === 'development') {
        try {
          if (device === 'pointer' && config.preventScrollDelay === undefined) {
            var currentTarget = 'uv' in event ? event.sourceEvent.currentTarget : event.currentTarget;
            var style = window.getComputedStyle(currentTarget);
            if (style.touchAction === 'auto') {
              console.warn("[@use-gesture]: The drag target has its `touch-action` style property set to `auto`. It is recommended to add `touch-action: 'none'` so that the drag gesture behaves correctly on touch-enabled devices. For more information read this: https://use-gesture.netlify.app/docs/extras/#touch-action.\n\nThis message will only show in development mode. It won't appear in production. If this is intended, you can ignore it.", currentTarget);
            }
          }
        } catch (_unused2) {}
      }
      if (config.pointerLock) {
        event.currentTarget.requestPointerLock();
      }
      if (!config.pointerCapture) {
        this.eventStore.add(this.sharedConfig.window, device, 'change', this.pointerMove.bind(this));
        this.eventStore.add(this.sharedConfig.window, device, 'end', this.pointerUp.bind(this));
        this.eventStore.add(this.sharedConfig.window, device, 'cancel', this.pointerUp.bind(this));
      }
    }
  }, {
    key: "pointerClean",
    value: function pointerClean() {
      if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) {
        document.exitPointerLock();
      }
    }
  }, {
    key: "preventScroll",
    value: function preventScroll(event) {
      if (this.state._preventScroll && event.cancelable) {
        event.preventDefault();
      }
    }
  }, {
    key: "setupScrollPrevention",
    value: function setupScrollPrevention(event) {
      this.state._preventScroll = false;
      persistEvent(event);
      var remove = this.eventStore.add(this.sharedConfig.window, 'touch', 'change', this.preventScroll.bind(this), {
        passive: false
      });
      this.eventStore.add(this.sharedConfig.window, 'touch', 'end', remove);
      this.eventStore.add(this.sharedConfig.window, 'touch', 'cancel', remove);
      this.timeoutStore.add('startPointerDrag', this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
    }
  }, {
    key: "setupDelayTrigger",
    value: function setupDelayTrigger(event) {
      var _this4 = this;
      this.state._delayed = true;
      this.timeoutStore.add('dragDelay', function () {
        _this4.state._step = [0, 0];
        _this4.startPointerDrag(event);
      }, this.config.delay);
    }
  }, {
    key: "keyDown",
    value: function keyDown(event) {
      var deltaFn = KEYS_DELTA_MAP[event.key];
      if (deltaFn) {
        var state = this.state;
        var factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
        this.start(event);
        state._delta = deltaFn(this.config.keyboardDisplacement, factor);
        state._keyboardActive = true;
        V.addTo(state._movement, state._delta);
        this.compute(event);
        this.emit();
      }
    }
  }, {
    key: "keyUp",
    value: function keyUp(event) {
      if (!(event.key in KEYS_DELTA_MAP)) return;
      this.state._keyboardActive = false;
      this.setActive();
      this.compute(event);
      this.emit();
    }
  }, {
    key: "bind",
    value: function bind(bindFunction) {
      var device = this.config.device;
      bindFunction(device, 'start', this.pointerDown.bind(this));
      if (this.config.pointerCapture) {
        bindFunction(device, 'change', this.pointerMove.bind(this));
        bindFunction(device, 'end', this.pointerUp.bind(this));
        bindFunction(device, 'cancel', this.pointerUp.bind(this));
        bindFunction('lostPointerCapture', '', this.pointerUp.bind(this));
      }
      if (this.config.keys) {
        bindFunction('key', 'down', this.keyDown.bind(this));
        bindFunction('key', 'up', this.keyUp.bind(this));
      }
      if (this.config.filterTaps) {
        bindFunction('click', '', this.pointerClick.bind(this), {
          capture: true,
          passive: false
        });
      }
    }
  }]);
  return DragEngine;
}(CoordinatesEngine);
function persistEvent(event) {
  'persist' in event && typeof event.persist === 'function' && event.persist();
}
var isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;
function supportsTouchEvents() {
  return isBrowser && 'ontouchstart' in window;
}
function isTouchScreen() {
  return supportsTouchEvents() || isBrowser && window.navigator.maxTouchPoints > 1;
}
function supportsPointerEvents() {
  return isBrowser && 'onpointerdown' in window;
}
function supportsPointerLock() {
  return isBrowser && 'exitPointerLock' in window.document;
}
function supportsGestureEvents() {
  try {
    return 'constructor' in GestureEvent;
  } catch (e) {
    return false;
  }
}
var SUPPORT = {
  isBrowser: isBrowser,
  gesture: supportsGestureEvents(),
  touch: supportsTouchEvents(),
  touchscreen: isTouchScreen(),
  pointer: supportsPointerEvents(),
  pointerLock: supportsPointerLock()
};
var DEFAULT_PREVENT_SCROLL_DELAY = 250;
var DEFAULT_DRAG_DELAY = 180;
var DEFAULT_SWIPE_VELOCITY = 0.5;
var DEFAULT_SWIPE_DISTANCE = 50;
var DEFAULT_SWIPE_DURATION = 250;
var DEFAULT_KEYBOARD_DISPLACEMENT = 10;
var DEFAULT_DRAG_AXIS_THRESHOLD = {
  mouse: 0,
  touch: 0,
  pen: 8
};
var dragConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  device: function device(_v, _k, _ref6) {
    var _ref6$pointer = _ref6.pointer,
      _ref6$pointer2 = _ref6$pointer === void 0 ? {} : _ref6$pointer,
      _ref6$pointer2$touch = _ref6$pointer2.touch,
      touch = _ref6$pointer2$touch === void 0 ? false : _ref6$pointer2$touch,
      _ref6$pointer2$lock = _ref6$pointer2.lock,
      lock = _ref6$pointer2$lock === void 0 ? false : _ref6$pointer2$lock,
      _ref6$pointer2$mouse = _ref6$pointer2.mouse,
      mouse = _ref6$pointer2$mouse === void 0 ? false : _ref6$pointer2$mouse;
    this.pointerLock = lock && SUPPORT.pointerLock;
    if (SUPPORT.touch && touch) return 'touch';
    if (this.pointerLock) return 'mouse';
    if (SUPPORT.pointer && !mouse) return 'pointer';
    if (SUPPORT.touch) return 'touch';
    return 'mouse';
  },
  preventScrollAxis: function preventScrollAxis(value, _k, _ref7) {
    var preventScroll = _ref7.preventScroll;
    this.preventScrollDelay = typeof preventScroll === 'number' ? preventScroll : preventScroll || preventScroll === undefined && value ? DEFAULT_PREVENT_SCROLL_DELAY : undefined;
    if (!SUPPORT.touchscreen || preventScroll === false) return undefined;
    return value ? value : preventScroll !== undefined ? 'y' : undefined;
  },
  pointerCapture: function pointerCapture(_v, _k, _ref8) {
    var _ref8$pointer = _ref8.pointer,
      _ref8$pointer2 = _ref8$pointer === void 0 ? {} : _ref8$pointer,
      _ref8$pointer2$captur = _ref8$pointer2.capture,
      capture = _ref8$pointer2$captur === void 0 ? true : _ref8$pointer2$captur,
      _ref8$pointer2$button = _ref8$pointer2.buttons,
      buttons = _ref8$pointer2$button === void 0 ? 1 : _ref8$pointer2$button,
      _ref8$pointer2$keys = _ref8$pointer2.keys,
      keys = _ref8$pointer2$keys === void 0 ? true : _ref8$pointer2$keys;
    this.pointerButtons = buttons;
    this.keys = keys;
    return !this.pointerLock && this.device === 'pointer' && capture;
  },
  threshold: function threshold(value, _k, _ref9) {
    var _ref9$filterTaps = _ref9.filterTaps,
      filterTaps = _ref9$filterTaps === void 0 ? false : _ref9$filterTaps,
      _ref9$tapsThreshold = _ref9.tapsThreshold,
      tapsThreshold = _ref9$tapsThreshold === void 0 ? 3 : _ref9$tapsThreshold,
      _ref9$axis = _ref9.axis,
      axis = _ref9$axis === void 0 ? undefined : _ref9$axis;
    var threshold = V.toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
    this.filterTaps = filterTaps;
    this.tapsThreshold = tapsThreshold;
    return threshold;
  },
  swipe: function swipe() {
    var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref10$velocity = _ref10.velocity,
      velocity = _ref10$velocity === void 0 ? DEFAULT_SWIPE_VELOCITY : _ref10$velocity,
      _ref10$distance = _ref10.distance,
      distance = _ref10$distance === void 0 ? DEFAULT_SWIPE_DISTANCE : _ref10$distance,
      _ref10$duration = _ref10.duration,
      duration = _ref10$duration === void 0 ? DEFAULT_SWIPE_DURATION : _ref10$duration;
    return {
      velocity: this.transform(V.toVector(velocity)),
      distance: this.transform(V.toVector(distance)),
      duration: duration
    };
  },
  delay: function delay() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    switch (value) {
      case true:
        return DEFAULT_DRAG_DELAY;
      case false:
        return 0;
      default:
        return value;
    }
  },
  axisThreshold: function axisThreshold(value) {
    if (!value) return DEFAULT_DRAG_AXIS_THRESHOLD;
    return _objectSpread2(_objectSpread2({}, DEFAULT_DRAG_AXIS_THRESHOLD), value);
  },
  keyboardDisplacement: function keyboardDisplacement() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_KEYBOARD_DISPLACEMENT;
    return value;
  }
});
if (process.env.NODE_ENV === 'development') {
  Object.assign(dragConfigResolver, {
    useTouch: function useTouch(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `useTouch` option has been renamed to `pointer.touch`. Use it as in `{ pointer: { touch: true } }`.");
      }
      return NaN;
    },
    experimental_preventWindowScrollY: function experimental_preventWindowScrollY(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `experimental_preventWindowScrollY` option has been renamed to `preventScroll`.");
      }
      return NaN;
    },
    swipeVelocity: function swipeVelocity(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `swipeVelocity` option has been renamed to `swipe.velocity`. Use it as in `{ swipe: { velocity: 0.5 } }`.");
      }
      return NaN;
    },
    swipeDistance: function swipeDistance(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `swipeDistance` option has been renamed to `swipe.distance`. Use it as in `{ swipe: { distance: 50 } }`.");
      }
      return NaN;
    },
    swipeDuration: function swipeDuration(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `swipeDuration` option has been renamed to `swipe.duration`. Use it as in `{ swipe: { duration: 250 } }`.");
      }
      return NaN;
    }
  });
}
_objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  device: function device(_v, _k, _ref11) {
    var shared = _ref11.shared,
      _ref11$pointer = _ref11.pointer,
      _ref11$pointer2 = _ref11$pointer === void 0 ? {} : _ref11$pointer,
      _ref11$pointer2$touch = _ref11$pointer2.touch,
      touch = _ref11$pointer2$touch === void 0 ? false : _ref11$pointer2$touch;
    var sharedConfig = shared;
    if (sharedConfig.target && !SUPPORT.touch && SUPPORT.gesture) return 'gesture';
    if (SUPPORT.touch && touch) return 'touch';
    if (SUPPORT.touchscreen) {
      if (SUPPORT.pointer) return 'pointer';
      if (SUPPORT.touch) return 'touch';
    }
  },
  bounds: function bounds(_v, _k, _ref12) {
    var _ref12$scaleBounds = _ref12.scaleBounds,
      scaleBounds = _ref12$scaleBounds === void 0 ? {} : _ref12$scaleBounds,
      _ref12$angleBounds = _ref12.angleBounds,
      angleBounds = _ref12$angleBounds === void 0 ? {} : _ref12$angleBounds;
    var _scaleBounds = function _scaleBounds(state) {
      var D = assignDefault(call(scaleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [D.min, D.max];
    };
    var _angleBounds = function _angleBounds(state) {
      var A = assignDefault(call(angleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [A.min, A.max];
    };
    if (typeof scaleBounds !== 'function' && typeof angleBounds !== 'function') return [_scaleBounds(), _angleBounds()];
    return function (state) {
      return [_scaleBounds(state), _angleBounds(state)];
    };
  },
  threshold: function threshold(value, _k, config) {
    this.lockDirection = config.axis === 'lock';
    var threshold = V.toVector(value, this.lockDirection ? [0.1, 3] : 0);
    return threshold;
  },
  modifierKey: function modifierKey(value) {
    if (value === undefined) return 'ctrlKey';
    return value;
  },
  pinchOnWheel: function pinchOnWheel() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  }
});
_objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: function mouseOnly() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  }
});
_objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: function mouseOnly() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  }
});
var EngineMap = new Map();
var ConfigResolverMap = new Map();
function registerAction(action) {
  EngineMap.set(action.key, action.engine);
  ConfigResolverMap.set(action.key, action.resolver);
}
var dragAction = {
  key: 'drag',
  engine: DragEngine,
  resolver: dragConfigResolver
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var sharedConfigResolver = {
  target: function target(value) {
    if (value) {
      return function () {
        return 'current' in value ? value.current : value;
      };
    }
    return undefined;
  },
  enabled: function enabled() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  },
  window: function (_window) {
    function window() {
      return _window.apply(this, arguments);
    }
    window.toString = function () {
      return _window.toString();
    };
    return window;
  }(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SUPPORT.isBrowser ? window : undefined;
    return value;
  }),
  eventOptions: function eventOptions() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$passive = _ref2.passive,
      passive = _ref2$passive === void 0 ? true : _ref2$passive,
      _ref2$capture = _ref2.capture,
      capture = _ref2$capture === void 0 ? false : _ref2$capture;
    return {
      passive: passive,
      capture: capture
    };
  },
  transform: function transform(value) {
    return value;
  }
};
var _excluded = ["target", "eventOptions", "window", "enabled", "transform"];
function resolveWith() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var resolvers = arguments.length > 1 ? arguments[1] : undefined;
  var result = {};
  for (var _i = 0, _Object$entries = Object.entries(resolvers); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      resolver = _Object$entries$_i[1];
    switch (_typeof(resolver)) {
      case 'function':
        if (process.env.NODE_ENV === 'development') {
          var r = resolver.call(result, config[key], key, config);
          if (!Number.isNaN(r)) result[key] = r;
        } else {
          result[key] = resolver.call(result, config[key], key, config);
        }
        break;
      case 'object':
        result[key] = resolveWith(config[key], resolver);
        break;
      case 'boolean':
        if (resolver) result[key] = config[key];
        break;
    }
  }
  return result;
}
function parse(newConfig, gestureKey) {
  var _config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _ref = newConfig,
    target = _ref.target,
    eventOptions = _ref.eventOptions,
    window = _ref.window,
    enabled = _ref.enabled,
    transform = _ref.transform,
    rest = _objectWithoutProperties(_ref, _excluded);
  _config.shared = resolveWith({
    target: target,
    eventOptions: eventOptions,
    window: window,
    enabled: enabled,
    transform: transform
  }, sharedConfigResolver);
  if (gestureKey) {
    var resolver = ConfigResolverMap.get(gestureKey);
    _config[gestureKey] = resolveWith(_objectSpread2({
      shared: _config.shared
    }, rest), resolver);
  } else {
    for (var key in rest) {
      var _resolver = ConfigResolverMap.get(key);
      if (_resolver) {
        _config[key] = resolveWith(_objectSpread2({
          shared: _config.shared
        }, rest[key]), _resolver);
      } else if (process.env.NODE_ENV === 'development') {
        if (!['drag', 'pinch', 'scroll', 'wheel', 'move', 'hover'].includes(key)) {
          if (key === 'domTarget') {
            throw Error("[@use-gesture]: `domTarget` option has been renamed to `target`.");
          }
          console.warn("[@use-gesture]: Unknown config key `".concat(key, "` was used. Please read the documentation for further information."));
        }
      }
    }
  }
  return _config;
}
var EventStore = /*#__PURE__*/function () {
  function EventStore(ctrl, gestureKey) {
    _classCallCheck(this, EventStore);
    _defineProperty(this, "_listeners", new Set());
    this._ctrl = ctrl;
    this._gestureKey = gestureKey;
  }
  _createClass(EventStore, [{
    key: "add",
    value: function add(element, device, action, handler, options) {
      var listeners = this._listeners;
      var type = toDomEventType(device, action);
      var _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};
      var eventOptions = _objectSpread2(_objectSpread2({}, _options), options);
      element.addEventListener(type, handler, eventOptions);
      var remove = function remove() {
        element.removeEventListener(type, handler, eventOptions);
        listeners["delete"](remove);
      };
      listeners.add(remove);
      return remove;
    }
  }, {
    key: "clean",
    value: function clean() {
      this._listeners.forEach(function (remove) {
        return remove();
      });
      this._listeners.clear();
    }
  }]);
  return EventStore;
}();
var TimeoutStore = /*#__PURE__*/function () {
  function TimeoutStore() {
    _classCallCheck(this, TimeoutStore);
    _defineProperty(this, "_timeouts", new Map());
  }
  _createClass(TimeoutStore, [{
    key: "add",
    value: function add(key, callback) {
      var _window2;
      var ms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 140;
      this.remove(key);
      for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }
      this._timeouts.set(key, (_window2 = window).setTimeout.apply(_window2, [callback, ms].concat(args)));
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var timeout = this._timeouts.get(key);
      if (timeout) window.clearTimeout(timeout);
    }
  }, {
    key: "clean",
    value: function clean() {
      this._timeouts.forEach(function (timeout) {
        return void window.clearTimeout(timeout);
      });
      this._timeouts.clear();
    }
  }]);
  return TimeoutStore;
}();
var Controller = /*#__PURE__*/function () {
  function Controller(handlers) {
    _classCallCheck(this, Controller);
    _defineProperty(this, "gestures", new Set());
    _defineProperty(this, "_targetEventStore", new EventStore(this));
    _defineProperty(this, "gestureEventStores", {});
    _defineProperty(this, "gestureTimeoutStores", {});
    _defineProperty(this, "handlers", {});
    _defineProperty(this, "config", {});
    _defineProperty(this, "pointerIds", new Set());
    _defineProperty(this, "touchIds", new Set());
    _defineProperty(this, "state", {
      shared: {
        shiftKey: false,
        metaKey: false,
        ctrlKey: false,
        altKey: false
      }
    });
    resolveGestures(this, handlers);
  }
  _createClass(Controller, [{
    key: "setEventIds",
    value: function setEventIds(event) {
      if (isTouch(event)) {
        this.touchIds = new Set(touchIds(event));
        return this.touchIds;
      } else if ('pointerId' in event) {
        if (event.type === 'pointerup' || event.type === 'pointercancel') this.pointerIds["delete"](event.pointerId);else if (event.type === 'pointerdown') this.pointerIds.add(event.pointerId);
        return this.pointerIds;
      }
    }
  }, {
    key: "applyHandlers",
    value: function applyHandlers(handlers, nativeHandlers) {
      this.handlers = handlers;
      this.nativeHandlers = nativeHandlers;
    }
  }, {
    key: "applyConfig",
    value: function applyConfig(config, gestureKey) {
      this.config = parse(config, gestureKey, this.config);
    }
  }, {
    key: "clean",
    value: function clean() {
      this._targetEventStore.clean();
      var _iterator = _createForOfIteratorHelper(this.gestures),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          this.gestureEventStores[key].clean();
          this.gestureTimeoutStores[key].clean();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "effect",
    value: function effect() {
      var _this = this;
      if (this.config.shared.target) this.bind();
      return function () {
        return _this._targetEventStore.clean();
      };
    }
  }, {
    key: "bind",
    value: function bind() {
      var _this2 = this;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var sharedConfig = this.config.shared;
      var props = {};
      var target;
      if (sharedConfig.target) {
        target = sharedConfig.target();
        if (!target) return;
      }
      if (sharedConfig.enabled) {
        var _iterator2 = _createForOfIteratorHelper(this.gestures),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var gestureKey = _step2.value;
            var gestureConfig = this.config[gestureKey];
            var bindFunction = bindToProps(props, gestureConfig.eventOptions, !!target);
            if (gestureConfig.enabled) {
              var Engine = EngineMap.get(gestureKey);
              new Engine(this, args, gestureKey).bind(bindFunction);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        var nativeBindFunction = bindToProps(props, sharedConfig.eventOptions, !!target);
        var _loop = function _loop(eventKey) {
          nativeBindFunction(eventKey, '', function (event) {
            return _this2.nativeHandlers[eventKey](_objectSpread2(_objectSpread2({}, _this2.state.shared), {}, {
              event: event,
              args: args
            }));
          }, undefined, true);
        };
        for (var eventKey in this.nativeHandlers) {
          _loop(eventKey);
        }
      }
      for (var handlerProp in props) {
        props[handlerProp] = chain.apply(void 0, _toConsumableArray(props[handlerProp]));
      }
      if (!target) return props;
      for (var _handlerProp in props) {
        var _parseProp = parseProp(_handlerProp),
          device = _parseProp.device,
          capture = _parseProp.capture,
          passive = _parseProp.passive;
        this._targetEventStore.add(target, device, '', props[_handlerProp], {
          capture: capture,
          passive: passive
        });
      }
    }
  }]);
  return Controller;
}();
function setupGesture(ctrl, gestureKey) {
  ctrl.gestures.add(gestureKey);
  ctrl.gestureEventStores[gestureKey] = new EventStore(ctrl, gestureKey);
  ctrl.gestureTimeoutStores[gestureKey] = new TimeoutStore();
}
function resolveGestures(ctrl, internalHandlers) {
  if (internalHandlers.drag) setupGesture(ctrl, 'drag');
  if (internalHandlers.wheel) setupGesture(ctrl, 'wheel');
  if (internalHandlers.scroll) setupGesture(ctrl, 'scroll');
  if (internalHandlers.move) setupGesture(ctrl, 'move');
  if (internalHandlers.pinch) setupGesture(ctrl, 'pinch');
  if (internalHandlers.hover) setupGesture(ctrl, 'hover');
}
var bindToProps = function bindToProps(props, eventOptions, withPassiveOption) {
  return function (device, action, handler) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var isNative = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var _options$capture, _options$passive;
    var capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
    var passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
    var handlerProp = isNative ? device : toHandlerProp(device, action, capture);
    if (withPassiveOption && passive) handlerProp += 'Passive';
    props[handlerProp] = props[handlerProp] || [];
    props[handlerProp].push(handler);
  };
};

function useRecognizers(handlers) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var gestureKey = arguments.length > 2 ? arguments[2] : undefined;
  var nativeHandlers = arguments.length > 3 ? arguments[3] : undefined;
  var ctrl = React__default.useMemo(function () {
    return new Controller(handlers);
  }, []);
  ctrl.applyHandlers(handlers, nativeHandlers);
  ctrl.applyConfig(config, gestureKey);
  React__default.useEffect(ctrl.effect.bind(ctrl));
  React__default.useEffect(function () {
    return ctrl.clean.bind(ctrl);
  }, []);
  if (config.target === undefined) {
    return ctrl.bind.bind(ctrl);
  }
  return undefined;
}
function useDrag(handler, config) {
  registerAction(dragAction);
  return useRecognizers({
    drag: handler
  }, config || {}, 'drag');
}

function bound(position, min, max) {
  var ret = position;
  if (min !== undefined) {
    ret = Math.max(position, min);
  }
  if (max !== undefined) {
    ret = Math.min(ret, max);
  }
  return ret;
}

function rubberband(distance, dimension, constant) {
  return distance * dimension * constant / (dimension + constant * distance);
}
function rubberbandIfOutOfBounds(position, min, max, dimension, constant) {
  if (constant === void 0) {
    constant = 0.15;
  }
  if (constant === 0) return bound(position, min, max);
  if (position < min) return -rubberband(min - position, dimension, constant) + min;
  if (position > max) return +rubberband(position - max, dimension, constant) + max;
  return position;
}

var ITEM_HEIGHT = 40;
var Wheel = function Wheel(props) {
  var value = props.value,
    items = props.items,
    onChange = props.onChange,
    align = props.align;
  var draggingRef = useRef(false);
  var rootRef = useRef(null);
  useIsomorphicLayoutEffect$2(function () {
    if (draggingRef.current) return;
    if (value === null) return;
    var targetIndex = items.findIndex(function (item) {
      return item.value === value;
    });
    if (targetIndex < 0) return;
    var finalPosition = targetIndex * -ITEM_HEIGHT;
    api.start({
      y: finalPosition,
      immediate: y.goal !== finalPosition
    });
  }, [value, items]);
  useIsomorphicLayoutEffect$2(function () {
    if (items.length === 0) {
      if (value !== null) {
        onChange(null);
      }
    } else {
      if (!items.some(function (item) {
        return item.value === value;
      })) {
        var firstItem = items[0];
        onChange(firstItem.value);
      }
    }
  }, [items, value]);
  function scrollSelect(index) {
    var finalPosition = index * -ITEM_HEIGHT;
    api.start({
      y: finalPosition
    });
    var item = items[index];
    if (!item) return;
    onChange(item.value);
  }
  var _a = useSpring(function () {
      return {
        from: {
          y: 0
        },
        config: {
          tension: 400,
          mass: 0.8
        }
      };
    }),
    y = _a[0].y,
    api = _a[1];
  var handleGestureState = function handleGestureState(state) {
    var _a = state.direction,
      direction = _a[1],
      _b = state.distance,
      distance = _b[1],
      _c = state.velocity,
      velocity = _c[1],
      _d = state.offset,
      offset = _d[1],
      last = state.last;
    return {
      direction: direction,
      distance: distance,
      velocity: velocity,
      offset: offset,
      last: last
    };
  };
  useDrag(function (state) {
    state.event.stopPropagation();
    draggingRef.current = true;
    var min = -((items.length - 1) * ITEM_HEIGHT);
    var max = 0;
    var dimension = 100;
    var _a = handleGestureState(state),
      direction = _a.direction,
      last = _a.last,
      velocity = _a.velocity,
      offset = _a.offset;
    if (last) {
      draggingRef.current = false;
      var position = offset + velocity * direction * dimension;
      var boundNum = bound(position, min, max);
      var targetIndex = -Math.round(boundNum / ITEM_HEIGHT);
      scrollSelect(targetIndex);
      return;
    }
    api.start({
      y: rubberbandIfOutOfBounds(offset, min, max, ITEM_HEIGHT * dimension, 0.5)
    });
  }, {
    axis: 'y',
    from: function from() {
      return [0, y.get()];
    },
    filterTaps: true,
    pointer: {
      touch: true
    },
    target: rootRef
  });
  return jsx(animated.div, {
    ref: rootRef,
    className: column,
    style: {
      y: y
    },
    children: jsx("div", {
      className: columnWheel,
      children: items.map(function (item, index) {
        function handleClick() {
          draggingRef.current = false;
          scrollSelect(index);
        }
        return jsx("div", {
          className: columnItem({
            textAlign: align,
            disabled: item.disabled
          }),
          onClick: handleClick,
          children: item.label
        }, item.value);
      })
    })
  });
};

var MobileTimePicker = function MobileTimePicker(props) {
  var value = props.value,
    onChange = props.onChange;
  var _a = useContext(MediaPlayerContext),
    baseUrl = _a.baseUrl,
    apiKey = _a.apiKey;
  var intlFormat = useFormat().intlFormat;
  var originDate = value.getDate();
  var _b = useState([]),
    validTimeData = _b[0],
    setValidTimeData = _b[1];
  var fetchData = function fetchData() {
    return __awaiter(void 0, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, getPlayerDay({
              baseUrl: baseUrl,
              apiKey: apiKey
            }, {
              date: startOfDay(value).toISOString(),
              interval: 1800000
            })];
          case 1:
            data = _a.sent();
            setValidTimeData(data);
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    fetchData();
  }, [originDate]);
  var options = useMemo(function () {
    var timeArray = [];
    var currentTime = startOfDay(value);
    var endTime = endOfDay(value);
    while (isBefore(currentTime, endTime)) {
      timeArray.push(currentTime);
      currentTime = addMinutes(currentTime, 30);
    }
    return timeArray.map(function (date, index) {
      var disabled = !validTimeData.some(function (e) {
        return isSameMinute(date, e.time) && e.isExist;
      });
      return {
        value: date.getTime(),
        label: intlFormat(date, {
          timeStyle: 'short'
        }),
        disabled: disabled
      };
    });
  }, [value, validTimeData]);
  /**
   * options 중 value와 가장 가까운 것을 찾아 기본값으로 설정합니다.
   */
  var _c = useState(closestTo(value, options.map(function (e) {
      return e.value;
    }))),
    currentDate = _c[0],
    setCurrentDate = _c[1];
  /**
   * 현재 선택된 시간대가 정상적인지 확인합니다.
   */
  var isCurrentDateInvalid = useMemo(function () {
    if (!currentDate) return true;
    return !validTimeData.some(function (e) {
      return isSameMinute(currentDate, e.time) && e.isExist;
    });
  }, [currentDate, validTimeData]);
  /**
   * Update date
   */
  var handleSubmit = function handleSubmit() {
    if (!currentDate) return;
    logger$1.debug('날짜 선택:', format$1(currentDate, 'yyyy-MM-dd HH:mm:ss'));
    onChange(currentDate);
  };
  return jsxs(Fragment$1, {
    children: [jsxs("div", {
      className: container$1,
      children: [jsx(Wheel, {
        value: currentDate === null || currentDate === void 0 ? void 0 : currentDate.getTime(),
        items: options,
        onChange: function onChange(value) {
          setCurrentDate(new Date(value));
        }
      }), jsx("div", {
        className: maskTop
      }), jsx("div", {
        className: maskBottom
      })]
    }), jsx(Button, {
      block: true,
      size: "large",
      variant: "filled",
      color: "primary",
      onClick: handleSubmit,
      disabled: isCurrentDateInvalid,
      style: {
        marginTop: '1rem'
      },
      children: "\uD655\uC778"
    })]
  });
};

var container = 'styles_container__xjqn0t0';
var header = 'styles_header__xjqn0t1';
var headerButton = createRuntimeFn({
  defaultClassName: 'styles_headerButton__xjqn0t2',
  variantClassNames: {
    type: {
      calendar: 'styles_headerButton_type_calendar__xjqn0t3',
      time: 'styles_headerButton_type_time__xjqn0t4'
    },
    active: {
      "true": 'styles_headerButton_active_true__xjqn0t5'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});

var list = 'styles_list__qpmrsn0';
var listItem = createRuntimeFn({
  defaultClassName: 'styles_listItem__qpmrsn1',
  variantClassNames: {
    active: {
      "true": 'styles_listItem_active_true__qpmrsn2'
    },
    disabled: {
      "true": 'styles_listItem_disabled_true__qpmrsn3'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});

var TimePicker = function TimePicker(props) {
  var value = props.value,
    onChange = props.onChange;
  var intlFormat = useFormat().intlFormat;
  var _a = useContext(MediaPlayerContext),
    baseUrl = _a.baseUrl,
    apiKey = _a.apiKey;
  var listRef = useRef(null);
  var currentDate = value.getDate();
  var _b = useState([]),
    validTimeData = _b[0],
    setValidTimeData = _b[1];
  var fetchData = function fetchData() {
    return __awaiter(void 0, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, getPlayerDay({
              baseUrl: baseUrl,
              apiKey: apiKey
            }, {
              date: startOfDay(value).toISOString(),
              interval: 1800000
            })];
          case 1:
            data = _a.sent();
            setValidTimeData(data);
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    fetchData();
  }, [currentDate]);
  var times = useMemo(function () {
    var timeArray = [];
    var currentTime = startOfDay(value);
    var endTime = endOfDay(value);
    while (isBefore(currentTime, endTime)) {
      timeArray.push(currentTime);
      currentTime = addMinutes(currentTime, 30);
    }
    return timeArray;
  }, [value]);
  var closetIndex = useMemo(function () {
    return closestIndexTo(value, times);
  }, [value, times]);
  useEffect(function () {
    if (!listRef.current || !closetIndex) return;
    var itemHeight = 38;
    listRef.current.scrollTo({
      /**
       * itemHeight * 2를 빼는 이유는 선택된 아이템이 어느정도
       * 화면 중앙에 위치할 수 있도록 보정하기 위함입니다.
       */
      top: closetIndex * itemHeight - itemHeight * 2
    });
  }, [closetIndex, listRef.current]);
  return jsx("ul", {
    ref: listRef,
    className: list,
    children: times.map(function (date, index) {
      var isActive = isSameMinute(date, value);
      var isValid = validTimeData.some(function (e) {
        return isSameMinute(date, e.time) && e.isExist;
      });
      var disabled = !isValid;
      return jsx("li", {
        children: jsx("button", {
          className: listItem({
            active: isActive,
            disabled: disabled
          }),
          onClick: function onClick() {
            if (disabled) return;
            logger$1.debug('날짜 선택:', date);
            onChange(date);
          },
          children: intlFormat(date, {
            timeStyle: 'short'
          })
        })
      }, index);
    })
  });
};

var DatePicker = function DatePicker(props) {
  var visible = props.visible,
    onClose = props.onClose,
    value = props.value,
    _onChange = props.onChange;
  var _a = useContext(MediaPlayerContext),
    baseUrl = _a.baseUrl,
    apiKey = _a.apiKey,
    containerRef = _a.containerRef,
    renderDatePicker = _a.renderDatePicker;
  var intlFormat = useFormat().intlFormat;
  var isMobile = useIsMobile();
  var wrapperRef = useRef(null);
  var _b = useState('calendar'),
    type = _b[0],
    setType = _b[1];
  var _c = useState(value),
    localValue = _c[0],
    setLocalValue = _c[1];
  useEffect(function () {
    setLocalValue(value);
  }, [visible]);
  var _d = useState({}),
    cachedCalendarDatas = _d[0],
    setCachedCalendarDatas = _d[1];
  var currentCalendarQuery = useMemo(function () {
    var startDate = startOfMonth(localValue).toISOString();
    var endDate = endOfMonth(localValue).toISOString();
    return [startDate, endDate];
  }, [localValue]);
  var fetchCalendarData = function fetchCalendarData() {
    return __awaiter(void 0, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, getPlayerCalendar({
              baseUrl: baseUrl,
              apiKey: apiKey
            }, {
              startDate: currentCalendarQuery[0],
              endDate: currentCalendarQuery[1]
            })];
          case 1:
            data = _a.sent();
            setCachedCalendarDatas(function (prev) {
              var _a;
              var query = currentCalendarQuery.toString();
              return _assign$1(_assign$1({}, prev), (_a = {}, _a[query] = data, _a));
            });
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    fetchCalendarData();
  }, [localValue, visible]);
  useClickOutside(wrapperRef, function (event) {
    if (renderDatePicker) return;
    if (!visible) return;
    event.preventDefault();
    event.stopPropagation();
    onClose();
  });
  // Reset type
  useEffect(function () {
    setType('calendar');
  }, [visible]);
  /**
   * 현재 선택된 시간대가 정상적인지 확인합니다.
   */
  var isCurrentDateInvalid = useMemo(function () {
    var _a;
    if (!localValue) return true;
    var currentCalendarData = (_a = cachedCalendarDatas === null || cachedCalendarDatas === void 0 ? void 0 : cachedCalendarDatas[currentCalendarQuery.toString()]) !== null && _a !== void 0 ? _a : [];
    return !(currentCalendarData === null || currentCalendarData === void 0 ? void 0 : currentCalendarData.some(function (e) {
      return isSameDay(localValue, e.date) && e.isExist;
    }));
  }, [localValue, cachedCalendarDatas, currentCalendarQuery]);
  var renderChildren = function renderChildren() {
    var _a;
    return jsxs(Fragment$1, {
      children: [jsxs("div", {
        className: header,
        children: [jsx("button", {
          className: headerButton({
            type: 'calendar',
            active: type === 'calendar'
          }),
          onClick: function onClick() {
            return setType('calendar');
          },
          children: intlFormat(localValue, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          })
        }), jsx("button", {
          className: headerButton({
            type: 'time',
            active: type === 'time'
          }),
          onClick: function onClick() {
            return setType('time');
          },
          children: intlFormat(localValue, {
            timeStyle: 'short'
          })
        })]
      }), type === 'calendar' && jsx(Calendar, {
        calendarData: (_a = cachedCalendarDatas === null || cachedCalendarDatas === void 0 ? void 0 : cachedCalendarDatas[currentCalendarQuery.toString()]) !== null && _a !== void 0 ? _a : [],
        value: localValue,
        onChange: function onChange(date) {
          setLocalValue(date);
          setType('time');
        },
        onChangeMonth: function onChangeMonth(date) {
          setLocalValue(date);
        }
      }), type === 'time' && (isMobile ? jsx(MobileTimePicker, {
        value: localValue,
        onChange: function onChange(date) {
          _onChange(date);
          onClose();
        }
      }) : jsx(TimePicker, {
        value: localValue,
        onChange: function onChange(date) {
          _onChange(date);
          onClose();
        }
      })), !(isMobile && type === 'time') && jsx(Button, {
        block: true,
        size: isMobile ? 'large' : 'medium',
        variant: "filled",
        color: "primary",
        onClick: function onClick() {
          _onChange(localValue);
          onClose();
        },
        disabled: isCurrentDateInvalid,
        style: {
          marginTop: isMobile ? '1rem' : '0.25rem'
        },
        children: "\uD655\uC778"
      })]
    });
  };
  if (renderDatePicker) {
    return renderDatePicker({
      visible: visible,
      onClose: onClose,
      children: renderChildren()
    });
  }
  if (!visible || !containerRef.current) return null;
  return createPortal(jsx("div", {
    ref: wrapperRef,
    className: container,
    children: renderChildren()
  }), containerRef.current);
};

var DateButton = function DateButton() {
  var _a = useContext(MediaPlayerContext),
    timelineScrollRef = _a.timelineScrollRef,
    progressBarWidth = _a.progressBarWidth,
    currentTs = _a.currentTs,
    setCurrentTs = _a.setCurrentTs,
    setInitTs = _a.setInitTs,
    setStartTs = _a.setStartTs,
    setOverlayForceDisplay = _a.setOverlayForceDisplay;
  var _b = useState(false),
    visible = _b[0],
    setVisible = _b[1];
  useEffect(function () {
    if (visible) {
      setOverlayForceDisplay(true);
    } else {
      setOverlayForceDisplay(false);
    }
  }, [visible]);
  var handleChangeDate = function handleChangeDate(date) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a;
      return __generator(this, function (_b) {
        setInitTs(date.getTime());
        setCurrentTs(date.getTime());
        setStartTs(sub(date, {
          hours: 0.5
        }).getTime());
        (_a = timelineScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
          left: progressBarWidth
        });
        return [2 /*return*/];
      });
    });
  };

  return jsxs(Fragment$1, {
    children: [jsx(ToolbarButton, {
      onClick: function onClick() {
        return setVisible(function (prev) {
          return !prev;
        });
      },
      children: jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [jsx("path", {
          stroke: "none",
          d: "M0 0h24v24H0z",
          fill: "none"
        }), jsx("path", {
          d: "M12 7v5l2 2"
        }), jsx("path", {
          d: "M17 22l5 -3l-5 -3z"
        }), jsx("path", {
          d: "M13.017 20.943a9 9 0 1 1 7.831 -7.292"
        })]
      })
    }), jsx(DatePicker, {
      visible: visible,
      onClose: function onClose() {
        return setVisible(false);
      },
      value: new Date(currentTs),
      onChange: handleChangeDate
    })]
  });
};

var FullscreenButton = function FullscreenButton() {
  var _a = useContext(MediaPlayerContext),
    containerRef = _a.containerRef,
    videoRef = _a.videoRef,
    isFullscreen = _a.isFullscreen;
  var toggleFullscreen = function toggleFullscreen() {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, _b, _c;
      return __generator(this, function (_d) {
        if (!document.fullscreenEnabled) {
          /**
           * iOS Safari 환경에서는 전용 메서드 사용
           */
          if ((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.webkitEnterFullScreen) {
            (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.webkitEnterFullScreen();
          } else {
            logger$1.warn('전체화면을 지원하지 않는 환경입니다.');
          }
          return [2 /*return*/];
        }

        if (!document.fullscreenElement) {
          (_c = containerRef.current) === null || _c === void 0 ? void 0 : _c.requestFullscreen();
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
        return [2 /*return*/];
      });
    });
  };

  return jsx(ToolbarButton, {
    onClick: toggleFullscreen,
    children: isFullscreen ? jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [jsx("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }), jsx("path", {
        d: "M15 19v-2a2 2 0 0 1 2 -2h2"
      }), jsx("path", {
        d: "M15 5v2a2 2 0 0 0 2 2h2"
      }), jsx("path", {
        d: "M5 15h2a2 2 0 0 1 2 2v2"
      }), jsx("path", {
        d: "M5 9h2a2 2 0 0 0 2 -2v-2"
      })]
    }) : jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [jsx("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }), jsx("path", {
        d: "M4 8v-2a2 2 0 0 1 2 -2h2"
      }), jsx("path", {
        d: "M4 16v2a2 2 0 0 0 2 2h2"
      }), jsx("path", {
        d: "M16 4h2a2 2 0 0 1 2 2v2"
      }), jsx("path", {
        d: "M16 20h2a2 2 0 0 0 2 -2v-2"
      })]
    })
  });
};

var theme = {
  spacing: {
    '2': 'var(--spacing-2)',
    '4': 'var(--spacing-4)',
    '8': 'var(--spacing-8)',
    '10': 'var(--spacing-10)',
    '12': 'var(--spacing-12)',
    '14': 'var(--spacing-14)',
    '16': 'var(--spacing-16)',
    '18': 'var(--spacing-18)',
    '20': 'var(--spacing-20)',
    '24': 'var(--spacing-24)',
    '32': 'var(--spacing-32)',
    '48': 'var(--spacing-48)',
    '64': 'var(--spacing-64)',
    xs: 'var(--spacing-xs)',
    sm: 'var(--spacing-sm)',
    md: 'var(--spacing-md)',
    lg: 'var(--spacing-lg)',
    xl: 'var(--spacing-xl)',
    xxl: 'var(--spacing-xxl)'
  },
  color: {
    primary: {
      '50': 'var(--color-primary-50)',
      '100': 'var(--color-primary-100)',
      '200': 'var(--color-primary-200)',
      '300': 'var(--color-primary-300)',
      '400': 'var(--color-primary-400)',
      '500': 'var(--color-primary-500)',
      '600': 'var(--color-primary-600)',
      '700': 'var(--color-primary-700)',
      '800': 'var(--color-primary-800)',
      '900': 'var(--color-primary-900)',
      '950': 'var(--color-primary-950)'
    },
    zinc: {
      '50': 'var(--color-zinc-50)',
      '100': 'var(--color-zinc-100)',
      '200': 'var(--color-zinc-200)',
      '300': 'var(--color-zinc-300)',
      '400': 'var(--color-zinc-400)',
      '500': 'var(--color-zinc-500)',
      '600': 'var(--color-zinc-600)',
      '700': 'var(--color-zinc-700)',
      '800': 'var(--color-zinc-800)',
      '900': 'var(--color-zinc-900)',
      '950': 'var(--color-zinc-950)'
    },
    gray: {
      '50': 'var(--color-gray-50)',
      '80': 'var(--color-gray-80)',
      '100': 'var(--color-gray-100)',
      '200': 'var(--color-gray-200)',
      '300': 'var(--color-gray-300)',
      '400': 'var(--color-gray-400)',
      '500': 'var(--color-gray-500)',
      '600': 'var(--color-gray-600)',
      '700': 'var(--color-gray-700)',
      '750': 'var(--color-gray-750)',
      '800': 'var(--color-gray-800)',
      '900': 'var(--color-gray-900)'
    },
    red: {
      '50': 'var(--color-red-50)',
      '100': 'var(--color-red-100)',
      '200': 'var(--color-red-200)',
      '300': 'var(--color-red-300)',
      '400': 'var(--color-red-400)',
      '500': 'var(--color-red-500)',
      '600': 'var(--color-red-600)',
      '700': 'var(--color-red-700)',
      '800': 'var(--color-red-800)',
      '900': 'var(--color-red-900)',
      '950': 'var(--color-red-950)'
    },
    yellow: {
      '50': 'var(--color-yellow-50)',
      '100': 'var(--color-yellow-100)',
      '200': 'var(--color-yellow-200)',
      '300': 'var(--color-yellow-300)',
      '400': 'var(--color-yellow-400)',
      '500': 'var(--color-yellow-500)',
      '600': 'var(--color-yellow-600)',
      '700': 'var(--color-yellow-700)',
      '800': 'var(--color-yellow-800)',
      '900': 'var(--color-yellow-900)',
      '950': 'var(--color-yellow-950)'
    },
    green: {
      '50': 'var(--color-green-50)',
      '100': 'var(--color-green-100)',
      '200': 'var(--color-green-200)',
      '300': 'var(--color-green-300)',
      '400': 'var(--color-green-400)',
      '500': 'var(--color-green-500)',
      '600': 'var(--color-green-600)',
      '700': 'var(--color-green-700)',
      '800': 'var(--color-green-800)',
      '900': 'var(--color-green-900)',
      '950': 'var(--color-green-950)'
    },
    blue: {
      '50': 'var(--color-blue-50)',
      '100': 'var(--color-blue-100)',
      '200': 'var(--color-blue-200)',
      '300': 'var(--color-blue-300)',
      '400': 'var(--color-blue-400)',
      '500': 'var(--color-blue-500)',
      '600': 'var(--color-blue-600)',
      '700': 'var(--color-blue-700)',
      '800': 'var(--color-blue-800)',
      '900': 'var(--color-blue-900)',
      '950': 'var(--color-blue-950)'
    },
    purple: {
      '50': 'var(--color-purple-50)',
      '100': 'var(--color-purple-100)',
      '200': 'var(--color-purple-200)',
      '300': 'var(--color-purple-300)',
      '400': 'var(--color-purple-400)',
      '500': 'var(--color-purple-500)',
      '600': 'var(--color-purple-600)',
      '700': 'var(--color-purple-700)',
      '800': 'var(--color-purple-800)',
      '900': 'var(--color-purple-900)',
      '950': 'var(--color-purple-950)'
    },
    text: {
      '300': 'var(--color-text-300)',
      '500': 'var(--color-text-500)',
      '600': 'var(--color-text-600)',
      '700': 'var(--color-text-700)',
      '800': 'var(--color-text-800)',
      primary: 'var(--color-text-primary)',
      secondary: 'var(--color-text-secondary)',
      caption: 'var(--color-text-secondary)',
      description: 'var(--color-text-description)',
      description2: 'var(--color-text-description2)',
      disabled: 'var(--color-text-disabled)',
      translation: 'var(--color-text-translation)',
      info: 'var(--color-text-info)',
      success: 'var(--color-text-success)',
      danger: 'var(--color-text-danger)',
      '01': 'var(--color-text-01)',
      '02': 'var(--color-text-02)',
      '03': 'var(--color-text-03)'
    },
    feedback: {
      danger: 'var(--color-feedback-danger)',
      warning: 'var(--color-feedback-warning)',
      success: 'var(--color-feedback-success)',
      info: 'var(--color-feedback-info)',
      neutral: 'var(--color-feedback-neutral)'
    },
    button: {
      red: 'var(--color-button-red)',
      yellow: 'var(--color-button-yellow)',
      green: 'var(--color-button-green)',
      primary: 'var(--color-button-primary)',
      blue: 'var(--color-button-blue)',
      neutral: 'var(--color-button-neutral)',
      white: 'var(--color-button-white)',
      mint: 'var(--color-button-mint)'
    },
    background: {
      gray: 'var(--color-background-gray)',
      grayBold: 'var(--color-background-gray-bold)',
      disabled: 'var(--color-background-disabled)'
    },
    border: {
      muted: 'var(--color-border-muted)',
      normal: 'var(--color-border-normal)',
      bold: 'var(--color-border-bold)'
    }
  },
  font: {
    body: 'var(--font-body)',
    size: {
      '8': 'var(--font-size-8)',
      '10': 'var(--font-size-10)',
      '12': 'var(--font-size-12)',
      '13': 'var(--font-size-13)',
      '14': 'var(--font-size-14)',
      '15': 'var(--font-size-15)',
      '16': 'var(--font-size-16)',
      '18': 'var(--font-size-18)',
      '20': 'var(--font-size-20)',
      '22': 'var(--font-size-22)',
      '24': 'var(--font-size-24)',
      '32': 'var(--font-size-32)',
      '48': 'var(--font-size-48)',
      xs: 'var(--font-size-xs)',
      sm: 'var(--font-size-sm)',
      md: 'var(--font-size-md)',
      lg: 'var(--font-size-lg)',
      xl: 'var(--font-size-xl)',
      xxl: 'var(--font-size-xxl)'
    }
  },
  borderRadius: {
    sm: 'var(--border-radius-sm)',
    md: 'var(--border-radius-md)',
    lg: 'var(--border-radius-lg)',
    xl: 'var(--border-radius-xl)'
  },
  input: {
    size: {
      sm: 'var(--input-size-sm)',
      md: 'var(--input-size-md)',
      lg: 'var(--input-size-lg)'
    }
  }
};

var LiveButton = function LiveButton() {
  var _a = useContext(MediaPlayerContext),
    now = _a.now,
    initTs = _a.initTs,
    setInitTs = _a.setInitTs,
    currentTs = _a.currentTs,
    setStartTs = _a.setStartTs,
    setCurrentTs = _a.setCurrentTs,
    progressBarWidth = _a.progressBarWidth,
    timelineScrollRef = _a.timelineScrollRef,
    forceInitHls = _a.forceInitHls;
  /**
   * 재생시점과 현재시간이 일치할 경우 true를 반환합니다.
   * 이때 60초 이내 범위를 live로 판단합니다.
   */
  var isLive = useMemo(function () {
    var nowDate = new Date(now);
    var currentDate = new Date(currentTs);
    return differenceInSeconds(nowDate, currentDate) <= 60;
  }, [now, currentTs]);
  return jsxs("svg", {
    width: "58",
    height: "24",
    viewBox: "0 0 58 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      var _a;
      setInitTs(now);
      setCurrentTs(now);
      setStartTs(sub(new Date(now), {
        hours: 0.5
      }).getTime());
      (_a = timelineScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
        left: progressBarWidth
      });
      if (initTs === now) {
        void forceInitHls(now);
      }
    },
    children: [jsx("rect", {
      x: "0.5",
      y: "1",
      width: "57",
      height: "22",
      rx: "3.5",
      stroke: isLive ? '#D9D9D9' : undefined
    }), jsx("g", {
      filter: "url(#filter0_d_41_3)",
      children: jsx("circle", {
        cx: "11",
        cy: "12",
        r: "3",
        fill: isLive ? '#FF0000' : theme.color.gray[400]
      })
    }), jsx("g", {
      filter: "url(#filter1_d_41_3)",
      children: jsx("path", {
        d: "M21.585 6.4V15.64H26.085V17.5H19.365V6.4H21.585ZM29.9422 6.4V17.5H27.7222V6.4H29.9422ZM33.2584 6.4L34.7284 11.8C34.8984 12.43 35.0484 13.03 35.1784 13.6C35.3184 14.16 35.4784 14.755 35.6584 15.385H35.7334C35.9034 14.755 36.0584 14.16 36.1984 13.6C36.3484 13.03 36.5084 12.43 36.6784 11.8L38.1184 6.4H40.3684L36.9634 17.5H34.3234L30.9334 6.4H33.2584ZM48.1559 6.4V8.245H43.5659V10.81H47.4659V12.67H43.5659V15.64H48.3209V17.5H41.3459V6.4H48.1559Z",
        fill: "white"
      })
    }), jsxs("defs", {
      children: [jsxs("filter", {
        id: "filter0_d_41_3",
        x: "6",
        y: "8",
        width: "10",
        height: "10",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: "1"
        }), jsx("feGaussianBlur", {
          stdDeviation: "1"
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
        }), jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_41_3"
        }), jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_41_3",
          result: "shape"
        })]
      }), jsxs("filter", {
        id: "filter1_d_41_3",
        x: "16.365",
        y: "3.3999",
        width: "34.9558",
        height: "17.1001",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {}), jsx("feGaussianBlur", {
          stdDeviation: "1.5"
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        }), jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_41_3"
        }), jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_41_3",
          result: "shape"
        })]
      })]
    })]
  });
};

var PipButton = function PipButton() {
  var onClickPip = useContext(MediaPlayerContext).onClickPip;
  if (!onClickPip) return null;
  return jsx(ToolbarButton, {
    onClick: onClickPip,
    children: jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [jsx("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }), jsx("path", {
        d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
      }), jsx("path", {
        d: "M14 14m0 1a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1z"
      })]
    })
  });
};

var PlayButton = function PlayButton(props) {
  var isPlaying = props.isPlaying,
    onClick = props.onClick;
  return jsx(ToolbarButton, {
    onClick: onClick,
    children: isPlaying ? jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      children: [jsx("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }), jsx("path", {
        d: "M9 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z"
      }), jsx("path", {
        d: "M17 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z"
      })]
    }) : jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      children: [jsx("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }), jsx("path", {
        d: "M6 4v16a1 1 0 0 0 1.524 .852l13 -8a1 1 0 0 0 0 -1.704l-13 -8a1 1 0 0 0 -1.524 .852z"
      })]
    })
  });
};

var floating = 'styles_floating__11bab4y0';
var menu = 'styles_menu__11bab4y3';
var menuHeader = createRuntimeFn({
  defaultClassName: 'styles_menuHeader__11bab4y1',
  variantClassNames: {
    clickable: {
      "true": 'styles_menuHeader_clickable_true__11bab4y2'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var menuItem = createRuntimeFn({
  defaultClassName: 'styles_menuItem__11bab4y4',
  variantClassNames: {
    active: {
      "true": 'styles_menuItem_active_true__11bab4y5'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var menuItemSub = 'styles_menuItemSub__11bab4y6';

var PlaybackRateMenu = function PlaybackRateMenu(props) {
  var onClose = props.onClose;
  var _a = useMediaPlayerContext(),
    playbackRate = _a.playbackRate,
    setPlaybackRate = _a.setPlaybackRate;
  return jsxs(Fragment$1, {
    children: [jsxs("div", {
      className: menuHeader({
        clickable: true
      }),
      onClick: onClose,
      children: [jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [jsx("path", {
          stroke: "none",
          d: "M0 0h24v24H0z",
          fill: "none"
        }), jsx("path", {
          d: "M15 6l-6 6l6 6"
        })]
      }), jsx("div", {
        children: "\uC7AC\uC0DD\uC18D\uB3C4"
      })]
    }), jsxs("div", {
      className: menu,
      children: [jsx("div", {
        className: menuItem({
          active: playbackRate === 4
        }),
        onClick: function onClick() {
          setPlaybackRate(4);
          onClose === null || onClose === void 0 ? void 0 : onClose();
        },
        children: "4\uBC30\uC18D"
      }), jsx("div", {
        className: menuItem({
          active: playbackRate === 3
        }),
        onClick: function onClick() {
          setPlaybackRate(3);
          onClose === null || onClose === void 0 ? void 0 : onClose();
        },
        children: "3\uBC30\uC18D"
      }), jsx("div", {
        className: menuItem({
          active: playbackRate === 2
        }),
        onClick: function onClick() {
          setPlaybackRate(2);
          onClose === null || onClose === void 0 ? void 0 : onClose();
        },
        children: "2\uBC30\uC18D"
      }), jsx("div", {
        className: menuItem({
          active: playbackRate === 1
        }),
        onClick: function onClick() {
          setPlaybackRate(1);
          onClose === null || onClose === void 0 ? void 0 : onClose();
        },
        children: "1\uBC30\uC18D"
      })]
    })]
  });
};

var ResolutionMenu = function ResolutionMenu(props) {
  var onClose = props.onClose;
  var _a = useMediaPlayerContext(),
    containerRef = _a.containerRef,
    resolutions = _a.resolutions,
    currentResolution = _a.currentResolution,
    setCurrentResolution = _a.setCurrentResolution,
    userSetResolution = _a.userSetResolution,
    setUserSetResolution = _a.setUserSetResolution,
    isFullscreen = _a.isFullscreen;
  var _b = useState(1080),
    defaultResolution = _b[0],
    setDefaultResolution = _b[1];
  useResolution({
    isFullscreen: isFullscreen,
    containerRef: containerRef,
    setResolution: setDefaultResolution
  });
  return jsxs(Fragment$1, {
    children: [jsxs("div", {
      className: menuHeader({
        clickable: true
      }),
      onClick: onClose,
      children: [jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [jsx("path", {
          stroke: "none",
          d: "M0 0h24v24H0z",
          fill: "none"
        }), jsx("path", {
          d: "M15 6l-6 6l6 6"
        })]
      }), jsx("div", {
        children: "\uD654\uC9C8"
      })]
    }), jsxs("div", {
      className: menu,
      children: [resolutions.map(function (item) {
        return jsxs("div", {
          className: menuItem({
            active: currentResolution === item.resolution && userSetResolution
          }),
          onClick: function onClick() {
            setCurrentResolution(item.resolution);
            setUserSetResolution(true);
            onClose === null || onClose === void 0 ? void 0 : onClose();
          },
          children: [item.resolution, "p"]
        }, item._id);
      }), jsx("div", {
        className: menuItem({
          active: !userSetResolution
        }),
        onClick: function onClick() {
          setCurrentResolution(defaultResolution);
          setUserSetResolution(false);
          onClose === null || onClose === void 0 ? void 0 : onClose();
        },
        children: "\uC790\uB3D9"
      })]
    })]
  });
};

var SettingButton = function SettingButton() {
  var _a = useState(false),
    visible = _a[0],
    setVisible = _a[1];
  var setOverlayForceDisplay = useContext(MediaPlayerContext).setOverlayForceDisplay;
  useEffect(function () {
    if (visible) {
      setOverlayForceDisplay(true);
    } else {
      setOverlayForceDisplay(false);
    }
  }, [visible]);
  return jsxs(Fragment$1, {
    children: [jsx(ToolbarButton, {
      onClick: function onClick() {
        return setVisible(function (prev) {
          return !prev;
        });
      },
      children: jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [jsx("path", {
          stroke: "none",
          d: "M0 0h24v24H0z",
          fill: "none"
        }), jsx("path", {
          d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
        }), jsx("path", {
          d: "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
        })]
      })
    }), jsx(SettingMenu, {
      visible: visible,
      onClose: function onClose() {
        return setVisible(false);
      }
    })]
  });
};
var SettingMenu = function SettingMenu(props) {
  var visible = props.visible,
    onClose = props.onClose;
  var _a = useContext(MediaPlayerContext),
    containerRef = _a.containerRef,
    userSetResolution = _a.userSetResolution,
    currentResolution = _a.currentResolution,
    playbackRate = _a.playbackRate,
    resolutions = _a.resolutions;
  var wrapperRef = useRef(null);
  var _b = useState('settings'),
    mode = _b[0],
    setMode = _b[1];
  var handleClose = function handleClose() {
    setMode('settings');
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  useClickOutside(wrapperRef, function (event) {
    if (!visible) return;
    event.preventDefault();
    event.stopPropagation();
    handleClose === null || handleClose === void 0 ? void 0 : handleClose();
  });
  var getCurrentResolution = function getCurrentResolution() {
    if (!currentResolution) return 1080;
    var matchedResolution = resolutions.find(function (r) {
      return r.resolution === currentResolution;
    });
    if (!matchedResolution) {
      return 1080;
    }
    return matchedResolution.resolution;
  };
  if (!visible || !containerRef.current) return null;
  var renderMenu = function renderMenu() {
    switch (mode) {
      case 'settings':
        return jsxs(Fragment$1, {
          children: [jsx("div", {
            className: menuHeader(),
            children: "\uC124\uC815"
          }), jsxs("div", {
            className: menu,
            children: [jsxs("div", {
              className: menuItem(),
              onClick: function onClick() {
                return setMode('playbackRate');
              },
              children: [jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [jsx("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }), jsx("path", {
                  d: "M5.636 19.364a9 9 0 1 1 12.728 0"
                }), jsx("path", {
                  d: "M16 9l-4 4"
                })]
              }), jsx("div", {
                style: {
                  flex: 1
                },
                children: "\uC7AC\uC0DD \uC18D\uB3C4"
              }), jsxs("div", {
                className: menuItemSub,
                children: [playbackRate, "\uBC30\uC18D"]
              }), jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [jsx("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }), jsx("path", {
                  d: "M9 6l6 6l-6 6"
                })]
              })]
            }), jsxs("div", {
              className: menuItem(),
              onClick: function onClick() {
                return setMode('resolution');
              },
              children: [jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [jsx("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }), jsx("path", {
                  d: "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
                }), jsx("path", {
                  d: "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
                }), jsx("path", {
                  d: "M7 15v-6"
                }), jsx("path", {
                  d: "M10 15v-6"
                }), jsx("path", {
                  d: "M7 12h3"
                })]
              }), jsx("div", {
                style: {
                  flex: 1
                },
                children: "\uD654\uC9C8"
              }), jsx("div", {
                className: menuItemSub,
                children: userSetResolution ? "".concat(getCurrentResolution(), "p") : "\uC790\uB3D9(".concat(getCurrentResolution(), "p)")
              }), jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [jsx("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }), jsx("path", {
                  d: "M9 6l6 6l-6 6"
                })]
              })]
            })]
          })]
        });
      case 'playbackRate':
        return jsx(PlaybackRateMenu, {
          onClose: function onClose() {
            return setMode('settings');
          }
        });
      case 'resolution':
        return jsx(ResolutionMenu, {
          onClose: function onClose() {
            return setMode('settings');
          }
        });
    }
  };
  return createPortal(jsx("div", {
    ref: wrapperRef,
    className: floating,
    children: renderMenu()
  }), containerRef.current);
};

var toolbarControls = 'styles_toolbarControls__stky2k0';
var toolbarControlsSide = 'styles_toolbarControlsSide__stky2k1';
var volumeButtonWrapper = 'styles_volumeButtonWrapper__stky2k2';
var volumeProgressBar = 'styles_volumeProgressBar__stky2k5';
var volumeProgressBarProgress = 'styles_volumeProgressBarProgress__stky2k6';
var volumeProgressBarScrubber = 'styles_volumeProgressBarScrubber__stky2k7';
var volumeProgressBarWrapper = createRuntimeFn({
  defaultClassName: 'styles_volumeProgressBarWrapper__stky2k3',
  variantClassNames: {
    opened: {
      "true": 'styles_volumeProgressBarWrapper_opened_true__stky2k4'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});

var VolumeButton = function VolumeButton(props) {
  var opened = props.opened,
    onOpenChange = props.onOpenChange,
    onActiveChange = props.onActiveChange;
  var _a = useContext(MediaPlayerContext),
    videoRef = _a.videoRef,
    setOverlayForceDisplay = _a.setOverlayForceDisplay;
  var _b = useState(0),
    volume = _b[0],
    setVolume = _b[1];
  var _c = useState(true),
    muted = _c[0],
    setMuted = _c[1];
  var trackRef = useRef(null);
  var isIos = function isIos() {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    return iOSSafari;
  };
  /**
   * 마우스 드래그 이벤트 제거
   */
  var clearEventListeners = function clearEventListeners() {
    document.removeEventListener('mousemove', handleDragIdle);
    document.removeEventListener('mouseup', handleDragStop);
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('touchend', handleTouchEnd);
  };
  /**
   * 프로그래스바 크기 계산 및 언마운트 시 불필요한 이벤트 제거
   */
  useEffect(function () {
    return function () {
      clearEventListeners();
    };
  }, []);
  useEffect(function () {
    if (!videoRef.current) return;
    var onVolumeChange = function onVolumeChange() {
      setMuted(videoRef.current.muted);
      setVolume(videoRef.current.volume);
    };
    videoRef.current.addEventListener('volumechange', onVolumeChange);
    return function () {
      var _a;
      (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('volumechange', onVolumeChange);
    };
  }, [videoRef.current]);
  /**
   * pageX를 기반으로 볼륨값을 찾습니다.
   * @param pageX
   * @returns
   */
  var getVolume = function getVolume(pageX) {
    var min = 0;
    var max = trackRef.current.getBoundingClientRect().width;
    var trackLeft = trackRef.current.getBoundingClientRect().left;
    /**
     * 프로그래스 바의 가장 왼쪽 또는 바깥쪽에 위치할 경우 0이 되도록 합니다.
     */
    var currentX = pageX - trackLeft;
    if (currentX > max) {
      currentX = max;
    }
    if (currentX < min) {
      currentX = min;
    }
    return currentX / max;
  };
  var handleChange = function handleChange(value) {
    if (!videoRef.current) return;
    if (!value) {
      onActiveChange(false);
    } else {
      onActiveChange(true);
    }
    videoRef.current.muted = false;
    videoRef.current.volume = value;
  };
  /**
   * 드래그 시작
   * @param event
   */
  var handleDragStart = function handleDragStart(event) {
    document.addEventListener('mousemove', handleDragIdle);
    document.addEventListener('mouseup', handleDragStop);
    handleChange(getVolume(event.pageX));
    setOverlayForceDisplay(true);
  };
  /**
   * 드래그 이동
   * @param event
   */
  var handleDragIdle = function handleDragIdle(event) {
    handleChange(getVolume(event.pageX));
  };
  /**
   * 드래그 중단
   */
  var handleDragStop = function handleDragStop(event) {
    handleChange(getVolume(event.pageX));
    clearEventListeners();
    setOverlayForceDisplay(false);
  };
  var handleTouchStart = function handleTouchStart(event) {
    var _a;
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
    handleChange(getVolume((_a = event.changedTouches.item(0)) === null || _a === void 0 ? void 0 : _a.pageX));
    setOverlayForceDisplay(true);
  };
  var handleTouchMove = function handleTouchMove(event) {
    var _a;
    handleChange(getVolume(((_a = event.changedTouches.item(0)) === null || _a === void 0 ? void 0 : _a.pageX) || 0));
  };
  var handleTouchEnd = function handleTouchEnd(event) {
    var _a;
    handleChange(getVolume(((_a = event.changedTouches.item(0)) === null || _a === void 0 ? void 0 : _a.pageX) || 0));
    clearEventListeners();
    setOverlayForceDisplay(false);
  };
  return jsxs("div", {
    className: volumeButtonWrapper,
    onMouseOver: function onMouseOver() {
      return onOpenChange(true);
    },
    children: [jsx(ToolbarButton, {
      onClick: function onClick() {
        if (!videoRef.current) return;
        if (videoRef.current.volume === 0 || videoRef.current.muted) {
          videoRef.current.muted = false;
          videoRef.current.volume = 1;
          onActiveChange(true);
        } else {
          videoRef.current.muted = true;
          videoRef.current.volume = 0;
          onActiveChange(false);
        }
      },
      children: volume === 0 || muted ? jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [jsx("path", {
          d: "M5.41956 8.18016H2C1.44772 8.18016 1 8.62787 1 9.18016V14.8202C1 15.3724 1.44793 15.8202 2.00022 15.8202H5.41944C5.6463 15.8202 5.86654 15.8973 6.04378 16.0389L11.4662 20.3714C11.6435 20.513 11.8636 20.5902 12.0904 20.5902H12.41C12.9623 20.5902 13.41 20.1424 13.41 19.5902V4.41016C13.41 3.85787 12.9623 3.41016 12.41 3.41016H12.0904C11.8636 3.41016 11.6435 3.48729 11.4662 3.6289L6.04378 7.96141C5.86654 8.10302 5.64642 8.18016 5.41956 8.18016Z",
          fill: "white"
        }), jsx("path", {
          d: "M22.5 9L16.77 14.72",
          stroke: "white",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round"
        }), jsx("path", {
          d: "M16.77 9L22.5 14.72",
          stroke: "white",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round"
        })]
      }) : jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [jsx("path", {
          d: "M5.41956 8.18016H2C1.44772 8.18016 1 8.62787 1 9.18016V14.8202C1 15.3724 1.44793 15.8202 2.00022 15.8202H5.41944C5.6463 15.8202 5.86654 15.8973 6.04378 16.0389L11.4662 20.3714C11.6435 20.513 11.8636 20.5902 12.0904 20.5902H12.41C12.9623 20.5902 13.41 20.1424 13.41 19.5902V4.41016C13.41 3.85787 12.9623 3.41016 12.41 3.41016H12.0904C11.8636 3.41016 11.6435 3.48729 11.4662 3.6289L6.04378 7.96141C5.86654 8.10302 5.64642 8.18016 5.41956 8.18016Z",
          fill: "white"
        }), jsx("path", {
          d: "M16.5 3.91602C19.9956 5.09269 22.5 8.26766 22.5 11.9997C22.5 15.7318 19.9956 18.9067 16.5 20.0834",
          stroke: "white",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        }), jsx("path", {
          d: "M19.2834 12C19.2834 10.2687 18.1216 8.79586 16.5 8.25V15.75C18.1216 15.2041 19.2834 13.7313 19.2834 12Z",
          fill: "white",
          stroke: "white",
          strokeLinejoin: "round"
        })]
      })
    }), !isIos() && jsx("div", {
      className: volumeProgressBarWrapper({
        opened: opened
      }),
      onMouseDown: handleDragStart,
      onTouchStart: handleTouchStart,
      children: jsxs("div", {
        ref: trackRef,
        className: volumeProgressBar,
        children: [jsx("div", {
          className: volumeProgressBarProgress,
          style: {
            width: "".concat(volume * 100, "%")
          }
        }), jsx("div", {
          className: volumeProgressBarScrubber,
          style: {
            transform: "translateX(".concat(volume * 60, "px)")
          }
        })]
      })
    })]
  });
};

var zoomContainer = 'styles_zoomContainer__1wso9f80';
var zoomControllButton = 'styles_zoomControllButton__1wso9f81';
var zoomProgressBar = 'styles_zoomProgressBar__1wso9f82';
var zoomProgressBarProgress = 'styles_zoomProgressBarProgress__1wso9f83';
var zoomProgressBarScrubber = 'styles_zoomProgressBarScrubber__1wso9f84';

var Zoom = function Zoom() {
  var _a = useContext(MediaPlayerContext),
    zoomLevel = _a.zoomLevel,
    setZoomLevel = _a.setZoomLevel,
    setOverlayForceDisplay = _a.setOverlayForceDisplay;
  var trackRef = useRef(null);
  var isMobile = useIsMobile();
  var getZoomLevelByClientY = function getZoomLevelByClientY(clientY) {
    var min = 0;
    var max = trackRef.current.getBoundingClientRect().height;
    var trackBottom = trackRef.current.getBoundingClientRect().bottom;
    /**
     * 프로그래스 바를 벗어나지 않도록 min/max를 설정합니다.
     */
    var currentY = (clientY - trackBottom) * -1;
    if (currentY > max) {
      currentY = max;
    }
    if (currentY < min) {
      currentY = min;
    }
    return currentY / max;
  };
  /**
   * 드래그 시작
   * @param event
   */
  var handleDragStart = function handleDragStart(event) {
    document.addEventListener('mousemove', handleDragIdle);
    document.addEventListener('mouseup', handleDragStop);
    setZoomLevel(getZoomLevelByClientY(event.clientY));
    setOverlayForceDisplay(true);
  };
  /**
   * 드래그 이동
   * @param event
   */
  var handleDragIdle = function handleDragIdle(event) {
    setZoomLevel(getZoomLevelByClientY(event.clientY));
  };
  /**
   * 드래그 중단
   */
  var handleDragStop = function handleDragStop(event) {
    setZoomLevel(getZoomLevelByClientY(event.clientY));
    clearEventListeners();
    setOverlayForceDisplay(false);
  };
  var handleTouchStart = function handleTouchStart(event) {
    var _a;
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
    setZoomLevel(getZoomLevelByClientY((_a = event.touches[0]) === null || _a === void 0 ? void 0 : _a.clientY));
    setOverlayForceDisplay(true);
  };
  var handleTouchMove = function handleTouchMove(event) {
    var _a;
    event.preventDefault();
    setZoomLevel(getZoomLevelByClientY(((_a = event.touches[0]) === null || _a === void 0 ? void 0 : _a.clientY) || 0));
  };
  var handleTouchEnd = function handleTouchEnd(event) {
    clearEventListeners();
    setOverlayForceDisplay(false);
  };
  /**
   * 마우스 드래그 이벤트 제거
   */
  var clearEventListeners = function clearEventListeners() {
    document.removeEventListener('mousemove', handleDragIdle);
    document.removeEventListener('mouseup', handleDragStop);
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('touchend', handleTouchEnd);
  };
  /**
   * 프로그래스바 크기 계산 및 언마운트 시 불필요한 이벤트 제거
   */
  useEffect(function () {
    return function () {
      clearEventListeners();
    };
  }, []);
  if (isMobile) return null;
  return jsxs("div", {
    className: zoomContainer,
    children: [jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      className: zoomControllButton,
      onClick: function onClick() {
        return setZoomLevel(function (prev) {
          var newValue = prev + 0.1;
          if (newValue > 1) return 1;
          return newValue;
        });
      },
      children: [jsx("path", {
        d: "M6 9H12",
        stroke: "white",
        strokeWidth: "1.3",
        strokeLinecap: "round"
      }), jsx("path", {
        d: "M9 6V12",
        stroke: "white",
        strokeWidth: "1.3",
        strokeLinecap: "round"
      }), jsx("path", {
        d: "M8.79247 15.5849C12.5438 15.5849 15.5849 12.5438 15.5849 8.79245C15.5849 5.04108 12.5438 2 8.79247 2C5.04109 2 2 5.04108 2 8.79245C2 12.5438 5.04109 15.5849 8.79247 15.5849Z",
        stroke: "white",
        strokeWidth: "1.3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M18 18.0002L13.5974 13.5977",
        stroke: "white",
        strokeWidth: "1.3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), jsxs("div", {
      ref: trackRef,
      className: zoomProgressBar,
      onMouseDown: handleDragStart,
      onTouchStart: handleTouchStart,
      children: [jsx("div", {
        className: zoomProgressBarProgress,
        style: {
          height: "".concat(zoomLevel * 100, "%")
        }
      }), jsx("div", {
        className: zoomProgressBarScrubber,
        style: {
          transform: "translateY(".concat(90 - zoomLevel * 90, "px)")
        }
      })]
    }), jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      className: zoomControllButton,
      onClick: function onClick() {
        return setZoomLevel(function (prev) {
          var newValue = prev - 0.1;
          if (newValue < 0) return 0;
          return newValue;
        });
      },
      children: [jsx("path", {
        d: "M6 9H12",
        stroke: "white",
        strokeWidth: "1.3",
        strokeLinecap: "round"
      }), jsx("path", {
        d: "M8.79247 15.5849C12.5438 15.5849 15.5849 12.5438 15.5849 8.79245C15.5849 5.04108 12.5438 2 8.79247 2C5.04109 2 2 5.04108 2 8.79245C2 12.5438 5.04109 15.5849 8.79247 15.5849Z",
        stroke: "white",
        strokeWidth: "1.3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M18 18.0002L13.5974 13.5977",
        stroke: "white",
        strokeWidth: "1.3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })]
  });
};

var Controls = function Controls(props) {
  var isPlaying = props.isPlaying,
    onPlayPause = props.onPlayPause;
  var _a = useMediaPlayerContext(),
    setControlMouseOvered = _a.setControlMouseOvered,
    _b = _a.showZoomControl,
    showZoomControl = _b === void 0 ? true : _b,
    renderControlsRight = _a.renderControlsRight;
  /**
   * 사용자가 볼륨 슬라이더를 조작한 이후부터는 마우스 아웃이 발생해도
   * 슬라이더를 숨기지 않습니다.
   */
  var _c = useState(false),
    volumeActived = _c[0],
    setVolumeActived = _c[1];
  var _d = useState(false),
    volumeOpened = _d[0],
    setVolumeOpened = _d[1];
  /**
   * 오른쪽 사이드 영역의 각 버튼들을 개별적으로 생성
   */
  var settingButton = jsx(SettingButton, {});
  var pipButton = jsx(PipButton, {});
  var dateButton = jsx(DateButton, {});
  var fullscreenButton = jsx(FullscreenButton, {});
  /**
   * 커스텀 렌더 함수가 있으면 개별 버튼을 전달하여 사용하고,
   * 없으면 기본 순서대로 모든 버튼을 표시합니다.
   */
  var rightButtons = renderControlsRight ? renderControlsRight({
    settingButton: settingButton,
    pipButton: pipButton,
    dateButton: dateButton,
    fullscreenButton: fullscreenButton
  }) : jsxs(Fragment$1, {
    children: [settingButton, pipButton, dateButton, fullscreenButton]
  });
  return jsxs("div", {
    className: toolbarControls,
    onMouseOver: function onMouseOver() {
      return setControlMouseOvered(true);
    },
    onMouseOut: function onMouseOut(e) {
      setControlMouseOvered(false);
      if (volumeActived) return;
      if (e.currentTarget === e.target) {
        setVolumeOpened(false);
      }
    },
    children: [showZoomControl && jsx(Zoom, {}), jsxs("div", {
      className: toolbarControlsSide,
      style: {
        gap: 12
      },
      children: [jsx(PlayButton, {
        isPlaying: isPlaying,
        onClick: onPlayPause
      }), jsx(LiveButton, {}), jsx(VolumeButton, {
        opened: volumeOpened,
        onOpenChange: setVolumeOpened,
        onActiveChange: setVolumeActived
      })]
    }), jsx("div", {
      className: toolbarControlsSide,
      children: rightButtons
    })]
  });
};

var Loading = function Loading(props) {
  var loading = props.loading;
  return jsx("div", {
    className: overlayLoading({
      loading: loading
    }),
    children: jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "20%",
      height: "20%",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [jsx("g", {
        transform: "rotate(0 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.9166666666666666s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(30 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.8333333333333334s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(60 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.75s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(90 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.6666666666666666s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(120 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.5833333333333334s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(150 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.5s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(180 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.4166666666666667s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(210 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.3333333333333333s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(240 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.25s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(270 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.16666666666666666s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(300 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "-0.08333333333333333s",
            repeatCount: "indefinite"
          })
        })
      }), jsx("g", {
        transform: "rotate(330 50 50)",
        children: jsx("rect", {
          x: "47",
          y: "21",
          rx: "3",
          ry: "4.08",
          width: "6",
          height: "12",
          fill: "#ffffff",
          children: jsx("animate", {
            attributeName: "opacity",
            values: "1;0",
            keyTimes: "0;1",
            dur: "1s",
            begin: "0s",
            repeatCount: "indefinite"
          })
        })
      })]
    })
  });
};

var progressBarContainer = 'styles_progressBarContainer__9i68fb1';
var progressBarIndex = createRuntimeFn({
  defaultClassName: 'styles_progressBarIndex__9i68fb8',
  variantClassNames: {
    size: {
      small: 'styles_progressBarIndex_size_small__9i68fb9',
      medium: 'styles_progressBarIndex_size_medium__9i68fba'
    },
    active: {
      "true": 'styles_progressBarIndex_active_true__9i68fbb'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var progressBarIndexTime = 'styles_progressBarIndexTime__9i68fbc';
var progressBarScrubber = 'styles_progressBarScrubber__9i68fb7';
var progressBarTrack = 'styles_progressBarTrack__9i68fb4';
var progressBarTrackBackground = 'styles_progressBarTrackBackground__9i68fb5';
var progressBarTrackBuffer = 'styles_progressBarTrackBuffer__9i68fb6';
var progressBarTrackContainer = 'styles_progressBarTrackContainer__9i68fb3';
var progressBarTrackScroll = 'styles_progressBarTrackScroll__9i68fb2';
var timelineContainer = 'styles_timelineContainer__9i68fb0';

var BREAKPOINTS = [{
  minWidth: 1600,
  intervalSeconds: 60,
  format: 'a hh:mm',
  splitCount: 5 // 5분마다
}, {
  minWidth: 600,
  intervalSeconds: 120,
  format: 'a hh:mm',
  splitCount: 5 // 10분마다
}, {
  minWidth: 0,
  intervalSeconds: 600,
  format: 'a hh:mm',
  splitCount: 2 // 30분마다
}];

var MAX_HOUR = 1;
/**
 * 프로그래스바
 *
 * - 현재 재생시점과 진행률을 표시하며, 사용자가 직접 컨트롤할 수 있는 UI를 제공한다.
 * - 한시간의 구간을 표현한다.
 */
var ProgressBar = function ProgressBar() {
  var _a = useMediaPlayerContext(),
    hlsRef = _a.hlsRef,
    videoRef = _a.videoRef,
    timelineScrollRef = _a.timelineScrollRef,
    timelineData = _a.timelineData,
    forceInitHls = _a.forceInitHls,
    now = _a.now,
    initTs = _a.initTs,
    setInitTs = _a.setInitTs,
    currentTs = _a.currentTs,
    setCurrentTs = _a.setCurrentTs,
    startTs = _a.startTs,
    setStartTs = _a.setStartTs,
    endTs = _a.endTs,
    progressBarWidth = _a.progressBarWidth,
    setProgressBarWidth = _a.setProgressBarWidth;
  var progressBarRef = useRef(null);
  var trackRef = useRef(null);
  var progressBarWidthRef = useRef(0);
  var _b = useState(false),
    isDragging = _b[0],
    setIsDragging = _b[1];
  var intlFormat = useFormat().intlFormat;
  var startTsRef = useRef(startTs);
  var endTsRef = useRef(endTs);
  useEffect(function () {
    startTsRef.current = startTs;
    endTsRef.current = endTs;
  }, [startTs, endTs]);
  /**
   * video element onTimeUpdate event handler
   * 동영상의 재생시점이 변경될 때마다 currentTs를 갱신합니다.
   * 갱신값을 만들 때 만약 timeOffset값이 존재한다면 이 값을 이용하여
   * 보정합니다.
   */
  var onTimeUpdate = function onTimeUpdate() {
    var _a;
    // 비디오가 정상적으로 재생될 때까지 기다립니다.
    if (!((_a = hlsRef === null || hlsRef === void 0 ? void 0 : hlsRef.current) === null || _a === void 0 ? void 0 : _a.playingDate)) return;
    var playingTime = new Date(hlsRef.current.playingDate).getTime();
    if (!Number.isFinite(playingTime)) {
      return;
    }
    setCurrentTs(playingTime);
    if (playingTime >= endTsRef.current) {
      logger$1.debug('재생시점이 타임라인보다 미래', playingTime, endTsRef.current);
      setStartTs(playingTime);
    }
    if (playingTime < startTsRef.current) {
      logger$1.debug('재생시점이 타임라인보다 과거', playingTime, startTsRef.current);
      setStartTs(playingTime);
    }
  };
  /**
   * video element에 ontimeupdate 이벤트 리스너를 추가합니다.
   * initTs, 비디오 엘리먼트의 상태 등이 변경될 때마다
   * 리스너를 완전히 삭제한 후 다시 생성하며, 드래깅 중에는
   * 이벤트 리스너를 생성하지 않도록 하여 프로그래스바가 임의로 움직여지지 않도록 방지합니다.
   */
  useEffect(function () {
    if (!videoRef.current) return;
    videoRef.current.removeEventListener('timeupdate', onTimeUpdate);
    if (isDragging) return;
    videoRef.current.addEventListener('timeupdate', onTimeUpdate);
    return function () {
      var _a;
      (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('timeupdate', onTimeUpdate);
    };
  }, [initTs, videoRef.current, isDragging]);
  /**
   * 화면 또는 오브젝트의 크기 등이 변경될 때 프로그래스바의 넓이를 다시 구합니다.
   */
  var handleResize = function handleResize() {
    var newWidth = getProgressBarWidth();
    setProgressBarWidth(newWidth);
    progressBarWidthRef.current = newWidth;
  };
  /**
   * 마우스 드래그 이벤트 제거
   */
  var removeMouseEvents = function removeMouseEvents() {
    document.removeEventListener('mousemove', handleDragIdle);
    document.removeEventListener('mouseup', handleDragStop);
  };
  /**
   * 프로그래스바 크기 계산 및 언마운트 시 불필요한 이벤트 제거
   */
  useEffect(function () {
    setProgressBarWidth(getProgressBarWidth());
    progressBarWidthRef.current = getProgressBarWidth();
    window.addEventListener('resize', handleResize);
    // Remove mouse event on document when unmounted
    return function () {
      removeMouseEvents();
      window.removeEventListener('resize', handleResize);
    };
  }, [progressBarRef.current]);
  /**
   * 현재 재생시점 변경
   * @param {number} ts
   * @param {boolean|undefined} initialize
   * true일 경우 initTs 값을 갱신하고 hls를 초기화합니다.
   */
  var handleChange = function handleChange(ts, initialize) {
    /**
     * 재생하고자 하는 시점이 재생유효범위 내인지 체크합니다.
     */
    var newValue = now < ts ? now : ts;
    setCurrentTs(newValue);
    if (initialize) {
      setInitTs(function (prev) {
        // 이전값과 현재값이 동일하다면 강제 초기화를 실행합니다.
        if (prev === newValue) {
          logger$1.warn('ProgressBar: 이전과 현재값이 동일해 강제 초기화를 실행합니다.');
          void forceInitHls(newValue);
        }
        return newValue;
      });
    }
  };
  /**
   * 프로그래스바의 넓이를 동적으로 구해옵니다.
   */
  var getProgressBarWidth = function getProgressBarWidth() {
    var _a, _b;
    return (_b = (_a = progressBarRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
  };
  /**
   * 1초를 화면에 표현하기 위해 필요한 픽셀값을 반환합니다.
   */
  var widthOfSeconds = useMemo(function () {
    return progressBarWidth / 3600;
  }, [progressBarWidth]);
  /**
   * 밀리초 단위를 픽셀로 변환합니다.
   * @param value
   * @returns
   */
  var getMsByPx = function getMsByPx(value) {
    return Math.floor(value / (widthOfSeconds / 1000));
  };
  /**
   * mousePaeX를 밀리초 단위의 타임스탬프로 변환해줍니다.
   * @param mousePageX
   * @returns
   */
  var getTsByMousePageX = function getTsByMousePageX(mousePageX) {
    var min = 0;
    var max = getProgressBarWidth();
    var trackLeft = trackRef.current.getBoundingClientRect().left;
    /**
     * 프로그래스 바의 가장 왼쪽 또는 바깥쪽에 위치할 경우 0이 되도록 합니다.
     */
    var currentPosition = mousePageX - trackLeft;
    if (currentPosition > max) {
      currentPosition = max;
    }
    if (currentPosition < min) {
      currentPosition = min;
    }
    return startTs + getMsByPx(currentPosition);
  };
  /**
   * 드래그 시작
   * @param event
   */
  var handleDragStart = function handleDragStart(event) {
    var _a;
    setIsDragging(true);
    document.addEventListener('mousemove', handleDragIdle);
    document.addEventListener('mouseup', handleDragStop);
    (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
    /**
     * 이벤트 루프의 마지막에 동작하도록 지연
     */
    setTimeout(function () {
      return handleChange(getTsByMousePageX(event.pageX));
    }, 0);
  };
  /**
   * 드래그 이동
   * @param event
   */
  var handleDragIdle = function handleDragIdle(event) {
    var _a;
    (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
    handleChange(getTsByMousePageX(event.pageX));
  };
  /**
   * 드래그 중단
   */
  var handleDragStop = function handleDragStop(event) {
    setIsDragging(false);
    handleChange(getTsByMousePageX(event.pageX), true);
    playMediaSafely(videoRef.current, 'progress-bar-drag-stop');
    removeMouseEvents();
  };
  /**
   * 현재 환경과 제약조건이 일치하는 브레이크 포인트를 찾는다.
   * 현재 환경은 프로그래스바의 넓이를 기준으로 하며, 이때 프로그래스바의 넓이는
   * 트랙 전체의 길이를 의미하지 않는다.
   * 트랙을 기준으로는 한시간 범위를 의미한다.
   */
  var currentBreakpoint = useMemo(function () {
    return BREAKPOINTS.find(function (bp) {
      return bp.minWidth <= progressBarWidth;
    });
  }, [progressBarWidth]);
  /**
   * 눈금을 데이터화합니다.
   */
  var scales = useMemo(function () {
    if (!currentBreakpoint) return [];
    var intervalSeconds = currentBreakpoint.intervalSeconds,
      splitCount = currentBreakpoint.splitCount;
    // 눈금의 전체 초
    var totalSeconds = 3600; // 1 hour
    // 눈금의 갯수
    var pointsLength = totalSeconds / intervalSeconds + 1;
    var points = Array.from({
      length: pointsLength
    }).map(function (_, index) {
      var ts = (startTs / 1000 + intervalSeconds * index) * 1000;
      var showLabel = index % splitCount === 0; // splitCount 마다 true
      return {
        ts: ts,
        showLabel: showLabel
      };
    });
    return points;
  }, [currentBreakpoint, progressBarWidth, startTs, endTs]);
  var visibleTimelineData = useMemo(function () {
    return (timelineData !== null && timelineData !== void 0 ? timelineData : []).flatMap(function (item) {
      var rawStartTs = new Date(item.startTime).getTime();
      var rawEndTs = new Date(item.endTime).getTime();
      if (!Number.isFinite(rawStartTs) || !Number.isFinite(rawEndTs) || rawEndTs <= rawStartTs) {
        return [];
      }
      var visibleStartTs = Math.max(rawStartTs, startTs);
      var visibleEndTs = Math.min(rawEndTs, endTs);
      if (visibleEndTs <= visibleStartTs) {
        return [];
      }
      return [{
        startTime: visibleStartTs,
        endTime: visibleEndTs
      }];
    });
  }, [endTs, startTs, timelineData]);
  /**
   * 트랙 영역을 그려냅니다.
   */
  var renderTrack = function renderTrack() {
    return jsxs("div", {
      className: progressBarTrack,
      style: {
        width: "".concat(progressBarWidth, "px")
      },
      children: [scales.map(function (plotPoint, index) {
        if (!currentBreakpoint) return null;
        return jsx("div", {
          className: progressBarIndex({
            size: plotPoint.showLabel ? 'medium' : 'small'
          }),
          style: {
            left: "".concat(Math.floor((plotPoint.ts - startTs) / 1000 * widthOfSeconds), "px")
          },
          children: plotPoint.showLabel && jsx("div", {
            className: progressBarIndexTime,
            children: intlFormat(new Date(plotPoint.ts), {
              hour: 'numeric',
              minute: 'numeric'
            })
          })
        }, index);
      }), jsx("div", {
        className: progressBarTrackBackground,
        style: {
          width: "".concat(progressBarWidth * MAX_HOUR, "px")
        },
        children: visibleTimelineData.map(function (item, itemIndex) {
          var startDate = new Date(item.startTime);
          var endDate = new Date(item.endTime);
          var startDiff = differenceInSeconds(startDate, new Date(startTs));
          var endDiff = differenceInSeconds(endDate, startDate);
          return jsx("div", {
            className: progressBarTrackBuffer,
            style: {
              left: "".concat(startDiff * widthOfSeconds, "px"),
              width: "".concat(endDiff * widthOfSeconds, "px")
            }
          }, itemIndex);
        })
      })]
    });
  };
  var currentX = useMemo(function () {
    return (currentTs - startTs) / 1000 * widthOfSeconds;
  }, [currentTs, startTs, widthOfSeconds]);
  /**
   * Mark up
   */
  return jsx("div", {
    ref: progressBarRef,
    className: progressBarContainer,
    onMouseDown: handleDragStart,
    children: jsxs("div", {
      ref: timelineScrollRef,
      className: progressBarTrackScroll,
      children: [jsx("div", {
        ref: trackRef,
        className: progressBarTrackContainer,
        style: {
          width: progressBarWidth
        },
        children: renderTrack()
      }), jsxs("svg", {
        className: progressBarScrubber,
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        style: {
          transform: "translateX(".concat(currentX, "px)")
        },
        children: [jsx("circle", {
          cx: "8.5",
          cy: "8.5",
          r: "8.5",
          fill: "black",
          fillOpacity: "0.5"
        }), jsx("circle", {
          cx: "8.5",
          cy: "8.5",
          r: "8",
          stroke: "white",
          strokeOpacity: "0.8"
        }), jsx("circle", {
          cx: "8.5",
          cy: "8.5",
          r: "3.5",
          fill: "white",
          fillOpacity: "0.8"
        })]
      })]
    })
  });
};

var Timeline = function Timeline() {
  var _a = useMediaPlayerContext(),
    now = _a.now,
    setStartTs = _a.setStartTs,
    setInitTs = _a.setInitTs,
    currentTs = _a.currentTs,
    setCurrentTs = _a.setCurrentTs;
  /**
   * 재생시점을 변경합니다.
   * - 재생시점을 변경할 때 전후 여부를 판단하여 가상의 애니메이션을 재생시킵니다.
   */
  var handleMoveTime = useThrottleFn(function (second) {
    var moveMs = second * 1000;
    var newInitTs = currentTs + moveMs;
    var newStartTs = sub(newInitTs, {
      hours: 0.5
    }).getTime();
    /**
     * 변경 시간이 현재 시간보다 미래라면 초기화합니다.
     */
    if (newInitTs >= now) {
      setStartTs(sub(now, {
        hours: 0.5
      }).getTime());
      setInitTs(now);
      setCurrentTs(now);
      return;
    }
    setStartTs(newStartTs);
    setInitTs(newInitTs);
    setCurrentTs(newInitTs);
  }, {
    wait: 400
  }).run;
  return jsxs("div", {
    className: timelineContainer,
    children: [jsx(ToolbarButton, {
      onClick: function onClick() {
        handleMoveTime(-3600);
      },
      children: jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [jsx("path", {
          d: "M18 18L12 12L18 6",
          stroke: "white",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), jsx("path", {
          d: "M11 18L5 12L11 6",
          stroke: "white",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      })
    }), jsx(ToolbarButton, {
      onClick: function onClick() {
        handleMoveTime(-600);
      },
      children: jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: jsx("path", {
          d: "M15 18L9 12L15 6",
          stroke: "white",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })
    }), jsx(ProgressBar, {}), jsx(ToolbarButton, {
      onClick: function onClick() {
        handleMoveTime(600);
      },
      children: jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
          d: "M9 18L15 12L9 6",
          stroke: "white",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })
    }), jsx(ToolbarButton, {
      onClick: function onClick() {
        handleMoveTime(3600);
      },
      children: jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [jsx("path", {
          d: "M6 18L12 12L6 6",
          stroke: "white",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), jsx("path", {
          d: "M13 18L19 12L13 6",
          stroke: "white",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      })
    })]
  });
};

var useVideoMove = function useVideoMove(props) {
  var ref = props.ref,
    scale = props.scale,
    onClick = props.onClick,
    onPinch = props.onPinch;
  var _a = useState(0),
    x = _a[0],
    setX = _a[1]; // %
  var _b = useState(0),
    y = _b[0],
    setY = _b[1]; // %
  var scaleRef = useRef(scale);
  var prevTouches = useRef([]);
  var prevDistance = useRef(0);
  var isDragging = useRef(false);
  useEffect(function () {
    scaleRef.current = scale;
    var minPercentage = (scaleRef.current - 1) / scaleRef.current * 100 / 2;
    var maxPercentage = minPercentage * -1;
    if (x > minPercentage) setX(minPercentage);
    if (x < maxPercentage) setX(maxPercentage);
    if (y > minPercentage) setY(minPercentage);
    if (y < maxPercentage) setY(maxPercentage);
  }, [scale]);
  /**
   * 드래그 시작
   * @param event
   */
  var handleDragStart = function handleDragStart(event) {
    document.addEventListener('mousemove', handleDragIdle);
    document.addEventListener('mouseup', handleDragStop);
  };
  /**
   * 드래그 이동
   * @param event
   */
  var handleDragIdle = function handleDragIdle(event) {
    isDragging.current = true;
    var rect = ref.current.getBoundingClientRect();
    var x = event.movementX / rect.width * 100;
    var y = event.movementY / rect.height * 100;
    var minPercentage = (scaleRef.current - 1) / scaleRef.current * 100 / 2;
    var maxPercentage = minPercentage * -1;
    setX(function (prev) {
      var newX = prev + x;
      if (newX > minPercentage) return minPercentage;
      if (newX < maxPercentage) return maxPercentage;
      return newX;
    });
    setY(function (prev) {
      var newY = prev + y;
      if (newY > minPercentage) return minPercentage;
      if (newY < maxPercentage) return maxPercentage;
      return newY;
    });
  };
  /**
   * 드래그 중단
   */
  var handleDragStop = function handleDragStop(event) {
    if (isDragging.current) {
      isDragging.current = false;
    } else {
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
    clearEventListeners();
  };
  /**
   * 터치 시작
   * @param event
   */
  var handleTouchStart = function handleTouchStart(event) {
    var touches = event.changedTouches;
    if (prevTouches.current.length + touches.length <= 2) {
      for (var i = 0; i < touches.length; i++) {
        var touch = touches[i];
        prevTouches.current.push(touch);
      }
    }
    window.addEventListener('touchmove', handleTouchMove, {
      passive: false
    });
    window.addEventListener('touchend', handleTouchEnd);
  };
  var setPositionByTouch = function setPositionByTouch(currentTouch, prevTouch) {
    var rect = ref.current.getBoundingClientRect();
    var movementX = prevTouch ? currentTouch.pageX - prevTouch.pageX : 0;
    var movementY = prevTouch ? currentTouch.pageY - prevTouch.pageY : 0;
    var x = movementX / rect.width * 100;
    var y = movementY / rect.height * 100;
    var minPercentage = (scaleRef.current - 1) / scaleRef.current * 100 / 2;
    var maxPercentage = minPercentage * -1;
    if (movementX > 1 || movementY > 1) {
      isDragging.current = true;
    } else {
      isDragging.current = false;
    }
    setX(function (prev) {
      var newX = prev + x;
      if (newX > minPercentage) return minPercentage;
      if (newX < maxPercentage) return maxPercentage;
      return newX;
    });
    setY(function (prev) {
      var newY = prev + y;
      if (newY > minPercentage) return minPercentage;
      if (newY < maxPercentage) return maxPercentage;
      return newY;
    });
  };
  /**
   * 터치 이동
   * @param event
   */
  var handleTouchMove = function handleTouchMove(event) {
    event.preventDefault();
    event.stopPropagation();
    var touches = event.changedTouches;
    var _loop_1 = function _loop_1(i) {
      var touch = touches[i];
      var index = prevTouches.current.findIndex(function (ev) {
        return ev.identifier === touch.identifier;
      });
      if (index !== -1) {
        setPositionByTouch(touch, prevTouches.current[index]);
        prevTouches.current[index] = touch; // update
        // 두 개의 터치에 대해 확인해서 핀치 줌 발생 여부를 판단한다
        if (prevTouches.current.length === 2) {
          var xDiff = prevTouches.current[0].clientX - prevTouches.current[1].clientX;
          var yDiff = prevTouches.current[0].clientY - prevTouches.current[1].clientY;
          // 유클리드 거리 공식 : (x1 - x2)^2 + (y1 - y2)^2
          var distance = Math.sqrt(xDiff * xDiff + yDiff * yDiff);
          // 첫 핀치의 경우 비교군이 없으므로 prevDiff가 -1인 경우 생략한다.
          if (prevDistance.current > 0) {
            var zoom = distance - prevDistance.current;
            onPinch === null || onPinch === void 0 ? void 0 : onPinch(zoom);
          }
          prevDistance.current = distance;
        }
      }
    };
    for (var i = 0; i < touches.length; i++) {
      _loop_1(i);
    }
  };
  /**
   * 터치 중단
   */
  var handleTouchEnd = function handleTouchEnd(event) {
    clearEventListeners();
    prevTouches.current = [];
    prevDistance.current = 0;
    if (isDragging.current) {
      isDragging.current = false;
    } else {
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
  };
  /**
   * 마우스 드래그 & 터치 이벤트 제거
   */
  var clearEventListeners = function clearEventListeners() {
    document.removeEventListener('mousemove', handleDragIdle);
    document.removeEventListener('mouseup', handleDragStop);
    window.removeEventListener('touchmove', handleTouchMove);
    window.removeEventListener('touchend', handleTouchEnd);
  };
  /**
   * 언마운트 시  이벤트 제거
   */
  useEffect(function () {
    return function () {
      clearEventListeners();
    };
  }, []);
  return {
    x: x,
    y: y,
    handleDragStart: handleDragStart,
    handleTouchStart: handleTouchStart
  };
};

var MediaPlayerVideo = forwardRef(function (props, _ref) {
  var isLoading = props.isLoading,
    setIsLoading = props.setIsLoading,
    aspectRatio = props.aspectRatio,
    _onClick = props.onClick,
    isPlaying = props.isPlaying,
    setIsPlaying = props.setIsPlaying,
    onChangeVisibility = props.onChangeVisibility,
    wrapperProps = __rest(props, ["isLoading", "setIsLoading", "aspectRatio", "onClick", "isPlaying", "setIsPlaying", "onChangeVisibility"]);
  var _a = useContext(MediaPlayerContext),
    containerRef = _a.containerRef,
    playbackRate = _a.playbackRate,
    zoomLevel = _a.zoomLevel,
    setZoomLevel = _a.setZoomLevel,
    overlayForceDisplay = _a.overlayForceDisplay,
    controlMouseOvered = _a.controlMouseOvered,
    isFullscreen = _a.isFullscreen,
    setIsFullscreen = _a.setIsFullscreen;
  var videoRef = useRef(null);
  var hideOverlayTimeout = useRef();
  var waitingTimeoutRef = useRef();
  var _b = useState(false),
    showOverlay = _b[0],
    setShowOverlay = _b[1];
  var forceDisplay = useMemo(function () {
    return overlayForceDisplay || controlMouseOvered;
  }, [overlayForceDisplay, controlMouseOvered]);
  /**
   * 플레이어가 화면에서 가려진 경우 일시정지 처리
   */
  useEffect(function () {
    var handleChangeVisibility = function handleChangeVisibility() {
      var _a;
      if (document.visibilityState === 'hidden') {
        onChangeVisibility(false);
        (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        logger$1.debug('Video paused (visibility hidden)');
      } else {
        onChangeVisibility(true);
        playMediaSafely(videoRef.current, 'visibilitychange');
        logger$1.debug('Video playing (visibility visible)');
      }
    };
    document.addEventListener('visibilitychange', handleChangeVisibility);
    return function () {
      document.removeEventListener('visibilitychange', handleChangeVisibility);
    };
  }, [onChangeVisibility]);
  /**
   * 전체화면 상태 변경 감지
   */
  useEffect(function () {
    var onFullscreenChange = function onFullscreenChange() {
      logger$1.debug('Fullscreen changed:', !!document.fullscreenElement);
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', onFullscreenChange);
    return function () {
      document.removeEventListener('fullscreenchange', onFullscreenChange);
    };
  }, [setIsFullscreen]);
  /**
   * 재생속도 설정
   */
  useEffect(function () {
    if (!videoRef.current) return;
    videoRef.current.playbackRate = playbackRate;
  }, [videoRef, playbackRate]);
  var getScale = function getScale() {
    var scale = 1 + zoomLevel * 3;
    return scale;
  };
  var _c = useVideoMove({
      ref: videoRef,
      scale: getScale(),
      onClick: function onClick() {
        if (isTouchDevice()) {
          return;
        }
        _onClick();
      },
      onPinch: function onPinch(zoom) {
        var _a, _b;
        var scale = zoom / ((_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 100);
        // alert(scale);
        setZoomLevel(function (prev) {
          var newZoomLevel = prev + scale;
          if (newZoomLevel > 1) return 1;
          if (newZoomLevel < 0) return 0;
          return newZoomLevel;
        });
      }
    }),
    x = _c.x,
    y = _c.y,
    handleDragStart = _c.handleDragStart,
    handleTouchStart = _c.handleTouchStart;
  useEffect(function () {
    if (forceDisplay) {
      clearTimeout(hideOverlayTimeout.current);
      setShowOverlay(true);
    } else {
      hideOverlayTimeout.current = setTimeout(function () {
        setShowOverlay(false);
      }, 3000);
    }
  }, [forceDisplay]);
  useEffect(function () {
    return function () {
      clearTimeout(waitingTimeoutRef.current);
    };
  }, []);
  var clearLoadingState = function clearLoadingState() {
    clearTimeout(waitingTimeoutRef.current);
    setIsLoading(false);
  };
  var scheduleLoadingState = function scheduleLoadingState() {
    clearTimeout(waitingTimeoutRef.current);
    // 짧은 stall에서 로딩 UI가 깜빡이며 라이브 추적 상태를 흔들지 않도록 지연 표시합니다.
    waitingTimeoutRef.current = setTimeout(function () {
      setIsLoading(true);
    }, 400);
  };
  return jsx("span", _assign$1({}, wrapperProps, {
    children: jsx("div", {
      className: playerWrapper({
        aspectRatio: isFullscreen || aspectRatio === 'full' ? 'full' : '16:9'
      }),
      onMouseMove: function onMouseMove() {
        clearTimeout(hideOverlayTimeout.current);
        setShowOverlay(true);
        if (!forceDisplay) {
          hideOverlayTimeout.current = setTimeout(function () {
            setShowOverlay(false);
          }, 3000);
        }
      },
      onMouseOut: function onMouseOut() {
        if (!forceDisplay) {
          clearTimeout(hideOverlayTimeout.current);
          setShowOverlay(false);
        }
      },
      children: jsxs("div", {
        ref: containerRef,
        className: container$2,
        children: [jsx("div", {
          className: videoWrapper,
          children: jsx("video", {
            muted: true,
            playsInline: true,
            className: videoElement,
            ref: function ref(instance) {
              videoRef.current = instance;
              if (!_ref) return;
              if (typeof _ref === 'function') {
                _ref(instance);
              } else if (_typeof(_ref) === 'object') {
                _ref.current = instance;
              }
            },
            onPlaying: function onPlaying() {
              clearLoadingState();
              setIsPlaying(true);
            },
            onPause: function onPause() {
              return setIsPlaying(false);
            },
            onEnded: function onEnded() {
              if (!videoRef.current) return;
              setIsPlaying(false);
            },
            onWaiting: scheduleLoadingState,
            onCanPlay: clearLoadingState,
            onSeeked: clearLoadingState,
            onMouseDown: handleDragStart,
            onTouchStart: handleTouchStart,
            style: {
              transform: "scale(".concat(getScale(), ") translate(").concat(x, "%, ").concat(y, "%)")
            }
          })
        }), jsx(Loading, {
          loading: isLoading
        }), jsx("div", {
          className: videoOverlay({
            // 재생 중이면서 showOverlay가 false일 때에만 숨김처리
            hide: isPlaying && !showOverlay
          }),
          children: jsxs("div", {
            className: toolbar,
            children: [jsx(Timeline, {}), jsx(Controls, {
              isPlaying: isPlaying,
              onPlayPause: _onClick
            })]
          })
        })]
      })
    })
  }));
});

var MediaPlayerCore = forwardRef(function (props, _ref) {
  var cmasUrl = props.cmasUrl,
    apiKey = props.apiKey,
    renderDatePicker = props.renderDatePicker,
    _a = props.showZoomControl,
    showZoomControl = _a === void 0 ? true : _a,
    renderControlsRight = props.renderControlsRight,
    _b = props.locale,
    locale = _b === void 0 ? 'en-US' : _b,
    position = props.position,
    aspectRatio = props.aspectRatio,
    onClickPip = props.onClickPip,
    wrapperProps = __rest(props, ["cmasUrl", "apiKey", "renderDatePicker", "showZoomControl", "renderControlsRight", "locale", "position", "aspectRatio", "onClickPip"]);
  var containerRef = useRef(null);
  var videoRef = useRef(null);
  var timelineScrollRef = useRef(null);
  var _c = useState(false),
    isPlaying = _c[0],
    setIsPlaying = _c[1];
  var _d = useState(false),
    isLoading = _d[0],
    _setIsLoading = _d[1];
  var _e = useState(false),
    isFullscreen = _e[0],
    setIsFullscreen = _e[1];
  var _f = useState(0),
    progressBarWidth = _f[0],
    setProgressBarWidth = _f[1];
  var _g = useState(1),
    playbackRate = _g[0],
    setPlaybackRate = _g[1];
  var _h = useState(0),
    zoomLevel = _h[0],
    setZoomLevel = _h[1];
  var _j = useState(false),
    overlayForceDisplay = _j[0],
    setOverlayForceDisplay = _j[1];
  var _k = useState(false),
    controlMouseOvered = _k[0],
    setControlMouseOvered = _k[1];
  var _l = useState([]),
    resolutions = _l[0],
    setResolutions = _l[1];
  var _m = useState(1080),
    currentResolution = _m[0],
    setCurrentResolution = _m[1];
  var _o = useState(false),
    userSetResolution = _o[0],
    setUserSetResolution = _o[1];
  var _p = useState(false);
    _p[0];
    var setIsHlsInitialized = _p[1];
  var _q = useState(false),
    isPausedByPlayer = _q[0],
    setIsPausedByPlayer = _q[1];
  var currentTsRef = useRef(0);
  var initTsRef = useRef(0);
  var isLiveRef = useRef(false);
  var lastRecoveryAtRef = useRef(0);
  var retryControllerRef = useRef({
    onLoading: function onLoading() {},
    clearRetry: function clearRetry() {}
  });
  useResolution({
    isFullscreen: isFullscreen,
    containerRef: containerRef,
    setResolution: setCurrentResolution,
    userSetResolution: userSetResolution
  });
  var fetchResolutions = function fetchResolutions() {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!apiKey) return [3 /*break*/, 5];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, getPlayerResolution({
              baseUrl: cmasUrl,
              apiKey: apiKey
            })];
          case 2:
            data = _a.sent();
            setResolutions(data);
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            logger$1.error('getPlayerResolution error:', error_1);
            return [3 /*break*/, 4];
          case 4:
            return [3 /*break*/, 6];
          case 5:
            setResolutions([]);
            _a.label = 6;
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    fetchResolutions();
  }, [apiKey]);
  var computedApiKey = useMemo(function () {
    // 화질 정보가 없다면 기본 토큰을 사용
    if (!resolutions.length) return apiKey;
    // 설정된 resolution이 없다면 기본 토큰을 사용
    if (!currentResolution) return apiKey;
    var matchedResolution = resolutions.find(function (r) {
      return r.resolution === currentResolution;
    });
    // 목록에서 선택된 화질과 일치하는 정보가 없다면 기본 토큰을 사용
    if (!matchedResolution) return apiKey;
    // 모든 조건을 준수한다면 토큰을 대체
    return matchedResolution.token;
  }, [apiKey, resolutions, currentResolution]);
  var _r = useTime({
      /**
       * 해상도 변경 시 시간이 초기화되지 않기 위해 초기화의 기준값은 원본 APIKey를 사용합니다.
       */
      originalApiKey: apiKey,
      position: position
    }),
    isInitialized = _r.isInitialized,
    now = _r.now,
    getNow = _r.getNow,
    initTs = _r.initTs,
    setInitTs = _r.setInitTs,
    currentTs = _r.currentTs,
    setCurrentTs = _r.setCurrentTs,
    startTs = _r.startTs,
    setStartTs = _r.setStartTs,
    endTs = _r.endTs,
    resetInitTime = _r.resetInitTime,
    isLive = _r.isLive;
  useEffect(function () {
    currentTsRef.current = currentTs;
    initTsRef.current = initTs;
    isLiveRef.current = isLive;
  }, [currentTs, initTs, isLive]);
  var _s = useTimeline({
      baseUrl: cmasUrl,
      apiKey: computedApiKey,
      isInitialized: isInitialized,
      now: now,
      getNow: getNow,
      currentTs: currentTs,
      startTs: startTs,
      endTs: endTs,
      resetInitTime: resetInitTime,
      timelineScrollRef: timelineScrollRef,
      progressBarWidth: progressBarWidth,
      setInitTs: setInitTs,
      setCurrentTs: setCurrentTs,
      setStartTs: setStartTs
    }),
    currentQueryKey = _s.currentQueryKey,
    timelineQueries = _s.timelineQueries,
    timelineDataWithLive = _s.timelineDataWithLive,
    fetchTimeline = _s.fetchTimeline,
    insertTimelineQuery = _s.insertTimelineQuery;
  var intlFormat = useFormat().intlFormat;
  var _t = useHls({
      baseUrl: cmasUrl,
      apiKey: computedApiKey,
      videoRef: videoRef,
      initTs: initTs,
      enabled: isInitialized,
      playbackRate: playbackRate,
      onFragBuffered: function onFragBuffered(_event, data) {
        logger$1.debug('HLS buffered fragments', data.frag.programDateTime && intlFormat(new Date(data.frag.programDateTime), {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        }), '~', data.frag.programDateTime && intlFormat(addSeconds(new Date(data.frag.programDateTime), data.frag.duration), {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        }));
        if (!data.frag.programDateTime) return;
        insertTimelineQuery({
          key: currentQueryKey.current,
          data: [{
            startTime: data.frag.programDateTime,
            endTime: addSeconds(data.frag.programDateTime, data.frag.duration).getTime()
          }]
        });
        logger$1.debug('HLS timelineQueries', timelineQueries.current);
      },
      onInitialized: function onInitialized() {
        logger$1.info('HLS Initialized');
        setIsHlsInitialized(true);
        setIsPlaying(false);
        setIsPausedByPlayer(false);
      },
      onDestroyed: function onDestroyed() {
        setIsHlsInitialized(false);
      },
      onInitializationFailed: function onInitializationFailed() {
        _setIsLoading(true);
        retryControllerRef.current.onLoading();
        var nowTs = Date.now();
        if (nowTs - lastRecoveryAtRef.current < 3000) {
          return;
        }
        lastRecoveryAtRef.current = nowTs;
        if (isLiveRef.current) {
          resetToLive('HLS 초기화에 실패하여 라이브 시점으로 초기화합니다.');
          return;
        }
        restartPlaybackAt(getRecoveryTargetTs(), 'HLS 초기화에 실패하여 현재 시점 재생을 다시 시도합니다.');
      },
      onError: function onError(_event, data) {
        var _a, _b;
        var shouldRecover = data.fatal || data.details === 'levelEmptyError' || data.details === 'levelLoadError' || data.details === 'manifestLoadError';
        if (!shouldRecover) return;
        _setIsLoading(true);
        retryControllerRef.current.onLoading();
        var nowTs = Date.now();
        if (nowTs - lastRecoveryAtRef.current < 3000) {
          return;
        }
        lastRecoveryAtRef.current = nowTs;
        if (((_b = (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.buffered.length) !== null && _b !== void 0 ? _b : 0) > 0) {
          return;
        }
        if (isLiveRef.current) {
          resetToLive('HLS 오류가 발생하여 라이브 시점으로 초기화합니다.');
          return;
        }
        restartPlaybackAt(getRecoveryTargetTs(), 'HLS 오류가 발생하여 현재 시점 재생을 다시 시도합니다.');
      }
    }),
    hlsRef = _t.hlsRef,
    isError = _t.isError,
    initHls = _t.initHls,
    destoryHls = _t.destoryHls;
  var restartPlaybackAt = function restartPlaybackAt(targetTs, reason) {
    logger$1.info(reason);
    setCurrentTs(targetTs);
    setStartTs(sub(new Date(targetTs), {
      hours: 0.5
    }).getTime());
    if (initTs === targetTs) {
      void initHls(targetTs);
      return;
    }
    setInitTs(targetTs);
  };
  var resetToLive = function resetToLive(reason) {
    restartPlaybackAt(getNow(), reason);
  };
  var getRecoveryTargetTs = function getRecoveryTargetTs() {
    return Math.max(currentTsRef.current, initTsRef.current);
  };
  var _u = useAutoRetry({
      videoRef: videoRef,
      onRetry: function onRetry(_a) {
        var exhausted = _a.exhausted,
          attempt = _a.attempt;
        if (exhausted) {
          resetToLive('재생 오류가 지속되어 라이브 시점으로 초기화합니다.');
          return;
        }
        if (isLive) {
          resetToLive("\uB77C\uC774\uBE0C \uAD6C\uAC04 \uC7AC\uC2DC\uB3C4 ".concat(attempt, "\uD68C\uCC28\uB97C \uC2E4\uD589\uD569\uB2C8\uB2E4."));
          return;
        }
        restartPlaybackAt(getRecoveryTargetTs(), "\uD604\uC7AC \uC2DC\uC810 \uC7AC\uC0DD\uC744 \uB2E4\uC2DC \uC2DC\uB3C4\uD569\uB2C8\uB2E4. (".concat(attempt, "\uD68C\uCC28)"));
      }
    }),
    onLoading = _u.onLoading,
    clearRetry = _u.clearRetry;
  retryControllerRef.current = {
    onLoading: onLoading,
    clearRetry: clearRetry
  };
  /**
   * 재생 또는 일시정지
   */
  var handlePlayPauseMedia = function handlePlayPauseMedia() {
    var _a, _b;
    if ((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.paused) {
      playMediaSafely(videoRef.current, 'play-pause');
      setIsPausedByPlayer(false);
      // hls 인스턴스가 없다면 새롭게 생성한다.
      if (!hlsRef.current) {
        restartPlaybackAt(getRecoveryTargetTs(), '일시정지된 재생을 다시 시작합니다.');
      }
    } else {
      (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.pause();
      setIsPausedByPlayer(true);
    }
  };
  /**
   * apiKey가 변경되면 줌 등 기본 상태를 초기화한다.
   */
  useEffect(function () {
    setPlaybackRate(1);
    setZoomLevel(0);
  }, [apiKey]);
  if (isError) {
    return jsx(MediaPlayerEmpty, _assign$1({
      aspectRatio: aspectRatio
    }, wrapperProps));
  }
  return jsx(MediaPlayerContext.Provider, {
    value: {
      baseUrl: cmasUrl,
      apiKey: computedApiKey,
      locale: locale,
      resolutions: resolutions,
      currentResolution: currentResolution,
      setCurrentResolution: setCurrentResolution,
      userSetResolution: userSetResolution,
      setUserSetResolution: setUserSetResolution,
      hlsRef: hlsRef,
      containerRef: containerRef,
      videoRef: videoRef,
      timelineScrollRef: timelineScrollRef,
      isPlaying: isPlaying,
      isLoading: isLoading,
      isFullscreen: isFullscreen,
      setIsFullscreen: setIsFullscreen,
      isPausedByPlayer: isPausedByPlayer,
      setIsPausedByPlayer: setIsPausedByPlayer,
      timelineData: timelineDataWithLive,
      fetchTimeline: fetchTimeline,
      now: now,
      initTs: initTs,
      setInitTs: setInitTs,
      currentTs: currentTs,
      setCurrentTs: setCurrentTs,
      startTs: startTs,
      setStartTs: setStartTs,
      endTs: endTs,
      progressBarWidth: progressBarWidth,
      setProgressBarWidth: setProgressBarWidth,
      forceInitHls: initHls,
      renderDatePicker: renderDatePicker,
      showZoomControl: showZoomControl,
      renderControlsRight: renderControlsRight,
      onClickPip: onClickPip,
      playbackRate: playbackRate,
      setPlaybackRate: setPlaybackRate,
      zoomLevel: zoomLevel,
      setZoomLevel: setZoomLevel,
      overlayForceDisplay: overlayForceDisplay,
      setOverlayForceDisplay: setOverlayForceDisplay,
      controlMouseOvered: controlMouseOvered,
      setControlMouseOvered: setControlMouseOvered
    },
    children: jsx(MediaPlayerVideo, _assign$1({
      ref: function ref(instance) {
        videoRef.current = instance;
        if (!_ref) return;
        if (typeof _ref === 'function') {
          _ref(instance);
        } else if (_typeof(_ref) === 'object') {
          _ref.current = instance;
        }
      },
      aspectRatio: aspectRatio,
      isLoading: isLoading,
      setIsLoading: function setIsLoading(value) {
        _setIsLoading(value);
        if (value) {
          onLoading();
        } else {
          clearRetry();
        }
      },
      isPlaying: isPlaying,
      setIsPlaying: setIsPlaying,
      onClick: handlePlayPauseMedia,
      // 비디오의 visibility 여부에 따라 hls 초기화
      onChangeVisibility: function onChangeVisibility(visible) {
        if (visible) {
          if (hlsRef.current) {
            return;
          }
          // 플레이어가 직접 일시정지한 경우 자동으로 재생시키지 않는다.
          if (isPausedByPlayer) return false;
          restartPlaybackAt(getRecoveryTargetTs(), '플레이어 가시성 복구로 재생을 다시 시작합니다.');
        } else {
          if (hlsRef.current) {
            destoryHls();
          }
        }
      }
    }, wrapperProps))
  });
});

var MediaPlayer = forwardRef(function (props, ref) {
  var token = props.token,
    renderDatePicker = props.renderDatePicker,
    showZoomControl = props.showZoomControl,
    renderControlsRight = props.renderControlsRight,
    defaultCMASUrl = props.cmasUrl,
    locale = props.locale,
    position = props.position,
    aspectRatio = props.aspectRatio,
    wrapperProps = __rest(props, ["token", "renderDatePicker", "showZoomControl", "renderControlsRight", "cmasUrl", "locale", "position", "aspectRatio"]);
  var context = useContext(MediaPlayerConfigContext);
  /**
   * MediaPlayerConfigContext에서 전달된 설정값과 props로 전달받은 값을 merge합니다.
   */
  var config = useMemo(function () {
    var _a;
    return _assign$1(_assign$1({}, context), {
      renderDatePicker: renderDatePicker || context.renderDatePicker,
      showZoomControl: (_a = showZoomControl !== null && showZoomControl !== void 0 ? showZoomControl : context.showZoomControl) !== null && _a !== void 0 ? _a : true,
      renderControlsRight: renderControlsRight || context.renderControlsRight,
      locale: locale || context.locale
    });
  }, [context, renderDatePicker, showZoomControl, renderControlsRight, locale]);
  /**
   * 토큰에서 `api` 필드의 값을 CMAS URL로 사용하도록 합니다.
   */
  var computedCmasUrl = useMemo(function () {
    var _a;
    if (!token) return null;
    var parsedApiUrl = (_a = JSON.parse(atob(token))) === null || _a === void 0 ? void 0 : _a.api;
    return parsedApiUrl || defaultCMASUrl;
  }, [token, defaultCMASUrl]);
  // `token`이 없거나 invalid할 경우 또는 cmasUrl이 없을 경우 Empty 화면을 보여줍니다.
  if (!token || !computedCmasUrl) {
    return jsx(MediaPlayerEmpty, _assign$1({
      aspectRatio: aspectRatio
    }, wrapperProps));
  }
  return jsx(MediaPlayerCore, _assign$1({
    ref: ref,
    cmasUrl: computedCmasUrl,
    apiKey: token,
    locale: config.locale,
    renderDatePicker: config.renderDatePicker,
    showZoomControl: config.showZoomControl,
    renderControlsRight: config.renderControlsRight,
    position: position,
    aspectRatio: aspectRatio
  }, wrapperProps));
});

var getStorageImages = function getStorageImages(context, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    var queryString, res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          queryString = new URLSearchParams();
          if (params.limit) {
            queryString.set('limit', params.limit.toString());
          }
          if (params.offset) {
            queryString.set('offset', params.offset.toString());
          }
          if (params.startTime) {
            queryString.set('startTime', params.startTime.toString());
          }
          if (params.endTime) {
            queryString.set('endTime', params.endTime.toString());
          }
          if (params.setInterval !== undefined) {
            queryString.set('setInterval', params.setInterval.toString());
          }
          return [4 /*yield*/, createFetch(context, "storage/images?".concat(queryString.toString()), {
            method: 'GET'
          })];
        case 1:
          res = _a.sent();
          return [4 /*yield*/, res.json()];
        case 2:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};

/**
 * storage/images API를 사용합니다.
 * 보통 카메라의 썸네일을 불러올 때 활용합니다.
 */
var useStorageImages = function useStorageImages(baseUrl) {
  var _getStorageImages = function _getStorageImages(token, params) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, getStorageImages({
          baseUrl: baseUrl,
          apiKey: token
        }, _assign$1({}, params))];
      });
    });
  };
  return {
    get: _getStorageImages
  };
};

var getLiveImage = function getLiveImage(context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, createFetch(context, "live/image", {
            method: 'GET'
          })];
        case 1:
          res = _a.sent();
          return [4 /*yield*/, res.json()];
        case 2:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};

/**
 * live/image API를 사용합니다.
 * 보통 카메라의 썸네일을 불러올 때 활용합니다.
 */
var useLiveImage = function useLiveImage(baseUrl) {
  var _getLiveImage = function _getLiveImage(token) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, getLiveImage({
          baseUrl: baseUrl,
          apiKey: token
        })];
      });
    });
  };
  return {
    get: _getLiveImage
  };
};

export { MediaPlayer, MediaPlayerProvider, ToolbarButton, disableDebugMode, enableDebugMode, logger$1 as logger, useLiveImage, useStorageImages };
//# sourceMappingURL=index.js.map
